import type {
    GraphQLResolveInfo,
    GraphQLScalarType,
    GraphQLScalarTypeConfig,
} from "graphql";
import { gql } from "@apollo/client";
import type * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & {
    [P in K]-?: NonNullable<T[P]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    Byte: any;
    Date: any;
    JSON: any;
};

export type GQAccount = {
    __typename?: "Account";
    amount: Scalars["Float"];
    balance: GQBalance;
    createdAt: Scalars["Date"];
    customer?: Maybe<GQCustomer>;
    externalId?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    merchant: GQMerchant;
    name: Scalars["String"];
    status: Scalars["String"];
    systemLabel?: Maybe<Scalars["String"]>;
    tags: GQTagPagination;
    transactions: GQAccountTransactionPagination;
    type: Scalars["String"];
    vat?: Maybe<GQVat>;
};

export type GQAccountBalanceArgs = {
    numberOfTransactions?: InputMaybe<Scalars["Int"]>;
    printWidth?: InputMaybe<Scalars["Int"]>;
};

export type GQAccountTagsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQAccountTransactionsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQAccountTransactionSearchInput>;
};

export type GQAccountBookkeepingPagination = GQIPagination & {
    __typename?: "AccountBookkeepingPagination";
    data: Array<GQBookkeepingAccount>;
    pagination: GQPagination;
};

export type GQAccountBookkeepingTransaction = {
    __typename?: "AccountBookkeepingTransaction";
    amount: Scalars["Float"];
    id: Scalars["ID"];
    invoiceId?: Maybe<Scalars["String"]>;
    transactionAt: Scalars["Date"];
    type: Scalars["String"];
};

export type GQAccountBookkeepingTransactionPagination = GQIPagination & {
    __typename?: "AccountBookkeepingTransactionPagination";
    data: Array<GQAccountBookkeepingTransaction>;
    pagination: GQPagination;
};

export type GQAccountBookkeepingTransactionSearchInput = {
    amount?: InputMaybe<GQAmountSearchInput>;
    createdAt?: InputMaybe<GQDateSearchInput>;
};

export type GQAccountBuyFundsResponse = {
    __typename?: "AccountBuyFundsResponse";
    status: GQAccountBuyFundsStatus;
    transactionId?: Maybe<Scalars["ID"]>;
};

export enum GQAccountBuyFundsStatus {
    AccountClosed = "ACCOUNT_CLOSED",
    AccountNotFound = "ACCOUNT_NOT_FOUND",
    Error = "ERROR",
    InvalidAmount = "INVALID_AMOUNT",
    Successful = "SUCCESSFUL",
}

export type GQAccountCloseResponse = {
    __typename?: "AccountCloseResponse";
    status: Scalars["Boolean"];
};

export type GQAccountCreate = {
    amount: Scalars["Float"];
    customerId?: InputMaybe<Scalars["String"]>;
    externalId?: InputMaybe<Scalars["String"]>;
    name: Scalars["String"];
    status: Scalars["String"];
    systemLabel?: InputMaybe<Scalars["String"]>;
    type: Scalars["String"];
    vatId: Scalars["String"];
};

export type GQAccountInput = {
    amount: Scalars["Float"];
    externalId?: InputMaybe<Scalars["String"]>;
    name: Scalars["String"];
    status: Scalars["String"];
    type: Scalars["String"];
    vatId?: InputMaybe<Scalars["String"]>;
};

export type GQAccountOpenResponse = {
    __typename?: "AccountOpenResponse";
    status: Scalars["Boolean"];
};

export type GQAccountPagination = GQIPagination & {
    __typename?: "AccountPagination";
    data: Array<GQAccount>;
    pagination: GQPagination;
};

export type GQAccountPayAmountResponse = {
    __typename?: "AccountPayAmountResponse";
    receipt?: Maybe<Scalars["String"]>;
    status: GQAccountTransactionStatus;
    transactionId: Scalars["ID"];
    type?: Maybe<Scalars["String"]>;
};

export type GQAccountRefundAmountResponse = {
    __typename?: "AccountRefundAmountResponse";
    receipt?: Maybe<Scalars["String"]>;
    status: GQAccountTransactionStatus;
    transactionId: Scalars["ID"];
    type?: Maybe<Scalars["String"]>;
};

export type GQAccountReturnFundsResponse = {
    __typename?: "AccountReturnFundsResponse";
    status: GQAccountReturnFundsStatus;
    transactionId?: Maybe<Scalars["ID"]>;
};

export enum GQAccountReturnFundsStatus {
    AccountClosed = "ACCOUNT_CLOSED",
    AccountNotFound = "ACCOUNT_NOT_FOUND",
    Error = "ERROR",
    InvalidAmount = "INVALID_AMOUNT",
    Successful = "SUCCESSFUL",
}

export type GQAccountRevertTransactionResponse = {
    __typename?: "AccountRevertTransactionResponse";
    status: GQAccountRevertTransactionStatus;
};

export enum GQAccountRevertTransactionStatus {
    AccountClosed = "ACCOUNT_CLOSED",
    AccountNotFound = "ACCOUNT_NOT_FOUND",
    AlreadyReverted = "ALREADY_REVERTED",
    Error = "ERROR",
    Successful = "SUCCESSFUL",
    TransactionNotFound = "TRANSACTION_NOT_FOUND",
}

export type GQAccountSearchInput = {
    amount?: InputMaybe<GQAmountSearchInput>;
    createdAt?: InputMaybe<GQDateSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
    status?: InputMaybe<GQTypeSearchInput>;
};

export type GQAccountTransaction = {
    __typename?: "AccountTransaction";
    amount: Scalars["Float"];
    id: Scalars["ID"];
    invoiceId?: Maybe<Scalars["String"]>;
    tag?: Maybe<GQTag>;
    transactionAt: Scalars["Date"];
    user?: Maybe<GQUser>;
    userId?: Maybe<Scalars["String"]>;
};

export type GQAccountTransactionPagination = GQIPagination & {
    __typename?: "AccountTransactionPagination";
    data: Array<GQAccountTransaction>;
    pagination: GQPagination;
};

export type GQAccountTransactionSearchInput = {
    amount?: InputMaybe<GQAmountSearchInput>;
    createdAt?: InputMaybe<GQDateSearchInput>;
    tag?: InputMaybe<GQStringSearchInput>;
    user?: InputMaybe<GQStringSearchInput>;
};

export enum GQAccountTransactionStatus {
    AccountClosed = "ACCOUNT_CLOSED",
    AccountNotFound = "ACCOUNT_NOT_FOUND",
    Error = "ERROR",
    InvalidAmount = "INVALID_AMOUNT",
    NotEnoughFunds = "NOT_ENOUGH_FUNDS",
    Successful = "SUCCESSFUL",
}

export type GQAddEventResponse = {
    __typename?: "AddEventResponse";
    success: Scalars["Boolean"];
};

export type GQAdyenSessionsResponse = {
    __typename?: "AdyenSessionsResponse";
    id: Scalars["String"];
    token: Scalars["String"];
};

export type GQAdyenStore = {
    __typename?: "AdyenStore";
    address?: Maybe<GQAdyenStoreLocation>;
    description?: Maybe<Scalars["String"]>;
    externalReferenceId?: Maybe<Scalars["String"]>;
    id?: Maybe<Scalars["String"]>;
    merchantId?: Maybe<Scalars["String"]>;
    phoneNumber?: Maybe<Scalars["String"]>;
    reference?: Maybe<Scalars["String"]>;
    shopperStatement?: Maybe<Scalars["String"]>;
    status?: Maybe<GQAdyenStoreStatus>;
};

export type GQAdyenStoreLocation = {
    __typename?: "AdyenStoreLocation";
    city?: Maybe<Scalars["String"]>;
    country?: Maybe<Scalars["String"]>;
    line1?: Maybe<Scalars["String"]>;
    line2?: Maybe<Scalars["String"]>;
    line3?: Maybe<Scalars["String"]>;
    postalCode?: Maybe<Scalars["String"]>;
    stateOrProvince?: Maybe<Scalars["String"]>;
};

export enum GQAdyenStoreStatus {
    Active = "active",
    Closed = "closed",
    Inactive = "inactive",
}

export type GQAdyenStoresPagination = GQIPagination & {
    __typename?: "AdyenStoresPagination";
    data: Array<GQAdyenStore>;
    pagination: GQPagination;
};

export type GQAdyenTerminal = {
    __typename?: "AdyenTerminal";
    assignment?: Maybe<GQAdyenTerminalAssignment>;
    connectivity?: Maybe<GQAdyenTerminalConnectivity>;
    firmwareVersion?: Maybe<Scalars["String"]>;
    id?: Maybe<Scalars["String"]>;
    lastActivityAt?: Maybe<Scalars["String"]>;
    lastTransactionAt?: Maybe<Scalars["String"]>;
    model?: Maybe<Scalars["String"]>;
    restartLocalTime?: Maybe<Scalars["String"]>;
    serialNumber?: Maybe<Scalars["String"]>;
};

export type GQAdyenTerminalAssignment = {
    __typename?: "AdyenTerminalAssignment";
    companyId?: Maybe<Scalars["String"]>;
    merchantId?: Maybe<Scalars["String"]>;
    status?: Maybe<Scalars["String"]>;
    storeId?: Maybe<Scalars["String"]>;
};

export type GQAdyenTerminalConnectivity = {
    __typename?: "AdyenTerminalConnectivity";
    bluetooth?: Maybe<GQAdyenTerminalConnectivityBluetooth>;
    cellular?: Maybe<GQAdyenTerminalConnectivityCellular>;
    ethernet?: Maybe<GQAdyenTerminalConnectivityEthernet>;
    wifi?: Maybe<GQAdyenTerminalConnectivityWifi>;
};

export type GQAdyenTerminalConnectivityBluetooth = {
    __typename?: "AdyenTerminalConnectivityBluetooth";
    ipAddress?: Maybe<Scalars["String"]>;
    macAddress?: Maybe<Scalars["String"]>;
};

export type GQAdyenTerminalConnectivityCellular = {
    __typename?: "AdyenTerminalConnectivityCellular";
    iccid?: Maybe<Scalars["String"]>;
    iccid2?: Maybe<Scalars["String"]>;
    status?: Maybe<Scalars["String"]>;
};

export type GQAdyenTerminalConnectivityEthernet = {
    __typename?: "AdyenTerminalConnectivityEthernet";
    ipAddress?: Maybe<Scalars["String"]>;
    linkNegotiation?: Maybe<Scalars["String"]>;
    macAddress?: Maybe<Scalars["String"]>;
};

export type GQAdyenTerminalConnectivityWifi = {
    __typename?: "AdyenTerminalConnectivityWifi";
    ipAddress?: Maybe<Scalars["String"]>;
    macAddress?: Maybe<Scalars["String"]>;
    ssid?: Maybe<Scalars["String"]>;
};

export type GQAdyenTerminalsPagination = GQIPagination & {
    __typename?: "AdyenTerminalsPagination";
    data: Array<GQAdyenTerminal>;
    pagination: GQPagination;
};

export type GQAdyenTerminalsResponse = {
    __typename?: "AdyenTerminalsResponse";
    data: Array<GQAdyenTerminal>;
};

export type GQAmountSearchInput = {
    value: Scalars["Float"];
};

export type GQAppData = {
    __typename?: "AppData";
    approvals?: Maybe<Array<GQApproval>>;
    bookkeepingAccounts: Array<GQBookkeepingAccount>;
    cashRegister: GQCashRegister;
    cmpEvents: Array<GQCmpEvent>;
    cmpProducts: Array<GQCmpProduct>;
    deviceConfig: Scalars["JSON"];
    discounts: Array<GQDiscount>;
    fiskaly?: Maybe<GQFiskalyConfiguration>;
    layout?: Maybe<GQLayout>;
    layoutEntities: Array<GQLayoutEntity>;
    merchant: GQMerchant;
    minimumStructVersion: Scalars["Int"];
    miscButtons?: Maybe<GQMiscButtons>;
    paymentConfiguration?: Maybe<GQPaymentConfiguration>;
    printers: Array<GQPrinter>;
    productGroups: Array<GQProductGroup>;
    products: Array<GQProduct>;
    structVersion: Scalars["Int"];
    tableLayout?: Maybe<GQLayout>;
    tags: Array<GQTag>;
    vats: Array<GQVat>;
    viProducts?: Maybe<Array<GQViProduct>>;
    virtualPrinters?: Maybe<Array<GQVirtualPrinter>>;
};

export type GQApproval = {
    __typename?: "Approval";
    active: Scalars["Boolean"];
    approvalTokenGroups: Array<GQApprovalTokenGroup>;
    approvalTokens: Array<GQApprovalToken>;
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    type: GQApprovalType;
    updatedAt?: Maybe<Scalars["Date"]>;
};

export enum GQApprovalGroupType {
    Card = "CARD",
    Code = "CODE",
}

export type GQApprovalInput = {
    active: Scalars["Boolean"];
    tokenGroupIds: Array<Scalars["ID"]>;
    tokenIds: Array<Scalars["ID"]>;
    type: Scalars["String"];
};

export type GQApprovalPagination = GQIPagination & {
    __typename?: "ApprovalPagination";
    data: Array<GQApproval>;
    pagination: GQPagination;
};

export type GQApprovalSearchInput = {
    active?: InputMaybe<GQBooleanSearchInput>;
    createdAt?: InputMaybe<GQDateSearchInput>;
};

export type GQApprovalToken = {
    __typename?: "ApprovalToken";
    active: Scalars["Boolean"];
    approvalTokenGroup?: Maybe<GQApprovalTokenGroup>;
    approvalTokenGroupId?: Maybe<Scalars["ID"]>;
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    name: Scalars["String"];
    type: GQApprovalGroupType;
    updatedAt?: Maybe<Scalars["Date"]>;
    value: Scalars["String"];
};

export type GQApprovalTokenGroup = {
    __typename?: "ApprovalTokenGroup";
    active: Scalars["Boolean"];
    approvalTokens: Array<GQApprovalToken>;
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    name: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQApprovalTokenGroupInput = {
    active: Scalars["Boolean"];
    name: Scalars["String"];
};

export type GQApprovalTokenGroupPagination = GQIPagination & {
    __typename?: "ApprovalTokenGroupPagination";
    data: Array<GQApprovalTokenGroup>;
    pagination: GQPagination;
};

export type GQApprovalTokenGroupSearchInput = {
    active?: InputMaybe<GQBooleanSearchInput>;
    createdAt?: InputMaybe<GQDateSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type GQApprovalTokenInput = {
    active: Scalars["Boolean"];
    approvalTokenGroupId?: InputMaybe<Scalars["ID"]>;
    name: Scalars["String"];
    type: Scalars["String"];
    value: Scalars["String"];
};

export type GQApprovalTokenPagination = GQIPagination & {
    __typename?: "ApprovalTokenPagination";
    data: Array<GQApprovalToken>;
    pagination: GQPagination;
};

export type GQApprovalTokenSearchInput = {
    active?: InputMaybe<GQBooleanSearchInput>;
    createdAt?: InputMaybe<GQDateSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export enum GQApprovalType {
    Discount = "DISCOUNT",
    OpenCashDrawer = "OPEN_CASH_DRAWER",
    Refund = "REFUND",
    Return = "RETURN",
}

export type GQAuthAttempt = {
    __typename?: "AuthAttempt";
    successful: Scalars["Boolean"];
    token?: Maybe<GQAuthToken>;
};

export type GQAuthToken = {
    __typename?: "AuthToken";
    access: Scalars["String"];
    accessExpire: Scalars["Int"];
    now: Scalars["String"];
    refresh: Scalars["String"];
};

export type GQBalance = {
    __typename?: "Balance";
    amount: Scalars["Float"];
    receipt: Scalars["String"];
};

export type GQBookkeepingAccount = {
    __typename?: "BookkeepingAccount";
    bookkeepingTransactions: GQAccountBookkeepingTransactionPagination;
    createdAt: Scalars["Date"];
    id: Scalars["ID"];
    merchant: GQMerchant;
    name: Scalars["String"];
    systemLabel?: Maybe<Scalars["String"]>;
    vat?: Maybe<GQVat>;
};

export type GQBookkeepingAccountBookkeepingTransactionsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQAccountBookkeepingTransactionSearchInput>;
};

export type GQBooleanResponse = {
    __typename?: "BooleanResponse";
    status: Scalars["Boolean"];
};

export type GQBooleanSearchInput = {
    value: Scalars["Boolean"];
};

export type GQBuyAccountFunds = {
    __typename?: "BuyAccountFunds";
    amount?: Maybe<Scalars["Int"]>;
    externalId?: Maybe<Scalars["String"]>;
};

export type GQCanPeriodCardBeRenewedResponse = {
    __typename?: "CanPeriodCardBeRenewedResponse";
    cardId?: Maybe<Scalars["String"]>;
    cardToken?: Maybe<Scalars["String"]>;
    message?: Maybe<Scalars["String"]>;
    status: GQPeriodCardRenewalStatus;
};

export type GQCanPeriodCardBeUpgradedResponse = {
    __typename?: "CanPeriodCardBeUpgradedResponse";
    cardId?: Maybe<Scalars["String"]>;
    cardToken?: Maybe<Scalars["String"]>;
    message?: Maybe<Scalars["String"]>;
    status: GQPeriodCardUpgradeStatus;
};

export type GQCardTransaction = {
    __typename?: "CardTransaction";
    amount: Scalars["Float"];
    cashRegister: GQCashRegister;
    id: Scalars["ID"];
    invoiceId?: Maybe<Scalars["ID"]>;
    maskedPan?: Maybe<Scalars["String"]>;
    merchant: GQMerchant;
    orderId?: Maybe<Scalars["ID"]>;
    receipt: Scalars["String"];
    scheme?: Maybe<Scalars["String"]>;
    status: GQCardTransactionType;
    transactionAt: Scalars["Date"];
};

export type GQCardTransactionPagination = GQIPagination & {
    __typename?: "CardTransactionPagination";
    data: Array<GQCardTransaction>;
    pagination: GQPagination;
};

export type GQCardTransactionSearchInput = {
    amount?: InputMaybe<GQAmountSearchInput>;
    cashRegisterName?: InputMaybe<GQStringSearchInput>;
    maskedPan?: InputMaybe<GQStringSearchInput>;
    status?: InputMaybe<GQTypeSearchInput>;
    transactionAt?: InputMaybe<GQDateSearchInput>;
};

export enum GQCardTransactionType {
    Failed = "FAILED",
    Successful = "SUCCESSFUL",
}

export type GQCashDifferencePerMethod = {
    __typename?: "CashDifferencePerMethod";
    amount: Scalars["Float"];
    currencyCode: Scalars["String"];
    currencyRate: Scalars["Float"];
    name: Scalars["String"];
    paymentMethodId: Scalars["String"];
};

export type GQCashInfoPerMethod = {
    __typename?: "CashInfoPerMethod";
    cashDifferencePerMethod?: Maybe<Array<GQCashDifferencePerMethod>>;
    cashSalePerMethod?: Maybe<Array<GQCashSalePerMethod>>;
};

export type GQCashRegister = {
    __typename?: "CashRegister";
    appData: GQAppData;
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    department?: Maybe<GQDepartment>;
    device?: Maybe<GQDevice>;
    id: Scalars["ID"];
    lastAppDataSentAt?: Maybe<Scalars["Date"]>;
    merchant: GQMerchant;
    name: Scalars["String"];
    serialId: Scalars["ID"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQCashRegisterCreateInput = {
    departmentId?: InputMaybe<Scalars["ID"]>;
    deviceId?: InputMaybe<Scalars["ID"]>;
    name: Scalars["String"];
};

export type GQCashRegisterDeleteResponse = {
    __typename?: "CashRegisterDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQCashRegisterEditInput = {
    departmentId?: InputMaybe<Scalars["ID"]>;
    name: Scalars["String"];
};

export type GQCashRegisterPagination = GQIPagination & {
    __typename?: "CashRegisterPagination";
    data: Array<GQCashRegister>;
    pagination: GQPagination;
};

export type GQCashRegisterSearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    department?: InputMaybe<GQStringSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type GQCashRegisterStatus = {
    __typename?: "CashRegisterStatus";
    appData: GQAppData;
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    department?: Maybe<GQDepartment>;
    device?: Maybe<GQDevice>;
    id: Scalars["ID"];
    lastAppDataSentAt?: Maybe<Scalars["Date"]>;
    merchant: GQMerchant;
    name: Scalars["String"];
    serialId: Scalars["ID"];
    status: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQCashRegisterStatusPagination = GQIPagination & {
    __typename?: "CashRegisterStatusPagination";
    data: Array<GQCashRegisterStatus>;
    pagination: GQPagination;
};

export type GQCashRegisterStatusSearchInput = {
    deviceAppVersion?: InputMaybe<GQStringSearchInput>;
    deviceLastSeen?: InputMaybe<GQDateSearchInput>;
    lastAppDataSentAt?: InputMaybe<GQDateSearchInput>;
    lastNotifySentAt?: InputMaybe<GQDateSearchInput>;
    merchantName?: InputMaybe<GQStringSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export enum GQCashRegisterTypeEnum {
    Master = "MASTER",
    SlaveWithoutTss = "SLAVE_WITHOUT_TSS",
    SlaveWithTss = "SLAVE_WITH_TSS",
}

export type GQCashRegisterVersion = {
    __typename?: "CashRegisterVersion";
    count: Scalars["Int"];
    label: Scalars["String"];
};

export type GQCashSalePerMethod = {
    __typename?: "CashSalePerMethod";
    amount: Scalars["Float"];
    currencyCode: Scalars["String"];
    currencyRate: Scalars["Float"];
    name: Scalars["String"];
    paymentMethodId: Scalars["String"];
};

export type GQChartAccount = {
    __typename?: "ChartAccount";
    accountNo?: Maybe<Scalars["Int"]>;
    productGroup: GQProductGroup;
    productGroupId: Scalars["ID"];
};

export type GQChartAccountInput = {
    accountNo?: InputMaybe<Scalars["Int"]>;
    productGroupId: Scalars["ID"];
};

export type GQChartAccounts = {
    __typename?: "ChartAccounts";
    data: Array<GQChartAccount>;
};

export type GQChartOfAccountNo = {
    __typename?: "ChartOfAccountNo";
    merchantAccountNo: Scalars["Int"];
};

export enum GQClientStateEnum {
    Deregistered = "DEREGISTERED",
    Registered = "REGISTERED",
}

export type GQCmpEvent = {
    __typename?: "CmpEvent";
    active: Scalars["Boolean"];
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    externalId?: Maybe<Scalars["String"]>;
    from?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    name: Scalars["String"];
    products: Array<GQCmpEventProduct>;
    sequence: Scalars["Float"];
    to?: Maybe<Scalars["Date"]>;
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQCmpEventCreateType = {
    customerId?: InputMaybe<Scalars["String"]>;
    id?: InputMaybe<Scalars["String"]>;
    payments?: InputMaybe<Array<GQCmpEventPayment>>;
    phoneNumber?: InputMaybe<Scalars["String"]>;
    products: Array<GQCmpEventProductItem>;
};

export type GQCmpEventNoProducts = {
    __typename?: "CmpEventNoProducts";
    active: Scalars["Boolean"];
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    externalId?: Maybe<Scalars["String"]>;
    from?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    name: Scalars["String"];
    sequence: Scalars["Float"];
    to?: Maybe<Scalars["Date"]>;
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQCmpEventOrderCreated = {
    __typename?: "CmpEventOrderCreated";
    orderId: Scalars["String"];
    productItems: Array<GQCmpProductResponse>;
    receipts: Array<GQCmpEventOrderReceipt>;
};

export type GQCmpEventOrderReceipt = {
    __typename?: "CmpEventOrderReceipt";
    code?: Maybe<Scalars["String"]>;
    description?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    url?: Maybe<Scalars["String"]>;
};

export type GQCmpEventPagination = GQIPagination & {
    __typename?: "CmpEventPagination";
    data: Array<GQCmpEvent>;
    pagination: GQPagination;
};

export type GQCmpEventPayment = {
    amount: Scalars["Int"];
    currency?: InputMaybe<Scalars["String"]>;
    type: Scalars["String"];
};

export type GQCmpEventProduct = {
    __typename?: "CmpEventProduct";
    active: Scalars["Boolean"];
    amount?: Maybe<Scalars["Int"]>;
    calendar?: Maybe<Scalars["JSON"]>;
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    externalEventId?: Maybe<Scalars["String"]>;
    externalId?: Maybe<Scalars["String"]>;
    group: GQProductGroup;
    id: Scalars["ID"];
    name: Scalars["String"];
    sequence: Scalars["Float"];
    shouldPrint: GQShouldPrintType;
    sms?: Maybe<Scalars["Boolean"]>;
    updatedAt?: Maybe<Scalars["Date"]>;
    upgradeable: Scalars["Boolean"];
};

export type GQCmpEventProductItem = {
    amount: Scalars["Int"];
    cardId?: InputMaybe<Scalars["String"]>;
    date?: InputMaybe<Scalars["Date"]>;
    itemId: Scalars["Int"];
    productId: Scalars["String"];
    productType?: InputMaybe<Scalars["String"]>;
    type: Scalars["String"];
    unitPrice?: InputMaybe<Scalars["Int"]>;
};

export type GQCmpEventProductPagination = GQIPagination & {
    __typename?: "CmpEventProductPagination";
    data: Array<GQCmpEventProduct>;
    pagination: GQPagination;
};

export type GQCmpGiftcardBalance = {
    __typename?: "CmpGiftcardBalance";
    amount: Scalars["Float"];
    expirationDate?: Maybe<Scalars["Date"]>;
    status: GQCmpGiftcardBalanceStatus;
};

export enum GQCmpGiftcardBalanceStatus {
    Error = "ERROR",
    GiftcardNotFound = "GIFTCARD_NOT_FOUND",
    Successful = "SUCCESSFUL",
}

export type GQCmpGiftcardPayAmountResponse = {
    __typename?: "CmpGiftcardPayAmountResponse";
    amount: Scalars["Float"];
    balance: Scalars["Float"];
    createdAt?: Maybe<Scalars["Date"]>;
    receipt?: Maybe<Scalars["String"]>;
    status: GQCmpGiftcardTransactionStatus;
    transactionId: Scalars["ID"];
};

export type GQCmpGiftcardRefundAmountResponse = {
    __typename?: "CmpGiftcardRefundAmountResponse";
    amount: Scalars["Float"];
    balance: Scalars["Float"];
    createdAt?: Maybe<Scalars["Date"]>;
    receipt?: Maybe<Scalars["String"]>;
    status: GQCmpGiftcardTransactionStatus;
    transactionId: Scalars["ID"];
};

export enum GQCmpGiftcardTransactionStatus {
    Error = "ERROR",
    GiftcardNotFound = "GIFTCARD_NOT_FOUND",
    InvalidAmount = "INVALID_AMOUNT",
    NotEnoughFunds = "NOT_ENOUGH_FUNDS",
    Successful = "SUCCESSFUL",
}

export type GQCmpInvoiceCustomer = {
    __typename?: "CmpInvoiceCustomer";
    address?: Maybe<Scalars["String"]>;
    company?: Maybe<Scalars["String"]>;
    email?: Maybe<Scalars["String"]>;
    id: Scalars["String"];
    name?: Maybe<Scalars["String"]>;
    paymentMethods: Array<GQCmpInvoicePaymentMethod>;
    phone?: Maybe<Scalars["String"]>;
};

export type GQCmpInvoiceCustomerResponse = {
    __typename?: "CmpInvoiceCustomerResponse";
    customers: Array<GQCmpInvoiceCustomer>;
    resultsFoundCount?: Maybe<Scalars["Int"]>;
    status?: Maybe<GQCmpInvoiceCustomerStatus>;
};

export enum GQCmpInvoiceCustomerStatus {
    Error = "ERROR",
    Successful = "SUCCESSFUL",
}

export type GQCmpInvoicePaymentMethod = {
    __typename?: "CmpInvoicePaymentMethod";
    allowed: Scalars["Boolean"];
    description?: Maybe<Scalars["String"]>;
    type: Scalars["String"];
};

export type GQCmpProduct = {
    __typename?: "CmpProduct";
    active: Scalars["Boolean"];
    amount?: Maybe<Scalars["Int"]>;
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    externalId?: Maybe<Scalars["String"]>;
    group: GQProductGroup;
    id: Scalars["ID"];
    name: Scalars["String"];
    sequence: Scalars["Float"];
    sms: Scalars["Boolean"];
    type?: Maybe<Scalars["String"]>;
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQCmpProductPagination = GQIPagination & {
    __typename?: "CmpProductPagination";
    data: Array<GQCmpProduct>;
    pagination: GQPagination;
};

export type GQCmpProductResponse = {
    __typename?: "CmpProductResponse";
    description?: Maybe<Scalars["String"]>;
    itemId: Scalars["Int"];
    shouldPrint: Scalars["Boolean"];
    title?: Maybe<Scalars["String"]>;
    value: Scalars["String"];
};

export type GQCmpProductSettings = {
    __typename?: "CmpProductSettings";
    cmpOrderUrl: Scalars["String"];
    exchangeName: Scalars["String"];
    hostname: Scalars["String"];
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    password: Scalars["String"];
    port: Scalars["Int"];
    queueName: Scalars["String"];
    routingKey: Scalars["String"];
    type: Scalars["String"];
    username: Scalars["String"];
    vhost: Scalars["String"];
};

export type GQCmpProductSettingsInput = {
    cmpOrderUrl: Scalars["String"];
    exchangeName: Scalars["String"];
    hostname: Scalars["String"];
    password: Scalars["String"];
    port: Scalars["Int"];
    queueName: Scalars["String"];
    routingKey: Scalars["String"];
    username: Scalars["String"];
    vhost: Scalars["String"];
};

export type GQConfiguration = {
    __typename?: "Configuration";
    paymentTerminalType?: Maybe<Scalars["String"]>;
};

export type GQCreateTssResponse = {
    __typename?: "CreateTssResponse";
    adminPuk?: Maybe<Scalars["String"]>;
    status: Scalars["Boolean"];
};

export type GQCurrency = {
    __typename?: "Currency";
    code: Scalars["String"];
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    merchant: GQMerchant;
    rate: Scalars["Float"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQCurrencyDeleteResponse = {
    __typename?: "CurrencyDeleteResponse";
    status: GQDeleteResponseEnum;
};

export type GQCurrencyInput = {
    code: Scalars["String"];
    rate: Scalars["Float"];
};

export type GQCurrencyPagination = GQIPagination & {
    __typename?: "CurrencyPagination";
    data: Array<GQCurrency>;
    pagination: GQPagination;
};

export type GQCursorPagination = {
    __typename?: "CursorPagination";
    limit: Scalars["Int"];
    remaining: Scalars["Int"];
    token: Scalars["String"];
};

export type GQCursorPaginationInput = {
    limit: Scalars["Int"];
    nextPageToken: Scalars["String"];
};

export type GQCustomItem = {
    __typename?: "CustomItem";
    externalId?: Maybe<Scalars["String"]>;
    productGroupId: Scalars["ID"];
};

export type GQCustomer = {
    __typename?: "Customer";
    accounts: Array<GQAccount>;
    address: Scalars["String"];
    city: Scalars["String"];
    comment?: Maybe<Scalars["String"]>;
    contactName?: Maybe<Scalars["String"]>;
    createdAt: Scalars["Date"];
    cvrNumber?: Maybe<Scalars["String"]>;
    deletedAt?: Maybe<Scalars["Date"]>;
    email?: Maybe<Scalars["String"]>;
    group?: Maybe<GQCustomerGroup>;
    id: Scalars["ID"];
    merchantId: GQMerchant;
    name: Scalars["String"];
    phoneNumber?: Maybe<Scalars["String"]>;
    tags: GQTagPagination;
    updatedAt?: Maybe<Scalars["Date"]>;
    zip: Scalars["String"];
};

export type GQCustomerTagsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQCustomerAssignTagsRelationResponse = {
    __typename?: "CustomerAssignTagsRelationResponse";
    status: Scalars["Boolean"];
};

export type GQCustomerCreate = {
    address: Scalars["String"];
    city: Scalars["String"];
    comment?: InputMaybe<Scalars["String"]>;
    contactName?: InputMaybe<Scalars["String"]>;
    cvrNumber?: InputMaybe<Scalars["String"]>;
    email?: InputMaybe<Scalars["String"]>;
    groupId?: InputMaybe<Scalars["ID"]>;
    merchantId: Scalars["ID"];
    name: Scalars["String"];
    phoneNumber?: InputMaybe<Scalars["String"]>;
    zip: Scalars["String"];
};

export type GQCustomerDeleteResponse = {
    __typename?: "CustomerDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQCustomerGroup = {
    __typename?: "CustomerGroup";
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    merchant: GQMerchant;
    name: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQCustomerGroupCreate = {
    merchantId: Scalars["ID"];
    name: Scalars["String"];
};

export type GQCustomerGroupDeleteResponse = {
    __typename?: "CustomerGroupDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQCustomerGroupInput = {
    name: Scalars["String"];
};

export type GQCustomerGroupPagination = GQIPagination & {
    __typename?: "CustomerGroupPagination";
    data: Array<GQCustomerGroup>;
    pagination: GQPagination;
};

export type GQCustomerGroupSearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type GQCustomerInput = {
    address: Scalars["String"];
    city: Scalars["String"];
    comment?: InputMaybe<Scalars["String"]>;
    contactName?: InputMaybe<Scalars["String"]>;
    cvrNumber?: InputMaybe<Scalars["String"]>;
    email?: InputMaybe<Scalars["String"]>;
    groupId?: InputMaybe<Scalars["ID"]>;
    name: Scalars["String"];
    phoneNumber?: InputMaybe<Scalars["String"]>;
    zip: Scalars["String"];
};

export type GQCustomerPagination = GQIPagination & {
    __typename?: "CustomerPagination";
    data: Array<GQCustomer>;
    pagination: GQPagination;
};

export type GQCustomerSearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    group?: InputMaybe<GQStringSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type GQDashboard = {
    __typename?: "Dashboard";
    accounts: Array<GQDashboardAccountItem>;
    amountsByHour: Array<GQDashboardAmountByHourItem>;
    departments: Array<GQDashboardDepartmentItem>;
    from: Scalars["Date"];
    productGroups: Array<GQDashboardProductGroupItem>;
    products: Array<GQDashboardProductItem>;
    to: Scalars["Date"];
    totals: GQDashboardTotals;
};

export type GQDashboardAccountItem = {
    __typename?: "DashboardAccountItem";
    amount: Scalars["Float"];
    id: Scalars["ID"];
    name: Scalars["String"];
};

export type GQDashboardAmountByHourItem = {
    __typename?: "DashboardAmountByHourItem";
    datetime: Scalars["Date"];
    sum: Scalars["Float"];
};

export type GQDashboardCashRegister = {
    __typename?: "DashboardCashRegister";
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    device?: Maybe<GQDevice>;
    id: Scalars["ID"];
    merchant?: Maybe<GQMerchant>;
    name: Scalars["String"];
};

export type GQDashboardCashRegisterPagination = GQIPagination & {
    __typename?: "DashboardCashRegisterPagination";
    data: Array<GQDashboardCashRegister>;
    pagination: GQPagination;
};

export type GQDashboardDepartmentItem = {
    __typename?: "DashboardDepartmentItem";
    avgTransaction: Scalars["Float"];
    id?: Maybe<Scalars["ID"]>;
    invoices: Scalars["Float"];
    name?: Maybe<Scalars["String"]>;
    turnoverAmount: Scalars["Float"];
};

export type GQDashboardProductGroupItem = {
    __typename?: "DashboardProductGroupItem";
    id: Scalars["ID"];
    name: Scalars["String"];
    quantity: Scalars["Float"];
    turnoverAmount: Scalars["Float"];
};

export type GQDashboardProductItem = {
    __typename?: "DashboardProductItem";
    id?: Maybe<Scalars["ID"]>;
    name: Scalars["String"];
    quantity: Scalars["Float"];
    turnoverAmount: Scalars["Float"];
};

export type GQDashboardTotals = {
    __typename?: "DashboardTotals";
    avgTransaction: Scalars["Float"];
    invoices: Scalars["Float"];
    turnoverAmount: Scalars["Float"];
};

export type GQDateSearchInput = {
    values: GQDateValues;
};

export type GQDateValues = {
    from: Scalars["Date"];
    to: Scalars["Date"];
};

export enum GQDeleteResponseEnum {
    InUse = "IN_USE",
    NotFound = "NOT_FOUND",
    Successful = "SUCCESSFUL",
}

export type GQDepartment = {
    __typename?: "Department";
    createdAt?: Maybe<Scalars["String"]>;
    deletedAt?: Maybe<Scalars["Date"]>;
    externalId?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    merchant: GQMerchant;
    name: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
    viWarehouse?: Maybe<GQViWarehouse>;
};

export type GQDepartmentDeleteResponse = {
    __typename?: "DepartmentDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQDepartmentInput = {
    externalId?: InputMaybe<Scalars["String"]>;
    name: Scalars["String"];
};

export type GQDepartmentPagination = GQIPagination & {
    __typename?: "DepartmentPagination";
    data: Array<GQDepartment>;
    pagination: GQPagination;
};

export type GQDepartmentSearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type GQDevice = {
    __typename?: "Device";
    appBuild?: Maybe<Scalars["String"]>;
    appVersion?: Maybe<Scalars["String"]>;
    createdAt: Scalars["Date"];
    gps?: Maybe<GQGpsPoint>;
    hardwareModel?: Maybe<Scalars["String"]>;
    hardwareProducer?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    isUsingAutoTime?: Maybe<Scalars["Boolean"]>;
    isUsingAutoTimeZone?: Maybe<Scalars["Boolean"]>;
    language?: Maybe<Scalars["String"]>;
    lastSeen: Scalars["Date"];
    macAddress?: Maybe<Scalars["String"]>;
    osName?: Maybe<Scalars["String"]>;
    osVersion?: Maybe<Scalars["String"]>;
    pinCode?: Maybe<Scalars["String"]>;
    serialNumber?: Maybe<Scalars["String"]>;
    timeZone?: Maybe<Scalars["String"]>;
};

export type GQDeviceCapabilitiesInput = {
    camera?: InputMaybe<Scalars["Boolean"]>;
    cameraFront?: InputMaybe<Scalars["Boolean"]>;
    cameraRear?: InputMaybe<Scalars["Boolean"]>;
    cashdrawer?: InputMaybe<Scalars["Boolean"]>;
};

export type GQDeviceInfoInput = {
    appBuild?: InputMaybe<Scalars["String"]>;
    appVersion?: InputMaybe<Scalars["String"]>;
    capabilities?: InputMaybe<GQDeviceCapabilitiesInput>;
    currentTime?: InputMaybe<Scalars["Float"]>;
    gps?: InputMaybe<GQGpsPointInput>;
    hardwareModel?: InputMaybe<Scalars["String"]>;
    hardwareProducer?: InputMaybe<Scalars["String"]>;
    id?: InputMaybe<Scalars["String"]>;
    isUsingAutoTime?: InputMaybe<Scalars["Boolean"]>;
    isUsingAutoTimeZone?: InputMaybe<Scalars["Boolean"]>;
    language?: InputMaybe<Scalars["String"]>;
    macAddress?: InputMaybe<Scalars["String"]>;
    osName?: InputMaybe<Scalars["String"]>;
    osVersion?: InputMaybe<Scalars["String"]>;
    printer?: InputMaybe<GQDevicePrinterInput>;
    serialNumber?: InputMaybe<Scalars["String"]>;
    timeZone?: InputMaybe<Scalars["String"]>;
};

export type GQDevicePagination = GQIPagination & {
    __typename?: "DevicePagination";
    data: Array<Maybe<GQDevice>>;
    pagination: GQPagination;
};

export type GQDevicePinCodeValidation = {
    __typename?: "DevicePinCodeValidation";
    valid: Scalars["Boolean"];
};

export type GQDevicePrinterInput = {
    charWidth?: InputMaybe<Scalars["Int"]>;
    columns?: InputMaybe<Scalars["Int"]>;
    feedPost?: InputMaybe<Scalars["Int"]>;
};

export type GQDiscount = {
    __typename?: "Discount";
    active: Scalars["Boolean"];
    conditions: Scalars["JSON"];
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    itemQuery: Scalars["JSON"];
    lineDescription: Scalars["String"];
    maxPerOrder?: Maybe<Scalars["Int"]>;
    merchant: GQMerchant;
    name: Scalars["String"];
    type: GQDiscountType;
    updatedAt?: Maybe<Scalars["Date"]>;
    value: Scalars["Float"];
    valueType: GQDiscountValueType;
};

export type GQDiscountInput = {
    active: Scalars["Boolean"];
    conditions: Scalars["JSON"];
    itemQuery: Scalars["JSON"];
    lineDescription: Scalars["String"];
    maxPerOrder?: InputMaybe<Scalars["Int"]>;
    name: Scalars["String"];
    type: GQDiscountType;
    value: Scalars["Float"];
    valueType: GQDiscountValueType;
};

export type GQDiscountPagination = GQIPagination & {
    __typename?: "DiscountPagination";
    data: Array<GQDiscount>;
    pagination: GQPagination;
};

export type GQDiscountSearchInput = {
    active?: InputMaybe<GQBooleanSearchInput>;
    createdAt?: InputMaybe<GQDateSearchInput>;
    description?: InputMaybe<GQStringSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
    type?: InputMaybe<GQTypeSearchInput>;
};

export type GQDiscountTemplate = {
    __typename?: "DiscountTemplate";
    color?: Maybe<Scalars["String"]>;
    name: Scalars["String"];
    type: GQDiscountValueType;
    value: Scalars["Float"];
};

export type GQDiscountTemplateInput = {
    color?: InputMaybe<Scalars["String"]>;
    name: Scalars["String"];
    type: GQDiscountValueType;
    value: Scalars["Float"];
};

export enum GQDiscountType {
    Group = "GROUP",
    Order = "ORDER",
    Product = "PRODUCT",
}

export enum GQDiscountValueType {
    Absolute = "ABSOLUTE",
    Percentage = "PERCENTAGE",
    Relative = "RELATIVE",
}

export type GQEconomicSettings = {
    __typename?: "EconomicSettings";
    enableSyncAfterShiftClose: Scalars["Boolean"];
    enableSyncByProductGroups: Scalars["Boolean"];
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    journalId: Scalars["Int"];
    type: Scalars["String"];
};

export type GQEconomicSettingsInput = {
    enableSyncAfterShiftClose: Scalars["Boolean"];
    enableSyncByProductGroups: Scalars["Boolean"];
    journalId: Scalars["Int"];
};

export type GQEconomicSyncJob = {
    __typename?: "EconomicSyncJob";
    attempts: Scalars["Int"];
    createdAt: Scalars["Date"];
    id: Scalars["Int"];
    lastError?: Maybe<Scalars["String"]>;
    runAt: Scalars["Date"];
    shift?: Maybe<GQShiftRm>;
    shiftId?: Maybe<Scalars["String"]>;
};

export type GQEconomicSyncJobPagination = GQIPagination & {
    __typename?: "EconomicSyncJobPagination";
    data: Array<GQEconomicSyncJob>;
    pagination: GQPagination;
};

export type GQEntity = {
    id: Scalars["ID"];
    name?: Maybe<Scalars["String"]>;
};

export type GQEntityConfig = {
    __typename?: "EntityConfig";
    data: Scalars["JSON"];
    entityId: Scalars["ID"];
};

export type GQEntityConfigDeleteResponse = {
    __typename?: "EntityConfigDeleteResponse";
    status: Scalars["Boolean"];
};

export enum GQEnvironmentEnum {
    Live = "LIVE",
    Test = "TEST",
}

export type GQEvent = {
    __typename?: "Event";
    aggregateId: Scalars["ID"];
    aggregateName: Scalars["String"];
    data: Scalars["JSON"];
    eventDate: Scalars["Date"];
    eventName: Scalars["String"];
    meta: Scalars["JSON"];
    owner: Scalars["ID"];
    ownerSequence: Scalars["Int"];
    version: Scalars["Int"];
};

export type GQEventInput = {
    aggregateId: Scalars["ID"];
    aggregateName: Scalars["String"];
    data: Scalars["JSON"];
    eventDate: Scalars["Date"];
    eventName: Scalars["String"];
    meta: Scalars["JSON"];
    owner: Scalars["ID"];
    ownerSequence: Scalars["Int"];
    version: Scalars["Int"];
};

export type GQEventQueryInput = {
    aggregateId?: InputMaybe<Array<Scalars["ID"]>>;
    aggregateName?: InputMaybe<Array<Scalars["String"]>>;
    eventName?: InputMaybe<Array<Scalars["String"]>>;
    owner?: InputMaybe<Array<Scalars["ID"]>>;
    seqEnd?: InputMaybe<Scalars["Int"]>;
    seqStart?: InputMaybe<Scalars["Int"]>;
};

export enum GQExportFormat {
    Tar = "tar",
    Zip = "zip",
}

export enum GQExportState {
    Cancelled = "CANCELLED",
    Completed = "COMPLETED",
    Deleted = "DELETED",
    Error = "ERROR",
    Expired = "EXPIRED",
    Pending = "PENDING",
    Working = "WORKING",
}

export type GQFile = {
    __typename?: "File";
    byteBuffer: Scalars["Byte"];
    contentType: Scalars["String"];
    fileName: Scalars["String"];
};

export type GQFiskalyAccessTokenResponse = {
    __typename?: "FiskalyAccessTokenResponse";
    accessToken: Scalars["String"];
    expiresAt: Scalars["Date"];
    expiresIn: Scalars["Int"];
    refreshToken: Scalars["String"];
    refreshTokenExpiresAt: Scalars["Date"];
    refreshTokenExpiresIn: Scalars["Int"];
};

export type GQFiskalyClient = {
    __typename?: "FiskalyClient";
    cashRegister: GQCashRegister;
    cashRegisterId: Scalars["ID"];
    clientState: GQClientStateEnum;
    createdAt: Scalars["Date"];
    establishmentId: Scalars["ID"];
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    submitBefore?: Maybe<Scalars["Date"]>;
    tssId: Scalars["ID"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQFiskalyClientList = {
    __typename?: "FiskalyClientList";
    data: Array<GQFiskalyClient>;
};

export type GQFiskalyConfiguration = {
    __typename?: "FiskalyConfiguration";
    clientActive: Scalars["Boolean"];
    clientId: Scalars["ID"];
    integrationActive: Scalars["Boolean"];
    tssId: Scalars["ID"];
};

export type GQFiskalyDsFinVkExport = {
    __typename?: "FiskalyDSFinVKExport";
    cashPointClosings: Array<Scalars["ID"]>;
    clientId?: Maybe<Scalars["ID"]>;
    completedAt?: Maybe<Scalars["Date"]>;
    error?: Maybe<Scalars["String"]>;
    expireAt?: Maybe<Scalars["Date"]>;
    exportState: GQExportState;
    exportUrl?: Maybe<Scalars["String"]>;
    format: GQExportFormat;
    fromDate: Scalars["Date"];
    id: Scalars["ID"];
    requestedAt: Scalars["Date"];
    toDate: Scalars["Date"];
};

export type GQFiskalyDsFinVkExportInput = {
    clientId?: InputMaybe<Scalars["ID"]>;
    fromDate: Scalars["Date"];
    toDate: Scalars["Date"];
};

export type GQFiskalyDsFinVkExportList = {
    __typename?: "FiskalyDSFinVKExportList";
    data: Array<GQFiskalyDsFinVkExport>;
};

export type GQFiskalyEstablishment = {
    __typename?: "FiskalyEstablishment";
    addressAdditional?: Maybe<Scalars["String"]>;
    createdAt: Scalars["Date"];
    decommisioningDate?: Maybe<Scalars["Date"]>;
    designation: Scalars["String"];
    houseNumber: Scalars["String"];
    houseNumberSuffix?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    organizationId: Scalars["ID"];
    remarks?: Maybe<Scalars["String"]>;
    street: Scalars["String"];
    submitBefore?: Maybe<Scalars["Date"]>;
    submittedAt?: Maybe<Scalars["Date"]>;
    town: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
    zip: Scalars["String"];
};

export type GQFiskalyEstablishmentInput = {
    addressAdditional?: InputMaybe<Scalars["String"]>;
    designation: Scalars["String"];
    houseNumber: Scalars["String"];
    houseNumberSuffix?: InputMaybe<Scalars["String"]>;
    integrationId: Scalars["ID"];
    organizationId: Scalars["ID"];
    remarks?: InputMaybe<Scalars["String"]>;
    street: Scalars["String"];
    town: Scalars["String"];
    zip: Scalars["String"];
};

export type GQFiskalyEstablishmentList = {
    __typename?: "FiskalyEstablishmentList";
    data: Array<GQFiskalyEstablishment>;
};

export type GQFiskalyEstablishmentMapping = {
    __typename?: "FiskalyEstablishmentMapping";
    cashRegister: GQCashRegister;
    cashRegisterId: Scalars["ID"];
    clientId: Scalars["ID"];
    establishmentId?: Maybe<Scalars["ID"]>;
    organizationId?: Maybe<Scalars["ID"]>;
};

export type GQFiskalyEstablishmentMappingInput = {
    cashRegisterId: Scalars["ID"];
    clientId: Scalars["ID"];
    establishmentId?: InputMaybe<Scalars["ID"]>;
};

export type GQFiskalyEstablishmentMappingList = {
    __typename?: "FiskalyEstablishmentMappingList";
    data: Array<GQFiskalyEstablishmentMapping>;
};

export type GQFiskalyEstablishmentSubmission = {
    __typename?: "FiskalyEstablishmentSubmission";
    createdAt: Scalars["Date"];
    error?: Maybe<Scalars["String"]>;
    establishmentId: Scalars["ID"];
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    previewedAt?: Maybe<Scalars["Date"]>;
    reviewedAt?: Maybe<Scalars["Date"]>;
    state: Scalars["String"];
    transmittedAt?: Maybe<Scalars["Date"]>;
};

export type GQFiskalyEstablishmentSubmissionDownload = {
    __typename?: "FiskalyEstablishmentSubmissionDownload";
    fileContents: Scalars["String"];
};

export type GQFiskalyEstablishmentSubmissionInput = {
    establishmentId: Scalars["String"];
};

export type GQFiskalyEstablishmentSubmissionList = {
    __typename?: "FiskalyEstablishmentSubmissionList";
    data: Array<GQFiskalyEstablishmentSubmission>;
    pagination: GQCursorPagination;
};

export type GQFiskalyOrganization = {
    __typename?: "FiskalyOrganization";
    address: Scalars["String"];
    countryCode: Scalars["String"];
    displayName?: Maybe<Scalars["String"]>;
    economyId?: Maybe<Scalars["String"]>;
    fiskalyEnvironment?: Maybe<GQEnvironmentEnum>;
    id: Scalars["ID"];
    integrationId?: Maybe<Scalars["ID"]>;
    managedBy?: Maybe<Scalars["ID"]>;
    merchant?: Maybe<GQMerchant>;
    merchantId?: Maybe<Scalars["ID"]>;
    name: Scalars["String"];
    state?: Maybe<Scalars["String"]>;
    taxNumber?: Maybe<Scalars["String"]>;
    town: Scalars["String"];
    vatId?: Maybe<Scalars["String"]>;
    zip: Scalars["String"];
};

export type GQFiskalyOrganizationInput = {
    address: Scalars["String"];
    countryCode: Scalars["String"];
    displayName?: InputMaybe<Scalars["String"]>;
    economyId?: InputMaybe<Scalars["String"]>;
    id: Scalars["ID"];
    name: Scalars["String"];
    state?: InputMaybe<Scalars["String"]>;
    taxNumber?: InputMaybe<Scalars["String"]>;
    town: Scalars["String"];
    vatId?: InputMaybe<Scalars["String"]>;
    zip: Scalars["String"];
};

export type GQFiskalyOrganizations = {
    __typename?: "FiskalyOrganizations";
    data: Array<GQFiskalyOrganization>;
};

export type GQFiskalyOrganizationsPagination = GQIPagination & {
    __typename?: "FiskalyOrganizationsPagination";
    data: Array<GQFiskalyOrganization>;
    pagination: GQPagination;
};

export type GQFiskalyRemoteCashRegister = {
    __typename?: "FiskalyRemoteCashRegister";
    baseCurrencyCode: Scalars["String"];
    brand: Scalars["String"];
    cashRegisterType: GQCashRegisterTypeEnum;
    clientId: Scalars["ID"];
    createdAt: Scalars["Date"];
    environment: GQEnvironmentEnum;
    model: Scalars["String"];
    revision: Scalars["Int"];
    softwareBrand?: Maybe<Scalars["String"]>;
    softwareVersion?: Maybe<Scalars["String"]>;
    tssId: Scalars["ID"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQFiskalyRemoteCashRegisterList = {
    __typename?: "FiskalyRemoteCashRegisterList";
    data: Array<GQFiskalyRemoteCashRegister>;
};

export type GQFiskalyRemoteClient = {
    __typename?: "FiskalyRemoteClient";
    createdAt: Scalars["Date"];
    id: Scalars["ID"];
    serialNumber: Scalars["String"];
    state?: Maybe<GQClientStateEnum>;
    tssId: Scalars["ID"];
    updatedAt: Scalars["Date"];
};

export type GQFiskalyRemoteClientList = {
    __typename?: "FiskalyRemoteClientList";
    data: Array<GQFiskalyRemoteClient>;
};

export type GQFiskalyRemoteEstablishmentSubmissionList = {
    __typename?: "FiskalyRemoteEstablishmentSubmissionList";
    data: Array<GQRemoteEstablishmentSubmission>;
};

export type GQFiskalySettings = {
    __typename?: "FiskalySettings";
    apiKey: Scalars["String"];
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    organizationId: Scalars["ID"];
    submissionNeeded: Scalars["Boolean"];
    tssId: Scalars["ID"];
    type: Scalars["String"];
};

export type GQFiskalySettingsInput = {
    apiKey: Scalars["String"];
    organizationId: Scalars["ID"];
    submissionNeeded: Scalars["Boolean"];
    tssId: Scalars["ID"];
};

export type GQFiskalyTaxPayer =
    | GQFiskalyTaxPayerLegal
    | GQFiskalyTaxPayerNatural;

export type GQFiskalyTaxPayerLegal = GQIFiskalyTaxPayer & {
    __typename?: "FiskalyTaxPayerLegal";
    companyName: Scalars["String"];
    country: Scalars["String"];
    houseNumber: Scalars["String"];
    houseNumberSuffix?: Maybe<Scalars["String"]>;
    legalForm: Scalars["String"];
    street: Scalars["String"];
    taxNumber: Scalars["String"];
    taxOfficeNumber?: Maybe<Scalars["String"]>;
    town: Scalars["String"];
    type: GQFiskalyTaxPayerType;
    vatNumber?: Maybe<Scalars["String"]>;
    webAddress?: Maybe<Scalars["String"]>;
    zip: Scalars["String"];
};

export type GQFiskalyTaxPayerLegalInput = {
    companyName: Scalars["String"];
    country: Scalars["String"];
    houseNumber: Scalars["String"];
    houseNumberSuffix?: InputMaybe<Scalars["String"]>;
    legalForm: Scalars["String"];
    street: Scalars["String"];
    taxNumber: Scalars["String"];
    taxOfficeNumber?: InputMaybe<Scalars["String"]>;
    town: Scalars["String"];
    type: GQFiskalyTaxPayerType;
    vatNumber?: InputMaybe<Scalars["String"]>;
    webAddress: Scalars["String"];
    zip: Scalars["String"];
};

export type GQFiskalyTaxPayerNatural = GQIFiskalyTaxPayer & {
    __typename?: "FiskalyTaxPayerNatural";
    birthDate: Scalars["Date"];
    country: Scalars["String"];
    firstName: Scalars["String"];
    houseNumber: Scalars["String"];
    houseNumberSuffix?: Maybe<Scalars["String"]>;
    identificationNumber?: Maybe<Scalars["String"]>;
    lastName: Scalars["String"];
    prefix?: Maybe<Scalars["String"]>;
    salutation: Scalars["String"];
    street: Scalars["String"];
    suffix?: Maybe<Scalars["String"]>;
    taxNumber: Scalars["String"];
    taxOfficeNumber?: Maybe<Scalars["String"]>;
    title?: Maybe<Scalars["String"]>;
    town: Scalars["String"];
    type: GQFiskalyTaxPayerType;
    vatNumber?: Maybe<Scalars["String"]>;
    webAddress?: Maybe<Scalars["String"]>;
    zip: Scalars["String"];
};

export type GQFiskalyTaxPayerNaturalInput = {
    birthDate: Scalars["Date"];
    country: Scalars["String"];
    firstName: Scalars["String"];
    houseNumber: Scalars["String"];
    houseNumberSuffix?: InputMaybe<Scalars["String"]>;
    identificationNumber?: InputMaybe<Scalars["String"]>;
    lastName: Scalars["String"];
    prefix?: InputMaybe<Scalars["String"]>;
    salutation: Scalars["String"];
    street: Scalars["String"];
    suffix?: InputMaybe<Scalars["String"]>;
    taxNumber: Scalars["String"];
    taxOfficeNumber?: InputMaybe<Scalars["String"]>;
    title?: InputMaybe<Scalars["String"]>;
    town: Scalars["String"];
    type: GQFiskalyTaxPayerType;
    vatNumber?: InputMaybe<Scalars["String"]>;
    webAddress?: InputMaybe<Scalars["String"]>;
    zip: Scalars["String"];
};

export enum GQFiskalyTaxPayerType {
    Legal = "legal",
    Natural = "natural",
}

export type GQFiskalyTss = {
    __typename?: "FiskalyTss";
    createdAt: Scalars["Date"];
    defectiveAt?: Maybe<Scalars["Date"]>;
    deletedAt?: Maybe<Scalars["Date"]>;
    description: Scalars["String"];
    disabledAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    initializedAt?: Maybe<Scalars["Date"]>;
    numberActiveTransactions: Scalars["Int"];
    numberRegisteredClients: Scalars["Int"];
    publicKey: Scalars["String"];
    serialNumber: Scalars["String"];
    signatureCounter: Scalars["Int"];
    state: GQTssStateEnum;
    transactionCounter: Scalars["Int"];
    uninitializedAt?: Maybe<Scalars["Date"]>;
};

export type GQFiskalyTssList = {
    __typename?: "FiskalyTssList";
    data: Array<GQFiskalyTss>;
};

export type GQFunction = GQBuyAccountFunds | GQCustomItem;

export type GQGpsPoint = {
    __typename?: "GpsPoint";
    latitude: Scalars["Float"];
    longitude: Scalars["Float"];
};

export type GQGpsPointInput = {
    latitude: Scalars["Float"];
    longitude: Scalars["Float"];
};

export type GQIFiskalyTaxPayer = {
    country: Scalars["String"];
    houseNumber: Scalars["String"];
    houseNumberSuffix?: Maybe<Scalars["String"]>;
    street: Scalars["String"];
    taxNumber: Scalars["String"];
    taxOfficeNumber?: Maybe<Scalars["String"]>;
    town: Scalars["String"];
    type: GQFiskalyTaxPayerType;
    vatNumber?: Maybe<Scalars["String"]>;
    webAddress?: Maybe<Scalars["String"]>;
    zip: Scalars["String"];
};

export type GQIPagination = {
    pagination: GQPagination;
};

export type GQIntegration = {
    __typename?: "Integration";
    active: Scalars["Boolean"];
    apiKey: Scalars["String"];
    createdAt?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    merchant: GQMerchant;
    merchantChartOfAccounts: Array<GQMerchantChartOfAccount>;
    name: Scalars["String"];
    type: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQIntegrationAccount = {
    __typename?: "IntegrationAccount";
    accountNo: Scalars["Int"];
    id: Scalars["ID"];
    integrationType: Scalars["String"];
    name: Scalars["String"];
};

export type GQIntegrationArray = {
    __typename?: "IntegrationArray";
    data: Array<GQIntegration>;
};

export type GQIntegrationCreate = {
    active: Scalars["Boolean"];
    apiKey: Scalars["String"];
    merchantChartOfAccounts?: InputMaybe<
        Array<InputMaybe<GQMerchantChartOfAccountInput>>
    >;
    merchantId: Scalars["String"];
    name: Scalars["String"];
    type: Scalars["String"];
};

export type GQIntegrationInput = {
    active: Scalars["Boolean"];
    apiKey: Scalars["String"];
    merchantChartOfAccounts?: InputMaybe<
        Array<InputMaybe<GQMerchantChartOfAccountInput>>
    >;
    merchantId: Scalars["String"];
    name: Scalars["String"];
    type: Scalars["String"];
};

export type GQIntegrationPagination = GQIPagination & {
    __typename?: "IntegrationPagination";
    data: Array<GQIntegration>;
    pagination: GQPagination;
};

export type GQIntegrationSettings =
    | GQCmpProductSettings
    | GQEconomicSettings
    | GQFiskalySettings
    | GQPartnerApiSettings
    | GQVenueAccessSettings;

export type GQInventoryProduct = {
    __typename?: "InventoryProduct";
    id: Scalars["ID"];
    merchant: GQMerchant;
    name: Scalars["String"];
    products: Array<GQProduct>;
    quantity: Scalars["Int"];
};

export type GQInventoryProductCreate = {
    name: Scalars["String"];
    productIds: Array<GQProductRelationInput>;
    quantity: Scalars["Int"];
};

export type GQInventoryProductInput = {
    name: Scalars["String"];
    productIds: Array<GQProductRelationInput>;
    quantity: Scalars["Int"];
};

export type GQInventoryProductNoteTemplate = {
    __typename?: "InventoryProductNoteTemplate";
    id: Scalars["ID"];
    merchant: GQMerchant;
    note: Scalars["String"];
};

export type GQInventoryProductNoteTemplateCreate = {
    note: Scalars["String"];
};

export type GQInventoryProductNoteTemplateInput = {
    id: Scalars["ID"];
    note: Scalars["String"];
};

export type GQInventoryProductNoteTemplatePagination = GQIPagination & {
    __typename?: "InventoryProductNoteTemplatePagination";
    data: Array<GQInventoryProductNoteTemplate>;
    pagination: GQPagination;
};

export type GQInventoryProductPagination = GQIPagination & {
    __typename?: "InventoryProductPagination";
    data: Array<GQInventoryProduct>;
    pagination: GQPagination;
};

export type GQInvoiceAmount = {
    __typename?: "InvoiceAmount";
    datetime: Scalars["Date"];
    sum: Scalars["Float"];
};

export type GQInvoiceAmountPerMonth = {
    __typename?: "InvoiceAmountPerMonth";
    monthNumber: Scalars["String"];
    sum: Scalars["Float"];
    year: Scalars["String"];
};

export type GQInvoiceCount = {
    __typename?: "InvoiceCount";
    count: Scalars["Float"];
    merchant?: Maybe<GQMerchant>;
};

export type GQInvoiceExternalReceipt = {
    __typename?: "InvoiceExternalReceipt";
    integrationId: Scalars["String"];
    receipt: Scalars["String"];
};

export type GQInvoiceHourSales = {
    __typename?: "InvoiceHourSales";
    amount: Scalars["Float"];
    count: Scalars["Float"];
    date: Scalars["Date"];
};

export type GQInvoiceItemExternalRm = {
    __typename?: "InvoiceItemExternalRM";
    checkoutRef?: Maybe<Scalars["String"]>;
    integration: Scalars["String"];
    itemId: Scalars["String"];
    parameters?: Maybe<Scalars["JSON"]>;
    receipt?: Maybe<Scalars["String"]>;
};

export type GQInvoiceItemRm = {
    __typename?: "InvoiceItemRM";
    amount: Scalars["Float"];
    costAmount?: Maybe<Scalars["Float"]>;
    discountAmount: Scalars["Float"];
    external?: Maybe<Array<GQInvoiceItemExternalRm>>;
    name: Scalars["String"];
    note?: Maybe<Scalars["String"]>;
    productId?: Maybe<Scalars["ID"]>;
    quantity: Scalars["Float"];
};

export type GQInvoicePaymentRm = {
    __typename?: "InvoicePaymentRM";
    amount: Scalars["Float"];
    cardReceipt?: Maybe<Scalars["String"]>;
    currency: Scalars["String"];
    paymentType: Scalars["String"];
};

export type GQInvoiceRm = {
    __typename?: "InvoiceRM";
    amount: Scalars["Float"];
    cashRegisterName?: Maybe<Scalars["String"]>;
    createdAt: Scalars["Date"];
    departmentId?: Maybe<Scalars["ID"]>;
    discountAmount: Scalars["Float"];
    externalId?: Maybe<Scalars["String"]>;
    externalReceipts: Array<GQInvoiceExternalReceipt>;
    id: Scalars["ID"];
    items?: Maybe<Array<GQInvoiceItemRm>>;
    name?: Maybe<Scalars["String"]>;
    payments?: Maybe<Array<GQInvoicePaymentRm>>;
    receipt: Scalars["String"];
    receiptNumber?: Maybe<Scalars["String"]>;
    shift: GQShiftRm;
    shiftId: Scalars["ID"];
    sms?: Maybe<Scalars["String"]>;
};

export type GQInvoiceRmPagination = GQIPagination & {
    __typename?: "InvoiceRMPagination";
    data: Array<GQInvoiceRm>;
    pagination: GQPagination;
};

export type GQInvoiceSearchInput = {
    amount?: InputMaybe<GQAmountSearchInput>;
    cashRegisterName?: InputMaybe<GQStringSearchInput>;
    createdAt?: InputMaybe<GQDateSearchInput>;
    receiptNumber?: InputMaybe<GQStringSearchInput>;
};

export type GQLayout = {
    __typename?: "Layout";
    columns: Scalars["Int"];
    createdAt: Scalars["Date"];
    data: Scalars["JSON"];
    id: Scalars["ID"];
    layoutType: Scalars["String"];
    name: Scalars["String"];
    productGroups: Array<GQProductGroup>;
    products: Array<GQProduct>;
    rows: Scalars["Int"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQLayoutCreate = {
    columns: Scalars["Int"];
    data: Scalars["JSON"];
    layoutType: Scalars["String"];
    name: Scalars["String"];
    rows: Scalars["Int"];
};

export type GQLayoutDeleteResponse = {
    __typename?: "LayoutDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQLayoutEntity = {
    __typename?: "LayoutEntity";
    createdAt: Scalars["Date"];
    data: GQFunction;
    function?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    name: Scalars["String"];
    type: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQLayoutEntityCreate = {
    data: Scalars["JSON"];
    function?: InputMaybe<Scalars["String"]>;
    name: Scalars["String"];
    type: Scalars["String"];
};

export type GQLayoutEntityPagination = GQIPagination & {
    __typename?: "LayoutEntityPagination";
    data: Array<GQLayoutEntity>;
    pagination: GQPagination;
};

export type GQLayoutEntitySave = {
    data: Scalars["JSON"];
    function?: InputMaybe<Scalars["String"]>;
    name: Scalars["String"];
    type: Scalars["String"];
};

export type GQLayoutEntitySearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type GQLayoutPagination = GQIPagination & {
    __typename?: "LayoutPagination";
    data: Array<GQLayout>;
    pagination: GQPagination;
};

export type GQLayoutSave = {
    data: Scalars["JSON"];
    name: Scalars["String"];
};

export type GQLayoutSearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type GQLog = {
    __typename?: "Log";
    id: Scalars["ID"];
    insertedAt: Scalars["Date"];
    merchant?: Maybe<GQMerchant>;
    message?: Maybe<Scalars["String"]>;
    payload?: Maybe<Scalars["JSON"]>;
    type: GQLogType;
};

export type GQLogPagination = GQIPagination & {
    __typename?: "LogPagination";
    data: Array<GQLog>;
    pagination: GQPagination;
};

export type GQLogSearchInput = {
    insertedAt?: InputMaybe<GQDateSearchInput>;
    merchantName?: InputMaybe<GQStringSearchInput>;
    message?: InputMaybe<GQStringSearchInput>;
    type?: InputMaybe<GQTypeSearchInput>;
};

export enum GQLogType {
    Debug = "DEBUG",
    Error = "ERROR",
    Info = "INFO",
    Log = "LOG",
    Warn = "WARN",
}

export type GQLogo = {
    __typename?: "Logo";
    base64Data: Scalars["String"];
    bmpData: Scalars["String"];
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    escposData: Scalars["String"];
    fileType: Scalars["String"];
    height: Scalars["Int"];
    id: Scalars["ID"];
    merchant: GQMerchant;
    type: GQLogoType;
    updatedAt?: Maybe<Scalars["Date"]>;
    width: Scalars["Int"];
};

export type GQLogoInput = {
    base64Data: Scalars["String"];
    bmpData: Scalars["String"];
    escposData: Scalars["String"];
    fileType: Scalars["String"];
    height: Scalars["Int"];
    type: GQLogoType;
    width: Scalars["Int"];
};

export enum GQLogoType {
    Receipt = "RECEIPT",
}

export type GQMe = {
    __typename?: "Me";
    cashRegister?: Maybe<GQCashRegister>;
    department?: Maybe<GQDepartment>;
    merchant?: Maybe<GQMerchant>;
    role?: Maybe<GQRole>;
    user?: Maybe<GQUser>;
};

export type GQMeasurementUnit = {
    __typename?: "MeasurementUnit";
    deletedAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    name: Scalars["String"];
};

export type GQMerchant = {
    __typename?: "Merchant";
    createdAt?: Maybe<Scalars["Date"]>;
    entityConfig?: Maybe<GQEntityConfig>;
    giftcardVatBookkeepingMethod: Scalars["String"];
    id: Scalars["ID"];
    lastNotifySentAt?: Maybe<Scalars["Date"]>;
    name: Scalars["String"];
    serialId: Scalars["Int"];
    updatedAt?: Maybe<Scalars["Date"]>;
    users: Array<GQUser>;
};

export type GQMerchantChartOfAccount = {
    __typename?: "MerchantChartOfAccount";
    chartOfAccountsId: Scalars["String"];
    integrationId: Scalars["String"];
    merchantAccountNo: Scalars["Int"];
    name: Scalars["String"];
};

export type GQMerchantChartOfAccountInput = {
    chartOfAccountsId: Scalars["String"];
    merchantAccountNo: Scalars["Int"];
    name: Scalars["String"];
};

export type GQMerchantChartOfAccounts = {
    __typename?: "MerchantChartOfAccounts";
    data: Array<GQMerchantChartOfAccount>;
};

export type GQMerchantCreate = {
    currency: Scalars["String"];
    email: Scalars["String"];
    giftcardVatBookkeepingMethod: Scalars["String"];
    name: Scalars["String"];
    vat: Scalars["Int"];
};

export type GQMerchantDeleteResponse = {
    __typename?: "MerchantDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQMerchantInput = {
    name: Scalars["String"];
};

export type GQMerchantPagination = GQIPagination & {
    __typename?: "MerchantPagination";
    data: Array<GQMerchant>;
    pagination: GQPagination;
};

export type GQMerchantSearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    merchant?: InputMaybe<GQStringSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type GQMiscButtons = {
    __typename?: "MiscButtons";
    buttons: Scalars["JSON"];
    buttonsSortOrder?: Maybe<Scalars["JSON"]>;
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    merchant: GQMerchant;
    name: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQMiscButtonsDeleteResponse = {
    __typename?: "MiscButtonsDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQMiscButtonsInput = {
    buttons: Scalars["JSON"];
    buttonsSortOrder?: InputMaybe<Scalars["JSON"]>;
    name: Scalars["String"];
};

export type GQMiscButtonsPagination = GQIPagination & {
    __typename?: "MiscButtonsPagination";
    data: Array<GQMiscButtons>;
    pagination: GQPagination;
};

export type GQMutation = {
    __typename?: "Mutation";
    accountAssignTags: GQBooleanResponse;
    accountBuyFunds: GQAccountBuyFundsResponse;
    accountClose: GQAccountCloseResponse;
    accountCreate: GQAccount;
    accountOpen: GQAccountOpenResponse;
    accountPayAmount: GQAccountPayAmountResponse;
    accountRefundAmount: GQAccountRefundAmountResponse;
    accountReissueGiftcard: GQBooleanResponse;
    accountReissueGiftcards: GQBooleanResponse;
    accountReturnFunds: GQAccountReturnFundsResponse;
    accountRevertTransaction: GQAccountRevertTransactionResponse;
    accountSave: GQAccount;
    addEconomicSyncJobs: GQBooleanResponse;
    approvalCreate: GQApproval;
    approvalDelete: GQBooleanResponse;
    approvalSave: GQApproval;
    approvalTokenCreate: GQApprovalToken;
    approvalTokenDelete: GQBooleanResponse;
    approvalTokenGroupCreate: GQApprovalTokenGroup;
    approvalTokenGroupDelete: GQBooleanResponse;
    approvalTokenGroupSave: GQApprovalTokenGroup;
    approvalTokenSave: GQApprovalToken;
    approveFiskalyEstablishmentSubmission: GQBooleanResponse;
    authLogin: GQAuthAttempt;
    authSelectUserRole: GQSelectUserRoleType;
    authUpdateLogin: GQAuthAttempt;
    cashRegisterClaim?: Maybe<GQCashRegister>;
    cashRegisterCreate: GQCashRegister;
    cashRegisterDelete: GQCashRegisterDeleteResponse;
    cashRegisterEdit: GQCashRegister;
    cashRegistersDelete: GQCashRegisterDeleteResponse;
    cmpEventCreateOrder: GQCmpEventOrderCreated;
    cmpEventDelete: GQBooleanResponse;
    cmpEventProductDelete: GQBooleanResponse;
    cmpGiftcardPayAmount: GQCmpGiftcardPayAmountResponse;
    cmpGiftcardRefundAmount: GQCmpGiftcardRefundAmountResponse;
    cmpProductDelete: GQBooleanResponse;
    currencyCreate: GQCurrency;
    currencyDelete: GQCurrencyDeleteResponse;
    currencySave: GQCurrency;
    customerAssignTags: GQCustomerAssignTagsRelationResponse;
    customerCreate: GQCustomer;
    customerDelete: GQCustomerDeleteResponse;
    customerGroupCreate: GQCustomerGroup;
    customerGroupDelete: GQCustomerGroupDeleteResponse;
    customerGroupSave: GQCustomerGroup;
    customerSave: GQCustomer;
    deleteEstablishment: GQBooleanResponse;
    departmentCreate: GQDepartment;
    departmentDelete: GQDepartmentDeleteResponse;
    departmentSave: GQDepartment;
    deviceHeartbeat: Scalars["Boolean"];
    deviceRegister: GQDevice;
    discountCreate: GQDiscount;
    discountDelete: GQBooleanResponse;
    discountSave: GQDiscount;
    discountsActiveToggle: GQBooleanResponse;
    entityConfigDelete: GQEntityConfigDeleteResponse;
    entityConfigSave: GQEntityConfig;
    eventStoreSyncDispatch: GQAddEventResponse;
    fiskalyAdvanceTssState: GQBooleanResponse;
    fiskalyChangePinForTss: GQBooleanResponse;
    fiskalyClientSync: GQFiskalyClient;
    fiskalyGoLive: GQBooleanResponse;
    fiskalyOrganizationGoLive: GQFiskalyOrganization;
    fiskalyOrganizationUpsert: GQFiskalyOrganization;
    fiskalyRegisterTssForOrganization: GQCreateTssResponse;
    integrationCmpProductSettingsSave: GQBooleanResponse;
    integrationCreate: GQIntegration;
    integrationDelete: GQBooleanResponse;
    integrationEconomicSettingsSave: GQBooleanResponse;
    integrationFiskalySettingsSave: GQBooleanResponse;
    integrationSave: GQIntegration;
    inventoryProductNoteTemplateCreate: GQInventoryProductNoteTemplate;
    inventoryProductNoteTemplateDelete: GQBooleanResponse;
    inventoryProductNoteTemplateSave: GQInventoryProductNoteTemplate;
    inventoryProductUpdate: GQInventoryProduct;
    layoutCopy: GQLayout;
    layoutCreate: GQLayout;
    layoutDelete: GQLayoutDeleteResponse;
    layoutEntityCreate: GQLayoutEntity;
    layoutEntityDelete: GQBooleanResponse;
    layoutEntitySave: GQLayoutEntity;
    layoutSave: GQLayout;
    logoDelete: GQBooleanResponse;
    logoSave: GQLogo;
    merchantCreate: GQMerchant;
    merchantDelete: GQMerchantDeleteResponse;
    merchantSave: GQMerchant;
    miscButtonsCreate: GQMiscButtons;
    miscButtonsDelete: GQMiscButtonsDeleteResponse;
    miscButtonsSave: GQMiscButtons;
    passwordResetRequest: GQBooleanResponse;
    passwordResetTokenDelete: GQBooleanResponse;
    passwordResetTokenUpdatePassword?: Maybe<GQBooleanResponse>;
    paymentConfigurationCreate: GQPaymentConfiguration;
    paymentConfigurationDelete: GQPaymentConfigurationDeleteResponse;
    paymentConfigurationSave: GQPaymentConfiguration;
    paymentMethodCreate: GQPaymentMethod;
    paymentMethodDelete: GQPaymentMethodDeleteResponse;
    paymentMethodSave: GQPaymentMethod;
    printerDelete: GQPrinterDeleteResponse;
    printerRegister: GQPrinter;
    printerSave: GQPrinter;
    productCreate: GQProduct;
    productDelete: GQProductDeleteResponse;
    productGroupCreate: GQProductGroup;
    productGroupDelete: GQProductGroupDeleteResponse;
    productGroupSave: GQProductGroup;
    productSave: GQProduct;
    productsDelete: GQProductDeleteResponse;
    rebuildSaftJobs: GQBooleanResponse;
    releaseTerminal: GQBooleanResponse;
    requestFiskalyDSFinVKExport: GQBooleanResponse;
    requestFiskalyEstablishmentSubmission: GQBooleanResponse;
    requestFiskalyEstablishmentSubmissionDownload: GQFiskalyEstablishmentSubmissionDownload;
    requestFiskalyEstablishmentSubmissionPreviewDownload: GQFiskalyEstablishmentSubmissionDownload;
    requestFiskalyEstablishmentSubmissionTransmission: GQBooleanResponse;
    roleCreate: GQRole;
    roleDelete: GQRoleDeleteResponse;
    roleSave: GQRole;
    saveAccountChartByProductGroup: GQBooleanResponse;
    saveAccountForProductGroup: GQBooleanResponse;
    saveFiskalyEstablishment: GQFiskalyEstablishment;
    saveFiskalyEstablishmentMapping: GQBooleanResponse;
    saveMerchantChartOfAccounts: GQBooleanResponse;
    setDepartment2Warehouse: GQBooleanResponse;
    setFiskalyClientState: GQFiskalyClient;
    setInventoryProductQuantity: GQInventoryProduct;
    setProduct2ViProduct2MeasurementUnit: GQBooleanResponse;
    tagCreate: GQTag;
    tagDelete: GQTagDeleteResponse;
    tagGroupCreate: GQTagGroup;
    tagGroupDelete: GQTagGroupDeleteResponse;
    tagGroupSave: GQTagGroup;
    tagSave: GQTag;
    updateViProducts: GQBooleanResponse;
    updateViWarehouses: GQBooleanResponse;
    upsertFiskalyTaxPayerLegal: GQBooleanResponse;
    upsertFiskalyTaxPayerNatural: GQBooleanResponse;
    userCreate: GQUser;
    userDelete: GQUserDeleteResponse;
    userRoleConfigurationSave: GQBooleanResponse;
    userSave: GQUser;
    userUpdatePassword: GQBooleanResponse;
    vatCreate: GQVat;
    vatDelete: GQVatDeleteResponse;
    venueAccessCancelAccessTicket: GQVenueAccessTicketCancelled;
    venueAccessCreateAccessTicket: GQVenueAccessTicketCreated;
    venueAccessCreateAccessTickets?: Maybe<Array<GQVenueAccessTicketCreated>>;
    virtualPrinterCreate: GQVirtualPrinter;
    virtualPrinterDelete: GQVirtualPrinterDeleteResponse;
    virtualPrinterSave: GQVirtualPrinter;
};

export type GQMutationAccountAssignTagsArgs = {
    id: Scalars["ID"];
    tagIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type GQMutationAccountBuyFundsArgs = {
    amount: Scalars["Float"];
    id: Scalars["ID"];
    orderId: Scalars["ID"];
    tagId: Scalars["ID"];
    tagIdentifier: Scalars["String"];
    userId: Scalars["ID"];
};

export type GQMutationAccountCloseArgs = {
    id: Scalars["ID"];
};

export type GQMutationAccountCreateArgs = {
    account: GQAccountCreate;
};

export type GQMutationAccountOpenArgs = {
    id: Scalars["ID"];
};

export type GQMutationAccountPayAmountArgs = {
    amount: Scalars["Float"];
    id: Scalars["ID"];
    orderId: Scalars["ID"];
    printWidth?: InputMaybe<Scalars["Int"]>;
    tagId?: InputMaybe<Scalars["ID"]>;
    tagIdentifier?: InputMaybe<Scalars["String"]>;
    userId: Scalars["ID"];
};

export type GQMutationAccountRefundAmountArgs = {
    amount: Scalars["Float"];
    id: Scalars["ID"];
    orderId: Scalars["ID"];
    printWidth?: InputMaybe<Scalars["Int"]>;
    tagId?: InputMaybe<Scalars["ID"]>;
    tagIdentifier?: InputMaybe<Scalars["String"]>;
    userId: Scalars["ID"];
};

export type GQMutationAccountReissueGiftcardArgs = {
    id: Scalars["ID"];
};

export type GQMutationAccountReissueGiftcardsArgs = {
    ids: Array<Scalars["ID"]>;
};

export type GQMutationAccountReturnFundsArgs = {
    amount: Scalars["Float"];
    id: Scalars["ID"];
    orderId: Scalars["ID"];
    tagId: Scalars["ID"];
    tagIdentifier: Scalars["String"];
    userId: Scalars["ID"];
};

export type GQMutationAccountRevertTransactionArgs = {
    id: Scalars["ID"];
    transactionId: Scalars["ID"];
    userId: Scalars["ID"];
};

export type GQMutationAccountSaveArgs = {
    account: GQAccountInput;
    id: Scalars["ID"];
};

export type GQMutationAddEconomicSyncJobsArgs = {
    ids?: InputMaybe<Array<Scalars["ID"]>>;
    integrationId: Scalars["ID"];
    voucherText?: InputMaybe<Scalars["String"]>;
};

export type GQMutationApprovalCreateArgs = {
    approval: GQApprovalInput;
};

export type GQMutationApprovalDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationApprovalSaveArgs = {
    approval: GQApprovalInput;
    id: Scalars["ID"];
};

export type GQMutationApprovalTokenCreateArgs = {
    approvalToken: GQApprovalTokenInput;
};

export type GQMutationApprovalTokenDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationApprovalTokenGroupCreateArgs = {
    approvalTokenGroup: GQApprovalTokenGroupInput;
};

export type GQMutationApprovalTokenGroupDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationApprovalTokenGroupSaveArgs = {
    approvalTokenGroup: GQApprovalTokenGroupInput;
    id: Scalars["ID"];
};

export type GQMutationApprovalTokenSaveArgs = {
    approvalToken: GQApprovalTokenInput;
    id: Scalars["ID"];
};

export type GQMutationApproveFiskalyEstablishmentSubmissionArgs = {
    submissionId: Scalars["ID"];
};

export type GQMutationAuthLoginArgs = {
    password: Scalars["String"];
    username: Scalars["String"];
};

export type GQMutationAuthSelectUserRoleArgs = {
    merchantId?: InputMaybe<Scalars["ID"]>;
    roleId: Scalars["ID"];
};

export type GQMutationCashRegisterClaimArgs = {
    devicePinCode: Scalars["String"];
    id: Scalars["ID"];
};

export type GQMutationCashRegisterCreateArgs = {
    cashRegister: GQCashRegisterCreateInput;
};

export type GQMutationCashRegisterDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationCashRegisterEditArgs = {
    cashRegister: GQCashRegisterEditInput;
    id: Scalars["ID"];
};

export type GQMutationCashRegistersDeleteArgs = {
    ids: Array<Scalars["ID"]>;
};

export type GQMutationCmpEventCreateOrderArgs = {
    order: GQCmpEventCreateType;
};

export type GQMutationCmpEventDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationCmpEventProductDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationCmpGiftcardPayAmountArgs = {
    amount: Scalars["Float"];
    code?: InputMaybe<Scalars["String"]>;
    id: Scalars["ID"];
    orderId: Scalars["ID"];
    userId: Scalars["ID"];
};

export type GQMutationCmpGiftcardRefundAmountArgs = {
    amount: Scalars["Float"];
    code?: InputMaybe<Scalars["String"]>;
    id: Scalars["ID"];
    orderId: Scalars["ID"];
    userId: Scalars["ID"];
};

export type GQMutationCmpProductDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationCurrencyCreateArgs = {
    currency: GQCurrencyInput;
};

export type GQMutationCurrencyDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationCurrencySaveArgs = {
    currency: GQCurrencyInput;
    id: Scalars["ID"];
};

export type GQMutationCustomerAssignTagsArgs = {
    id: Scalars["ID"];
    tagIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type GQMutationCustomerCreateArgs = {
    customer: GQCustomerInput;
};

export type GQMutationCustomerDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationCustomerGroupCreateArgs = {
    customerGroup: GQCustomerGroupInput;
};

export type GQMutationCustomerGroupDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationCustomerGroupSaveArgs = {
    customerGroup: GQCustomerGroupInput;
    id: Scalars["ID"];
};

export type GQMutationCustomerSaveArgs = {
    customer: GQCustomerInput;
    id: Scalars["ID"];
};

export type GQMutationDeleteEstablishmentArgs = {
    establishmentId: Scalars["ID"];
};

export type GQMutationDepartmentCreateArgs = {
    department: GQDepartmentInput;
};

export type GQMutationDepartmentDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationDepartmentSaveArgs = {
    department: GQDepartmentInput;
    id: Scalars["ID"];
};

export type GQMutationDeviceHeartbeatArgs = {
    deviceInfo: GQDeviceInfoInput;
};

export type GQMutationDeviceRegisterArgs = {
    deviceInfo: GQDeviceInfoInput;
    newPinCode?: InputMaybe<Scalars["Boolean"]>;
};

export type GQMutationDiscountCreateArgs = {
    discount: GQDiscountInput;
};

export type GQMutationDiscountDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationDiscountSaveArgs = {
    discount: GQDiscountInput;
    id: Scalars["ID"];
};

export type GQMutationDiscountsActiveToggleArgs = {
    ids: Array<Scalars["ID"]>;
};

export type GQMutationEntityConfigDeleteArgs = {
    entityId: Scalars["ID"];
};

export type GQMutationEntityConfigSaveArgs = {
    disabledData: Array<Scalars["String"]>;
    entityId: Scalars["ID"];
    partialData: Scalars["JSON"];
};

export type GQMutationEventStoreSyncDispatchArgs = {
    events: Array<GQEventInput>;
};

export type GQMutationFiskalyAdvanceTssStateArgs = {
    adminPuk?: InputMaybe<Scalars["String"]>;
    pinCode?: InputMaybe<Scalars["String"]>;
    tssState: GQTssStateEnum;
};

export type GQMutationFiskalyChangePinForTssArgs = {
    adminPuk: Scalars["String"];
    integrationId: Scalars["ID"];
    pinCode: Scalars["String"];
};

export type GQMutationFiskalyClientSyncArgs = {
    id: Scalars["ID"];
    pin: Scalars["String"];
};

export type GQMutationFiskalyGoLiveArgs = {
    integrationId: Scalars["ID"];
};

export type GQMutationFiskalyOrganizationGoLiveArgs = {
    integrationId: Scalars["ID"];
};

export type GQMutationFiskalyOrganizationUpsertArgs = {
    managedOrganization: GQFiskalyOrganizationInput;
};

export type GQMutationIntegrationCmpProductSettingsSaveArgs = {
    integrationId: Scalars["ID"];
    settings: GQCmpProductSettingsInput;
};

export type GQMutationIntegrationCreateArgs = {
    integration: GQIntegrationCreate;
};

export type GQMutationIntegrationDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationIntegrationEconomicSettingsSaveArgs = {
    integrationId: Scalars["ID"];
    settings: GQEconomicSettingsInput;
};

export type GQMutationIntegrationFiskalySettingsSaveArgs = {
    integrationId: Scalars["ID"];
    settings: GQFiskalySettingsInput;
};

export type GQMutationIntegrationSaveArgs = {
    id: Scalars["ID"];
    integration: GQIntegrationInput;
};

export type GQMutationInventoryProductNoteTemplateCreateArgs = {
    inventoryProductNoteTemplate: GQInventoryProductNoteTemplateCreate;
};

export type GQMutationInventoryProductNoteTemplateDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationInventoryProductNoteTemplateSaveArgs = {
    id: Scalars["ID"];
    inventoryProductNoteTemplate: GQInventoryProductNoteTemplateInput;
};

export type GQMutationInventoryProductUpdateArgs = {
    id: Scalars["ID"];
    inventoryProduct: GQInventoryProductInput;
};

export type GQMutationLayoutCopyArgs = {
    id: Scalars["ID"];
    newTitle: Scalars["String"];
};

export type GQMutationLayoutCreateArgs = {
    layout: GQLayoutCreate;
};

export type GQMutationLayoutDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationLayoutEntityCreateArgs = {
    layoutEntity: GQLayoutEntityCreate;
};

export type GQMutationLayoutEntityDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationLayoutEntitySaveArgs = {
    id: Scalars["ID"];
    layoutEntity: GQLayoutEntitySave;
};

export type GQMutationLayoutSaveArgs = {
    id: Scalars["ID"];
    layout: GQLayoutSave;
};

export type GQMutationLogoDeleteArgs = {
    merchantId: Scalars["ID"];
    type?: InputMaybe<GQLogoType>;
};

export type GQMutationLogoSaveArgs = {
    logo: GQLogoInput;
};

export type GQMutationMerchantCreateArgs = {
    merchant: GQMerchantCreate;
};

export type GQMutationMerchantDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationMerchantSaveArgs = {
    id: Scalars["ID"];
    merchant: GQMerchantInput;
};

export type GQMutationMiscButtonsCreateArgs = {
    miscButtons: GQMiscButtonsInput;
};

export type GQMutationMiscButtonsDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationMiscButtonsSaveArgs = {
    id: Scalars["ID"];
    miscButtons: GQMiscButtonsInput;
};

export type GQMutationPasswordResetRequestArgs = {
    email: Scalars["String"];
};

export type GQMutationPasswordResetTokenDeleteArgs = {
    token: Scalars["String"];
};

export type GQMutationPasswordResetTokenUpdatePasswordArgs = {
    password: Scalars["String"];
    token: Scalars["String"];
};

export type GQMutationPaymentConfigurationCreateArgs = {
    paymentConfiguration: GQPaymentConfigurationInput;
};

export type GQMutationPaymentConfigurationDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationPaymentConfigurationSaveArgs = {
    id: Scalars["ID"];
    paymentConfiguration: GQPaymentConfigurationInput;
};

export type GQMutationPaymentMethodCreateArgs = {
    paymentMethod: GQPaymentMethodInput;
};

export type GQMutationPaymentMethodDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationPaymentMethodSaveArgs = {
    id: Scalars["ID"];
    paymentMethod: GQPaymentMethodInput;
};

export type GQMutationPrinterDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationPrinterRegisterArgs = {
    printer: GQPrinterRegister;
};

export type GQMutationPrinterSaveArgs = {
    id: Scalars["ID"];
    printer: GQPrinterSave;
};

export type GQMutationProductCreateArgs = {
    product: GQProductInput;
};

export type GQMutationProductDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationProductGroupCreateArgs = {
    productGroup: GQProductGroupInput;
};

export type GQMutationProductGroupDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationProductGroupSaveArgs = {
    id: Scalars["ID"];
    productGroup: GQProductGroupInput;
};

export type GQMutationProductSaveArgs = {
    id: Scalars["ID"];
    product: GQProductInput;
};

export type GQMutationProductsDeleteArgs = {
    ids: Array<Scalars["ID"]>;
};

export type GQMutationRebuildSaftJobsArgs = {
    shiftIds: Array<Scalars["ID"]>;
};

export type GQMutationReleaseTerminalArgs = {
    acquirer: GQSoftpayAcquirer;
    merchantId: Scalars["String"];
    storeId: Scalars["String"];
    terminalId: Scalars["String"];
};

export type GQMutationRequestFiskalyDsFinVkExportArgs = {
    exportInput: GQFiskalyDsFinVkExportInput;
};

export type GQMutationRequestFiskalyEstablishmentSubmissionArgs = {
    establishmentId: Scalars["ID"];
};

export type GQMutationRequestFiskalyEstablishmentSubmissionDownloadArgs = {
    submissionId: Scalars["ID"];
};

export type GQMutationRequestFiskalyEstablishmentSubmissionPreviewDownloadArgs =
    {
        submissionId: Scalars["ID"];
    };

export type GQMutationRequestFiskalyEstablishmentSubmissionTransmissionArgs = {
    submissionId: Scalars["ID"];
};

export type GQMutationRoleCreateArgs = {
    role: GQRoleInput;
};

export type GQMutationRoleDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationRoleSaveArgs = {
    id: Scalars["ID"];
    role: GQRoleInput;
};

export type GQMutationSaveAccountChartByProductGroupArgs = {
    integrationId: Scalars["ID"];
    productGroupMap: Array<GQChartAccountInput>;
};

export type GQMutationSaveAccountForProductGroupArgs = {
    integrationId: Scalars["ID"];
    productGroupMap: GQChartAccountInput;
};

export type GQMutationSaveFiskalyEstablishmentArgs = {
    establishment: GQFiskalyEstablishmentInput;
    establishmentId?: InputMaybe<Scalars["ID"]>;
};

export type GQMutationSaveFiskalyEstablishmentMappingArgs = {
    establishmentMapping: Array<GQFiskalyEstablishmentMappingInput>;
    integrationId: Scalars["ID"];
};

export type GQMutationSaveMerchantChartOfAccountsArgs = {
    chartOfAccounts: Array<GQMerchantChartOfAccountInput>;
    integrationId: Scalars["ID"];
};

export type GQMutationSetDepartment2WarehouseArgs = {
    departmentId: Scalars["ID"];
    warehouseId?: InputMaybe<Scalars["ID"]>;
};

export type GQMutationSetFiskalyClientStateArgs = {
    clientState?: InputMaybe<GQClientStateEnum>;
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    pin: Scalars["String"];
};

export type GQMutationSetInventoryProductQuantityArgs = {
    id?: InputMaybe<Scalars["ID"]>;
    note?: InputMaybe<Scalars["String"]>;
    productId: Scalars["ID"];
    quantity: Scalars["Int"];
};

export type GQMutationSetProduct2ViProduct2MeasurementUnitArgs = {
    productId: Scalars["ID"];
    relations: Array<GQProduct2ViProduct2MeasurementUnitInput>;
};

export type GQMutationTagCreateArgs = {
    tag: GQTagInput;
};

export type GQMutationTagDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationTagGroupCreateArgs = {
    tagGroup: GQTagGroupInput;
};

export type GQMutationTagGroupDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationTagGroupSaveArgs = {
    id: Scalars["ID"];
    tagGroup: GQTagGroupInput;
};

export type GQMutationTagSaveArgs = {
    id: Scalars["ID"];
    tag: GQTagInput;
};

export type GQMutationUpsertFiskalyTaxPayerLegalArgs = {
    taxPayerData: GQFiskalyTaxPayerLegalInput;
};

export type GQMutationUpsertFiskalyTaxPayerNaturalArgs = {
    taxPayerData: GQFiskalyTaxPayerNaturalInput;
};

export type GQMutationUserCreateArgs = {
    user: GQUserInput;
};

export type GQMutationUserDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationUserRoleConfigurationSaveArgs = {
    configuration: Scalars["JSON"];
    merchantId?: InputMaybe<Scalars["ID"]>;
    roleId: Scalars["ID"];
    type: Scalars["String"];
    userId: Scalars["ID"];
};

export type GQMutationUserSaveArgs = {
    id: Scalars["ID"];
    user: GQUserInput;
};

export type GQMutationUserUpdatePasswordArgs = {
    id: Scalars["ID"];
    password: Scalars["String"];
};

export type GQMutationVatCreateArgs = {
    vat: GQVatCreateInput;
};

export type GQMutationVatDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationVenueAccessCancelAccessTicketArgs = {
    ticketId: Scalars["Int"];
};

export type GQMutationVenueAccessCreateAccessTicketArgs = {
    accessTypes: Array<Scalars["Int"]>;
    eventId: Scalars["Int"];
    validFrom: Scalars["Date"];
    validTo: Scalars["Date"];
};

export type GQMutationVenueAccessCreateAccessTicketsArgs = {
    tickets?: InputMaybe<Array<GQVenueAccessCreateType>>;
};

export type GQMutationVirtualPrinterCreateArgs = {
    virtualPrinter: GQVirtualPrinterCreate;
};

export type GQMutationVirtualPrinterDeleteArgs = {
    id: Scalars["ID"];
};

export type GQMutationVirtualPrinterSaveArgs = {
    id: Scalars["ID"];
    virtualPrinter: GQVirtualPrinterSave;
};

export type GQNumberSearchInput = {
    value: Scalars["Float"];
};

export type GQPos = GQEntity & {
    __typename?: "POS";
    configuration?: Maybe<GQConfiguration>;
    department?: Maybe<GQDepartment>;
    device: GQDevice;
    firstActive?: Maybe<Scalars["Date"]>;
    firstLocation?: Maybe<GQGpsPoint>;
    firstUser?: Maybe<GQUser>;
    id: Scalars["ID"];
    lastActive?: Maybe<Scalars["Date"]>;
    lastLocation?: Maybe<GQGpsPoint>;
    lastUser?: Maybe<GQUser>;
    merchant?: Maybe<GQMerchant>;
    name?: Maybe<Scalars["String"]>;
    partner?: Maybe<GQPartner>;
    tags: Array<Scalars["String"]>;
};

export type GQPagination = {
    __typename?: "Pagination";
    page: Scalars["Int"];
    pageSize: Scalars["Int"];
    pages: Scalars["Int"];
    resultCount: Scalars["Int"];
    sort: Scalars["String"];
    sortDirection: Scalars["String"];
};

export type GQPaginationInput = {
    page?: InputMaybe<Scalars["Int"]>;
    pageSize?: InputMaybe<Scalars["Int"]>;
    sort?: InputMaybe<Scalars["String"]>;
    sortDirection?: InputMaybe<Scalars["String"]>;
};

export type GQPartner = GQEntity & {
    __typename?: "Partner";
    id: Scalars["ID"];
    name?: Maybe<Scalars["String"]>;
};

export type GQPartnerApiSettings = {
    __typename?: "PartnerApiSettings";
    foo: Scalars["String"];
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    type: Scalars["String"];
};

export type GQPaymentConfiguration = {
    __typename?: "PaymentConfiguration";
    createdAt: Scalars["String"];
    id: Scalars["ID"];
    name: Scalars["String"];
    paymentMethods: Array<GQPaymentConfigurationMethod>;
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQPaymentConfigurationDeleteResponse = {
    __typename?: "PaymentConfigurationDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQPaymentConfigurationInput = {
    name: Scalars["String"];
    paymentMethods: Array<GQPaymentConfigurationMethodInput>;
};

export type GQPaymentConfigurationMethod = {
    __typename?: "PaymentConfigurationMethod";
    askForAmount: Scalars["Boolean"];
    paymentMethod: GQPaymentMethod;
    showAsQuickButton: Scalars["Boolean"];
    showInPaymentWindow: Scalars["Boolean"];
};

export type GQPaymentConfigurationMethodInput = {
    askForAmount: Scalars["Boolean"];
    methodId: Scalars["String"];
    showAsQuickButton: Scalars["Boolean"];
    showInPaymentWindow: Scalars["Boolean"];
};

export type GQPaymentConfigurationPagination = GQIPagination & {
    __typename?: "PaymentConfigurationPagination";
    data: Array<GQPaymentConfiguration>;
    pagination: GQPagination;
};

export type GQPaymentMethod = {
    __typename?: "PaymentMethod";
    account: Scalars["String"];
    createdAt: Scalars["String"];
    currency: GQCurrency;
    diffAccount: Scalars["String"];
    enabled: Scalars["Boolean"];
    id: Scalars["ID"];
    name: Scalars["String"];
    paymentType: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQPaymentMethodDeleteResponse = {
    __typename?: "PaymentMethodDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQPaymentMethodInput = {
    account: Scalars["String"];
    currencyId: Scalars["String"];
    diffAccount: Scalars["String"];
    enabled: Scalars["Boolean"];
    name: Scalars["String"];
    paymentType: Scalars["String"];
};

export type GQPaymentMethodPagination = GQIPagination & {
    __typename?: "PaymentMethodPagination";
    data: Array<GQPaymentMethod>;
    pagination: GQPagination;
};

export type GQPercentSearchInput = {
    value: Scalars["Float"];
};

export enum GQPeriodCardRenewalStatus {
    Error = "ERROR",
    Successful = "SUCCESSFUL",
}

export enum GQPeriodCardUpgradeStatus {
    Error = "ERROR",
    Successful = "SUCCESSFUL",
}

export type GQPrinter = {
    __typename?: "Printer";
    cashRegister?: Maybe<GQCashRegister>;
    class: GQPrinterClass;
    createdAt: Scalars["Date"];
    id: Scalars["ID"];
    isVirtual?: Maybe<Scalars["Boolean"]>;
    manufacturer: GQPrinterManufacturer;
    merchant: GQMerchant;
    name: Scalars["String"];
    product: Array<GQProduct>;
    productGroup: Array<GQProductGroup>;
    serial: Scalars["String"];
    type: GQPrinterType;
    updatedAt?: Maybe<Scalars["Date"]>;
    virtualPrinter: Array<GQVirtualPrinter>;
};

export enum GQPrinterClass {
    Generic = "Generic",
    Ticket = "Ticket",
}

export type GQPrinterDeleteResponse = {
    __typename?: "PrinterDeleteResponse";
    status: GQDeleteResponseEnum;
};

export enum GQPrinterManufacturer {
    Boca = "Boca",
    Castles = "Castles",
    Epson = "Epson",
    Pax = "Pax",
    Sunmi = "Sunmi",
    Virtual = "Virtual",
}

export type GQPrinterPagination = GQIPagination & {
    __typename?: "PrinterPagination";
    data: Array<GQPrinter>;
    pagination: GQPagination;
};

export type GQPrinterRegister = {
    class?: InputMaybe<GQPrinterClass>;
    manufacturer: GQPrinterManufacturer;
    name: Scalars["String"];
    serial: Scalars["String"];
    type: GQPrinterType;
};

export type GQPrinterSave = {
    name: Scalars["String"];
};

export type GQPrinterSearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    manufacturer?: InputMaybe<GQTypeSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
    serial?: InputMaybe<GQStringSearchInput>;
    type?: InputMaybe<GQTypeSearchInput>;
};

export enum GQPrinterType {
    Bt = "BT",
    Internal = "INTERNAL",
    Ip = "IP",
    Mac = "MAC",
    Usb = "USB",
}

export type GQProduct = {
    __typename?: "Product";
    active: Scalars["Boolean"];
    amount: Scalars["Int"];
    barcode?: Maybe<Scalars["String"]>;
    barcodes: Array<GQProductBarcode>;
    buttonText?: Maybe<Scalars["String"]>;
    children: GQProductPagination;
    costAmount: Scalars["Int"];
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    discountTemplate?: Maybe<Array<GQDiscountTemplate>>;
    excludeFromDiscounts: Scalars["Boolean"];
    externalId?: Maybe<Scalars["String"]>;
    group: GQProductGroup;
    id: Scalars["ID"];
    inheritPrinter: Scalars["Boolean"];
    inventoryProduct?: Maybe<GQInventoryProduct>;
    isExternal: Scalars["Boolean"];
    minimumAmount: Scalars["Int"];
    name: Scalars["String"];
    onlineRequired: Scalars["Boolean"];
    ownExcludeFromDiscounts: Scalars["Boolean"];
    ownVat?: Maybe<GQVat>;
    parent?: Maybe<GQProduct>;
    plu?: Maybe<Scalars["Int"]>;
    printer?: Maybe<GQPrinter>;
    updatedAt?: Maybe<Scalars["Date"]>;
    vat: GQVat;
    viProductRelations?: Maybe<Array<GQProduct2ViProduct2MeasurementUnit>>;
};

export type GQProductChildrenArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQProduct2ViProduct2MeasurementUnit = {
    __typename?: "Product2ViProduct2MeasurementUnit";
    deletedAt?: Maybe<Scalars["Date"]>;
    measurementUnit: GQMeasurementUnit;
    value: Scalars["Int"];
    viProduct: GQViProduct;
};

export type GQProduct2ViProduct2MeasurementUnitInput = {
    measurementUnitId: Scalars["ID"];
    value: Scalars["Int"];
    viProductId: Scalars["ID"];
};

export type GQProductBarcode = {
    __typename?: "ProductBarcode";
    barcode: Scalars["String"];
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    updatedAt: Scalars["Date"];
};

export type GQProductBarcodeInput = {
    barcode: Scalars["String"];
    id?: InputMaybe<Scalars["ID"]>;
};

export type GQProductDeleteResponse = {
    __typename?: "ProductDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQProductGroup = {
    __typename?: "ProductGroup";
    color: Scalars["String"];
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    excludeFromDiscounts: Scalars["Boolean"];
    externalId?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    isExternal: Scalars["Boolean"];
    name: Scalars["String"];
    printer?: Maybe<GQPrinter>;
    updatedAt?: Maybe<Scalars["Date"]>;
    vat: GQVat;
};

export type GQProductGroupDeleteResponse = {
    __typename?: "ProductGroupDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQProductGroupInput = {
    color: Scalars["String"];
    excludeFromDiscounts: Scalars["Boolean"];
    externalId?: InputMaybe<Scalars["String"]>;
    isExternal: Scalars["Boolean"];
    name: Scalars["String"];
    printerId?: InputMaybe<Scalars["ID"]>;
    vatId: Scalars["ID"];
};

export type GQProductGroupPagination = GQIPagination & {
    __typename?: "ProductGroupPagination";
    data: Array<GQProductGroup>;
    pagination: GQPagination;
};

export type GQProductGroupSearchInput = {
    color?: InputMaybe<GQStringSearchInput>;
    createdAt?: InputMaybe<GQDateSearchInput>;
    eid?: InputMaybe<GQStringSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type GQProductInput = {
    active: Scalars["Boolean"];
    amount: Scalars["Int"];
    barcode?: InputMaybe<Scalars["String"]>;
    barcodes: Array<GQProductBarcodeInput>;
    buttonText?: InputMaybe<Scalars["String"]>;
    costAmount: Scalars["Int"];
    discountTemplate?: InputMaybe<Array<GQDiscountTemplateInput>>;
    externalId?: InputMaybe<Scalars["String"]>;
    groupId?: InputMaybe<Scalars["ID"]>;
    inheritPrinter: Scalars["Boolean"];
    isExternal: Scalars["Boolean"];
    minimumAmount: Scalars["Int"];
    name: Scalars["String"];
    onlineRequired: Scalars["Boolean"];
    ownExcludeFromDiscounts: Scalars["Boolean"];
    ownVatId?: InputMaybe<Scalars["ID"]>;
    parentId?: InputMaybe<Scalars["ID"]>;
    plu?: InputMaybe<Scalars["Int"]>;
    printerId?: InputMaybe<Scalars["ID"]>;
};

export type GQProductPagination = GQIPagination & {
    __typename?: "ProductPagination";
    data: Array<GQProduct>;
    pagination: GQPagination;
};

export type GQProductRelationInput = {
    productId: Scalars["String"];
};

export type GQProductSearchInput = {
    amount?: InputMaybe<GQAmountSearchInput>;
    barcode?: InputMaybe<GQStringSearchInput>;
    eid?: InputMaybe<GQStringSearchInput>;
    group?: InputMaybe<GQStringSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
    plu?: InputMaybe<GQNumberSearchInput>;
};

export type GQQuery = {
    __typename?: "Query";
    accessToken: GQSumUpAccessTokenResponse;
    account: GQAccount;
    accountChartByProductGroup: GQChartAccounts;
    accountForProductGroup?: Maybe<GQChartAccount>;
    accounts: GQAccountPagination;
    accountsByCustomerSearch: GQAccountPagination;
    actionsForTag: GQTagActionPagination;
    adyenSessions: GQAdyenSessionsResponse;
    adyenStores: GQAdyenStoresPagination;
    adyenTerminals: GQAdyenTerminalsPagination;
    adyenTerminalsForEntityConfig: GQAdyenTerminalsResponse;
    allMiscButtons: GQMiscButtonsPagination;
    approval?: Maybe<GQApproval>;
    approvalToken?: Maybe<GQApprovalToken>;
    approvalTokenGroup?: Maybe<GQApprovalTokenGroup>;
    approvalTokenGroups: GQApprovalTokenGroupPagination;
    approvalTokens: GQApprovalTokenPagination;
    approvals: GQApprovalPagination;
    authDevicePoll?: Maybe<GQAuthToken>;
    authRefresh?: Maybe<GQAuthToken>;
    bookkeepingAccount: GQBookkeepingAccount;
    bookkeepingAccounts: GQAccountBookkeepingPagination;
    bookkeepingTransactions: GQAccountBookkeepingTransactionPagination;
    canPeriodCardBeRenewed: GQCanPeriodCardBeRenewedResponse;
    canPeriodCardBeUpgraded: GQCanPeriodCardBeUpgradedResponse;
    cardTransaction: GQCardTransaction;
    cardTransactions: GQCardTransactionPagination;
    cashRegister?: Maybe<GQCashRegister>;
    cashRegisters: GQCashRegisterPagination;
    cashRegistersStatus: GQCashRegisterStatusPagination;
    cmpEvent?: Maybe<GQCmpEvent>;
    cmpEventByExternalId?: Maybe<GQCmpEventNoProducts>;
    cmpEventProduct?: Maybe<GQCmpEventProduct>;
    cmpEventProducts: GQCmpEventProductPagination;
    cmpEvents: GQCmpEventPagination;
    cmpGiftcardBalance: GQCmpGiftcardBalance;
    cmpInvoiceCustomerSearch: GQCmpInvoiceCustomerResponse;
    cmpProduct?: Maybe<GQCmpProduct>;
    cmpProducts: GQCmpProductPagination;
    currencies: GQCurrencyPagination;
    currency?: Maybe<GQCurrency>;
    customer: GQCustomer;
    customerAccounts: GQAccountPagination;
    customerGroup: GQCustomerGroup;
    customerGroups: GQCustomerGroupPagination;
    customers: GQCustomerPagination;
    customersInGroup: GQCustomerPagination;
    dashboard?: Maybe<GQDashboard>;
    dashboardCashRegisterStats: Array<GQCashRegisterVersion>;
    dashboardCashRegisters: GQDashboardCashRegisterPagination;
    dashboardInvoiceAmountPerMonthStats?: Maybe<Array<GQInvoiceAmountPerMonth>>;
    dashboardInvoiceAmountStats?: Maybe<Array<GQInvoiceAmount>>;
    department?: Maybe<GQDepartment>;
    departments: GQDepartmentPagination;
    device?: Maybe<GQDevice>;
    deviceByPinCode?: Maybe<GQDevice>;
    devices: GQDevicePagination;
    discount?: Maybe<GQDiscount>;
    discounts: GQDiscountPagination;
    economicSyncJobs: GQEconomicSyncJobPagination;
    entityConfig: GQEntityConfig;
    entityConfigs: Array<Maybe<GQEntityConfig>>;
    eventStoreSyncGet: Array<GQEvent>;
    eventStoreSyncLatestSequence: Scalars["Int"];
    fiskalyAccessToken: GQFiskalyAccessTokenResponse;
    fiskalyClient?: Maybe<GQFiskalyClient>;
    fiskalyClientByCashRegisterId?: Maybe<GQFiskalyClient>;
    fiskalyClients: GQFiskalyClientList;
    fiskalyDSFinVKExport: GQFiskalyDsFinVkExport;
    fiskalyDSFinVKExports: GQFiskalyDsFinVkExportList;
    fiskalyEstablishmentMapping: GQFiskalyEstablishmentMappingList;
    fiskalyEstablishmentSubmissions: GQFiskalyEstablishmentSubmissionList;
    fiskalyEstablishments: GQFiskalyEstablishmentList;
    fiskalyOrganization: GQFiskalyOrganization;
    fiskalyOrganizations: GQFiskalyOrganizations;
    fiskalyRefreshToken: GQFiskalyAccessTokenResponse;
    fiskalyRemoteCashRegisters: GQFiskalyRemoteCashRegisterList;
    fiskalyRemoteClients: GQFiskalyRemoteClientList;
    fiskalyRemoteEstablishmentSubmissions: GQFiskalyRemoteEstablishmentSubmissionList;
    fiskalyTss: GQFiskalyTss;
    fiskalyTssList: GQFiskalyTssList;
    getFiskalyDSFinVKExportDownload: GQFile;
    getFiskalyTaxPayer?: Maybe<GQFiskalyTaxPayer>;
    getProduct2ViProduct2MeasurementUnit: Array<GQProduct2ViProduct2MeasurementUnit>;
    giftCards: GQAccountPagination;
    integration?: Maybe<GQIntegration>;
    integrationSettings?: Maybe<GQIntegrationSettings>;
    integrations: GQIntegrationPagination;
    integrationsOfType: GQIntegrationArray;
    inventoryForIds: Array<GQInventoryProduct>;
    inventoryProduct?: Maybe<GQInventoryProduct>;
    inventoryProductNoteTemplate?: Maybe<GQInventoryProductNoteTemplate>;
    inventoryProductNoteTemplates: GQInventoryProductNoteTemplatePagination;
    inventoryProducts: GQInventoryProductPagination;
    invoice?: Maybe<GQInvoiceRm>;
    invoiceCount: Array<Maybe<GQInvoiceCount>>;
    invoices: GQInvoiceRmPagination;
    invoicesInPeriod: GQInvoiceRmPagination;
    isAccountNameInUse: GQBooleanResponse;
    isProductPluInUse: GQBooleanResponse;
    latestTaskResults: GQTaskResultPagination;
    layout?: Maybe<GQLayout>;
    layoutEntities: GQLayoutEntityPagination;
    layoutEntity?: Maybe<GQLayoutEntity>;
    logo?: Maybe<GQLogo>;
    logs: GQLogPagination;
    me: GQMe;
    merchant?: Maybe<GQMerchant>;
    merchantAccountNo: GQChartOfAccountNo;
    merchantChartOfAccounts: GQMerchantChartOfAccounts;
    merchants: GQMerchantPagination;
    miscButtons?: Maybe<GQMiscButtons>;
    passwordResetTokenRedeem?: Maybe<GQBooleanResponse>;
    paymentConfiguration: GQPaymentConfiguration;
    paymentConfigurations: GQPaymentConfigurationPagination;
    paymentMethod: GQPaymentMethod;
    paymentMethods: GQPaymentMethodPagination;
    printer: GQPrinter;
    printers: GQPrinterPagination;
    printersForCashRegister: GQPrinterPagination;
    product?: Maybe<GQProduct>;
    productGroup?: Maybe<GQProductGroup>;
    productGroups: GQProductGroupPagination;
    productLayouts: GQLayoutPagination;
    products: GQProductPagination;
    reportParameters: GQReportParameters;
    role?: Maybe<GQRole>;
    roles: GQRolePagination;
    saftJobs: GQSaftJobPagination;
    shift?: Maybe<GQShiftRm>;
    shifts: GQShiftRmPagination;
    shiftsByCashRegister: GQShiftRmPagination;
    shiftsByOpenedByUser: GQShiftRmPagination;
    shiftsInPeriod: GQShiftRmPagination;
    softpayAccessToken: GQSoftpayAccessTokenResponse;
    softpayCloudTerminals: GQSoftpayCloudTerminalsPagination;
    softpayMerchants: GQSoftpayMerchantsPagination;
    softpayMiaMerchant: GQSoftpayMiaMerchant;
    softpayMiaMerchants: GQSoftpayMiaMerchantsPagination;
    softpayMiaStore: GQSoftpayMiaStore;
    softpayMiaTerminal: GQSoftpayMiaTerminal;
    tableLayouts: GQLayoutPagination;
    tag: GQTag;
    tagGroup: GQTagGroup;
    tagGroups: GQTagGroupPagination;
    tags: GQTagPagination;
    tagsByAccount: GQTagPagination;
    tagsByCustomer: GQTagPagination;
    tagsByGroup: GQTagPagination;
    tagsWithoutAccount: GQTagPagination;
    tagsWithoutCustomer: GQTagPagination;
    taskResult: GQTaskResult;
    taskResults: GQTaskResultPagination;
    transactions: GQAccountTransactionPagination;
    user?: Maybe<GQUser>;
    userAvailability: Scalars["Boolean"];
    userRoleConfiguration?: Maybe<GQUserRoleConfiguration>;
    users: GQUserPagination;
    vat?: Maybe<GQVat>;
    vats: GQVatPagination;
    venueAccessTicketParameters: GQVenueAccessParameters;
    venueAccessTicketParametersBulk: GQVenueAccessParametersBulk;
    viProducts: GQViProductPagination;
    viWarehouseForDepartment: Array<GQViWarehouse>;
    viWarehouses: GQViWarehousePagination;
    virtualPrinter: GQVirtualPrinter;
    virtualPrinters: GQVirtualPrinterPagination;
};

export type GQQueryAccountArgs = {
    id: Scalars["ID"];
};

export type GQQueryAccountChartByProductGroupArgs = {
    integrationId: Scalars["ID"];
};

export type GQQueryAccountForProductGroupArgs = {
    integrationId: Scalars["ID"];
    productGroupId: Scalars["ID"];
};

export type GQQueryAccountsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQAccountSearchInput>;
};

export type GQQueryAccountsByCustomerSearchArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryActionsForTagArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    tagId: Scalars["ID"];
};

export type GQQueryAdyenStoresArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryAdyenTerminalsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryAdyenTerminalsForEntityConfigArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryAllMiscButtonsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryApprovalArgs = {
    id: Scalars["ID"];
};

export type GQQueryApprovalTokenArgs = {
    id: Scalars["ID"];
};

export type GQQueryApprovalTokenGroupArgs = {
    id: Scalars["ID"];
};

export type GQQueryApprovalTokenGroupsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQApprovalTokenGroupSearchInput>;
};

export type GQQueryApprovalTokensArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQApprovalTokenSearchInput>;
};

export type GQQueryApprovalsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQApprovalSearchInput>;
};

export type GQQueryAuthDevicePollArgs = {
    deviceId: Scalars["ID"];
    devicePinCode: Scalars["String"];
};

export type GQQueryAuthRefreshArgs = {
    refreshToken: Scalars["String"];
};

export type GQQueryBookkeepingAccountArgs = {
    id: Scalars["ID"];
};

export type GQQueryBookkeepingAccountsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryBookkeepingTransactionsArgs = {
    accountId?: InputMaybe<Scalars["String"]>;
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQAccountBookkeepingTransactionSearchInput>;
};

export type GQQueryCanPeriodCardBeRenewedArgs = {
    cardId?: InputMaybe<Scalars["String"]>;
    cardToken?: InputMaybe<Scalars["String"]>;
    productId: Scalars["String"];
};

export type GQQueryCanPeriodCardBeUpgradedArgs = {
    cardId?: InputMaybe<Scalars["String"]>;
    cardToken?: InputMaybe<Scalars["String"]>;
    productId: Scalars["String"];
};

export type GQQueryCardTransactionArgs = {
    id: Scalars["ID"];
};

export type GQQueryCardTransactionsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQCardTransactionSearchInput>;
};

export type GQQueryCashRegisterArgs = {
    id: Scalars["ID"];
};

export type GQQueryCashRegistersArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQCashRegisterSearchInput>;
};

export type GQQueryCashRegistersStatusArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQCashRegisterStatusSearchInput>;
};

export type GQQueryCmpEventArgs = {
    id: Scalars["ID"];
};

export type GQQueryCmpEventByExternalIdArgs = {
    externalId: Scalars["ID"];
};

export type GQQueryCmpEventProductArgs = {
    id: Scalars["ID"];
};

export type GQQueryCmpEventProductsArgs = {
    externalEventId: Scalars["String"];
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryCmpEventsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryCmpGiftcardBalanceArgs = {
    code: Scalars["String"];
};

export type GQQueryCmpInvoiceCustomerSearchArgs = {
    value: Scalars["String"];
};

export type GQQueryCmpProductArgs = {
    id: Scalars["ID"];
};

export type GQQueryCmpProductsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryCurrenciesArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryCurrencyArgs = {
    id: Scalars["ID"];
};

export type GQQueryCustomerArgs = {
    id: Scalars["ID"];
};

export type GQQueryCustomerAccountsArgs = {
    customerId?: InputMaybe<Scalars["ID"]>;
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryCustomerGroupArgs = {
    id: Scalars["ID"];
};

export type GQQueryCustomerGroupsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQCustomerGroupSearchInput>;
};

export type GQQueryCustomersArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQCustomerSearchInput>;
};

export type GQQueryCustomersInGroupArgs = {
    groupId: Scalars["ID"];
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryDashboardArgs = {
    departmentIds?: InputMaybe<Array<Scalars["String"]>>;
    from: Scalars["Date"];
    to: Scalars["Date"];
};

export type GQQueryDashboardCashRegistersArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryDashboardInvoiceAmountStatsArgs = {
    from: Scalars["Date"];
    interval?: InputMaybe<Scalars["String"]>;
    to: Scalars["Date"];
};

export type GQQueryDepartmentArgs = {
    id: Scalars["ID"];
};

export type GQQueryDepartmentsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQDepartmentSearchInput>;
};

export type GQQueryDeviceArgs = {
    id: Scalars["String"];
};

export type GQQueryDeviceByPinCodeArgs = {
    pinCode: Scalars["String"];
};

export type GQQueryDevicesArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryDiscountArgs = {
    id: Scalars["ID"];
};

export type GQQueryDiscountsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQDiscountSearchInput>;
};

export type GQQueryEconomicSyncJobsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryEntityConfigArgs = {
    entityId: Scalars["ID"];
};

export type GQQueryEntityConfigsArgs = {
    entityIds: Array<Scalars["ID"]>;
};

export type GQQueryEventStoreSyncGetArgs = {
    query: GQEventQueryInput;
};

export type GQQueryEventStoreSyncLatestSequenceArgs = {
    returnSyncFrom?: InputMaybe<Scalars["Boolean"]>;
};

export type GQQueryFiskalyClientArgs = {
    id: Scalars["ID"];
};

export type GQQueryFiskalyClientByCashRegisterIdArgs = {
    cashRegisterId: Scalars["ID"];
};

export type GQQueryFiskalyDsFinVkExportArgs = {
    id: Scalars["ID"];
};

export type GQQueryFiskalyEstablishmentMappingArgs = {
    integrationId: Scalars["ID"];
};

export type GQQueryFiskalyEstablishmentSubmissionsArgs = {
    pagination?: InputMaybe<GQCursorPaginationInput>;
};

export type GQQueryFiskalyEstablishmentsArgs = {
    integrationId: Scalars["ID"];
};

export type GQQueryFiskalyOrganizationArgs = {
    id: Scalars["ID"];
};

export type GQQueryFiskalyRefreshTokenArgs = {
    refreshToken: Scalars["String"];
};

export type GQQueryFiskalyRemoteCashRegistersArgs = {
    integrationId: Scalars["ID"];
};

export type GQQueryFiskalyRemoteClientsArgs = {
    integrationId: Scalars["ID"];
};

export type GQQueryFiskalyRemoteEstablishmentSubmissionsArgs = {
    integrationId: Scalars["ID"];
};

export type GQQueryFiskalyTssArgs = {
    id: Scalars["ID"];
};

export type GQQueryFiskalyTssListArgs = {
    integrationId: Scalars["ID"];
};

export type GQQueryGetFiskalyDsFinVkExportDownloadArgs = {
    id: Scalars["ID"];
};

export type GQQueryGetProduct2ViProduct2MeasurementUnitArgs = {
    productId: Scalars["ID"];
};

export type GQQueryGiftCardsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQAccountSearchInput>;
    status?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type GQQueryIntegrationArgs = {
    id: Scalars["ID"];
};

export type GQQueryIntegrationSettingsArgs = {
    integrationId: Scalars["ID"];
};

export type GQQueryIntegrationsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryIntegrationsOfTypeArgs = {
    type: Scalars["String"];
};

export type GQQueryInventoryForIdsArgs = {
    ids: Array<Scalars["ID"]>;
};

export type GQQueryInventoryProductArgs = {
    id: Scalars["ID"];
};

export type GQQueryInventoryProductNoteTemplateArgs = {
    id: Scalars["ID"];
};

export type GQQueryInventoryProductNoteTemplatesArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryInventoryProductsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryInvoiceArgs = {
    id: Scalars["ID"];
};

export type GQQueryInvoiceCountArgs = {
    from: Scalars["Date"];
    to: Scalars["Date"];
};

export type GQQueryInvoicesArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQInvoiceSearchInput>;
};

export type GQQueryInvoicesInPeriodArgs = {
    from: Scalars["Date"];
    pagination?: InputMaybe<GQPaginationInput>;
    to: Scalars["Date"];
};

export type GQQueryIsAccountNameInUseArgs = {
    accountId?: InputMaybe<Scalars["ID"]>;
    customerId?: InputMaybe<Scalars["ID"]>;
    name?: InputMaybe<Scalars["String"]>;
};

export type GQQueryIsProductPluInUseArgs = {
    plu: Scalars["Int"];
    productId?: InputMaybe<Scalars["ID"]>;
};

export type GQQueryLatestTaskResultsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryLayoutArgs = {
    id: Scalars["ID"];
};

export type GQQueryLayoutEntitiesArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQLayoutEntitySearchInput>;
};

export type GQQueryLayoutEntityArgs = {
    id: Scalars["ID"];
};

export type GQQueryLogoArgs = {
    type: GQLogoType;
};

export type GQQueryLogsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQLogSearchInput>;
};

export type GQQueryMerchantArgs = {
    id: Scalars["ID"];
};

export type GQQueryMerchantAccountNoArgs = {
    defaultAccountNo: Scalars["String"];
    integrationType: Scalars["String"];
    merchantId: Scalars["ID"];
};

export type GQQueryMerchantChartOfAccountsArgs = {
    integrationId: Scalars["ID"];
};

export type GQQueryMerchantsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQMerchantSearchInput>;
};

export type GQQueryMiscButtonsArgs = {
    id: Scalars["ID"];
};

export type GQQueryPasswordResetTokenRedeemArgs = {
    token: Scalars["String"];
};

export type GQQueryPaymentConfigurationArgs = {
    id: Scalars["ID"];
};

export type GQQueryPaymentConfigurationsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryPaymentMethodArgs = {
    id: Scalars["ID"];
};

export type GQQueryPaymentMethodsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryPrinterArgs = {
    id: Scalars["ID"];
};

export type GQQueryPrintersArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQPrinterSearchInput>;
};

export type GQQueryPrintersForCashRegisterArgs = {
    class?: InputMaybe<Scalars["String"]>;
    entityId?: InputMaybe<Scalars["String"]>;
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryProductArgs = {
    id: Scalars["ID"];
};

export type GQQueryProductGroupArgs = {
    id: Scalars["ID"];
};

export type GQQueryProductGroupsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQProductGroupSearchInput>;
};

export type GQQueryProductLayoutsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQLayoutSearchInput>;
};

export type GQQueryProductsArgs = {
    includeChildren?: InputMaybe<Scalars["Boolean"]>;
    includeInactive?: InputMaybe<Scalars["Boolean"]>;
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQProductSearchInput>;
};

export type GQQueryRoleArgs = {
    id: Scalars["ID"];
};

export type GQQueryRolesArgs = {
    merchantId?: InputMaybe<Scalars["ID"]>;
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    userId?: InputMaybe<Scalars["ID"]>;
};

export type GQQuerySaftJobsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryShiftArgs = {
    id: Scalars["ID"];
};

export type GQQueryShiftsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQShiftSearchInput>;
};

export type GQQueryShiftsByCashRegisterArgs = {
    cashRegisterId: Scalars["String"];
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryShiftsByOpenedByUserArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    userId: Scalars["String"];
};

export type GQQueryShiftsInPeriodArgs = {
    from: Scalars["Date"];
    pagination?: InputMaybe<GQPaginationInput>;
    to: Scalars["Date"];
};

export type GQQuerySoftpayCloudTerminalsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQuerySoftpayMerchantsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQuerySoftpayMiaMerchantArgs = {
    acquirer: GQSoftpayAcquirer;
    merchantId: Scalars["String"];
};

export type GQQuerySoftpayMiaMerchantsArgs = {
    acquirer: GQSoftpayAcquirer;
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQuerySoftpayMiaStoreArgs = {
    acquirer: GQSoftpayAcquirer;
    merchantId: Scalars["String"];
    storeId: Scalars["String"];
};

export type GQQuerySoftpayMiaTerminalArgs = {
    acquirer: GQSoftpayAcquirer;
    merchantId: Scalars["String"];
    storeId: Scalars["String"];
    terminalId: Scalars["String"];
};

export type GQQueryTableLayoutsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQLayoutSearchInput>;
};

export type GQQueryTagArgs = {
    id: Scalars["ID"];
};

export type GQQueryTagGroupArgs = {
    id: Scalars["ID"];
};

export type GQQueryTagGroupsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQTagGroupSearchInput>;
};

export type GQQueryTagsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQTagSearchInput>;
    tagIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type GQQueryTagsByAccountArgs = {
    accountId: Scalars["ID"];
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryTagsByCustomerArgs = {
    customerId: Scalars["ID"];
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryTagsByGroupArgs = {
    groupId: Scalars["ID"];
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryTagsWithoutAccountArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryTagsWithoutCustomerArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
};

export type GQQueryTaskResultArgs = {
    id: Scalars["ID"];
};

export type GQQueryTaskResultsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    type: Scalars["String"];
};

export type GQQueryTransactionsArgs = {
    accountId?: InputMaybe<Scalars["String"]>;
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQAccountTransactionSearchInput>;
};

export type GQQueryUserArgs = {
    id: Scalars["ID"];
};

export type GQQueryUserAvailabilityArgs = {
    username: Scalars["String"];
};

export type GQQueryUserRoleConfigurationArgs = {
    merchantId?: InputMaybe<Scalars["ID"]>;
    roleId: Scalars["ID"];
    type: Scalars["String"];
    userId: Scalars["ID"];
};

export type GQQueryUsersArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQUserSearchInput>;
};

export type GQQueryVatArgs = {
    id: Scalars["ID"];
};

export type GQQueryVatsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryVenueAccessTicketParametersArgs = {
    eventId?: InputMaybe<Scalars["Int"]>;
};

export type GQQueryVenueAccessTicketParametersBulkArgs = {
    eventIds: Array<Scalars["Int"]>;
};

export type GQQueryViProductsArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryViWarehouseForDepartmentArgs = {
    departmentId: Scalars["ID"];
};

export type GQQueryViWarehousesArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQQueryVirtualPrinterArgs = {
    id: Scalars["ID"];
};

export type GQQueryVirtualPrintersArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQPrinterSearchInput>;
};

export type GQRemoteEstablishmentSubmission = {
    __typename?: "RemoteEstablishmentSubmission";
    createdAt: Scalars["Date"];
    error?: Maybe<Scalars["String"]>;
    establishmentId: Scalars["ID"];
    id: Scalars["ID"];
    state: Scalars["String"];
    transmittedAt?: Maybe<Scalars["Date"]>;
};

export type GQReportCashRegister = {
    __typename?: "ReportCashRegister";
    id: Scalars["ID"];
    name: Scalars["String"];
};

export type GQReportDepartment = {
    __typename?: "ReportDepartment";
    id: Scalars["ID"];
    name: Scalars["String"];
};

export type GQReportParameters = {
    __typename?: "ReportParameters";
    cashRegisters: Array<GQReportCashRegister>;
    departments: Array<GQReportDepartment>;
    productGroups: Array<GQReportProductGroup>;
    products: Array<GQReportProduct>;
    users: Array<GQReportUser>;
};

export type GQReportProduct = {
    __typename?: "ReportProduct";
    id: Scalars["ID"];
    name: Scalars["String"];
};

export type GQReportProductGroup = {
    __typename?: "ReportProductGroup";
    id: Scalars["ID"];
    name: Scalars["String"];
};

export type GQReportUser = {
    __typename?: "ReportUser";
    firstName: Scalars["String"];
    id: Scalars["ID"];
    lastName: Scalars["String"];
    username: Scalars["String"];
};

export type GQRole = {
    __typename?: "Role";
    id: Scalars["ID"];
    inUse: Scalars["Boolean"];
    merchant?: Maybe<GQMerchant>;
    name: Scalars["String"];
    permissions: Array<GQRolePermission>;
    shared: Scalars["Boolean"];
    type: GQRoleTypeEnum;
};

export type GQRoleDeleteResponse = {
    __typename?: "RoleDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQRoleInput = {
    name: Scalars["String"];
    permissions: Array<GQRolePermissionInput>;
    shared: Scalars["Boolean"];
    type: GQRoleTypeEnum;
};

export type GQRolePagination = GQIPagination & {
    __typename?: "RolePagination";
    data: Array<GQRole>;
    pagination: GQPagination;
};

export type GQRolePermission = {
    __typename?: "RolePermission";
    key: Scalars["String"];
    role: GQRole;
    value: Scalars["String"];
};

export type GQRolePermissionInput = {
    key: Scalars["String"];
    value: Scalars["String"];
};

export enum GQRoleTypeEnum {
    Admin = "ADMIN",
    Merchant = "MERCHANT",
    Reseller = "RESELLER",
}

export type GQSaftJob = {
    __typename?: "SaftJob";
    attempts: Scalars["Int"];
    createdAt: Scalars["Date"];
    id: Scalars["Int"];
    lastError?: Maybe<Scalars["String"]>;
    runAt: Scalars["Date"];
    shift?: Maybe<GQShiftRm>;
    shiftId?: Maybe<Scalars["String"]>;
};

export type GQSaftJobPagination = GQIPagination & {
    __typename?: "SaftJobPagination";
    data: Array<GQSaftJob>;
    pagination: GQPagination;
};

export type GQSearchInput = {
    query: Scalars["String"];
};

export type GQSelectUserRoleType = {
    __typename?: "SelectUserRoleType";
    token: GQAuthToken;
    userRole: GQUserRole;
};

export type GQShiftFundsRm = {
    __typename?: "ShiftFundsRM";
    amount: Scalars["Float"];
    createdAt: Scalars["Date"];
    name?: Maybe<Scalars["String"]>;
    type: Scalars["String"];
};

export type GQShiftPaymentCardRm = {
    __typename?: "ShiftPaymentCardRM";
    amount: Scalars["Float"];
    count: Scalars["Float"];
    name: Scalars["String"];
    paymentProvider: Scalars["String"];
};

export type GQShiftPaymentRm = {
    __typename?: "ShiftPaymentRM";
    amount: Scalars["Float"];
    cardSchemas?: Maybe<Array<GQShiftPaymentCardRm>>;
    currency?: Maybe<Scalars["String"]>;
    currencyRate?: Maybe<Scalars["Float"]>;
    event: GQShiftPaymentRmEvent;
    id: Scalars["ID"];
    name: Scalars["String"];
    paymentMethodId?: Maybe<Scalars["String"]>;
    type: Scalars["String"];
};

export enum GQShiftPaymentRmEvent {
    Close = "CLOSE",
    Open = "OPEN",
}

export type GQShiftRm = {
    __typename?: "ShiftRM";
    amount: Scalars["Float"];
    cashDifference: Scalars["Float"];
    cashInfoPerMethod?: Maybe<GQCashInfoPerMethod>;
    cashRegister: GQCashRegister;
    cashRegisterName?: Maybe<Scalars["String"]>;
    closedAt?: Maybe<Scalars["Date"]>;
    closedByUser?: Maybe<GQUser>;
    discount: Scalars["Float"];
    funds?: Maybe<Array<GQShiftFundsRm>>;
    id: Scalars["ID"];
    invoices: GQInvoiceRmPagination;
    merchant: GQMerchant;
    numCashDrawerOpen: Scalars["Float"];
    openedAt: Scalars["Date"];
    openedByUser: GQUser;
    openingAmount?: Maybe<Scalars["Float"]>;
    payments?: Maybe<Array<GQShiftPaymentRm>>;
    salesData?: Maybe<GQShiftSalesData>;
    shiftNumber?: Maybe<Scalars["Int"]>;
    syncDetails?: Maybe<Scalars["String"]>;
    syncStatus?: Maybe<Scalars["String"]>;
    syncedAt?: Maybe<Scalars["Date"]>;
    xReport?: Maybe<Scalars["String"]>;
    zReport?: Maybe<Scalars["String"]>;
};

export type GQShiftRmInvoicesArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
};

export type GQShiftRmPagination = GQIPagination & {
    __typename?: "ShiftRMPagination";
    data: Array<GQShiftRm>;
    pagination: GQPagination;
};

export type GQShiftSalesData = {
    __typename?: "ShiftSalesData";
    byProductGroup?: Maybe<Array<GQShiftSalesDataByProductGroup>>;
    hourSales?: Maybe<Array<GQInvoiceHourSales>>;
};

export type GQShiftSalesDataByProductGroup = {
    __typename?: "ShiftSalesDataByProductGroup";
    amount: Scalars["Float"];
    name: Scalars["String"];
};

export type GQShiftSearchInput = {
    amount?: InputMaybe<GQAmountSearchInput>;
    cashRegisterName?: InputMaybe<GQStringSearchInput>;
    closedAt?: InputMaybe<GQDateSearchInput>;
    department?: InputMaybe<GQStringSearchInput>;
    openedAt?: InputMaybe<GQDateSearchInput>;
    shiftNumber?: InputMaybe<GQNumberSearchInput>;
};

export enum GQShouldPrintType {
    Always = "ALWAYS",
    Never = "NEVER",
    NextDay = "NEXT_DAY",
}

export type GQSoftpayAccessTokenResponse = {
    __typename?: "SoftpayAccessTokenResponse";
    accessToken: Scalars["String"];
    expiresIn: Scalars["Int"];
    tokenType: Scalars["String"];
};

export enum GQSoftpayAcquirer {
    Elavon = "ELAVON",
    Nets = "NETS",
}

export type GQSoftpayCloudStore = {
    __typename?: "SoftpayCloudStore";
    acquirerStoreId: Scalars["String"];
    address: Scalars["String"];
    businessRegistrationNumber: Scalars["String"];
    city: Scalars["String"];
    countryNumeric: Scalars["Int"];
    id: Scalars["Int"];
    name: Scalars["String"];
    phone: Scalars["String"];
    timeZoneId: Scalars["String"];
    zip: Scalars["String"];
};

export type GQSoftpayCloudTerminal = {
    __typename?: "SoftpayCloudTerminal";
    appId: Scalars["String"];
    lastOnline: Scalars["String"];
    name: Scalars["String"];
    store: GQSoftpayCloudStore;
};

export type GQSoftpayCloudTerminalsPagination = GQIPagination & {
    __typename?: "SoftpayCloudTerminalsPagination";
    data: Array<GQSoftpayCloudTerminal>;
    pagination: GQPagination;
};

export type GQSoftpayMerchant = {
    __typename?: "SoftpayMerchant";
    businessRegistrationNumber?: Maybe<Scalars["String"]>;
    merchantReference?: Maybe<Scalars["String"]>;
    name?: Maybe<Scalars["String"]>;
};

export type GQSoftpayMerchantsPagination = GQIPagination & {
    __typename?: "SoftpayMerchantsPagination";
    data: Array<GQSoftpayMerchant>;
    pagination: GQPagination;
};

export type GQSoftpayMiaAdditionalData = {
    __typename?: "SoftpayMiaAdditionalData";
    key?: Maybe<Scalars["String"]>;
    value?: Maybe<Scalars["String"]>;
};

export type GQSoftpayMiaMerchant = {
    __typename?: "SoftpayMiaMerchant";
    aidGroup?: Maybe<Scalars["String"]>;
    businessRegNo: Scalars["String"];
    countryCode: Scalars["String"];
    localPrivileges: Array<Maybe<Scalars["String"]>>;
    merchantId: Scalars["String"];
    merchantName: Scalars["String"];
    merchantReference?: Maybe<Scalars["String"]>;
    primaryContactEmail: Scalars["String"];
    primaryContactPhone: Scalars["String"];
    remotePrivileges: Array<Maybe<Scalars["String"]>>;
    state: Scalars["String"];
    stores: Array<Maybe<GQSoftpayMiaStore>>;
};

export type GQSoftpayMiaMerchantStoresArgs = {
    acquirer: GQSoftpayAcquirer;
};

export type GQSoftpayMiaMerchantsPagination = GQIPagination & {
    __typename?: "SoftpayMiaMerchantsPagination";
    data: Array<GQSoftpayMiaMerchant>;
    pagination: GQPagination;
};

export type GQSoftpayMiaProcessorData = {
    __typename?: "SoftpayMiaProcessorData";
    cardSchema?: Maybe<Scalars["String"]>;
    processorMerchantId?: Maybe<Scalars["String"]>;
    processorName?: Maybe<Scalars["String"]>;
    processorTerminalId?: Maybe<Scalars["String"]>;
};

export type GQSoftpayMiaStore = {
    __typename?: "SoftpayMiaStore";
    additionalData?: Maybe<Array<GQSoftpayMiaAdditionalData>>;
    addressLine1: Scalars["String"];
    addressLine2?: Maybe<Scalars["String"]>;
    businessRegNo?: Maybe<Scalars["String"]>;
    cardAcceptorCountryCode: Scalars["String"];
    cardAcceptorNameLocation?: Maybe<Scalars["String"]>;
    city: Scalars["String"];
    name: Scalars["String"];
    onlineStoreId?: Maybe<Scalars["String"]>;
    phone?: Maybe<Scalars["String"]>;
    state: Scalars["String"];
    storeId: Scalars["String"];
    terminals: Array<Maybe<GQSoftpayMiaTerminal>>;
    timeZone?: Maybe<Scalars["String"]>;
    zipCode: Scalars["String"];
};

export type GQSoftpayMiaStoreTerminalsArgs = {
    acquirer: GQSoftpayAcquirer;
};

export type GQSoftpayMiaTerminal = {
    __typename?: "SoftpayMiaTerminal";
    additionalData?: Maybe<Array<GQSoftpayMiaAdditionalData>>;
    appId?: Maybe<Scalars["String"]>;
    defaultCurrencyCode: Scalars["String"];
    installed?: Maybe<Scalars["Boolean"]>;
    kernelDataId?: Maybe<Scalars["String"]>;
    lastOnline?: Maybe<Scalars["String"]>;
    merchantCategoryCode?: Maybe<Scalars["String"]>;
    onlineMerchantId?: Maybe<Scalars["String"]>;
    onlineTerminalId?: Maybe<Scalars["String"]>;
    processorData?: Maybe<GQSoftpayMiaProcessorData>;
    profileName?: Maybe<Scalars["String"]>;
    publicKeySetId?: Maybe<Scalars["String"]>;
    releasedAt?: Maybe<Scalars["String"]>;
    softpayTerminalId?: Maybe<Scalars["String"]>;
    state: Scalars["String"];
    takenAt?: Maybe<Scalars["String"]>;
    terminalId: Scalars["String"];
};

export type GQStringSearchInput = {
    value: Scalars["String"];
};

export type GQSubscription = {
    __typename?: "Subscription";
    dashboardUpdated?: Maybe<GQDashboard>;
    eventStoreSubscribe: Array<GQEvent>;
    logoDataUpdated: Scalars["Date"];
    merchantDataUpdated: Scalars["Date"];
};

export type GQSubscriptionDashboardUpdatedArgs = {
    departmentIds?: InputMaybe<Array<Scalars["String"]>>;
    from: Scalars["Date"];
    to: Scalars["Date"];
};

export type GQSubscriptionEventStoreSubscribeArgs = {
    query: GQEventQueryInput;
};

export type GQSumUpAccessTokenResponse = {
    __typename?: "SumUpAccessTokenResponse";
    accessToken: Scalars["String"];
};

export type GQTag = {
    __typename?: "Tag";
    account?: Maybe<GQAccount>;
    actionsForTag: GQTagActionPagination;
    createdAt: Scalars["Date"];
    customer?: Maybe<GQCustomer>;
    group?: Maybe<GQTagGroup>;
    id: Scalars["ID"];
    identifier: Scalars["String"];
    merchantId: GQMerchant;
    name?: Maybe<Scalars["String"]>;
    tagType: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQTagActionsForTagArgs = {
    pagination?: InputMaybe<GQPaginationInput>;
    tagId: Scalars["ID"];
};

export type GQTagAction = {
    __typename?: "TagAction";
    accountId: Scalars["String"];
    accountName: Scalars["String"];
    action: Scalars["String"];
    createdAt: Scalars["Date"];
    userName: Scalars["String"];
};

export type GQTagActionPagination = GQIPagination & {
    __typename?: "TagActionPagination";
    data: Array<GQTagAction>;
    pagination: GQPagination;
};

export type GQTagCreate = {
    groupId?: InputMaybe<Scalars["ID"]>;
    identifier: Scalars["String"];
    merchantId: Scalars["ID"];
    name?: InputMaybe<Scalars["String"]>;
    tagType: Scalars["String"];
};

export type GQTagDeleteResponse = {
    __typename?: "TagDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQTagGroup = {
    __typename?: "TagGroup";
    createdAt: Scalars["Date"];
    id: Scalars["ID"];
    merchant: GQMerchant;
    name: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQTagGroupCreate = {
    merchantId: Scalars["ID"];
    name: Scalars["String"];
};

export type GQTagGroupDeleteResponse = {
    __typename?: "TagGroupDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQTagGroupInput = {
    name: Scalars["String"];
};

export type GQTagGroupPagination = GQIPagination & {
    __typename?: "TagGroupPagination";
    data: Array<GQTagGroup>;
    pagination: GQPagination;
};

export type GQTagGroupSearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type GQTagInput = {
    accountId?: InputMaybe<Scalars["ID"]>;
    customerId?: InputMaybe<Scalars["ID"]>;
    groupId?: InputMaybe<Scalars["ID"]>;
    identifier: Scalars["String"];
    name?: InputMaybe<Scalars["String"]>;
    tagType: Scalars["String"];
};

export type GQTagPagination = GQIPagination & {
    __typename?: "TagPagination";
    data: Array<GQTag>;
    pagination: GQPagination;
};

export type GQTagSearchInput = {
    group?: InputMaybe<GQStringSearchInput>;
    identifier?: InputMaybe<GQStringSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
    type?: InputMaybe<GQTypeSearchInput>;
};

export type GQTaskResult = {
    __typename?: "TaskResult";
    createdAt: Scalars["Date"];
    executionTime: Scalars["Int"];
    jobId: Scalars["ID"];
    name?: Maybe<Scalars["String"]>;
    output?: Maybe<Scalars["String"]>;
    status: Scalars["String"];
    type: Scalars["String"];
};

export type GQTaskResultPagination = GQIPagination & {
    __typename?: "TaskResultPagination";
    data: Array<GQTaskResult>;
    pagination: GQPagination;
};

export enum GQTssStateEnum {
    Created = "CREATED",
    Defective = "DEFECTIVE",
    Deleted = "DELETED",
    Disabled = "DISABLED",
    Evicted = "EVICTED",
    Initialized = "INITIALIZED",
    Uninitialized = "UNINITIALIZED",
}

export type GQTypeSearchInput = {
    value: Scalars["String"];
};

export type GQUser = {
    __typename?: "User";
    active: Scalars["Boolean"];
    createdAt: Scalars["Date"];
    email: Scalars["String"];
    externalId?: Maybe<Scalars["String"]>;
    firstName: Scalars["String"];
    id: Scalars["ID"];
    lastLoginAt?: Maybe<Scalars["Date"]>;
    lastName: Scalars["String"];
    pin?: Maybe<Scalars["String"]>;
    requireLoginPin: Scalars["Boolean"];
    requireLogoutPin: Scalars["Boolean"];
    requirePasswordChange: Scalars["Boolean"];
    roles: Array<GQUserRole>;
    updatedAt: Scalars["Date"];
    username: Scalars["String"];
};

export type GQUserRolesArgs = {
    merchantId?: InputMaybe<Scalars["ID"]>;
};

export type GQUserDeleteResponse = {
    __typename?: "UserDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQUserInput = {
    active: Scalars["Boolean"];
    doNotSendPassword: Scalars["Boolean"];
    email: Scalars["String"];
    externalId?: InputMaybe<Scalars["String"]>;
    firstName: Scalars["String"];
    lastName: Scalars["String"];
    password?: InputMaybe<Scalars["String"]>;
    pin?: InputMaybe<Scalars["String"]>;
    requireLoginPin: Scalars["Boolean"];
    requireLogoutPin: Scalars["Boolean"];
    requirePasswordChange: Scalars["Boolean"];
    roles: Array<GQUserInputRole>;
    username: Scalars["String"];
};

export type GQUserInputRole = {
    merchantId?: InputMaybe<Scalars["ID"]>;
    roleId: Scalars["ID"];
    type: GQRoleTypeEnum;
};

export type GQUserPagination = GQIPagination & {
    __typename?: "UserPagination";
    data: Array<GQUser>;
    pagination: GQPagination;
};

export type GQUserRole = {
    __typename?: "UserRole";
    merchant?: Maybe<GQMerchant>;
    role: GQRole;
};

export type GQUserRoleConfiguration = {
    __typename?: "UserRoleConfiguration";
    createdAt: Scalars["Date"];
    data: Scalars["JSON"];
    merchant?: Maybe<GQMerchant>;
    role: GQRole;
    type: Scalars["String"];
    updatedAt?: Maybe<Scalars["Date"]>;
    user: GQUser;
};

export type GQUserRoleInput = {
    merchantId: Scalars["ID"];
    roleId: Scalars["ID"];
};

export type GQUserSearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    email?: InputMaybe<GQStringSearchInput>;
    firstname?: InputMaybe<GQStringSearchInput>;
    lastname?: InputMaybe<GQStringSearchInput>;
    username?: InputMaybe<GQStringSearchInput>;
};

export type GQVat = {
    __typename?: "Vat";
    createdAt: Scalars["Date"];
    deletedAt?: Maybe<Scalars["Date"]>;
    externalId?: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    isExternal?: Maybe<Scalars["Boolean"]>;
    merchant: GQMerchant;
    name: Scalars["String"];
    percentage: Scalars["Float"];
    updatedAt?: Maybe<Scalars["Date"]>;
};

export type GQVatCreateInput = {
    externalId?: InputMaybe<Scalars["String"]>;
    isExternal?: InputMaybe<Scalars["Boolean"]>;
    name: Scalars["String"];
    percentage: Scalars["Float"];
};

export type GQVatDeleteResponse = {
    __typename?: "VatDeleteResponse";
    status: Scalars["Boolean"];
};

export type GQVatPagination = GQIPagination & {
    __typename?: "VatPagination";
    data: Array<GQVat>;
    pagination: GQPagination;
};

export type GQVenueAccessAccessType = {
    __typename?: "VenueAccessAccessType";
    id: Scalars["Int"];
    name: Scalars["String"];
};

export type GQVenueAccessCreateType = {
    accessTypes: Array<Scalars["Int"]>;
    eventId: Scalars["Int"];
    validFrom: Scalars["Date"];
    validTo: Scalars["Date"];
};

export type GQVenueAccessEvent = {
    __typename?: "VenueAccessEvent";
    id: Scalars["Int"];
    isActive: Scalars["Boolean"];
    name: Scalars["String"];
};

export type GQVenueAccessParameters = {
    __typename?: "VenueAccessParameters";
    accessTypes: Array<GQVenueAccessAccessType>;
    events?: Maybe<Array<GQVenueAccessEvent>>;
};

export type GQVenueAccessParametersBulk = {
    __typename?: "VenueAccessParametersBulk";
    accessTypes: Array<GQVenueAccessAccessType>;
    events: Array<GQVenueAccessEvent>;
};

export type GQVenueAccessSettings = {
    __typename?: "VenueAccessSettings";
    bar: Scalars["String"];
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    type: Scalars["String"];
};

export type GQVenueAccessTicketCancelled = {
    __typename?: "VenueAccessTicketCancelled";
    status: Scalars["Boolean"];
};

export type GQVenueAccessTicketCreated = {
    __typename?: "VenueAccessTicketCreated";
    ticketId: Scalars["String"];
    tokenValue: Scalars["String"];
};

export type GQViProduct = {
    __typename?: "ViProduct";
    deletedAt?: Maybe<Scalars["Date"]>;
    id: Scalars["ID"];
    measurementUnit: Array<GQMeasurementUnit>;
    name: Scalars["String"];
};

export type GQViProductPagination = GQIPagination & {
    __typename?: "ViProductPagination";
    data: Array<GQViProduct>;
    pagination: GQPagination;
};

export type GQViWarehouse = {
    __typename?: "ViWarehouse";
    id: Scalars["ID"];
    name: Scalars["String"];
};

export type GQViWarehousePagination = GQIPagination & {
    __typename?: "ViWarehousePagination";
    data: Array<GQViWarehouse>;
    pagination: GQPagination;
};

export type GQVirtualPrinter = {
    __typename?: "VirtualPrinter";
    createdAt: Scalars["Date"];
    departments?: Maybe<Array<GQVirtualPrinterDepartment>>;
    id: Scalars["ID"];
    merchant: GQMerchant;
    name: Scalars["String"];
    printer: GQPrinter;
    updatedAt: Scalars["Date"];
};

export type GQVirtualPrinterCreate = {
    departments?: InputMaybe<Array<GQVirtualPrinterDepartmentSave>>;
    name: Scalars["String"];
    printerId: Scalars["ID"];
};

export type GQVirtualPrinterDeleteResponse = {
    __typename?: "VirtualPrinterDeleteResponse";
    status: GQDeleteResponseEnum;
};

export type GQVirtualPrinterDepartment = {
    __typename?: "VirtualPrinterDepartment";
    department: GQDepartment;
    printer?: Maybe<GQPrinter>;
};

export type GQVirtualPrinterDepartmentSave = {
    departmentId: Scalars["ID"];
    printerId?: InputMaybe<Scalars["ID"]>;
};

export type GQVirtualPrinterPagination = GQIPagination & {
    __typename?: "VirtualPrinterPagination";
    data: Array<GQVirtualPrinter>;
    pagination: GQPagination;
};

export type GQVirtualPrinterSave = {
    departments?: InputMaybe<Array<GQVirtualPrinterDepartmentSave>>;
    name: Scalars["String"];
    printerId: Scalars["ID"];
};

export type GQVirtualPrinterSearchInput = {
    createdAt?: InputMaybe<GQDateSearchInput>;
    name?: InputMaybe<GQStringSearchInput>;
};

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
    resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
    | ResolverFn<TResult, TParent, TContext, TArgs>
    | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
    parent: TParent,
    args: TArgs,
    context: TContext,
    info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
    parent: TParent,
    args: TArgs,
    context: TContext,
    info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
    parent: TParent,
    args: TArgs,
    context: TContext,
    info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
    TResult,
    TKey extends string,
    TParent,
    TContext,
    TArgs
> {
    subscribe: SubscriptionSubscribeFn<
        { [key in TKey]: TResult },
        TParent,
        TContext,
        TArgs
    >;
    resolve?: SubscriptionResolveFn<
        TResult,
        { [key in TKey]: TResult },
        TContext,
        TArgs
    >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
    subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
    resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
    TResult,
    TKey extends string,
    TParent,
    TContext,
    TArgs
> =
    | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
    | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
    TResult,
    TKey extends string,
    TParent = {},
    TContext = {},
    TArgs = {}
> =
    | ((
          ...args: any[]
      ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
    | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
    parent: TParent,
    context: TContext,
    info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
    obj: T,
    context: TContext,
    info: GraphQLResolveInfo
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
    TResult = {},
    TParent = {},
    TContext = {},
    TArgs = {}
> = (
    next: NextResolverFn<TResult>,
    parent: TParent,
    args: TArgs,
    context: TContext,
    info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type GQResolversTypes = {
    Account: ResolverTypeWrapper<GQAccount>;
    AccountBookkeepingPagination: ResolverTypeWrapper<GQAccountBookkeepingPagination>;
    AccountBookkeepingTransaction: ResolverTypeWrapper<GQAccountBookkeepingTransaction>;
    AccountBookkeepingTransactionPagination: ResolverTypeWrapper<GQAccountBookkeepingTransactionPagination>;
    AccountBookkeepingTransactionSearchInput: GQAccountBookkeepingTransactionSearchInput;
    AccountBuyFundsResponse: ResolverTypeWrapper<GQAccountBuyFundsResponse>;
    AccountBuyFundsStatus: GQAccountBuyFundsStatus;
    AccountCloseResponse: ResolverTypeWrapper<GQAccountCloseResponse>;
    AccountCreate: GQAccountCreate;
    AccountInput: GQAccountInput;
    AccountOpenResponse: ResolverTypeWrapper<GQAccountOpenResponse>;
    AccountPagination: ResolverTypeWrapper<GQAccountPagination>;
    AccountPayAmountResponse: ResolverTypeWrapper<GQAccountPayAmountResponse>;
    AccountRefundAmountResponse: ResolverTypeWrapper<GQAccountRefundAmountResponse>;
    AccountReturnFundsResponse: ResolverTypeWrapper<GQAccountReturnFundsResponse>;
    AccountReturnFundsStatus: GQAccountReturnFundsStatus;
    AccountRevertTransactionResponse: ResolverTypeWrapper<GQAccountRevertTransactionResponse>;
    AccountRevertTransactionStatus: GQAccountRevertTransactionStatus;
    AccountSearchInput: GQAccountSearchInput;
    AccountTransaction: ResolverTypeWrapper<GQAccountTransaction>;
    AccountTransactionPagination: ResolverTypeWrapper<GQAccountTransactionPagination>;
    AccountTransactionSearchInput: GQAccountTransactionSearchInput;
    AccountTransactionStatus: GQAccountTransactionStatus;
    AddEventResponse: ResolverTypeWrapper<GQAddEventResponse>;
    AdyenSessionsResponse: ResolverTypeWrapper<GQAdyenSessionsResponse>;
    AdyenStore: ResolverTypeWrapper<GQAdyenStore>;
    AdyenStoreLocation: ResolverTypeWrapper<GQAdyenStoreLocation>;
    AdyenStoreStatus: GQAdyenStoreStatus;
    AdyenStoresPagination: ResolverTypeWrapper<GQAdyenStoresPagination>;
    AdyenTerminal: ResolverTypeWrapper<GQAdyenTerminal>;
    AdyenTerminalAssignment: ResolverTypeWrapper<GQAdyenTerminalAssignment>;
    AdyenTerminalConnectivity: ResolverTypeWrapper<GQAdyenTerminalConnectivity>;
    AdyenTerminalConnectivityBluetooth: ResolverTypeWrapper<GQAdyenTerminalConnectivityBluetooth>;
    AdyenTerminalConnectivityCellular: ResolverTypeWrapper<GQAdyenTerminalConnectivityCellular>;
    AdyenTerminalConnectivityEthernet: ResolverTypeWrapper<GQAdyenTerminalConnectivityEthernet>;
    AdyenTerminalConnectivityWifi: ResolverTypeWrapper<GQAdyenTerminalConnectivityWifi>;
    AdyenTerminalsPagination: ResolverTypeWrapper<GQAdyenTerminalsPagination>;
    AdyenTerminalsResponse: ResolverTypeWrapper<GQAdyenTerminalsResponse>;
    AmountSearchInput: GQAmountSearchInput;
    AppData: ResolverTypeWrapper<GQAppData>;
    Approval: ResolverTypeWrapper<GQApproval>;
    ApprovalGroupType: GQApprovalGroupType;
    ApprovalInput: GQApprovalInput;
    ApprovalPagination: ResolverTypeWrapper<GQApprovalPagination>;
    ApprovalSearchInput: GQApprovalSearchInput;
    ApprovalToken: ResolverTypeWrapper<GQApprovalToken>;
    ApprovalTokenGroup: ResolverTypeWrapper<GQApprovalTokenGroup>;
    ApprovalTokenGroupInput: GQApprovalTokenGroupInput;
    ApprovalTokenGroupPagination: ResolverTypeWrapper<GQApprovalTokenGroupPagination>;
    ApprovalTokenGroupSearchInput: GQApprovalTokenGroupSearchInput;
    ApprovalTokenInput: GQApprovalTokenInput;
    ApprovalTokenPagination: ResolverTypeWrapper<GQApprovalTokenPagination>;
    ApprovalTokenSearchInput: GQApprovalTokenSearchInput;
    ApprovalType: GQApprovalType;
    AuthAttempt: ResolverTypeWrapper<GQAuthAttempt>;
    AuthToken: ResolverTypeWrapper<GQAuthToken>;
    Balance: ResolverTypeWrapper<GQBalance>;
    BookkeepingAccount: ResolverTypeWrapper<GQBookkeepingAccount>;
    Boolean: ResolverTypeWrapper<Scalars["Boolean"]>;
    BooleanResponse: ResolverTypeWrapper<GQBooleanResponse>;
    BooleanSearchInput: GQBooleanSearchInput;
    BuyAccountFunds: ResolverTypeWrapper<GQBuyAccountFunds>;
    Byte: ResolverTypeWrapper<Scalars["Byte"]>;
    CanPeriodCardBeRenewedResponse: ResolverTypeWrapper<GQCanPeriodCardBeRenewedResponse>;
    CanPeriodCardBeUpgradedResponse: ResolverTypeWrapper<GQCanPeriodCardBeUpgradedResponse>;
    CardTransaction: ResolverTypeWrapper<GQCardTransaction>;
    CardTransactionPagination: ResolverTypeWrapper<GQCardTransactionPagination>;
    CardTransactionSearchInput: GQCardTransactionSearchInput;
    CardTransactionType: GQCardTransactionType;
    CashDifferencePerMethod: ResolverTypeWrapper<GQCashDifferencePerMethod>;
    CashInfoPerMethod: ResolverTypeWrapper<GQCashInfoPerMethod>;
    CashRegister: ResolverTypeWrapper<GQCashRegister>;
    CashRegisterCreateInput: GQCashRegisterCreateInput;
    CashRegisterDeleteResponse: ResolverTypeWrapper<GQCashRegisterDeleteResponse>;
    CashRegisterEditInput: GQCashRegisterEditInput;
    CashRegisterPagination: ResolverTypeWrapper<GQCashRegisterPagination>;
    CashRegisterSearchInput: GQCashRegisterSearchInput;
    CashRegisterStatus: ResolverTypeWrapper<GQCashRegisterStatus>;
    CashRegisterStatusPagination: ResolverTypeWrapper<GQCashRegisterStatusPagination>;
    CashRegisterStatusSearchInput: GQCashRegisterStatusSearchInput;
    CashRegisterTypeEnum: GQCashRegisterTypeEnum;
    CashRegisterVersion: ResolverTypeWrapper<GQCashRegisterVersion>;
    CashSalePerMethod: ResolverTypeWrapper<GQCashSalePerMethod>;
    ChartAccount: ResolverTypeWrapper<GQChartAccount>;
    ChartAccountInput: GQChartAccountInput;
    ChartAccounts: ResolverTypeWrapper<GQChartAccounts>;
    ChartOfAccountNo: ResolverTypeWrapper<GQChartOfAccountNo>;
    ClientStateEnum: GQClientStateEnum;
    CmpEvent: ResolverTypeWrapper<GQCmpEvent>;
    CmpEventCreateType: GQCmpEventCreateType;
    CmpEventNoProducts: ResolverTypeWrapper<GQCmpEventNoProducts>;
    CmpEventOrderCreated: ResolverTypeWrapper<GQCmpEventOrderCreated>;
    CmpEventOrderReceipt: ResolverTypeWrapper<GQCmpEventOrderReceipt>;
    CmpEventPagination: ResolverTypeWrapper<GQCmpEventPagination>;
    CmpEventPayment: GQCmpEventPayment;
    CmpEventProduct: ResolverTypeWrapper<GQCmpEventProduct>;
    CmpEventProductItem: GQCmpEventProductItem;
    CmpEventProductPagination: ResolverTypeWrapper<GQCmpEventProductPagination>;
    CmpGiftcardBalance: ResolverTypeWrapper<GQCmpGiftcardBalance>;
    CmpGiftcardBalanceStatus: GQCmpGiftcardBalanceStatus;
    CmpGiftcardPayAmountResponse: ResolverTypeWrapper<GQCmpGiftcardPayAmountResponse>;
    CmpGiftcardRefundAmountResponse: ResolverTypeWrapper<GQCmpGiftcardRefundAmountResponse>;
    CmpGiftcardTransactionStatus: GQCmpGiftcardTransactionStatus;
    CmpInvoiceCustomer: ResolverTypeWrapper<GQCmpInvoiceCustomer>;
    CmpInvoiceCustomerResponse: ResolverTypeWrapper<GQCmpInvoiceCustomerResponse>;
    CmpInvoiceCustomerStatus: GQCmpInvoiceCustomerStatus;
    CmpInvoicePaymentMethod: ResolverTypeWrapper<GQCmpInvoicePaymentMethod>;
    CmpProduct: ResolverTypeWrapper<GQCmpProduct>;
    CmpProductPagination: ResolverTypeWrapper<GQCmpProductPagination>;
    CmpProductResponse: ResolverTypeWrapper<GQCmpProductResponse>;
    CmpProductSettings: ResolverTypeWrapper<GQCmpProductSettings>;
    CmpProductSettingsInput: GQCmpProductSettingsInput;
    Configuration: ResolverTypeWrapper<GQConfiguration>;
    CreateTssResponse: ResolverTypeWrapper<GQCreateTssResponse>;
    Currency: ResolverTypeWrapper<GQCurrency>;
    CurrencyDeleteResponse: ResolverTypeWrapper<GQCurrencyDeleteResponse>;
    CurrencyInput: GQCurrencyInput;
    CurrencyPagination: ResolverTypeWrapper<GQCurrencyPagination>;
    CursorPagination: ResolverTypeWrapper<GQCursorPagination>;
    CursorPaginationInput: GQCursorPaginationInput;
    CustomItem: ResolverTypeWrapper<GQCustomItem>;
    Customer: ResolverTypeWrapper<GQCustomer>;
    CustomerAssignTagsRelationResponse: ResolverTypeWrapper<GQCustomerAssignTagsRelationResponse>;
    CustomerCreate: GQCustomerCreate;
    CustomerDeleteResponse: ResolverTypeWrapper<GQCustomerDeleteResponse>;
    CustomerGroup: ResolverTypeWrapper<GQCustomerGroup>;
    CustomerGroupCreate: GQCustomerGroupCreate;
    CustomerGroupDeleteResponse: ResolverTypeWrapper<GQCustomerGroupDeleteResponse>;
    CustomerGroupInput: GQCustomerGroupInput;
    CustomerGroupPagination: ResolverTypeWrapper<GQCustomerGroupPagination>;
    CustomerGroupSearchInput: GQCustomerGroupSearchInput;
    CustomerInput: GQCustomerInput;
    CustomerPagination: ResolverTypeWrapper<GQCustomerPagination>;
    CustomerSearchInput: GQCustomerSearchInput;
    Dashboard: ResolverTypeWrapper<GQDashboard>;
    DashboardAccountItem: ResolverTypeWrapper<GQDashboardAccountItem>;
    DashboardAmountByHourItem: ResolverTypeWrapper<GQDashboardAmountByHourItem>;
    DashboardCashRegister: ResolverTypeWrapper<GQDashboardCashRegister>;
    DashboardCashRegisterPagination: ResolverTypeWrapper<GQDashboardCashRegisterPagination>;
    DashboardDepartmentItem: ResolverTypeWrapper<GQDashboardDepartmentItem>;
    DashboardProductGroupItem: ResolverTypeWrapper<GQDashboardProductGroupItem>;
    DashboardProductItem: ResolverTypeWrapper<GQDashboardProductItem>;
    DashboardTotals: ResolverTypeWrapper<GQDashboardTotals>;
    Date: ResolverTypeWrapper<Scalars["Date"]>;
    DateSearchInput: GQDateSearchInput;
    DateValues: GQDateValues;
    DeleteResponseEnum: GQDeleteResponseEnum;
    Department: ResolverTypeWrapper<GQDepartment>;
    DepartmentDeleteResponse: ResolverTypeWrapper<GQDepartmentDeleteResponse>;
    DepartmentInput: GQDepartmentInput;
    DepartmentPagination: ResolverTypeWrapper<GQDepartmentPagination>;
    DepartmentSearchInput: GQDepartmentSearchInput;
    Device: ResolverTypeWrapper<GQDevice>;
    DeviceCapabilitiesInput: GQDeviceCapabilitiesInput;
    DeviceInfoInput: GQDeviceInfoInput;
    DevicePagination: ResolverTypeWrapper<GQDevicePagination>;
    DevicePinCodeValidation: ResolverTypeWrapper<GQDevicePinCodeValidation>;
    DevicePrinterInput: GQDevicePrinterInput;
    Discount: ResolverTypeWrapper<GQDiscount>;
    DiscountInput: GQDiscountInput;
    DiscountPagination: ResolverTypeWrapper<GQDiscountPagination>;
    DiscountSearchInput: GQDiscountSearchInput;
    DiscountTemplate: ResolverTypeWrapper<GQDiscountTemplate>;
    DiscountTemplateInput: GQDiscountTemplateInput;
    DiscountType: GQDiscountType;
    DiscountValueType: GQDiscountValueType;
    EconomicSettings: ResolverTypeWrapper<GQEconomicSettings>;
    EconomicSettingsInput: GQEconomicSettingsInput;
    EconomicSyncJob: ResolverTypeWrapper<GQEconomicSyncJob>;
    EconomicSyncJobPagination: ResolverTypeWrapper<GQEconomicSyncJobPagination>;
    Entity: GQResolversTypes["POS"] | GQResolversTypes["Partner"];
    EntityConfig: ResolverTypeWrapper<GQEntityConfig>;
    EntityConfigDeleteResponse: ResolverTypeWrapper<GQEntityConfigDeleteResponse>;
    EnvironmentEnum: GQEnvironmentEnum;
    Event: ResolverTypeWrapper<GQEvent>;
    EventInput: GQEventInput;
    EventQueryInput: GQEventQueryInput;
    ExportFormat: GQExportFormat;
    ExportState: GQExportState;
    File: ResolverTypeWrapper<GQFile>;
    FiskalyAccessTokenResponse: ResolverTypeWrapper<GQFiskalyAccessTokenResponse>;
    FiskalyClient: ResolverTypeWrapper<GQFiskalyClient>;
    FiskalyClientList: ResolverTypeWrapper<GQFiskalyClientList>;
    FiskalyConfiguration: ResolverTypeWrapper<GQFiskalyConfiguration>;
    FiskalyDSFinVKExport: ResolverTypeWrapper<GQFiskalyDsFinVkExport>;
    FiskalyDSFinVKExportInput: GQFiskalyDsFinVkExportInput;
    FiskalyDSFinVKExportList: ResolverTypeWrapper<GQFiskalyDsFinVkExportList>;
    FiskalyEstablishment: ResolverTypeWrapper<GQFiskalyEstablishment>;
    FiskalyEstablishmentInput: GQFiskalyEstablishmentInput;
    FiskalyEstablishmentList: ResolverTypeWrapper<GQFiskalyEstablishmentList>;
    FiskalyEstablishmentMapping: ResolverTypeWrapper<GQFiskalyEstablishmentMapping>;
    FiskalyEstablishmentMappingInput: GQFiskalyEstablishmentMappingInput;
    FiskalyEstablishmentMappingList: ResolverTypeWrapper<GQFiskalyEstablishmentMappingList>;
    FiskalyEstablishmentSubmission: ResolverTypeWrapper<GQFiskalyEstablishmentSubmission>;
    FiskalyEstablishmentSubmissionDownload: ResolverTypeWrapper<GQFiskalyEstablishmentSubmissionDownload>;
    FiskalyEstablishmentSubmissionInput: GQFiskalyEstablishmentSubmissionInput;
    FiskalyEstablishmentSubmissionList: ResolverTypeWrapper<GQFiskalyEstablishmentSubmissionList>;
    FiskalyOrganization: ResolverTypeWrapper<GQFiskalyOrganization>;
    FiskalyOrganizationInput: GQFiskalyOrganizationInput;
    FiskalyOrganizations: ResolverTypeWrapper<GQFiskalyOrganizations>;
    FiskalyOrganizationsPagination: ResolverTypeWrapper<GQFiskalyOrganizationsPagination>;
    FiskalyRemoteCashRegister: ResolverTypeWrapper<GQFiskalyRemoteCashRegister>;
    FiskalyRemoteCashRegisterList: ResolverTypeWrapper<GQFiskalyRemoteCashRegisterList>;
    FiskalyRemoteClient: ResolverTypeWrapper<GQFiskalyRemoteClient>;
    FiskalyRemoteClientList: ResolverTypeWrapper<GQFiskalyRemoteClientList>;
    FiskalyRemoteEstablishmentSubmissionList: ResolverTypeWrapper<GQFiskalyRemoteEstablishmentSubmissionList>;
    FiskalySettings: ResolverTypeWrapper<GQFiskalySettings>;
    FiskalySettingsInput: GQFiskalySettingsInput;
    FiskalyTaxPayer:
        | GQResolversTypes["FiskalyTaxPayerLegal"]
        | GQResolversTypes["FiskalyTaxPayerNatural"];
    FiskalyTaxPayerLegal: ResolverTypeWrapper<GQFiskalyTaxPayerLegal>;
    FiskalyTaxPayerLegalInput: GQFiskalyTaxPayerLegalInput;
    FiskalyTaxPayerNatural: ResolverTypeWrapper<GQFiskalyTaxPayerNatural>;
    FiskalyTaxPayerNaturalInput: GQFiskalyTaxPayerNaturalInput;
    FiskalyTaxPayerType: GQFiskalyTaxPayerType;
    FiskalyTss: ResolverTypeWrapper<GQFiskalyTss>;
    FiskalyTssList: ResolverTypeWrapper<GQFiskalyTssList>;
    Float: ResolverTypeWrapper<Scalars["Float"]>;
    Function:
        | GQResolversTypes["BuyAccountFunds"]
        | GQResolversTypes["CustomItem"];
    GpsPoint: ResolverTypeWrapper<GQGpsPoint>;
    GpsPointInput: GQGpsPointInput;
    ID: ResolverTypeWrapper<Scalars["ID"]>;
    IFiskalyTaxPayer:
        | GQResolversTypes["FiskalyTaxPayerLegal"]
        | GQResolversTypes["FiskalyTaxPayerNatural"];
    IPagination:
        | GQResolversTypes["AccountBookkeepingPagination"]
        | GQResolversTypes["AccountBookkeepingTransactionPagination"]
        | GQResolversTypes["AccountPagination"]
        | GQResolversTypes["AccountTransactionPagination"]
        | GQResolversTypes["AdyenStoresPagination"]
        | GQResolversTypes["AdyenTerminalsPagination"]
        | GQResolversTypes["ApprovalPagination"]
        | GQResolversTypes["ApprovalTokenGroupPagination"]
        | GQResolversTypes["ApprovalTokenPagination"]
        | GQResolversTypes["CardTransactionPagination"]
        | GQResolversTypes["CashRegisterPagination"]
        | GQResolversTypes["CashRegisterStatusPagination"]
        | GQResolversTypes["CmpEventPagination"]
        | GQResolversTypes["CmpEventProductPagination"]
        | GQResolversTypes["CmpProductPagination"]
        | GQResolversTypes["CurrencyPagination"]
        | GQResolversTypes["CustomerGroupPagination"]
        | GQResolversTypes["CustomerPagination"]
        | GQResolversTypes["DashboardCashRegisterPagination"]
        | GQResolversTypes["DepartmentPagination"]
        | GQResolversTypes["DevicePagination"]
        | GQResolversTypes["DiscountPagination"]
        | GQResolversTypes["EconomicSyncJobPagination"]
        | GQResolversTypes["FiskalyOrganizationsPagination"]
        | GQResolversTypes["IntegrationPagination"]
        | GQResolversTypes["InventoryProductNoteTemplatePagination"]
        | GQResolversTypes["InventoryProductPagination"]
        | GQResolversTypes["InvoiceRMPagination"]
        | GQResolversTypes["LayoutEntityPagination"]
        | GQResolversTypes["LayoutPagination"]
        | GQResolversTypes["LogPagination"]
        | GQResolversTypes["MerchantPagination"]
        | GQResolversTypes["MiscButtonsPagination"]
        | GQResolversTypes["PaymentConfigurationPagination"]
        | GQResolversTypes["PaymentMethodPagination"]
        | GQResolversTypes["PrinterPagination"]
        | GQResolversTypes["ProductGroupPagination"]
        | GQResolversTypes["ProductPagination"]
        | GQResolversTypes["RolePagination"]
        | GQResolversTypes["SaftJobPagination"]
        | GQResolversTypes["ShiftRMPagination"]
        | GQResolversTypes["SoftpayCloudTerminalsPagination"]
        | GQResolversTypes["SoftpayMerchantsPagination"]
        | GQResolversTypes["SoftpayMiaMerchantsPagination"]
        | GQResolversTypes["TagActionPagination"]
        | GQResolversTypes["TagGroupPagination"]
        | GQResolversTypes["TagPagination"]
        | GQResolversTypes["TaskResultPagination"]
        | GQResolversTypes["UserPagination"]
        | GQResolversTypes["VatPagination"]
        | GQResolversTypes["ViProductPagination"]
        | GQResolversTypes["ViWarehousePagination"]
        | GQResolversTypes["VirtualPrinterPagination"];
    Int: ResolverTypeWrapper<Scalars["Int"]>;
    Integration: ResolverTypeWrapper<GQIntegration>;
    IntegrationAccount: ResolverTypeWrapper<GQIntegrationAccount>;
    IntegrationArray: ResolverTypeWrapper<GQIntegrationArray>;
    IntegrationCreate: GQIntegrationCreate;
    IntegrationInput: GQIntegrationInput;
    IntegrationPagination: ResolverTypeWrapper<GQIntegrationPagination>;
    IntegrationSettings:
        | GQResolversTypes["CmpProductSettings"]
        | GQResolversTypes["EconomicSettings"]
        | GQResolversTypes["FiskalySettings"]
        | GQResolversTypes["PartnerApiSettings"]
        | GQResolversTypes["VenueAccessSettings"];
    InventoryProduct: ResolverTypeWrapper<GQInventoryProduct>;
    InventoryProductCreate: GQInventoryProductCreate;
    InventoryProductInput: GQInventoryProductInput;
    InventoryProductNoteTemplate: ResolverTypeWrapper<GQInventoryProductNoteTemplate>;
    InventoryProductNoteTemplateCreate: GQInventoryProductNoteTemplateCreate;
    InventoryProductNoteTemplateInput: GQInventoryProductNoteTemplateInput;
    InventoryProductNoteTemplatePagination: ResolverTypeWrapper<GQInventoryProductNoteTemplatePagination>;
    InventoryProductPagination: ResolverTypeWrapper<GQInventoryProductPagination>;
    InvoiceAmount: ResolverTypeWrapper<GQInvoiceAmount>;
    InvoiceAmountPerMonth: ResolverTypeWrapper<GQInvoiceAmountPerMonth>;
    InvoiceCount: ResolverTypeWrapper<GQInvoiceCount>;
    InvoiceExternalReceipt: ResolverTypeWrapper<GQInvoiceExternalReceipt>;
    InvoiceHourSales: ResolverTypeWrapper<GQInvoiceHourSales>;
    InvoiceItemExternalRM: ResolverTypeWrapper<GQInvoiceItemExternalRm>;
    InvoiceItemRM: ResolverTypeWrapper<GQInvoiceItemRm>;
    InvoicePaymentRM: ResolverTypeWrapper<GQInvoicePaymentRm>;
    InvoiceRM: ResolverTypeWrapper<GQInvoiceRm>;
    InvoiceRMPagination: ResolverTypeWrapper<GQInvoiceRmPagination>;
    InvoiceSearchInput: GQInvoiceSearchInput;
    JSON: ResolverTypeWrapper<Scalars["JSON"]>;
    Layout: ResolverTypeWrapper<GQLayout>;
    LayoutCreate: GQLayoutCreate;
    LayoutDeleteResponse: ResolverTypeWrapper<GQLayoutDeleteResponse>;
    LayoutEntity: ResolverTypeWrapper<
        Omit<GQLayoutEntity, "data"> & { data: GQResolversTypes["Function"] }
    >;
    LayoutEntityCreate: GQLayoutEntityCreate;
    LayoutEntityPagination: ResolverTypeWrapper<GQLayoutEntityPagination>;
    LayoutEntitySave: GQLayoutEntitySave;
    LayoutEntitySearchInput: GQLayoutEntitySearchInput;
    LayoutPagination: ResolverTypeWrapper<GQLayoutPagination>;
    LayoutSave: GQLayoutSave;
    LayoutSearchInput: GQLayoutSearchInput;
    Log: ResolverTypeWrapper<GQLog>;
    LogPagination: ResolverTypeWrapper<GQLogPagination>;
    LogSearchInput: GQLogSearchInput;
    LogType: GQLogType;
    Logo: ResolverTypeWrapper<GQLogo>;
    LogoInput: GQLogoInput;
    LogoType: GQLogoType;
    Me: ResolverTypeWrapper<GQMe>;
    MeasurementUnit: ResolverTypeWrapper<GQMeasurementUnit>;
    Merchant: ResolverTypeWrapper<GQMerchant>;
    MerchantChartOfAccount: ResolverTypeWrapper<GQMerchantChartOfAccount>;
    MerchantChartOfAccountInput: GQMerchantChartOfAccountInput;
    MerchantChartOfAccounts: ResolverTypeWrapper<GQMerchantChartOfAccounts>;
    MerchantCreate: GQMerchantCreate;
    MerchantDeleteResponse: ResolverTypeWrapper<GQMerchantDeleteResponse>;
    MerchantInput: GQMerchantInput;
    MerchantPagination: ResolverTypeWrapper<GQMerchantPagination>;
    MerchantSearchInput: GQMerchantSearchInput;
    MiscButtons: ResolverTypeWrapper<GQMiscButtons>;
    MiscButtonsDeleteResponse: ResolverTypeWrapper<GQMiscButtonsDeleteResponse>;
    MiscButtonsInput: GQMiscButtonsInput;
    MiscButtonsPagination: ResolverTypeWrapper<GQMiscButtonsPagination>;
    Mutation: ResolverTypeWrapper<{}>;
    NumberSearchInput: GQNumberSearchInput;
    POS: ResolverTypeWrapper<GQPos>;
    Pagination: ResolverTypeWrapper<GQPagination>;
    PaginationInput: GQPaginationInput;
    Partner: ResolverTypeWrapper<GQPartner>;
    PartnerApiSettings: ResolverTypeWrapper<GQPartnerApiSettings>;
    PaymentConfiguration: ResolverTypeWrapper<GQPaymentConfiguration>;
    PaymentConfigurationDeleteResponse: ResolverTypeWrapper<GQPaymentConfigurationDeleteResponse>;
    PaymentConfigurationInput: GQPaymentConfigurationInput;
    PaymentConfigurationMethod: ResolverTypeWrapper<GQPaymentConfigurationMethod>;
    PaymentConfigurationMethodInput: GQPaymentConfigurationMethodInput;
    PaymentConfigurationPagination: ResolverTypeWrapper<GQPaymentConfigurationPagination>;
    PaymentMethod: ResolverTypeWrapper<GQPaymentMethod>;
    PaymentMethodDeleteResponse: ResolverTypeWrapper<GQPaymentMethodDeleteResponse>;
    PaymentMethodInput: GQPaymentMethodInput;
    PaymentMethodPagination: ResolverTypeWrapper<GQPaymentMethodPagination>;
    PercentSearchInput: GQPercentSearchInput;
    PeriodCardRenewalStatus: GQPeriodCardRenewalStatus;
    PeriodCardUpgradeStatus: GQPeriodCardUpgradeStatus;
    Printer: ResolverTypeWrapper<GQPrinter>;
    PrinterClass: GQPrinterClass;
    PrinterDeleteResponse: ResolverTypeWrapper<GQPrinterDeleteResponse>;
    PrinterManufacturer: GQPrinterManufacturer;
    PrinterPagination: ResolverTypeWrapper<GQPrinterPagination>;
    PrinterRegister: GQPrinterRegister;
    PrinterSave: GQPrinterSave;
    PrinterSearchInput: GQPrinterSearchInput;
    PrinterType: GQPrinterType;
    Product: ResolverTypeWrapper<GQProduct>;
    Product2ViProduct2MeasurementUnit: ResolverTypeWrapper<GQProduct2ViProduct2MeasurementUnit>;
    Product2ViProduct2MeasurementUnitInput: GQProduct2ViProduct2MeasurementUnitInput;
    ProductBarcode: ResolverTypeWrapper<GQProductBarcode>;
    ProductBarcodeInput: GQProductBarcodeInput;
    ProductDeleteResponse: ResolverTypeWrapper<GQProductDeleteResponse>;
    ProductGroup: ResolverTypeWrapper<GQProductGroup>;
    ProductGroupDeleteResponse: ResolverTypeWrapper<GQProductGroupDeleteResponse>;
    ProductGroupInput: GQProductGroupInput;
    ProductGroupPagination: ResolverTypeWrapper<GQProductGroupPagination>;
    ProductGroupSearchInput: GQProductGroupSearchInput;
    ProductInput: GQProductInput;
    ProductPagination: ResolverTypeWrapper<GQProductPagination>;
    ProductRelationInput: GQProductRelationInput;
    ProductSearchInput: GQProductSearchInput;
    Query: ResolverTypeWrapper<{}>;
    RemoteEstablishmentSubmission: ResolverTypeWrapper<GQRemoteEstablishmentSubmission>;
    ReportCashRegister: ResolverTypeWrapper<GQReportCashRegister>;
    ReportDepartment: ResolverTypeWrapper<GQReportDepartment>;
    ReportParameters: ResolverTypeWrapper<GQReportParameters>;
    ReportProduct: ResolverTypeWrapper<GQReportProduct>;
    ReportProductGroup: ResolverTypeWrapper<GQReportProductGroup>;
    ReportUser: ResolverTypeWrapper<GQReportUser>;
    Role: ResolverTypeWrapper<GQRole>;
    RoleDeleteResponse: ResolverTypeWrapper<GQRoleDeleteResponse>;
    RoleInput: GQRoleInput;
    RolePagination: ResolverTypeWrapper<GQRolePagination>;
    RolePermission: ResolverTypeWrapper<GQRolePermission>;
    RolePermissionInput: GQRolePermissionInput;
    RoleTypeEnum: GQRoleTypeEnum;
    SaftJob: ResolverTypeWrapper<GQSaftJob>;
    SaftJobPagination: ResolverTypeWrapper<GQSaftJobPagination>;
    SearchInput: GQSearchInput;
    SelectUserRoleType: ResolverTypeWrapper<GQSelectUserRoleType>;
    ShiftFundsRM: ResolverTypeWrapper<GQShiftFundsRm>;
    ShiftPaymentCardRM: ResolverTypeWrapper<GQShiftPaymentCardRm>;
    ShiftPaymentRM: ResolverTypeWrapper<GQShiftPaymentRm>;
    ShiftPaymentRMEvent: GQShiftPaymentRmEvent;
    ShiftRM: ResolverTypeWrapper<GQShiftRm>;
    ShiftRMPagination: ResolverTypeWrapper<GQShiftRmPagination>;
    ShiftSalesData: ResolverTypeWrapper<GQShiftSalesData>;
    ShiftSalesDataByProductGroup: ResolverTypeWrapper<GQShiftSalesDataByProductGroup>;
    ShiftSearchInput: GQShiftSearchInput;
    ShouldPrintType: GQShouldPrintType;
    SoftpayAccessTokenResponse: ResolverTypeWrapper<GQSoftpayAccessTokenResponse>;
    SoftpayAcquirer: GQSoftpayAcquirer;
    SoftpayCloudStore: ResolverTypeWrapper<GQSoftpayCloudStore>;
    SoftpayCloudTerminal: ResolverTypeWrapper<GQSoftpayCloudTerminal>;
    SoftpayCloudTerminalsPagination: ResolverTypeWrapper<GQSoftpayCloudTerminalsPagination>;
    SoftpayMerchant: ResolverTypeWrapper<GQSoftpayMerchant>;
    SoftpayMerchantsPagination: ResolverTypeWrapper<GQSoftpayMerchantsPagination>;
    SoftpayMiaAdditionalData: ResolverTypeWrapper<GQSoftpayMiaAdditionalData>;
    SoftpayMiaMerchant: ResolverTypeWrapper<GQSoftpayMiaMerchant>;
    SoftpayMiaMerchantsPagination: ResolverTypeWrapper<GQSoftpayMiaMerchantsPagination>;
    SoftpayMiaProcessorData: ResolverTypeWrapper<GQSoftpayMiaProcessorData>;
    SoftpayMiaStore: ResolverTypeWrapper<GQSoftpayMiaStore>;
    SoftpayMiaTerminal: ResolverTypeWrapper<GQSoftpayMiaTerminal>;
    String: ResolverTypeWrapper<Scalars["String"]>;
    StringSearchInput: GQStringSearchInput;
    Subscription: ResolverTypeWrapper<{}>;
    SumUpAccessTokenResponse: ResolverTypeWrapper<GQSumUpAccessTokenResponse>;
    Tag: ResolverTypeWrapper<GQTag>;
    TagAction: ResolverTypeWrapper<GQTagAction>;
    TagActionPagination: ResolverTypeWrapper<GQTagActionPagination>;
    TagCreate: GQTagCreate;
    TagDeleteResponse: ResolverTypeWrapper<GQTagDeleteResponse>;
    TagGroup: ResolverTypeWrapper<GQTagGroup>;
    TagGroupCreate: GQTagGroupCreate;
    TagGroupDeleteResponse: ResolverTypeWrapper<GQTagGroupDeleteResponse>;
    TagGroupInput: GQTagGroupInput;
    TagGroupPagination: ResolverTypeWrapper<GQTagGroupPagination>;
    TagGroupSearchInput: GQTagGroupSearchInput;
    TagInput: GQTagInput;
    TagPagination: ResolverTypeWrapper<GQTagPagination>;
    TagSearchInput: GQTagSearchInput;
    TaskResult: ResolverTypeWrapper<GQTaskResult>;
    TaskResultPagination: ResolverTypeWrapper<GQTaskResultPagination>;
    TssStateEnum: GQTssStateEnum;
    TypeSearchInput: GQTypeSearchInput;
    User: ResolverTypeWrapper<GQUser>;
    UserDeleteResponse: ResolverTypeWrapper<GQUserDeleteResponse>;
    UserInput: GQUserInput;
    UserInputRole: GQUserInputRole;
    UserPagination: ResolverTypeWrapper<GQUserPagination>;
    UserRole: ResolverTypeWrapper<GQUserRole>;
    UserRoleConfiguration: ResolverTypeWrapper<GQUserRoleConfiguration>;
    UserRoleInput: GQUserRoleInput;
    UserSearchInput: GQUserSearchInput;
    Vat: ResolverTypeWrapper<GQVat>;
    VatCreateInput: GQVatCreateInput;
    VatDeleteResponse: ResolverTypeWrapper<GQVatDeleteResponse>;
    VatPagination: ResolverTypeWrapper<GQVatPagination>;
    VenueAccessAccessType: ResolverTypeWrapper<GQVenueAccessAccessType>;
    VenueAccessCreateType: GQVenueAccessCreateType;
    VenueAccessEvent: ResolverTypeWrapper<GQVenueAccessEvent>;
    VenueAccessParameters: ResolverTypeWrapper<GQVenueAccessParameters>;
    VenueAccessParametersBulk: ResolverTypeWrapper<GQVenueAccessParametersBulk>;
    VenueAccessSettings: ResolverTypeWrapper<GQVenueAccessSettings>;
    VenueAccessTicketCancelled: ResolverTypeWrapper<GQVenueAccessTicketCancelled>;
    VenueAccessTicketCreated: ResolverTypeWrapper<GQVenueAccessTicketCreated>;
    ViProduct: ResolverTypeWrapper<GQViProduct>;
    ViProductPagination: ResolverTypeWrapper<GQViProductPagination>;
    ViWarehouse: ResolverTypeWrapper<GQViWarehouse>;
    ViWarehousePagination: ResolverTypeWrapper<GQViWarehousePagination>;
    VirtualPrinter: ResolverTypeWrapper<GQVirtualPrinter>;
    VirtualPrinterCreate: GQVirtualPrinterCreate;
    VirtualPrinterDeleteResponse: ResolverTypeWrapper<GQVirtualPrinterDeleteResponse>;
    VirtualPrinterDepartment: ResolverTypeWrapper<GQVirtualPrinterDepartment>;
    VirtualPrinterDepartmentSave: GQVirtualPrinterDepartmentSave;
    VirtualPrinterPagination: ResolverTypeWrapper<GQVirtualPrinterPagination>;
    VirtualPrinterSave: GQVirtualPrinterSave;
    VirtualPrinterSearchInput: GQVirtualPrinterSearchInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type GQResolversParentTypes = {
    Account: GQAccount;
    AccountBookkeepingPagination: GQAccountBookkeepingPagination;
    AccountBookkeepingTransaction: GQAccountBookkeepingTransaction;
    AccountBookkeepingTransactionPagination: GQAccountBookkeepingTransactionPagination;
    AccountBookkeepingTransactionSearchInput: GQAccountBookkeepingTransactionSearchInput;
    AccountBuyFundsResponse: GQAccountBuyFundsResponse;
    AccountCloseResponse: GQAccountCloseResponse;
    AccountCreate: GQAccountCreate;
    AccountInput: GQAccountInput;
    AccountOpenResponse: GQAccountOpenResponse;
    AccountPagination: GQAccountPagination;
    AccountPayAmountResponse: GQAccountPayAmountResponse;
    AccountRefundAmountResponse: GQAccountRefundAmountResponse;
    AccountReturnFundsResponse: GQAccountReturnFundsResponse;
    AccountRevertTransactionResponse: GQAccountRevertTransactionResponse;
    AccountSearchInput: GQAccountSearchInput;
    AccountTransaction: GQAccountTransaction;
    AccountTransactionPagination: GQAccountTransactionPagination;
    AccountTransactionSearchInput: GQAccountTransactionSearchInput;
    AddEventResponse: GQAddEventResponse;
    AdyenSessionsResponse: GQAdyenSessionsResponse;
    AdyenStore: GQAdyenStore;
    AdyenStoreLocation: GQAdyenStoreLocation;
    AdyenStoresPagination: GQAdyenStoresPagination;
    AdyenTerminal: GQAdyenTerminal;
    AdyenTerminalAssignment: GQAdyenTerminalAssignment;
    AdyenTerminalConnectivity: GQAdyenTerminalConnectivity;
    AdyenTerminalConnectivityBluetooth: GQAdyenTerminalConnectivityBluetooth;
    AdyenTerminalConnectivityCellular: GQAdyenTerminalConnectivityCellular;
    AdyenTerminalConnectivityEthernet: GQAdyenTerminalConnectivityEthernet;
    AdyenTerminalConnectivityWifi: GQAdyenTerminalConnectivityWifi;
    AdyenTerminalsPagination: GQAdyenTerminalsPagination;
    AdyenTerminalsResponse: GQAdyenTerminalsResponse;
    AmountSearchInput: GQAmountSearchInput;
    AppData: GQAppData;
    Approval: GQApproval;
    ApprovalInput: GQApprovalInput;
    ApprovalPagination: GQApprovalPagination;
    ApprovalSearchInput: GQApprovalSearchInput;
    ApprovalToken: GQApprovalToken;
    ApprovalTokenGroup: GQApprovalTokenGroup;
    ApprovalTokenGroupInput: GQApprovalTokenGroupInput;
    ApprovalTokenGroupPagination: GQApprovalTokenGroupPagination;
    ApprovalTokenGroupSearchInput: GQApprovalTokenGroupSearchInput;
    ApprovalTokenInput: GQApprovalTokenInput;
    ApprovalTokenPagination: GQApprovalTokenPagination;
    ApprovalTokenSearchInput: GQApprovalTokenSearchInput;
    AuthAttempt: GQAuthAttempt;
    AuthToken: GQAuthToken;
    Balance: GQBalance;
    BookkeepingAccount: GQBookkeepingAccount;
    Boolean: Scalars["Boolean"];
    BooleanResponse: GQBooleanResponse;
    BooleanSearchInput: GQBooleanSearchInput;
    BuyAccountFunds: GQBuyAccountFunds;
    Byte: Scalars["Byte"];
    CanPeriodCardBeRenewedResponse: GQCanPeriodCardBeRenewedResponse;
    CanPeriodCardBeUpgradedResponse: GQCanPeriodCardBeUpgradedResponse;
    CardTransaction: GQCardTransaction;
    CardTransactionPagination: GQCardTransactionPagination;
    CardTransactionSearchInput: GQCardTransactionSearchInput;
    CashDifferencePerMethod: GQCashDifferencePerMethod;
    CashInfoPerMethod: GQCashInfoPerMethod;
    CashRegister: GQCashRegister;
    CashRegisterCreateInput: GQCashRegisterCreateInput;
    CashRegisterDeleteResponse: GQCashRegisterDeleteResponse;
    CashRegisterEditInput: GQCashRegisterEditInput;
    CashRegisterPagination: GQCashRegisterPagination;
    CashRegisterSearchInput: GQCashRegisterSearchInput;
    CashRegisterStatus: GQCashRegisterStatus;
    CashRegisterStatusPagination: GQCashRegisterStatusPagination;
    CashRegisterStatusSearchInput: GQCashRegisterStatusSearchInput;
    CashRegisterVersion: GQCashRegisterVersion;
    CashSalePerMethod: GQCashSalePerMethod;
    ChartAccount: GQChartAccount;
    ChartAccountInput: GQChartAccountInput;
    ChartAccounts: GQChartAccounts;
    ChartOfAccountNo: GQChartOfAccountNo;
    CmpEvent: GQCmpEvent;
    CmpEventCreateType: GQCmpEventCreateType;
    CmpEventNoProducts: GQCmpEventNoProducts;
    CmpEventOrderCreated: GQCmpEventOrderCreated;
    CmpEventOrderReceipt: GQCmpEventOrderReceipt;
    CmpEventPagination: GQCmpEventPagination;
    CmpEventPayment: GQCmpEventPayment;
    CmpEventProduct: GQCmpEventProduct;
    CmpEventProductItem: GQCmpEventProductItem;
    CmpEventProductPagination: GQCmpEventProductPagination;
    CmpGiftcardBalance: GQCmpGiftcardBalance;
    CmpGiftcardPayAmountResponse: GQCmpGiftcardPayAmountResponse;
    CmpGiftcardRefundAmountResponse: GQCmpGiftcardRefundAmountResponse;
    CmpInvoiceCustomer: GQCmpInvoiceCustomer;
    CmpInvoiceCustomerResponse: GQCmpInvoiceCustomerResponse;
    CmpInvoicePaymentMethod: GQCmpInvoicePaymentMethod;
    CmpProduct: GQCmpProduct;
    CmpProductPagination: GQCmpProductPagination;
    CmpProductResponse: GQCmpProductResponse;
    CmpProductSettings: GQCmpProductSettings;
    CmpProductSettingsInput: GQCmpProductSettingsInput;
    Configuration: GQConfiguration;
    CreateTssResponse: GQCreateTssResponse;
    Currency: GQCurrency;
    CurrencyDeleteResponse: GQCurrencyDeleteResponse;
    CurrencyInput: GQCurrencyInput;
    CurrencyPagination: GQCurrencyPagination;
    CursorPagination: GQCursorPagination;
    CursorPaginationInput: GQCursorPaginationInput;
    CustomItem: GQCustomItem;
    Customer: GQCustomer;
    CustomerAssignTagsRelationResponse: GQCustomerAssignTagsRelationResponse;
    CustomerCreate: GQCustomerCreate;
    CustomerDeleteResponse: GQCustomerDeleteResponse;
    CustomerGroup: GQCustomerGroup;
    CustomerGroupCreate: GQCustomerGroupCreate;
    CustomerGroupDeleteResponse: GQCustomerGroupDeleteResponse;
    CustomerGroupInput: GQCustomerGroupInput;
    CustomerGroupPagination: GQCustomerGroupPagination;
    CustomerGroupSearchInput: GQCustomerGroupSearchInput;
    CustomerInput: GQCustomerInput;
    CustomerPagination: GQCustomerPagination;
    CustomerSearchInput: GQCustomerSearchInput;
    Dashboard: GQDashboard;
    DashboardAccountItem: GQDashboardAccountItem;
    DashboardAmountByHourItem: GQDashboardAmountByHourItem;
    DashboardCashRegister: GQDashboardCashRegister;
    DashboardCashRegisterPagination: GQDashboardCashRegisterPagination;
    DashboardDepartmentItem: GQDashboardDepartmentItem;
    DashboardProductGroupItem: GQDashboardProductGroupItem;
    DashboardProductItem: GQDashboardProductItem;
    DashboardTotals: GQDashboardTotals;
    Date: Scalars["Date"];
    DateSearchInput: GQDateSearchInput;
    DateValues: GQDateValues;
    Department: GQDepartment;
    DepartmentDeleteResponse: GQDepartmentDeleteResponse;
    DepartmentInput: GQDepartmentInput;
    DepartmentPagination: GQDepartmentPagination;
    DepartmentSearchInput: GQDepartmentSearchInput;
    Device: GQDevice;
    DeviceCapabilitiesInput: GQDeviceCapabilitiesInput;
    DeviceInfoInput: GQDeviceInfoInput;
    DevicePagination: GQDevicePagination;
    DevicePinCodeValidation: GQDevicePinCodeValidation;
    DevicePrinterInput: GQDevicePrinterInput;
    Discount: GQDiscount;
    DiscountInput: GQDiscountInput;
    DiscountPagination: GQDiscountPagination;
    DiscountSearchInput: GQDiscountSearchInput;
    DiscountTemplate: GQDiscountTemplate;
    DiscountTemplateInput: GQDiscountTemplateInput;
    EconomicSettings: GQEconomicSettings;
    EconomicSettingsInput: GQEconomicSettingsInput;
    EconomicSyncJob: GQEconomicSyncJob;
    EconomicSyncJobPagination: GQEconomicSyncJobPagination;
    Entity: GQResolversParentTypes["POS"] | GQResolversParentTypes["Partner"];
    EntityConfig: GQEntityConfig;
    EntityConfigDeleteResponse: GQEntityConfigDeleteResponse;
    Event: GQEvent;
    EventInput: GQEventInput;
    EventQueryInput: GQEventQueryInput;
    File: GQFile;
    FiskalyAccessTokenResponse: GQFiskalyAccessTokenResponse;
    FiskalyClient: GQFiskalyClient;
    FiskalyClientList: GQFiskalyClientList;
    FiskalyConfiguration: GQFiskalyConfiguration;
    FiskalyDSFinVKExport: GQFiskalyDsFinVkExport;
    FiskalyDSFinVKExportInput: GQFiskalyDsFinVkExportInput;
    FiskalyDSFinVKExportList: GQFiskalyDsFinVkExportList;
    FiskalyEstablishment: GQFiskalyEstablishment;
    FiskalyEstablishmentInput: GQFiskalyEstablishmentInput;
    FiskalyEstablishmentList: GQFiskalyEstablishmentList;
    FiskalyEstablishmentMapping: GQFiskalyEstablishmentMapping;
    FiskalyEstablishmentMappingInput: GQFiskalyEstablishmentMappingInput;
    FiskalyEstablishmentMappingList: GQFiskalyEstablishmentMappingList;
    FiskalyEstablishmentSubmission: GQFiskalyEstablishmentSubmission;
    FiskalyEstablishmentSubmissionDownload: GQFiskalyEstablishmentSubmissionDownload;
    FiskalyEstablishmentSubmissionInput: GQFiskalyEstablishmentSubmissionInput;
    FiskalyEstablishmentSubmissionList: GQFiskalyEstablishmentSubmissionList;
    FiskalyOrganization: GQFiskalyOrganization;
    FiskalyOrganizationInput: GQFiskalyOrganizationInput;
    FiskalyOrganizations: GQFiskalyOrganizations;
    FiskalyOrganizationsPagination: GQFiskalyOrganizationsPagination;
    FiskalyRemoteCashRegister: GQFiskalyRemoteCashRegister;
    FiskalyRemoteCashRegisterList: GQFiskalyRemoteCashRegisterList;
    FiskalyRemoteClient: GQFiskalyRemoteClient;
    FiskalyRemoteClientList: GQFiskalyRemoteClientList;
    FiskalyRemoteEstablishmentSubmissionList: GQFiskalyRemoteEstablishmentSubmissionList;
    FiskalySettings: GQFiskalySettings;
    FiskalySettingsInput: GQFiskalySettingsInput;
    FiskalyTaxPayer:
        | GQResolversParentTypes["FiskalyTaxPayerLegal"]
        | GQResolversParentTypes["FiskalyTaxPayerNatural"];
    FiskalyTaxPayerLegal: GQFiskalyTaxPayerLegal;
    FiskalyTaxPayerLegalInput: GQFiskalyTaxPayerLegalInput;
    FiskalyTaxPayerNatural: GQFiskalyTaxPayerNatural;
    FiskalyTaxPayerNaturalInput: GQFiskalyTaxPayerNaturalInput;
    FiskalyTss: GQFiskalyTss;
    FiskalyTssList: GQFiskalyTssList;
    Float: Scalars["Float"];
    Function:
        | GQResolversParentTypes["BuyAccountFunds"]
        | GQResolversParentTypes["CustomItem"];
    GpsPoint: GQGpsPoint;
    GpsPointInput: GQGpsPointInput;
    ID: Scalars["ID"];
    IFiskalyTaxPayer:
        | GQResolversParentTypes["FiskalyTaxPayerLegal"]
        | GQResolversParentTypes["FiskalyTaxPayerNatural"];
    IPagination:
        | GQResolversParentTypes["AccountBookkeepingPagination"]
        | GQResolversParentTypes["AccountBookkeepingTransactionPagination"]
        | GQResolversParentTypes["AccountPagination"]
        | GQResolversParentTypes["AccountTransactionPagination"]
        | GQResolversParentTypes["AdyenStoresPagination"]
        | GQResolversParentTypes["AdyenTerminalsPagination"]
        | GQResolversParentTypes["ApprovalPagination"]
        | GQResolversParentTypes["ApprovalTokenGroupPagination"]
        | GQResolversParentTypes["ApprovalTokenPagination"]
        | GQResolversParentTypes["CardTransactionPagination"]
        | GQResolversParentTypes["CashRegisterPagination"]
        | GQResolversParentTypes["CashRegisterStatusPagination"]
        | GQResolversParentTypes["CmpEventPagination"]
        | GQResolversParentTypes["CmpEventProductPagination"]
        | GQResolversParentTypes["CmpProductPagination"]
        | GQResolversParentTypes["CurrencyPagination"]
        | GQResolversParentTypes["CustomerGroupPagination"]
        | GQResolversParentTypes["CustomerPagination"]
        | GQResolversParentTypes["DashboardCashRegisterPagination"]
        | GQResolversParentTypes["DepartmentPagination"]
        | GQResolversParentTypes["DevicePagination"]
        | GQResolversParentTypes["DiscountPagination"]
        | GQResolversParentTypes["EconomicSyncJobPagination"]
        | GQResolversParentTypes["FiskalyOrganizationsPagination"]
        | GQResolversParentTypes["IntegrationPagination"]
        | GQResolversParentTypes["InventoryProductNoteTemplatePagination"]
        | GQResolversParentTypes["InventoryProductPagination"]
        | GQResolversParentTypes["InvoiceRMPagination"]
        | GQResolversParentTypes["LayoutEntityPagination"]
        | GQResolversParentTypes["LayoutPagination"]
        | GQResolversParentTypes["LogPagination"]
        | GQResolversParentTypes["MerchantPagination"]
        | GQResolversParentTypes["MiscButtonsPagination"]
        | GQResolversParentTypes["PaymentConfigurationPagination"]
        | GQResolversParentTypes["PaymentMethodPagination"]
        | GQResolversParentTypes["PrinterPagination"]
        | GQResolversParentTypes["ProductGroupPagination"]
        | GQResolversParentTypes["ProductPagination"]
        | GQResolversParentTypes["RolePagination"]
        | GQResolversParentTypes["SaftJobPagination"]
        | GQResolversParentTypes["ShiftRMPagination"]
        | GQResolversParentTypes["SoftpayCloudTerminalsPagination"]
        | GQResolversParentTypes["SoftpayMerchantsPagination"]
        | GQResolversParentTypes["SoftpayMiaMerchantsPagination"]
        | GQResolversParentTypes["TagActionPagination"]
        | GQResolversParentTypes["TagGroupPagination"]
        | GQResolversParentTypes["TagPagination"]
        | GQResolversParentTypes["TaskResultPagination"]
        | GQResolversParentTypes["UserPagination"]
        | GQResolversParentTypes["VatPagination"]
        | GQResolversParentTypes["ViProductPagination"]
        | GQResolversParentTypes["ViWarehousePagination"]
        | GQResolversParentTypes["VirtualPrinterPagination"];
    Int: Scalars["Int"];
    Integration: GQIntegration;
    IntegrationAccount: GQIntegrationAccount;
    IntegrationArray: GQIntegrationArray;
    IntegrationCreate: GQIntegrationCreate;
    IntegrationInput: GQIntegrationInput;
    IntegrationPagination: GQIntegrationPagination;
    IntegrationSettings:
        | GQResolversParentTypes["CmpProductSettings"]
        | GQResolversParentTypes["EconomicSettings"]
        | GQResolversParentTypes["FiskalySettings"]
        | GQResolversParentTypes["PartnerApiSettings"]
        | GQResolversParentTypes["VenueAccessSettings"];
    InventoryProduct: GQInventoryProduct;
    InventoryProductCreate: GQInventoryProductCreate;
    InventoryProductInput: GQInventoryProductInput;
    InventoryProductNoteTemplate: GQInventoryProductNoteTemplate;
    InventoryProductNoteTemplateCreate: GQInventoryProductNoteTemplateCreate;
    InventoryProductNoteTemplateInput: GQInventoryProductNoteTemplateInput;
    InventoryProductNoteTemplatePagination: GQInventoryProductNoteTemplatePagination;
    InventoryProductPagination: GQInventoryProductPagination;
    InvoiceAmount: GQInvoiceAmount;
    InvoiceAmountPerMonth: GQInvoiceAmountPerMonth;
    InvoiceCount: GQInvoiceCount;
    InvoiceExternalReceipt: GQInvoiceExternalReceipt;
    InvoiceHourSales: GQInvoiceHourSales;
    InvoiceItemExternalRM: GQInvoiceItemExternalRm;
    InvoiceItemRM: GQInvoiceItemRm;
    InvoicePaymentRM: GQInvoicePaymentRm;
    InvoiceRM: GQInvoiceRm;
    InvoiceRMPagination: GQInvoiceRmPagination;
    InvoiceSearchInput: GQInvoiceSearchInput;
    JSON: Scalars["JSON"];
    Layout: GQLayout;
    LayoutCreate: GQLayoutCreate;
    LayoutDeleteResponse: GQLayoutDeleteResponse;
    LayoutEntity: Omit<GQLayoutEntity, "data"> & {
        data: GQResolversParentTypes["Function"];
    };
    LayoutEntityCreate: GQLayoutEntityCreate;
    LayoutEntityPagination: GQLayoutEntityPagination;
    LayoutEntitySave: GQLayoutEntitySave;
    LayoutEntitySearchInput: GQLayoutEntitySearchInput;
    LayoutPagination: GQLayoutPagination;
    LayoutSave: GQLayoutSave;
    LayoutSearchInput: GQLayoutSearchInput;
    Log: GQLog;
    LogPagination: GQLogPagination;
    LogSearchInput: GQLogSearchInput;
    Logo: GQLogo;
    LogoInput: GQLogoInput;
    Me: GQMe;
    MeasurementUnit: GQMeasurementUnit;
    Merchant: GQMerchant;
    MerchantChartOfAccount: GQMerchantChartOfAccount;
    MerchantChartOfAccountInput: GQMerchantChartOfAccountInput;
    MerchantChartOfAccounts: GQMerchantChartOfAccounts;
    MerchantCreate: GQMerchantCreate;
    MerchantDeleteResponse: GQMerchantDeleteResponse;
    MerchantInput: GQMerchantInput;
    MerchantPagination: GQMerchantPagination;
    MerchantSearchInput: GQMerchantSearchInput;
    MiscButtons: GQMiscButtons;
    MiscButtonsDeleteResponse: GQMiscButtonsDeleteResponse;
    MiscButtonsInput: GQMiscButtonsInput;
    MiscButtonsPagination: GQMiscButtonsPagination;
    Mutation: {};
    NumberSearchInput: GQNumberSearchInput;
    POS: GQPos;
    Pagination: GQPagination;
    PaginationInput: GQPaginationInput;
    Partner: GQPartner;
    PartnerApiSettings: GQPartnerApiSettings;
    PaymentConfiguration: GQPaymentConfiguration;
    PaymentConfigurationDeleteResponse: GQPaymentConfigurationDeleteResponse;
    PaymentConfigurationInput: GQPaymentConfigurationInput;
    PaymentConfigurationMethod: GQPaymentConfigurationMethod;
    PaymentConfigurationMethodInput: GQPaymentConfigurationMethodInput;
    PaymentConfigurationPagination: GQPaymentConfigurationPagination;
    PaymentMethod: GQPaymentMethod;
    PaymentMethodDeleteResponse: GQPaymentMethodDeleteResponse;
    PaymentMethodInput: GQPaymentMethodInput;
    PaymentMethodPagination: GQPaymentMethodPagination;
    PercentSearchInput: GQPercentSearchInput;
    Printer: GQPrinter;
    PrinterDeleteResponse: GQPrinterDeleteResponse;
    PrinterPagination: GQPrinterPagination;
    PrinterRegister: GQPrinterRegister;
    PrinterSave: GQPrinterSave;
    PrinterSearchInput: GQPrinterSearchInput;
    Product: GQProduct;
    Product2ViProduct2MeasurementUnit: GQProduct2ViProduct2MeasurementUnit;
    Product2ViProduct2MeasurementUnitInput: GQProduct2ViProduct2MeasurementUnitInput;
    ProductBarcode: GQProductBarcode;
    ProductBarcodeInput: GQProductBarcodeInput;
    ProductDeleteResponse: GQProductDeleteResponse;
    ProductGroup: GQProductGroup;
    ProductGroupDeleteResponse: GQProductGroupDeleteResponse;
    ProductGroupInput: GQProductGroupInput;
    ProductGroupPagination: GQProductGroupPagination;
    ProductGroupSearchInput: GQProductGroupSearchInput;
    ProductInput: GQProductInput;
    ProductPagination: GQProductPagination;
    ProductRelationInput: GQProductRelationInput;
    ProductSearchInput: GQProductSearchInput;
    Query: {};
    RemoteEstablishmentSubmission: GQRemoteEstablishmentSubmission;
    ReportCashRegister: GQReportCashRegister;
    ReportDepartment: GQReportDepartment;
    ReportParameters: GQReportParameters;
    ReportProduct: GQReportProduct;
    ReportProductGroup: GQReportProductGroup;
    ReportUser: GQReportUser;
    Role: GQRole;
    RoleDeleteResponse: GQRoleDeleteResponse;
    RoleInput: GQRoleInput;
    RolePagination: GQRolePagination;
    RolePermission: GQRolePermission;
    RolePermissionInput: GQRolePermissionInput;
    SaftJob: GQSaftJob;
    SaftJobPagination: GQSaftJobPagination;
    SearchInput: GQSearchInput;
    SelectUserRoleType: GQSelectUserRoleType;
    ShiftFundsRM: GQShiftFundsRm;
    ShiftPaymentCardRM: GQShiftPaymentCardRm;
    ShiftPaymentRM: GQShiftPaymentRm;
    ShiftRM: GQShiftRm;
    ShiftRMPagination: GQShiftRmPagination;
    ShiftSalesData: GQShiftSalesData;
    ShiftSalesDataByProductGroup: GQShiftSalesDataByProductGroup;
    ShiftSearchInput: GQShiftSearchInput;
    SoftpayAccessTokenResponse: GQSoftpayAccessTokenResponse;
    SoftpayCloudStore: GQSoftpayCloudStore;
    SoftpayCloudTerminal: GQSoftpayCloudTerminal;
    SoftpayCloudTerminalsPagination: GQSoftpayCloudTerminalsPagination;
    SoftpayMerchant: GQSoftpayMerchant;
    SoftpayMerchantsPagination: GQSoftpayMerchantsPagination;
    SoftpayMiaAdditionalData: GQSoftpayMiaAdditionalData;
    SoftpayMiaMerchant: GQSoftpayMiaMerchant;
    SoftpayMiaMerchantsPagination: GQSoftpayMiaMerchantsPagination;
    SoftpayMiaProcessorData: GQSoftpayMiaProcessorData;
    SoftpayMiaStore: GQSoftpayMiaStore;
    SoftpayMiaTerminal: GQSoftpayMiaTerminal;
    String: Scalars["String"];
    StringSearchInput: GQStringSearchInput;
    Subscription: {};
    SumUpAccessTokenResponse: GQSumUpAccessTokenResponse;
    Tag: GQTag;
    TagAction: GQTagAction;
    TagActionPagination: GQTagActionPagination;
    TagCreate: GQTagCreate;
    TagDeleteResponse: GQTagDeleteResponse;
    TagGroup: GQTagGroup;
    TagGroupCreate: GQTagGroupCreate;
    TagGroupDeleteResponse: GQTagGroupDeleteResponse;
    TagGroupInput: GQTagGroupInput;
    TagGroupPagination: GQTagGroupPagination;
    TagGroupSearchInput: GQTagGroupSearchInput;
    TagInput: GQTagInput;
    TagPagination: GQTagPagination;
    TagSearchInput: GQTagSearchInput;
    TaskResult: GQTaskResult;
    TaskResultPagination: GQTaskResultPagination;
    TypeSearchInput: GQTypeSearchInput;
    User: GQUser;
    UserDeleteResponse: GQUserDeleteResponse;
    UserInput: GQUserInput;
    UserInputRole: GQUserInputRole;
    UserPagination: GQUserPagination;
    UserRole: GQUserRole;
    UserRoleConfiguration: GQUserRoleConfiguration;
    UserRoleInput: GQUserRoleInput;
    UserSearchInput: GQUserSearchInput;
    Vat: GQVat;
    VatCreateInput: GQVatCreateInput;
    VatDeleteResponse: GQVatDeleteResponse;
    VatPagination: GQVatPagination;
    VenueAccessAccessType: GQVenueAccessAccessType;
    VenueAccessCreateType: GQVenueAccessCreateType;
    VenueAccessEvent: GQVenueAccessEvent;
    VenueAccessParameters: GQVenueAccessParameters;
    VenueAccessParametersBulk: GQVenueAccessParametersBulk;
    VenueAccessSettings: GQVenueAccessSettings;
    VenueAccessTicketCancelled: GQVenueAccessTicketCancelled;
    VenueAccessTicketCreated: GQVenueAccessTicketCreated;
    ViProduct: GQViProduct;
    ViProductPagination: GQViProductPagination;
    ViWarehouse: GQViWarehouse;
    ViWarehousePagination: GQViWarehousePagination;
    VirtualPrinter: GQVirtualPrinter;
    VirtualPrinterCreate: GQVirtualPrinterCreate;
    VirtualPrinterDeleteResponse: GQVirtualPrinterDeleteResponse;
    VirtualPrinterDepartment: GQVirtualPrinterDepartment;
    VirtualPrinterDepartmentSave: GQVirtualPrinterDepartmentSave;
    VirtualPrinterPagination: GQVirtualPrinterPagination;
    VirtualPrinterSave: GQVirtualPrinterSave;
    VirtualPrinterSearchInput: GQVirtualPrinterSearchInput;
};

export type GQAccountResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Account"] = GQResolversParentTypes["Account"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    balance?: Resolver<
        GQResolversTypes["Balance"],
        ParentType,
        ContextType,
        Partial<GQAccountBalanceArgs>
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    customer?: Resolver<
        Maybe<GQResolversTypes["Customer"]>,
        ParentType,
        ContextType
    >;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    status?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    systemLabel?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    tags?: Resolver<
        GQResolversTypes["TagPagination"],
        ParentType,
        ContextType,
        Partial<GQAccountTagsArgs>
    >;
    transactions?: Resolver<
        GQResolversTypes["AccountTransactionPagination"],
        ParentType,
        ContextType,
        Partial<GQAccountTransactionsArgs>
    >;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    vat?: Resolver<Maybe<GQResolversTypes["Vat"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountBookkeepingPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountBookkeepingPagination"] = GQResolversParentTypes["AccountBookkeepingPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["BookkeepingAccount"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountBookkeepingTransactionResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountBookkeepingTransaction"] = GQResolversParentTypes["AccountBookkeepingTransaction"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    invoiceId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    transactionAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountBookkeepingTransactionPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountBookkeepingTransactionPagination"] = GQResolversParentTypes["AccountBookkeepingTransactionPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["AccountBookkeepingTransaction"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountBuyFundsResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountBuyFundsResponse"] = GQResolversParentTypes["AccountBuyFundsResponse"]
> = {
    status?: Resolver<
        GQResolversTypes["AccountBuyFundsStatus"],
        ParentType,
        ContextType
    >;
    transactionId?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountCloseResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountCloseResponse"] = GQResolversParentTypes["AccountCloseResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountOpenResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountOpenResponse"] = GQResolversParentTypes["AccountOpenResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountPagination"] = GQResolversParentTypes["AccountPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Account"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountPayAmountResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountPayAmountResponse"] = GQResolversParentTypes["AccountPayAmountResponse"]
> = {
    receipt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        GQResolversTypes["AccountTransactionStatus"],
        ParentType,
        ContextType
    >;
    transactionId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    type?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountRefundAmountResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountRefundAmountResponse"] = GQResolversParentTypes["AccountRefundAmountResponse"]
> = {
    receipt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        GQResolversTypes["AccountTransactionStatus"],
        ParentType,
        ContextType
    >;
    transactionId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    type?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountReturnFundsResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountReturnFundsResponse"] = GQResolversParentTypes["AccountReturnFundsResponse"]
> = {
    status?: Resolver<
        GQResolversTypes["AccountReturnFundsStatus"],
        ParentType,
        ContextType
    >;
    transactionId?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountRevertTransactionResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountRevertTransactionResponse"] = GQResolversParentTypes["AccountRevertTransactionResponse"]
> = {
    status?: Resolver<
        GQResolversTypes["AccountRevertTransactionStatus"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountTransactionResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountTransaction"] = GQResolversParentTypes["AccountTransaction"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    invoiceId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    tag?: Resolver<Maybe<GQResolversTypes["Tag"]>, ParentType, ContextType>;
    transactionAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    user?: Resolver<Maybe<GQResolversTypes["User"]>, ParentType, ContextType>;
    userId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAccountTransactionPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AccountTransactionPagination"] = GQResolversParentTypes["AccountTransactionPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["AccountTransaction"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAddEventResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AddEventResponse"] = GQResolversParentTypes["AddEventResponse"]
> = {
    success?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenSessionsResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenSessionsResponse"] = GQResolversParentTypes["AdyenSessionsResponse"]
> = {
    id?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    token?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenStoreResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenStore"] = GQResolversParentTypes["AdyenStore"]
> = {
    address?: Resolver<
        Maybe<GQResolversTypes["AdyenStoreLocation"]>,
        ParentType,
        ContextType
    >;
    description?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    externalReferenceId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    merchantId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    phoneNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    reference?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    shopperStatement?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        Maybe<GQResolversTypes["AdyenStoreStatus"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenStoreLocationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenStoreLocation"] = GQResolversParentTypes["AdyenStoreLocation"]
> = {
    city?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    country?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    line1?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    line2?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    line3?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    postalCode?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    stateOrProvince?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenStoresPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenStoresPagination"] = GQResolversParentTypes["AdyenStoresPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["AdyenStore"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenTerminalResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenTerminal"] = GQResolversParentTypes["AdyenTerminal"]
> = {
    assignment?: Resolver<
        Maybe<GQResolversTypes["AdyenTerminalAssignment"]>,
        ParentType,
        ContextType
    >;
    connectivity?: Resolver<
        Maybe<GQResolversTypes["AdyenTerminalConnectivity"]>,
        ParentType,
        ContextType
    >;
    firmwareVersion?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    lastActivityAt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    lastTransactionAt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    model?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    restartLocalTime?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    serialNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenTerminalAssignmentResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenTerminalAssignment"] = GQResolversParentTypes["AdyenTerminalAssignment"]
> = {
    companyId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    merchantId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    storeId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenTerminalConnectivityResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenTerminalConnectivity"] = GQResolversParentTypes["AdyenTerminalConnectivity"]
> = {
    bluetooth?: Resolver<
        Maybe<GQResolversTypes["AdyenTerminalConnectivityBluetooth"]>,
        ParentType,
        ContextType
    >;
    cellular?: Resolver<
        Maybe<GQResolversTypes["AdyenTerminalConnectivityCellular"]>,
        ParentType,
        ContextType
    >;
    ethernet?: Resolver<
        Maybe<GQResolversTypes["AdyenTerminalConnectivityEthernet"]>,
        ParentType,
        ContextType
    >;
    wifi?: Resolver<
        Maybe<GQResolversTypes["AdyenTerminalConnectivityWifi"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenTerminalConnectivityBluetoothResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenTerminalConnectivityBluetooth"] = GQResolversParentTypes["AdyenTerminalConnectivityBluetooth"]
> = {
    ipAddress?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    macAddress?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenTerminalConnectivityCellularResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenTerminalConnectivityCellular"] = GQResolversParentTypes["AdyenTerminalConnectivityCellular"]
> = {
    iccid?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    iccid2?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenTerminalConnectivityEthernetResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenTerminalConnectivityEthernet"] = GQResolversParentTypes["AdyenTerminalConnectivityEthernet"]
> = {
    ipAddress?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    linkNegotiation?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    macAddress?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenTerminalConnectivityWifiResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenTerminalConnectivityWifi"] = GQResolversParentTypes["AdyenTerminalConnectivityWifi"]
> = {
    ipAddress?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    macAddress?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    ssid?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenTerminalsPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenTerminalsPagination"] = GQResolversParentTypes["AdyenTerminalsPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["AdyenTerminal"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAdyenTerminalsResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AdyenTerminalsResponse"] = GQResolversParentTypes["AdyenTerminalsResponse"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["AdyenTerminal"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAppDataResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AppData"] = GQResolversParentTypes["AppData"]
> = {
    approvals?: Resolver<
        Maybe<Array<GQResolversTypes["Approval"]>>,
        ParentType,
        ContextType
    >;
    bookkeepingAccounts?: Resolver<
        Array<GQResolversTypes["BookkeepingAccount"]>,
        ParentType,
        ContextType
    >;
    cashRegister?: Resolver<
        GQResolversTypes["CashRegister"],
        ParentType,
        ContextType
    >;
    cmpEvents?: Resolver<
        Array<GQResolversTypes["CmpEvent"]>,
        ParentType,
        ContextType
    >;
    cmpProducts?: Resolver<
        Array<GQResolversTypes["CmpProduct"]>,
        ParentType,
        ContextType
    >;
    deviceConfig?: Resolver<GQResolversTypes["JSON"], ParentType, ContextType>;
    discounts?: Resolver<
        Array<GQResolversTypes["Discount"]>,
        ParentType,
        ContextType
    >;
    fiskaly?: Resolver<
        Maybe<GQResolversTypes["FiskalyConfiguration"]>,
        ParentType,
        ContextType
    >;
    layout?: Resolver<
        Maybe<GQResolversTypes["Layout"]>,
        ParentType,
        ContextType
    >;
    layoutEntities?: Resolver<
        Array<GQResolversTypes["LayoutEntity"]>,
        ParentType,
        ContextType
    >;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    minimumStructVersion?: Resolver<
        GQResolversTypes["Int"],
        ParentType,
        ContextType
    >;
    miscButtons?: Resolver<
        Maybe<GQResolversTypes["MiscButtons"]>,
        ParentType,
        ContextType
    >;
    paymentConfiguration?: Resolver<
        Maybe<GQResolversTypes["PaymentConfiguration"]>,
        ParentType,
        ContextType
    >;
    printers?: Resolver<
        Array<GQResolversTypes["Printer"]>,
        ParentType,
        ContextType
    >;
    productGroups?: Resolver<
        Array<GQResolversTypes["ProductGroup"]>,
        ParentType,
        ContextType
    >;
    products?: Resolver<
        Array<GQResolversTypes["Product"]>,
        ParentType,
        ContextType
    >;
    structVersion?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    tableLayout?: Resolver<
        Maybe<GQResolversTypes["Layout"]>,
        ParentType,
        ContextType
    >;
    tags?: Resolver<Array<GQResolversTypes["Tag"]>, ParentType, ContextType>;
    vats?: Resolver<Array<GQResolversTypes["Vat"]>, ParentType, ContextType>;
    viProducts?: Resolver<
        Maybe<Array<GQResolversTypes["ViProduct"]>>,
        ParentType,
        ContextType
    >;
    virtualPrinters?: Resolver<
        Maybe<Array<GQResolversTypes["VirtualPrinter"]>>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQApprovalResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Approval"] = GQResolversParentTypes["Approval"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    approvalTokenGroups?: Resolver<
        Array<GQResolversTypes["ApprovalTokenGroup"]>,
        ParentType,
        ContextType
    >;
    approvalTokens?: Resolver<
        Array<GQResolversTypes["ApprovalToken"]>,
        ParentType,
        ContextType
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["ApprovalType"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQApprovalPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ApprovalPagination"] = GQResolversParentTypes["ApprovalPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Approval"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQApprovalTokenResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ApprovalToken"] = GQResolversParentTypes["ApprovalToken"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    approvalTokenGroup?: Resolver<
        Maybe<GQResolversTypes["ApprovalTokenGroup"]>,
        ParentType,
        ContextType
    >;
    approvalTokenGroupId?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<
        GQResolversTypes["ApprovalGroupType"],
        ParentType,
        ContextType
    >;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    value?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQApprovalTokenGroupResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ApprovalTokenGroup"] = GQResolversParentTypes["ApprovalTokenGroup"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    approvalTokens?: Resolver<
        Array<GQResolversTypes["ApprovalToken"]>,
        ParentType,
        ContextType
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQApprovalTokenGroupPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ApprovalTokenGroupPagination"] = GQResolversParentTypes["ApprovalTokenGroupPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["ApprovalTokenGroup"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQApprovalTokenPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ApprovalTokenPagination"] = GQResolversParentTypes["ApprovalTokenPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["ApprovalToken"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAuthAttemptResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AuthAttempt"] = GQResolversParentTypes["AuthAttempt"]
> = {
    successful?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    token?: Resolver<
        Maybe<GQResolversTypes["AuthToken"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQAuthTokenResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["AuthToken"] = GQResolversParentTypes["AuthToken"]
> = {
    access?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    accessExpire?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    now?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    refresh?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQBalanceResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Balance"] = GQResolversParentTypes["Balance"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    receipt?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQBookkeepingAccountResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["BookkeepingAccount"] = GQResolversParentTypes["BookkeepingAccount"]
> = {
    bookkeepingTransactions?: Resolver<
        GQResolversTypes["AccountBookkeepingTransactionPagination"],
        ParentType,
        ContextType,
        Partial<GQBookkeepingAccountBookkeepingTransactionsArgs>
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    systemLabel?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    vat?: Resolver<Maybe<GQResolversTypes["Vat"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQBooleanResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["BooleanResponse"] = GQResolversParentTypes["BooleanResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQBuyAccountFundsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["BuyAccountFunds"] = GQResolversParentTypes["BuyAccountFunds"]
> = {
    amount?: Resolver<Maybe<GQResolversTypes["Int"]>, ParentType, ContextType>;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface GQByteScalarConfig
    extends GraphQLScalarTypeConfig<GQResolversTypes["Byte"], any> {
    name: "Byte";
}

export type GQCanPeriodCardBeRenewedResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CanPeriodCardBeRenewedResponse"] = GQResolversParentTypes["CanPeriodCardBeRenewedResponse"]
> = {
    cardId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    cardToken?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    message?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        GQResolversTypes["PeriodCardRenewalStatus"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCanPeriodCardBeUpgradedResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CanPeriodCardBeUpgradedResponse"] = GQResolversParentTypes["CanPeriodCardBeUpgradedResponse"]
> = {
    cardId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    cardToken?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    message?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        GQResolversTypes["PeriodCardUpgradeStatus"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCardTransactionResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CardTransaction"] = GQResolversParentTypes["CardTransaction"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    cashRegister?: Resolver<
        GQResolversTypes["CashRegister"],
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    invoiceId?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    maskedPan?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    orderId?: Resolver<Maybe<GQResolversTypes["ID"]>, ParentType, ContextType>;
    receipt?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    scheme?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        GQResolversTypes["CardTransactionType"],
        ParentType,
        ContextType
    >;
    transactionAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCardTransactionPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CardTransactionPagination"] = GQResolversParentTypes["CardTransactionPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["CardTransaction"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCashDifferencePerMethodResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CashDifferencePerMethod"] = GQResolversParentTypes["CashDifferencePerMethod"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    currencyCode?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    currencyRate?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    paymentMethodId?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCashInfoPerMethodResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CashInfoPerMethod"] = GQResolversParentTypes["CashInfoPerMethod"]
> = {
    cashDifferencePerMethod?: Resolver<
        Maybe<Array<GQResolversTypes["CashDifferencePerMethod"]>>,
        ParentType,
        ContextType
    >;
    cashSalePerMethod?: Resolver<
        Maybe<Array<GQResolversTypes["CashSalePerMethod"]>>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCashRegisterResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CashRegister"] = GQResolversParentTypes["CashRegister"]
> = {
    appData?: Resolver<GQResolversTypes["AppData"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    department?: Resolver<
        Maybe<GQResolversTypes["Department"]>,
        ParentType,
        ContextType
    >;
    device?: Resolver<
        Maybe<GQResolversTypes["Device"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    lastAppDataSentAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    serialId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCashRegisterDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CashRegisterDeleteResponse"] = GQResolversParentTypes["CashRegisterDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCashRegisterPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CashRegisterPagination"] = GQResolversParentTypes["CashRegisterPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["CashRegister"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCashRegisterStatusResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CashRegisterStatus"] = GQResolversParentTypes["CashRegisterStatus"]
> = {
    appData?: Resolver<GQResolversTypes["AppData"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    department?: Resolver<
        Maybe<GQResolversTypes["Department"]>,
        ParentType,
        ContextType
    >;
    device?: Resolver<
        Maybe<GQResolversTypes["Device"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    lastAppDataSentAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    serialId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    status?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCashRegisterStatusPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CashRegisterStatusPagination"] = GQResolversParentTypes["CashRegisterStatusPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["CashRegisterStatus"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCashRegisterVersionResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CashRegisterVersion"] = GQResolversParentTypes["CashRegisterVersion"]
> = {
    count?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    label?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCashSalePerMethodResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CashSalePerMethod"] = GQResolversParentTypes["CashSalePerMethod"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    currencyCode?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    currencyRate?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    paymentMethodId?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQChartAccountResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ChartAccount"] = GQResolversParentTypes["ChartAccount"]
> = {
    accountNo?: Resolver<
        Maybe<GQResolversTypes["Int"]>,
        ParentType,
        ContextType
    >;
    productGroup?: Resolver<
        GQResolversTypes["ProductGroup"],
        ParentType,
        ContextType
    >;
    productGroupId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQChartAccountsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ChartAccounts"] = GQResolversParentTypes["ChartAccounts"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["ChartAccount"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQChartOfAccountNoResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ChartOfAccountNo"] = GQResolversParentTypes["ChartOfAccountNo"]
> = {
    merchantAccountNo?: Resolver<
        GQResolversTypes["Int"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpEventResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpEvent"] = GQResolversParentTypes["CmpEvent"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    from?: Resolver<Maybe<GQResolversTypes["Date"]>, ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    products?: Resolver<
        Array<GQResolversTypes["CmpEventProduct"]>,
        ParentType,
        ContextType
    >;
    sequence?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    to?: Resolver<Maybe<GQResolversTypes["Date"]>, ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpEventNoProductsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpEventNoProducts"] = GQResolversParentTypes["CmpEventNoProducts"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    from?: Resolver<Maybe<GQResolversTypes["Date"]>, ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    sequence?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    to?: Resolver<Maybe<GQResolversTypes["Date"]>, ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpEventOrderCreatedResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpEventOrderCreated"] = GQResolversParentTypes["CmpEventOrderCreated"]
> = {
    orderId?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    productItems?: Resolver<
        Array<GQResolversTypes["CmpProductResponse"]>,
        ParentType,
        ContextType
    >;
    receipts?: Resolver<
        Array<GQResolversTypes["CmpEventOrderReceipt"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpEventOrderReceiptResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpEventOrderReceipt"] = GQResolversParentTypes["CmpEventOrderReceipt"]
> = {
    code?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    description?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    title?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    url?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpEventPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpEventPagination"] = GQResolversParentTypes["CmpEventPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["CmpEvent"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpEventProductResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpEventProduct"] = GQResolversParentTypes["CmpEventProduct"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    amount?: Resolver<Maybe<GQResolversTypes["Int"]>, ParentType, ContextType>;
    calendar?: Resolver<
        Maybe<GQResolversTypes["JSON"]>,
        ParentType,
        ContextType
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    externalEventId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    group?: Resolver<GQResolversTypes["ProductGroup"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    sequence?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    shouldPrint?: Resolver<
        GQResolversTypes["ShouldPrintType"],
        ParentType,
        ContextType
    >;
    sms?: Resolver<Maybe<GQResolversTypes["Boolean"]>, ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    upgradeable?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpEventProductPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpEventProductPagination"] = GQResolversParentTypes["CmpEventProductPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["CmpEventProduct"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpGiftcardBalanceResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpGiftcardBalance"] = GQResolversParentTypes["CmpGiftcardBalance"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    expirationDate?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        GQResolversTypes["CmpGiftcardBalanceStatus"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpGiftcardPayAmountResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpGiftcardPayAmountResponse"] = GQResolversParentTypes["CmpGiftcardPayAmountResponse"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    balance?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    createdAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    receipt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        GQResolversTypes["CmpGiftcardTransactionStatus"],
        ParentType,
        ContextType
    >;
    transactionId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpGiftcardRefundAmountResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpGiftcardRefundAmountResponse"] = GQResolversParentTypes["CmpGiftcardRefundAmountResponse"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    balance?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    createdAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    receipt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        GQResolversTypes["CmpGiftcardTransactionStatus"],
        ParentType,
        ContextType
    >;
    transactionId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpInvoiceCustomerResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpInvoiceCustomer"] = GQResolversParentTypes["CmpInvoiceCustomer"]
> = {
    address?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    company?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    email?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    name?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    paymentMethods?: Resolver<
        Array<GQResolversTypes["CmpInvoicePaymentMethod"]>,
        ParentType,
        ContextType
    >;
    phone?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpInvoiceCustomerResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpInvoiceCustomerResponse"] = GQResolversParentTypes["CmpInvoiceCustomerResponse"]
> = {
    customers?: Resolver<
        Array<GQResolversTypes["CmpInvoiceCustomer"]>,
        ParentType,
        ContextType
    >;
    resultsFoundCount?: Resolver<
        Maybe<GQResolversTypes["Int"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<
        Maybe<GQResolversTypes["CmpInvoiceCustomerStatus"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpInvoicePaymentMethodResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpInvoicePaymentMethod"] = GQResolversParentTypes["CmpInvoicePaymentMethod"]
> = {
    allowed?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    description?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpProductResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpProduct"] = GQResolversParentTypes["CmpProduct"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    amount?: Resolver<Maybe<GQResolversTypes["Int"]>, ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    group?: Resolver<GQResolversTypes["ProductGroup"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    sequence?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    sms?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    type?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpProductPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpProductPagination"] = GQResolversParentTypes["CmpProductPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["CmpProduct"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpProductResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpProductResponse"] = GQResolversParentTypes["CmpProductResponse"]
> = {
    description?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    itemId?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    shouldPrint?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    title?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    value?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCmpProductSettingsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CmpProductSettings"] = GQResolversParentTypes["CmpProductSettings"]
> = {
    cmpOrderUrl?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    exchangeName?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    hostname?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    password?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    port?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    queueName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    routingKey?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    username?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    vhost?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQConfigurationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Configuration"] = GQResolversParentTypes["Configuration"]
> = {
    paymentTerminalType?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCreateTssResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CreateTssResponse"] = GQResolversParentTypes["CreateTssResponse"]
> = {
    adminPuk?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCurrencyResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Currency"] = GQResolversParentTypes["Currency"]
> = {
    code?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    rate?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCurrencyDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CurrencyDeleteResponse"] = GQResolversParentTypes["CurrencyDeleteResponse"]
> = {
    status?: Resolver<
        GQResolversTypes["DeleteResponseEnum"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCurrencyPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CurrencyPagination"] = GQResolversParentTypes["CurrencyPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Currency"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCursorPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CursorPagination"] = GQResolversParentTypes["CursorPagination"]
> = {
    limit?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    remaining?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    token?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCustomItemResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CustomItem"] = GQResolversParentTypes["CustomItem"]
> = {
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    productGroupId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCustomerResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Customer"] = GQResolversParentTypes["Customer"]
> = {
    accounts?: Resolver<
        Array<GQResolversTypes["Account"]>,
        ParentType,
        ContextType
    >;
    address?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    city?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    comment?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    contactName?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    cvrNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    email?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    group?: Resolver<
        Maybe<GQResolversTypes["CustomerGroup"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchantId?: Resolver<
        GQResolversTypes["Merchant"],
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    phoneNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    tags?: Resolver<
        GQResolversTypes["TagPagination"],
        ParentType,
        ContextType,
        Partial<GQCustomerTagsArgs>
    >;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    zip?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCustomerAssignTagsRelationResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CustomerAssignTagsRelationResponse"] = GQResolversParentTypes["CustomerAssignTagsRelationResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCustomerDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CustomerDeleteResponse"] = GQResolversParentTypes["CustomerDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCustomerGroupResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CustomerGroup"] = GQResolversParentTypes["CustomerGroup"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCustomerGroupDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CustomerGroupDeleteResponse"] = GQResolversParentTypes["CustomerGroupDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCustomerGroupPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CustomerGroupPagination"] = GQResolversParentTypes["CustomerGroupPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["CustomerGroup"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQCustomerPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["CustomerPagination"] = GQResolversParentTypes["CustomerPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Customer"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDashboardResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Dashboard"] = GQResolversParentTypes["Dashboard"]
> = {
    accounts?: Resolver<
        Array<GQResolversTypes["DashboardAccountItem"]>,
        ParentType,
        ContextType
    >;
    amountsByHour?: Resolver<
        Array<GQResolversTypes["DashboardAmountByHourItem"]>,
        ParentType,
        ContextType
    >;
    departments?: Resolver<
        Array<GQResolversTypes["DashboardDepartmentItem"]>,
        ParentType,
        ContextType
    >;
    from?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    productGroups?: Resolver<
        Array<GQResolversTypes["DashboardProductGroupItem"]>,
        ParentType,
        ContextType
    >;
    products?: Resolver<
        Array<GQResolversTypes["DashboardProductItem"]>,
        ParentType,
        ContextType
    >;
    to?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    totals?: Resolver<
        GQResolversTypes["DashboardTotals"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDashboardAccountItemResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DashboardAccountItem"] = GQResolversParentTypes["DashboardAccountItem"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDashboardAmountByHourItemResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DashboardAmountByHourItem"] = GQResolversParentTypes["DashboardAmountByHourItem"]
> = {
    datetime?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    sum?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDashboardCashRegisterResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DashboardCashRegister"] = GQResolversParentTypes["DashboardCashRegister"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    device?: Resolver<
        Maybe<GQResolversTypes["Device"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<
        Maybe<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDashboardCashRegisterPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DashboardCashRegisterPagination"] = GQResolversParentTypes["DashboardCashRegisterPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["DashboardCashRegister"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDashboardDepartmentItemResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DashboardDepartmentItem"] = GQResolversParentTypes["DashboardDepartmentItem"]
> = {
    avgTransaction?: Resolver<
        GQResolversTypes["Float"],
        ParentType,
        ContextType
    >;
    id?: Resolver<Maybe<GQResolversTypes["ID"]>, ParentType, ContextType>;
    invoices?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    name?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    turnoverAmount?: Resolver<
        GQResolversTypes["Float"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDashboardProductGroupItemResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DashboardProductGroupItem"] = GQResolversParentTypes["DashboardProductGroupItem"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    quantity?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    turnoverAmount?: Resolver<
        GQResolversTypes["Float"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDashboardProductItemResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DashboardProductItem"] = GQResolversParentTypes["DashboardProductItem"]
> = {
    id?: Resolver<Maybe<GQResolversTypes["ID"]>, ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    quantity?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    turnoverAmount?: Resolver<
        GQResolversTypes["Float"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDashboardTotalsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DashboardTotals"] = GQResolversParentTypes["DashboardTotals"]
> = {
    avgTransaction?: Resolver<
        GQResolversTypes["Float"],
        ParentType,
        ContextType
    >;
    invoices?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    turnoverAmount?: Resolver<
        GQResolversTypes["Float"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface GQDateScalarConfig
    extends GraphQLScalarTypeConfig<GQResolversTypes["Date"], any> {
    name: "Date";
}

export type GQDepartmentResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Department"] = GQResolversParentTypes["Department"]
> = {
    createdAt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    viWarehouse?: Resolver<
        Maybe<GQResolversTypes["ViWarehouse"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDepartmentDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DepartmentDeleteResponse"] = GQResolversParentTypes["DepartmentDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDepartmentPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DepartmentPagination"] = GQResolversParentTypes["DepartmentPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Department"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDeviceResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Device"] = GQResolversParentTypes["Device"]
> = {
    appBuild?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    appVersion?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    gps?: Resolver<
        Maybe<GQResolversTypes["GpsPoint"]>,
        ParentType,
        ContextType
    >;
    hardwareModel?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    hardwareProducer?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    isUsingAutoTime?: Resolver<
        Maybe<GQResolversTypes["Boolean"]>,
        ParentType,
        ContextType
    >;
    isUsingAutoTimeZone?: Resolver<
        Maybe<GQResolversTypes["Boolean"]>,
        ParentType,
        ContextType
    >;
    language?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    lastSeen?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    macAddress?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    osName?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    osVersion?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    pinCode?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    serialNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    timeZone?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDevicePaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DevicePagination"] = GQResolversParentTypes["DevicePagination"]
> = {
    data?: Resolver<
        Array<Maybe<GQResolversTypes["Device"]>>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDevicePinCodeValidationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DevicePinCodeValidation"] = GQResolversParentTypes["DevicePinCodeValidation"]
> = {
    valid?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDiscountResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Discount"] = GQResolversParentTypes["Discount"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    conditions?: Resolver<GQResolversTypes["JSON"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    itemQuery?: Resolver<GQResolversTypes["JSON"], ParentType, ContextType>;
    lineDescription?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    maxPerOrder?: Resolver<
        Maybe<GQResolversTypes["Int"]>,
        ParentType,
        ContextType
    >;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["DiscountType"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    value?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    valueType?: Resolver<
        GQResolversTypes["DiscountValueType"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDiscountPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DiscountPagination"] = GQResolversParentTypes["DiscountPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Discount"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQDiscountTemplateResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["DiscountTemplate"] = GQResolversParentTypes["DiscountTemplate"]
> = {
    color?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<
        GQResolversTypes["DiscountValueType"],
        ParentType,
        ContextType
    >;
    value?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQEconomicSettingsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["EconomicSettings"] = GQResolversParentTypes["EconomicSettings"]
> = {
    enableSyncAfterShiftClose?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    enableSyncByProductGroups?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    journalId?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQEconomicSyncJobResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["EconomicSyncJob"] = GQResolversParentTypes["EconomicSyncJob"]
> = {
    attempts?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    lastError?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    runAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    shift?: Resolver<
        Maybe<GQResolversTypes["ShiftRM"]>,
        ParentType,
        ContextType
    >;
    shiftId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQEconomicSyncJobPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["EconomicSyncJobPagination"] = GQResolversParentTypes["EconomicSyncJobPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["EconomicSyncJob"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQEntityResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Entity"] = GQResolversParentTypes["Entity"]
> = {
    __resolveType: TypeResolveFn<"POS" | "Partner", ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
};

export type GQEntityConfigResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["EntityConfig"] = GQResolversParentTypes["EntityConfig"]
> = {
    data?: Resolver<GQResolversTypes["JSON"], ParentType, ContextType>;
    entityId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQEntityConfigDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["EntityConfigDeleteResponse"] = GQResolversParentTypes["EntityConfigDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQEventResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Event"] = GQResolversParentTypes["Event"]
> = {
    aggregateId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    aggregateName?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    data?: Resolver<GQResolversTypes["JSON"], ParentType, ContextType>;
    eventDate?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    eventName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    meta?: Resolver<GQResolversTypes["JSON"], ParentType, ContextType>;
    owner?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    ownerSequence?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    version?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFileResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["File"] = GQResolversParentTypes["File"]
> = {
    byteBuffer?: Resolver<GQResolversTypes["Byte"], ParentType, ContextType>;
    contentType?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    fileName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyAccessTokenResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyAccessTokenResponse"] = GQResolversParentTypes["FiskalyAccessTokenResponse"]
> = {
    accessToken?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    expiresAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    expiresIn?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    refreshToken?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    refreshTokenExpiresAt?: Resolver<
        GQResolversTypes["Date"],
        ParentType,
        ContextType
    >;
    refreshTokenExpiresIn?: Resolver<
        GQResolversTypes["Int"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyClientResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyClient"] = GQResolversParentTypes["FiskalyClient"]
> = {
    cashRegister?: Resolver<
        GQResolversTypes["CashRegister"],
        ParentType,
        ContextType
    >;
    cashRegisterId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    clientState?: Resolver<
        GQResolversTypes["ClientStateEnum"],
        ParentType,
        ContextType
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    establishmentId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    submitBefore?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    tssId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyClientListResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyClientList"] = GQResolversParentTypes["FiskalyClientList"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["FiskalyClient"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyConfigurationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyConfiguration"] = GQResolversParentTypes["FiskalyConfiguration"]
> = {
    clientActive?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    clientId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationActive?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    tssId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyDsFinVkExportResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyDSFinVKExport"] = GQResolversParentTypes["FiskalyDSFinVKExport"]
> = {
    cashPointClosings?: Resolver<
        Array<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    clientId?: Resolver<Maybe<GQResolversTypes["ID"]>, ParentType, ContextType>;
    completedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    error?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    expireAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    exportState?: Resolver<
        GQResolversTypes["ExportState"],
        ParentType,
        ContextType
    >;
    exportUrl?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    format?: Resolver<
        GQResolversTypes["ExportFormat"],
        ParentType,
        ContextType
    >;
    fromDate?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    requestedAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    toDate?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyDsFinVkExportListResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyDSFinVKExportList"] = GQResolversParentTypes["FiskalyDSFinVKExportList"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["FiskalyDSFinVKExport"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyEstablishmentResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyEstablishment"] = GQResolversParentTypes["FiskalyEstablishment"]
> = {
    addressAdditional?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    decommisioningDate?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    designation?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    houseNumber?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    houseNumberSuffix?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    organizationId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    remarks?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    street?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    submitBefore?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    submittedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    town?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    zip?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyEstablishmentListResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyEstablishmentList"] = GQResolversParentTypes["FiskalyEstablishmentList"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["FiskalyEstablishment"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyEstablishmentMappingResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyEstablishmentMapping"] = GQResolversParentTypes["FiskalyEstablishmentMapping"]
> = {
    cashRegister?: Resolver<
        GQResolversTypes["CashRegister"],
        ParentType,
        ContextType
    >;
    cashRegisterId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    clientId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    establishmentId?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    organizationId?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyEstablishmentMappingListResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyEstablishmentMappingList"] = GQResolversParentTypes["FiskalyEstablishmentMappingList"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["FiskalyEstablishmentMapping"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyEstablishmentSubmissionResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyEstablishmentSubmission"] = GQResolversParentTypes["FiskalyEstablishmentSubmission"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    error?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    establishmentId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    previewedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    reviewedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    state?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    transmittedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyEstablishmentSubmissionDownloadResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyEstablishmentSubmissionDownload"] = GQResolversParentTypes["FiskalyEstablishmentSubmissionDownload"]
> = {
    fileContents?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyEstablishmentSubmissionListResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyEstablishmentSubmissionList"] = GQResolversParentTypes["FiskalyEstablishmentSubmissionList"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["FiskalyEstablishmentSubmission"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["CursorPagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyOrganizationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyOrganization"] = GQResolversParentTypes["FiskalyOrganization"]
> = {
    address?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    countryCode?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    displayName?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    economyId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    fiskalyEnvironment?: Resolver<
        Maybe<GQResolversTypes["EnvironmentEnum"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationId?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    managedBy?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    merchant?: Resolver<
        Maybe<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType
    >;
    merchantId?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    state?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    taxNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    town?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    vatId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    zip?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyOrganizationsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyOrganizations"] = GQResolversParentTypes["FiskalyOrganizations"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["FiskalyOrganization"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyOrganizationsPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyOrganizationsPagination"] = GQResolversParentTypes["FiskalyOrganizationsPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["FiskalyOrganization"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyRemoteCashRegisterResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyRemoteCashRegister"] = GQResolversParentTypes["FiskalyRemoteCashRegister"]
> = {
    baseCurrencyCode?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    brand?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    cashRegisterType?: Resolver<
        GQResolversTypes["CashRegisterTypeEnum"],
        ParentType,
        ContextType
    >;
    clientId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    environment?: Resolver<
        GQResolversTypes["EnvironmentEnum"],
        ParentType,
        ContextType
    >;
    model?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    revision?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    softwareBrand?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    softwareVersion?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    tssId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyRemoteCashRegisterListResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyRemoteCashRegisterList"] = GQResolversParentTypes["FiskalyRemoteCashRegisterList"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["FiskalyRemoteCashRegister"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyRemoteClientResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyRemoteClient"] = GQResolversParentTypes["FiskalyRemoteClient"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    serialNumber?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    state?: Resolver<
        Maybe<GQResolversTypes["ClientStateEnum"]>,
        ParentType,
        ContextType
    >;
    tssId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    updatedAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyRemoteClientListResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyRemoteClientList"] = GQResolversParentTypes["FiskalyRemoteClientList"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["FiskalyRemoteClient"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyRemoteEstablishmentSubmissionListResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyRemoteEstablishmentSubmissionList"] = GQResolversParentTypes["FiskalyRemoteEstablishmentSubmissionList"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["RemoteEstablishmentSubmission"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalySettingsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalySettings"] = GQResolversParentTypes["FiskalySettings"]
> = {
    apiKey?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    organizationId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    submissionNeeded?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    tssId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyTaxPayerResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyTaxPayer"] = GQResolversParentTypes["FiskalyTaxPayer"]
> = {
    __resolveType: TypeResolveFn<
        "FiskalyTaxPayerLegal" | "FiskalyTaxPayerNatural",
        ParentType,
        ContextType
    >;
};

export type GQFiskalyTaxPayerLegalResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyTaxPayerLegal"] = GQResolversParentTypes["FiskalyTaxPayerLegal"]
> = {
    companyName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    country?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    houseNumber?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    houseNumberSuffix?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    legalForm?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    street?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    taxNumber?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    taxOfficeNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    town?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<
        GQResolversTypes["FiskalyTaxPayerType"],
        ParentType,
        ContextType
    >;
    vatNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    webAddress?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    zip?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyTaxPayerNaturalResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyTaxPayerNatural"] = GQResolversParentTypes["FiskalyTaxPayerNatural"]
> = {
    birthDate?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    country?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    firstName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    houseNumber?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    houseNumberSuffix?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    identificationNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    lastName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    prefix?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    salutation?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    street?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    suffix?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    taxNumber?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    taxOfficeNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    title?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    town?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<
        GQResolversTypes["FiskalyTaxPayerType"],
        ParentType,
        ContextType
    >;
    vatNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    webAddress?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    zip?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyTssResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyTss"] = GQResolversParentTypes["FiskalyTss"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    defectiveAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    description?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    disabledAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    initializedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    numberActiveTransactions?: Resolver<
        GQResolversTypes["Int"],
        ParentType,
        ContextType
    >;
    numberRegisteredClients?: Resolver<
        GQResolversTypes["Int"],
        ParentType,
        ContextType
    >;
    publicKey?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    serialNumber?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    signatureCounter?: Resolver<
        GQResolversTypes["Int"],
        ParentType,
        ContextType
    >;
    state?: Resolver<GQResolversTypes["TssStateEnum"], ParentType, ContextType>;
    transactionCounter?: Resolver<
        GQResolversTypes["Int"],
        ParentType,
        ContextType
    >;
    uninitializedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFiskalyTssListResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["FiskalyTssList"] = GQResolversParentTypes["FiskalyTssList"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["FiskalyTss"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQFunctionResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Function"] = GQResolversParentTypes["Function"]
> = {
    __resolveType: TypeResolveFn<
        "BuyAccountFunds" | "CustomItem",
        ParentType,
        ContextType
    >;
};

export type GQGpsPointResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["GpsPoint"] = GQResolversParentTypes["GpsPoint"]
> = {
    latitude?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    longitude?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQIFiskalyTaxPayerResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["IFiskalyTaxPayer"] = GQResolversParentTypes["IFiskalyTaxPayer"]
> = {
    __resolveType: TypeResolveFn<
        "FiskalyTaxPayerLegal" | "FiskalyTaxPayerNatural",
        ParentType,
        ContextType
    >;
    country?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    houseNumber?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    houseNumberSuffix?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    street?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    taxNumber?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    taxOfficeNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    town?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<
        GQResolversTypes["FiskalyTaxPayerType"],
        ParentType,
        ContextType
    >;
    vatNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    webAddress?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    zip?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
};

export type GQIPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["IPagination"] = GQResolversParentTypes["IPagination"]
> = {
    __resolveType: TypeResolveFn<
        | "AccountBookkeepingPagination"
        | "AccountBookkeepingTransactionPagination"
        | "AccountPagination"
        | "AccountTransactionPagination"
        | "AdyenStoresPagination"
        | "AdyenTerminalsPagination"
        | "ApprovalPagination"
        | "ApprovalTokenGroupPagination"
        | "ApprovalTokenPagination"
        | "CardTransactionPagination"
        | "CashRegisterPagination"
        | "CashRegisterStatusPagination"
        | "CmpEventPagination"
        | "CmpEventProductPagination"
        | "CmpProductPagination"
        | "CurrencyPagination"
        | "CustomerGroupPagination"
        | "CustomerPagination"
        | "DashboardCashRegisterPagination"
        | "DepartmentPagination"
        | "DevicePagination"
        | "DiscountPagination"
        | "EconomicSyncJobPagination"
        | "FiskalyOrganizationsPagination"
        | "IntegrationPagination"
        | "InventoryProductNoteTemplatePagination"
        | "InventoryProductPagination"
        | "InvoiceRMPagination"
        | "LayoutEntityPagination"
        | "LayoutPagination"
        | "LogPagination"
        | "MerchantPagination"
        | "MiscButtonsPagination"
        | "PaymentConfigurationPagination"
        | "PaymentMethodPagination"
        | "PrinterPagination"
        | "ProductGroupPagination"
        | "ProductPagination"
        | "RolePagination"
        | "SaftJobPagination"
        | "ShiftRMPagination"
        | "SoftpayCloudTerminalsPagination"
        | "SoftpayMerchantsPagination"
        | "SoftpayMiaMerchantsPagination"
        | "TagActionPagination"
        | "TagGroupPagination"
        | "TagPagination"
        | "TaskResultPagination"
        | "UserPagination"
        | "VatPagination"
        | "ViProductPagination"
        | "ViWarehousePagination"
        | "VirtualPrinterPagination",
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
};

export type GQIntegrationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Integration"] = GQResolversParentTypes["Integration"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    apiKey?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    createdAt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    merchantChartOfAccounts?: Resolver<
        Array<GQResolversTypes["MerchantChartOfAccount"]>,
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQIntegrationAccountResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["IntegrationAccount"] = GQResolversParentTypes["IntegrationAccount"]
> = {
    accountNo?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationType?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQIntegrationArrayResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["IntegrationArray"] = GQResolversParentTypes["IntegrationArray"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Integration"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQIntegrationPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["IntegrationPagination"] = GQResolversParentTypes["IntegrationPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Integration"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQIntegrationSettingsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["IntegrationSettings"] = GQResolversParentTypes["IntegrationSettings"]
> = {
    __resolveType: TypeResolveFn<
        | "CmpProductSettings"
        | "EconomicSettings"
        | "FiskalySettings"
        | "PartnerApiSettings"
        | "VenueAccessSettings",
        ParentType,
        ContextType
    >;
};

export type GQInventoryProductResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InventoryProduct"] = GQResolversParentTypes["InventoryProduct"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    products?: Resolver<
        Array<GQResolversTypes["Product"]>,
        ParentType,
        ContextType
    >;
    quantity?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInventoryProductNoteTemplateResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InventoryProductNoteTemplate"] = GQResolversParentTypes["InventoryProductNoteTemplate"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    note?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInventoryProductNoteTemplatePaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InventoryProductNoteTemplatePagination"] = GQResolversParentTypes["InventoryProductNoteTemplatePagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["InventoryProductNoteTemplate"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInventoryProductPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InventoryProductPagination"] = GQResolversParentTypes["InventoryProductPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["InventoryProduct"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInvoiceAmountResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InvoiceAmount"] = GQResolversParentTypes["InvoiceAmount"]
> = {
    datetime?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    sum?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInvoiceAmountPerMonthResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InvoiceAmountPerMonth"] = GQResolversParentTypes["InvoiceAmountPerMonth"]
> = {
    monthNumber?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    sum?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    year?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInvoiceCountResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InvoiceCount"] = GQResolversParentTypes["InvoiceCount"]
> = {
    count?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    merchant?: Resolver<
        Maybe<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInvoiceExternalReceiptResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InvoiceExternalReceipt"] = GQResolversParentTypes["InvoiceExternalReceipt"]
> = {
    integrationId?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    receipt?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInvoiceHourSalesResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InvoiceHourSales"] = GQResolversParentTypes["InvoiceHourSales"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    count?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    date?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInvoiceItemExternalRmResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InvoiceItemExternalRM"] = GQResolversParentTypes["InvoiceItemExternalRM"]
> = {
    checkoutRef?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    integration?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    itemId?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    parameters?: Resolver<
        Maybe<GQResolversTypes["JSON"]>,
        ParentType,
        ContextType
    >;
    receipt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInvoiceItemRmResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InvoiceItemRM"] = GQResolversParentTypes["InvoiceItemRM"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    costAmount?: Resolver<
        Maybe<GQResolversTypes["Float"]>,
        ParentType,
        ContextType
    >;
    discountAmount?: Resolver<
        GQResolversTypes["Float"],
        ParentType,
        ContextType
    >;
    external?: Resolver<
        Maybe<Array<GQResolversTypes["InvoiceItemExternalRM"]>>,
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    note?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    productId?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    quantity?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInvoicePaymentRmResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InvoicePaymentRM"] = GQResolversParentTypes["InvoicePaymentRM"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    cardReceipt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    currency?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    paymentType?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInvoiceRmResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InvoiceRM"] = GQResolversParentTypes["InvoiceRM"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    cashRegisterName?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    departmentId?: Resolver<
        Maybe<GQResolversTypes["ID"]>,
        ParentType,
        ContextType
    >;
    discountAmount?: Resolver<
        GQResolversTypes["Float"],
        ParentType,
        ContextType
    >;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    externalReceipts?: Resolver<
        Array<GQResolversTypes["InvoiceExternalReceipt"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    items?: Resolver<
        Maybe<Array<GQResolversTypes["InvoiceItemRM"]>>,
        ParentType,
        ContextType
    >;
    name?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    payments?: Resolver<
        Maybe<Array<GQResolversTypes["InvoicePaymentRM"]>>,
        ParentType,
        ContextType
    >;
    receipt?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    receiptNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    shift?: Resolver<GQResolversTypes["ShiftRM"], ParentType, ContextType>;
    shiftId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    sms?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQInvoiceRmPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["InvoiceRMPagination"] = GQResolversParentTypes["InvoiceRMPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["InvoiceRM"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface GQJsonScalarConfig
    extends GraphQLScalarTypeConfig<GQResolversTypes["JSON"], any> {
    name: "JSON";
}

export type GQLayoutResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Layout"] = GQResolversParentTypes["Layout"]
> = {
    columns?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    data?: Resolver<GQResolversTypes["JSON"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    layoutType?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    productGroups?: Resolver<
        Array<GQResolversTypes["ProductGroup"]>,
        ParentType,
        ContextType
    >;
    products?: Resolver<
        Array<GQResolversTypes["Product"]>,
        ParentType,
        ContextType
    >;
    rows?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLayoutDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["LayoutDeleteResponse"] = GQResolversParentTypes["LayoutDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLayoutEntityResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["LayoutEntity"] = GQResolversParentTypes["LayoutEntity"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    data?: Resolver<GQResolversTypes["Function"], ParentType, ContextType>;
    function?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLayoutEntityPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["LayoutEntityPagination"] = GQResolversParentTypes["LayoutEntityPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["LayoutEntity"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLayoutPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["LayoutPagination"] = GQResolversParentTypes["LayoutPagination"]
> = {
    data?: Resolver<Array<GQResolversTypes["Layout"]>, ParentType, ContextType>;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLogResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Log"] = GQResolversParentTypes["Log"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    insertedAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    merchant?: Resolver<
        Maybe<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType
    >;
    message?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    payload?: Resolver<
        Maybe<GQResolversTypes["JSON"]>,
        ParentType,
        ContextType
    >;
    type?: Resolver<GQResolversTypes["LogType"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLogPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["LogPagination"] = GQResolversParentTypes["LogPagination"]
> = {
    data?: Resolver<Array<GQResolversTypes["Log"]>, ParentType, ContextType>;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLogoResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Logo"] = GQResolversParentTypes["Logo"]
> = {
    base64Data?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    bmpData?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    escposData?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    fileType?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    height?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["LogoType"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    width?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMeResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Me"] = GQResolversParentTypes["Me"]
> = {
    cashRegister?: Resolver<
        Maybe<GQResolversTypes["CashRegister"]>,
        ParentType,
        ContextType
    >;
    department?: Resolver<
        Maybe<GQResolversTypes["Department"]>,
        ParentType,
        ContextType
    >;
    merchant?: Resolver<
        Maybe<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType
    >;
    role?: Resolver<Maybe<GQResolversTypes["Role"]>, ParentType, ContextType>;
    user?: Resolver<Maybe<GQResolversTypes["User"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMeasurementUnitResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["MeasurementUnit"] = GQResolversParentTypes["MeasurementUnit"]
> = {
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMerchantResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Merchant"] = GQResolversParentTypes["Merchant"]
> = {
    createdAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    entityConfig?: Resolver<
        Maybe<GQResolversTypes["EntityConfig"]>,
        ParentType,
        ContextType
    >;
    giftcardVatBookkeepingMethod?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    lastNotifySentAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    serialId?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    users?: Resolver<Array<GQResolversTypes["User"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMerchantChartOfAccountResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["MerchantChartOfAccount"] = GQResolversParentTypes["MerchantChartOfAccount"]
> = {
    chartOfAccountsId?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    integrationId?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    merchantAccountNo?: Resolver<
        GQResolversTypes["Int"],
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMerchantChartOfAccountsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["MerchantChartOfAccounts"] = GQResolversParentTypes["MerchantChartOfAccounts"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["MerchantChartOfAccount"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMerchantDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["MerchantDeleteResponse"] = GQResolversParentTypes["MerchantDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMerchantPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["MerchantPagination"] = GQResolversParentTypes["MerchantPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMiscButtonsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["MiscButtons"] = GQResolversParentTypes["MiscButtons"]
> = {
    buttons?: Resolver<GQResolversTypes["JSON"], ParentType, ContextType>;
    buttonsSortOrder?: Resolver<
        Maybe<GQResolversTypes["JSON"]>,
        ParentType,
        ContextType
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMiscButtonsDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["MiscButtonsDeleteResponse"] = GQResolversParentTypes["MiscButtonsDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMiscButtonsPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["MiscButtonsPagination"] = GQResolversParentTypes["MiscButtonsPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["MiscButtons"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQMutationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Mutation"] = GQResolversParentTypes["Mutation"]
> = {
    accountAssignTags?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationAccountAssignTagsArgs, "id">
    >;
    accountBuyFunds?: Resolver<
        GQResolversTypes["AccountBuyFundsResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationAccountBuyFundsArgs,
            "amount" | "id" | "orderId" | "tagId" | "tagIdentifier" | "userId"
        >
    >;
    accountClose?: Resolver<
        GQResolversTypes["AccountCloseResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationAccountCloseArgs, "id">
    >;
    accountCreate?: Resolver<
        GQResolversTypes["Account"],
        ParentType,
        ContextType,
        RequireFields<GQMutationAccountCreateArgs, "account">
    >;
    accountOpen?: Resolver<
        GQResolversTypes["AccountOpenResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationAccountOpenArgs, "id">
    >;
    accountPayAmount?: Resolver<
        GQResolversTypes["AccountPayAmountResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationAccountPayAmountArgs,
            "amount" | "id" | "orderId" | "userId"
        >
    >;
    accountRefundAmount?: Resolver<
        GQResolversTypes["AccountRefundAmountResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationAccountRefundAmountArgs,
            "amount" | "id" | "orderId" | "userId"
        >
    >;
    accountReissueGiftcard?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationAccountReissueGiftcardArgs, "id">
    >;
    accountReissueGiftcards?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationAccountReissueGiftcardsArgs, "ids">
    >;
    accountReturnFunds?: Resolver<
        GQResolversTypes["AccountReturnFundsResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationAccountReturnFundsArgs,
            "amount" | "id" | "orderId" | "tagId" | "tagIdentifier" | "userId"
        >
    >;
    accountRevertTransaction?: Resolver<
        GQResolversTypes["AccountRevertTransactionResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationAccountRevertTransactionArgs,
            "id" | "transactionId" | "userId"
        >
    >;
    accountSave?: Resolver<
        GQResolversTypes["Account"],
        ParentType,
        ContextType,
        RequireFields<GQMutationAccountSaveArgs, "account" | "id">
    >;
    addEconomicSyncJobs?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationAddEconomicSyncJobsArgs, "integrationId">
    >;
    approvalCreate?: Resolver<
        GQResolversTypes["Approval"],
        ParentType,
        ContextType,
        RequireFields<GQMutationApprovalCreateArgs, "approval">
    >;
    approvalDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationApprovalDeleteArgs, "id">
    >;
    approvalSave?: Resolver<
        GQResolversTypes["Approval"],
        ParentType,
        ContextType,
        RequireFields<GQMutationApprovalSaveArgs, "approval" | "id">
    >;
    approvalTokenCreate?: Resolver<
        GQResolversTypes["ApprovalToken"],
        ParentType,
        ContextType,
        RequireFields<GQMutationApprovalTokenCreateArgs, "approvalToken">
    >;
    approvalTokenDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationApprovalTokenDeleteArgs, "id">
    >;
    approvalTokenGroupCreate?: Resolver<
        GQResolversTypes["ApprovalTokenGroup"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationApprovalTokenGroupCreateArgs,
            "approvalTokenGroup"
        >
    >;
    approvalTokenGroupDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationApprovalTokenGroupDeleteArgs, "id">
    >;
    approvalTokenGroupSave?: Resolver<
        GQResolversTypes["ApprovalTokenGroup"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationApprovalTokenGroupSaveArgs,
            "approvalTokenGroup" | "id"
        >
    >;
    approvalTokenSave?: Resolver<
        GQResolversTypes["ApprovalToken"],
        ParentType,
        ContextType,
        RequireFields<GQMutationApprovalTokenSaveArgs, "approvalToken" | "id">
    >;
    approveFiskalyEstablishmentSubmission?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationApproveFiskalyEstablishmentSubmissionArgs,
            "submissionId"
        >
    >;
    authLogin?: Resolver<
        GQResolversTypes["AuthAttempt"],
        ParentType,
        ContextType,
        RequireFields<GQMutationAuthLoginArgs, "password" | "username">
    >;
    authSelectUserRole?: Resolver<
        GQResolversTypes["SelectUserRoleType"],
        ParentType,
        ContextType,
        RequireFields<GQMutationAuthSelectUserRoleArgs, "roleId">
    >;
    authUpdateLogin?: Resolver<
        GQResolversTypes["AuthAttempt"],
        ParentType,
        ContextType
    >;
    cashRegisterClaim?: Resolver<
        Maybe<GQResolversTypes["CashRegister"]>,
        ParentType,
        ContextType,
        RequireFields<GQMutationCashRegisterClaimArgs, "devicePinCode" | "id">
    >;
    cashRegisterCreate?: Resolver<
        GQResolversTypes["CashRegister"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCashRegisterCreateArgs, "cashRegister">
    >;
    cashRegisterDelete?: Resolver<
        GQResolversTypes["CashRegisterDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCashRegisterDeleteArgs, "id">
    >;
    cashRegisterEdit?: Resolver<
        GQResolversTypes["CashRegister"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCashRegisterEditArgs, "cashRegister" | "id">
    >;
    cashRegistersDelete?: Resolver<
        GQResolversTypes["CashRegisterDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCashRegistersDeleteArgs, "ids">
    >;
    cmpEventCreateOrder?: Resolver<
        GQResolversTypes["CmpEventOrderCreated"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCmpEventCreateOrderArgs, "order">
    >;
    cmpEventDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCmpEventDeleteArgs, "id">
    >;
    cmpEventProductDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCmpEventProductDeleteArgs, "id">
    >;
    cmpGiftcardPayAmount?: Resolver<
        GQResolversTypes["CmpGiftcardPayAmountResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationCmpGiftcardPayAmountArgs,
            "amount" | "id" | "orderId" | "userId"
        >
    >;
    cmpGiftcardRefundAmount?: Resolver<
        GQResolversTypes["CmpGiftcardRefundAmountResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationCmpGiftcardRefundAmountArgs,
            "amount" | "id" | "orderId" | "userId"
        >
    >;
    cmpProductDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCmpProductDeleteArgs, "id">
    >;
    currencyCreate?: Resolver<
        GQResolversTypes["Currency"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCurrencyCreateArgs, "currency">
    >;
    currencyDelete?: Resolver<
        GQResolversTypes["CurrencyDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCurrencyDeleteArgs, "id">
    >;
    currencySave?: Resolver<
        GQResolversTypes["Currency"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCurrencySaveArgs, "currency" | "id">
    >;
    customerAssignTags?: Resolver<
        GQResolversTypes["CustomerAssignTagsRelationResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCustomerAssignTagsArgs, "id">
    >;
    customerCreate?: Resolver<
        GQResolversTypes["Customer"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCustomerCreateArgs, "customer">
    >;
    customerDelete?: Resolver<
        GQResolversTypes["CustomerDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCustomerDeleteArgs, "id">
    >;
    customerGroupCreate?: Resolver<
        GQResolversTypes["CustomerGroup"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCustomerGroupCreateArgs, "customerGroup">
    >;
    customerGroupDelete?: Resolver<
        GQResolversTypes["CustomerGroupDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCustomerGroupDeleteArgs, "id">
    >;
    customerGroupSave?: Resolver<
        GQResolversTypes["CustomerGroup"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCustomerGroupSaveArgs, "customerGroup" | "id">
    >;
    customerSave?: Resolver<
        GQResolversTypes["Customer"],
        ParentType,
        ContextType,
        RequireFields<GQMutationCustomerSaveArgs, "customer" | "id">
    >;
    deleteEstablishment?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationDeleteEstablishmentArgs, "establishmentId">
    >;
    departmentCreate?: Resolver<
        GQResolversTypes["Department"],
        ParentType,
        ContextType,
        RequireFields<GQMutationDepartmentCreateArgs, "department">
    >;
    departmentDelete?: Resolver<
        GQResolversTypes["DepartmentDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationDepartmentDeleteArgs, "id">
    >;
    departmentSave?: Resolver<
        GQResolversTypes["Department"],
        ParentType,
        ContextType,
        RequireFields<GQMutationDepartmentSaveArgs, "department" | "id">
    >;
    deviceHeartbeat?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType,
        RequireFields<GQMutationDeviceHeartbeatArgs, "deviceInfo">
    >;
    deviceRegister?: Resolver<
        GQResolversTypes["Device"],
        ParentType,
        ContextType,
        RequireFields<GQMutationDeviceRegisterArgs, "deviceInfo">
    >;
    discountCreate?: Resolver<
        GQResolversTypes["Discount"],
        ParentType,
        ContextType,
        RequireFields<GQMutationDiscountCreateArgs, "discount">
    >;
    discountDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationDiscountDeleteArgs, "id">
    >;
    discountSave?: Resolver<
        GQResolversTypes["Discount"],
        ParentType,
        ContextType,
        RequireFields<GQMutationDiscountSaveArgs, "discount" | "id">
    >;
    discountsActiveToggle?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationDiscountsActiveToggleArgs, "ids">
    >;
    entityConfigDelete?: Resolver<
        GQResolversTypes["EntityConfigDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationEntityConfigDeleteArgs, "entityId">
    >;
    entityConfigSave?: Resolver<
        GQResolversTypes["EntityConfig"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationEntityConfigSaveArgs,
            "disabledData" | "entityId" | "partialData"
        >
    >;
    eventStoreSyncDispatch?: Resolver<
        GQResolversTypes["AddEventResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationEventStoreSyncDispatchArgs, "events">
    >;
    fiskalyAdvanceTssState?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationFiskalyAdvanceTssStateArgs, "tssState">
    >;
    fiskalyChangePinForTss?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationFiskalyChangePinForTssArgs,
            "adminPuk" | "integrationId" | "pinCode"
        >
    >;
    fiskalyClientSync?: Resolver<
        GQResolversTypes["FiskalyClient"],
        ParentType,
        ContextType,
        RequireFields<GQMutationFiskalyClientSyncArgs, "id" | "pin">
    >;
    fiskalyGoLive?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationFiskalyGoLiveArgs, "integrationId">
    >;
    fiskalyOrganizationGoLive?: Resolver<
        GQResolversTypes["FiskalyOrganization"],
        ParentType,
        ContextType,
        RequireFields<GQMutationFiskalyOrganizationGoLiveArgs, "integrationId">
    >;
    fiskalyOrganizationUpsert?: Resolver<
        GQResolversTypes["FiskalyOrganization"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationFiskalyOrganizationUpsertArgs,
            "managedOrganization"
        >
    >;
    fiskalyRegisterTssForOrganization?: Resolver<
        GQResolversTypes["CreateTssResponse"],
        ParentType,
        ContextType
    >;
    integrationCmpProductSettingsSave?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationIntegrationCmpProductSettingsSaveArgs,
            "integrationId" | "settings"
        >
    >;
    integrationCreate?: Resolver<
        GQResolversTypes["Integration"],
        ParentType,
        ContextType,
        RequireFields<GQMutationIntegrationCreateArgs, "integration">
    >;
    integrationDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationIntegrationDeleteArgs, "id">
    >;
    integrationEconomicSettingsSave?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationIntegrationEconomicSettingsSaveArgs,
            "integrationId" | "settings"
        >
    >;
    integrationFiskalySettingsSave?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationIntegrationFiskalySettingsSaveArgs,
            "integrationId" | "settings"
        >
    >;
    integrationSave?: Resolver<
        GQResolversTypes["Integration"],
        ParentType,
        ContextType,
        RequireFields<GQMutationIntegrationSaveArgs, "id" | "integration">
    >;
    inventoryProductNoteTemplateCreate?: Resolver<
        GQResolversTypes["InventoryProductNoteTemplate"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationInventoryProductNoteTemplateCreateArgs,
            "inventoryProductNoteTemplate"
        >
    >;
    inventoryProductNoteTemplateDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationInventoryProductNoteTemplateDeleteArgs, "id">
    >;
    inventoryProductNoteTemplateSave?: Resolver<
        GQResolversTypes["InventoryProductNoteTemplate"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationInventoryProductNoteTemplateSaveArgs,
            "id" | "inventoryProductNoteTemplate"
        >
    >;
    inventoryProductUpdate?: Resolver<
        GQResolversTypes["InventoryProduct"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationInventoryProductUpdateArgs,
            "id" | "inventoryProduct"
        >
    >;
    layoutCopy?: Resolver<
        GQResolversTypes["Layout"],
        ParentType,
        ContextType,
        RequireFields<GQMutationLayoutCopyArgs, "id" | "newTitle">
    >;
    layoutCreate?: Resolver<
        GQResolversTypes["Layout"],
        ParentType,
        ContextType,
        RequireFields<GQMutationLayoutCreateArgs, "layout">
    >;
    layoutDelete?: Resolver<
        GQResolversTypes["LayoutDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationLayoutDeleteArgs, "id">
    >;
    layoutEntityCreate?: Resolver<
        GQResolversTypes["LayoutEntity"],
        ParentType,
        ContextType,
        RequireFields<GQMutationLayoutEntityCreateArgs, "layoutEntity">
    >;
    layoutEntityDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationLayoutEntityDeleteArgs, "id">
    >;
    layoutEntitySave?: Resolver<
        GQResolversTypes["LayoutEntity"],
        ParentType,
        ContextType,
        RequireFields<GQMutationLayoutEntitySaveArgs, "id" | "layoutEntity">
    >;
    layoutSave?: Resolver<
        GQResolversTypes["Layout"],
        ParentType,
        ContextType,
        RequireFields<GQMutationLayoutSaveArgs, "id" | "layout">
    >;
    logoDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationLogoDeleteArgs, "merchantId">
    >;
    logoSave?: Resolver<
        GQResolversTypes["Logo"],
        ParentType,
        ContextType,
        RequireFields<GQMutationLogoSaveArgs, "logo">
    >;
    merchantCreate?: Resolver<
        GQResolversTypes["Merchant"],
        ParentType,
        ContextType,
        RequireFields<GQMutationMerchantCreateArgs, "merchant">
    >;
    merchantDelete?: Resolver<
        GQResolversTypes["MerchantDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationMerchantDeleteArgs, "id">
    >;
    merchantSave?: Resolver<
        GQResolversTypes["Merchant"],
        ParentType,
        ContextType,
        RequireFields<GQMutationMerchantSaveArgs, "id" | "merchant">
    >;
    miscButtonsCreate?: Resolver<
        GQResolversTypes["MiscButtons"],
        ParentType,
        ContextType,
        RequireFields<GQMutationMiscButtonsCreateArgs, "miscButtons">
    >;
    miscButtonsDelete?: Resolver<
        GQResolversTypes["MiscButtonsDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationMiscButtonsDeleteArgs, "id">
    >;
    miscButtonsSave?: Resolver<
        GQResolversTypes["MiscButtons"],
        ParentType,
        ContextType,
        RequireFields<GQMutationMiscButtonsSaveArgs, "id" | "miscButtons">
    >;
    passwordResetRequest?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationPasswordResetRequestArgs, "email">
    >;
    passwordResetTokenDelete?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationPasswordResetTokenDeleteArgs, "token">
    >;
    passwordResetTokenUpdatePassword?: Resolver<
        Maybe<GQResolversTypes["BooleanResponse"]>,
        ParentType,
        ContextType,
        RequireFields<
            GQMutationPasswordResetTokenUpdatePasswordArgs,
            "password" | "token"
        >
    >;
    paymentConfigurationCreate?: Resolver<
        GQResolversTypes["PaymentConfiguration"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationPaymentConfigurationCreateArgs,
            "paymentConfiguration"
        >
    >;
    paymentConfigurationDelete?: Resolver<
        GQResolversTypes["PaymentConfigurationDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationPaymentConfigurationDeleteArgs, "id">
    >;
    paymentConfigurationSave?: Resolver<
        GQResolversTypes["PaymentConfiguration"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationPaymentConfigurationSaveArgs,
            "id" | "paymentConfiguration"
        >
    >;
    paymentMethodCreate?: Resolver<
        GQResolversTypes["PaymentMethod"],
        ParentType,
        ContextType,
        RequireFields<GQMutationPaymentMethodCreateArgs, "paymentMethod">
    >;
    paymentMethodDelete?: Resolver<
        GQResolversTypes["PaymentMethodDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationPaymentMethodDeleteArgs, "id">
    >;
    paymentMethodSave?: Resolver<
        GQResolversTypes["PaymentMethod"],
        ParentType,
        ContextType,
        RequireFields<GQMutationPaymentMethodSaveArgs, "id" | "paymentMethod">
    >;
    printerDelete?: Resolver<
        GQResolversTypes["PrinterDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationPrinterDeleteArgs, "id">
    >;
    printerRegister?: Resolver<
        GQResolversTypes["Printer"],
        ParentType,
        ContextType,
        RequireFields<GQMutationPrinterRegisterArgs, "printer">
    >;
    printerSave?: Resolver<
        GQResolversTypes["Printer"],
        ParentType,
        ContextType,
        RequireFields<GQMutationPrinterSaveArgs, "id" | "printer">
    >;
    productCreate?: Resolver<
        GQResolversTypes["Product"],
        ParentType,
        ContextType,
        RequireFields<GQMutationProductCreateArgs, "product">
    >;
    productDelete?: Resolver<
        GQResolversTypes["ProductDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationProductDeleteArgs, "id">
    >;
    productGroupCreate?: Resolver<
        GQResolversTypes["ProductGroup"],
        ParentType,
        ContextType,
        RequireFields<GQMutationProductGroupCreateArgs, "productGroup">
    >;
    productGroupDelete?: Resolver<
        GQResolversTypes["ProductGroupDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationProductGroupDeleteArgs, "id">
    >;
    productGroupSave?: Resolver<
        GQResolversTypes["ProductGroup"],
        ParentType,
        ContextType,
        RequireFields<GQMutationProductGroupSaveArgs, "id" | "productGroup">
    >;
    productSave?: Resolver<
        GQResolversTypes["Product"],
        ParentType,
        ContextType,
        RequireFields<GQMutationProductSaveArgs, "id" | "product">
    >;
    productsDelete?: Resolver<
        GQResolversTypes["ProductDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationProductsDeleteArgs, "ids">
    >;
    rebuildSaftJobs?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationRebuildSaftJobsArgs, "shiftIds">
    >;
    releaseTerminal?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationReleaseTerminalArgs,
            "acquirer" | "merchantId" | "storeId" | "terminalId"
        >
    >;
    requestFiskalyDSFinVKExport?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationRequestFiskalyDsFinVkExportArgs, "exportInput">
    >;
    requestFiskalyEstablishmentSubmission?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationRequestFiskalyEstablishmentSubmissionArgs,
            "establishmentId"
        >
    >;
    requestFiskalyEstablishmentSubmissionDownload?: Resolver<
        GQResolversTypes["FiskalyEstablishmentSubmissionDownload"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationRequestFiskalyEstablishmentSubmissionDownloadArgs,
            "submissionId"
        >
    >;
    requestFiskalyEstablishmentSubmissionPreviewDownload?: Resolver<
        GQResolversTypes["FiskalyEstablishmentSubmissionDownload"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationRequestFiskalyEstablishmentSubmissionPreviewDownloadArgs,
            "submissionId"
        >
    >;
    requestFiskalyEstablishmentSubmissionTransmission?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationRequestFiskalyEstablishmentSubmissionTransmissionArgs,
            "submissionId"
        >
    >;
    roleCreate?: Resolver<
        GQResolversTypes["Role"],
        ParentType,
        ContextType,
        RequireFields<GQMutationRoleCreateArgs, "role">
    >;
    roleDelete?: Resolver<
        GQResolversTypes["RoleDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationRoleDeleteArgs, "id">
    >;
    roleSave?: Resolver<
        GQResolversTypes["Role"],
        ParentType,
        ContextType,
        RequireFields<GQMutationRoleSaveArgs, "id" | "role">
    >;
    saveAccountChartByProductGroup?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationSaveAccountChartByProductGroupArgs,
            "integrationId" | "productGroupMap"
        >
    >;
    saveAccountForProductGroup?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationSaveAccountForProductGroupArgs,
            "integrationId" | "productGroupMap"
        >
    >;
    saveFiskalyEstablishment?: Resolver<
        GQResolversTypes["FiskalyEstablishment"],
        ParentType,
        ContextType,
        RequireFields<GQMutationSaveFiskalyEstablishmentArgs, "establishment">
    >;
    saveFiskalyEstablishmentMapping?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationSaveFiskalyEstablishmentMappingArgs,
            "establishmentMapping" | "integrationId"
        >
    >;
    saveMerchantChartOfAccounts?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationSaveMerchantChartOfAccountsArgs,
            "chartOfAccounts" | "integrationId"
        >
    >;
    setDepartment2Warehouse?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationSetDepartment2WarehouseArgs, "departmentId">
    >;
    setFiskalyClientState?: Resolver<
        GQResolversTypes["FiskalyClient"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationSetFiskalyClientStateArgs,
            "id" | "integrationId" | "pin"
        >
    >;
    setInventoryProductQuantity?: Resolver<
        GQResolversTypes["InventoryProduct"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationSetInventoryProductQuantityArgs,
            "productId" | "quantity"
        >
    >;
    setProduct2ViProduct2MeasurementUnit?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationSetProduct2ViProduct2MeasurementUnitArgs,
            "productId" | "relations"
        >
    >;
    tagCreate?: Resolver<
        GQResolversTypes["Tag"],
        ParentType,
        ContextType,
        RequireFields<GQMutationTagCreateArgs, "tag">
    >;
    tagDelete?: Resolver<
        GQResolversTypes["TagDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationTagDeleteArgs, "id">
    >;
    tagGroupCreate?: Resolver<
        GQResolversTypes["TagGroup"],
        ParentType,
        ContextType,
        RequireFields<GQMutationTagGroupCreateArgs, "tagGroup">
    >;
    tagGroupDelete?: Resolver<
        GQResolversTypes["TagGroupDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationTagGroupDeleteArgs, "id">
    >;
    tagGroupSave?: Resolver<
        GQResolversTypes["TagGroup"],
        ParentType,
        ContextType,
        RequireFields<GQMutationTagGroupSaveArgs, "id" | "tagGroup">
    >;
    tagSave?: Resolver<
        GQResolversTypes["Tag"],
        ParentType,
        ContextType,
        RequireFields<GQMutationTagSaveArgs, "id" | "tag">
    >;
    updateViProducts?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType
    >;
    updateViWarehouses?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType
    >;
    upsertFiskalyTaxPayerLegal?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationUpsertFiskalyTaxPayerLegalArgs, "taxPayerData">
    >;
    upsertFiskalyTaxPayerNatural?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationUpsertFiskalyTaxPayerNaturalArgs,
            "taxPayerData"
        >
    >;
    userCreate?: Resolver<
        GQResolversTypes["User"],
        ParentType,
        ContextType,
        RequireFields<GQMutationUserCreateArgs, "user">
    >;
    userDelete?: Resolver<
        GQResolversTypes["UserDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationUserDeleteArgs, "id">
    >;
    userRoleConfigurationSave?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationUserRoleConfigurationSaveArgs,
            "configuration" | "roleId" | "type" | "userId"
        >
    >;
    userSave?: Resolver<
        GQResolversTypes["User"],
        ParentType,
        ContextType,
        RequireFields<GQMutationUserSaveArgs, "id" | "user">
    >;
    userUpdatePassword?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationUserUpdatePasswordArgs, "id" | "password">
    >;
    vatCreate?: Resolver<
        GQResolversTypes["Vat"],
        ParentType,
        ContextType,
        RequireFields<GQMutationVatCreateArgs, "vat">
    >;
    vatDelete?: Resolver<
        GQResolversTypes["VatDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationVatDeleteArgs, "id">
    >;
    venueAccessCancelAccessTicket?: Resolver<
        GQResolversTypes["VenueAccessTicketCancelled"],
        ParentType,
        ContextType,
        RequireFields<GQMutationVenueAccessCancelAccessTicketArgs, "ticketId">
    >;
    venueAccessCreateAccessTicket?: Resolver<
        GQResolversTypes["VenueAccessTicketCreated"],
        ParentType,
        ContextType,
        RequireFields<
            GQMutationVenueAccessCreateAccessTicketArgs,
            "accessTypes" | "eventId" | "validFrom" | "validTo"
        >
    >;
    venueAccessCreateAccessTickets?: Resolver<
        Maybe<Array<GQResolversTypes["VenueAccessTicketCreated"]>>,
        ParentType,
        ContextType,
        Partial<GQMutationVenueAccessCreateAccessTicketsArgs>
    >;
    virtualPrinterCreate?: Resolver<
        GQResolversTypes["VirtualPrinter"],
        ParentType,
        ContextType,
        RequireFields<GQMutationVirtualPrinterCreateArgs, "virtualPrinter">
    >;
    virtualPrinterDelete?: Resolver<
        GQResolversTypes["VirtualPrinterDeleteResponse"],
        ParentType,
        ContextType,
        RequireFields<GQMutationVirtualPrinterDeleteArgs, "id">
    >;
    virtualPrinterSave?: Resolver<
        GQResolversTypes["VirtualPrinter"],
        ParentType,
        ContextType,
        RequireFields<GQMutationVirtualPrinterSaveArgs, "id" | "virtualPrinter">
    >;
};

export type GQPosResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["POS"] = GQResolversParentTypes["POS"]
> = {
    configuration?: Resolver<
        Maybe<GQResolversTypes["Configuration"]>,
        ParentType,
        ContextType
    >;
    department?: Resolver<
        Maybe<GQResolversTypes["Department"]>,
        ParentType,
        ContextType
    >;
    device?: Resolver<GQResolversTypes["Device"], ParentType, ContextType>;
    firstActive?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    firstLocation?: Resolver<
        Maybe<GQResolversTypes["GpsPoint"]>,
        ParentType,
        ContextType
    >;
    firstUser?: Resolver<
        Maybe<GQResolversTypes["User"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    lastActive?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    lastLocation?: Resolver<
        Maybe<GQResolversTypes["GpsPoint"]>,
        ParentType,
        ContextType
    >;
    lastUser?: Resolver<
        Maybe<GQResolversTypes["User"]>,
        ParentType,
        ContextType
    >;
    merchant?: Resolver<
        Maybe<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType
    >;
    name?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    partner?: Resolver<
        Maybe<GQResolversTypes["Partner"]>,
        ParentType,
        ContextType
    >;
    tags?: Resolver<Array<GQResolversTypes["String"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Pagination"] = GQResolversParentTypes["Pagination"]
> = {
    page?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    pageSize?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    pages?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    resultCount?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    sort?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    sortDirection?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPartnerResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Partner"] = GQResolversParentTypes["Partner"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPartnerApiSettingsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["PartnerApiSettings"] = GQResolversParentTypes["PartnerApiSettings"]
> = {
    foo?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPaymentConfigurationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["PaymentConfiguration"] = GQResolversParentTypes["PaymentConfiguration"]
> = {
    createdAt?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    paymentMethods?: Resolver<
        Array<GQResolversTypes["PaymentConfigurationMethod"]>,
        ParentType,
        ContextType
    >;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPaymentConfigurationDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["PaymentConfigurationDeleteResponse"] = GQResolversParentTypes["PaymentConfigurationDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPaymentConfigurationMethodResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["PaymentConfigurationMethod"] = GQResolversParentTypes["PaymentConfigurationMethod"]
> = {
    askForAmount?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    paymentMethod?: Resolver<
        GQResolversTypes["PaymentMethod"],
        ParentType,
        ContextType
    >;
    showAsQuickButton?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    showInPaymentWindow?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPaymentConfigurationPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["PaymentConfigurationPagination"] = GQResolversParentTypes["PaymentConfigurationPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["PaymentConfiguration"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPaymentMethodResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["PaymentMethod"] = GQResolversParentTypes["PaymentMethod"]
> = {
    account?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    currency?: Resolver<GQResolversTypes["Currency"], ParentType, ContextType>;
    diffAccount?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    enabled?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    paymentType?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPaymentMethodDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["PaymentMethodDeleteResponse"] = GQResolversParentTypes["PaymentMethodDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPaymentMethodPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["PaymentMethodPagination"] = GQResolversParentTypes["PaymentMethodPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["PaymentMethod"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPrinterResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Printer"] = GQResolversParentTypes["Printer"]
> = {
    cashRegister?: Resolver<
        Maybe<GQResolversTypes["CashRegister"]>,
        ParentType,
        ContextType
    >;
    class?: Resolver<GQResolversTypes["PrinterClass"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    isVirtual?: Resolver<
        Maybe<GQResolversTypes["Boolean"]>,
        ParentType,
        ContextType
    >;
    manufacturer?: Resolver<
        GQResolversTypes["PrinterManufacturer"],
        ParentType,
        ContextType
    >;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    product?: Resolver<
        Array<GQResolversTypes["Product"]>,
        ParentType,
        ContextType
    >;
    productGroup?: Resolver<
        Array<GQResolversTypes["ProductGroup"]>,
        ParentType,
        ContextType
    >;
    serial?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["PrinterType"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    virtualPrinter?: Resolver<
        Array<GQResolversTypes["VirtualPrinter"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPrinterDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["PrinterDeleteResponse"] = GQResolversParentTypes["PrinterDeleteResponse"]
> = {
    status?: Resolver<
        GQResolversTypes["DeleteResponseEnum"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQPrinterPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["PrinterPagination"] = GQResolversParentTypes["PrinterPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Printer"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQProductResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Product"] = GQResolversParentTypes["Product"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    amount?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    barcode?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    barcodes?: Resolver<
        Array<GQResolversTypes["ProductBarcode"]>,
        ParentType,
        ContextType
    >;
    buttonText?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    children?: Resolver<
        GQResolversTypes["ProductPagination"],
        ParentType,
        ContextType,
        Partial<GQProductChildrenArgs>
    >;
    costAmount?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    discountTemplate?: Resolver<
        Maybe<Array<GQResolversTypes["DiscountTemplate"]>>,
        ParentType,
        ContextType
    >;
    excludeFromDiscounts?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    group?: Resolver<GQResolversTypes["ProductGroup"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    inheritPrinter?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    inventoryProduct?: Resolver<
        Maybe<GQResolversTypes["InventoryProduct"]>,
        ParentType,
        ContextType
    >;
    isExternal?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    minimumAmount?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    onlineRequired?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    ownExcludeFromDiscounts?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    ownVat?: Resolver<Maybe<GQResolversTypes["Vat"]>, ParentType, ContextType>;
    parent?: Resolver<
        Maybe<GQResolversTypes["Product"]>,
        ParentType,
        ContextType
    >;
    plu?: Resolver<Maybe<GQResolversTypes["Int"]>, ParentType, ContextType>;
    printer?: Resolver<
        Maybe<GQResolversTypes["Printer"]>,
        ParentType,
        ContextType
    >;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    vat?: Resolver<GQResolversTypes["Vat"], ParentType, ContextType>;
    viProductRelations?: Resolver<
        Maybe<Array<GQResolversTypes["Product2ViProduct2MeasurementUnit"]>>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQProduct2ViProduct2MeasurementUnitResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Product2ViProduct2MeasurementUnit"] = GQResolversParentTypes["Product2ViProduct2MeasurementUnit"]
> = {
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    measurementUnit?: Resolver<
        GQResolversTypes["MeasurementUnit"],
        ParentType,
        ContextType
    >;
    value?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    viProduct?: Resolver<
        GQResolversTypes["ViProduct"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQProductBarcodeResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ProductBarcode"] = GQResolversParentTypes["ProductBarcode"]
> = {
    barcode?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    updatedAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQProductDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ProductDeleteResponse"] = GQResolversParentTypes["ProductDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQProductGroupResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ProductGroup"] = GQResolversParentTypes["ProductGroup"]
> = {
    color?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    excludeFromDiscounts?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    isExternal?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    printer?: Resolver<
        Maybe<GQResolversTypes["Printer"]>,
        ParentType,
        ContextType
    >;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    vat?: Resolver<GQResolversTypes["Vat"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQProductGroupDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ProductGroupDeleteResponse"] = GQResolversParentTypes["ProductGroupDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQProductGroupPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ProductGroupPagination"] = GQResolversParentTypes["ProductGroupPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["ProductGroup"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQProductPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ProductPagination"] = GQResolversParentTypes["ProductPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["Product"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQQueryResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Query"] = GQResolversParentTypes["Query"]
> = {
    accessToken?: Resolver<
        GQResolversTypes["SumUpAccessTokenResponse"],
        ParentType,
        ContextType
    >;
    account?: Resolver<
        GQResolversTypes["Account"],
        ParentType,
        ContextType,
        RequireFields<GQQueryAccountArgs, "id">
    >;
    accountChartByProductGroup?: Resolver<
        GQResolversTypes["ChartAccounts"],
        ParentType,
        ContextType,
        RequireFields<GQQueryAccountChartByProductGroupArgs, "integrationId">
    >;
    accountForProductGroup?: Resolver<
        Maybe<GQResolversTypes["ChartAccount"]>,
        ParentType,
        ContextType,
        RequireFields<
            GQQueryAccountForProductGroupArgs,
            "integrationId" | "productGroupId"
        >
    >;
    accounts?: Resolver<
        GQResolversTypes["AccountPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryAccountsArgs>
    >;
    accountsByCustomerSearch?: Resolver<
        GQResolversTypes["AccountPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryAccountsByCustomerSearchArgs>
    >;
    actionsForTag?: Resolver<
        GQResolversTypes["TagActionPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryActionsForTagArgs, "tagId">
    >;
    adyenSessions?: Resolver<
        GQResolversTypes["AdyenSessionsResponse"],
        ParentType,
        ContextType
    >;
    adyenStores?: Resolver<
        GQResolversTypes["AdyenStoresPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryAdyenStoresArgs>
    >;
    adyenTerminals?: Resolver<
        GQResolversTypes["AdyenTerminalsPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryAdyenTerminalsArgs>
    >;
    adyenTerminalsForEntityConfig?: Resolver<
        GQResolversTypes["AdyenTerminalsResponse"],
        ParentType,
        ContextType,
        Partial<GQQueryAdyenTerminalsForEntityConfigArgs>
    >;
    allMiscButtons?: Resolver<
        GQResolversTypes["MiscButtonsPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryAllMiscButtonsArgs>
    >;
    approval?: Resolver<
        Maybe<GQResolversTypes["Approval"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryApprovalArgs, "id">
    >;
    approvalToken?: Resolver<
        Maybe<GQResolversTypes["ApprovalToken"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryApprovalTokenArgs, "id">
    >;
    approvalTokenGroup?: Resolver<
        Maybe<GQResolversTypes["ApprovalTokenGroup"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryApprovalTokenGroupArgs, "id">
    >;
    approvalTokenGroups?: Resolver<
        GQResolversTypes["ApprovalTokenGroupPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryApprovalTokenGroupsArgs>
    >;
    approvalTokens?: Resolver<
        GQResolversTypes["ApprovalTokenPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryApprovalTokensArgs>
    >;
    approvals?: Resolver<
        GQResolversTypes["ApprovalPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryApprovalsArgs>
    >;
    authDevicePoll?: Resolver<
        Maybe<GQResolversTypes["AuthToken"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryAuthDevicePollArgs, "deviceId" | "devicePinCode">
    >;
    authRefresh?: Resolver<
        Maybe<GQResolversTypes["AuthToken"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryAuthRefreshArgs, "refreshToken">
    >;
    bookkeepingAccount?: Resolver<
        GQResolversTypes["BookkeepingAccount"],
        ParentType,
        ContextType,
        RequireFields<GQQueryBookkeepingAccountArgs, "id">
    >;
    bookkeepingAccounts?: Resolver<
        GQResolversTypes["AccountBookkeepingPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryBookkeepingAccountsArgs>
    >;
    bookkeepingTransactions?: Resolver<
        GQResolversTypes["AccountBookkeepingTransactionPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryBookkeepingTransactionsArgs>
    >;
    canPeriodCardBeRenewed?: Resolver<
        GQResolversTypes["CanPeriodCardBeRenewedResponse"],
        ParentType,
        ContextType,
        RequireFields<GQQueryCanPeriodCardBeRenewedArgs, "productId">
    >;
    canPeriodCardBeUpgraded?: Resolver<
        GQResolversTypes["CanPeriodCardBeUpgradedResponse"],
        ParentType,
        ContextType,
        RequireFields<GQQueryCanPeriodCardBeUpgradedArgs, "productId">
    >;
    cardTransaction?: Resolver<
        GQResolversTypes["CardTransaction"],
        ParentType,
        ContextType,
        RequireFields<GQQueryCardTransactionArgs, "id">
    >;
    cardTransactions?: Resolver<
        GQResolversTypes["CardTransactionPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryCardTransactionsArgs>
    >;
    cashRegister?: Resolver<
        Maybe<GQResolversTypes["CashRegister"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryCashRegisterArgs, "id">
    >;
    cashRegisters?: Resolver<
        GQResolversTypes["CashRegisterPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryCashRegistersArgs>
    >;
    cashRegistersStatus?: Resolver<
        GQResolversTypes["CashRegisterStatusPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryCashRegistersStatusArgs>
    >;
    cmpEvent?: Resolver<
        Maybe<GQResolversTypes["CmpEvent"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryCmpEventArgs, "id">
    >;
    cmpEventByExternalId?: Resolver<
        Maybe<GQResolversTypes["CmpEventNoProducts"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryCmpEventByExternalIdArgs, "externalId">
    >;
    cmpEventProduct?: Resolver<
        Maybe<GQResolversTypes["CmpEventProduct"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryCmpEventProductArgs, "id">
    >;
    cmpEventProducts?: Resolver<
        GQResolversTypes["CmpEventProductPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryCmpEventProductsArgs, "externalEventId">
    >;
    cmpEvents?: Resolver<
        GQResolversTypes["CmpEventPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryCmpEventsArgs>
    >;
    cmpGiftcardBalance?: Resolver<
        GQResolversTypes["CmpGiftcardBalance"],
        ParentType,
        ContextType,
        RequireFields<GQQueryCmpGiftcardBalanceArgs, "code">
    >;
    cmpInvoiceCustomerSearch?: Resolver<
        GQResolversTypes["CmpInvoiceCustomerResponse"],
        ParentType,
        ContextType,
        RequireFields<GQQueryCmpInvoiceCustomerSearchArgs, "value">
    >;
    cmpProduct?: Resolver<
        Maybe<GQResolversTypes["CmpProduct"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryCmpProductArgs, "id">
    >;
    cmpProducts?: Resolver<
        GQResolversTypes["CmpProductPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryCmpProductsArgs>
    >;
    currencies?: Resolver<
        GQResolversTypes["CurrencyPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryCurrenciesArgs>
    >;
    currency?: Resolver<
        Maybe<GQResolversTypes["Currency"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryCurrencyArgs, "id">
    >;
    customer?: Resolver<
        GQResolversTypes["Customer"],
        ParentType,
        ContextType,
        RequireFields<GQQueryCustomerArgs, "id">
    >;
    customerAccounts?: Resolver<
        GQResolversTypes["AccountPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryCustomerAccountsArgs>
    >;
    customerGroup?: Resolver<
        GQResolversTypes["CustomerGroup"],
        ParentType,
        ContextType,
        RequireFields<GQQueryCustomerGroupArgs, "id">
    >;
    customerGroups?: Resolver<
        GQResolversTypes["CustomerGroupPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryCustomerGroupsArgs>
    >;
    customers?: Resolver<
        GQResolversTypes["CustomerPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryCustomersArgs>
    >;
    customersInGroup?: Resolver<
        GQResolversTypes["CustomerPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryCustomersInGroupArgs, "groupId">
    >;
    dashboard?: Resolver<
        Maybe<GQResolversTypes["Dashboard"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryDashboardArgs, "from" | "to">
    >;
    dashboardCashRegisterStats?: Resolver<
        Array<GQResolversTypes["CashRegisterVersion"]>,
        ParentType,
        ContextType
    >;
    dashboardCashRegisters?: Resolver<
        GQResolversTypes["DashboardCashRegisterPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryDashboardCashRegistersArgs>
    >;
    dashboardInvoiceAmountPerMonthStats?: Resolver<
        Maybe<Array<GQResolversTypes["InvoiceAmountPerMonth"]>>,
        ParentType,
        ContextType
    >;
    dashboardInvoiceAmountStats?: Resolver<
        Maybe<Array<GQResolversTypes["InvoiceAmount"]>>,
        ParentType,
        ContextType,
        RequireFields<GQQueryDashboardInvoiceAmountStatsArgs, "from" | "to">
    >;
    department?: Resolver<
        Maybe<GQResolversTypes["Department"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryDepartmentArgs, "id">
    >;
    departments?: Resolver<
        GQResolversTypes["DepartmentPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryDepartmentsArgs>
    >;
    device?: Resolver<
        Maybe<GQResolversTypes["Device"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryDeviceArgs, "id">
    >;
    deviceByPinCode?: Resolver<
        Maybe<GQResolversTypes["Device"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryDeviceByPinCodeArgs, "pinCode">
    >;
    devices?: Resolver<
        GQResolversTypes["DevicePagination"],
        ParentType,
        ContextType,
        Partial<GQQueryDevicesArgs>
    >;
    discount?: Resolver<
        Maybe<GQResolversTypes["Discount"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryDiscountArgs, "id">
    >;
    discounts?: Resolver<
        GQResolversTypes["DiscountPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryDiscountsArgs>
    >;
    economicSyncJobs?: Resolver<
        GQResolversTypes["EconomicSyncJobPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryEconomicSyncJobsArgs>
    >;
    entityConfig?: Resolver<
        GQResolversTypes["EntityConfig"],
        ParentType,
        ContextType,
        RequireFields<GQQueryEntityConfigArgs, "entityId">
    >;
    entityConfigs?: Resolver<
        Array<Maybe<GQResolversTypes["EntityConfig"]>>,
        ParentType,
        ContextType,
        RequireFields<GQQueryEntityConfigsArgs, "entityIds">
    >;
    eventStoreSyncGet?: Resolver<
        Array<GQResolversTypes["Event"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryEventStoreSyncGetArgs, "query">
    >;
    eventStoreSyncLatestSequence?: Resolver<
        GQResolversTypes["Int"],
        ParentType,
        ContextType,
        Partial<GQQueryEventStoreSyncLatestSequenceArgs>
    >;
    fiskalyAccessToken?: Resolver<
        GQResolversTypes["FiskalyAccessTokenResponse"],
        ParentType,
        ContextType
    >;
    fiskalyClient?: Resolver<
        Maybe<GQResolversTypes["FiskalyClient"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryFiskalyClientArgs, "id">
    >;
    fiskalyClientByCashRegisterId?: Resolver<
        Maybe<GQResolversTypes["FiskalyClient"]>,
        ParentType,
        ContextType,
        RequireFields<
            GQQueryFiskalyClientByCashRegisterIdArgs,
            "cashRegisterId"
        >
    >;
    fiskalyClients?: Resolver<
        GQResolversTypes["FiskalyClientList"],
        ParentType,
        ContextType
    >;
    fiskalyDSFinVKExport?: Resolver<
        GQResolversTypes["FiskalyDSFinVKExport"],
        ParentType,
        ContextType,
        RequireFields<GQQueryFiskalyDsFinVkExportArgs, "id">
    >;
    fiskalyDSFinVKExports?: Resolver<
        GQResolversTypes["FiskalyDSFinVKExportList"],
        ParentType,
        ContextType
    >;
    fiskalyEstablishmentMapping?: Resolver<
        GQResolversTypes["FiskalyEstablishmentMappingList"],
        ParentType,
        ContextType,
        RequireFields<GQQueryFiskalyEstablishmentMappingArgs, "integrationId">
    >;
    fiskalyEstablishmentSubmissions?: Resolver<
        GQResolversTypes["FiskalyEstablishmentSubmissionList"],
        ParentType,
        ContextType,
        Partial<GQQueryFiskalyEstablishmentSubmissionsArgs>
    >;
    fiskalyEstablishments?: Resolver<
        GQResolversTypes["FiskalyEstablishmentList"],
        ParentType,
        ContextType,
        RequireFields<GQQueryFiskalyEstablishmentsArgs, "integrationId">
    >;
    fiskalyOrganization?: Resolver<
        GQResolversTypes["FiskalyOrganization"],
        ParentType,
        ContextType,
        RequireFields<GQQueryFiskalyOrganizationArgs, "id">
    >;
    fiskalyOrganizations?: Resolver<
        GQResolversTypes["FiskalyOrganizations"],
        ParentType,
        ContextType
    >;
    fiskalyRefreshToken?: Resolver<
        GQResolversTypes["FiskalyAccessTokenResponse"],
        ParentType,
        ContextType,
        RequireFields<GQQueryFiskalyRefreshTokenArgs, "refreshToken">
    >;
    fiskalyRemoteCashRegisters?: Resolver<
        GQResolversTypes["FiskalyRemoteCashRegisterList"],
        ParentType,
        ContextType,
        RequireFields<GQQueryFiskalyRemoteCashRegistersArgs, "integrationId">
    >;
    fiskalyRemoteClients?: Resolver<
        GQResolversTypes["FiskalyRemoteClientList"],
        ParentType,
        ContextType,
        RequireFields<GQQueryFiskalyRemoteClientsArgs, "integrationId">
    >;
    fiskalyRemoteEstablishmentSubmissions?: Resolver<
        GQResolversTypes["FiskalyRemoteEstablishmentSubmissionList"],
        ParentType,
        ContextType,
        RequireFields<
            GQQueryFiskalyRemoteEstablishmentSubmissionsArgs,
            "integrationId"
        >
    >;
    fiskalyTss?: Resolver<
        GQResolversTypes["FiskalyTss"],
        ParentType,
        ContextType,
        RequireFields<GQQueryFiskalyTssArgs, "id">
    >;
    fiskalyTssList?: Resolver<
        GQResolversTypes["FiskalyTssList"],
        ParentType,
        ContextType,
        RequireFields<GQQueryFiskalyTssListArgs, "integrationId">
    >;
    getFiskalyDSFinVKExportDownload?: Resolver<
        GQResolversTypes["File"],
        ParentType,
        ContextType,
        RequireFields<GQQueryGetFiskalyDsFinVkExportDownloadArgs, "id">
    >;
    getFiskalyTaxPayer?: Resolver<
        Maybe<GQResolversTypes["FiskalyTaxPayer"]>,
        ParentType,
        ContextType
    >;
    getProduct2ViProduct2MeasurementUnit?: Resolver<
        Array<GQResolversTypes["Product2ViProduct2MeasurementUnit"]>,
        ParentType,
        ContextType,
        RequireFields<
            GQQueryGetProduct2ViProduct2MeasurementUnitArgs,
            "productId"
        >
    >;
    giftCards?: Resolver<
        GQResolversTypes["AccountPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryGiftCardsArgs>
    >;
    integration?: Resolver<
        Maybe<GQResolversTypes["Integration"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryIntegrationArgs, "id">
    >;
    integrationSettings?: Resolver<
        Maybe<GQResolversTypes["IntegrationSettings"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryIntegrationSettingsArgs, "integrationId">
    >;
    integrations?: Resolver<
        GQResolversTypes["IntegrationPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryIntegrationsArgs>
    >;
    integrationsOfType?: Resolver<
        GQResolversTypes["IntegrationArray"],
        ParentType,
        ContextType,
        RequireFields<GQQueryIntegrationsOfTypeArgs, "type">
    >;
    inventoryForIds?: Resolver<
        Array<GQResolversTypes["InventoryProduct"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryInventoryForIdsArgs, "ids">
    >;
    inventoryProduct?: Resolver<
        Maybe<GQResolversTypes["InventoryProduct"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryInventoryProductArgs, "id">
    >;
    inventoryProductNoteTemplate?: Resolver<
        Maybe<GQResolversTypes["InventoryProductNoteTemplate"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryInventoryProductNoteTemplateArgs, "id">
    >;
    inventoryProductNoteTemplates?: Resolver<
        GQResolversTypes["InventoryProductNoteTemplatePagination"],
        ParentType,
        ContextType,
        Partial<GQQueryInventoryProductNoteTemplatesArgs>
    >;
    inventoryProducts?: Resolver<
        GQResolversTypes["InventoryProductPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryInventoryProductsArgs>
    >;
    invoice?: Resolver<
        Maybe<GQResolversTypes["InvoiceRM"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryInvoiceArgs, "id">
    >;
    invoiceCount?: Resolver<
        Array<Maybe<GQResolversTypes["InvoiceCount"]>>,
        ParentType,
        ContextType,
        RequireFields<GQQueryInvoiceCountArgs, "from" | "to">
    >;
    invoices?: Resolver<
        GQResolversTypes["InvoiceRMPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryInvoicesArgs>
    >;
    invoicesInPeriod?: Resolver<
        GQResolversTypes["InvoiceRMPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryInvoicesInPeriodArgs, "from" | "to">
    >;
    isAccountNameInUse?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        Partial<GQQueryIsAccountNameInUseArgs>
    >;
    isProductPluInUse?: Resolver<
        GQResolversTypes["BooleanResponse"],
        ParentType,
        ContextType,
        RequireFields<GQQueryIsProductPluInUseArgs, "plu">
    >;
    latestTaskResults?: Resolver<
        GQResolversTypes["TaskResultPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryLatestTaskResultsArgs>
    >;
    layout?: Resolver<
        Maybe<GQResolversTypes["Layout"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryLayoutArgs, "id">
    >;
    layoutEntities?: Resolver<
        GQResolversTypes["LayoutEntityPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryLayoutEntitiesArgs>
    >;
    layoutEntity?: Resolver<
        Maybe<GQResolversTypes["LayoutEntity"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryLayoutEntityArgs, "id">
    >;
    logo?: Resolver<
        Maybe<GQResolversTypes["Logo"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryLogoArgs, "type">
    >;
    logs?: Resolver<
        GQResolversTypes["LogPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryLogsArgs>
    >;
    me?: Resolver<GQResolversTypes["Me"], ParentType, ContextType>;
    merchant?: Resolver<
        Maybe<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryMerchantArgs, "id">
    >;
    merchantAccountNo?: Resolver<
        GQResolversTypes["ChartOfAccountNo"],
        ParentType,
        ContextType,
        RequireFields<
            GQQueryMerchantAccountNoArgs,
            "defaultAccountNo" | "integrationType" | "merchantId"
        >
    >;
    merchantChartOfAccounts?: Resolver<
        GQResolversTypes["MerchantChartOfAccounts"],
        ParentType,
        ContextType,
        RequireFields<GQQueryMerchantChartOfAccountsArgs, "integrationId">
    >;
    merchants?: Resolver<
        GQResolversTypes["MerchantPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryMerchantsArgs>
    >;
    miscButtons?: Resolver<
        Maybe<GQResolversTypes["MiscButtons"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryMiscButtonsArgs, "id">
    >;
    passwordResetTokenRedeem?: Resolver<
        Maybe<GQResolversTypes["BooleanResponse"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryPasswordResetTokenRedeemArgs, "token">
    >;
    paymentConfiguration?: Resolver<
        GQResolversTypes["PaymentConfiguration"],
        ParentType,
        ContextType,
        RequireFields<GQQueryPaymentConfigurationArgs, "id">
    >;
    paymentConfigurations?: Resolver<
        GQResolversTypes["PaymentConfigurationPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryPaymentConfigurationsArgs>
    >;
    paymentMethod?: Resolver<
        GQResolversTypes["PaymentMethod"],
        ParentType,
        ContextType,
        RequireFields<GQQueryPaymentMethodArgs, "id">
    >;
    paymentMethods?: Resolver<
        GQResolversTypes["PaymentMethodPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryPaymentMethodsArgs>
    >;
    printer?: Resolver<
        GQResolversTypes["Printer"],
        ParentType,
        ContextType,
        RequireFields<GQQueryPrinterArgs, "id">
    >;
    printers?: Resolver<
        GQResolversTypes["PrinterPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryPrintersArgs>
    >;
    printersForCashRegister?: Resolver<
        GQResolversTypes["PrinterPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryPrintersForCashRegisterArgs>
    >;
    product?: Resolver<
        Maybe<GQResolversTypes["Product"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryProductArgs, "id">
    >;
    productGroup?: Resolver<
        Maybe<GQResolversTypes["ProductGroup"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryProductGroupArgs, "id">
    >;
    productGroups?: Resolver<
        GQResolversTypes["ProductGroupPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryProductGroupsArgs>
    >;
    productLayouts?: Resolver<
        GQResolversTypes["LayoutPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryProductLayoutsArgs>
    >;
    products?: Resolver<
        GQResolversTypes["ProductPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryProductsArgs>
    >;
    reportParameters?: Resolver<
        GQResolversTypes["ReportParameters"],
        ParentType,
        ContextType
    >;
    role?: Resolver<
        Maybe<GQResolversTypes["Role"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryRoleArgs, "id">
    >;
    roles?: Resolver<
        GQResolversTypes["RolePagination"],
        ParentType,
        ContextType,
        Partial<GQQueryRolesArgs>
    >;
    saftJobs?: Resolver<
        GQResolversTypes["SaftJobPagination"],
        ParentType,
        ContextType,
        Partial<GQQuerySaftJobsArgs>
    >;
    shift?: Resolver<
        Maybe<GQResolversTypes["ShiftRM"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryShiftArgs, "id">
    >;
    shifts?: Resolver<
        GQResolversTypes["ShiftRMPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryShiftsArgs>
    >;
    shiftsByCashRegister?: Resolver<
        GQResolversTypes["ShiftRMPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryShiftsByCashRegisterArgs, "cashRegisterId">
    >;
    shiftsByOpenedByUser?: Resolver<
        GQResolversTypes["ShiftRMPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryShiftsByOpenedByUserArgs, "userId">
    >;
    shiftsInPeriod?: Resolver<
        GQResolversTypes["ShiftRMPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryShiftsInPeriodArgs, "from" | "to">
    >;
    softpayAccessToken?: Resolver<
        GQResolversTypes["SoftpayAccessTokenResponse"],
        ParentType,
        ContextType
    >;
    softpayCloudTerminals?: Resolver<
        GQResolversTypes["SoftpayCloudTerminalsPagination"],
        ParentType,
        ContextType,
        Partial<GQQuerySoftpayCloudTerminalsArgs>
    >;
    softpayMerchants?: Resolver<
        GQResolversTypes["SoftpayMerchantsPagination"],
        ParentType,
        ContextType,
        Partial<GQQuerySoftpayMerchantsArgs>
    >;
    softpayMiaMerchant?: Resolver<
        GQResolversTypes["SoftpayMiaMerchant"],
        ParentType,
        ContextType,
        RequireFields<GQQuerySoftpayMiaMerchantArgs, "acquirer" | "merchantId">
    >;
    softpayMiaMerchants?: Resolver<
        GQResolversTypes["SoftpayMiaMerchantsPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQuerySoftpayMiaMerchantsArgs, "acquirer">
    >;
    softpayMiaStore?: Resolver<
        GQResolversTypes["SoftpayMiaStore"],
        ParentType,
        ContextType,
        RequireFields<
            GQQuerySoftpayMiaStoreArgs,
            "acquirer" | "merchantId" | "storeId"
        >
    >;
    softpayMiaTerminal?: Resolver<
        GQResolversTypes["SoftpayMiaTerminal"],
        ParentType,
        ContextType,
        RequireFields<
            GQQuerySoftpayMiaTerminalArgs,
            "acquirer" | "merchantId" | "storeId" | "terminalId"
        >
    >;
    tableLayouts?: Resolver<
        GQResolversTypes["LayoutPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryTableLayoutsArgs>
    >;
    tag?: Resolver<
        GQResolversTypes["Tag"],
        ParentType,
        ContextType,
        RequireFields<GQQueryTagArgs, "id">
    >;
    tagGroup?: Resolver<
        GQResolversTypes["TagGroup"],
        ParentType,
        ContextType,
        RequireFields<GQQueryTagGroupArgs, "id">
    >;
    tagGroups?: Resolver<
        GQResolversTypes["TagGroupPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryTagGroupsArgs>
    >;
    tags?: Resolver<
        GQResolversTypes["TagPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryTagsArgs>
    >;
    tagsByAccount?: Resolver<
        GQResolversTypes["TagPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryTagsByAccountArgs, "accountId">
    >;
    tagsByCustomer?: Resolver<
        GQResolversTypes["TagPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryTagsByCustomerArgs, "customerId">
    >;
    tagsByGroup?: Resolver<
        GQResolversTypes["TagPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryTagsByGroupArgs, "groupId">
    >;
    tagsWithoutAccount?: Resolver<
        GQResolversTypes["TagPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryTagsWithoutAccountArgs>
    >;
    tagsWithoutCustomer?: Resolver<
        GQResolversTypes["TagPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryTagsWithoutCustomerArgs>
    >;
    taskResult?: Resolver<
        GQResolversTypes["TaskResult"],
        ParentType,
        ContextType,
        RequireFields<GQQueryTaskResultArgs, "id">
    >;
    taskResults?: Resolver<
        GQResolversTypes["TaskResultPagination"],
        ParentType,
        ContextType,
        RequireFields<GQQueryTaskResultsArgs, "type">
    >;
    transactions?: Resolver<
        GQResolversTypes["AccountTransactionPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryTransactionsArgs>
    >;
    user?: Resolver<
        Maybe<GQResolversTypes["User"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryUserArgs, "id">
    >;
    userAvailability?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType,
        RequireFields<GQQueryUserAvailabilityArgs, "username">
    >;
    userRoleConfiguration?: Resolver<
        Maybe<GQResolversTypes["UserRoleConfiguration"]>,
        ParentType,
        ContextType,
        RequireFields<
            GQQueryUserRoleConfigurationArgs,
            "roleId" | "type" | "userId"
        >
    >;
    users?: Resolver<
        GQResolversTypes["UserPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryUsersArgs>
    >;
    vat?: Resolver<
        Maybe<GQResolversTypes["Vat"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryVatArgs, "id">
    >;
    vats?: Resolver<
        GQResolversTypes["VatPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryVatsArgs>
    >;
    venueAccessTicketParameters?: Resolver<
        GQResolversTypes["VenueAccessParameters"],
        ParentType,
        ContextType,
        Partial<GQQueryVenueAccessTicketParametersArgs>
    >;
    venueAccessTicketParametersBulk?: Resolver<
        GQResolversTypes["VenueAccessParametersBulk"],
        ParentType,
        ContextType,
        RequireFields<GQQueryVenueAccessTicketParametersBulkArgs, "eventIds">
    >;
    viProducts?: Resolver<
        GQResolversTypes["ViProductPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryViProductsArgs>
    >;
    viWarehouseForDepartment?: Resolver<
        Array<GQResolversTypes["ViWarehouse"]>,
        ParentType,
        ContextType,
        RequireFields<GQQueryViWarehouseForDepartmentArgs, "departmentId">
    >;
    viWarehouses?: Resolver<
        GQResolversTypes["ViWarehousePagination"],
        ParentType,
        ContextType,
        Partial<GQQueryViWarehousesArgs>
    >;
    virtualPrinter?: Resolver<
        GQResolversTypes["VirtualPrinter"],
        ParentType,
        ContextType,
        RequireFields<GQQueryVirtualPrinterArgs, "id">
    >;
    virtualPrinters?: Resolver<
        GQResolversTypes["VirtualPrinterPagination"],
        ParentType,
        ContextType,
        Partial<GQQueryVirtualPrintersArgs>
    >;
};

export type GQRemoteEstablishmentSubmissionResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["RemoteEstablishmentSubmission"] = GQResolversParentTypes["RemoteEstablishmentSubmission"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    error?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    establishmentId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    state?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    transmittedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQReportCashRegisterResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ReportCashRegister"] = GQResolversParentTypes["ReportCashRegister"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQReportDepartmentResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ReportDepartment"] = GQResolversParentTypes["ReportDepartment"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQReportParametersResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ReportParameters"] = GQResolversParentTypes["ReportParameters"]
> = {
    cashRegisters?: Resolver<
        Array<GQResolversTypes["ReportCashRegister"]>,
        ParentType,
        ContextType
    >;
    departments?: Resolver<
        Array<GQResolversTypes["ReportDepartment"]>,
        ParentType,
        ContextType
    >;
    productGroups?: Resolver<
        Array<GQResolversTypes["ReportProductGroup"]>,
        ParentType,
        ContextType
    >;
    products?: Resolver<
        Array<GQResolversTypes["ReportProduct"]>,
        ParentType,
        ContextType
    >;
    users?: Resolver<
        Array<GQResolversTypes["ReportUser"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQReportProductResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ReportProduct"] = GQResolversParentTypes["ReportProduct"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQReportProductGroupResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ReportProductGroup"] = GQResolversParentTypes["ReportProductGroup"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQReportUserResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ReportUser"] = GQResolversParentTypes["ReportUser"]
> = {
    firstName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    lastName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    username?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQRoleResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Role"] = GQResolversParentTypes["Role"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    inUse?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    merchant?: Resolver<
        Maybe<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    permissions?: Resolver<
        Array<GQResolversTypes["RolePermission"]>,
        ParentType,
        ContextType
    >;
    shared?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["RoleTypeEnum"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQRoleDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["RoleDeleteResponse"] = GQResolversParentTypes["RoleDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQRolePaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["RolePagination"] = GQResolversParentTypes["RolePagination"]
> = {
    data?: Resolver<Array<GQResolversTypes["Role"]>, ParentType, ContextType>;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQRolePermissionResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["RolePermission"] = GQResolversParentTypes["RolePermission"]
> = {
    key?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    role?: Resolver<GQResolversTypes["Role"], ParentType, ContextType>;
    value?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSaftJobResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SaftJob"] = GQResolversParentTypes["SaftJob"]
> = {
    attempts?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    lastError?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    runAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    shift?: Resolver<
        Maybe<GQResolversTypes["ShiftRM"]>,
        ParentType,
        ContextType
    >;
    shiftId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSaftJobPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SaftJobPagination"] = GQResolversParentTypes["SaftJobPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["SaftJob"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSelectUserRoleTypeResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SelectUserRoleType"] = GQResolversParentTypes["SelectUserRoleType"]
> = {
    token?: Resolver<GQResolversTypes["AuthToken"], ParentType, ContextType>;
    userRole?: Resolver<GQResolversTypes["UserRole"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQShiftFundsRmResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ShiftFundsRM"] = GQResolversParentTypes["ShiftFundsRM"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    name?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQShiftPaymentCardRmResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ShiftPaymentCardRM"] = GQResolversParentTypes["ShiftPaymentCardRM"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    count?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    paymentProvider?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQShiftPaymentRmResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ShiftPaymentRM"] = GQResolversParentTypes["ShiftPaymentRM"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    cardSchemas?: Resolver<
        Maybe<Array<GQResolversTypes["ShiftPaymentCardRM"]>>,
        ParentType,
        ContextType
    >;
    currency?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    currencyRate?: Resolver<
        Maybe<GQResolversTypes["Float"]>,
        ParentType,
        ContextType
    >;
    event?: Resolver<
        GQResolversTypes["ShiftPaymentRMEvent"],
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    paymentMethodId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQShiftRmResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ShiftRM"] = GQResolversParentTypes["ShiftRM"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    cashDifference?: Resolver<
        GQResolversTypes["Float"],
        ParentType,
        ContextType
    >;
    cashInfoPerMethod?: Resolver<
        Maybe<GQResolversTypes["CashInfoPerMethod"]>,
        ParentType,
        ContextType
    >;
    cashRegister?: Resolver<
        GQResolversTypes["CashRegister"],
        ParentType,
        ContextType
    >;
    cashRegisterName?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    closedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    closedByUser?: Resolver<
        Maybe<GQResolversTypes["User"]>,
        ParentType,
        ContextType
    >;
    discount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    funds?: Resolver<
        Maybe<Array<GQResolversTypes["ShiftFundsRM"]>>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    invoices?: Resolver<
        GQResolversTypes["InvoiceRMPagination"],
        ParentType,
        ContextType,
        Partial<GQShiftRmInvoicesArgs>
    >;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    numCashDrawerOpen?: Resolver<
        GQResolversTypes["Float"],
        ParentType,
        ContextType
    >;
    openedAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    openedByUser?: Resolver<GQResolversTypes["User"], ParentType, ContextType>;
    openingAmount?: Resolver<
        Maybe<GQResolversTypes["Float"]>,
        ParentType,
        ContextType
    >;
    payments?: Resolver<
        Maybe<Array<GQResolversTypes["ShiftPaymentRM"]>>,
        ParentType,
        ContextType
    >;
    salesData?: Resolver<
        Maybe<GQResolversTypes["ShiftSalesData"]>,
        ParentType,
        ContextType
    >;
    shiftNumber?: Resolver<
        Maybe<GQResolversTypes["Int"]>,
        ParentType,
        ContextType
    >;
    syncDetails?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    syncStatus?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    syncedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    xReport?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    zReport?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQShiftRmPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ShiftRMPagination"] = GQResolversParentTypes["ShiftRMPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["ShiftRM"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQShiftSalesDataResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ShiftSalesData"] = GQResolversParentTypes["ShiftSalesData"]
> = {
    byProductGroup?: Resolver<
        Maybe<Array<GQResolversTypes["ShiftSalesDataByProductGroup"]>>,
        ParentType,
        ContextType
    >;
    hourSales?: Resolver<
        Maybe<Array<GQResolversTypes["InvoiceHourSales"]>>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQShiftSalesDataByProductGroupResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ShiftSalesDataByProductGroup"] = GQResolversParentTypes["ShiftSalesDataByProductGroup"]
> = {
    amount?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayAccessTokenResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayAccessTokenResponse"] = GQResolversParentTypes["SoftpayAccessTokenResponse"]
> = {
    accessToken?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    expiresIn?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    tokenType?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayCloudStoreResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayCloudStore"] = GQResolversParentTypes["SoftpayCloudStore"]
> = {
    acquirerStoreId?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    address?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    businessRegistrationNumber?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    city?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    countryNumeric?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    phone?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    timeZoneId?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    zip?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayCloudTerminalResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayCloudTerminal"] = GQResolversParentTypes["SoftpayCloudTerminal"]
> = {
    appId?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    lastOnline?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    store?: Resolver<
        GQResolversTypes["SoftpayCloudStore"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayCloudTerminalsPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayCloudTerminalsPagination"] = GQResolversParentTypes["SoftpayCloudTerminalsPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["SoftpayCloudTerminal"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayMerchantResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayMerchant"] = GQResolversParentTypes["SoftpayMerchant"]
> = {
    businessRegistrationNumber?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    merchantReference?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    name?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayMerchantsPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayMerchantsPagination"] = GQResolversParentTypes["SoftpayMerchantsPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["SoftpayMerchant"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayMiaAdditionalDataResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayMiaAdditionalData"] = GQResolversParentTypes["SoftpayMiaAdditionalData"]
> = {
    key?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    value?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayMiaMerchantResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayMiaMerchant"] = GQResolversParentTypes["SoftpayMiaMerchant"]
> = {
    aidGroup?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    businessRegNo?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    countryCode?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    localPrivileges?: Resolver<
        Array<Maybe<GQResolversTypes["String"]>>,
        ParentType,
        ContextType
    >;
    merchantId?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    merchantName?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    merchantReference?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    primaryContactEmail?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    primaryContactPhone?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    remotePrivileges?: Resolver<
        Array<Maybe<GQResolversTypes["String"]>>,
        ParentType,
        ContextType
    >;
    state?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    stores?: Resolver<
        Array<Maybe<GQResolversTypes["SoftpayMiaStore"]>>,
        ParentType,
        ContextType,
        RequireFields<GQSoftpayMiaMerchantStoresArgs, "acquirer">
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayMiaMerchantsPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayMiaMerchantsPagination"] = GQResolversParentTypes["SoftpayMiaMerchantsPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["SoftpayMiaMerchant"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayMiaProcessorDataResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayMiaProcessorData"] = GQResolversParentTypes["SoftpayMiaProcessorData"]
> = {
    cardSchema?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    processorMerchantId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    processorName?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    processorTerminalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayMiaStoreResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayMiaStore"] = GQResolversParentTypes["SoftpayMiaStore"]
> = {
    additionalData?: Resolver<
        Maybe<Array<GQResolversTypes["SoftpayMiaAdditionalData"]>>,
        ParentType,
        ContextType
    >;
    addressLine1?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    addressLine2?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    businessRegNo?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    cardAcceptorCountryCode?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    cardAcceptorNameLocation?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    city?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    onlineStoreId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    phone?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    state?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    storeId?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    terminals?: Resolver<
        Array<Maybe<GQResolversTypes["SoftpayMiaTerminal"]>>,
        ParentType,
        ContextType,
        RequireFields<GQSoftpayMiaStoreTerminalsArgs, "acquirer">
    >;
    timeZone?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    zipCode?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSoftpayMiaTerminalResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SoftpayMiaTerminal"] = GQResolversParentTypes["SoftpayMiaTerminal"]
> = {
    additionalData?: Resolver<
        Maybe<Array<GQResolversTypes["SoftpayMiaAdditionalData"]>>,
        ParentType,
        ContextType
    >;
    appId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    defaultCurrencyCode?: Resolver<
        GQResolversTypes["String"],
        ParentType,
        ContextType
    >;
    installed?: Resolver<
        Maybe<GQResolversTypes["Boolean"]>,
        ParentType,
        ContextType
    >;
    kernelDataId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    lastOnline?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    merchantCategoryCode?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    onlineMerchantId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    onlineTerminalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    processorData?: Resolver<
        Maybe<GQResolversTypes["SoftpayMiaProcessorData"]>,
        ParentType,
        ContextType
    >;
    profileName?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    publicKeySetId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    releasedAt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    softpayTerminalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    state?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    takenAt?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    terminalId?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQSubscriptionResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Subscription"] = GQResolversParentTypes["Subscription"]
> = {
    dashboardUpdated?: SubscriptionResolver<
        Maybe<GQResolversTypes["Dashboard"]>,
        "dashboardUpdated",
        ParentType,
        ContextType,
        RequireFields<GQSubscriptionDashboardUpdatedArgs, "from" | "to">
    >;
    eventStoreSubscribe?: SubscriptionResolver<
        Array<GQResolversTypes["Event"]>,
        "eventStoreSubscribe",
        ParentType,
        ContextType,
        RequireFields<GQSubscriptionEventStoreSubscribeArgs, "query">
    >;
    logoDataUpdated?: SubscriptionResolver<
        GQResolversTypes["Date"],
        "logoDataUpdated",
        ParentType,
        ContextType
    >;
    merchantDataUpdated?: SubscriptionResolver<
        GQResolversTypes["Date"],
        "merchantDataUpdated",
        ParentType,
        ContextType
    >;
};

export type GQSumUpAccessTokenResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["SumUpAccessTokenResponse"] = GQResolversParentTypes["SumUpAccessTokenResponse"]
> = {
    accessToken?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQTagResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Tag"] = GQResolversParentTypes["Tag"]
> = {
    account?: Resolver<
        Maybe<GQResolversTypes["Account"]>,
        ParentType,
        ContextType
    >;
    actionsForTag?: Resolver<
        GQResolversTypes["TagActionPagination"],
        ParentType,
        ContextType,
        RequireFields<GQTagActionsForTagArgs, "tagId">
    >;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    customer?: Resolver<
        Maybe<GQResolversTypes["Customer"]>,
        ParentType,
        ContextType
    >;
    group?: Resolver<
        Maybe<GQResolversTypes["TagGroup"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    identifier?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    merchantId?: Resolver<
        GQResolversTypes["Merchant"],
        ParentType,
        ContextType
    >;
    name?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    tagType?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQTagActionResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["TagAction"] = GQResolversParentTypes["TagAction"]
> = {
    accountId?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    accountName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    action?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    userName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQTagActionPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["TagActionPagination"] = GQResolversParentTypes["TagActionPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["TagAction"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQTagDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["TagDeleteResponse"] = GQResolversParentTypes["TagDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQTagGroupResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["TagGroup"] = GQResolversParentTypes["TagGroup"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQTagGroupDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["TagGroupDeleteResponse"] = GQResolversParentTypes["TagGroupDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQTagGroupPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["TagGroupPagination"] = GQResolversParentTypes["TagGroupPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["TagGroup"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQTagPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["TagPagination"] = GQResolversParentTypes["TagPagination"]
> = {
    data?: Resolver<Array<GQResolversTypes["Tag"]>, ParentType, ContextType>;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQTaskResultResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["TaskResult"] = GQResolversParentTypes["TaskResult"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    executionTime?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    jobId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    output?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    status?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQTaskResultPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["TaskResultPagination"] = GQResolversParentTypes["TaskResultPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["TaskResult"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQUserResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["User"] = GQResolversParentTypes["User"]
> = {
    active?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    email?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    firstName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    lastLoginAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    lastName?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    pin?: Resolver<Maybe<GQResolversTypes["String"]>, ParentType, ContextType>;
    requireLoginPin?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    requireLogoutPin?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    requirePasswordChange?: Resolver<
        GQResolversTypes["Boolean"],
        ParentType,
        ContextType
    >;
    roles?: Resolver<
        Array<GQResolversTypes["UserRole"]>,
        ParentType,
        ContextType,
        Partial<GQUserRolesArgs>
    >;
    updatedAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    username?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQUserDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["UserDeleteResponse"] = GQResolversParentTypes["UserDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQUserPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["UserPagination"] = GQResolversParentTypes["UserPagination"]
> = {
    data?: Resolver<Array<GQResolversTypes["User"]>, ParentType, ContextType>;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQUserRoleResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["UserRole"] = GQResolversParentTypes["UserRole"]
> = {
    merchant?: Resolver<
        Maybe<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType
    >;
    role?: Resolver<GQResolversTypes["Role"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQUserRoleConfigurationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["UserRoleConfiguration"] = GQResolversParentTypes["UserRoleConfiguration"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    data?: Resolver<GQResolversTypes["JSON"], ParentType, ContextType>;
    merchant?: Resolver<
        Maybe<GQResolversTypes["Merchant"]>,
        ParentType,
        ContextType
    >;
    role?: Resolver<GQResolversTypes["Role"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    user?: Resolver<GQResolversTypes["User"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVatResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["Vat"] = GQResolversParentTypes["Vat"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    externalId?: Resolver<
        Maybe<GQResolversTypes["String"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    isExternal?: Resolver<
        Maybe<GQResolversTypes["Boolean"]>,
        ParentType,
        ContextType
    >;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    percentage?: Resolver<GQResolversTypes["Float"], ParentType, ContextType>;
    updatedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVatDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VatDeleteResponse"] = GQResolversParentTypes["VatDeleteResponse"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVatPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VatPagination"] = GQResolversParentTypes["VatPagination"]
> = {
    data?: Resolver<Array<GQResolversTypes["Vat"]>, ParentType, ContextType>;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVenueAccessAccessTypeResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VenueAccessAccessType"] = GQResolversParentTypes["VenueAccessAccessType"]
> = {
    id?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVenueAccessEventResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VenueAccessEvent"] = GQResolversParentTypes["VenueAccessEvent"]
> = {
    id?: Resolver<GQResolversTypes["Int"], ParentType, ContextType>;
    isActive?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVenueAccessParametersResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VenueAccessParameters"] = GQResolversParentTypes["VenueAccessParameters"]
> = {
    accessTypes?: Resolver<
        Array<GQResolversTypes["VenueAccessAccessType"]>,
        ParentType,
        ContextType
    >;
    events?: Resolver<
        Maybe<Array<GQResolversTypes["VenueAccessEvent"]>>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVenueAccessParametersBulkResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VenueAccessParametersBulk"] = GQResolversParentTypes["VenueAccessParametersBulk"]
> = {
    accessTypes?: Resolver<
        Array<GQResolversTypes["VenueAccessAccessType"]>,
        ParentType,
        ContextType
    >;
    events?: Resolver<
        Array<GQResolversTypes["VenueAccessEvent"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVenueAccessSettingsResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VenueAccessSettings"] = GQResolversParentTypes["VenueAccessSettings"]
> = {
    bar?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    integrationId?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    type?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVenueAccessTicketCancelledResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VenueAccessTicketCancelled"] = GQResolversParentTypes["VenueAccessTicketCancelled"]
> = {
    status?: Resolver<GQResolversTypes["Boolean"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVenueAccessTicketCreatedResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VenueAccessTicketCreated"] = GQResolversParentTypes["VenueAccessTicketCreated"]
> = {
    ticketId?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    tokenValue?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQViProductResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ViProduct"] = GQResolversParentTypes["ViProduct"]
> = {
    deletedAt?: Resolver<
        Maybe<GQResolversTypes["Date"]>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    measurementUnit?: Resolver<
        Array<GQResolversTypes["MeasurementUnit"]>,
        ParentType,
        ContextType
    >;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQViProductPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ViProductPagination"] = GQResolversParentTypes["ViProductPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["ViProduct"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQViWarehouseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ViWarehouse"] = GQResolversParentTypes["ViWarehouse"]
> = {
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQViWarehousePaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["ViWarehousePagination"] = GQResolversParentTypes["ViWarehousePagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["ViWarehouse"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVirtualPrinterResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VirtualPrinter"] = GQResolversParentTypes["VirtualPrinter"]
> = {
    createdAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    departments?: Resolver<
        Maybe<Array<GQResolversTypes["VirtualPrinterDepartment"]>>,
        ParentType,
        ContextType
    >;
    id?: Resolver<GQResolversTypes["ID"], ParentType, ContextType>;
    merchant?: Resolver<GQResolversTypes["Merchant"], ParentType, ContextType>;
    name?: Resolver<GQResolversTypes["String"], ParentType, ContextType>;
    printer?: Resolver<GQResolversTypes["Printer"], ParentType, ContextType>;
    updatedAt?: Resolver<GQResolversTypes["Date"], ParentType, ContextType>;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVirtualPrinterDeleteResponseResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VirtualPrinterDeleteResponse"] = GQResolversParentTypes["VirtualPrinterDeleteResponse"]
> = {
    status?: Resolver<
        GQResolversTypes["DeleteResponseEnum"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVirtualPrinterDepartmentResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VirtualPrinterDepartment"] = GQResolversParentTypes["VirtualPrinterDepartment"]
> = {
    department?: Resolver<
        GQResolversTypes["Department"],
        ParentType,
        ContextType
    >;
    printer?: Resolver<
        Maybe<GQResolversTypes["Printer"]>,
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQVirtualPrinterPaginationResolvers<
    ContextType = any,
    ParentType extends GQResolversParentTypes["VirtualPrinterPagination"] = GQResolversParentTypes["VirtualPrinterPagination"]
> = {
    data?: Resolver<
        Array<GQResolversTypes["VirtualPrinter"]>,
        ParentType,
        ContextType
    >;
    pagination?: Resolver<
        GQResolversTypes["Pagination"],
        ParentType,
        ContextType
    >;
    __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQResolvers<ContextType = any> = {
    Account?: GQAccountResolvers<ContextType>;
    AccountBookkeepingPagination?: GQAccountBookkeepingPaginationResolvers<ContextType>;
    AccountBookkeepingTransaction?: GQAccountBookkeepingTransactionResolvers<ContextType>;
    AccountBookkeepingTransactionPagination?: GQAccountBookkeepingTransactionPaginationResolvers<ContextType>;
    AccountBuyFundsResponse?: GQAccountBuyFundsResponseResolvers<ContextType>;
    AccountCloseResponse?: GQAccountCloseResponseResolvers<ContextType>;
    AccountOpenResponse?: GQAccountOpenResponseResolvers<ContextType>;
    AccountPagination?: GQAccountPaginationResolvers<ContextType>;
    AccountPayAmountResponse?: GQAccountPayAmountResponseResolvers<ContextType>;
    AccountRefundAmountResponse?: GQAccountRefundAmountResponseResolvers<ContextType>;
    AccountReturnFundsResponse?: GQAccountReturnFundsResponseResolvers<ContextType>;
    AccountRevertTransactionResponse?: GQAccountRevertTransactionResponseResolvers<ContextType>;
    AccountTransaction?: GQAccountTransactionResolvers<ContextType>;
    AccountTransactionPagination?: GQAccountTransactionPaginationResolvers<ContextType>;
    AddEventResponse?: GQAddEventResponseResolvers<ContextType>;
    AdyenSessionsResponse?: GQAdyenSessionsResponseResolvers<ContextType>;
    AdyenStore?: GQAdyenStoreResolvers<ContextType>;
    AdyenStoreLocation?: GQAdyenStoreLocationResolvers<ContextType>;
    AdyenStoresPagination?: GQAdyenStoresPaginationResolvers<ContextType>;
    AdyenTerminal?: GQAdyenTerminalResolvers<ContextType>;
    AdyenTerminalAssignment?: GQAdyenTerminalAssignmentResolvers<ContextType>;
    AdyenTerminalConnectivity?: GQAdyenTerminalConnectivityResolvers<ContextType>;
    AdyenTerminalConnectivityBluetooth?: GQAdyenTerminalConnectivityBluetoothResolvers<ContextType>;
    AdyenTerminalConnectivityCellular?: GQAdyenTerminalConnectivityCellularResolvers<ContextType>;
    AdyenTerminalConnectivityEthernet?: GQAdyenTerminalConnectivityEthernetResolvers<ContextType>;
    AdyenTerminalConnectivityWifi?: GQAdyenTerminalConnectivityWifiResolvers<ContextType>;
    AdyenTerminalsPagination?: GQAdyenTerminalsPaginationResolvers<ContextType>;
    AdyenTerminalsResponse?: GQAdyenTerminalsResponseResolvers<ContextType>;
    AppData?: GQAppDataResolvers<ContextType>;
    Approval?: GQApprovalResolvers<ContextType>;
    ApprovalPagination?: GQApprovalPaginationResolvers<ContextType>;
    ApprovalToken?: GQApprovalTokenResolvers<ContextType>;
    ApprovalTokenGroup?: GQApprovalTokenGroupResolvers<ContextType>;
    ApprovalTokenGroupPagination?: GQApprovalTokenGroupPaginationResolvers<ContextType>;
    ApprovalTokenPagination?: GQApprovalTokenPaginationResolvers<ContextType>;
    AuthAttempt?: GQAuthAttemptResolvers<ContextType>;
    AuthToken?: GQAuthTokenResolvers<ContextType>;
    Balance?: GQBalanceResolvers<ContextType>;
    BookkeepingAccount?: GQBookkeepingAccountResolvers<ContextType>;
    BooleanResponse?: GQBooleanResponseResolvers<ContextType>;
    BuyAccountFunds?: GQBuyAccountFundsResolvers<ContextType>;
    Byte?: GraphQLScalarType;
    CanPeriodCardBeRenewedResponse?: GQCanPeriodCardBeRenewedResponseResolvers<ContextType>;
    CanPeriodCardBeUpgradedResponse?: GQCanPeriodCardBeUpgradedResponseResolvers<ContextType>;
    CardTransaction?: GQCardTransactionResolvers<ContextType>;
    CardTransactionPagination?: GQCardTransactionPaginationResolvers<ContextType>;
    CashDifferencePerMethod?: GQCashDifferencePerMethodResolvers<ContextType>;
    CashInfoPerMethod?: GQCashInfoPerMethodResolvers<ContextType>;
    CashRegister?: GQCashRegisterResolvers<ContextType>;
    CashRegisterDeleteResponse?: GQCashRegisterDeleteResponseResolvers<ContextType>;
    CashRegisterPagination?: GQCashRegisterPaginationResolvers<ContextType>;
    CashRegisterStatus?: GQCashRegisterStatusResolvers<ContextType>;
    CashRegisterStatusPagination?: GQCashRegisterStatusPaginationResolvers<ContextType>;
    CashRegisterVersion?: GQCashRegisterVersionResolvers<ContextType>;
    CashSalePerMethod?: GQCashSalePerMethodResolvers<ContextType>;
    ChartAccount?: GQChartAccountResolvers<ContextType>;
    ChartAccounts?: GQChartAccountsResolvers<ContextType>;
    ChartOfAccountNo?: GQChartOfAccountNoResolvers<ContextType>;
    CmpEvent?: GQCmpEventResolvers<ContextType>;
    CmpEventNoProducts?: GQCmpEventNoProductsResolvers<ContextType>;
    CmpEventOrderCreated?: GQCmpEventOrderCreatedResolvers<ContextType>;
    CmpEventOrderReceipt?: GQCmpEventOrderReceiptResolvers<ContextType>;
    CmpEventPagination?: GQCmpEventPaginationResolvers<ContextType>;
    CmpEventProduct?: GQCmpEventProductResolvers<ContextType>;
    CmpEventProductPagination?: GQCmpEventProductPaginationResolvers<ContextType>;
    CmpGiftcardBalance?: GQCmpGiftcardBalanceResolvers<ContextType>;
    CmpGiftcardPayAmountResponse?: GQCmpGiftcardPayAmountResponseResolvers<ContextType>;
    CmpGiftcardRefundAmountResponse?: GQCmpGiftcardRefundAmountResponseResolvers<ContextType>;
    CmpInvoiceCustomer?: GQCmpInvoiceCustomerResolvers<ContextType>;
    CmpInvoiceCustomerResponse?: GQCmpInvoiceCustomerResponseResolvers<ContextType>;
    CmpInvoicePaymentMethod?: GQCmpInvoicePaymentMethodResolvers<ContextType>;
    CmpProduct?: GQCmpProductResolvers<ContextType>;
    CmpProductPagination?: GQCmpProductPaginationResolvers<ContextType>;
    CmpProductResponse?: GQCmpProductResponseResolvers<ContextType>;
    CmpProductSettings?: GQCmpProductSettingsResolvers<ContextType>;
    Configuration?: GQConfigurationResolvers<ContextType>;
    CreateTssResponse?: GQCreateTssResponseResolvers<ContextType>;
    Currency?: GQCurrencyResolvers<ContextType>;
    CurrencyDeleteResponse?: GQCurrencyDeleteResponseResolvers<ContextType>;
    CurrencyPagination?: GQCurrencyPaginationResolvers<ContextType>;
    CursorPagination?: GQCursorPaginationResolvers<ContextType>;
    CustomItem?: GQCustomItemResolvers<ContextType>;
    Customer?: GQCustomerResolvers<ContextType>;
    CustomerAssignTagsRelationResponse?: GQCustomerAssignTagsRelationResponseResolvers<ContextType>;
    CustomerDeleteResponse?: GQCustomerDeleteResponseResolvers<ContextType>;
    CustomerGroup?: GQCustomerGroupResolvers<ContextType>;
    CustomerGroupDeleteResponse?: GQCustomerGroupDeleteResponseResolvers<ContextType>;
    CustomerGroupPagination?: GQCustomerGroupPaginationResolvers<ContextType>;
    CustomerPagination?: GQCustomerPaginationResolvers<ContextType>;
    Dashboard?: GQDashboardResolvers<ContextType>;
    DashboardAccountItem?: GQDashboardAccountItemResolvers<ContextType>;
    DashboardAmountByHourItem?: GQDashboardAmountByHourItemResolvers<ContextType>;
    DashboardCashRegister?: GQDashboardCashRegisterResolvers<ContextType>;
    DashboardCashRegisterPagination?: GQDashboardCashRegisterPaginationResolvers<ContextType>;
    DashboardDepartmentItem?: GQDashboardDepartmentItemResolvers<ContextType>;
    DashboardProductGroupItem?: GQDashboardProductGroupItemResolvers<ContextType>;
    DashboardProductItem?: GQDashboardProductItemResolvers<ContextType>;
    DashboardTotals?: GQDashboardTotalsResolvers<ContextType>;
    Date?: GraphQLScalarType;
    Department?: GQDepartmentResolvers<ContextType>;
    DepartmentDeleteResponse?: GQDepartmentDeleteResponseResolvers<ContextType>;
    DepartmentPagination?: GQDepartmentPaginationResolvers<ContextType>;
    Device?: GQDeviceResolvers<ContextType>;
    DevicePagination?: GQDevicePaginationResolvers<ContextType>;
    DevicePinCodeValidation?: GQDevicePinCodeValidationResolvers<ContextType>;
    Discount?: GQDiscountResolvers<ContextType>;
    DiscountPagination?: GQDiscountPaginationResolvers<ContextType>;
    DiscountTemplate?: GQDiscountTemplateResolvers<ContextType>;
    EconomicSettings?: GQEconomicSettingsResolvers<ContextType>;
    EconomicSyncJob?: GQEconomicSyncJobResolvers<ContextType>;
    EconomicSyncJobPagination?: GQEconomicSyncJobPaginationResolvers<ContextType>;
    Entity?: GQEntityResolvers<ContextType>;
    EntityConfig?: GQEntityConfigResolvers<ContextType>;
    EntityConfigDeleteResponse?: GQEntityConfigDeleteResponseResolvers<ContextType>;
    Event?: GQEventResolvers<ContextType>;
    File?: GQFileResolvers<ContextType>;
    FiskalyAccessTokenResponse?: GQFiskalyAccessTokenResponseResolvers<ContextType>;
    FiskalyClient?: GQFiskalyClientResolvers<ContextType>;
    FiskalyClientList?: GQFiskalyClientListResolvers<ContextType>;
    FiskalyConfiguration?: GQFiskalyConfigurationResolvers<ContextType>;
    FiskalyDSFinVKExport?: GQFiskalyDsFinVkExportResolvers<ContextType>;
    FiskalyDSFinVKExportList?: GQFiskalyDsFinVkExportListResolvers<ContextType>;
    FiskalyEstablishment?: GQFiskalyEstablishmentResolvers<ContextType>;
    FiskalyEstablishmentList?: GQFiskalyEstablishmentListResolvers<ContextType>;
    FiskalyEstablishmentMapping?: GQFiskalyEstablishmentMappingResolvers<ContextType>;
    FiskalyEstablishmentMappingList?: GQFiskalyEstablishmentMappingListResolvers<ContextType>;
    FiskalyEstablishmentSubmission?: GQFiskalyEstablishmentSubmissionResolvers<ContextType>;
    FiskalyEstablishmentSubmissionDownload?: GQFiskalyEstablishmentSubmissionDownloadResolvers<ContextType>;
    FiskalyEstablishmentSubmissionList?: GQFiskalyEstablishmentSubmissionListResolvers<ContextType>;
    FiskalyOrganization?: GQFiskalyOrganizationResolvers<ContextType>;
    FiskalyOrganizations?: GQFiskalyOrganizationsResolvers<ContextType>;
    FiskalyOrganizationsPagination?: GQFiskalyOrganizationsPaginationResolvers<ContextType>;
    FiskalyRemoteCashRegister?: GQFiskalyRemoteCashRegisterResolvers<ContextType>;
    FiskalyRemoteCashRegisterList?: GQFiskalyRemoteCashRegisterListResolvers<ContextType>;
    FiskalyRemoteClient?: GQFiskalyRemoteClientResolvers<ContextType>;
    FiskalyRemoteClientList?: GQFiskalyRemoteClientListResolvers<ContextType>;
    FiskalyRemoteEstablishmentSubmissionList?: GQFiskalyRemoteEstablishmentSubmissionListResolvers<ContextType>;
    FiskalySettings?: GQFiskalySettingsResolvers<ContextType>;
    FiskalyTaxPayer?: GQFiskalyTaxPayerResolvers<ContextType>;
    FiskalyTaxPayerLegal?: GQFiskalyTaxPayerLegalResolvers<ContextType>;
    FiskalyTaxPayerNatural?: GQFiskalyTaxPayerNaturalResolvers<ContextType>;
    FiskalyTss?: GQFiskalyTssResolvers<ContextType>;
    FiskalyTssList?: GQFiskalyTssListResolvers<ContextType>;
    Function?: GQFunctionResolvers<ContextType>;
    GpsPoint?: GQGpsPointResolvers<ContextType>;
    IFiskalyTaxPayer?: GQIFiskalyTaxPayerResolvers<ContextType>;
    IPagination?: GQIPaginationResolvers<ContextType>;
    Integration?: GQIntegrationResolvers<ContextType>;
    IntegrationAccount?: GQIntegrationAccountResolvers<ContextType>;
    IntegrationArray?: GQIntegrationArrayResolvers<ContextType>;
    IntegrationPagination?: GQIntegrationPaginationResolvers<ContextType>;
    IntegrationSettings?: GQIntegrationSettingsResolvers<ContextType>;
    InventoryProduct?: GQInventoryProductResolvers<ContextType>;
    InventoryProductNoteTemplate?: GQInventoryProductNoteTemplateResolvers<ContextType>;
    InventoryProductNoteTemplatePagination?: GQInventoryProductNoteTemplatePaginationResolvers<ContextType>;
    InventoryProductPagination?: GQInventoryProductPaginationResolvers<ContextType>;
    InvoiceAmount?: GQInvoiceAmountResolvers<ContextType>;
    InvoiceAmountPerMonth?: GQInvoiceAmountPerMonthResolvers<ContextType>;
    InvoiceCount?: GQInvoiceCountResolvers<ContextType>;
    InvoiceExternalReceipt?: GQInvoiceExternalReceiptResolvers<ContextType>;
    InvoiceHourSales?: GQInvoiceHourSalesResolvers<ContextType>;
    InvoiceItemExternalRM?: GQInvoiceItemExternalRmResolvers<ContextType>;
    InvoiceItemRM?: GQInvoiceItemRmResolvers<ContextType>;
    InvoicePaymentRM?: GQInvoicePaymentRmResolvers<ContextType>;
    InvoiceRM?: GQInvoiceRmResolvers<ContextType>;
    InvoiceRMPagination?: GQInvoiceRmPaginationResolvers<ContextType>;
    JSON?: GraphQLScalarType;
    Layout?: GQLayoutResolvers<ContextType>;
    LayoutDeleteResponse?: GQLayoutDeleteResponseResolvers<ContextType>;
    LayoutEntity?: GQLayoutEntityResolvers<ContextType>;
    LayoutEntityPagination?: GQLayoutEntityPaginationResolvers<ContextType>;
    LayoutPagination?: GQLayoutPaginationResolvers<ContextType>;
    Log?: GQLogResolvers<ContextType>;
    LogPagination?: GQLogPaginationResolvers<ContextType>;
    Logo?: GQLogoResolvers<ContextType>;
    Me?: GQMeResolvers<ContextType>;
    MeasurementUnit?: GQMeasurementUnitResolvers<ContextType>;
    Merchant?: GQMerchantResolvers<ContextType>;
    MerchantChartOfAccount?: GQMerchantChartOfAccountResolvers<ContextType>;
    MerchantChartOfAccounts?: GQMerchantChartOfAccountsResolvers<ContextType>;
    MerchantDeleteResponse?: GQMerchantDeleteResponseResolvers<ContextType>;
    MerchantPagination?: GQMerchantPaginationResolvers<ContextType>;
    MiscButtons?: GQMiscButtonsResolvers<ContextType>;
    MiscButtonsDeleteResponse?: GQMiscButtonsDeleteResponseResolvers<ContextType>;
    MiscButtonsPagination?: GQMiscButtonsPaginationResolvers<ContextType>;
    Mutation?: GQMutationResolvers<ContextType>;
    POS?: GQPosResolvers<ContextType>;
    Pagination?: GQPaginationResolvers<ContextType>;
    Partner?: GQPartnerResolvers<ContextType>;
    PartnerApiSettings?: GQPartnerApiSettingsResolvers<ContextType>;
    PaymentConfiguration?: GQPaymentConfigurationResolvers<ContextType>;
    PaymentConfigurationDeleteResponse?: GQPaymentConfigurationDeleteResponseResolvers<ContextType>;
    PaymentConfigurationMethod?: GQPaymentConfigurationMethodResolvers<ContextType>;
    PaymentConfigurationPagination?: GQPaymentConfigurationPaginationResolvers<ContextType>;
    PaymentMethod?: GQPaymentMethodResolvers<ContextType>;
    PaymentMethodDeleteResponse?: GQPaymentMethodDeleteResponseResolvers<ContextType>;
    PaymentMethodPagination?: GQPaymentMethodPaginationResolvers<ContextType>;
    Printer?: GQPrinterResolvers<ContextType>;
    PrinterDeleteResponse?: GQPrinterDeleteResponseResolvers<ContextType>;
    PrinterPagination?: GQPrinterPaginationResolvers<ContextType>;
    Product?: GQProductResolvers<ContextType>;
    Product2ViProduct2MeasurementUnit?: GQProduct2ViProduct2MeasurementUnitResolvers<ContextType>;
    ProductBarcode?: GQProductBarcodeResolvers<ContextType>;
    ProductDeleteResponse?: GQProductDeleteResponseResolvers<ContextType>;
    ProductGroup?: GQProductGroupResolvers<ContextType>;
    ProductGroupDeleteResponse?: GQProductGroupDeleteResponseResolvers<ContextType>;
    ProductGroupPagination?: GQProductGroupPaginationResolvers<ContextType>;
    ProductPagination?: GQProductPaginationResolvers<ContextType>;
    Query?: GQQueryResolvers<ContextType>;
    RemoteEstablishmentSubmission?: GQRemoteEstablishmentSubmissionResolvers<ContextType>;
    ReportCashRegister?: GQReportCashRegisterResolvers<ContextType>;
    ReportDepartment?: GQReportDepartmentResolvers<ContextType>;
    ReportParameters?: GQReportParametersResolvers<ContextType>;
    ReportProduct?: GQReportProductResolvers<ContextType>;
    ReportProductGroup?: GQReportProductGroupResolvers<ContextType>;
    ReportUser?: GQReportUserResolvers<ContextType>;
    Role?: GQRoleResolvers<ContextType>;
    RoleDeleteResponse?: GQRoleDeleteResponseResolvers<ContextType>;
    RolePagination?: GQRolePaginationResolvers<ContextType>;
    RolePermission?: GQRolePermissionResolvers<ContextType>;
    SaftJob?: GQSaftJobResolvers<ContextType>;
    SaftJobPagination?: GQSaftJobPaginationResolvers<ContextType>;
    SelectUserRoleType?: GQSelectUserRoleTypeResolvers<ContextType>;
    ShiftFundsRM?: GQShiftFundsRmResolvers<ContextType>;
    ShiftPaymentCardRM?: GQShiftPaymentCardRmResolvers<ContextType>;
    ShiftPaymentRM?: GQShiftPaymentRmResolvers<ContextType>;
    ShiftRM?: GQShiftRmResolvers<ContextType>;
    ShiftRMPagination?: GQShiftRmPaginationResolvers<ContextType>;
    ShiftSalesData?: GQShiftSalesDataResolvers<ContextType>;
    ShiftSalesDataByProductGroup?: GQShiftSalesDataByProductGroupResolvers<ContextType>;
    SoftpayAccessTokenResponse?: GQSoftpayAccessTokenResponseResolvers<ContextType>;
    SoftpayCloudStore?: GQSoftpayCloudStoreResolvers<ContextType>;
    SoftpayCloudTerminal?: GQSoftpayCloudTerminalResolvers<ContextType>;
    SoftpayCloudTerminalsPagination?: GQSoftpayCloudTerminalsPaginationResolvers<ContextType>;
    SoftpayMerchant?: GQSoftpayMerchantResolvers<ContextType>;
    SoftpayMerchantsPagination?: GQSoftpayMerchantsPaginationResolvers<ContextType>;
    SoftpayMiaAdditionalData?: GQSoftpayMiaAdditionalDataResolvers<ContextType>;
    SoftpayMiaMerchant?: GQSoftpayMiaMerchantResolvers<ContextType>;
    SoftpayMiaMerchantsPagination?: GQSoftpayMiaMerchantsPaginationResolvers<ContextType>;
    SoftpayMiaProcessorData?: GQSoftpayMiaProcessorDataResolvers<ContextType>;
    SoftpayMiaStore?: GQSoftpayMiaStoreResolvers<ContextType>;
    SoftpayMiaTerminal?: GQSoftpayMiaTerminalResolvers<ContextType>;
    Subscription?: GQSubscriptionResolvers<ContextType>;
    SumUpAccessTokenResponse?: GQSumUpAccessTokenResponseResolvers<ContextType>;
    Tag?: GQTagResolvers<ContextType>;
    TagAction?: GQTagActionResolvers<ContextType>;
    TagActionPagination?: GQTagActionPaginationResolvers<ContextType>;
    TagDeleteResponse?: GQTagDeleteResponseResolvers<ContextType>;
    TagGroup?: GQTagGroupResolvers<ContextType>;
    TagGroupDeleteResponse?: GQTagGroupDeleteResponseResolvers<ContextType>;
    TagGroupPagination?: GQTagGroupPaginationResolvers<ContextType>;
    TagPagination?: GQTagPaginationResolvers<ContextType>;
    TaskResult?: GQTaskResultResolvers<ContextType>;
    TaskResultPagination?: GQTaskResultPaginationResolvers<ContextType>;
    User?: GQUserResolvers<ContextType>;
    UserDeleteResponse?: GQUserDeleteResponseResolvers<ContextType>;
    UserPagination?: GQUserPaginationResolvers<ContextType>;
    UserRole?: GQUserRoleResolvers<ContextType>;
    UserRoleConfiguration?: GQUserRoleConfigurationResolvers<ContextType>;
    Vat?: GQVatResolvers<ContextType>;
    VatDeleteResponse?: GQVatDeleteResponseResolvers<ContextType>;
    VatPagination?: GQVatPaginationResolvers<ContextType>;
    VenueAccessAccessType?: GQVenueAccessAccessTypeResolvers<ContextType>;
    VenueAccessEvent?: GQVenueAccessEventResolvers<ContextType>;
    VenueAccessParameters?: GQVenueAccessParametersResolvers<ContextType>;
    VenueAccessParametersBulk?: GQVenueAccessParametersBulkResolvers<ContextType>;
    VenueAccessSettings?: GQVenueAccessSettingsResolvers<ContextType>;
    VenueAccessTicketCancelled?: GQVenueAccessTicketCancelledResolvers<ContextType>;
    VenueAccessTicketCreated?: GQVenueAccessTicketCreatedResolvers<ContextType>;
    ViProduct?: GQViProductResolvers<ContextType>;
    ViProductPagination?: GQViProductPaginationResolvers<ContextType>;
    ViWarehouse?: GQViWarehouseResolvers<ContextType>;
    ViWarehousePagination?: GQViWarehousePaginationResolvers<ContextType>;
    VirtualPrinter?: GQVirtualPrinterResolvers<ContextType>;
    VirtualPrinterDeleteResponse?: GQVirtualPrinterDeleteResponseResolvers<ContextType>;
    VirtualPrinterDepartment?: GQVirtualPrinterDepartmentResolvers<ContextType>;
    VirtualPrinterPagination?: GQVirtualPrinterPaginationResolvers<ContextType>;
};

export type GQEntityConfigsQueryVariables = Exact<{
    entityIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type GQEntityConfigsQuery = {
    __typename?: "Query";
    entityConfigs: Array<{
        __typename?: "EntityConfig";
        entityId: string;
        data: any;
    } | null>;
};

export type GQEntityConfigSaveMutationVariables = Exact<{
    entityId: Scalars["ID"];
    partialData: Scalars["JSON"];
    disabledData: Array<Scalars["String"]> | Scalars["String"];
}>;

export type GQEntityConfigSaveMutation = {
    __typename?: "Mutation";
    entityConfigSave: {
        __typename?: "EntityConfig";
        entityId: string;
        data: any;
    };
};

export type GQEntityConfigDeleteMutationVariables = Exact<{
    entityId: Scalars["ID"];
}>;

export type GQEntityConfigDeleteMutation = {
    __typename?: "Mutation";
    entityConfigDelete: {
        __typename?: "EntityConfigDeleteResponse";
        status: boolean;
    };
};

export type GQDefaultPaginationFieldsFragment = {
    __typename?: "Pagination";
    pages: number;
    sort: string;
    sortDirection: string;
    resultCount: number;
};

export type GQAllAccountFieldsFragment = {
    __typename?: "Account";
    id: string;
    name: string;
    type: string;
    status: string;
    amount: number;
    systemLabel?: string | null;
    createdAt: any;
    externalId?: string | null;
    merchant: { __typename?: "Merchant"; id: string; name: string };
    customer?: {
        __typename?: "Customer";
        id: string;
        name: string;
        group?: {
            __typename?: "CustomerGroup";
            id: string;
            name: string;
        } | null;
    } | null;
    vat?: { __typename?: "Vat"; id: string } | null;
};

export type GQAllBookkeepingAccountFieldsFragment = {
    __typename?: "BookkeepingAccount";
    id: string;
    name: string;
    systemLabel?: string | null;
    createdAt: any;
    merchant: { __typename?: "Merchant"; id: string; name: string };
};

export type GQAllAccountTransactionFieldsFragment = {
    __typename?: "AccountTransaction";
    id: string;
    userId?: string | null;
    transactionAt: any;
    amount: number;
    invoiceId?: string | null;
    user?: { __typename?: "User"; username: string } | null;
    tag?: {
        __typename?: "Tag";
        id: string;
        identifier: string;
        name?: string | null;
    } | null;
};

export type GQAllAccountBookkeepingTransactionFieldsFragment = {
    __typename?: "AccountBookkeepingTransaction";
    id: string;
    transactionAt: any;
    amount: number;
    type: string;
    invoiceId?: string | null;
};

export type GQAccountsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQAccountSearchInput>;
}>;

export type GQAccountsQuery = {
    __typename?: "Query";
    accounts: {
        __typename?: "AccountPagination";
        data: Array<{
            __typename?: "Account";
            id: string;
            name: string;
            type: string;
            status: string;
            amount: number;
            systemLabel?: string | null;
            createdAt: any;
            externalId?: string | null;
            merchant: { __typename?: "Merchant"; id: string; name: string };
            customer?: {
                __typename?: "Customer";
                id: string;
                name: string;
                group?: {
                    __typename?: "CustomerGroup";
                    id: string;
                    name: string;
                } | null;
            } | null;
            vat?: { __typename?: "Vat"; id: string } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQGiftCardsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    status?: InputMaybe<
        Array<InputMaybe<Scalars["String"]>> | InputMaybe<Scalars["String"]>
    >;
    searching?: InputMaybe<GQAccountSearchInput>;
}>;

export type GQGiftCardsQuery = {
    __typename?: "Query";
    giftCards: {
        __typename?: "AccountPagination";
        data: Array<{
            __typename?: "Account";
            id: string;
            name: string;
            type: string;
            status: string;
            amount: number;
            systemLabel?: string | null;
            createdAt: any;
            externalId?: string | null;
            tags: {
                __typename?: "TagPagination";
                data: Array<{
                    __typename?: "Tag";
                    id: string;
                    identifier: string;
                    name?: string | null;
                    tagType: string;
                    createdAt: any;
                    group?: {
                        __typename?: "TagGroup";
                        id: string;
                        name: string;
                    } | null;
                    account?: {
                        __typename?: "Account";
                        id: string;
                        name: string;
                    } | null;
                    customer?: {
                        __typename?: "Customer";
                        id: string;
                        name: string;
                    } | null;
                }>;
                pagination: {
                    __typename?: "Pagination";
                    pages: number;
                    sort: string;
                    sortDirection: string;
                    resultCount: number;
                };
            };
            merchant: { __typename?: "Merchant"; id: string; name: string };
            customer?: {
                __typename?: "Customer";
                id: string;
                name: string;
                group?: {
                    __typename?: "CustomerGroup";
                    id: string;
                    name: string;
                } | null;
            } | null;
            vat?: { __typename?: "Vat"; id: string } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCustomerAccountsQueryVariables = Exact<{
    customerId?: InputMaybe<Scalars["ID"]>;
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQCustomerAccountsQuery = {
    __typename?: "Query";
    customerAccounts: {
        __typename?: "AccountPagination";
        data: Array<{
            __typename?: "Account";
            id: string;
            name: string;
            type: string;
            status: string;
            amount: number;
            systemLabel?: string | null;
            createdAt: any;
            externalId?: string | null;
            merchant: { __typename?: "Merchant"; id: string; name: string };
            customer?: {
                __typename?: "Customer";
                id: string;
                name: string;
                group?: {
                    __typename?: "CustomerGroup";
                    id: string;
                    name: string;
                } | null;
            } | null;
            vat?: { __typename?: "Vat"; id: string } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQBookkeepingAccountsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
}>;

export type GQBookkeepingAccountsQuery = {
    __typename?: "Query";
    bookkeepingAccounts: {
        __typename?: "AccountBookkeepingPagination";
        data: Array<{
            __typename?: "BookkeepingAccount";
            id: string;
            name: string;
            systemLabel?: string | null;
            createdAt: any;
            merchant: { __typename?: "Merchant"; id: string; name: string };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQAccountQueryVariables = Exact<{
    id: Scalars["ID"];
    transactionPagination?: InputMaybe<GQPaginationInput>;
    transactionSearch?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQAccountTransactionSearchInput>;
    tagPagination?: InputMaybe<GQPaginationInput>;
    tagSearch?: InputMaybe<GQSearchInput>;
    numberOfTransactions?: InputMaybe<Scalars["Int"]>;
}>;

export type GQAccountQuery = {
    __typename?: "Query";
    account: {
        __typename?: "Account";
        id: string;
        name: string;
        type: string;
        status: string;
        amount: number;
        systemLabel?: string | null;
        createdAt: any;
        externalId?: string | null;
        transactions: {
            __typename?: "AccountTransactionPagination";
            data: Array<{
                __typename?: "AccountTransaction";
                id: string;
                userId?: string | null;
                transactionAt: any;
                amount: number;
                invoiceId?: string | null;
                user?: { __typename?: "User"; username: string } | null;
                tag?: {
                    __typename?: "Tag";
                    id: string;
                    identifier: string;
                    name?: string | null;
                } | null;
            }>;
            pagination: {
                __typename?: "Pagination";
                pages: number;
                sort: string;
                sortDirection: string;
                resultCount: number;
            };
        };
        tags: {
            __typename?: "TagPagination";
            data: Array<{
                __typename?: "Tag";
                id: string;
                identifier: string;
                name?: string | null;
                tagType: string;
                createdAt: any;
                group?: {
                    __typename?: "TagGroup";
                    id: string;
                    name: string;
                } | null;
                account?: {
                    __typename?: "Account";
                    id: string;
                    name: string;
                } | null;
                customer?: {
                    __typename?: "Customer";
                    id: string;
                    name: string;
                } | null;
            }>;
            pagination: {
                __typename?: "Pagination";
                pages: number;
                sort: string;
                sortDirection: string;
                resultCount: number;
            };
        };
        balance: { __typename?: "Balance"; receipt: string };
        merchant: { __typename?: "Merchant"; id: string; name: string };
        customer?: {
            __typename?: "Customer";
            id: string;
            name: string;
            group?: {
                __typename?: "CustomerGroup";
                id: string;
                name: string;
            } | null;
        } | null;
        vat?: { __typename?: "Vat"; id: string } | null;
    };
};

export type GQBookkeepingAccountQueryVariables = Exact<{
    id: Scalars["ID"];
    transactionPagination?: InputMaybe<GQPaginationInput>;
    transactionSearch?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQAccountBookkeepingTransactionSearchInput>;
}>;

export type GQBookkeepingAccountQuery = {
    __typename?: "Query";
    bookkeepingAccount: {
        __typename?: "BookkeepingAccount";
        id: string;
        name: string;
        systemLabel?: string | null;
        createdAt: any;
        bookkeepingTransactions: {
            __typename?: "AccountBookkeepingTransactionPagination";
            data: Array<{
                __typename?: "AccountBookkeepingTransaction";
                id: string;
                transactionAt: any;
                amount: number;
                type: string;
                invoiceId?: string | null;
            }>;
            pagination: {
                __typename?: "Pagination";
                pages: number;
                sort: string;
                sortDirection: string;
                resultCount: number;
            };
        };
        merchant: { __typename?: "Merchant"; id: string; name: string };
    };
};

export type GQAccountEnabledTagsQueryVariables = Exact<{
    id: Scalars["ID"];
    tagPagination?: InputMaybe<GQPaginationInput>;
    tagSearch?: InputMaybe<GQSearchInput>;
}>;

export type GQAccountEnabledTagsQuery = {
    __typename?: "Query";
    account: {
        __typename?: "Account";
        tags: {
            __typename?: "TagPagination";
            data: Array<{
                __typename?: "Tag";
                id: string;
                identifier: string;
                name?: string | null;
                tagType: string;
                createdAt: any;
                group?: {
                    __typename?: "TagGroup";
                    id: string;
                    name: string;
                } | null;
                account?: {
                    __typename?: "Account";
                    id: string;
                    name: string;
                } | null;
                customer?: {
                    __typename?: "Customer";
                    id: string;
                    name: string;
                } | null;
            }>;
            pagination: {
                __typename?: "Pagination";
                pages: number;
                sort: string;
                sortDirection: string;
                resultCount: number;
            };
        };
    };
};

export type GQAccountTagsViewQueryVariables = Exact<{
    id: Scalars["ID"];
    tagPagination?: InputMaybe<GQPaginationInput>;
    tagSearch?: InputMaybe<GQSearchInput>;
}>;

export type GQAccountTagsViewQuery = {
    __typename?: "Query";
    account: {
        __typename?: "Account";
        id: string;
        name: string;
        type: string;
        status: string;
        amount: number;
        systemLabel?: string | null;
        createdAt: any;
        externalId?: string | null;
        tags: {
            __typename?: "TagPagination";
            data: Array<{
                __typename?: "Tag";
                id: string;
                identifier: string;
                name?: string | null;
                tagType: string;
                createdAt: any;
                group?: {
                    __typename?: "TagGroup";
                    id: string;
                    name: string;
                } | null;
                account?: {
                    __typename?: "Account";
                    id: string;
                    name: string;
                } | null;
                customer?: {
                    __typename?: "Customer";
                    id: string;
                    name: string;
                } | null;
            }>;
            pagination: {
                __typename?: "Pagination";
                pages: number;
                sort: string;
                sortDirection: string;
                resultCount: number;
            };
        };
        merchant: { __typename?: "Merchant"; id: string; name: string };
        customer?: {
            __typename?: "Customer";
            id: string;
            name: string;
            group?: {
                __typename?: "CustomerGroup";
                id: string;
                name: string;
            } | null;
        } | null;
        vat?: { __typename?: "Vat"; id: string } | null;
    };
};

export type GQAllTransactionsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    accountId?: InputMaybe<Scalars["String"]>;
    searching?: InputMaybe<GQAccountTransactionSearchInput>;
}>;

export type GQAllTransactionsQuery = {
    __typename?: "Query";
    transactions: {
        __typename?: "AccountTransactionPagination";
        data: Array<{
            __typename?: "AccountTransaction";
            id: string;
            userId?: string | null;
            transactionAt: any;
            amount: number;
            invoiceId?: string | null;
            user?: { __typename?: "User"; username: string } | null;
            tag?: {
                __typename?: "Tag";
                id: string;
                identifier: string;
                name?: string | null;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQIsAccountNameInUseQueryVariables = Exact<{
    name?: InputMaybe<Scalars["String"]>;
    customerId?: InputMaybe<Scalars["ID"]>;
    accountId?: InputMaybe<Scalars["ID"]>;
}>;

export type GQIsAccountNameInUseQuery = {
    __typename?: "Query";
    isAccountNameInUse: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQAccountCreateMutationVariables = Exact<{
    account: GQAccountCreate;
}>;

export type GQAccountCreateMutation = {
    __typename?: "Mutation";
    accountCreate: {
        __typename?: "Account";
        id: string;
        name: string;
        type: string;
        status: string;
        amount: number;
        systemLabel?: string | null;
        createdAt: any;
        externalId?: string | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
        customer?: {
            __typename?: "Customer";
            id: string;
            name: string;
            group?: {
                __typename?: "CustomerGroup";
                id: string;
                name: string;
            } | null;
        } | null;
        vat?: { __typename?: "Vat"; id: string } | null;
    };
};

export type GQAccountSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    account: GQAccountInput;
}>;

export type GQAccountSaveMutation = {
    __typename?: "Mutation";
    accountSave: {
        __typename?: "Account";
        id: string;
        name: string;
        type: string;
        status: string;
        amount: number;
        systemLabel?: string | null;
        createdAt: any;
        externalId?: string | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
        customer?: {
            __typename?: "Customer";
            id: string;
            name: string;
            group?: {
                __typename?: "CustomerGroup";
                id: string;
                name: string;
            } | null;
        } | null;
        vat?: { __typename?: "Vat"; id: string } | null;
    };
};

export type GQAccountCloseMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQAccountCloseMutation = {
    __typename?: "Mutation";
    accountClose: { __typename?: "AccountCloseResponse"; status: boolean };
};

export type GQAccountOpenMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQAccountOpenMutation = {
    __typename?: "Mutation";
    accountOpen: { __typename?: "AccountOpenResponse"; status: boolean };
};

export type GQAccountAssignTagsMutationVariables = Exact<{
    id: Scalars["ID"];
    tagIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type GQAccountAssignTagsMutation = {
    __typename?: "Mutation";
    accountAssignTags: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQAccountPayAmountMutationVariables = Exact<{
    id: Scalars["ID"];
    orderId: Scalars["ID"];
    amount: Scalars["Float"];
    userId: Scalars["ID"];
    tagId?: InputMaybe<Scalars["ID"]>;
    tagIdentifier?: InputMaybe<Scalars["String"]>;
    printWidth?: InputMaybe<Scalars["Int"]>;
}>;

export type GQAccountPayAmountMutation = {
    __typename?: "Mutation";
    accountPayAmount: {
        __typename?: "AccountPayAmountResponse";
        transactionId: string;
        status: GQAccountTransactionStatus;
        type?: string | null;
        receipt?: string | null;
    };
};

export type GQAccountRefundAmountMutationVariables = Exact<{
    id: Scalars["ID"];
    orderId: Scalars["ID"];
    amount: Scalars["Float"];
    userId: Scalars["ID"];
    tagId?: InputMaybe<Scalars["ID"]>;
    tagIdentifier?: InputMaybe<Scalars["String"]>;
    printWidth?: InputMaybe<Scalars["Int"]>;
}>;

export type GQAccountRefundAmountMutation = {
    __typename?: "Mutation";
    accountRefundAmount: {
        __typename?: "AccountRefundAmountResponse";
        transactionId: string;
        status: GQAccountTransactionStatus;
        type?: string | null;
        receipt?: string | null;
    };
};

export type GQAccountReissueGiftcardMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQAccountReissueGiftcardMutation = {
    __typename?: "Mutation";
    accountReissueGiftcard: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQAccountReissueGiftcardsMutationVariables = Exact<{
    ids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type GQAccountReissueGiftcardsMutation = {
    __typename?: "Mutation";
    accountReissueGiftcards: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQCustomerScreenFieldsFragment = {
    __typename?: "Customer";
    id: string;
    name: string;
    address: string;
    zip: string;
    city: string;
    email?: string | null;
    phoneNumber?: string | null;
    comment?: string | null;
    cvrNumber?: string | null;
    contactName?: string | null;
    createdAt: any;
    group?: { __typename?: "CustomerGroup"; id: string; name: string } | null;
    accounts: Array<{ __typename?: "Account"; amount: number }>;
};

export type GQCustomersQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQCustomerSearchInput>;
}>;

export type GQCustomersQuery = {
    __typename?: "Query";
    customers: {
        __typename?: "CustomerPagination";
        data: Array<{
            __typename?: "Customer";
            id: string;
            name: string;
            address: string;
            zip: string;
            city: string;
            email?: string | null;
            phoneNumber?: string | null;
            comment?: string | null;
            cvrNumber?: string | null;
            contactName?: string | null;
            createdAt: any;
            group?: {
                __typename?: "CustomerGroup";
                id: string;
                name: string;
            } | null;
            accounts: Array<{ __typename?: "Account"; amount: number }>;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCustomerQueryVariables = Exact<{
    id: Scalars["ID"];
    tagPagination?: InputMaybe<GQPaginationInput>;
    tagSearch?: InputMaybe<GQSearchInput>;
}>;

export type GQCustomerQuery = {
    __typename?: "Query";
    customer: {
        __typename?: "Customer";
        id: string;
        name: string;
        address: string;
        zip: string;
        city: string;
        email?: string | null;
        phoneNumber?: string | null;
        comment?: string | null;
        cvrNumber?: string | null;
        contactName?: string | null;
        createdAt: any;
        tags: {
            __typename?: "TagPagination";
            data: Array<{
                __typename?: "Tag";
                id: string;
                identifier: string;
                name?: string | null;
                tagType: string;
                createdAt: any;
                group?: {
                    __typename?: "TagGroup";
                    id: string;
                    name: string;
                } | null;
                account?: {
                    __typename?: "Account";
                    id: string;
                    name: string;
                } | null;
                customer?: {
                    __typename?: "Customer";
                    id: string;
                    name: string;
                } | null;
            }>;
            pagination: {
                __typename?: "Pagination";
                pages: number;
                sort: string;
                sortDirection: string;
                resultCount: number;
            };
        };
        group?: {
            __typename?: "CustomerGroup";
            id: string;
            name: string;
        } | null;
        accounts: Array<{ __typename?: "Account"; amount: number }>;
    };
};

export type GQCustomersInGroupQueryVariables = Exact<{
    groupId: Scalars["ID"];
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
}>;

export type GQCustomersInGroupQuery = {
    __typename?: "Query";
    customersInGroup: {
        __typename?: "CustomerPagination";
        data: Array<{
            __typename?: "Customer";
            id: string;
            name: string;
            address: string;
            zip: string;
            city: string;
            email?: string | null;
            phoneNumber?: string | null;
            comment?: string | null;
            cvrNumber?: string | null;
            contactName?: string | null;
            createdAt: any;
            group?: {
                __typename?: "CustomerGroup";
                id: string;
                name: string;
            } | null;
            accounts: Array<{ __typename?: "Account"; amount: number }>;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCustomerFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQCustomerFormQuery = {
    __typename?: "Query";
    customers: {
        __typename?: "CustomerPagination";
        data: Array<{ __typename?: "Customer"; id: string; name: string }>;
    };
    customerGroups: {
        __typename?: "CustomerGroupPagination";
        data: Array<{ __typename?: "CustomerGroup"; id: string; name: string }>;
    };
};

export type GQCustomerCreateMutationVariables = Exact<{
    customer: GQCustomerInput;
}>;

export type GQCustomerCreateMutation = {
    __typename?: "Mutation";
    customerCreate: {
        __typename?: "Customer";
        id: string;
        name: string;
        address: string;
        zip: string;
        city: string;
        email?: string | null;
        phoneNumber?: string | null;
        comment?: string | null;
        cvrNumber?: string | null;
        contactName?: string | null;
        createdAt: any;
        group?: {
            __typename?: "CustomerGroup";
            id: string;
            name: string;
        } | null;
        accounts: Array<{ __typename?: "Account"; amount: number }>;
    };
};

export type GQCustomerSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    customer: GQCustomerInput;
}>;

export type GQCustomerSaveMutation = {
    __typename?: "Mutation";
    customerSave: {
        __typename?: "Customer";
        id: string;
        name: string;
        address: string;
        zip: string;
        city: string;
        email?: string | null;
        phoneNumber?: string | null;
        comment?: string | null;
        cvrNumber?: string | null;
        contactName?: string | null;
        createdAt: any;
        group?: {
            __typename?: "CustomerGroup";
            id: string;
            name: string;
        } | null;
        accounts: Array<{ __typename?: "Account"; amount: number }>;
    };
};

export type GQCustomerDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCustomerDeleteMutation = {
    __typename?: "Mutation";
    customerDelete: { __typename?: "CustomerDeleteResponse"; status: boolean };
};

export type GQCustomerAssignTagsMutationVariables = Exact<{
    id: Scalars["ID"];
    tagIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type GQCustomerAssignTagsMutation = {
    __typename?: "Mutation";
    customerAssignTags: {
        __typename?: "CustomerAssignTagsRelationResponse";
        status: boolean;
    };
};

export type GQCustomerGroupScreenFieldsFragment = {
    __typename?: "CustomerGroup";
    id: string;
    name: string;
};

export type GQCustomerGroupsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQCustomerGroupSearchInput>;
}>;

export type GQCustomerGroupsQuery = {
    __typename?: "Query";
    customerGroups: {
        __typename?: "CustomerGroupPagination";
        data: Array<{ __typename?: "CustomerGroup"; id: string; name: string }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCustomerGroupQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCustomerGroupQuery = {
    __typename?: "Query";
    customerGroup: { __typename?: "CustomerGroup"; id: string; name: string };
};

export type GQCustomerGroupCreateMutationVariables = Exact<{
    customerGroup: GQCustomerGroupInput;
}>;

export type GQCustomerGroupCreateMutation = {
    __typename?: "Mutation";
    customerGroupCreate: {
        __typename?: "CustomerGroup";
        id: string;
        name: string;
    };
};

export type GQCustomerGroupSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    customerGroup: GQCustomerGroupInput;
}>;

export type GQCustomerGroupSaveMutation = {
    __typename?: "Mutation";
    customerGroupSave: {
        __typename?: "CustomerGroup";
        id: string;
        name: string;
    };
};

export type GQCustomerGroupDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCustomerGroupDeleteMutation = {
    __typename?: "Mutation";
    customerGroupDelete: {
        __typename?: "CustomerGroupDeleteResponse";
        status: boolean;
    };
};

export type GQAdyenSessionsQueryVariables = Exact<{ [key: string]: never }>;

export type GQAdyenSessionsQuery = {
    __typename?: "Query";
    adyenSessions: {
        __typename?: "AdyenSessionsResponse";
        id: string;
        token: string;
    };
};

export type GQAdyenStoresQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQAdyenStoresQuery = {
    __typename?: "Query";
    adyenStores: {
        __typename?: "AdyenStoresPagination";
        data: Array<{
            __typename?: "AdyenStore";
            id?: string | null;
            description?: string | null;
            externalReferenceId?: string | null;
            merchantId?: string | null;
            phoneNumber?: string | null;
            reference?: string | null;
            shopperStatement?: string | null;
            status?: GQAdyenStoreStatus | null;
            address?: {
                __typename?: "AdyenStoreLocation";
                city?: string | null;
                country?: string | null;
                line1?: string | null;
                line2?: string | null;
                line3?: string | null;
                postalCode?: string | null;
                stateOrProvince?: string | null;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQAdyenTerminalsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQAdyenTerminalsQuery = {
    __typename?: "Query";
    adyenTerminals: {
        __typename?: "AdyenTerminalsPagination";
        data: Array<{
            __typename?: "AdyenTerminal";
            id?: string | null;
            model?: string | null;
            serialNumber?: string | null;
            lastActivityAt?: string | null;
            lastTransactionAt?: string | null;
            firmwareVersion?: string | null;
            restartLocalTime?: string | null;
            assignment?: {
                __typename?: "AdyenTerminalAssignment";
                companyId?: string | null;
                merchantId?: string | null;
                storeId?: string | null;
                status?: string | null;
            } | null;
            connectivity?: {
                __typename?: "AdyenTerminalConnectivity";
                bluetooth?: {
                    __typename?: "AdyenTerminalConnectivityBluetooth";
                    ipAddress?: string | null;
                    macAddress?: string | null;
                } | null;
                cellular?: {
                    __typename?: "AdyenTerminalConnectivityCellular";
                    iccid?: string | null;
                    iccid2?: string | null;
                    status?: string | null;
                } | null;
                ethernet?: {
                    __typename?: "AdyenTerminalConnectivityEthernet";
                    ipAddress?: string | null;
                    linkNegotiation?: string | null;
                    macAddress?: string | null;
                } | null;
                wifi?: {
                    __typename?: "AdyenTerminalConnectivityWifi";
                    ipAddress?: string | null;
                    macAddress?: string | null;
                    ssid?: string | null;
                } | null;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQAllApprovalFieldsFragment = {
    __typename?: "Approval";
    id: string;
    type: GQApprovalType;
    active: boolean;
    createdAt: any;
    updatedAt?: any | null;
    approvalTokens: Array<{ __typename?: "ApprovalToken"; id: string }>;
    approvalTokenGroups: Array<{
        __typename?: "ApprovalTokenGroup";
        id: string;
    }>;
};

export type GQAllApprovalTokenFieldsFragment = {
    __typename?: "ApprovalToken";
    id: string;
    name: string;
    approvalTokenGroupId?: string | null;
    value: string;
    type: GQApprovalGroupType;
    active: boolean;
    createdAt: any;
    updatedAt?: any | null;
    approvalTokenGroup?: {
        __typename?: "ApprovalTokenGroup";
        name: string;
    } | null;
};

export type GQAllApprovalTokenGroupFieldsFragment = {
    __typename?: "ApprovalTokenGroup";
    id: string;
    name: string;
    active: boolean;
    createdAt: any;
    updatedAt?: any | null;
};

export type GQApprovalsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQApprovalSearchInput>;
}>;

export type GQApprovalsQuery = {
    __typename?: "Query";
    approvals: {
        __typename?: "ApprovalPagination";
        data: Array<{
            __typename?: "Approval";
            id: string;
            type: GQApprovalType;
            active: boolean;
            createdAt: any;
            updatedAt?: any | null;
            approvalTokens: Array<{ __typename?: "ApprovalToken"; id: string }>;
            approvalTokenGroups: Array<{
                __typename?: "ApprovalTokenGroup";
                id: string;
            }>;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQApprovalTokensQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQApprovalTokenSearchInput>;
}>;

export type GQApprovalTokensQuery = {
    __typename?: "Query";
    approvalTokens: {
        __typename?: "ApprovalTokenPagination";
        data: Array<{
            __typename?: "ApprovalToken";
            id: string;
            name: string;
            approvalTokenGroupId?: string | null;
            value: string;
            type: GQApprovalGroupType;
            active: boolean;
            createdAt: any;
            updatedAt?: any | null;
            approvalTokenGroup?: {
                __typename?: "ApprovalTokenGroup";
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQApprovalTokenGroupsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQApprovalTokenGroupSearchInput>;
}>;

export type GQApprovalTokenGroupsQuery = {
    __typename?: "Query";
    approvalTokenGroups: {
        __typename?: "ApprovalTokenGroupPagination";
        data: Array<{
            __typename?: "ApprovalTokenGroup";
            id: string;
            name: string;
            active: boolean;
            createdAt: any;
            updatedAt?: any | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQApprovalQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQApprovalQuery = {
    __typename?: "Query";
    approval?: {
        __typename?: "Approval";
        id: string;
        type: GQApprovalType;
        active: boolean;
        createdAt: any;
        updatedAt?: any | null;
        approvalTokens: Array<{ __typename?: "ApprovalToken"; id: string }>;
        approvalTokenGroups: Array<{
            __typename?: "ApprovalTokenGroup";
            id: string;
        }>;
    } | null;
};

export type GQApprovalTokenQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQApprovalTokenQuery = {
    __typename?: "Query";
    approvalToken?: {
        __typename?: "ApprovalToken";
        id: string;
        name: string;
        approvalTokenGroupId?: string | null;
        value: string;
        type: GQApprovalGroupType;
        active: boolean;
        createdAt: any;
        updatedAt?: any | null;
        approvalTokenGroup?: {
            __typename?: "ApprovalTokenGroup";
            name: string;
        } | null;
    } | null;
};

export type GQApprovalTokenGroupQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQApprovalTokenGroupQuery = {
    __typename?: "Query";
    approvalTokenGroup?: {
        __typename?: "ApprovalTokenGroup";
        id: string;
        name: string;
        active: boolean;
        createdAt: any;
        updatedAt?: any | null;
    } | null;
};

export type GQApprovalDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQApprovalDeleteMutation = {
    __typename?: "Mutation";
    approvalDelete: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQApprovalTokenDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQApprovalTokenDeleteMutation = {
    __typename?: "Mutation";
    approvalTokenDelete: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQApprovalTokenGroupDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQApprovalTokenGroupDeleteMutation = {
    __typename?: "Mutation";
    approvalTokenGroupDelete: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQApprovalCreateMutationVariables = Exact<{
    approval: GQApprovalInput;
}>;

export type GQApprovalCreateMutation = {
    __typename?: "Mutation";
    approvalCreate: {
        __typename?: "Approval";
        type: GQApprovalType;
        active: boolean;
    };
};

export type GQApprovalTokenCreateMutationVariables = Exact<{
    approvalToken: GQApprovalTokenInput;
}>;

export type GQApprovalTokenCreateMutation = {
    __typename?: "Mutation";
    approvalTokenCreate: {
        __typename?: "ApprovalToken";
        name: string;
        approvalTokenGroupId?: string | null;
        value: string;
        type: GQApprovalGroupType;
        active: boolean;
    };
};

export type GQApprovalTokenGroupCreateMutationVariables = Exact<{
    approvalTokenGroup: GQApprovalTokenGroupInput;
}>;

export type GQApprovalTokenGroupCreateMutation = {
    __typename?: "Mutation";
    approvalTokenGroupCreate: {
        __typename?: "ApprovalTokenGroup";
        name: string;
        active: boolean;
    };
};

export type GQApprovalSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    approval: GQApprovalInput;
}>;

export type GQApprovalSaveMutation = {
    __typename?: "Mutation";
    approvalSave: {
        __typename?: "Approval";
        type: GQApprovalType;
        active: boolean;
    };
};

export type GQApprovalTokenSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    approvalToken: GQApprovalTokenInput;
}>;

export type GQApprovalTokenSaveMutation = {
    __typename?: "Mutation";
    approvalTokenSave: {
        __typename?: "ApprovalToken";
        name: string;
        approvalTokenGroupId?: string | null;
        value: string;
        type: GQApprovalGroupType;
        active: boolean;
    };
};

export type GQApprovalTokenGroupSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    approvalTokenGroup: GQApprovalTokenGroupInput;
}>;

export type GQApprovalTokenGroupSaveMutation = {
    __typename?: "Mutation";
    approvalTokenGroupSave: {
        __typename?: "ApprovalTokenGroup";
        name: string;
        active: boolean;
    };
};

export type GQApprovalFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQApprovalFormQuery = {
    __typename?: "Query";
    approvals: {
        __typename?: "ApprovalPagination";
        data: Array<{
            __typename?: "Approval";
            type: GQApprovalType;
            active: boolean;
        }>;
    };
};

export type GQApprovalTokenFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQApprovalTokenFormQuery = {
    __typename?: "Query";
    approvalTokens: {
        __typename?: "ApprovalTokenPagination";
        data: Array<{
            __typename?: "ApprovalToken";
            name: string;
            approvalTokenGroupId?: string | null;
            value: string;
            type: GQApprovalGroupType;
            active: boolean;
        }>;
    };
};

export type GQApprovalTokenGroupFormQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQApprovalTokenGroupFormQuery = {
    __typename?: "Query";
    approvalTokenGroups: {
        __typename?: "ApprovalTokenGroupPagination";
        data: Array<{
            __typename?: "ApprovalTokenGroup";
            name: string;
            active: boolean;
        }>;
    };
};

export type GQCardTransactionScreenFieldsFragment = {
    __typename?: "CardTransaction";
    id: string;
    status: GQCardTransactionType;
    orderId?: string | null;
    amount: number;
    receipt: string;
    invoiceId?: string | null;
    transactionAt: any;
    scheme?: string | null;
    maskedPan?: string | null;
    cashRegister: { __typename?: "CashRegister"; name: string };
};

export type GQCardTransactionQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCardTransactionQuery = {
    __typename?: "Query";
    cardTransaction: {
        __typename?: "CardTransaction";
        id: string;
        status: GQCardTransactionType;
        orderId?: string | null;
        amount: number;
        receipt: string;
        invoiceId?: string | null;
        transactionAt: any;
        scheme?: string | null;
        maskedPan?: string | null;
        cashRegister: { __typename?: "CashRegister"; name: string };
    };
};

export type GQCardTransactionsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQCardTransactionSearchInput>;
}>;

export type GQCardTransactionsQuery = {
    __typename?: "Query";
    cardTransactions: {
        __typename?: "CardTransactionPagination";
        data: Array<{
            __typename?: "CardTransaction";
            id: string;
            status: GQCardTransactionType;
            orderId?: string | null;
            amount: number;
            receipt: string;
            invoiceId?: string | null;
            transactionAt: any;
            scheme?: string | null;
            maskedPan?: string | null;
            cashRegister: { __typename?: "CashRegister"; name: string };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCashRegisterFragment = {
    __typename?: "CashRegister";
    id: string;
    name: string;
    createdAt: any;
    deletedAt?: any | null;
    lastAppDataSentAt?: any | null;
    device?: {
        __typename?: "Device";
        id: string;
        osName?: string | null;
        osVersion?: string | null;
        appVersion?: string | null;
        appBuild?: string | null;
        serialNumber?: string | null;
        hardwareModel?: string | null;
        hardwareProducer?: string | null;
        macAddress?: string | null;
        language?: string | null;
        lastSeen: any;
        isUsingAutoTime?: boolean | null;
        isUsingAutoTimeZone?: boolean | null;
        timeZone?: string | null;
    } | null;
    department?: { __typename?: "Department"; id: string; name: string } | null;
    merchant: {
        __typename?: "Merchant";
        id: string;
        name: string;
        lastNotifySentAt?: any | null;
    };
};

export type GQCashRegistersQueryVariables = Exact<{
    pagination: GQPaginationInput;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQCashRegisterSearchInput>;
}>;

export type GQCashRegistersQuery = {
    __typename?: "Query";
    cashRegisters: {
        __typename?: "CashRegisterPagination";
        data: Array<{
            __typename?: "CashRegister";
            id: string;
            name: string;
            createdAt: any;
            deletedAt?: any | null;
            lastAppDataSentAt?: any | null;
            device?: {
                __typename?: "Device";
                id: string;
                osName?: string | null;
                osVersion?: string | null;
                appVersion?: string | null;
                appBuild?: string | null;
                serialNumber?: string | null;
                hardwareModel?: string | null;
                hardwareProducer?: string | null;
                macAddress?: string | null;
                language?: string | null;
                lastSeen: any;
                isUsingAutoTime?: boolean | null;
                isUsingAutoTimeZone?: boolean | null;
                timeZone?: string | null;
            } | null;
            department?: {
                __typename?: "Department";
                id: string;
                name: string;
            } | null;
            merchant: {
                __typename?: "Merchant";
                id: string;
                name: string;
                lastNotifySentAt?: any | null;
            };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCashRegistersStatusQueryVariables = Exact<{
    pagination: GQPaginationInput;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQCashRegisterStatusSearchInput>;
}>;

export type GQCashRegistersStatusQuery = {
    __typename?: "Query";
    cashRegistersStatus: {
        __typename?: "CashRegisterStatusPagination";
        data: Array<{
            __typename?: "CashRegisterStatus";
            id: string;
            name: string;
            lastAppDataSentAt?: any | null;
            status: string;
            device?: {
                __typename?: "Device";
                id: string;
                lastSeen: any;
                appVersion?: string | null;
            } | null;
            department?: {
                __typename?: "Department";
                id: string;
                name: string;
            } | null;
            merchant: {
                __typename?: "Merchant";
                id: string;
                name: string;
                lastNotifySentAt?: any | null;
            };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCashRegisterEditFormQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCashRegisterEditFormQuery = {
    __typename?: "Query";
    cashRegister?: {
        __typename?: "CashRegister";
        id: string;
        name: string;
        createdAt: any;
        deletedAt?: any | null;
        lastAppDataSentAt?: any | null;
        device?: {
            __typename?: "Device";
            id: string;
            osName?: string | null;
            osVersion?: string | null;
            appVersion?: string | null;
            appBuild?: string | null;
            serialNumber?: string | null;
            hardwareModel?: string | null;
            hardwareProducer?: string | null;
            macAddress?: string | null;
            language?: string | null;
            lastSeen: any;
            isUsingAutoTime?: boolean | null;
            isUsingAutoTimeZone?: boolean | null;
            timeZone?: string | null;
        } | null;
        department?: {
            __typename?: "Department";
            id: string;
            name: string;
        } | null;
        merchant: {
            __typename?: "Merchant";
            id: string;
            name: string;
            lastNotifySentAt?: any | null;
        };
    } | null;
    departments: {
        __typename?: "DepartmentPagination";
        data: Array<{ __typename?: "Department"; id: string; name: string }>;
    };
};

export type GQCashRegisterCreateMutationVariables = Exact<{
    cashRegister: GQCashRegisterCreateInput;
}>;

export type GQCashRegisterCreateMutation = {
    __typename?: "Mutation";
    cashRegisterCreate: {
        __typename?: "CashRegister";
        id: string;
        name: string;
        createdAt: any;
        deletedAt?: any | null;
        lastAppDataSentAt?: any | null;
        device?: {
            __typename?: "Device";
            id: string;
            osName?: string | null;
            osVersion?: string | null;
            appVersion?: string | null;
            appBuild?: string | null;
            serialNumber?: string | null;
            hardwareModel?: string | null;
            hardwareProducer?: string | null;
            macAddress?: string | null;
            language?: string | null;
            lastSeen: any;
            isUsingAutoTime?: boolean | null;
            isUsingAutoTimeZone?: boolean | null;
            timeZone?: string | null;
        } | null;
        department?: {
            __typename?: "Department";
            id: string;
            name: string;
        } | null;
        merchant: {
            __typename?: "Merchant";
            id: string;
            name: string;
            lastNotifySentAt?: any | null;
        };
    };
};

export type GQCashRegisterEditMutationVariables = Exact<{
    id: Scalars["ID"];
    cashRegister: GQCashRegisterEditInput;
}>;

export type GQCashRegisterEditMutation = {
    __typename?: "Mutation";
    cashRegisterEdit: {
        __typename?: "CashRegister";
        id: string;
        name: string;
        createdAt: any;
        deletedAt?: any | null;
        lastAppDataSentAt?: any | null;
        device?: {
            __typename?: "Device";
            id: string;
            osName?: string | null;
            osVersion?: string | null;
            appVersion?: string | null;
            appBuild?: string | null;
            serialNumber?: string | null;
            hardwareModel?: string | null;
            hardwareProducer?: string | null;
            macAddress?: string | null;
            language?: string | null;
            lastSeen: any;
            isUsingAutoTime?: boolean | null;
            isUsingAutoTimeZone?: boolean | null;
            timeZone?: string | null;
        } | null;
        department?: {
            __typename?: "Department";
            id: string;
            name: string;
        } | null;
        merchant: {
            __typename?: "Merchant";
            id: string;
            name: string;
            lastNotifySentAt?: any | null;
        };
    };
};

export type GQCashRegisterDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCashRegisterDeleteMutation = {
    __typename?: "Mutation";
    cashRegisterDelete: {
        __typename?: "CashRegisterDeleteResponse";
        status: boolean;
    };
};

export type GQCashRegistersDeleteMutationVariables = Exact<{
    ids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type GQCashRegistersDeleteMutation = {
    __typename?: "Mutation";
    cashRegistersDelete: {
        __typename?: "CashRegisterDeleteResponse";
        status: boolean;
    };
};

export type GQCashRegisterClaimMutationVariables = Exact<{
    id: Scalars["ID"];
    devicePinCode: Scalars["String"];
}>;

export type GQCashRegisterClaimMutation = {
    __typename?: "Mutation";
    cashRegisterClaim?: {
        __typename?: "CashRegister";
        id: string;
        name: string;
        createdAt: any;
        deletedAt?: any | null;
        lastAppDataSentAt?: any | null;
        device?: {
            __typename?: "Device";
            id: string;
            osName?: string | null;
            osVersion?: string | null;
            appVersion?: string | null;
            appBuild?: string | null;
            serialNumber?: string | null;
            hardwareModel?: string | null;
            hardwareProducer?: string | null;
            macAddress?: string | null;
            language?: string | null;
            lastSeen: any;
            isUsingAutoTime?: boolean | null;
            isUsingAutoTimeZone?: boolean | null;
            timeZone?: string | null;
        } | null;
        department?: {
            __typename?: "Department";
            id: string;
            name: string;
        } | null;
        merchant: {
            __typename?: "Merchant";
            id: string;
            name: string;
            lastNotifySentAt?: any | null;
        };
    } | null;
};

export type GQDeviceByPinCodeQueryVariables = Exact<{
    pinCode: Scalars["String"];
}>;

export type GQDeviceByPinCodeQuery = {
    __typename?: "Query";
    deviceByPinCode?: { __typename?: "Device"; id: string } | null;
};

export type GQCmpEventsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQCmpEventsQuery = {
    __typename?: "Query";
    cmpEvents: {
        __typename?: "CmpEventPagination";
        data: Array<{
            __typename?: "CmpEvent";
            id: string;
            externalId?: string | null;
            name: string;
            active: boolean;
            from?: any | null;
            to?: any | null;
            sequence: number;
            createdAt: any;
            updatedAt?: any | null;
            products: Array<{
                __typename?: "CmpEventProduct";
                id: string;
                name: string;
                amount?: number | null;
                externalId?: string | null;
                calendar?: any | null;
            }>;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCmpEventQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCmpEventQuery = {
    __typename?: "Query";
    cmpEvent?: {
        __typename?: "CmpEvent";
        id: string;
        externalId?: string | null;
        name: string;
        active: boolean;
        from?: any | null;
        to?: any | null;
        createdAt: any;
        updatedAt?: any | null;
        products: Array<{
            __typename?: "CmpEventProduct";
            id: string;
            externalId?: string | null;
            externalEventId?: string | null;
            name: string;
            amount?: number | null;
            active: boolean;
            calendar?: any | null;
            shouldPrint: GQShouldPrintType;
            upgradeable: boolean;
            sequence: number;
            createdAt: any;
            updatedAt?: any | null;
            group: {
                __typename?: "ProductGroup";
                vat: { __typename?: "Vat"; percentage: number };
            };
        }>;
    } | null;
};

export type GQCmpEventByExternalIdQueryVariables = Exact<{
    externalId: Scalars["ID"];
}>;

export type GQCmpEventByExternalIdQuery = {
    __typename?: "Query";
    cmpEventByExternalId?: {
        __typename?: "CmpEventNoProducts";
        id: string;
        externalId?: string | null;
        name: string;
        active: boolean;
        from?: any | null;
        to?: any | null;
        createdAt: any;
        updatedAt?: any | null;
    } | null;
};

export type GQCmpEventProductsQueryVariables = Exact<{
    externalEventId: Scalars["String"];
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQCmpEventProductsQuery = {
    __typename?: "Query";
    cmpEventProducts: {
        __typename?: "CmpEventProductPagination";
        data: Array<{
            __typename?: "CmpEventProduct";
            id: string;
            externalId?: string | null;
            externalEventId?: string | null;
            name: string;
            amount?: number | null;
            active: boolean;
            calendar?: any | null;
            sequence: number;
            shouldPrint: GQShouldPrintType;
            upgradeable: boolean;
            sms?: boolean | null;
            createdAt: any;
            updatedAt?: any | null;
            group: {
                __typename?: "ProductGroup";
                vat: { __typename?: "Vat"; percentage: number };
            };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCmpEventProductDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCmpEventProductDeleteMutation = {
    __typename?: "Mutation";
    cmpEventProductDelete: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQCmpEventDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCmpEventDeleteMutation = {
    __typename?: "Mutation";
    cmpEventDelete: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQCmpProductsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQCmpProductsQuery = {
    __typename?: "Query";
    cmpProducts: {
        __typename?: "CmpProductPagination";
        data: Array<{
            __typename?: "CmpProduct";
            id: string;
            externalId?: string | null;
            name: string;
            amount?: number | null;
            type?: string | null;
            active: boolean;
            sequence: number;
            sms: boolean;
            createdAt: any;
            updatedAt?: any | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCmpProductDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCmpProductDeleteMutation = {
    __typename?: "Mutation";
    cmpProductDelete: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQAllCurrencyFieldsFragment = {
    __typename?: "Currency";
    id: string;
    code: string;
    rate: number;
    createdAt: any;
    deletedAt?: any | null;
    merchant: { __typename?: "Merchant"; id: string; name: string };
};

export type GQCurrenciesQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
}>;

export type GQCurrenciesQuery = {
    __typename?: "Query";
    currencies: {
        __typename?: "CurrencyPagination";
        data: Array<{
            __typename?: "Currency";
            id: string;
            code: string;
            rate: number;
            createdAt: any;
            deletedAt?: any | null;
            merchant: { __typename?: "Merchant"; id: string; name: string };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCurrencyQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCurrencyQuery = {
    __typename?: "Query";
    currency?: {
        __typename?: "Currency";
        id: string;
        code: string;
        rate: number;
        createdAt: any;
        deletedAt?: any | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    } | null;
};

export type GQCurrencyCreateMutationVariables = Exact<{
    currency: GQCurrencyInput;
}>;

export type GQCurrencyCreateMutation = {
    __typename?: "Mutation";
    currencyCreate: {
        __typename?: "Currency";
        id: string;
        code: string;
        rate: number;
        createdAt: any;
        deletedAt?: any | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    };
};

export type GQCurrencySaveMutationVariables = Exact<{
    id: Scalars["ID"];
    currency: GQCurrencyInput;
}>;

export type GQCurrencySaveMutation = {
    __typename?: "Mutation";
    currencySave: {
        __typename?: "Currency";
        id: string;
        code: string;
        rate: number;
        createdAt: any;
        deletedAt?: any | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    };
};

export type GQCurrencyDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQCurrencyDeleteMutation = {
    __typename?: "Mutation";
    currencyDelete: {
        __typename?: "CurrencyDeleteResponse";
        status: GQDeleteResponseEnum;
    };
};

export type GQDashboardCashRegistersQueryVariables = Exact<{
    pagination: GQPaginationInput;
    search: GQSearchInput;
}>;

export type GQDashboardCashRegistersQuery = {
    __typename?: "Query";
    dashboardCashRegisters: {
        __typename?: "DashboardCashRegisterPagination";
        data: Array<{
            __typename?: "DashboardCashRegister";
            id: string;
            name: string;
            device?: {
                __typename?: "Device";
                id: string;
                osName?: string | null;
                osVersion?: string | null;
                appVersion?: string | null;
                appBuild?: string | null;
                serialNumber?: string | null;
                hardwareModel?: string | null;
                hardwareProducer?: string | null;
                macAddress?: string | null;
                language?: string | null;
                lastSeen: any;
            } | null;
            merchant?: {
                __typename?: "Merchant";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQDashboardCashRegisterStatsQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQDashboardCashRegisterStatsQuery = {
    __typename?: "Query";
    dashboardCashRegisterStats: Array<{
        __typename?: "CashRegisterVersion";
        label: string;
        count: number;
    }>;
};

export type GQDashboardInvoiceAmountStatsQueryVariables = Exact<{
    from: Scalars["Date"];
    to: Scalars["Date"];
    interval?: InputMaybe<Scalars["String"]>;
}>;

export type GQDashboardInvoiceAmountStatsQuery = {
    __typename?: "Query";
    dashboardInvoiceAmountStats?: Array<{
        __typename?: "InvoiceAmount";
        datetime: any;
        sum: number;
    }> | null;
};

export type GQDashboardInvoiceAmountPerMonthStatsQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQDashboardInvoiceAmountPerMonthStatsQuery = {
    __typename?: "Query";
    dashboardInvoiceAmountPerMonthStats?: Array<{
        __typename?: "InvoiceAmountPerMonth";
        year: string;
        monthNumber: string;
        sum: number;
    }> | null;
};

export type GQAllDashboardFragment = {
    __typename?: "Dashboard";
    from: any;
    to: any;
    totals: {
        __typename?: "DashboardTotals";
        invoices: number;
        turnoverAmount: number;
        avgTransaction: number;
    };
    products: Array<{
        __typename?: "DashboardProductItem";
        id?: string | null;
        name: string;
        quantity: number;
        turnoverAmount: number;
    }>;
    productGroups: Array<{
        __typename?: "DashboardProductGroupItem";
        id: string;
        name: string;
        quantity: number;
        turnoverAmount: number;
    }>;
    departments: Array<{
        __typename?: "DashboardDepartmentItem";
        id?: string | null;
        name?: string | null;
        invoices: number;
        avgTransaction: number;
        turnoverAmount: number;
    }>;
    accounts: Array<{
        __typename?: "DashboardAccountItem";
        id: string;
        name: string;
        amount: number;
    }>;
    amountsByHour: Array<{
        __typename?: "DashboardAmountByHourItem";
        datetime: any;
        sum: number;
    }>;
};

export type GQSubscribeToDashboardSubscriptionVariables = Exact<{
    from: Scalars["Date"];
    to: Scalars["Date"];
    departmentIds?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
}>;

export type GQSubscribeToDashboardSubscription = {
    __typename?: "Subscription";
    dashboardUpdated?: {
        __typename?: "Dashboard";
        from: any;
        to: any;
        totals: {
            __typename?: "DashboardTotals";
            invoices: number;
            turnoverAmount: number;
            avgTransaction: number;
        };
        products: Array<{
            __typename?: "DashboardProductItem";
            id?: string | null;
            name: string;
            quantity: number;
            turnoverAmount: number;
        }>;
        productGroups: Array<{
            __typename?: "DashboardProductGroupItem";
            id: string;
            name: string;
            quantity: number;
            turnoverAmount: number;
        }>;
        departments: Array<{
            __typename?: "DashboardDepartmentItem";
            id?: string | null;
            name?: string | null;
            invoices: number;
            avgTransaction: number;
            turnoverAmount: number;
        }>;
        accounts: Array<{
            __typename?: "DashboardAccountItem";
            id: string;
            name: string;
            amount: number;
        }>;
        amountsByHour: Array<{
            __typename?: "DashboardAmountByHourItem";
            datetime: any;
            sum: number;
        }>;
    } | null;
};

export type GQDashboardQueryVariables = Exact<{
    from: Scalars["Date"];
    to: Scalars["Date"];
    departmentIds?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
}>;

export type GQDashboardQuery = {
    __typename?: "Query";
    dashboard?: {
        __typename?: "Dashboard";
        from: any;
        to: any;
        totals: {
            __typename?: "DashboardTotals";
            invoices: number;
            turnoverAmount: number;
            avgTransaction: number;
        };
        products: Array<{
            __typename?: "DashboardProductItem";
            id?: string | null;
            name: string;
            quantity: number;
            turnoverAmount: number;
        }>;
        productGroups: Array<{
            __typename?: "DashboardProductGroupItem";
            id: string;
            name: string;
            quantity: number;
            turnoverAmount: number;
        }>;
        departments: Array<{
            __typename?: "DashboardDepartmentItem";
            id?: string | null;
            name?: string | null;
            invoices: number;
            avgTransaction: number;
            turnoverAmount: number;
        }>;
        accounts: Array<{
            __typename?: "DashboardAccountItem";
            id: string;
            name: string;
            amount: number;
        }>;
        amountsByHour: Array<{
            __typename?: "DashboardAmountByHourItem";
            datetime: any;
            sum: number;
        }>;
    } | null;
};

export type GQUserRoleConfigurationQueryVariables = Exact<{
    userId: Scalars["ID"];
    merchantId?: InputMaybe<Scalars["ID"]>;
    roleId: Scalars["ID"];
    type: Scalars["String"];
}>;

export type GQUserRoleConfigurationQuery = {
    __typename?: "Query";
    userRoleConfiguration?: {
        __typename?: "UserRoleConfiguration";
        type: string;
        data: any;
        user: { __typename?: "User"; id: string };
        merchant?: { __typename?: "Merchant"; id: string } | null;
        role: { __typename?: "Role"; id: string };
    } | null;
};

export type GQUserRoleConfigurationSaveMutationVariables = Exact<{
    userId: Scalars["ID"];
    merchantId?: InputMaybe<Scalars["ID"]>;
    roleId: Scalars["ID"];
    type: Scalars["String"];
    configuration: Scalars["JSON"];
}>;

export type GQUserRoleConfigurationSaveMutation = {
    __typename?: "Mutation";
    userRoleConfigurationSave: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQAllDepartmentFieldsFragment = {
    __typename?: "Department";
    id: string;
    name: string;
    externalId?: string | null;
    createdAt?: string | null;
    deletedAt?: any | null;
    merchant: { __typename?: "Merchant"; id: string; name: string };
    viWarehouse?: {
        __typename?: "ViWarehouse";
        id: string;
        name: string;
    } | null;
};

export type GQDepartmentsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQDepartmentSearchInput>;
}>;

export type GQDepartmentsQuery = {
    __typename?: "Query";
    departments: {
        __typename?: "DepartmentPagination";
        data: Array<{
            __typename?: "Department";
            id: string;
            name: string;
            externalId?: string | null;
            createdAt?: string | null;
            deletedAt?: any | null;
            merchant: { __typename?: "Merchant"; id: string; name: string };
            viWarehouse?: {
                __typename?: "ViWarehouse";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQDepartmentQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQDepartmentQuery = {
    __typename?: "Query";
    department?: {
        __typename?: "Department";
        id: string;
        name: string;
        externalId?: string | null;
        createdAt?: string | null;
        deletedAt?: any | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
        viWarehouse?: {
            __typename?: "ViWarehouse";
            id: string;
            name: string;
        } | null;
    } | null;
};

export type GQDepartmentCreateMutationVariables = Exact<{
    department: GQDepartmentInput;
}>;

export type GQDepartmentCreateMutation = {
    __typename?: "Mutation";
    departmentCreate: {
        __typename?: "Department";
        id: string;
        name: string;
        externalId?: string | null;
        createdAt?: string | null;
        deletedAt?: any | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
        viWarehouse?: {
            __typename?: "ViWarehouse";
            id: string;
            name: string;
        } | null;
    };
};

export type GQDepartmentSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    department: GQDepartmentInput;
}>;

export type GQDepartmentSaveMutation = {
    __typename?: "Mutation";
    departmentSave: {
        __typename?: "Department";
        id: string;
        name: string;
        externalId?: string | null;
        createdAt?: string | null;
        deletedAt?: any | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
        viWarehouse?: {
            __typename?: "ViWarehouse";
            id: string;
            name: string;
        } | null;
    };
};

export type GQDepartmentDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQDepartmentDeleteMutation = {
    __typename?: "Mutation";
    departmentDelete: {
        __typename?: "DepartmentDeleteResponse";
        status: boolean;
    };
};

export type GQViWarehousesQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQViWarehousesQuery = {
    __typename?: "Query";
    viWarehouses: {
        __typename?: "ViWarehousePagination";
        data: Array<{ __typename?: "ViWarehouse"; id: string; name: string }>;
    };
};

export type GQViWarehouseForDepartmentQueryVariables = Exact<{
    departmentId: Scalars["ID"];
}>;

export type GQViWarehouseForDepartmentQuery = {
    __typename?: "Query";
    viWarehouseForDepartment: Array<{
        __typename?: "ViWarehouse";
        id: string;
        name: string;
    }>;
};

export type GQSetDepartment2WarehouseMutationVariables = Exact<{
    departmentId: Scalars["ID"];
    warehouseId?: InputMaybe<Scalars["ID"]>;
}>;

export type GQSetDepartment2WarehouseMutation = {
    __typename?: "Mutation";
    setDepartment2Warehouse: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQUpdateViWarehousesMutationVariables = Exact<{
    [key: string]: never;
}>;

export type GQUpdateViWarehousesMutation = {
    __typename?: "Mutation";
    updateViWarehouses: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQAllDiscountFieldsFragment = {
    __typename?: "Discount";
    id: string;
    name: string;
    lineDescription: string;
    type: GQDiscountType;
    valueType: GQDiscountValueType;
    value: number;
    maxPerOrder?: number | null;
    itemQuery: any;
    conditions: any;
    createdAt: any;
    deletedAt?: any | null;
    active: boolean;
    merchant: { __typename?: "Merchant"; id: string; name: string };
};

export type GQDiscountsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQDiscountSearchInput>;
}>;

export type GQDiscountsQuery = {
    __typename?: "Query";
    discounts: {
        __typename?: "DiscountPagination";
        data: Array<{
            __typename?: "Discount";
            id: string;
            name: string;
            lineDescription: string;
            type: GQDiscountType;
            valueType: GQDiscountValueType;
            value: number;
            maxPerOrder?: number | null;
            itemQuery: any;
            conditions: any;
            createdAt: any;
            deletedAt?: any | null;
            active: boolean;
            merchant: { __typename?: "Merchant"; id: string; name: string };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQDiscountQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQDiscountQuery = {
    __typename?: "Query";
    discount?: {
        __typename?: "Discount";
        id: string;
        name: string;
        lineDescription: string;
        type: GQDiscountType;
        valueType: GQDiscountValueType;
        value: number;
        maxPerOrder?: number | null;
        itemQuery: any;
        conditions: any;
        createdAt: any;
        deletedAt?: any | null;
        active: boolean;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    } | null;
};

export type GQDiscountFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQDiscountFormQuery = {
    __typename?: "Query";
    products: {
        __typename?: "ProductPagination";
        data: Array<{
            __typename?: "Product";
            id: string;
            name: string;
            active: boolean;
        }>;
    };
    tags: {
        __typename?: "TagPagination";
        data: Array<{
            __typename?: "Tag";
            id: string;
            identifier: string;
            name?: string | null;
        }>;
    };
    tagGroups: {
        __typename?: "TagGroupPagination";
        data: Array<{ __typename?: "TagGroup"; id: string; name: string }>;
    };
    customers: {
        __typename?: "CustomerPagination";
        data: Array<{ __typename?: "Customer"; id: string; name: string }>;
    };
    customerGroups: {
        __typename?: "CustomerGroupPagination";
        data: Array<{ __typename?: "CustomerGroup"; id: string; name: string }>;
    };
    departments: {
        __typename?: "DepartmentPagination";
        data: Array<{ __typename?: "Department"; id: string; name: string }>;
    };
};

export type GQDiscountCreateMutationVariables = Exact<{
    discount: GQDiscountInput;
}>;

export type GQDiscountCreateMutation = {
    __typename?: "Mutation";
    discountCreate: {
        __typename?: "Discount";
        id: string;
        name: string;
        lineDescription: string;
        type: GQDiscountType;
        valueType: GQDiscountValueType;
        value: number;
        maxPerOrder?: number | null;
        itemQuery: any;
        conditions: any;
        createdAt: any;
        deletedAt?: any | null;
        active: boolean;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    };
};

export type GQDiscountSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    discount: GQDiscountInput;
}>;

export type GQDiscountSaveMutation = {
    __typename?: "Mutation";
    discountSave: {
        __typename?: "Discount";
        id: string;
        name: string;
        lineDescription: string;
        type: GQDiscountType;
        valueType: GQDiscountValueType;
        value: number;
        maxPerOrder?: number | null;
        itemQuery: any;
        conditions: any;
        createdAt: any;
        deletedAt?: any | null;
        active: boolean;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    };
};

export type GQDiscountDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQDiscountDeleteMutation = {
    __typename?: "Mutation";
    discountDelete: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQDiscountsActiveToggleMutationVariables = Exact<{
    ids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type GQDiscountsActiveToggleMutation = {
    __typename?: "Mutation";
    discountsActiveToggle: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQEconomicSyncJobFieldsFragment = {
    __typename?: "EconomicSyncJob";
    id: number;
    shiftId?: string | null;
    runAt: any;
    attempts: number;
    lastError?: string | null;
    createdAt: any;
    shift?: {
        __typename?: "ShiftRM";
        id: string;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    } | null;
};

export type GQEconomicSyncJobsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQEconomicSyncJobsQuery = {
    __typename?: "Query";
    economicSyncJobs: {
        __typename?: "EconomicSyncJobPagination";
        data: Array<{
            __typename?: "EconomicSyncJob";
            id: number;
            shiftId?: string | null;
            runAt: any;
            attempts: number;
            lastError?: string | null;
            createdAt: any;
            shift?: {
                __typename?: "ShiftRM";
                id: string;
                merchant: { __typename?: "Merchant"; id: string; name: string };
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQInvoiceCountQueryVariables = Exact<{
    from: Scalars["Date"];
    to: Scalars["Date"];
}>;

export type GQInvoiceCountQuery = {
    __typename?: "Query";
    invoiceCount: Array<{
        __typename?: "InvoiceCount";
        count: number;
        merchant?: { __typename?: "Merchant"; name: string } | null;
    } | null>;
};

export type GQMerchantChartOfAccountsQueryVariables = Exact<{
    integrationId: Scalars["ID"];
}>;

export type GQMerchantChartOfAccountsQuery = {
    __typename?: "Query";
    merchantChartOfAccounts: {
        __typename?: "MerchantChartOfAccounts";
        data: Array<{
            __typename?: "MerchantChartOfAccount";
            chartOfAccountsId: string;
            merchantAccountNo: number;
            name: string;
        }>;
    };
};

export type GQAccountChartByProductGroupQueryVariables = Exact<{
    integrationId: Scalars["ID"];
}>;

export type GQAccountChartByProductGroupQuery = {
    __typename?: "Query";
    accountChartByProductGroup: {
        __typename?: "ChartAccounts";
        data: Array<{
            __typename?: "ChartAccount";
            accountNo?: number | null;
            productGroupId: string;
            productGroup: {
                __typename?: "ProductGroup";
                id: string;
                name: string;
                deletedAt?: any | null;
            };
        }>;
    };
};

export type GQAccountForProductGroupQueryVariables = Exact<{
    integrationId: Scalars["ID"];
    productGroupId: Scalars["ID"];
}>;

export type GQAccountForProductGroupQuery = {
    __typename?: "Query";
    accountForProductGroup?: {
        __typename?: "ChartAccount";
        accountNo?: number | null;
        productGroupId: string;
        productGroup: { __typename?: "ProductGroup"; id: string; name: string };
    } | null;
};

export type GQSaveMerchantChartOfAccountsMutationVariables = Exact<{
    integrationId: Scalars["ID"];
    chartOfAccounts:
        | Array<GQMerchantChartOfAccountInput>
        | GQMerchantChartOfAccountInput;
}>;

export type GQSaveMerchantChartOfAccountsMutation = {
    __typename?: "Mutation";
    saveMerchantChartOfAccounts: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQSaveAccountChartByProductGroupMutationVariables = Exact<{
    integrationId: Scalars["ID"];
    productGroupMap: Array<GQChartAccountInput> | GQChartAccountInput;
}>;

export type GQSaveAccountChartByProductGroupMutation = {
    __typename?: "Mutation";
    saveAccountChartByProductGroup: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQSaveAccountForProductGroupMutationVariables = Exact<{
    integrationId: Scalars["ID"];
    productGroupMap: GQChartAccountInput;
}>;

export type GQSaveAccountForProductGroupMutation = {
    __typename?: "Mutation";
    saveAccountForProductGroup: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQFiskalyClientFieldsFragment = {
    __typename?: "FiskalyClient";
    id: string;
    integrationId: string;
    establishmentId: string;
    tssId: string;
    clientState: GQClientStateEnum;
    updatedAt?: any | null;
    submitBefore?: any | null;
    cashRegisterId: string;
    cashRegister: { __typename?: "CashRegister"; id: string; name: string };
};

export type GQFiskalyRemoteClientFieldsFragment = {
    __typename?: "FiskalyRemoteClient";
    id: string;
    state?: GQClientStateEnum | null;
    serialNumber: string;
    tssId: string;
    createdAt: any;
    updatedAt: any;
};

export type GQFiskalyRemoteCashRegisterFieldsFragment = {
    __typename?: "FiskalyRemoteCashRegister";
    clientId: string;
    cashRegisterType: GQCashRegisterTypeEnum;
    revision: number;
    tssId: string;
    model: string;
    brand: string;
    softwareBrand?: string | null;
    softwareVersion?: string | null;
    baseCurrencyCode: string;
    environment: GQEnvironmentEnum;
    createdAt: any;
    updatedAt?: any | null;
};

export type GQFiskalyOrganizationFieldsFragment = {
    __typename?: "FiskalyOrganization";
    id: string;
    name: string;
    displayName?: string | null;
    address: string;
    zip: string;
    town: string;
    state?: string | null;
    countryCode: string;
    vatId?: string | null;
    economyId?: string | null;
    taxNumber?: string | null;
    fiskalyEnvironment?: GQEnvironmentEnum | null;
    managedBy?: string | null;
};

export type GQFiskalyTssFieldsFragment = {
    __typename?: "FiskalyTss";
    id: string;
    state: GQTssStateEnum;
    description: string;
    publicKey: string;
    serialNumber: string;
    numberActiveTransactions: number;
    numberRegisteredClients: number;
    signatureCounter: number;
    transactionCounter: number;
    createdAt: any;
    uninitializedAt?: any | null;
    initializedAt?: any | null;
    disabledAt?: any | null;
    defectiveAt?: any | null;
};

export type GQFiskalyEstablishmentFieldsFragment = {
    __typename?: "FiskalyEstablishment";
    id: string;
    integrationId: string;
    organizationId: string;
    designation: string;
    street: string;
    town: string;
    zip: string;
    houseNumber: string;
    houseNumberSuffix?: string | null;
    addressAdditional?: string | null;
    remarks?: string | null;
    createdAt: any;
    updatedAt?: any | null;
    submittedAt?: any | null;
    submitBefore?: any | null;
};

export type GQFiskalyDsFinVkExportFieldsFragment = {
    __typename?: "FiskalyDSFinVKExport";
    id: string;
    fromDate: any;
    toDate: any;
    clientId?: string | null;
    exportState: GQExportState;
    format: GQExportFormat;
    cashPointClosings: Array<string>;
    exportUrl?: string | null;
    error?: string | null;
    requestedAt: any;
    completedAt?: any | null;
    expireAt?: any | null;
};

export type GQFiskalyClientQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQFiskalyClientQuery = {
    __typename?: "Query";
    fiskalyClient?: {
        __typename?: "FiskalyClient";
        id: string;
        integrationId: string;
        establishmentId: string;
        tssId: string;
        clientState: GQClientStateEnum;
        updatedAt?: any | null;
        submitBefore?: any | null;
        cashRegisterId: string;
        cashRegister: { __typename?: "CashRegister"; id: string; name: string };
    } | null;
};

export type GQFiskalyClientByCashRegisterIdQueryVariables = Exact<{
    cashRegisterId: Scalars["ID"];
}>;

export type GQFiskalyClientByCashRegisterIdQuery = {
    __typename?: "Query";
    fiskalyClientByCashRegisterId?: {
        __typename?: "FiskalyClient";
        id: string;
        integrationId: string;
        establishmentId: string;
        tssId: string;
        clientState: GQClientStateEnum;
        updatedAt?: any | null;
        submitBefore?: any | null;
        cashRegisterId: string;
        cashRegister: { __typename?: "CashRegister"; id: string; name: string };
    } | null;
};

export type GQFiskalyClientsQueryVariables = Exact<{ [key: string]: never }>;

export type GQFiskalyClientsQuery = {
    __typename?: "Query";
    fiskalyClients: {
        __typename?: "FiskalyClientList";
        data: Array<{
            __typename?: "FiskalyClient";
            id: string;
            integrationId: string;
            establishmentId: string;
            tssId: string;
            clientState: GQClientStateEnum;
            updatedAt?: any | null;
            submitBefore?: any | null;
            cashRegisterId: string;
            cashRegister: {
                __typename?: "CashRegister";
                id: string;
                name: string;
            };
        }>;
    };
};

export type GQFiskalyRemoteClientsQueryVariables = Exact<{
    integrationId: Scalars["ID"];
}>;

export type GQFiskalyRemoteClientsQuery = {
    __typename?: "Query";
    fiskalyRemoteClients: {
        __typename?: "FiskalyRemoteClientList";
        data: Array<{
            __typename?: "FiskalyRemoteClient";
            id: string;
            state?: GQClientStateEnum | null;
            serialNumber: string;
            tssId: string;
            createdAt: any;
            updatedAt: any;
        }>;
    };
};

export type GQFiskalyRemoteCashRegistersQueryVariables = Exact<{
    integrationId: Scalars["ID"];
}>;

export type GQFiskalyRemoteCashRegistersQuery = {
    __typename?: "Query";
    fiskalyRemoteCashRegisters: {
        __typename?: "FiskalyRemoteCashRegisterList";
        data: Array<{
            __typename?: "FiskalyRemoteCashRegister";
            clientId: string;
            cashRegisterType: GQCashRegisterTypeEnum;
            revision: number;
            tssId: string;
            model: string;
            brand: string;
            softwareBrand?: string | null;
            softwareVersion?: string | null;
            baseCurrencyCode: string;
            environment: GQEnvironmentEnum;
            createdAt: any;
            updatedAt?: any | null;
        }>;
    };
};

export type GQFiskalyOrganizationsQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQFiskalyOrganizationsQuery = {
    __typename?: "Query";
    fiskalyOrganizations: {
        __typename?: "FiskalyOrganizations";
        data: Array<{
            __typename?: "FiskalyOrganization";
            integrationId?: string | null;
            id: string;
            name: string;
            displayName?: string | null;
            address: string;
            zip: string;
            town: string;
            state?: string | null;
            countryCode: string;
            vatId?: string | null;
            economyId?: string | null;
            taxNumber?: string | null;
            fiskalyEnvironment?: GQEnvironmentEnum | null;
            managedBy?: string | null;
            merchant?: {
                __typename?: "Merchant";
                id: string;
                name: string;
            } | null;
        }>;
    };
};

export type GQFiskalyTssListQueryVariables = Exact<{
    integrationId: Scalars["ID"];
}>;

export type GQFiskalyTssListQuery = {
    __typename?: "Query";
    fiskalyTssList: {
        __typename?: "FiskalyTssList";
        data: Array<{
            __typename?: "FiskalyTss";
            id: string;
            state: GQTssStateEnum;
            description: string;
            publicKey: string;
            serialNumber: string;
            numberActiveTransactions: number;
            numberRegisteredClients: number;
            signatureCounter: number;
            transactionCounter: number;
            createdAt: any;
            uninitializedAt?: any | null;
            initializedAt?: any | null;
            disabledAt?: any | null;
            defectiveAt?: any | null;
        }>;
    };
};

export type GQFiskalyOrganizationQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQFiskalyOrganizationQuery = {
    __typename?: "Query";
    fiskalyOrganization: {
        __typename?: "FiskalyOrganization";
        id: string;
        name: string;
        displayName?: string | null;
        address: string;
        zip: string;
        town: string;
        state?: string | null;
        countryCode: string;
        vatId?: string | null;
        economyId?: string | null;
        taxNumber?: string | null;
        fiskalyEnvironment?: GQEnvironmentEnum | null;
        managedBy?: string | null;
    };
};

export type GQFiskalyTssQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQFiskalyTssQuery = {
    __typename?: "Query";
    fiskalyTss: {
        __typename?: "FiskalyTss";
        id: string;
        state: GQTssStateEnum;
    };
};

export type GQFiskalyEstablishmentsQueryVariables = Exact<{
    integrationId: Scalars["ID"];
}>;

export type GQFiskalyEstablishmentsQuery = {
    __typename?: "Query";
    fiskalyEstablishments: {
        __typename?: "FiskalyEstablishmentList";
        data: Array<{
            __typename?: "FiskalyEstablishment";
            id: string;
            integrationId: string;
            organizationId: string;
            designation: string;
            street: string;
            town: string;
            zip: string;
            houseNumber: string;
            houseNumberSuffix?: string | null;
            addressAdditional?: string | null;
            remarks?: string | null;
            createdAt: any;
            updatedAt?: any | null;
            submittedAt?: any | null;
            submitBefore?: any | null;
        }>;
    };
};

export type GQFiskalyEstablishmentMappingQueryVariables = Exact<{
    integrationId: Scalars["ID"];
}>;

export type GQFiskalyEstablishmentMappingQuery = {
    __typename?: "Query";
    fiskalyEstablishmentMapping: {
        __typename?: "FiskalyEstablishmentMappingList";
        data: Array<{
            __typename?: "FiskalyEstablishmentMapping";
            clientId: string;
            cashRegisterId: string;
            establishmentId?: string | null;
            organizationId?: string | null;
            cashRegister: {
                __typename?: "CashRegister";
                id: string;
                name: string;
            };
        }>;
    };
};

export type GQFiskalyDsFinVkExportsQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQFiskalyDsFinVkExportsQuery = {
    __typename?: "Query";
    fiskalyDSFinVKExports: {
        __typename?: "FiskalyDSFinVKExportList";
        data: Array<{
            __typename?: "FiskalyDSFinVKExport";
            id: string;
            fromDate: any;
            toDate: any;
            clientId?: string | null;
            exportState: GQExportState;
            format: GQExportFormat;
            cashPointClosings: Array<string>;
            exportUrl?: string | null;
            error?: string | null;
            requestedAt: any;
            completedAt?: any | null;
            expireAt?: any | null;
        }>;
    };
};

export type GQFiskalyDsFinVkExportQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQFiskalyDsFinVkExportQuery = {
    __typename?: "Query";
    fiskalyDSFinVKExport: {
        __typename?: "FiskalyDSFinVKExport";
        id: string;
        fromDate: any;
        toDate: any;
        clientId?: string | null;
        exportState: GQExportState;
        format: GQExportFormat;
        cashPointClosings: Array<string>;
        exportUrl?: string | null;
        error?: string | null;
        requestedAt: any;
        completedAt?: any | null;
        expireAt?: any | null;
    };
};

export type GQGetFiskalyDsFinVkExportDownloadQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQGetFiskalyDsFinVkExportDownloadQuery = {
    __typename?: "Query";
    getFiskalyDSFinVKExportDownload: {
        __typename?: "File";
        fileName: string;
        contentType: string;
        byteBuffer: any;
    };
};

export type GQFiskalyEstablishmentSubmissionsQueryVariables = Exact<{
    pagination?: InputMaybe<GQCursorPaginationInput>;
}>;

export type GQFiskalyEstablishmentSubmissionsQuery = {
    __typename?: "Query";
    fiskalyEstablishmentSubmissions: {
        __typename?: "FiskalyEstablishmentSubmissionList";
        pagination: {
            __typename?: "CursorPagination";
            token: string;
            limit: number;
            remaining: number;
        };
        data: Array<{
            __typename?: "FiskalyEstablishmentSubmission";
            id: string;
            establishmentId: string;
            state: string;
            error?: string | null;
            createdAt: any;
            previewedAt?: any | null;
            reviewedAt?: any | null;
            transmittedAt?: any | null;
        }>;
    };
};

export type GQFiskalyRemoteEstablishmentSubmissionsQueryVariables = Exact<{
    integrationId: Scalars["ID"];
}>;

export type GQFiskalyRemoteEstablishmentSubmissionsQuery = {
    __typename?: "Query";
    fiskalyRemoteEstablishmentSubmissions: {
        __typename?: "FiskalyRemoteEstablishmentSubmissionList";
        data: Array<{
            __typename?: "RemoteEstablishmentSubmission";
            id: string;
            establishmentId: string;
            state: string;
            error?: string | null;
            createdAt: any;
            transmittedAt?: any | null;
        }>;
    };
};

export type GQGetFiskalyTaxPayerQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQGetFiskalyTaxPayerQuery = {
    __typename?: "Query";
    getFiskalyTaxPayer?:
        | {
              __typename?: "FiskalyTaxPayerLegal";
              legalForm: string;
              companyName: string;
              type: GQFiskalyTaxPayerType;
              webAddress?: string | null;
              taxNumber: string;
              taxOfficeNumber?: string | null;
              vatNumber?: string | null;
              street: string;
              houseNumber: string;
              houseNumberSuffix?: string | null;
              zip: string;
              town: string;
              country: string;
          }
        | {
              __typename?: "FiskalyTaxPayerNatural";
              salutation: string;
              title?: string | null;
              prefix?: string | null;
              firstName: string;
              lastName: string;
              suffix?: string | null;
              birthDate: any;
              identificationNumber?: string | null;
              type: GQFiskalyTaxPayerType;
              webAddress?: string | null;
              taxNumber: string;
              taxOfficeNumber?: string | null;
              vatNumber?: string | null;
              street: string;
              houseNumber: string;
              houseNumberSuffix?: string | null;
              zip: string;
              town: string;
              country: string;
          }
        | null;
};

export type GQFiskalyClientSyncMutationVariables = Exact<{
    id: Scalars["ID"];
    pin: Scalars["String"];
}>;

export type GQFiskalyClientSyncMutation = {
    __typename?: "Mutation";
    fiskalyClientSync: {
        __typename?: "FiskalyClient";
        id: string;
        integrationId: string;
        establishmentId: string;
        tssId: string;
        clientState: GQClientStateEnum;
        updatedAt?: any | null;
        submitBefore?: any | null;
        cashRegisterId: string;
        cashRegister: { __typename?: "CashRegister"; id: string; name: string };
    };
};

export type GQFiskalyClientDeregisterMutationVariables = Exact<{
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    pin: Scalars["String"];
}>;

export type GQFiskalyClientDeregisterMutation = {
    __typename?: "Mutation";
    setFiskalyClientState: {
        __typename?: "FiskalyClient";
        id: string;
        integrationId: string;
        establishmentId: string;
        tssId: string;
        clientState: GQClientStateEnum;
        updatedAt?: any | null;
        submitBefore?: any | null;
        cashRegisterId: string;
        cashRegister: { __typename?: "CashRegister"; id: string; name: string };
    };
};

export type GQFiskalyClientRegisterMutationVariables = Exact<{
    id: Scalars["ID"];
    integrationId: Scalars["ID"];
    pin: Scalars["String"];
}>;

export type GQFiskalyClientRegisterMutation = {
    __typename?: "Mutation";
    setFiskalyClientState: {
        __typename?: "FiskalyClient";
        id: string;
        integrationId: string;
        establishmentId: string;
        tssId: string;
        clientState: GQClientStateEnum;
        updatedAt?: any | null;
        submitBefore?: any | null;
        cashRegisterId: string;
        cashRegister: { __typename?: "CashRegister"; id: string; name: string };
    };
};

export type GQFiskalyRegisterTssForOrganizationMutationVariables = Exact<{
    [key: string]: never;
}>;

export type GQFiskalyRegisterTssForOrganizationMutation = {
    __typename?: "Mutation";
    fiskalyRegisterTssForOrganization: {
        __typename?: "CreateTssResponse";
        status: boolean;
        adminPuk?: string | null;
    };
};

export type GQFiskalyAdvanceTssStateMutationVariables = Exact<{
    tssState: GQTssStateEnum;
    pinCode?: InputMaybe<Scalars["String"]>;
    adminPuk?: InputMaybe<Scalars["String"]>;
}>;

export type GQFiskalyAdvanceTssStateMutation = {
    __typename?: "Mutation";
    fiskalyAdvanceTssState: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQFiskalyChangePinForTssMutationVariables = Exact<{
    pinCode: Scalars["String"];
    adminPuk: Scalars["String"];
    integrationId: Scalars["ID"];
}>;

export type GQFiskalyChangePinForTssMutation = {
    __typename?: "Mutation";
    fiskalyChangePinForTss: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQFiskalyOrganizationUpsertMutationVariables = Exact<{
    managedOrganization: GQFiskalyOrganizationInput;
}>;

export type GQFiskalyOrganizationUpsertMutation = {
    __typename?: "Mutation";
    fiskalyOrganizationUpsert: {
        __typename?: "FiskalyOrganization";
        id: string;
        name: string;
        displayName?: string | null;
        address: string;
        zip: string;
        town: string;
        state?: string | null;
        countryCode: string;
        vatId?: string | null;
        economyId?: string | null;
        taxNumber?: string | null;
        fiskalyEnvironment?: GQEnvironmentEnum | null;
        managedBy?: string | null;
    };
};

export type GQFiskalyOrganizationGoLiveMutationVariables = Exact<{
    integrationId: Scalars["ID"];
}>;

export type GQFiskalyOrganizationGoLiveMutation = {
    __typename?: "Mutation";
    fiskalyOrganizationGoLive: {
        __typename?: "FiskalyOrganization";
        id: string;
        name: string;
        displayName?: string | null;
        address: string;
        zip: string;
        town: string;
        state?: string | null;
        countryCode: string;
        vatId?: string | null;
        economyId?: string | null;
        taxNumber?: string | null;
        fiskalyEnvironment?: GQEnvironmentEnum | null;
        managedBy?: string | null;
    };
};

export type GQSaveFiskalyEstablishmentMappingMutationVariables = Exact<{
    integrationId: Scalars["ID"];
    establishmentMapping:
        | Array<GQFiskalyEstablishmentMappingInput>
        | GQFiskalyEstablishmentMappingInput;
}>;

export type GQSaveFiskalyEstablishmentMappingMutation = {
    __typename?: "Mutation";
    saveFiskalyEstablishmentMapping: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQSaveFiskalyEstablishmentMutationVariables = Exact<{
    establishment: GQFiskalyEstablishmentInput;
    establishmentId?: InputMaybe<Scalars["ID"]>;
}>;

export type GQSaveFiskalyEstablishmentMutation = {
    __typename?: "Mutation";
    saveFiskalyEstablishment: {
        __typename?: "FiskalyEstablishment";
        id: string;
        integrationId: string;
        organizationId: string;
        designation: string;
        street: string;
        town: string;
        zip: string;
        houseNumber: string;
        houseNumberSuffix?: string | null;
        addressAdditional?: string | null;
        remarks?: string | null;
        createdAt: any;
        updatedAt?: any | null;
        submittedAt?: any | null;
        submitBefore?: any | null;
    };
};

export type GQDeleteEstablishmentMutationVariables = Exact<{
    establishmentId: Scalars["ID"];
}>;

export type GQDeleteEstablishmentMutation = {
    __typename?: "Mutation";
    deleteEstablishment: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQRequestFiskalyDsFinVkExportMutationVariables = Exact<{
    exportArguments: GQFiskalyDsFinVkExportInput;
}>;

export type GQRequestFiskalyDsFinVkExportMutation = {
    __typename?: "Mutation";
    requestFiskalyDSFinVKExport: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQRequestFiskalyEstablishmentSubmissionMutationVariables = Exact<{
    establishmentId: Scalars["ID"];
}>;

export type GQRequestFiskalyEstablishmentSubmissionMutation = {
    __typename?: "Mutation";
    requestFiskalyEstablishmentSubmission: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQUpsertFiskalyTaxPayerLegalMutationVariables = Exact<{
    taxPayerData: GQFiskalyTaxPayerLegalInput;
}>;

export type GQUpsertFiskalyTaxPayerLegalMutation = {
    __typename?: "Mutation";
    upsertFiskalyTaxPayerLegal: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQUpsertFiskalyTaxPayerNaturalMutationVariables = Exact<{
    taxPayerData: GQFiskalyTaxPayerNaturalInput;
}>;

export type GQUpsertFiskalyTaxPayerNaturalMutation = {
    __typename?: "Mutation";
    upsertFiskalyTaxPayerNatural: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutationVariables =
    Exact<{
        submissionId: Scalars["ID"];
    }>;

export type GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation = {
    __typename?: "Mutation";
    requestFiskalyEstablishmentSubmissionPreviewDownload: {
        __typename?: "FiskalyEstablishmentSubmissionDownload";
        fileContents: string;
    };
};

export type GQRequestFiskalyEstablishmentSubmissionDownloadMutationVariables =
    Exact<{
        submissionId: Scalars["ID"];
    }>;

export type GQRequestFiskalyEstablishmentSubmissionDownloadMutation = {
    __typename?: "Mutation";
    requestFiskalyEstablishmentSubmissionDownload: {
        __typename?: "FiskalyEstablishmentSubmissionDownload";
        fileContents: string;
    };
};

export type GQApproveFiskalyEstablishmentSubmissionMutationVariables = Exact<{
    submissionId: Scalars["ID"];
}>;

export type GQApproveFiskalyEstablishmentSubmissionMutation = {
    __typename?: "Mutation";
    approveFiskalyEstablishmentSubmission: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQRequestFiskalyEstablishmentSubmissionTransmissionMutationVariables =
    Exact<{
        submissionId: Scalars["ID"];
    }>;

export type GQRequestFiskalyEstablishmentSubmissionTransmissionMutation = {
    __typename?: "Mutation";
    requestFiskalyEstablishmentSubmissionTransmission: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQIntegrationSettingsQueryVariables = Exact<{
    integrationId: Scalars["ID"];
}>;

export type GQIntegrationSettingsQuery = {
    __typename?: "Query";
    integrationSettings?:
        | {
              __typename?: "CmpProductSettings";
              id: string;
              type: string;
              integrationId: string;
              hostname: string;
              port: number;
              vhost: string;
              exchangeName: string;
              queueName: string;
              routingKey: string;
              username: string;
              password: string;
              cmpOrderUrl: string;
          }
        | {
              __typename?: "EconomicSettings";
              id: string;
              type: string;
              integrationId: string;
              journalId: number;
              enableSyncByProductGroups: boolean;
              enableSyncAfterShiftClose: boolean;
          }
        | {
              __typename?: "FiskalySettings";
              id: string;
              type: string;
              integrationId: string;
              organizationId: string;
              tssId: string;
              apiKey: string;
              submissionNeeded: boolean;
          }
        | {
              __typename?: "PartnerApiSettings";
              id: string;
              type: string;
              integrationId: string;
          }
        | {
              __typename?: "VenueAccessSettings";
              id: string;
              type: string;
              integrationId: string;
          }
        | null;
};

export type GQEconomicSettingsSaveMutationVariables = Exact<{
    integrationId: Scalars["ID"];
    settings: GQEconomicSettingsInput;
}>;

export type GQEconomicSettingsSaveMutation = {
    __typename?: "Mutation";
    integrationEconomicSettingsSave: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQCmpProductSettingsSaveMutationVariables = Exact<{
    integrationId: Scalars["ID"];
    settings: GQCmpProductSettingsInput;
}>;

export type GQCmpProductSettingsSaveMutation = {
    __typename?: "Mutation";
    integrationCmpProductSettingsSave: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQFiskalySettingsSaveMutationVariables = Exact<{
    integrationId: Scalars["ID"];
    settings: GQFiskalySettingsInput;
}>;

export type GQFiskalySettingsSaveMutation = {
    __typename?: "Mutation";
    integrationFiskalySettingsSave: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQAllIntegrationFieldsFragment = {
    __typename?: "Integration";
    id: string;
    type: string;
    active: boolean;
    name: string;
    apiKey: string;
    createdAt?: string | null;
    merchant: { __typename?: "Merchant"; id: string; name: string };
};

export type GQIntegrationsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQIntegrationsQuery = {
    __typename?: "Query";
    integrations: {
        __typename?: "IntegrationPagination";
        data: Array<{
            __typename?: "Integration";
            id: string;
            type: string;
            active: boolean;
            name: string;
            apiKey: string;
            createdAt?: string | null;
            merchant: { __typename?: "Merchant"; id: string; name: string };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQIntegrationsOfTypeQueryVariables = Exact<{
    type: Scalars["String"];
}>;

export type GQIntegrationsOfTypeQuery = {
    __typename?: "Query";
    integrationsOfType: {
        __typename?: "IntegrationArray";
        data: Array<{
            __typename?: "Integration";
            id: string;
            type: string;
            active: boolean;
            name: string;
            apiKey: string;
            createdAt?: string | null;
            merchant: { __typename?: "Merchant"; id: string; name: string };
        }>;
    };
};

export type GQIntegrationQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQIntegrationQuery = {
    __typename?: "Query";
    integration?: {
        __typename?: "Integration";
        id: string;
        type: string;
        active: boolean;
        name: string;
        apiKey: string;
        createdAt?: string | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    } | null;
};

export type GQIntegrationCreateMutationVariables = Exact<{
    integration: GQIntegrationCreate;
}>;

export type GQIntegrationCreateMutation = {
    __typename?: "Mutation";
    integrationCreate: {
        __typename?: "Integration";
        id: string;
        type: string;
        active: boolean;
        name: string;
        apiKey: string;
        createdAt?: string | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    };
};

export type GQIntegrationSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    integration: GQIntegrationInput;
}>;

export type GQIntegrationSaveMutation = {
    __typename?: "Mutation";
    integrationSave: {
        __typename?: "Integration";
        id: string;
        type: string;
        active: boolean;
        name: string;
        apiKey: string;
        createdAt?: string | null;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    };
};

export type GQIntegrationDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQIntegrationDeleteMutation = {
    __typename?: "Mutation";
    integrationDelete: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQIntegrationFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQIntegrationFormQuery = {
    __typename?: "Query";
    integrations: {
        __typename?: "IntegrationPagination";
        data: Array<{
            __typename?: "Integration";
            id: string;
            type: string;
            active: boolean;
            name: string;
            apiKey: string;
        }>;
    };
};

export type GQAllMerchantChartOfAccountFieldsFragment = {
    __typename?: "MerchantChartOfAccount";
    integrationId: string;
    name: string;
    chartOfAccountsId: string;
    merchantAccountNo: number;
};

export type GQAllInvoiceFieldsFragment = {
    __typename?: "InvoiceRM";
    id: string;
    receiptNumber?: string | null;
    receipt: string;
    discountAmount: number;
    amount: number;
    cashRegisterName?: string | null;
    sms?: string | null;
    createdAt: any;
    shift: {
        __typename?: "ShiftRM";
        id: string;
        cashRegister: { __typename?: "CashRegister"; name: string };
    };
    items?: Array<{
        __typename?: "InvoiceItemRM";
        quantity: number;
        external?: Array<{
            __typename?: "InvoiceItemExternalRM";
            integration: string;
            receipt?: string | null;
        }> | null;
    }> | null;
    payments?: Array<{
        __typename?: "InvoicePaymentRM";
        cardReceipt?: string | null;
    }> | null;
    externalReceipts: Array<{
        __typename?: "InvoiceExternalReceipt";
        integrationId: string;
        receipt: string;
    }>;
};

export type GQInvoicesQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQInvoiceSearchInput>;
}>;

export type GQInvoicesQuery = {
    __typename?: "Query";
    invoices: {
        __typename?: "InvoiceRMPagination";
        data: Array<{
            __typename?: "InvoiceRM";
            id: string;
            receiptNumber?: string | null;
            receipt: string;
            discountAmount: number;
            amount: number;
            cashRegisterName?: string | null;
            sms?: string | null;
            createdAt: any;
            shift: {
                __typename?: "ShiftRM";
                id: string;
                cashRegister: { __typename?: "CashRegister"; name: string };
            };
            items?: Array<{
                __typename?: "InvoiceItemRM";
                quantity: number;
                external?: Array<{
                    __typename?: "InvoiceItemExternalRM";
                    integration: string;
                    receipt?: string | null;
                }> | null;
            }> | null;
            payments?: Array<{
                __typename?: "InvoicePaymentRM";
                cardReceipt?: string | null;
            }> | null;
            externalReceipts: Array<{
                __typename?: "InvoiceExternalReceipt";
                integrationId: string;
                receipt: string;
            }>;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQInvoiceQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQInvoiceQuery = {
    __typename?: "Query";
    invoice?: {
        __typename?: "InvoiceRM";
        id: string;
        receiptNumber?: string | null;
        receipt: string;
        discountAmount: number;
        amount: number;
        cashRegisterName?: string | null;
        sms?: string | null;
        createdAt: any;
        shift: {
            __typename?: "ShiftRM";
            id: string;
            cashRegister: { __typename?: "CashRegister"; name: string };
        };
        items?: Array<{
            __typename?: "InvoiceItemRM";
            quantity: number;
            external?: Array<{
                __typename?: "InvoiceItemExternalRM";
                integration: string;
                receipt?: string | null;
            }> | null;
        }> | null;
        payments?: Array<{
            __typename?: "InvoicePaymentRM";
            cardReceipt?: string | null;
        }> | null;
        externalReceipts: Array<{
            __typename?: "InvoiceExternalReceipt";
            integrationId: string;
            receipt: string;
        }>;
    } | null;
};

export type GQInvoicesInPeriodQueryVariables = Exact<{
    from: Scalars["Date"];
    to: Scalars["Date"];
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQInvoicesInPeriodQuery = {
    __typename?: "Query";
    invoicesInPeriod: {
        __typename?: "InvoiceRMPagination";
        data: Array<{
            __typename?: "InvoiceRM";
            id: string;
            receiptNumber?: string | null;
            receipt: string;
            discountAmount: number;
            amount: number;
            cashRegisterName?: string | null;
            sms?: string | null;
            createdAt: any;
            shift: {
                __typename?: "ShiftRM";
                id: string;
                cashRegister: { __typename?: "CashRegister"; name: string };
            };
            items?: Array<{
                __typename?: "InvoiceItemRM";
                quantity: number;
                external?: Array<{
                    __typename?: "InvoiceItemExternalRM";
                    integration: string;
                    receipt?: string | null;
                }> | null;
            }> | null;
            payments?: Array<{
                __typename?: "InvoicePaymentRM";
                cardReceipt?: string | null;
            }> | null;
            externalReceipts: Array<{
                __typename?: "InvoiceExternalReceipt";
                integrationId: string;
                receipt: string;
            }>;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQAllLayoutEntityFieldsFragment = {
    __typename?: "LayoutEntity";
    id: string;
    name: string;
    type: string;
    function?: string | null;
    createdAt: any;
    updatedAt?: any | null;
    data:
        | {
              __typename: "BuyAccountFunds";
              externalId?: string | null;
              amount?: number | null;
          }
        | {
              __typename: "CustomItem";
              externalId?: string | null;
              productGroupId: string;
          };
};

export type GQLayoutEntityQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQLayoutEntityQuery = {
    __typename?: "Query";
    layoutEntity?: {
        __typename?: "LayoutEntity";
        id: string;
        name: string;
        type: string;
        function?: string | null;
        createdAt: any;
        updatedAt?: any | null;
        data:
            | {
                  __typename: "BuyAccountFunds";
                  externalId?: string | null;
                  amount?: number | null;
              }
            | {
                  __typename: "CustomItem";
                  externalId?: string | null;
                  productGroupId: string;
              };
    } | null;
};

export type GQLayoutEntitiesQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQLayoutEntitySearchInput>;
}>;

export type GQLayoutEntitiesQuery = {
    __typename?: "Query";
    layoutEntities: {
        __typename?: "LayoutEntityPagination";
        data: Array<{
            __typename?: "LayoutEntity";
            id: string;
            name: string;
            type: string;
            function?: string | null;
            createdAt: any;
            updatedAt?: any | null;
            data:
                | {
                      __typename: "BuyAccountFunds";
                      externalId?: string | null;
                      amount?: number | null;
                  }
                | {
                      __typename: "CustomItem";
                      externalId?: string | null;
                      productGroupId: string;
                  };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQLayoutEntityFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQLayoutEntityFormQuery = {
    __typename?: "Query";
    layoutEntities: {
        __typename?: "LayoutEntityPagination";
        data: Array<{ __typename?: "LayoutEntity"; name: string }>;
    };
};

export type GQLayoutEntityCreateMutationVariables = Exact<{
    layoutEntity: GQLayoutEntityCreate;
}>;

export type GQLayoutEntityCreateMutation = {
    __typename?: "Mutation";
    layoutEntityCreate: {
        __typename?: "LayoutEntity";
        id: string;
        name: string;
        type: string;
        function?: string | null;
        createdAt: any;
        updatedAt?: any | null;
        data:
            | {
                  __typename: "BuyAccountFunds";
                  externalId?: string | null;
                  amount?: number | null;
              }
            | {
                  __typename: "CustomItem";
                  externalId?: string | null;
                  productGroupId: string;
              };
    };
};

export type GQLayoutEntitySaveMutationVariables = Exact<{
    id: Scalars["ID"];
    layoutEntity: GQLayoutEntitySave;
}>;

export type GQLayoutEntitySaveMutation = {
    __typename?: "Mutation";
    layoutEntitySave: {
        __typename?: "LayoutEntity";
        id: string;
        name: string;
        type: string;
        function?: string | null;
        createdAt: any;
        updatedAt?: any | null;
        data:
            | {
                  __typename: "BuyAccountFunds";
                  externalId?: string | null;
                  amount?: number | null;
              }
            | {
                  __typename: "CustomItem";
                  externalId?: string | null;
                  productGroupId: string;
              };
    };
};

export type GQLayoutEntityDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQLayoutEntityDeleteMutation = {
    __typename?: "Mutation";
    layoutEntityDelete: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQAllLayoutFieldsFragment = {
    __typename?: "Layout";
    id: string;
    name: string;
    data: any;
    columns: number;
    rows: number;
    layoutType: string;
    createdAt: any;
    updatedAt?: any | null;
};

export type GQAllPosProductLayoutFieldsFragment = {
    __typename?: "Layout";
    id: string;
    name: string;
    data: any;
    columns: number;
    rows: number;
    layoutType: string;
    products: Array<{
        __typename?: "Product";
        id: string;
        name: string;
        amount: number;
        minimumAmount: number;
        costAmount: number;
        excludeFromDiscounts: boolean;
        buttonText?: string | null;
        externalId?: string | null;
        vat: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        };
        group: {
            __typename?: "ProductGroup";
            id: string;
            name: string;
            color: string;
        };
    }>;
    productGroups: Array<{
        __typename?: "ProductGroup";
        id: string;
        name: string;
        color: string;
        vat: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        };
    }>;
};

export type GQLayoutQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQLayoutQuery = {
    __typename?: "Query";
    layout?: {
        __typename?: "Layout";
        id: string;
        name: string;
        data: any;
        columns: number;
        rows: number;
        layoutType: string;
        createdAt: any;
        updatedAt?: any | null;
    } | null;
};

export type GQProductLayoutsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQLayoutSearchInput>;
}>;

export type GQProductLayoutsQuery = {
    __typename?: "Query";
    productLayouts: {
        __typename?: "LayoutPagination";
        data: Array<{
            __typename?: "Layout";
            id: string;
            name: string;
            data: any;
            columns: number;
            rows: number;
            layoutType: string;
            createdAt: any;
            updatedAt?: any | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQTableLayoutsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQLayoutSearchInput>;
}>;

export type GQTableLayoutsQuery = {
    __typename?: "Query";
    tableLayouts: {
        __typename?: "LayoutPagination";
        data: Array<{
            __typename?: "Layout";
            id: string;
            name: string;
            data: any;
            columns: number;
            rows: number;
            layoutType: string;
            createdAt: any;
            updatedAt?: any | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQLayoutCreateMutationVariables = Exact<{
    layout: GQLayoutCreate;
}>;

export type GQLayoutCreateMutation = {
    __typename?: "Mutation";
    layoutCreate: {
        __typename?: "Layout";
        id: string;
        name: string;
        data: any;
        columns: number;
        rows: number;
        layoutType: string;
        createdAt: any;
        updatedAt?: any | null;
    };
};

export type GQLayoutSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    layout: GQLayoutSave;
}>;

export type GQLayoutSaveMutation = {
    __typename?: "Mutation";
    layoutSave: {
        __typename?: "Layout";
        id: string;
        name: string;
        data: any;
        columns: number;
        rows: number;
        layoutType: string;
        createdAt: any;
        updatedAt?: any | null;
    };
};

export type GQLayoutDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQLayoutDeleteMutation = {
    __typename?: "Mutation";
    layoutDelete: { __typename?: "LayoutDeleteResponse"; status: boolean };
};

export type GQLayoutCopyMutationVariables = Exact<{
    id: Scalars["ID"];
    newTitle: Scalars["String"];
}>;

export type GQLayoutCopyMutation = {
    __typename?: "Mutation";
    layoutCopy: {
        __typename?: "Layout";
        id: string;
        name: string;
        data: any;
        columns: number;
        rows: number;
        layoutType: string;
        createdAt: any;
        updatedAt?: any | null;
    };
};

export type GQProductLayoutFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQProductLayoutFormQuery = {
    __typename?: "Query";
    products: {
        __typename?: "ProductPagination";
        data: Array<{
            __typename?: "Product";
            id: string;
            name: string;
            buttonText?: string | null;
            amount: number;
            minimumAmount: number;
            costAmount: number;
            group: {
                __typename?: "ProductGroup";
                id: string;
                name: string;
                color: string;
            };
        }>;
    };
    productGroups: {
        __typename?: "ProductGroupPagination";
        data: Array<{
            __typename?: "ProductGroup";
            id: string;
            name: string;
            color: string;
        }>;
    };
    cmpEvents: {
        __typename?: "CmpEventPagination";
        data: Array<{
            __typename?: "CmpEvent";
            id: string;
            name: string;
            externalId?: string | null;
            active: boolean;
            products: Array<{
                __typename?: "CmpEventProduct";
                id: string;
                name: string;
                externalId?: string | null;
                active: boolean;
                amount?: number | null;
            }>;
        }>;
    };
    cmpProducts: {
        __typename?: "CmpProductPagination";
        data: Array<{
            __typename?: "CmpProduct";
            id: string;
            name: string;
            externalId?: string | null;
            active: boolean;
            amount?: number | null;
        }>;
    };
    layoutEntities: {
        __typename?: "LayoutEntityPagination";
        data: Array<{
            __typename?: "LayoutEntity";
            id: string;
            name: string;
            type: string;
            function?: string | null;
            createdAt: any;
            updatedAt?: any | null;
            data:
                | {
                      __typename: "BuyAccountFunds";
                      externalId?: string | null;
                      amount?: number | null;
                  }
                | {
                      __typename: "CustomItem";
                      externalId?: string | null;
                      productGroupId: string;
                  };
        }>;
    };
};

export type GQVenueAccessTicketParametersBulkQueryVariables = Exact<{
    eventIds: Array<Scalars["Int"]> | Scalars["Int"];
}>;

export type GQVenueAccessTicketParametersBulkQuery = {
    __typename?: "Query";
    venueAccessTicketParametersBulk: {
        __typename?: "VenueAccessParametersBulk";
        events: Array<{
            __typename?: "VenueAccessEvent";
            id: number;
            name: string;
            isActive: boolean;
        }>;
        accessTypes: Array<{
            __typename?: "VenueAccessAccessType";
            id: number;
            name: string;
        }>;
    };
};

export type GQAllAccessTicketFieldsFragment = {
    __typename?: "VenueAccessParameters";
    events?: Array<{
        __typename?: "VenueAccessEvent";
        id: number;
        name: string;
        isActive: boolean;
    }> | null;
    accessTypes: Array<{
        __typename?: "VenueAccessAccessType";
        id: number;
        name: string;
    }>;
};

export type GQVenueAccessTicketParametersQueryVariables = Exact<{
    eventId?: InputMaybe<Scalars["Int"]>;
}>;

export type GQVenueAccessTicketParametersQuery = {
    __typename?: "Query";
    venueAccessTicketParameters: {
        __typename?: "VenueAccessParameters";
        events?: Array<{
            __typename?: "VenueAccessEvent";
            id: number;
            name: string;
            isActive: boolean;
        }> | null;
        accessTypes: Array<{
            __typename?: "VenueAccessAccessType";
            id: number;
            name: string;
        }>;
    };
};

export type GQLogFieldsFragment = {
    __typename?: "Log";
    id: string;
    type: GQLogType;
    message?: string | null;
    payload?: any | null;
    insertedAt: any;
    merchant?: { __typename?: "Merchant"; name: string } | null;
};

export type GQLogsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQLogSearchInput>;
}>;

export type GQLogsQuery = {
    __typename?: "Query";
    logs: {
        __typename?: "LogPagination";
        data: Array<{
            __typename?: "Log";
            id: string;
            type: GQLogType;
            message?: string | null;
            payload?: any | null;
            insertedAt: any;
            merchant?: { __typename?: "Merchant"; name: string } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQAllLogoFieldsFragment = {
    __typename?: "Logo";
    type: GQLogoType;
    base64Data: string;
    escposData: string;
    bmpData: string;
    width: number;
    height: number;
    fileType: string;
    createdAt: any;
    updatedAt?: any | null;
    deletedAt?: any | null;
};

export type GQLogoQueryVariables = Exact<{
    type: GQLogoType;
}>;

export type GQLogoQuery = {
    __typename?: "Query";
    logo?: {
        __typename?: "Logo";
        type: GQLogoType;
        base64Data: string;
        escposData: string;
        bmpData: string;
        width: number;
        height: number;
        fileType: string;
        createdAt: any;
        updatedAt?: any | null;
        deletedAt?: any | null;
    } | null;
};

export type GQLogoSaveMutationVariables = Exact<{
    logo: GQLogoInput;
}>;

export type GQLogoSaveMutation = {
    __typename?: "Mutation";
    logoSave: {
        __typename?: "Logo";
        type: GQLogoType;
        base64Data: string;
        escposData: string;
        bmpData: string;
        width: number;
        height: number;
        fileType: string;
        createdAt: any;
        updatedAt?: any | null;
        deletedAt?: any | null;
    };
};

export type GQLogoDeleteMutationVariables = Exact<{
    merchantId: Scalars["ID"];
    type: GQLogoType;
}>;

export type GQLogoDeleteMutation = {
    __typename?: "Mutation";
    logoDelete: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQAllMerchantFieldsFragment = {
    __typename?: "Merchant";
    id: string;
    name: string;
    createdAt?: any | null;
};

export type GQMerchantsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQMerchantSearchInput>;
}>;

export type GQMerchantsQuery = {
    __typename?: "Query";
    merchants: {
        __typename?: "MerchantPagination";
        data: Array<{
            __typename?: "Merchant";
            id: string;
            name: string;
            createdAt?: any | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQMerchantQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQMerchantQuery = {
    __typename?: "Query";
    merchant?: {
        __typename?: "Merchant";
        id: string;
        name: string;
        createdAt?: any | null;
    } | null;
};

export type GQMerchantCreateMutationVariables = Exact<{
    merchant: GQMerchantCreate;
}>;

export type GQMerchantCreateMutation = {
    __typename?: "Mutation";
    merchantCreate: {
        __typename?: "Merchant";
        id: string;
        name: string;
        createdAt?: any | null;
    };
};

export type GQMerchantSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    merchant: GQMerchantInput;
}>;

export type GQMerchantSaveMutation = {
    __typename?: "Mutation";
    merchantSave: {
        __typename?: "Merchant";
        id: string;
        name: string;
        createdAt?: any | null;
    };
};

export type GQMerchantDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQMerchantDeleteMutation = {
    __typename?: "Mutation";
    merchantDelete: { __typename?: "MerchantDeleteResponse"; status: boolean };
};

export type GQMerchantFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQMerchantFormQuery = {
    __typename?: "Query";
    merchants: {
        __typename?: "MerchantPagination";
        data: Array<{ __typename?: "Merchant"; id: string; name: string }>;
    };
};

export type GQAvailableLoginAsRolesQueryVariables = Exact<{
    merchantId: Scalars["ID"];
}>;

export type GQAvailableLoginAsRolesQuery = {
    __typename?: "Query";
    roles: {
        __typename?: "RolePagination";
        data: Array<{ __typename?: "Role"; id: string; name: string }>;
    };
};

export type GQAllMiscButtonsFieldsFragment = {
    __typename?: "MiscButtons";
    id: string;
    name: string;
    buttons: any;
    buttonsSortOrder?: any | null;
    createdAt: any;
    deletedAt?: any | null;
    merchant: { __typename?: "Merchant"; id: string; name: string };
};

export type GQScreenMiscButtonFieldsFragment = {
    __typename?: "MiscButtons";
    id: string;
    name: string;
    buttons: any;
    buttonsSortOrder?: any | null;
    createdAt: any;
    merchant: { __typename?: "Merchant"; id: string; name: string };
};

export type GQAllMiscButtonsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQAllMiscButtonsQuery = {
    __typename?: "Query";
    allMiscButtons: {
        __typename?: "MiscButtonsPagination";
        data: Array<{
            __typename?: "MiscButtons";
            id: string;
            name: string;
            buttons: any;
            buttonsSortOrder?: any | null;
            createdAt: any;
            merchant: { __typename?: "Merchant"; id: string; name: string };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQMiscButtonsQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQMiscButtonsQuery = {
    __typename?: "Query";
    miscButtons?: {
        __typename?: "MiscButtons";
        id: string;
        name: string;
        buttons: any;
        buttonsSortOrder?: any | null;
        createdAt: any;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    } | null;
};

export type GQMiscButtonsCreateMutationVariables = Exact<{
    miscButtons: GQMiscButtonsInput;
}>;

export type GQMiscButtonsCreateMutation = {
    __typename?: "Mutation";
    miscButtonsCreate: {
        __typename?: "MiscButtons";
        id: string;
        name: string;
        buttons: any;
        buttonsSortOrder?: any | null;
        createdAt: any;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    };
};

export type GQMiscButtonsSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    miscButtons: GQMiscButtonsInput;
}>;

export type GQMiscButtonsSaveMutation = {
    __typename?: "Mutation";
    miscButtonsSave: {
        __typename?: "MiscButtons";
        id: string;
        name: string;
        buttons: any;
        buttonsSortOrder?: any | null;
        createdAt: any;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    };
};

export type GQMiscButtonsDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQMiscButtonsDeleteMutation = {
    __typename?: "Mutation";
    miscButtonsDelete: {
        __typename?: "MiscButtonsDeleteResponse";
        status: boolean;
    };
};

export type GQPasswordResetTokenRedeemQueryVariables = Exact<{
    token: Scalars["String"];
}>;

export type GQPasswordResetTokenRedeemQuery = {
    __typename?: "Query";
    passwordResetTokenRedeem?: {
        __typename?: "BooleanResponse";
        status: boolean;
    } | null;
};

export type GQPasswordResetRequestMutationVariables = Exact<{
    email: Scalars["String"];
}>;

export type GQPasswordResetRequestMutation = {
    __typename?: "Mutation";
    passwordResetRequest: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQPasswordResetTokenDeleteMutationVariables = Exact<{
    token: Scalars["String"];
}>;

export type GQPasswordResetTokenDeleteMutation = {
    __typename?: "Mutation";
    passwordResetTokenDelete: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQPasswordResetTokenUpdatePasswordMutationVariables = Exact<{
    token: Scalars["String"];
    password: Scalars["String"];
}>;

export type GQPasswordResetTokenUpdatePasswordMutation = {
    __typename?: "Mutation";
    passwordResetTokenUpdatePassword?: {
        __typename?: "BooleanResponse";
        status: boolean;
    } | null;
};

export type GQAllPaymentConfigurationFieldsFragment = {
    __typename?: "PaymentConfiguration";
    id: string;
    name: string;
    createdAt: string;
    paymentMethods: Array<{
        __typename?: "PaymentConfigurationMethod";
        showAsQuickButton: boolean;
        showInPaymentWindow: boolean;
        askForAmount: boolean;
        paymentMethod: {
            __typename?: "PaymentMethod";
            id: string;
            name: string;
            paymentType: string;
            enabled: boolean;
            currency: { __typename?: "Currency"; code: string; rate: number };
        };
    }>;
};

export type GQPaymentConfigurationsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQPaymentConfigurationsQuery = {
    __typename?: "Query";
    paymentConfigurations: {
        __typename?: "PaymentConfigurationPagination";
        data: Array<{
            __typename?: "PaymentConfiguration";
            id: string;
            name: string;
            createdAt: string;
            paymentMethods: Array<{
                __typename?: "PaymentConfigurationMethod";
                showAsQuickButton: boolean;
                showInPaymentWindow: boolean;
                askForAmount: boolean;
                paymentMethod: {
                    __typename?: "PaymentMethod";
                    id: string;
                    name: string;
                    paymentType: string;
                    enabled: boolean;
                    currency: {
                        __typename?: "Currency";
                        code: string;
                        rate: number;
                    };
                };
            }>;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQPaymentConfigurationQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQPaymentConfigurationQuery = {
    __typename?: "Query";
    paymentConfiguration: {
        __typename?: "PaymentConfiguration";
        id: string;
        name: string;
        createdAt: string;
        paymentMethods: Array<{
            __typename?: "PaymentConfigurationMethod";
            showAsQuickButton: boolean;
            showInPaymentWindow: boolean;
            askForAmount: boolean;
            paymentMethod: {
                __typename?: "PaymentMethod";
                id: string;
                name: string;
                paymentType: string;
                enabled: boolean;
                currency: {
                    __typename?: "Currency";
                    code: string;
                    rate: number;
                };
            };
        }>;
    };
};

export type GQPaymentConfigurationCreateMutationVariables = Exact<{
    paymentConfiguration: GQPaymentConfigurationInput;
}>;

export type GQPaymentConfigurationCreateMutation = {
    __typename?: "Mutation";
    paymentConfigurationCreate: {
        __typename?: "PaymentConfiguration";
        id: string;
        name: string;
        createdAt: string;
        paymentMethods: Array<{
            __typename?: "PaymentConfigurationMethod";
            showAsQuickButton: boolean;
            showInPaymentWindow: boolean;
            askForAmount: boolean;
            paymentMethod: {
                __typename?: "PaymentMethod";
                id: string;
                name: string;
                paymentType: string;
                enabled: boolean;
                currency: {
                    __typename?: "Currency";
                    code: string;
                    rate: number;
                };
            };
        }>;
    };
};

export type GQPaymentConfigurationSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    paymentConfiguration: GQPaymentConfigurationInput;
}>;

export type GQPaymentConfigurationSaveMutation = {
    __typename?: "Mutation";
    paymentConfigurationSave: {
        __typename?: "PaymentConfiguration";
        id: string;
        name: string;
        createdAt: string;
        paymentMethods: Array<{
            __typename?: "PaymentConfigurationMethod";
            showAsQuickButton: boolean;
            showInPaymentWindow: boolean;
            askForAmount: boolean;
            paymentMethod: {
                __typename?: "PaymentMethod";
                id: string;
                name: string;
                paymentType: string;
                enabled: boolean;
                currency: {
                    __typename?: "Currency";
                    code: string;
                    rate: number;
                };
            };
        }>;
    };
};

export type GQPaymentConfigurationDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQPaymentConfigurationDeleteMutation = {
    __typename?: "Mutation";
    paymentConfigurationDelete: {
        __typename?: "PaymentConfigurationDeleteResponse";
        status: boolean;
    };
};

export type GQPaymentConfigurationFormQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQPaymentConfigurationFormQuery = {
    __typename?: "Query";
    paymentMethods: {
        __typename?: "PaymentMethodPagination";
        data: Array<{
            __typename?: "PaymentMethod";
            id: string;
            name: string;
            enabled: boolean;
        }>;
    };
};

export type GQAllPaymentMethodFieldsFragment = {
    __typename?: "PaymentMethod";
    id: string;
    name: string;
    paymentType: string;
    enabled: boolean;
    account: string;
    diffAccount: string;
    createdAt: string;
    currency: { __typename?: "Currency"; id: string; code: string };
};

export type GQPaymentMethodsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQPaymentMethodsQuery = {
    __typename?: "Query";
    paymentMethods: {
        __typename?: "PaymentMethodPagination";
        data: Array<{
            __typename?: "PaymentMethod";
            id: string;
            name: string;
            paymentType: string;
            enabled: boolean;
            account: string;
            diffAccount: string;
            createdAt: string;
            currency: { __typename?: "Currency"; id: string; code: string };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQPaymentMethodQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQPaymentMethodQuery = {
    __typename?: "Query";
    paymentMethod: {
        __typename?: "PaymentMethod";
        id: string;
        name: string;
        paymentType: string;
        enabled: boolean;
        account: string;
        diffAccount: string;
        createdAt: string;
        currency: { __typename?: "Currency"; id: string; code: string };
    };
};

export type GQPaymentMethodCreateMutationVariables = Exact<{
    paymentMethod: GQPaymentMethodInput;
}>;

export type GQPaymentMethodCreateMutation = {
    __typename?: "Mutation";
    paymentMethodCreate: {
        __typename?: "PaymentMethod";
        id: string;
        name: string;
        paymentType: string;
        enabled: boolean;
        account: string;
        diffAccount: string;
        createdAt: string;
        currency: { __typename?: "Currency"; id: string; code: string };
    };
};

export type GQPaymentMethodSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    paymentMethod: GQPaymentMethodInput;
}>;

export type GQPaymentMethodSaveMutation = {
    __typename?: "Mutation";
    paymentMethodSave: {
        __typename?: "PaymentMethod";
        id: string;
        name: string;
        paymentType: string;
        enabled: boolean;
        account: string;
        diffAccount: string;
        createdAt: string;
        currency: { __typename?: "Currency"; id: string; code: string };
    };
};

export type GQPaymentMethodDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQPaymentMethodDeleteMutation = {
    __typename?: "Mutation";
    paymentMethodDelete: {
        __typename?: "PaymentMethodDeleteResponse";
        status: boolean;
    };
};

export type GQPaymentMethodFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQPaymentMethodFormQuery = {
    __typename?: "Query";
    currencies: {
        __typename?: "CurrencyPagination";
        data: Array<{ __typename?: "Currency"; id: string; code: string }>;
    };
};

export type GQPrinterScreenFieldsFragment = {
    __typename?: "Printer";
    id: string;
    name: string;
    serial: string;
    type: GQPrinterType;
    manufacturer: GQPrinterManufacturer;
    class: GQPrinterClass;
    createdAt: any;
    cashRegister?: {
        __typename?: "CashRegister";
        id: string;
        name: string;
    } | null;
};

export type GQPrinterWithRelationsFragment = {
    __typename?: "Printer";
    id: string;
    name: string;
    serial: string;
    type: GQPrinterType;
    manufacturer: GQPrinterManufacturer;
    class: GQPrinterClass;
    createdAt: any;
    cashRegister?: {
        __typename?: "CashRegister";
        id: string;
        name: string;
    } | null;
    product: Array<{ __typename?: "Product"; id: string; name: string }>;
    productGroup: Array<{
        __typename?: "ProductGroup";
        id: string;
        name: string;
    }>;
    virtualPrinter: Array<{
        __typename?: "VirtualPrinter";
        id: string;
        name: string;
    }>;
};

export type GQPrinterQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQPrinterQuery = {
    __typename?: "Query";
    printer: {
        __typename?: "Printer";
        id: string;
        name: string;
        serial: string;
        type: GQPrinterType;
        manufacturer: GQPrinterManufacturer;
        class: GQPrinterClass;
        createdAt: any;
        cashRegister?: {
            __typename?: "CashRegister";
            id: string;
            name: string;
        } | null;
    };
};

export type GQPrinterWithRelationsQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQPrinterWithRelationsQuery = {
    __typename?: "Query";
    printer: {
        __typename?: "Printer";
        id: string;
        name: string;
        serial: string;
        type: GQPrinterType;
        manufacturer: GQPrinterManufacturer;
        class: GQPrinterClass;
        createdAt: any;
        cashRegister?: {
            __typename?: "CashRegister";
            id: string;
            name: string;
        } | null;
        product: Array<{ __typename?: "Product"; id: string; name: string }>;
        productGroup: Array<{
            __typename?: "ProductGroup";
            id: string;
            name: string;
        }>;
        virtualPrinter: Array<{
            __typename?: "VirtualPrinter";
            id: string;
            name: string;
        }>;
    };
};

export type GQPrintersQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQPrinterSearchInput>;
}>;

export type GQPrintersQuery = {
    __typename?: "Query";
    printers: {
        __typename?: "PrinterPagination";
        data: Array<{
            __typename?: "Printer";
            id: string;
            name: string;
            serial: string;
            type: GQPrinterType;
            manufacturer: GQPrinterManufacturer;
            class: GQPrinterClass;
            createdAt: any;
            cashRegister?: {
                __typename?: "CashRegister";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQPrintersForCashRegisterQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    class?: InputMaybe<Scalars["String"]>;
    entityId?: InputMaybe<Scalars["String"]>;
}>;

export type GQPrintersForCashRegisterQuery = {
    __typename?: "Query";
    printersForCashRegister: {
        __typename?: "PrinterPagination";
        data: Array<{
            __typename?: "Printer";
            id: string;
            name: string;
            serial: string;
            type: GQPrinterType;
            manufacturer: GQPrinterManufacturer;
            class: GQPrinterClass;
            createdAt: any;
            cashRegister?: {
                __typename?: "CashRegister";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQPrinterRegisterMutationVariables = Exact<{
    printer: GQPrinterRegister;
}>;

export type GQPrinterRegisterMutation = {
    __typename?: "Mutation";
    printerRegister: {
        __typename?: "Printer";
        name: string;
        serial: string;
        type: GQPrinterType;
        manufacturer: GQPrinterManufacturer;
        class: GQPrinterClass;
    };
};

export type GQPrinterSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    printer: GQPrinterSave;
}>;

export type GQPrinterSaveMutation = {
    __typename?: "Mutation";
    printerSave: { __typename?: "Printer"; id: string; name: string };
};

export type GQPrinterDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQPrinterDeleteMutation = {
    __typename?: "Mutation";
    printerDelete: {
        __typename?: "PrinterDeleteResponse";
        status: GQDeleteResponseEnum;
    };
};

export type GQAllProductGroupFieldsFragment = {
    __typename?: "ProductGroup";
    id: string;
    externalId?: string | null;
    name: string;
    color: string;
    excludeFromDiscounts: boolean;
    isExternal: boolean;
    createdAt: any;
    deletedAt?: any | null;
    vat: { __typename?: "Vat"; id: string; name: string; percentage: number };
    printer?: {
        __typename?: "Printer";
        id: string;
        name: string;
        isVirtual?: boolean | null;
    } | null;
};

export type GQProductGroupsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQProductGroupSearchInput>;
}>;

export type GQProductGroupsQuery = {
    __typename?: "Query";
    productGroups: {
        __typename?: "ProductGroupPagination";
        data: Array<{
            __typename?: "ProductGroup";
            id: string;
            externalId?: string | null;
            name: string;
            color: string;
            excludeFromDiscounts: boolean;
            isExternal: boolean;
            createdAt: any;
            deletedAt?: any | null;
            vat: {
                __typename?: "Vat";
                id: string;
                name: string;
                percentage: number;
            };
            printer?: {
                __typename?: "Printer";
                id: string;
                name: string;
                isVirtual?: boolean | null;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQProductGroupQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQProductGroupQuery = {
    __typename?: "Query";
    productGroup?: {
        __typename?: "ProductGroup";
        id: string;
        externalId?: string | null;
        name: string;
        color: string;
        excludeFromDiscounts: boolean;
        isExternal: boolean;
        createdAt: any;
        deletedAt?: any | null;
        vat: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        };
        printer?: {
            __typename?: "Printer";
            id: string;
            name: string;
            isVirtual?: boolean | null;
        } | null;
    } | null;
};

export type GQProductGroupCreateMutationVariables = Exact<{
    productGroup: GQProductGroupInput;
}>;

export type GQProductGroupCreateMutation = {
    __typename?: "Mutation";
    productGroupCreate: {
        __typename?: "ProductGroup";
        id: string;
        externalId?: string | null;
        name: string;
        color: string;
        excludeFromDiscounts: boolean;
        isExternal: boolean;
        createdAt: any;
        deletedAt?: any | null;
        vat: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        };
        printer?: {
            __typename?: "Printer";
            id: string;
            name: string;
            isVirtual?: boolean | null;
        } | null;
    };
};

export type GQProductGroupSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    productGroup: GQProductGroupInput;
}>;

export type GQProductGroupSaveMutation = {
    __typename?: "Mutation";
    productGroupSave: {
        __typename?: "ProductGroup";
        id: string;
        externalId?: string | null;
        name: string;
        color: string;
        excludeFromDiscounts: boolean;
        isExternal: boolean;
        createdAt: any;
        deletedAt?: any | null;
        vat: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        };
        printer?: {
            __typename?: "Printer";
            id: string;
            name: string;
            isVirtual?: boolean | null;
        } | null;
    };
};

export type GQProductGroupDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQProductGroupDeleteMutation = {
    __typename?: "Mutation";
    productGroupDelete: {
        __typename?: "ProductGroupDeleteResponse";
        status: boolean;
    };
};

export type GQSetInventoryProductQuantityMutationVariables = Exact<{
    id?: InputMaybe<Scalars["ID"]>;
    productId: Scalars["ID"];
    quantity: Scalars["Int"];
    note?: InputMaybe<Scalars["String"]>;
}>;

export type GQSetInventoryProductQuantityMutation = {
    __typename?: "Mutation";
    setInventoryProductQuantity: {
        __typename?: "InventoryProduct";
        id: string;
        quantity: number;
    };
};

export type GQAllInventoryProductNoteTemplateFieldsFragment = {
    __typename?: "InventoryProductNoteTemplate";
    id: string;
    note: string;
};

export type GQInventoryProductNoteTemplatesQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQInventoryProductNoteTemplatesQuery = {
    __typename?: "Query";
    inventoryProductNoteTemplates: {
        __typename?: "InventoryProductNoteTemplatePagination";
        data: Array<{
            __typename?: "InventoryProductNoteTemplate";
            id: string;
            note: string;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQInventoryProductNoteTemplateQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQInventoryProductNoteTemplateQuery = {
    __typename?: "Query";
    inventoryProductNoteTemplate?: {
        __typename?: "InventoryProductNoteTemplate";
        id: string;
        note: string;
    } | null;
};

export type GQInventoryProductNoteTemplateCreateMutationVariables = Exact<{
    inventoryProductNoteTemplate: GQInventoryProductNoteTemplateCreate;
}>;

export type GQInventoryProductNoteTemplateCreateMutation = {
    __typename?: "Mutation";
    inventoryProductNoteTemplateCreate: {
        __typename?: "InventoryProductNoteTemplate";
        id: string;
        note: string;
    };
};

export type GQInventoryProductNoteTemplateSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    inventoryProductNoteTemplate: GQInventoryProductNoteTemplateInput;
}>;

export type GQInventoryProductNoteTemplateSaveMutation = {
    __typename?: "Mutation";
    inventoryProductNoteTemplateSave: {
        __typename?: "InventoryProductNoteTemplate";
        id: string;
        note: string;
    };
};

export type GQInventoryProductNoteTemplateDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQInventoryProductNoteTemplateDeleteMutation = {
    __typename?: "Mutation";
    inventoryProductNoteTemplateDelete: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQAllProductFieldsFragment = {
    __typename?: "Product";
    id: string;
    externalId?: string | null;
    name: string;
    amount: number;
    minimumAmount: number;
    costAmount: number;
    onlineRequired: boolean;
    active: boolean;
    isExternal: boolean;
    excludeFromDiscounts: boolean;
    ownExcludeFromDiscounts: boolean;
    barcode?: string | null;
    buttonText?: string | null;
    inheritPrinter: boolean;
    plu?: number | null;
    createdAt: any;
    deletedAt?: any | null;
    parent?: { __typename?: "Product"; id: string; name: string } | null;
    group: {
        __typename?: "ProductGroup";
        id: string;
        name: string;
        color: string;
        vat: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        };
    };
    vat: { __typename?: "Vat"; id: string; name: string; percentage: number };
    ownVat?: {
        __typename?: "Vat";
        id: string;
        name: string;
        percentage: number;
    } | null;
    barcodes: Array<{
        __typename?: "ProductBarcode";
        id: string;
        barcode: string;
    }>;
    inventoryProduct?: {
        __typename?: "InventoryProduct";
        id: string;
        quantity: number;
    } | null;
    printer?: { __typename?: "Printer"; id: string; name: string } | null;
    discountTemplate?: Array<{
        __typename?: "DiscountTemplate";
        name: string;
        type: GQDiscountValueType;
        value: number;
        color?: string | null;
    }> | null;
};

export type GQProductChildrenListFieldsFragment = {
    __typename?: "ProductPagination";
    data: Array<{
        __typename?: "Product";
        id: string;
        name: string;
        amount: number;
    }>;
};

export type GQProductsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    includeChildren?: InputMaybe<Scalars["Boolean"]>;
    includeInactive?: InputMaybe<Scalars["Boolean"]>;
    searching?: InputMaybe<GQProductSearchInput>;
}>;

export type GQProductsQuery = {
    __typename?: "Query";
    products: {
        __typename?: "ProductPagination";
        data: Array<{
            __typename?: "Product";
            id: string;
            externalId?: string | null;
            name: string;
            amount: number;
            minimumAmount: number;
            costAmount: number;
            onlineRequired: boolean;
            active: boolean;
            isExternal: boolean;
            excludeFromDiscounts: boolean;
            ownExcludeFromDiscounts: boolean;
            barcode?: string | null;
            buttonText?: string | null;
            inheritPrinter: boolean;
            plu?: number | null;
            createdAt: any;
            deletedAt?: any | null;
            parent?: {
                __typename?: "Product";
                id: string;
                name: string;
            } | null;
            group: {
                __typename?: "ProductGroup";
                id: string;
                name: string;
                color: string;
                vat: {
                    __typename?: "Vat";
                    id: string;
                    name: string;
                    percentage: number;
                };
            };
            vat: {
                __typename?: "Vat";
                id: string;
                name: string;
                percentage: number;
            };
            ownVat?: {
                __typename?: "Vat";
                id: string;
                name: string;
                percentage: number;
            } | null;
            barcodes: Array<{
                __typename?: "ProductBarcode";
                id: string;
                barcode: string;
            }>;
            inventoryProduct?: {
                __typename?: "InventoryProduct";
                id: string;
                quantity: number;
            } | null;
            printer?: {
                __typename?: "Printer";
                id: string;
                name: string;
            } | null;
            discountTemplate?: Array<{
                __typename?: "DiscountTemplate";
                name: string;
                type: GQDiscountValueType;
                value: number;
                color?: string | null;
            }> | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQProductQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQProductQuery = {
    __typename?: "Query";
    product?: {
        __typename?: "Product";
        id: string;
        externalId?: string | null;
        name: string;
        amount: number;
        minimumAmount: number;
        costAmount: number;
        onlineRequired: boolean;
        active: boolean;
        isExternal: boolean;
        excludeFromDiscounts: boolean;
        ownExcludeFromDiscounts: boolean;
        barcode?: string | null;
        buttonText?: string | null;
        inheritPrinter: boolean;
        plu?: number | null;
        createdAt: any;
        deletedAt?: any | null;
        children: {
            __typename?: "ProductPagination";
            data: Array<{
                __typename?: "Product";
                id: string;
                name: string;
                amount: number;
            }>;
        };
        parent?: { __typename?: "Product"; id: string; name: string } | null;
        group: {
            __typename?: "ProductGroup";
            id: string;
            name: string;
            color: string;
            vat: {
                __typename?: "Vat";
                id: string;
                name: string;
                percentage: number;
            };
        };
        vat: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        };
        ownVat?: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        } | null;
        barcodes: Array<{
            __typename?: "ProductBarcode";
            id: string;
            barcode: string;
        }>;
        inventoryProduct?: {
            __typename?: "InventoryProduct";
            id: string;
            quantity: number;
        } | null;
        printer?: { __typename?: "Printer"; id: string; name: string } | null;
        discountTemplate?: Array<{
            __typename?: "DiscountTemplate";
            name: string;
            type: GQDiscountValueType;
            value: number;
            color?: string | null;
        }> | null;
    } | null;
};

export type GQProductCreateMutationVariables = Exact<{
    product: GQProductInput;
}>;

export type GQProductCreateMutation = {
    __typename?: "Mutation";
    productCreate: {
        __typename?: "Product";
        id: string;
        externalId?: string | null;
        name: string;
        amount: number;
        minimumAmount: number;
        costAmount: number;
        onlineRequired: boolean;
        active: boolean;
        isExternal: boolean;
        excludeFromDiscounts: boolean;
        ownExcludeFromDiscounts: boolean;
        barcode?: string | null;
        buttonText?: string | null;
        inheritPrinter: boolean;
        plu?: number | null;
        createdAt: any;
        deletedAt?: any | null;
        parent?: { __typename?: "Product"; id: string; name: string } | null;
        group: {
            __typename?: "ProductGroup";
            id: string;
            name: string;
            color: string;
            vat: {
                __typename?: "Vat";
                id: string;
                name: string;
                percentage: number;
            };
        };
        vat: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        };
        ownVat?: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        } | null;
        barcodes: Array<{
            __typename?: "ProductBarcode";
            id: string;
            barcode: string;
        }>;
        inventoryProduct?: {
            __typename?: "InventoryProduct";
            id: string;
            quantity: number;
        } | null;
        printer?: { __typename?: "Printer"; id: string; name: string } | null;
        discountTemplate?: Array<{
            __typename?: "DiscountTemplate";
            name: string;
            type: GQDiscountValueType;
            value: number;
            color?: string | null;
        }> | null;
    };
};

export type GQProductSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    product: GQProductInput;
}>;

export type GQProductSaveMutation = {
    __typename?: "Mutation";
    productSave: {
        __typename?: "Product";
        id: string;
        externalId?: string | null;
        name: string;
        amount: number;
        minimumAmount: number;
        costAmount: number;
        onlineRequired: boolean;
        active: boolean;
        isExternal: boolean;
        excludeFromDiscounts: boolean;
        ownExcludeFromDiscounts: boolean;
        barcode?: string | null;
        buttonText?: string | null;
        inheritPrinter: boolean;
        plu?: number | null;
        createdAt: any;
        deletedAt?: any | null;
        parent?: { __typename?: "Product"; id: string; name: string } | null;
        group: {
            __typename?: "ProductGroup";
            id: string;
            name: string;
            color: string;
            vat: {
                __typename?: "Vat";
                id: string;
                name: string;
                percentage: number;
            };
        };
        vat: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        };
        ownVat?: {
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        } | null;
        barcodes: Array<{
            __typename?: "ProductBarcode";
            id: string;
            barcode: string;
        }>;
        inventoryProduct?: {
            __typename?: "InventoryProduct";
            id: string;
            quantity: number;
        } | null;
        printer?: { __typename?: "Printer"; id: string; name: string } | null;
        discountTemplate?: Array<{
            __typename?: "DiscountTemplate";
            name: string;
            type: GQDiscountValueType;
            value: number;
            color?: string | null;
        }> | null;
    };
};

export type GQProductDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQProductDeleteMutation = {
    __typename?: "Mutation";
    productDelete: { __typename?: "ProductDeleteResponse"; status: boolean };
};

export type GQProductsDeleteMutationVariables = Exact<{
    ids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type GQProductsDeleteMutation = {
    __typename?: "Mutation";
    productsDelete: { __typename?: "ProductDeleteResponse"; status: boolean };
};

export type GQIsProductPluInUseQueryVariables = Exact<{
    plu: Scalars["Int"];
    productId?: InputMaybe<Scalars["ID"]>;
}>;

export type GQIsProductPluInUseQuery = {
    __typename?: "Query";
    isProductPluInUse: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQProductFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQProductFormQuery = {
    __typename?: "Query";
    products: {
        __typename?: "ProductPagination";
        data: Array<{ __typename?: "Product"; id: string; name: string }>;
    };
    productGroups: {
        __typename?: "ProductGroupPagination";
        data: Array<{
            __typename?: "ProductGroup";
            id: string;
            name: string;
            vat: { __typename?: "Vat"; id: string };
        }>;
    };
    vats: {
        __typename?: "VatPagination";
        data: Array<{
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
        }>;
    };
    printers: {
        __typename?: "PrinterPagination";
        data: Array<{
            __typename?: "Printer";
            id: string;
            name: string;
            type: GQPrinterType;
            class: GQPrinterClass;
        }>;
    };
    virtualPrinters: {
        __typename?: "VirtualPrinterPagination";
        data: Array<{
            __typename?: "VirtualPrinter";
            id: string;
            name: string;
        }>;
    };
};

export type GQAllViProductFieldsFragment = {
    __typename?: "ViProduct";
    id: string;
    name: string;
    deletedAt?: any | null;
    measurementUnit: Array<{
        __typename?: "MeasurementUnit";
        name: string;
        id: string;
        deletedAt?: any | null;
    }>;
};

export type GQViProductsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQViProductsQuery = {
    __typename?: "Query";
    viProducts: {
        __typename?: "ViProductPagination";
        data: Array<{
            __typename?: "ViProduct";
            id: string;
            name: string;
            deletedAt?: any | null;
            measurementUnit: Array<{
                __typename?: "MeasurementUnit";
                name: string;
                id: string;
                deletedAt?: any | null;
            }>;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQGetProduct2ViProduct2MeasurementUnitQueryVariables = Exact<{
    productId: Scalars["ID"];
}>;

export type GQGetProduct2ViProduct2MeasurementUnitQuery = {
    __typename?: "Query";
    getProduct2ViProduct2MeasurementUnit: Array<{
        __typename?: "Product2ViProduct2MeasurementUnit";
        value: number;
        deletedAt?: any | null;
        viProduct: {
            __typename?: "ViProduct";
            id: string;
            name: string;
            deletedAt?: any | null;
        };
        measurementUnit: {
            __typename?: "MeasurementUnit";
            id: string;
            name: string;
            deletedAt?: any | null;
        };
    }>;
};

export type GQSetProduct2ViProduct2MeasurementUnitMutationVariables = Exact<{
    productId: Scalars["ID"];
    relations:
        | Array<GQProduct2ViProduct2MeasurementUnitInput>
        | GQProduct2ViProduct2MeasurementUnitInput;
}>;

export type GQSetProduct2ViProduct2MeasurementUnitMutation = {
    __typename?: "Mutation";
    setProduct2ViProduct2MeasurementUnit: {
        __typename?: "BooleanResponse";
        status: boolean;
    };
};

export type GQUpdateViProductsMutationVariables = Exact<{
    [key: string]: never;
}>;

export type GQUpdateViProductsMutation = {
    __typename?: "Mutation";
    updateViProducts: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQReportFieldsFragment = {
    __typename?: "ReportParameters";
    users: Array<{
        __typename?: "ReportUser";
        id: string;
        username: string;
        firstName: string;
        lastName: string;
    }>;
    departments: Array<{
        __typename?: "ReportDepartment";
        id: string;
        name: string;
    }>;
    cashRegisters: Array<{
        __typename?: "ReportCashRegister";
        id: string;
        name: string;
    }>;
    productGroups: Array<{
        __typename?: "ReportProductGroup";
        id: string;
        name: string;
    }>;
    products: Array<{ __typename?: "ReportProduct"; id: string; name: string }>;
};

export type GQReportFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQReportFormQuery = {
    __typename?: "Query";
    reportParameters: {
        __typename?: "ReportParameters";
        users: Array<{
            __typename?: "ReportUser";
            id: string;
            username: string;
            firstName: string;
            lastName: string;
        }>;
        departments: Array<{
            __typename?: "ReportDepartment";
            id: string;
            name: string;
        }>;
        cashRegisters: Array<{
            __typename?: "ReportCashRegister";
            id: string;
            name: string;
        }>;
        productGroups: Array<{
            __typename?: "ReportProductGroup";
            id: string;
            name: string;
        }>;
        products: Array<{
            __typename?: "ReportProduct";
            id: string;
            name: string;
        }>;
    };
};

export type GQSaftJobFieldsFragment = {
    __typename?: "SaftJob";
    id: number;
    shiftId?: string | null;
    runAt: any;
    attempts: number;
    lastError?: string | null;
    createdAt: any;
    shift?: {
        __typename?: "ShiftRM";
        id: string;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    } | null;
};

export type GQSaftJobsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQSaftJobsQuery = {
    __typename?: "Query";
    saftJobs: {
        __typename?: "SaftJobPagination";
        data: Array<{
            __typename?: "SaftJob";
            id: number;
            shiftId?: string | null;
            runAt: any;
            attempts: number;
            lastError?: string | null;
            createdAt: any;
            shift?: {
                __typename?: "ShiftRM";
                id: string;
                merchant: { __typename?: "Merchant"; id: string; name: string };
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQRebuildSaftJobsMutationVariables = Exact<{
    shiftIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type GQRebuildSaftJobsMutation = {
    __typename?: "Mutation";
    rebuildSaftJobs: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQAllShiftFieldsFragment = {
    __typename?: "ShiftRM";
    id: string;
    shiftNumber?: number | null;
    cashRegisterName?: string | null;
    openedAt: any;
    closedAt?: any | null;
    discount: number;
    amount: number;
    syncedAt?: any | null;
    syncStatus?: string | null;
    syncDetails?: string | null;
    zReport?: string | null;
    openingAmount?: number | null;
    cashDifference: number;
    numCashDrawerOpen: number;
    cashRegister: {
        __typename?: "CashRegister";
        id: string;
        name: string;
        department?: { __typename?: "Department"; name: string } | null;
    };
    openedByUser: { __typename?: "User"; username: string };
    closedByUser?: { __typename?: "User"; username: string } | null;
    funds?: Array<{
        __typename?: "ShiftFundsRM";
        name?: string | null;
        type: string;
        amount: number;
        createdAt: any;
    }> | null;
    payments?: Array<{
        __typename?: "ShiftPaymentRM";
        id: string;
        name: string;
        paymentMethodId?: string | null;
        type: string;
        amount: number;
        currency?: string | null;
        currencyRate?: number | null;
        event: GQShiftPaymentRmEvent;
        cardSchemas?: Array<{
            __typename?: "ShiftPaymentCardRM";
            name: string;
            amount: number;
            count: number;
        }> | null;
    }> | null;
    salesData?: {
        __typename?: "ShiftSalesData";
        byProductGroup?: Array<{
            __typename?: "ShiftSalesDataByProductGroup";
            name: string;
            amount: number;
        }> | null;
        hourSales?: Array<{
            __typename?: "InvoiceHourSales";
            date: any;
            count: number;
            amount: number;
        }> | null;
    } | null;
    cashInfoPerMethod?: {
        __typename?: "CashInfoPerMethod";
        cashDifferencePerMethod?: Array<{
            __typename?: "CashDifferencePerMethod";
            name: string;
            paymentMethodId: string;
            amount: number;
            currencyCode: string;
            currencyRate: number;
        }> | null;
        cashSalePerMethod?: Array<{
            __typename?: "CashSalePerMethod";
            name: string;
            paymentMethodId: string;
            amount: number;
            currencyCode: string;
            currencyRate: number;
        }> | null;
    } | null;
};

export type GQShiftsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQShiftSearchInput>;
}>;

export type GQShiftsQuery = {
    __typename?: "Query";
    shifts: {
        __typename?: "ShiftRMPagination";
        data: Array<{
            __typename?: "ShiftRM";
            id: string;
            shiftNumber?: number | null;
            cashRegisterName?: string | null;
            openedAt: any;
            closedAt?: any | null;
            discount: number;
            amount: number;
            syncedAt?: any | null;
            syncStatus?: string | null;
            syncDetails?: string | null;
            zReport?: string | null;
            openingAmount?: number | null;
            cashDifference: number;
            numCashDrawerOpen: number;
            cashRegister: {
                __typename?: "CashRegister";
                id: string;
                name: string;
                department?: { __typename?: "Department"; name: string } | null;
            };
            openedByUser: { __typename?: "User"; username: string };
            closedByUser?: { __typename?: "User"; username: string } | null;
            funds?: Array<{
                __typename?: "ShiftFundsRM";
                name?: string | null;
                type: string;
                amount: number;
                createdAt: any;
            }> | null;
            payments?: Array<{
                __typename?: "ShiftPaymentRM";
                id: string;
                name: string;
                paymentMethodId?: string | null;
                type: string;
                amount: number;
                currency?: string | null;
                currencyRate?: number | null;
                event: GQShiftPaymentRmEvent;
                cardSchemas?: Array<{
                    __typename?: "ShiftPaymentCardRM";
                    name: string;
                    amount: number;
                    count: number;
                }> | null;
            }> | null;
            salesData?: {
                __typename?: "ShiftSalesData";
                byProductGroup?: Array<{
                    __typename?: "ShiftSalesDataByProductGroup";
                    name: string;
                    amount: number;
                }> | null;
                hourSales?: Array<{
                    __typename?: "InvoiceHourSales";
                    date: any;
                    count: number;
                    amount: number;
                }> | null;
            } | null;
            cashInfoPerMethod?: {
                __typename?: "CashInfoPerMethod";
                cashDifferencePerMethod?: Array<{
                    __typename?: "CashDifferencePerMethod";
                    name: string;
                    paymentMethodId: string;
                    amount: number;
                    currencyCode: string;
                    currencyRate: number;
                }> | null;
                cashSalePerMethod?: Array<{
                    __typename?: "CashSalePerMethod";
                    name: string;
                    paymentMethodId: string;
                    amount: number;
                    currencyCode: string;
                    currencyRate: number;
                }> | null;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQShiftQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQShiftQuery = {
    __typename?: "Query";
    shift?: {
        __typename?: "ShiftRM";
        id: string;
        shiftNumber?: number | null;
        cashRegisterName?: string | null;
        openedAt: any;
        closedAt?: any | null;
        discount: number;
        amount: number;
        syncedAt?: any | null;
        syncStatus?: string | null;
        syncDetails?: string | null;
        zReport?: string | null;
        openingAmount?: number | null;
        cashDifference: number;
        numCashDrawerOpen: number;
        cashRegister: {
            __typename?: "CashRegister";
            id: string;
            name: string;
            department?: { __typename?: "Department"; name: string } | null;
        };
        openedByUser: { __typename?: "User"; username: string };
        closedByUser?: { __typename?: "User"; username: string } | null;
        funds?: Array<{
            __typename?: "ShiftFundsRM";
            name?: string | null;
            type: string;
            amount: number;
            createdAt: any;
        }> | null;
        payments?: Array<{
            __typename?: "ShiftPaymentRM";
            id: string;
            name: string;
            paymentMethodId?: string | null;
            type: string;
            amount: number;
            currency?: string | null;
            currencyRate?: number | null;
            event: GQShiftPaymentRmEvent;
            cardSchemas?: Array<{
                __typename?: "ShiftPaymentCardRM";
                name: string;
                amount: number;
                count: number;
            }> | null;
        }> | null;
        salesData?: {
            __typename?: "ShiftSalesData";
            byProductGroup?: Array<{
                __typename?: "ShiftSalesDataByProductGroup";
                name: string;
                amount: number;
            }> | null;
            hourSales?: Array<{
                __typename?: "InvoiceHourSales";
                date: any;
                count: number;
                amount: number;
            }> | null;
        } | null;
        cashInfoPerMethod?: {
            __typename?: "CashInfoPerMethod";
            cashDifferencePerMethod?: Array<{
                __typename?: "CashDifferencePerMethod";
                name: string;
                paymentMethodId: string;
                amount: number;
                currencyCode: string;
                currencyRate: number;
            }> | null;
            cashSalePerMethod?: Array<{
                __typename?: "CashSalePerMethod";
                name: string;
                paymentMethodId: string;
                amount: number;
                currencyCode: string;
                currencyRate: number;
            }> | null;
        } | null;
    } | null;
};

export type GQShiftsInPeriodQueryVariables = Exact<{
    from: Scalars["Date"];
    to: Scalars["Date"];
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQShiftsInPeriodQuery = {
    __typename?: "Query";
    shiftsInPeriod: {
        __typename?: "ShiftRMPagination";
        data: Array<{
            __typename?: "ShiftRM";
            id: string;
            shiftNumber?: number | null;
            cashRegisterName?: string | null;
            openedAt: any;
            closedAt?: any | null;
            discount: number;
            amount: number;
            syncedAt?: any | null;
            syncStatus?: string | null;
            syncDetails?: string | null;
            zReport?: string | null;
            openingAmount?: number | null;
            cashDifference: number;
            numCashDrawerOpen: number;
            cashRegister: {
                __typename?: "CashRegister";
                id: string;
                name: string;
                department?: { __typename?: "Department"; name: string } | null;
            };
            openedByUser: { __typename?: "User"; username: string };
            closedByUser?: { __typename?: "User"; username: string } | null;
            funds?: Array<{
                __typename?: "ShiftFundsRM";
                name?: string | null;
                type: string;
                amount: number;
                createdAt: any;
            }> | null;
            payments?: Array<{
                __typename?: "ShiftPaymentRM";
                id: string;
                name: string;
                paymentMethodId?: string | null;
                type: string;
                amount: number;
                currency?: string | null;
                currencyRate?: number | null;
                event: GQShiftPaymentRmEvent;
                cardSchemas?: Array<{
                    __typename?: "ShiftPaymentCardRM";
                    name: string;
                    amount: number;
                    count: number;
                }> | null;
            }> | null;
            salesData?: {
                __typename?: "ShiftSalesData";
                byProductGroup?: Array<{
                    __typename?: "ShiftSalesDataByProductGroup";
                    name: string;
                    amount: number;
                }> | null;
                hourSales?: Array<{
                    __typename?: "InvoiceHourSales";
                    date: any;
                    count: number;
                    amount: number;
                }> | null;
            } | null;
            cashInfoPerMethod?: {
                __typename?: "CashInfoPerMethod";
                cashDifferencePerMethod?: Array<{
                    __typename?: "CashDifferencePerMethod";
                    name: string;
                    paymentMethodId: string;
                    amount: number;
                    currencyCode: string;
                    currencyRate: number;
                }> | null;
                cashSalePerMethod?: Array<{
                    __typename?: "CashSalePerMethod";
                    name: string;
                    paymentMethodId: string;
                    amount: number;
                    currencyCode: string;
                    currencyRate: number;
                }> | null;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQAddEconomicSyncJobsMutationVariables = Exact<{
    ids?: InputMaybe<Array<Scalars["ID"]> | Scalars["ID"]>;
    integrationId: Scalars["ID"];
    voucherText?: InputMaybe<Scalars["String"]>;
}>;

export type GQAddEconomicSyncJobsMutation = {
    __typename?: "Mutation";
    addEconomicSyncJobs: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQSoftpayMiaMerchantsQueryVariables = Exact<{
    acquirer: GQSoftpayAcquirer;
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQSoftpayMiaMerchantsQuery = {
    __typename?: "Query";
    softpayMiaMerchants: {
        __typename?: "SoftpayMiaMerchantsPagination";
        data: Array<{
            __typename?: "SoftpayMiaMerchant";
            merchantId: string;
            businessRegNo: string;
            merchantName: string;
            primaryContactEmail: string;
            primaryContactPhone: string;
            countryCode: string;
            state: string;
            aidGroup?: string | null;
            localPrivileges: Array<string | null>;
            remotePrivileges: Array<string | null>;
            merchantReference?: string | null;
            stores: Array<{
                __typename?: "SoftpayMiaStore";
                storeId: string;
                businessRegNo?: string | null;
                name: string;
                addressLine1: string;
                addressLine2?: string | null;
                zipCode: string;
                city: string;
                phone?: string | null;
                cardAcceptorCountryCode: string;
                cardAcceptorNameLocation?: string | null;
                onlineStoreId?: string | null;
                state: string;
                timeZone?: string | null;
            } | null>;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQSoftpayMiaMerchantQueryVariables = Exact<{
    acquirer: GQSoftpayAcquirer;
    merchantId: Scalars["String"];
}>;

export type GQSoftpayMiaMerchantQuery = {
    __typename?: "Query";
    softpayMiaMerchant: {
        __typename?: "SoftpayMiaMerchant";
        merchantId: string;
        businessRegNo: string;
        merchantName: string;
        primaryContactEmail: string;
        primaryContactPhone: string;
        countryCode: string;
        state: string;
        aidGroup?: string | null;
        localPrivileges: Array<string | null>;
        remotePrivileges: Array<string | null>;
        merchantReference?: string | null;
        stores: Array<{
            __typename?: "SoftpayMiaStore";
            storeId: string;
            businessRegNo?: string | null;
            name: string;
            addressLine1: string;
            addressLine2?: string | null;
            zipCode: string;
            city: string;
            phone?: string | null;
            state: string;
        } | null>;
    };
};

export type GQSoftpayMiaStoreQueryVariables = Exact<{
    acquirer: GQSoftpayAcquirer;
    merchantId: Scalars["String"];
    storeId: Scalars["String"];
}>;

export type GQSoftpayMiaStoreQuery = {
    __typename?: "Query";
    softpayMiaStore: {
        __typename?: "SoftpayMiaStore";
        storeId: string;
        businessRegNo?: string | null;
        name: string;
        addressLine1: string;
        addressLine2?: string | null;
        zipCode: string;
        city: string;
        phone?: string | null;
        cardAcceptorCountryCode: string;
        cardAcceptorNameLocation?: string | null;
        onlineStoreId?: string | null;
        state: string;
        timeZone?: string | null;
        additionalData?: Array<{
            __typename?: "SoftpayMiaAdditionalData";
            key?: string | null;
            value?: string | null;
        }> | null;
        terminals: Array<{
            __typename?: "SoftpayMiaTerminal";
            terminalId: string;
            onlineTerminalId?: string | null;
            merchantCategoryCode?: string | null;
            defaultCurrencyCode: string;
            onlineMerchantId?: string | null;
            state: string;
            profileName?: string | null;
            installed?: boolean | null;
            takenAt?: string | null;
            releasedAt?: string | null;
            lastOnline?: string | null;
            appId?: string | null;
        } | null>;
    };
};

export type GQSoftpayMiaTerminalQueryVariables = Exact<{
    acquirer: GQSoftpayAcquirer;
    merchantId: Scalars["String"];
    storeId: Scalars["String"];
    terminalId: Scalars["String"];
}>;

export type GQSoftpayMiaTerminalQuery = {
    __typename?: "Query";
    softpayMiaTerminal: {
        __typename?: "SoftpayMiaTerminal";
        terminalId: string;
        onlineTerminalId?: string | null;
        merchantCategoryCode?: string | null;
        defaultCurrencyCode: string;
        onlineMerchantId?: string | null;
        publicKeySetId?: string | null;
        kernelDataId?: string | null;
        state: string;
        profileName?: string | null;
        installed?: boolean | null;
        takenAt?: string | null;
        releasedAt?: string | null;
        lastOnline?: string | null;
        appId?: string | null;
        softpayTerminalId?: string | null;
        additionalData?: Array<{
            __typename?: "SoftpayMiaAdditionalData";
            key?: string | null;
            value?: string | null;
        }> | null;
        processorData?: {
            __typename?: "SoftpayMiaProcessorData";
            cardSchema?: string | null;
            processorName?: string | null;
            processorTerminalId?: string | null;
            processorMerchantId?: string | null;
        } | null;
    };
};

export type GQReleaseTerminalMutationVariables = Exact<{
    acquirer: GQSoftpayAcquirer;
    merchantId: Scalars["String"];
    storeId: Scalars["String"];
    terminalId: Scalars["String"];
}>;

export type GQReleaseTerminalMutation = {
    __typename?: "Mutation";
    releaseTerminal: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQSoftpayMerchantFieldsFragment = {
    __typename?: "SoftpayMerchant";
    name?: string | null;
    businessRegistrationNumber?: string | null;
    merchantReference?: string | null;
};

export type GQSoftpayMerchantsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQSoftpayMerchantsQuery = {
    __typename?: "Query";
    softpayMerchants: {
        __typename?: "SoftpayMerchantsPagination";
        data: Array<{
            __typename?: "SoftpayMerchant";
            name?: string | null;
            businessRegistrationNumber?: string | null;
            merchantReference?: string | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQTagGroupScreenFieldsFragment = {
    __typename?: "TagGroup";
    id: string;
    name: string;
};

export type GQTagGroupsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQTagGroupSearchInput>;
}>;

export type GQTagGroupsQuery = {
    __typename?: "Query";
    tagGroups: {
        __typename?: "TagGroupPagination";
        data: Array<{ __typename?: "TagGroup"; id: string; name: string }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQTagGroupQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQTagGroupQuery = {
    __typename?: "Query";
    tagGroup: { __typename?: "TagGroup"; id: string; name: string };
};

export type GQTagGroupCreateMutationVariables = Exact<{
    tagGroup: GQTagGroupInput;
}>;

export type GQTagGroupCreateMutation = {
    __typename?: "Mutation";
    tagGroupCreate: { __typename?: "TagGroup"; id: string; name: string };
};

export type GQTagGroupSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    tagGroup: GQTagGroupInput;
}>;

export type GQTagGroupSaveMutation = {
    __typename?: "Mutation";
    tagGroupSave: { __typename?: "TagGroup"; id: string; name: string };
};

export type GQTagGroupDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQTagGroupDeleteMutation = {
    __typename?: "Mutation";
    tagGroupDelete: { __typename?: "TagGroupDeleteResponse"; status: boolean };
};

export type GQTagScreenFieldsFragment = {
    __typename?: "Tag";
    id: string;
    identifier: string;
    name?: string | null;
    tagType: string;
    createdAt: any;
    group?: { __typename?: "TagGroup"; id: string; name: string } | null;
    account?: { __typename?: "Account"; id: string; name: string } | null;
    customer?: { __typename?: "Customer"; id: string; name: string } | null;
};

export type GQTagNameFieldsFragment = {
    __typename?: "Tag";
    id: string;
    identifier: string;
    name?: string | null;
};

export type GQTagsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
    tagIds?: InputMaybe<Array<Scalars["ID"]> | Scalars["ID"]>;
    searching?: InputMaybe<GQTagSearchInput>;
}>;

export type GQTagsQuery = {
    __typename?: "Query";
    tags: {
        __typename?: "TagPagination";
        data: Array<{
            __typename?: "Tag";
            id: string;
            identifier: string;
            name?: string | null;
            tagType: string;
            createdAt: any;
            group?: {
                __typename?: "TagGroup";
                id: string;
                name: string;
            } | null;
            account?: {
                __typename?: "Account";
                id: string;
                name: string;
            } | null;
            customer?: {
                __typename?: "Customer";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQTagsWithoutAccountQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
}>;

export type GQTagsWithoutAccountQuery = {
    __typename?: "Query";
    tagsWithoutAccount: {
        __typename?: "TagPagination";
        data: Array<{
            __typename?: "Tag";
            id: string;
            identifier: string;
            name?: string | null;
            tagType: string;
            createdAt: any;
            group?: {
                __typename?: "TagGroup";
                id: string;
                name: string;
            } | null;
            account?: {
                __typename?: "Account";
                id: string;
                name: string;
            } | null;
            customer?: {
                __typename?: "Customer";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQTagsWithoutCustomerQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
}>;

export type GQTagsWithoutCustomerQuery = {
    __typename?: "Query";
    tagsWithoutCustomer: {
        __typename?: "TagPagination";
        data: Array<{
            __typename?: "Tag";
            id: string;
            identifier: string;
            name?: string | null;
            tagType: string;
            createdAt: any;
            group?: {
                __typename?: "TagGroup";
                id: string;
                name: string;
            } | null;
            account?: {
                __typename?: "Account";
                id: string;
                name: string;
            } | null;
            customer?: {
                __typename?: "Customer";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQTagsByGroupQueryVariables = Exact<{
    groupId: Scalars["ID"];
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
}>;

export type GQTagsByGroupQuery = {
    __typename?: "Query";
    tagsByGroup: {
        __typename?: "TagPagination";
        data: Array<{
            __typename?: "Tag";
            id: string;
            identifier: string;
            name?: string | null;
            tagType: string;
            createdAt: any;
            group?: {
                __typename?: "TagGroup";
                id: string;
                name: string;
            } | null;
            account?: {
                __typename?: "Account";
                id: string;
                name: string;
            } | null;
            customer?: {
                __typename?: "Customer";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQTagsByCustomerQueryVariables = Exact<{
    customerId: Scalars["ID"];
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
}>;

export type GQTagsByCustomerQuery = {
    __typename?: "Query";
    tagsByCustomer: {
        __typename?: "TagPagination";
        data: Array<{
            __typename?: "Tag";
            id: string;
            identifier: string;
            name?: string | null;
            tagType: string;
            createdAt: any;
            group?: {
                __typename?: "TagGroup";
                id: string;
                name: string;
            } | null;
            account?: {
                __typename?: "Account";
                id: string;
                name: string;
            } | null;
            customer?: {
                __typename?: "Customer";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQTagsByAccountQueryVariables = Exact<{
    accountId: Scalars["ID"];
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
}>;

export type GQTagsByAccountQuery = {
    __typename?: "Query";
    tagsByAccount: {
        __typename?: "TagPagination";
        data: Array<{
            __typename?: "Tag";
            id: string;
            identifier: string;
            name?: string | null;
            tagType: string;
            createdAt: any;
            group?: {
                __typename?: "TagGroup";
                id: string;
                name: string;
            } | null;
            account?: {
                __typename?: "Account";
                id: string;
                name: string;
            } | null;
            customer?: {
                __typename?: "Customer";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQTagQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQTagQuery = {
    __typename?: "Query";
    tag: {
        __typename?: "Tag";
        id: string;
        identifier: string;
        name?: string | null;
        tagType: string;
        createdAt: any;
        actionsForTag: {
            __typename?: "TagActionPagination";
            data: Array<{
                __typename?: "TagAction";
                action: string;
                createdAt: any;
                accountId: string;
                accountName: string;
                userName: string;
            }>;
            pagination: {
                __typename?: "Pagination";
                pages: number;
                sort: string;
                sortDirection: string;
                resultCount: number;
            };
        };
        group?: { __typename?: "TagGroup"; id: string; name: string } | null;
        account?: { __typename?: "Account"; id: string; name: string } | null;
        customer?: { __typename?: "Customer"; id: string; name: string } | null;
    };
};

export type GQTagCreateMutationVariables = Exact<{
    tag: GQTagInput;
}>;

export type GQTagCreateMutation = {
    __typename?: "Mutation";
    tagCreate: {
        __typename?: "Tag";
        id: string;
        identifier: string;
        name?: string | null;
        tagType: string;
        createdAt: any;
        group?: { __typename?: "TagGroup"; id: string; name: string } | null;
        account?: { __typename?: "Account"; id: string; name: string } | null;
        customer?: { __typename?: "Customer"; id: string; name: string } | null;
    };
};

export type GQTagSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    tag: GQTagInput;
}>;

export type GQTagSaveMutation = {
    __typename?: "Mutation";
    tagSave: {
        __typename?: "Tag";
        id: string;
        identifier: string;
        name?: string | null;
        tagType: string;
        createdAt: any;
        group?: { __typename?: "TagGroup"; id: string; name: string } | null;
        account?: { __typename?: "Account"; id: string; name: string } | null;
        customer?: { __typename?: "Customer"; id: string; name: string } | null;
    };
};

export type GQTagDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQTagDeleteMutation = {
    __typename?: "Mutation";
    tagDelete: { __typename?: "TagDeleteResponse"; status: boolean };
};

export type GQTagFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQTagFormQuery = {
    __typename?: "Query";
    tags: {
        __typename?: "TagPagination";
        data: Array<{
            __typename?: "Tag";
            id: string;
            identifier: string;
            name?: string | null;
        }>;
    };
    tagGroups: {
        __typename?: "TagGroupPagination";
        data: Array<{ __typename?: "TagGroup"; id: string; name: string }>;
    };
};

export type GQTaskResultFieldsFragment = {
    __typename?: "TaskResult";
    jobId: string;
    name?: string | null;
    type: string;
    status: string;
    output?: string | null;
    executionTime: number;
    createdAt: any;
};

export type GQTaskResultsQueryVariables = Exact<{
    type: Scalars["String"];
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQTaskResultsQuery = {
    __typename?: "Query";
    taskResults: {
        __typename?: "TaskResultPagination";
        data: Array<{
            __typename?: "TaskResult";
            jobId: string;
            name?: string | null;
            type: string;
            status: string;
            output?: string | null;
            executionTime: number;
            createdAt: any;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQLatestTaskResultsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQLatestTaskResultsQuery = {
    __typename?: "Query";
    latestTaskResults: {
        __typename?: "TaskResultPagination";
        data: Array<{
            __typename?: "TaskResult";
            jobId: string;
            name?: string | null;
            type: string;
            status: string;
            output?: string | null;
            executionTime: number;
            createdAt: any;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQAllRoleFieldsFragment = {
    __typename?: "Role";
    id: string;
    name: string;
    shared: boolean;
    merchant?: { __typename?: "Merchant"; id: string; name: string } | null;
};

export type GQRolesQueryVariables = Exact<{
    pagination: GQPaginationInput;
}>;

export type GQRolesQuery = {
    __typename?: "Query";
    roles: {
        __typename?: "RolePagination";
        data: Array<{
            __typename?: "Role";
            id: string;
            name: string;
            shared: boolean;
            merchant?: {
                __typename?: "Merchant";
                id: string;
                name: string;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQRoleEditFormQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQRoleEditFormQuery = {
    __typename?: "Query";
    role?: {
        __typename?: "Role";
        id: string;
        name: string;
        type: GQRoleTypeEnum;
        shared: boolean;
        inUse: boolean;
        merchant?: { __typename?: "Merchant"; id: string; name: string } | null;
        permissions: Array<{
            __typename?: "RolePermission";
            key: string;
            value: string;
        }>;
    } | null;
};

export type GQRoleCreateMutationVariables = Exact<{
    role: GQRoleInput;
}>;

export type GQRoleCreateMutation = {
    __typename?: "Mutation";
    roleCreate: {
        __typename?: "Role";
        id: string;
        name: string;
        shared: boolean;
        merchant?: { __typename?: "Merchant"; id: string; name: string } | null;
    };
};

export type GQRoleSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    role: GQRoleInput;
}>;

export type GQRoleSaveMutation = {
    __typename?: "Mutation";
    roleSave: {
        __typename?: "Role";
        id: string;
        name: string;
        shared: boolean;
        merchant?: { __typename?: "Merchant"; id: string; name: string } | null;
    };
};

export type GQRoleDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQRoleDeleteMutation = {
    __typename?: "Mutation";
    roleDelete: { __typename?: "RoleDeleteResponse"; status: boolean };
};

export type GQUserFragment = {
    __typename?: "User";
    id: string;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    active: boolean;
    pin?: string | null;
    requireLoginPin: boolean;
    requireLogoutPin: boolean;
    requirePasswordChange: boolean;
    externalId?: string | null;
    createdAt: any;
    roles: Array<{
        __typename?: "UserRole";
        role: {
            __typename?: "Role";
            id: string;
            name: string;
            type: GQRoleTypeEnum;
        };
        merchant?: { __typename?: "Merchant"; id: string; name: string } | null;
    }>;
};

export type GQUsersQueryVariables = Exact<{
    pagination: GQPaginationInput;
    search?: InputMaybe<GQSearchInput>;
    searching?: InputMaybe<GQUserSearchInput>;
}>;

export type GQUsersQuery = {
    __typename?: "Query";
    users: {
        __typename?: "UserPagination";
        data: Array<{
            __typename?: "User";
            id: string;
            username: string;
            email: string;
            firstName: string;
            lastName: string;
            active: boolean;
            pin?: string | null;
            requireLoginPin: boolean;
            requireLogoutPin: boolean;
            requirePasswordChange: boolean;
            externalId?: string | null;
            createdAt: any;
            roles: Array<{
                __typename?: "UserRole";
                role: {
                    __typename?: "Role";
                    id: string;
                    name: string;
                    type: GQRoleTypeEnum;
                };
                merchant?: {
                    __typename?: "Merchant";
                    id: string;
                    name: string;
                } | null;
            }>;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQUserQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQUserQuery = {
    __typename?: "Query";
    user?: {
        __typename?: "User";
        id: string;
        username: string;
        email: string;
        firstName: string;
        lastName: string;
        active: boolean;
        pin?: string | null;
        requireLoginPin: boolean;
        requireLogoutPin: boolean;
        requirePasswordChange: boolean;
        externalId?: string | null;
        createdAt: any;
        roles: Array<{
            __typename?: "UserRole";
            role: {
                __typename?: "Role";
                id: string;
                name: string;
                type: GQRoleTypeEnum;
            };
            merchant?: {
                __typename?: "Merchant";
                id: string;
                name: string;
            } | null;
        }>;
    } | null;
};

export type GQUserFormRolesFieldsFragment = {
    __typename?: "Role";
    id: string;
    name: string;
    type: GQRoleTypeEnum;
    merchant?: { __typename?: "Merchant"; id: string; name: string } | null;
};

export type GQUserCreateFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQUserCreateFormQuery = {
    __typename?: "Query";
    roles: {
        __typename?: "RolePagination";
        data: Array<{
            __typename?: "Role";
            id: string;
            name: string;
            type: GQRoleTypeEnum;
            merchant?: {
                __typename?: "Merchant";
                id: string;
                name: string;
            } | null;
        }>;
    };
};

export type GQUserEditFormQueryVariables = Exact<{
    userId: Scalars["ID"];
}>;

export type GQUserEditFormQuery = {
    __typename?: "Query";
    user?: {
        __typename?: "User";
        id: string;
        username: string;
        email: string;
        firstName: string;
        lastName: string;
        active: boolean;
        pin?: string | null;
        requireLoginPin: boolean;
        requireLogoutPin: boolean;
        requirePasswordChange: boolean;
        externalId?: string | null;
        createdAt: any;
        roles: Array<{
            __typename?: "UserRole";
            role: {
                __typename?: "Role";
                id: string;
                name: string;
                type: GQRoleTypeEnum;
            };
            merchant?: {
                __typename?: "Merchant";
                id: string;
                name: string;
            } | null;
        }>;
    } | null;
    roles: {
        __typename?: "RolePagination";
        data: Array<{
            __typename?: "Role";
            id: string;
            name: string;
            type: GQRoleTypeEnum;
            merchant?: {
                __typename?: "Merchant";
                id: string;
                name: string;
            } | null;
        }>;
    };
};

export type GQUsernameAvailabilityQueryVariables = Exact<{
    username: Scalars["String"];
}>;

export type GQUsernameAvailabilityQuery = {
    __typename?: "Query";
    userAvailability: boolean;
};

export type GQUserCreateMutationVariables = Exact<{
    user: GQUserInput;
}>;

export type GQUserCreateMutation = {
    __typename?: "Mutation";
    userCreate: {
        __typename?: "User";
        id: string;
        username: string;
        email: string;
        firstName: string;
        lastName: string;
        active: boolean;
        pin?: string | null;
        requireLoginPin: boolean;
        requireLogoutPin: boolean;
        requirePasswordChange: boolean;
        externalId?: string | null;
        createdAt: any;
        roles: Array<{
            __typename?: "UserRole";
            role: {
                __typename?: "Role";
                id: string;
                name: string;
                type: GQRoleTypeEnum;
            };
            merchant?: {
                __typename?: "Merchant";
                id: string;
                name: string;
            } | null;
        }>;
    };
};

export type GQUserSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    user: GQUserInput;
}>;

export type GQUserSaveMutation = {
    __typename?: "Mutation";
    userSave: {
        __typename?: "User";
        id: string;
        username: string;
        email: string;
        firstName: string;
        lastName: string;
        active: boolean;
        pin?: string | null;
        requireLoginPin: boolean;
        requireLogoutPin: boolean;
        requirePasswordChange: boolean;
        externalId?: string | null;
        createdAt: any;
        roles: Array<{
            __typename?: "UserRole";
            role: {
                __typename?: "Role";
                id: string;
                name: string;
                type: GQRoleTypeEnum;
            };
            merchant?: {
                __typename?: "Merchant";
                id: string;
                name: string;
            } | null;
        }>;
    };
};

export type GQUserDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQUserDeleteMutation = {
    __typename?: "Mutation";
    userDelete: { __typename?: "UserDeleteResponse"; status: boolean };
};

export type GQUserUpdatePasswordMutationVariables = Exact<{
    id: Scalars["ID"];
    password: Scalars["String"];
}>;

export type GQUserUpdatePasswordMutation = {
    __typename?: "Mutation";
    userUpdatePassword: { __typename?: "BooleanResponse"; status: boolean };
};

export type GQVatScreenFieldsFragment = {
    __typename?: "Vat";
    id: string;
    name: string;
    percentage: number;
    isExternal?: boolean | null;
    externalId?: string | null;
    createdAt: any;
    merchant: { __typename?: "Merchant"; id: string; name: string };
};

export type GQVatQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQVatQuery = {
    __typename?: "Query";
    vat?: {
        __typename?: "Vat";
        id: string;
        name: string;
        percentage: number;
        isExternal?: boolean | null;
        externalId?: string | null;
        createdAt: any;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    } | null;
};

export type GQVatsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQVatsQuery = {
    __typename?: "Query";
    vats: {
        __typename?: "VatPagination";
        data: Array<{
            __typename?: "Vat";
            id: string;
            name: string;
            percentage: number;
            isExternal?: boolean | null;
            externalId?: string | null;
            createdAt: any;
            merchant: { __typename?: "Merchant"; id: string; name: string };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQVatCreateMutationVariables = Exact<{
    vat: GQVatCreateInput;
}>;

export type GQVatCreateMutation = {
    __typename?: "Mutation";
    vatCreate: {
        __typename?: "Vat";
        id: string;
        name: string;
        percentage: number;
        isExternal?: boolean | null;
        externalId?: string | null;
        createdAt: any;
        merchant: { __typename?: "Merchant"; id: string; name: string };
    };
};

export type GQVatDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQVatDeleteMutation = {
    __typename?: "Mutation";
    vatDelete: { __typename?: "VatDeleteResponse"; status: boolean };
};

export type GQVatFormQueryVariables = Exact<{ [key: string]: never }>;

export type GQVatFormQuery = {
    __typename?: "Query";
    vats: {
        __typename?: "VatPagination";
        data: Array<{ __typename?: "Vat"; id: string; percentage: number }>;
    };
};

export type GQVirtualPrinterScreenFieldsFragment = {
    __typename?: "VirtualPrinter";
    id: string;
    name: string;
    createdAt: any;
    printer: { __typename?: "Printer"; id: string; name: string };
    departments?: Array<{
        __typename?: "VirtualPrinterDepartment";
        department: { __typename?: "Department"; id: string; name: string };
        printer?: {
            __typename?: "Printer";
            id: string;
            name: string;
            manufacturer: GQPrinterManufacturer;
        } | null;
    }> | null;
};

export type GQVirtualPrinterQueryVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQVirtualPrinterQuery = {
    __typename?: "Query";
    virtualPrinter: {
        __typename?: "VirtualPrinter";
        id: string;
        name: string;
        createdAt: any;
        printer: { __typename?: "Printer"; id: string; name: string };
        departments?: Array<{
            __typename?: "VirtualPrinterDepartment";
            department: { __typename?: "Department"; id: string; name: string };
            printer?: {
                __typename?: "Printer";
                id: string;
                name: string;
                manufacturer: GQPrinterManufacturer;
            } | null;
        }> | null;
    };
};

export type GQVirtualPrintersQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    searching?: InputMaybe<GQPrinterSearchInput>;
}>;

export type GQVirtualPrintersQuery = {
    __typename?: "Query";
    virtualPrinters: {
        __typename?: "VirtualPrinterPagination";
        data: Array<{
            __typename?: "VirtualPrinter";
            id: string;
            name: string;
            createdAt: any;
            printer: { __typename?: "Printer"; id: string; name: string };
            departments?: Array<{
                __typename?: "VirtualPrinterDepartment";
                department: {
                    __typename?: "Department";
                    id: string;
                    name: string;
                };
                printer?: {
                    __typename?: "Printer";
                    id: string;
                    name: string;
                    manufacturer: GQPrinterManufacturer;
                } | null;
            }> | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQVirtualPrinterCreateMutationVariables = Exact<{
    virtualPrinter: GQVirtualPrinterCreate;
}>;

export type GQVirtualPrinterCreateMutation = {
    __typename?: "Mutation";
    virtualPrinterCreate: {
        __typename?: "VirtualPrinter";
        name: string;
        printer: { __typename?: "Printer"; id: string };
    };
};

export type GQVirtualPrinterSaveMutationVariables = Exact<{
    id: Scalars["ID"];
    virtualPrinter: GQVirtualPrinterSave;
}>;

export type GQVirtualPrinterSaveMutation = {
    __typename?: "Mutation";
    virtualPrinterSave: {
        __typename?: "VirtualPrinter";
        name: string;
        printer: { __typename?: "Printer"; id: string };
    };
};

export type GQVirtualPrinterDeleteMutationVariables = Exact<{
    id: Scalars["ID"];
}>;

export type GQVirtualPrinterDeleteMutation = {
    __typename?: "Mutation";
    virtualPrinterDelete: {
        __typename?: "VirtualPrinterDeleteResponse";
        status: GQDeleteResponseEnum;
    };
};

export type GQVirtualPrinterFormQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQVirtualPrinterFormQuery = {
    __typename?: "Query";
    departments: {
        __typename?: "DepartmentPagination";
        data: Array<{ __typename?: "Department"; id: string; name: string }>;
    };
    printers: {
        __typename?: "PrinterPagination";
        data: Array<{
            __typename?: "Printer";
            id: string;
            name: string;
            type: GQPrinterType;
            class: GQPrinterClass;
            manufacturer: GQPrinterManufacturer;
        }>;
    };
};

export type GQAccountBuyFundsMutationVariables = Exact<{
    accountId: Scalars["ID"];
    amount: Scalars["Float"];
    orderId: Scalars["ID"];
    userId: Scalars["ID"];
    tagId: Scalars["ID"];
    tagIdentifier: Scalars["String"];
}>;

export type GQAccountBuyFundsMutation = {
    __typename?: "Mutation";
    accountBuyFunds: {
        __typename?: "AccountBuyFundsResponse";
        status: GQAccountBuyFundsStatus;
        transactionId?: string | null;
    };
};

export type GQAccountReturnFundsMutationVariables = Exact<{
    accountId: Scalars["ID"];
    amount: Scalars["Float"];
    orderId: Scalars["ID"];
    userId: Scalars["ID"];
    tagId: Scalars["ID"];
    tagIdentifier: Scalars["String"];
}>;

export type GQAccountReturnFundsMutation = {
    __typename?: "Mutation";
    accountReturnFunds: {
        __typename?: "AccountReturnFundsResponse";
        status: GQAccountReturnFundsStatus;
        transactionId?: string | null;
    };
};

export type GQAccountRevertTransactionMutationVariables = Exact<{
    accountId: Scalars["ID"];
    transactionId: Scalars["ID"];
    userId: Scalars["ID"];
}>;

export type GQAccountRevertTransactionMutation = {
    __typename?: "Mutation";
    accountRevertTransaction: {
        __typename?: "AccountRevertTransactionResponse";
        status: GQAccountRevertTransactionStatus;
    };
};

export type GQAccountBalanceQueryVariables = Exact<{
    id: Scalars["ID"];
    numberOfTransactions?: InputMaybe<Scalars["Int"]>;
    printWidth?: InputMaybe<Scalars["Int"]>;
}>;

export type GQAccountBalanceQuery = {
    __typename?: "Query";
    account: {
        __typename?: "Account";
        amount: number;
        balance: { __typename?: "Balance"; receipt: string };
    };
};

export type GQAppDataQueryVariables = Exact<{ [key: string]: never }>;

export type GQAppDataQuery = {
    __typename?: "Query";
    me: {
        __typename?: "Me";
        cashRegister?: {
            __typename?: "CashRegister";
            appData: {
                __typename?: "AppData";
                structVersion: number;
                minimumStructVersion: number;
                deviceConfig: any;
                cashRegister: {
                    __typename?: "CashRegister";
                    id: string;
                    serialId: string;
                    name: string;
                    department?: {
                        __typename?: "Department";
                        id: string;
                        name: string;
                    } | null;
                };
                merchant: {
                    __typename?: "Merchant";
                    id: string;
                    serialId: number;
                    name: string;
                    giftcardVatBookkeepingMethod: string;
                };
                productGroups: Array<{
                    __typename?: "ProductGroup";
                    id: string;
                    name: string;
                    color: string;
                    excludeFromDiscounts: boolean;
                    createdAt: any;
                    vat: {
                        __typename?: "Vat";
                        id: string;
                        name: string;
                        percentage: number;
                    };
                    printer?: {
                        __typename?: "Printer";
                        id: string;
                        name: string;
                        serial: string;
                    } | null;
                }>;
                vats: Array<{
                    __typename?: "Vat";
                    id: string;
                    name: string;
                    percentage: number;
                }>;
                products: Array<{
                    __typename?: "Product";
                    id: string;
                    name: string;
                    externalId?: string | null;
                    amount: number;
                    buttonText?: string | null;
                    minimumAmount: number;
                    costAmount: number;
                    excludeFromDiscounts: boolean;
                    plu?: number | null;
                    inheritPrinter: boolean;
                    vat: {
                        __typename?: "Vat";
                        id: string;
                        name: string;
                        percentage: number;
                    };
                    barcodes: Array<{
                        __typename?: "ProductBarcode";
                        barcode: string;
                    }>;
                    group: {
                        __typename?: "ProductGroup";
                        id: string;
                        name: string;
                        color: string;
                        printer?: {
                            __typename?: "Printer";
                            id: string;
                            name: string;
                            serial: string;
                        } | null;
                    };
                    printer?: {
                        __typename?: "Printer";
                        id: string;
                        name: string;
                        serial: string;
                    } | null;
                    discountTemplate?: Array<{
                        __typename?: "DiscountTemplate";
                        name: string;
                        type: GQDiscountValueType;
                        value: number;
                        color?: string | null;
                    }> | null;
                    viProductRelations?: Array<{
                        __typename?: "Product2ViProduct2MeasurementUnit";
                        value: number;
                        viProduct: { __typename?: "ViProduct"; id: string };
                        measurementUnit: {
                            __typename?: "MeasurementUnit";
                            id: string;
                        };
                    }> | null;
                }>;
                discounts: Array<{
                    __typename?: "Discount";
                    lineDescription: string;
                    type: GQDiscountType;
                    valueType: GQDiscountValueType;
                    value: number;
                    maxPerOrder?: number | null;
                    itemQuery: any;
                    conditions: any;
                }>;
                layout?: {
                    __typename?: "Layout";
                    id: string;
                    name: string;
                    data: any;
                    columns: number;
                    rows: number;
                    layoutType: string;
                    products: Array<{
                        __typename?: "Product";
                        id: string;
                        name: string;
                        amount: number;
                        minimumAmount: number;
                        costAmount: number;
                        excludeFromDiscounts: boolean;
                        buttonText?: string | null;
                        externalId?: string | null;
                        vat: {
                            __typename?: "Vat";
                            id: string;
                            name: string;
                            percentage: number;
                        };
                        group: {
                            __typename?: "ProductGroup";
                            id: string;
                            name: string;
                            color: string;
                        };
                    }>;
                    productGroups: Array<{
                        __typename?: "ProductGroup";
                        id: string;
                        name: string;
                        color: string;
                        vat: {
                            __typename?: "Vat";
                            id: string;
                            name: string;
                            percentage: number;
                        };
                    }>;
                } | null;
                layoutEntities: Array<{
                    __typename?: "LayoutEntity";
                    id: string;
                    name: string;
                    type: string;
                    function?: string | null;
                    createdAt: any;
                    updatedAt?: any | null;
                    data:
                        | {
                              __typename: "BuyAccountFunds";
                              externalId?: string | null;
                              amount?: number | null;
                          }
                        | {
                              __typename: "CustomItem";
                              externalId?: string | null;
                              productGroupId: string;
                          };
                }>;
                tableLayout?: {
                    __typename?: "Layout";
                    id: string;
                    name: string;
                    data: any;
                    columns: number;
                    rows: number;
                    layoutType: string;
                    createdAt: any;
                    updatedAt?: any | null;
                } | null;
                paymentConfiguration?: {
                    __typename?: "PaymentConfiguration";
                    id: string;
                    name: string;
                    createdAt: string;
                    paymentMethods: Array<{
                        __typename?: "PaymentConfigurationMethod";
                        showAsQuickButton: boolean;
                        showInPaymentWindow: boolean;
                        askForAmount: boolean;
                        paymentMethod: {
                            __typename?: "PaymentMethod";
                            id: string;
                            name: string;
                            paymentType: string;
                            enabled: boolean;
                            currency: {
                                __typename?: "Currency";
                                code: string;
                                rate: number;
                            };
                        };
                    }>;
                } | null;
                miscButtons?: {
                    __typename?: "MiscButtons";
                    id: string;
                    name: string;
                    buttons: any;
                    buttonsSortOrder?: any | null;
                    createdAt: any;
                    deletedAt?: any | null;
                    merchant: {
                        __typename?: "Merchant";
                        id: string;
                        name: string;
                    };
                } | null;
                tags: Array<{
                    __typename?: "Tag";
                    id: string;
                    identifier: string;
                    tagType: string;
                    name?: string | null;
                    group?: {
                        __typename?: "TagGroup";
                        id: string;
                        name: string;
                    } | null;
                    account?: {
                        __typename?: "Account";
                        id: string;
                        name: string;
                        amount: number;
                        status: string;
                        type: string;
                        vat?: {
                            __typename?: "Vat";
                            id: string;
                            percentage: number;
                        } | null;
                    } | null;
                    customer?: {
                        __typename?: "Customer";
                        id: string;
                        name: string;
                        group?: {
                            __typename?: "CustomerGroup";
                            id: string;
                            name: string;
                        } | null;
                    } | null;
                }>;
                printers: Array<{
                    __typename?: "Printer";
                    id: string;
                    name: string;
                    serial: string;
                    type: GQPrinterType;
                    class: GQPrinterClass;
                    manufacturer: GQPrinterManufacturer;
                }>;
                bookkeepingAccounts: Array<{
                    __typename?: "BookkeepingAccount";
                    id: string;
                    name: string;
                    systemLabel?: string | null;
                }>;
                cmpEvents: Array<{
                    __typename?: "CmpEvent";
                    id: string;
                    externalId?: string | null;
                    name: string;
                    active: boolean;
                    from?: any | null;
                    to?: any | null;
                    products: Array<{
                        __typename?: "CmpEventProduct";
                        id: string;
                        externalId?: string | null;
                        name: string;
                        amount?: number | null;
                        active: boolean;
                        calendar?: any | null;
                        sms?: boolean | null;
                        group: { __typename?: "ProductGroup"; id: string };
                    }>;
                }>;
                cmpProducts: Array<{
                    __typename?: "CmpProduct";
                    id: string;
                    externalId?: string | null;
                    type?: string | null;
                    name: string;
                    active: boolean;
                    amount?: number | null;
                    sms: boolean;
                    group: { __typename?: "ProductGroup"; id: string };
                }>;
                fiskaly?: {
                    __typename?: "FiskalyConfiguration";
                    integrationActive: boolean;
                    tssId: string;
                    clientId: string;
                    clientActive: boolean;
                } | null;
                viProducts?: Array<{
                    __typename?: "ViProduct";
                    id: string;
                    name: string;
                    measurementUnit: Array<{
                        __typename?: "MeasurementUnit";
                        id: string;
                        name: string;
                    }>;
                }> | null;
                virtualPrinters?: Array<{
                    __typename?: "VirtualPrinter";
                    id: string;
                    name: string;
                    printer: { __typename?: "Printer"; id: string };
                    departments?: Array<{
                        __typename?: "VirtualPrinterDepartment";
                        department: { __typename?: "Department"; id: string };
                        printer?: { __typename?: "Printer"; id: string } | null;
                    }> | null;
                }> | null;
                approvals?: Array<{
                    __typename?: "Approval";
                    id: string;
                    type: GQApprovalType;
                    approvalTokens: Array<{
                        __typename?: "ApprovalToken";
                        id: string;
                        name: string;
                        value: string;
                        type: GQApprovalGroupType;
                    }>;
                    approvalTokenGroups: Array<{
                        __typename?: "ApprovalTokenGroup";
                        id: string;
                        name: string;
                        approvalTokens: Array<{
                            __typename?: "ApprovalToken";
                            id: string;
                            name: string;
                            value: string;
                            type: GQApprovalGroupType;
                        }>;
                    }>;
                }> | null;
            };
        } | null;
    };
};

export type GQCmpEventCreateOrderMutationVariables = Exact<{
    order: GQCmpEventCreateType;
}>;

export type GQCmpEventCreateOrderMutation = {
    __typename?: "Mutation";
    cmpEventCreateOrder: {
        __typename?: "CmpEventOrderCreated";
        orderId: string;
        receipts: Array<{
            __typename?: "CmpEventOrderReceipt";
            url?: string | null;
            title?: string | null;
            description?: string | null;
            code?: string | null;
        }>;
        productItems: Array<{
            __typename?: "CmpProductResponse";
            itemId: number;
            value: string;
            shouldPrint: boolean;
            title?: string | null;
            description?: string | null;
        }>;
    };
};

export type GQCmpGiftcardBalanceQueryVariables = Exact<{
    code: Scalars["String"];
}>;

export type GQCmpGiftcardBalanceQuery = {
    __typename?: "Query";
    cmpGiftcardBalance: {
        __typename?: "CmpGiftcardBalance";
        amount: number;
        expirationDate?: any | null;
        status: GQCmpGiftcardBalanceStatus;
    };
};

export type GQFiskalyConfigurationFieldsFragment = {
    __typename?: "FiskalyConfiguration";
    integrationActive: boolean;
    tssId: string;
    clientId: string;
    clientActive: boolean;
};

export type GQAccessTokenFieldsFragment = {
    __typename?: "FiskalyAccessTokenResponse";
    accessToken: string;
    expiresIn: number;
    expiresAt: any;
    refreshToken: string;
    refreshTokenExpiresIn: number;
    refreshTokenExpiresAt: any;
};

export type GQFiskalyAccessTokenQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQFiskalyAccessTokenQuery = {
    __typename?: "Query";
    fiskalyAccessToken: {
        __typename?: "FiskalyAccessTokenResponse";
        accessToken: string;
        expiresIn: number;
        expiresAt: any;
        refreshToken: string;
        refreshTokenExpiresIn: number;
        refreshTokenExpiresAt: any;
    };
};

export type GQFiskalyRefreshTokenQueryVariables = Exact<{
    refreshToken: Scalars["String"];
}>;

export type GQFiskalyRefreshTokenQuery = {
    __typename?: "Query";
    fiskalyRefreshToken: {
        __typename?: "FiskalyAccessTokenResponse";
        accessToken: string;
        expiresIn: number;
        expiresAt: any;
        refreshToken: string;
        refreshTokenExpiresIn: number;
        refreshTokenExpiresAt: any;
    };
};

export type GQAccountsByCustomerSearchQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
    search?: InputMaybe<GQSearchInput>;
}>;

export type GQAccountsByCustomerSearchQuery = {
    __typename?: "Query";
    accountsByCustomerSearch: {
        __typename?: "AccountPagination";
        data: Array<{
            __typename?: "Account";
            id: string;
            name: string;
            customer?: {
                __typename?: "Customer";
                id: string;
                name: string;
                phoneNumber?: string | null;
            } | null;
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQCmpGiftcardPayAmountMutationVariables = Exact<{
    id: Scalars["ID"];
    orderId: Scalars["ID"];
    amount: Scalars["Float"];
    userId: Scalars["ID"];
    code?: InputMaybe<Scalars["String"]>;
}>;

export type GQCmpGiftcardPayAmountMutation = {
    __typename?: "Mutation";
    cmpGiftcardPayAmount: {
        __typename?: "CmpGiftcardPayAmountResponse";
        transactionId: string;
        status: GQCmpGiftcardTransactionStatus;
        receipt?: string | null;
        amount: number;
        balance: number;
        createdAt?: any | null;
    };
};

export type GQCmpGiftcardRefundAmountMutationVariables = Exact<{
    id: Scalars["ID"];
    orderId: Scalars["ID"];
    amount: Scalars["Float"];
    userId: Scalars["ID"];
    code?: InputMaybe<Scalars["String"]>;
}>;

export type GQCmpGiftcardRefundAmountMutation = {
    __typename?: "Mutation";
    cmpGiftcardRefundAmount: {
        __typename?: "CmpGiftcardRefundAmountResponse";
        transactionId: string;
        status: GQCmpGiftcardTransactionStatus;
        receipt?: string | null;
        amount: number;
        balance: number;
        createdAt?: any | null;
    };
};

export type GQCmpInvoiceCustomerSearchQueryVariables = Exact<{
    value: Scalars["String"];
}>;

export type GQCmpInvoiceCustomerSearchQuery = {
    __typename?: "Query";
    cmpInvoiceCustomerSearch: {
        __typename?: "CmpInvoiceCustomerResponse";
        resultsFoundCount?: number | null;
        status?: GQCmpInvoiceCustomerStatus | null;
        customers: Array<{
            __typename?: "CmpInvoiceCustomer";
            id: string;
            name?: string | null;
            email?: string | null;
            phone?: string | null;
            company?: string | null;
            address?: string | null;
            paymentMethods: Array<{
                __typename?: "CmpInvoicePaymentMethod";
                type: string;
                allowed: boolean;
                description?: string | null;
            }>;
        }>;
    };
};

export type GQSoftpayCloudTerminalFieldsFragment = {
    __typename?: "SoftpayCloudTerminal";
    appId: string;
    lastOnline: string;
    name: string;
    store: { __typename?: "SoftpayCloudStore"; name: string };
};

export type GQSoftpayAccessTokenQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQSoftpayAccessTokenQuery = {
    __typename?: "Query";
    softpayAccessToken: {
        __typename?: "SoftpayAccessTokenResponse";
        accessToken: string;
        expiresIn: number;
        tokenType: string;
    };
};

export type GQSoftpayCloudTerminalsQueryVariables = Exact<{
    pagination?: InputMaybe<GQPaginationInput>;
}>;

export type GQSoftpayCloudTerminalsQuery = {
    __typename?: "Query";
    softpayCloudTerminals: {
        __typename?: "SoftpayCloudTerminalsPagination";
        data: Array<{
            __typename?: "SoftpayCloudTerminal";
            appId: string;
            lastOnline: string;
            name: string;
            store: { __typename?: "SoftpayCloudStore"; name: string };
        }>;
        pagination: {
            __typename?: "Pagination";
            pages: number;
            sort: string;
            sortDirection: string;
            resultCount: number;
        };
    };
};

export type GQAccessTokenQueryVariables = Exact<{ [key: string]: never }>;

export type GQAccessTokenQuery = {
    __typename?: "Query";
    accessToken: {
        __typename?: "SumUpAccessTokenResponse";
        accessToken: string;
    };
};

export type GQVenueAccessCheckoutTicketMutationVariables = Exact<{
    eventId: Scalars["Int"];
    accessTypes: Array<Scalars["Int"]> | Scalars["Int"];
    validFrom: Scalars["Date"];
    validTo: Scalars["Date"];
}>;

export type GQVenueAccessCheckoutTicketMutation = {
    __typename?: "Mutation";
    venueAccessCreateAccessTicket: {
        __typename?: "VenueAccessTicketCreated";
        tokenValue: string;
        ticketId: string;
    };
};

export type GQVenueAccessCheckoutTicketsMutationVariables = Exact<{
    tickets?: InputMaybe<
        Array<GQVenueAccessCreateType> | GQVenueAccessCreateType
    >;
}>;

export type GQVenueAccessCheckoutTicketsMutation = {
    __typename?: "Mutation";
    venueAccessCreateAccessTickets?: Array<{
        __typename?: "VenueAccessTicketCreated";
        tokenValue: string;
        ticketId: string;
    }> | null;
};

export type GQVenueAccessCancelTicketMutationVariables = Exact<{
    ticketId: Scalars["Int"];
}>;

export type GQVenueAccessCancelTicketMutation = {
    __typename?: "Mutation";
    venueAccessCancelAccessTicket: {
        __typename?: "VenueAccessTicketCancelled";
        status: boolean;
    };
};

export type GQCanPeriodCardBeRenewedQueryVariables = Exact<{
    productId: Scalars["String"];
    cardToken?: InputMaybe<Scalars["String"]>;
    cardId?: InputMaybe<Scalars["String"]>;
}>;

export type GQCanPeriodCardBeRenewedQuery = {
    __typename?: "Query";
    canPeriodCardBeRenewed: {
        __typename?: "CanPeriodCardBeRenewedResponse";
        status: GQPeriodCardRenewalStatus;
        message?: string | null;
        cardToken?: string | null;
        cardId?: string | null;
    };
};

export type GQCanPeriodCardBeUpgradedQueryVariables = Exact<{
    productId: Scalars["String"];
    cardToken?: InputMaybe<Scalars["String"]>;
    cardId?: InputMaybe<Scalars["String"]>;
}>;

export type GQCanPeriodCardBeUpgradedQuery = {
    __typename?: "Query";
    canPeriodCardBeUpgraded: {
        __typename?: "CanPeriodCardBeUpgradedResponse";
        status: GQPeriodCardUpgradeStatus;
        message?: string | null;
        cardToken?: string | null;
        cardId?: string | null;
    };
};

export type GQMerchantDataUpdatedSubscriptionVariables = Exact<{
    [key: string]: never;
}>;

export type GQMerchantDataUpdatedSubscription = {
    __typename?: "Subscription";
    merchantDataUpdated: any;
};

export type GQLogoDataUpdatedSubscriptionVariables = Exact<{
    [key: string]: never;
}>;

export type GQLogoDataUpdatedSubscription = {
    __typename?: "Subscription";
    logoDataUpdated: any;
};

export type GQInventoryForIdsQueryVariables = Exact<{
    ids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type GQInventoryForIdsQuery = {
    __typename?: "Query";
    inventoryForIds: Array<{
        __typename?: "InventoryProduct";
        id: string;
        quantity: number;
        products: Array<{ __typename?: "Product"; id: string }>;
    }>;
};

export type GQSelectMerchantPosUserQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GQSelectMerchantPosUserQuery = {
    __typename?: "Query";
    me: {
        __typename?: "Me";
        cashRegister?: {
            __typename?: "CashRegister";
            name: string;
            department?: { __typename?: "Department"; name: string } | null;
            merchant: { __typename?: "Merchant"; name: string };
        } | null;
        merchant?: {
            __typename?: "Merchant";
            id: string;
            users: Array<{
                __typename?: "User";
                id: string;
                username: string;
                email: string;
                firstName: string;
                lastName: string;
                pin?: string | null;
                requireLoginPin: boolean;
                requireLogoutPin: boolean;
                requirePasswordChange: boolean;
                active: boolean;
                roles: Array<{
                    __typename?: "UserRole";
                    role: {
                        __typename?: "Role";
                        id: string;
                        type: GQRoleTypeEnum;
                        name: string;
                        permissions: Array<{
                            __typename?: "RolePermission";
                            key: string;
                            value: string;
                        }>;
                    };
                    merchant?: {
                        __typename?: "Merchant";
                        id: string;
                        name: string;
                    } | null;
                }>;
            }>;
        } | null;
    };
};

export type GQAllAuthTokenFieldsFragment = {
    __typename?: "AuthToken";
    access: string;
    accessExpire: number;
    now: string;
    refresh: string;
};

export type GQAllAuthRoleFieldsFragment = {
    __typename?: "Role";
    id: string;
    type: GQRoleTypeEnum;
    name: string;
    permissions: Array<{
        __typename?: "RolePermission";
        key: string;
        value: string;
    }>;
};

export type GQAllAuthUserFieldsFragment = {
    __typename?: "User";
    id: string;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    pin?: string | null;
    requireLoginPin: boolean;
    requireLogoutPin: boolean;
    requirePasswordChange: boolean;
    active: boolean;
    roles: Array<{
        __typename?: "UserRole";
        role: {
            __typename?: "Role";
            id: string;
            type: GQRoleTypeEnum;
            name: string;
            permissions: Array<{
                __typename?: "RolePermission";
                key: string;
                value: string;
            }>;
        };
        merchant?: { __typename?: "Merchant"; id: string; name: string } | null;
    }>;
};

export type GQAllAuthMerchantFieldsFragment = {
    __typename?: "Merchant";
    id: string;
    serialId: number;
    name: string;
    entityConfig?: { __typename?: "EntityConfig"; data: any } | null;
};

export type GQAuthDevicePollQueryVariables = Exact<{
    deviceId: Scalars["ID"];
    devicePinCode: Scalars["String"];
}>;

export type GQAuthDevicePollQuery = {
    __typename?: "Query";
    authDevicePoll?: {
        __typename?: "AuthToken";
        access: string;
        accessExpire: number;
        now: string;
        refresh: string;
    } | null;
};

export type GQAuthRefreshQueryVariables = Exact<{
    refreshToken: Scalars["String"];
}>;

export type GQAuthRefreshQuery = {
    __typename?: "Query";
    authRefresh?: {
        __typename?: "AuthToken";
        access: string;
        accessExpire: number;
        now: string;
        refresh: string;
    } | null;
};

export type GQAuthLoginMutationVariables = Exact<{
    username: Scalars["String"];
    password: Scalars["String"];
}>;

export type GQAuthLoginMutation = {
    __typename?: "Mutation";
    authLogin: {
        __typename?: "AuthAttempt";
        successful: boolean;
        token?: {
            __typename?: "AuthToken";
            access: string;
            accessExpire: number;
            now: string;
            refresh: string;
        } | null;
    };
};

export type GQAuthUpdateLoginMutationVariables = Exact<{
    [key: string]: never;
}>;

export type GQAuthUpdateLoginMutation = {
    __typename?: "Mutation";
    authUpdateLogin: {
        __typename?: "AuthAttempt";
        successful: boolean;
        token?: {
            __typename?: "AuthToken";
            access: string;
            accessExpire: number;
            now: string;
            refresh: string;
        } | null;
    };
};

export type GQAuthSelectUserRoleMutationVariables = Exact<{
    roleId: Scalars["ID"];
    merchantId?: InputMaybe<Scalars["ID"]>;
}>;

export type GQAuthSelectUserRoleMutation = {
    __typename?: "Mutation";
    authSelectUserRole: {
        __typename?: "SelectUserRoleType";
        token: {
            __typename?: "AuthToken";
            access: string;
            accessExpire: number;
            now: string;
            refresh: string;
        };
    };
};

export type GQMeQueryVariables = Exact<{ [key: string]: never }>;

export type GQMeQuery = {
    __typename?: "Query";
    me: {
        __typename?: "Me";
        cashRegister?: {
            __typename?: "CashRegister";
            id: string;
            serialId: string;
            name: string;
        } | null;
        user?: {
            __typename?: "User";
            id: string;
            username: string;
            email: string;
            firstName: string;
            lastName: string;
            pin?: string | null;
            requireLoginPin: boolean;
            requireLogoutPin: boolean;
            requirePasswordChange: boolean;
            active: boolean;
            roles: Array<{
                __typename?: "UserRole";
                role: {
                    __typename?: "Role";
                    id: string;
                    type: GQRoleTypeEnum;
                    name: string;
                    permissions: Array<{
                        __typename?: "RolePermission";
                        key: string;
                        value: string;
                    }>;
                };
                merchant?: {
                    __typename?: "Merchant";
                    id: string;
                    name: string;
                } | null;
            }>;
        } | null;
        department?: {
            __typename?: "Department";
            id: string;
            name: string;
            externalId?: string | null;
            createdAt?: string | null;
            deletedAt?: any | null;
            merchant: { __typename?: "Merchant"; id: string; name: string };
            viWarehouse?: {
                __typename?: "ViWarehouse";
                id: string;
                name: string;
            } | null;
        } | null;
        merchant?: {
            __typename?: "Merchant";
            id: string;
            serialId: number;
            name: string;
            entityConfig?: { __typename?: "EntityConfig"; data: any } | null;
        } | null;
        role?: {
            __typename?: "Role";
            id: string;
            type: GQRoleTypeEnum;
            name: string;
            permissions: Array<{
                __typename?: "RolePermission";
                key: string;
                value: string;
            }>;
        } | null;
    };
};

export type GQRegisterDeviceMutationVariables = Exact<{
    deviceInfo: GQDeviceInfoInput;
    newPinCode?: InputMaybe<Scalars["Boolean"]>;
}>;

export type GQRegisterDeviceMutation = {
    __typename?: "Mutation";
    deviceRegister: {
        __typename?: "Device";
        id: string;
        pinCode?: string | null;
    };
};

export type GQDeviceHeartbeatMutationVariables = Exact<{
    deviceInfo: GQDeviceInfoInput;
}>;

export type GQDeviceHeartbeatMutation = {
    __typename?: "Mutation";
    deviceHeartbeat: boolean;
};

export const DefaultPaginationFieldsFragmentDoc = gql`
    fragment defaultPaginationFields on Pagination {
        pages
        sort
        sortDirection
        resultCount
    }
`;
export const AllAccountFieldsFragmentDoc = gql`
    fragment allAccountFields on Account {
        id
        name
        merchant {
            id
            name
        }
        type
        status
        amount
        systemLabel
        customer {
            id
            name
            group {
                id
                name
            }
        }
        createdAt
        externalId
        vat {
            id
        }
    }
`;
export const AllBookkeepingAccountFieldsFragmentDoc = gql`
    fragment allBookkeepingAccountFields on BookkeepingAccount {
        id
        name
        merchant {
            id
            name
        }
        systemLabel
        createdAt
    }
`;
export const AllAccountTransactionFieldsFragmentDoc = gql`
    fragment allAccountTransactionFields on AccountTransaction {
        id
        userId
        transactionAt
        amount
        user {
            username
        }
        tag {
            id
            identifier
            name
        }
        invoiceId
    }
`;
export const AllAccountBookkeepingTransactionFieldsFragmentDoc = gql`
    fragment allAccountBookkeepingTransactionFields on AccountBookkeepingTransaction {
        id
        transactionAt
        amount
        type
        invoiceId
    }
`;
export const CustomerScreenFieldsFragmentDoc = gql`
    fragment customerScreenFields on Customer {
        id
        name
        group {
            id
            name
        }
        address
        zip
        city
        email
        phoneNumber
        comment
        cvrNumber
        contactName
        accounts {
            amount
        }
        createdAt
    }
`;
export const CustomerGroupScreenFieldsFragmentDoc = gql`
    fragment customerGroupScreenFields on CustomerGroup {
        id
        name
    }
`;
export const AllApprovalFieldsFragmentDoc = gql`
    fragment allApprovalFields on Approval {
        id
        type
        active
        createdAt
        updatedAt
        approvalTokens {
            id
        }
        approvalTokenGroups {
            id
        }
    }
`;
export const AllApprovalTokenFieldsFragmentDoc = gql`
    fragment allApprovalTokenFields on ApprovalToken {
        id
        name
        approvalTokenGroupId
        value
        type
        active
        createdAt
        updatedAt
        approvalTokenGroup {
            name
        }
    }
`;
export const AllApprovalTokenGroupFieldsFragmentDoc = gql`
    fragment allApprovalTokenGroupFields on ApprovalTokenGroup {
        id
        name
        active
        createdAt
        updatedAt
    }
`;
export const CardTransactionScreenFieldsFragmentDoc = gql`
    fragment cardTransactionScreenFields on CardTransaction {
        id
        status
        orderId
        amount
        receipt
        invoiceId
        transactionAt
        scheme
        maskedPan
        cashRegister {
            name
        }
    }
`;
export const CashRegisterFragmentDoc = gql`
    fragment cashRegister on CashRegister {
        id
        name
        device {
            id
            osName
            osVersion
            appVersion
            appBuild
            serialNumber
            hardwareModel
            hardwareProducer
            macAddress
            language
            lastSeen
            isUsingAutoTime
            isUsingAutoTimeZone
            timeZone
        }
        department {
            id
            name
        }
        merchant {
            id
            name
            lastNotifySentAt
        }
        createdAt
        deletedAt
        lastAppDataSentAt
    }
`;
export const AllCurrencyFieldsFragmentDoc = gql`
    fragment allCurrencyFields on Currency {
        id
        merchant {
            id
            name
        }
        code
        rate
        createdAt
        deletedAt
    }
`;
export const AllDashboardFragmentDoc = gql`
    fragment allDashboard on Dashboard {
        from
        to
        totals {
            invoices
            turnoverAmount
            avgTransaction
        }
        products {
            id
            name
            quantity
            turnoverAmount
        }
        productGroups {
            id
            name
            quantity
            turnoverAmount
        }
        departments {
            id
            name
            invoices
            avgTransaction
            turnoverAmount
        }
        accounts {
            id
            name
            amount
        }
        amountsByHour {
            datetime
            sum
        }
    }
`;
export const AllDepartmentFieldsFragmentDoc = gql`
    fragment allDepartmentFields on Department {
        id
        name
        externalId
        createdAt
        deletedAt
        merchant {
            id
            name
        }
        viWarehouse {
            id
            name
        }
    }
`;
export const AllDiscountFieldsFragmentDoc = gql`
    fragment allDiscountFields on Discount {
        id
        merchant {
            id
            name
        }
        name
        lineDescription
        type
        valueType
        value
        maxPerOrder
        itemQuery
        conditions
        createdAt
        deletedAt
        active
    }
`;
export const EconomicSyncJobFieldsFragmentDoc = gql`
    fragment economicSyncJobFields on EconomicSyncJob {
        id
        shiftId
        runAt
        attempts
        lastError
        createdAt
        shift {
            id
            merchant {
                id
                name
            }
        }
    }
`;
export const FiskalyClientFieldsFragmentDoc = gql`
    fragment fiskalyClientFields on FiskalyClient {
        id
        integrationId
        establishmentId
        tssId
        clientState
        updatedAt
        submitBefore
        cashRegisterId
        cashRegister {
            id
            name
        }
    }
`;
export const FiskalyRemoteClientFieldsFragmentDoc = gql`
    fragment fiskalyRemoteClientFields on FiskalyRemoteClient {
        id
        state
        serialNumber
        tssId
        createdAt
        updatedAt
    }
`;
export const FiskalyRemoteCashRegisterFieldsFragmentDoc = gql`
    fragment fiskalyRemoteCashRegisterFields on FiskalyRemoteCashRegister {
        clientId
        cashRegisterType
        revision
        tssId
        model
        brand
        softwareBrand
        softwareVersion
        baseCurrencyCode
        environment
        createdAt
        updatedAt
    }
`;
export const FiskalyOrganizationFieldsFragmentDoc = gql`
    fragment fiskalyOrganizationFields on FiskalyOrganization {
        id
        name
        displayName
        address
        zip
        town
        state
        countryCode
        vatId
        economyId
        taxNumber
        fiskalyEnvironment
        managedBy
    }
`;
export const FiskalyTssFieldsFragmentDoc = gql`
    fragment fiskalyTssFields on FiskalyTss {
        id
        state
        description
        publicKey
        serialNumber
        numberActiveTransactions
        numberRegisteredClients
        signatureCounter
        transactionCounter
        createdAt
        uninitializedAt
        initializedAt
        disabledAt
        defectiveAt
    }
`;
export const FiskalyEstablishmentFieldsFragmentDoc = gql`
    fragment fiskalyEstablishmentFields on FiskalyEstablishment {
        id
        integrationId
        organizationId
        designation
        street
        town
        zip
        houseNumber
        houseNumberSuffix
        addressAdditional
        remarks
        createdAt
        updatedAt
        submittedAt
        submitBefore
    }
`;
export const FiskalyDsFinVkExportFieldsFragmentDoc = gql`
    fragment fiskalyDSFinVKExportFields on FiskalyDSFinVKExport {
        id
        fromDate
        toDate
        clientId
        exportState
        format
        cashPointClosings
        exportUrl
        error
        requestedAt
        completedAt
        expireAt
    }
`;
export const AllIntegrationFieldsFragmentDoc = gql`
    fragment allIntegrationFields on Integration {
        id
        type
        active
        name
        apiKey
        createdAt
        merchant {
            id
            name
        }
    }
`;
export const AllMerchantChartOfAccountFieldsFragmentDoc = gql`
    fragment allMerchantChartOfAccountFields on MerchantChartOfAccount {
        integrationId
        name
        chartOfAccountsId
        merchantAccountNo
    }
`;
export const AllInvoiceFieldsFragmentDoc = gql`
    fragment allInvoiceFields on InvoiceRM {
        id
        shift {
            id
            cashRegister {
                name
            }
        }
        items {
            quantity
            external {
                integration
                receipt
            }
        }
        payments {
            cardReceipt
        }
        receiptNumber
        receipt
        externalReceipts {
            integrationId
            receipt
        }
        discountAmount
        amount
        cashRegisterName
        sms
        createdAt
    }
`;
export const AllLayoutEntityFieldsFragmentDoc = gql`
    fragment allLayoutEntityFields on LayoutEntity {
        id
        name
        type
        function
        data {
            __typename
            ... on CustomItem {
                externalId
                productGroupId
            }
            ... on BuyAccountFunds {
                externalId
                amount
            }
        }
        createdAt
        updatedAt
    }
`;
export const AllLayoutFieldsFragmentDoc = gql`
    fragment allLayoutFields on Layout {
        id
        name
        data
        columns
        rows
        layoutType
        createdAt
        updatedAt
    }
`;
export const AllPosProductLayoutFieldsFragmentDoc = gql`
    fragment allPosProductLayoutFields on Layout {
        id
        name
        data
        columns
        rows
        layoutType
        products {
            id
            name
            amount
            minimumAmount
            costAmount
            vat {
                id
                name
                percentage
            }
            excludeFromDiscounts
            group {
                id
                name
                color
            }
            buttonText
            externalId
        }
        productGroups {
            id
            name
            color
            vat {
                id
                name
                percentage
            }
        }
    }
`;
export const AllAccessTicketFieldsFragmentDoc = gql`
    fragment allAccessTicketFields on VenueAccessParameters {
        events {
            id
            name
            isActive
        }
        accessTypes {
            id
            name
        }
    }
`;
export const LogFieldsFragmentDoc = gql`
    fragment logFields on Log {
        id
        type
        message
        payload
        merchant {
            name
        }
        insertedAt
    }
`;
export const AllLogoFieldsFragmentDoc = gql`
    fragment allLogoFields on Logo {
        type
        base64Data
        escposData
        bmpData
        width
        height
        fileType
        createdAt
        updatedAt
        deletedAt
    }
`;
export const AllMerchantFieldsFragmentDoc = gql`
    fragment allMerchantFields on Merchant {
        id
        name
        createdAt
    }
`;
export const AllMiscButtonsFieldsFragmentDoc = gql`
    fragment allMiscButtonsFields on MiscButtons {
        id
        merchant {
            id
            name
        }
        name
        buttons
        buttonsSortOrder
        createdAt
        deletedAt
    }
`;
export const ScreenMiscButtonFieldsFragmentDoc = gql`
    fragment screenMiscButtonFields on MiscButtons {
        id
        merchant {
            id
            name
        }
        name
        buttons
        buttonsSortOrder
        createdAt
    }
`;
export const AllPaymentConfigurationFieldsFragmentDoc = gql`
    fragment allPaymentConfigurationFields on PaymentConfiguration {
        id
        name
        paymentMethods {
            paymentMethod {
                id
                name
                paymentType
                enabled
                currency {
                    code
                    rate
                }
            }
            showAsQuickButton
            showInPaymentWindow
            askForAmount
        }
        createdAt
    }
`;
export const AllPaymentMethodFieldsFragmentDoc = gql`
    fragment allPaymentMethodFields on PaymentMethod {
        id
        name
        paymentType
        enabled
        account
        diffAccount
        currency {
            id
            code
        }
        createdAt
    }
`;
export const PrinterScreenFieldsFragmentDoc = gql`
    fragment printerScreenFields on Printer {
        id
        name
        serial
        type
        manufacturer
        class
        createdAt
        cashRegister {
            id
            name
        }
    }
`;
export const PrinterWithRelationsFragmentDoc = gql`
    fragment printerWithRelations on Printer {
        id
        name
        serial
        type
        manufacturer
        class
        createdAt
        cashRegister {
            id
            name
        }
        product {
            id
            name
        }
        productGroup {
            id
            name
        }
        virtualPrinter {
            id
            name
        }
    }
`;
export const AllProductGroupFieldsFragmentDoc = gql`
    fragment allProductGroupFields on ProductGroup {
        id
        externalId
        name
        vat {
            id
            name
            percentage
        }
        color
        excludeFromDiscounts
        isExternal
        printer {
            id
            name
            isVirtual
        }
        createdAt
        deletedAt
    }
`;
export const AllInventoryProductNoteTemplateFieldsFragmentDoc = gql`
    fragment allInventoryProductNoteTemplateFields on InventoryProductNoteTemplate {
        id
        note
    }
`;
export const AllProductFieldsFragmentDoc = gql`
    fragment allProductFields on Product {
        id
        parent {
            id
            name
        }
        group {
            id
            name
            color
            vat {
                id
                name
                percentage
            }
        }
        externalId
        name
        amount
        minimumAmount
        costAmount
        vat {
            id
            name
            percentage
        }
        ownVat {
            id
            name
            percentage
        }
        onlineRequired
        active
        isExternal
        excludeFromDiscounts
        ownExcludeFromDiscounts
        barcode
        barcodes {
            id
            barcode
        }
        buttonText
        inventoryProduct {
            id
            quantity
        }
        buttonText
        printer {
            id
            name
        }
        inheritPrinter
        plu
        discountTemplate {
            name
            type
            value
            color
        }
        createdAt
        deletedAt
    }
`;
export const ProductChildrenListFieldsFragmentDoc = gql`
    fragment productChildrenListFields on ProductPagination {
        data {
            id
            name
            amount
        }
    }
`;
export const AllViProductFieldsFragmentDoc = gql`
    fragment allViProductFields on ViProduct {
        id
        name
        deletedAt
        measurementUnit {
            name
            id
            deletedAt
        }
    }
`;
export const ReportFieldsFragmentDoc = gql`
    fragment reportFields on ReportParameters {
        users {
            id
            username
            firstName
            lastName
        }
        departments {
            id
            name
        }
        cashRegisters {
            id
            name
        }
        productGroups {
            id
            name
        }
        products {
            id
            name
        }
    }
`;
export const SaftJobFieldsFragmentDoc = gql`
    fragment saftJobFields on SaftJob {
        id
        shiftId
        runAt
        attempts
        lastError
        createdAt
        shift {
            id
            merchant {
                id
                name
            }
        }
    }
`;
export const AllShiftFieldsFragmentDoc = gql`
    fragment allShiftFields on ShiftRM {
        id
        shiftNumber
        cashRegister {
            id
            name
            department {
                name
            }
        }
        cashRegisterName
        openedByUser {
            username
        }
        closedByUser {
            username
        }
        openedAt
        closedAt
        discount
        amount
        syncedAt
        syncStatus
        syncDetails
        zReport
        openingAmount
        cashDifference
        numCashDrawerOpen
        funds {
            name
            type
            amount
            createdAt
        }
        payments {
            id
            name
            paymentMethodId
            type
            amount
            currency
            currencyRate
            event
            cardSchemas {
                name
                amount
                count
            }
        }
        salesData {
            byProductGroup {
                name
                amount
            }
            hourSales {
                date
                count
                amount
            }
        }
        cashInfoPerMethod {
            cashDifferencePerMethod {
                name
                paymentMethodId
                amount
                currencyCode
                currencyRate
            }
            cashSalePerMethod {
                name
                paymentMethodId
                amount
                currencyCode
                currencyRate
            }
        }
    }
`;
export const SoftpayMerchantFieldsFragmentDoc = gql`
    fragment softpayMerchantFields on SoftpayMerchant {
        name
        businessRegistrationNumber
        merchantReference
    }
`;
export const TagGroupScreenFieldsFragmentDoc = gql`
    fragment tagGroupScreenFields on TagGroup {
        id
        name
    }
`;
export const TagScreenFieldsFragmentDoc = gql`
    fragment tagScreenFields on Tag {
        id
        identifier
        name
        tagType
        group {
            id
            name
        }
        account {
            id
            name
        }
        customer {
            id
            name
        }
        createdAt
    }
`;
export const TagNameFieldsFragmentDoc = gql`
    fragment tagNameFields on Tag {
        id
        identifier
        name
    }
`;
export const TaskResultFieldsFragmentDoc = gql`
    fragment taskResultFields on TaskResult {
        jobId
        name
        type
        status
        output
        executionTime
        createdAt
    }
`;
export const AllRoleFieldsFragmentDoc = gql`
    fragment allRoleFields on Role {
        id
        name
        shared
        merchant {
            id
            name
        }
    }
`;
export const UserFragmentDoc = gql`
    fragment user on User {
        id
        username
        email
        firstName
        lastName
        active
        pin
        requireLoginPin
        requireLogoutPin
        requirePasswordChange
        externalId
        createdAt
        roles {
            role {
                id
                name
                type
            }
            merchant {
                id
                name
            }
        }
    }
`;
export const UserFormRolesFieldsFragmentDoc = gql`
    fragment userFormRolesFields on Role {
        id
        name
        type
        merchant {
            id
            name
        }
    }
`;
export const VatScreenFieldsFragmentDoc = gql`
    fragment vatScreenFields on Vat {
        id
        name
        merchant {
            id
            name
        }
        percentage
        isExternal
        externalId
        createdAt
    }
`;
export const VirtualPrinterScreenFieldsFragmentDoc = gql`
    fragment virtualPrinterScreenFields on VirtualPrinter {
        id
        name
        printer {
            id
            name
        }
        createdAt
        departments {
            department {
                id
                name
            }
            printer {
                id
                name
                manufacturer
            }
        }
    }
`;
export const FiskalyConfigurationFieldsFragmentDoc = gql`
    fragment fiskalyConfigurationFields on FiskalyConfiguration {
        integrationActive
        tssId
        clientId
        clientActive
    }
`;
export const AccessTokenFieldsFragmentDoc = gql`
    fragment accessTokenFields on FiskalyAccessTokenResponse {
        accessToken
        expiresIn
        expiresAt
        refreshToken
        refreshTokenExpiresIn
        refreshTokenExpiresAt
    }
`;
export const SoftpayCloudTerminalFieldsFragmentDoc = gql`
    fragment softpayCloudTerminalFields on SoftpayCloudTerminal {
        appId
        lastOnline
        name
        store {
            name
        }
    }
`;
export const AllAuthTokenFieldsFragmentDoc = gql`
    fragment allAuthTokenFields on AuthToken {
        access
        accessExpire
        now
        refresh
    }
`;
export const AllAuthRoleFieldsFragmentDoc = gql`
    fragment allAuthRoleFields on Role {
        id
        type
        name
        permissions {
            key
            value
        }
    }
`;
export const AllAuthUserFieldsFragmentDoc = gql`
    fragment allAuthUserFields on User {
        id
        username
        email
        firstName
        lastName
        pin
        requireLoginPin
        requireLogoutPin
        requirePasswordChange
        active
        roles {
            role {
                ...allAuthRoleFields
            }
            merchant {
                id
                name
            }
        }
    }
    ${AllAuthRoleFieldsFragmentDoc}
`;
export const AllAuthMerchantFieldsFragmentDoc = gql`
    fragment allAuthMerchantFields on Merchant {
        id
        serialId
        name
        entityConfig {
            data
        }
    }
`;
export const EntityConfigsDocument = gql`
    query entityConfigs($entityIds: [ID!]!) {
        entityConfigs(entityIds: $entityIds) {
            entityId
            data
        }
    }
`;

/**
 * __useEntityConfigsQuery__
 *
 * To run a query within a React component, call `useEntityConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityConfigsQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useEntityConfigsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQEntityConfigsQuery,
        GQEntityConfigsQueryVariables
    > &
        (
            | { variables: GQEntityConfigsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQEntityConfigsQuery,
        GQEntityConfigsQueryVariables
    >(EntityConfigsDocument, options);
}
export function useEntityConfigsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQEntityConfigsQuery,
        GQEntityConfigsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQEntityConfigsQuery,
        GQEntityConfigsQueryVariables
    >(EntityConfigsDocument, options);
}
// @ts-ignore
export function useEntityConfigsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQEntityConfigsQuery,
        GQEntityConfigsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQEntityConfigsQuery,
    GQEntityConfigsQueryVariables
>;
export function useEntityConfigsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQEntityConfigsQuery,
              GQEntityConfigsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQEntityConfigsQuery | undefined,
    GQEntityConfigsQueryVariables
>;
export function useEntityConfigsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQEntityConfigsQuery,
              GQEntityConfigsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQEntityConfigsQuery,
        GQEntityConfigsQueryVariables
    >(EntityConfigsDocument, options);
}
export type EntityConfigsQueryHookResult = ReturnType<
    typeof useEntityConfigsQuery
>;
export type EntityConfigsLazyQueryHookResult = ReturnType<
    typeof useEntityConfigsLazyQuery
>;
export type EntityConfigsSuspenseQueryHookResult = ReturnType<
    typeof useEntityConfigsSuspenseQuery
>;
export type EntityConfigsQueryResult = ApolloReactCommon.QueryResult<
    GQEntityConfigsQuery,
    GQEntityConfigsQueryVariables
>;
export const EntityConfigSaveDocument = gql`
    mutation entityConfigSave(
        $entityId: ID!
        $partialData: JSON!
        $disabledData: [String!]!
    ) {
        entityConfigSave(
            entityId: $entityId
            partialData: $partialData
            disabledData: $disabledData
        ) {
            entityId
            data
        }
    }
`;
export type GQEntityConfigSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQEntityConfigSaveMutation,
    GQEntityConfigSaveMutationVariables
>;

/**
 * __useEntityConfigSaveMutation__
 *
 * To run a mutation, you first call `useEntityConfigSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityConfigSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityConfigSaveMutation, { data, loading, error }] = useEntityConfigSaveMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      partialData: // value for 'partialData'
 *      disabledData: // value for 'disabledData'
 *   },
 * });
 */
export function useEntityConfigSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQEntityConfigSaveMutation,
        GQEntityConfigSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQEntityConfigSaveMutation,
        GQEntityConfigSaveMutationVariables
    >(EntityConfigSaveDocument, options);
}
export type EntityConfigSaveMutationHookResult = ReturnType<
    typeof useEntityConfigSaveMutation
>;
export type EntityConfigSaveMutationResult =
    ApolloReactCommon.MutationResult<GQEntityConfigSaveMutation>;
export type EntityConfigSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQEntityConfigSaveMutation,
        GQEntityConfigSaveMutationVariables
    >;
export const EntityConfigDeleteDocument = gql`
    mutation entityConfigDelete($entityId: ID!) {
        entityConfigDelete(entityId: $entityId) {
            status
        }
    }
`;
export type GQEntityConfigDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQEntityConfigDeleteMutation,
    GQEntityConfigDeleteMutationVariables
>;

/**
 * __useEntityConfigDeleteMutation__
 *
 * To run a mutation, you first call `useEntityConfigDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityConfigDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityConfigDeleteMutation, { data, loading, error }] = useEntityConfigDeleteMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useEntityConfigDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQEntityConfigDeleteMutation,
        GQEntityConfigDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQEntityConfigDeleteMutation,
        GQEntityConfigDeleteMutationVariables
    >(EntityConfigDeleteDocument, options);
}
export type EntityConfigDeleteMutationHookResult = ReturnType<
    typeof useEntityConfigDeleteMutation
>;
export type EntityConfigDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQEntityConfigDeleteMutation>;
export type EntityConfigDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQEntityConfigDeleteMutation,
        GQEntityConfigDeleteMutationVariables
    >;
export const AccountsDocument = gql`
    query accounts(
        $pagination: PaginationInput
        $search: SearchInput
        $searching: AccountSearchInput
    ) {
        accounts(
            pagination: $pagination
            search: $search
            searching: $searching
        ) {
            data {
                ...allAccountFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllAccountFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useAccountsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQAccountsQuery,
        GQAccountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQAccountsQuery, GQAccountsQueryVariables>(
        AccountsDocument,
        options
    );
}
export function useAccountsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAccountsQuery,
        GQAccountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAccountsQuery,
        GQAccountsQueryVariables
    >(AccountsDocument, options);
}
// @ts-ignore
export function useAccountsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAccountsQuery,
        GQAccountsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountsQuery,
    GQAccountsQueryVariables
>;
export function useAccountsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountsQuery,
              GQAccountsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountsQuery | undefined,
    GQAccountsQueryVariables
>;
export function useAccountsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountsQuery,
              GQAccountsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAccountsQuery,
        GQAccountsQueryVariables
    >(AccountsDocument, options);
}
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<
    typeof useAccountsLazyQuery
>;
export type AccountsSuspenseQueryHookResult = ReturnType<
    typeof useAccountsSuspenseQuery
>;
export type AccountsQueryResult = ApolloReactCommon.QueryResult<
    GQAccountsQuery,
    GQAccountsQueryVariables
>;
export const GiftCardsDocument = gql`
    query giftCards(
        $pagination: PaginationInput
        $search: SearchInput
        $status: [String]
        $searching: AccountSearchInput
    ) {
        giftCards(
            pagination: $pagination
            search: $search
            status: $status
            searching: $searching
        ) {
            data {
                ...allAccountFields
                tags(
                    pagination: {
                        pageSize: 99999
                        sort: "name"
                        sortDirection: "ASC"
                    }
                ) {
                    data {
                        ...tagScreenFields
                    }
                    pagination {
                        ...defaultPaginationFields
                    }
                }
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllAccountFieldsFragmentDoc}
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useGiftCardsQuery__
 *
 * To run a query within a React component, call `useGiftCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useGiftCardsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQGiftCardsQuery,
        GQGiftCardsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQGiftCardsQuery,
        GQGiftCardsQueryVariables
    >(GiftCardsDocument, options);
}
export function useGiftCardsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQGiftCardsQuery,
        GQGiftCardsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQGiftCardsQuery,
        GQGiftCardsQueryVariables
    >(GiftCardsDocument, options);
}
// @ts-ignore
export function useGiftCardsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQGiftCardsQuery,
        GQGiftCardsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQGiftCardsQuery,
    GQGiftCardsQueryVariables
>;
export function useGiftCardsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQGiftCardsQuery,
              GQGiftCardsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQGiftCardsQuery | undefined,
    GQGiftCardsQueryVariables
>;
export function useGiftCardsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQGiftCardsQuery,
              GQGiftCardsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQGiftCardsQuery,
        GQGiftCardsQueryVariables
    >(GiftCardsDocument, options);
}
export type GiftCardsQueryHookResult = ReturnType<typeof useGiftCardsQuery>;
export type GiftCardsLazyQueryHookResult = ReturnType<
    typeof useGiftCardsLazyQuery
>;
export type GiftCardsSuspenseQueryHookResult = ReturnType<
    typeof useGiftCardsSuspenseQuery
>;
export type GiftCardsQueryResult = ApolloReactCommon.QueryResult<
    GQGiftCardsQuery,
    GQGiftCardsQueryVariables
>;
export const CustomerAccountsDocument = gql`
    query customerAccounts($customerId: ID, $pagination: PaginationInput) {
        customerAccounts(customerId: $customerId, pagination: $pagination) {
            data {
                ...allAccountFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllAccountFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCustomerAccountsQuery__
 *
 * To run a query within a React component, call `useCustomerAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAccountsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCustomerAccountsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQCustomerAccountsQuery,
        GQCustomerAccountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCustomerAccountsQuery,
        GQCustomerAccountsQueryVariables
    >(CustomerAccountsDocument, options);
}
export function useCustomerAccountsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCustomerAccountsQuery,
        GQCustomerAccountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCustomerAccountsQuery,
        GQCustomerAccountsQueryVariables
    >(CustomerAccountsDocument, options);
}
// @ts-ignore
export function useCustomerAccountsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCustomerAccountsQuery,
        GQCustomerAccountsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomerAccountsQuery,
    GQCustomerAccountsQueryVariables
>;
export function useCustomerAccountsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomerAccountsQuery,
              GQCustomerAccountsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomerAccountsQuery | undefined,
    GQCustomerAccountsQueryVariables
>;
export function useCustomerAccountsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomerAccountsQuery,
              GQCustomerAccountsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCustomerAccountsQuery,
        GQCustomerAccountsQueryVariables
    >(CustomerAccountsDocument, options);
}
export type CustomerAccountsQueryHookResult = ReturnType<
    typeof useCustomerAccountsQuery
>;
export type CustomerAccountsLazyQueryHookResult = ReturnType<
    typeof useCustomerAccountsLazyQuery
>;
export type CustomerAccountsSuspenseQueryHookResult = ReturnType<
    typeof useCustomerAccountsSuspenseQuery
>;
export type CustomerAccountsQueryResult = ApolloReactCommon.QueryResult<
    GQCustomerAccountsQuery,
    GQCustomerAccountsQueryVariables
>;
export const BookkeepingAccountsDocument = gql`
    query bookkeepingAccounts(
        $pagination: PaginationInput
        $search: SearchInput
    ) {
        bookkeepingAccounts(pagination: $pagination, search: $search) {
            data {
                ...allBookkeepingAccountFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllBookkeepingAccountFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useBookkeepingAccountsQuery__
 *
 * To run a query within a React component, call `useBookkeepingAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookkeepingAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookkeepingAccountsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useBookkeepingAccountsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQBookkeepingAccountsQuery,
        GQBookkeepingAccountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQBookkeepingAccountsQuery,
        GQBookkeepingAccountsQueryVariables
    >(BookkeepingAccountsDocument, options);
}
export function useBookkeepingAccountsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQBookkeepingAccountsQuery,
        GQBookkeepingAccountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQBookkeepingAccountsQuery,
        GQBookkeepingAccountsQueryVariables
    >(BookkeepingAccountsDocument, options);
}
// @ts-ignore
export function useBookkeepingAccountsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQBookkeepingAccountsQuery,
        GQBookkeepingAccountsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQBookkeepingAccountsQuery,
    GQBookkeepingAccountsQueryVariables
>;
export function useBookkeepingAccountsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQBookkeepingAccountsQuery,
              GQBookkeepingAccountsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQBookkeepingAccountsQuery | undefined,
    GQBookkeepingAccountsQueryVariables
>;
export function useBookkeepingAccountsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQBookkeepingAccountsQuery,
              GQBookkeepingAccountsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQBookkeepingAccountsQuery,
        GQBookkeepingAccountsQueryVariables
    >(BookkeepingAccountsDocument, options);
}
export type BookkeepingAccountsQueryHookResult = ReturnType<
    typeof useBookkeepingAccountsQuery
>;
export type BookkeepingAccountsLazyQueryHookResult = ReturnType<
    typeof useBookkeepingAccountsLazyQuery
>;
export type BookkeepingAccountsSuspenseQueryHookResult = ReturnType<
    typeof useBookkeepingAccountsSuspenseQuery
>;
export type BookkeepingAccountsQueryResult = ApolloReactCommon.QueryResult<
    GQBookkeepingAccountsQuery,
    GQBookkeepingAccountsQueryVariables
>;
export const AccountDocument = gql`
    query account(
        $id: ID!
        $transactionPagination: PaginationInput
        $transactionSearch: SearchInput
        $searching: AccountTransactionSearchInput
        $tagPagination: PaginationInput
        $tagSearch: SearchInput
        $numberOfTransactions: Int
    ) {
        account(id: $id) {
            ...allAccountFields
            transactions(
                pagination: $transactionPagination
                search: $transactionSearch
                searching: $searching
            ) {
                data {
                    ...allAccountTransactionFields
                }
                pagination {
                    ...defaultPaginationFields
                }
            }
            tags(pagination: $tagPagination, search: $tagSearch) {
                data {
                    ...tagScreenFields
                }
                pagination {
                    ...defaultPaginationFields
                }
            }
            balance(numberOfTransactions: $numberOfTransactions) {
                receipt
            }
        }
    }
    ${AllAccountFieldsFragmentDoc}
    ${AllAccountTransactionFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
    ${TagScreenFieldsFragmentDoc}
`;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      transactionPagination: // value for 'transactionPagination'
 *      transactionSearch: // value for 'transactionSearch'
 *      searching: // value for 'searching'
 *      tagPagination: // value for 'tagPagination'
 *      tagSearch: // value for 'tagSearch'
 *      numberOfTransactions: // value for 'numberOfTransactions'
 *   },
 * });
 */
export function useAccountQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQAccountQuery,
        GQAccountQueryVariables
    > &
        (
            | { variables: GQAccountQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQAccountQuery, GQAccountQueryVariables>(
        AccountDocument,
        options
    );
}
export function useAccountLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAccountQuery,
        GQAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAccountQuery,
        GQAccountQueryVariables
    >(AccountDocument, options);
}
// @ts-ignore
export function useAccountSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAccountQuery,
        GQAccountQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountQuery,
    GQAccountQueryVariables
>;
export function useAccountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountQuery,
              GQAccountQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountQuery | undefined,
    GQAccountQueryVariables
>;
export function useAccountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountQuery,
              GQAccountQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAccountQuery,
        GQAccountQueryVariables
    >(AccountDocument, options);
}
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountSuspenseQueryHookResult = ReturnType<
    typeof useAccountSuspenseQuery
>;
export type AccountQueryResult = ApolloReactCommon.QueryResult<
    GQAccountQuery,
    GQAccountQueryVariables
>;
export const BookkeepingAccountDocument = gql`
    query bookkeepingAccount(
        $id: ID!
        $transactionPagination: PaginationInput
        $transactionSearch: SearchInput
        $searching: AccountBookkeepingTransactionSearchInput
    ) {
        bookkeepingAccount(id: $id) {
            ...allBookkeepingAccountFields
            bookkeepingTransactions(
                pagination: $transactionPagination
                search: $transactionSearch
                searching: $searching
            ) {
                data {
                    ...allAccountBookkeepingTransactionFields
                }
                pagination {
                    ...defaultPaginationFields
                }
            }
        }
    }
    ${AllBookkeepingAccountFieldsFragmentDoc}
    ${AllAccountBookkeepingTransactionFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useBookkeepingAccountQuery__
 *
 * To run a query within a React component, call `useBookkeepingAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookkeepingAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookkeepingAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      transactionPagination: // value for 'transactionPagination'
 *      transactionSearch: // value for 'transactionSearch'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useBookkeepingAccountQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQBookkeepingAccountQuery,
        GQBookkeepingAccountQueryVariables
    > &
        (
            | { variables: GQBookkeepingAccountQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQBookkeepingAccountQuery,
        GQBookkeepingAccountQueryVariables
    >(BookkeepingAccountDocument, options);
}
export function useBookkeepingAccountLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQBookkeepingAccountQuery,
        GQBookkeepingAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQBookkeepingAccountQuery,
        GQBookkeepingAccountQueryVariables
    >(BookkeepingAccountDocument, options);
}
// @ts-ignore
export function useBookkeepingAccountSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQBookkeepingAccountQuery,
        GQBookkeepingAccountQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQBookkeepingAccountQuery,
    GQBookkeepingAccountQueryVariables
>;
export function useBookkeepingAccountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQBookkeepingAccountQuery,
              GQBookkeepingAccountQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQBookkeepingAccountQuery | undefined,
    GQBookkeepingAccountQueryVariables
>;
export function useBookkeepingAccountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQBookkeepingAccountQuery,
              GQBookkeepingAccountQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQBookkeepingAccountQuery,
        GQBookkeepingAccountQueryVariables
    >(BookkeepingAccountDocument, options);
}
export type BookkeepingAccountQueryHookResult = ReturnType<
    typeof useBookkeepingAccountQuery
>;
export type BookkeepingAccountLazyQueryHookResult = ReturnType<
    typeof useBookkeepingAccountLazyQuery
>;
export type BookkeepingAccountSuspenseQueryHookResult = ReturnType<
    typeof useBookkeepingAccountSuspenseQuery
>;
export type BookkeepingAccountQueryResult = ApolloReactCommon.QueryResult<
    GQBookkeepingAccountQuery,
    GQBookkeepingAccountQueryVariables
>;
export const AccountEnabledTagsDocument = gql`
    query accountEnabledTags(
        $id: ID!
        $tagPagination: PaginationInput
        $tagSearch: SearchInput
    ) {
        account(id: $id) {
            tags(pagination: $tagPagination, search: $tagSearch) {
                data {
                    ...tagScreenFields
                }
                pagination {
                    ...defaultPaginationFields
                }
            }
        }
    }
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useAccountEnabledTagsQuery__
 *
 * To run a query within a React component, call `useAccountEnabledTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountEnabledTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountEnabledTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tagPagination: // value for 'tagPagination'
 *      tagSearch: // value for 'tagSearch'
 *   },
 * });
 */
export function useAccountEnabledTagsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQAccountEnabledTagsQuery,
        GQAccountEnabledTagsQueryVariables
    > &
        (
            | { variables: GQAccountEnabledTagsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAccountEnabledTagsQuery,
        GQAccountEnabledTagsQueryVariables
    >(AccountEnabledTagsDocument, options);
}
export function useAccountEnabledTagsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAccountEnabledTagsQuery,
        GQAccountEnabledTagsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAccountEnabledTagsQuery,
        GQAccountEnabledTagsQueryVariables
    >(AccountEnabledTagsDocument, options);
}
// @ts-ignore
export function useAccountEnabledTagsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAccountEnabledTagsQuery,
        GQAccountEnabledTagsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountEnabledTagsQuery,
    GQAccountEnabledTagsQueryVariables
>;
export function useAccountEnabledTagsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountEnabledTagsQuery,
              GQAccountEnabledTagsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountEnabledTagsQuery | undefined,
    GQAccountEnabledTagsQueryVariables
>;
export function useAccountEnabledTagsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountEnabledTagsQuery,
              GQAccountEnabledTagsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAccountEnabledTagsQuery,
        GQAccountEnabledTagsQueryVariables
    >(AccountEnabledTagsDocument, options);
}
export type AccountEnabledTagsQueryHookResult = ReturnType<
    typeof useAccountEnabledTagsQuery
>;
export type AccountEnabledTagsLazyQueryHookResult = ReturnType<
    typeof useAccountEnabledTagsLazyQuery
>;
export type AccountEnabledTagsSuspenseQueryHookResult = ReturnType<
    typeof useAccountEnabledTagsSuspenseQuery
>;
export type AccountEnabledTagsQueryResult = ApolloReactCommon.QueryResult<
    GQAccountEnabledTagsQuery,
    GQAccountEnabledTagsQueryVariables
>;
export const AccountTagsViewDocument = gql`
    query accountTagsView(
        $id: ID!
        $tagPagination: PaginationInput
        $tagSearch: SearchInput
    ) {
        account(id: $id) {
            ...allAccountFields
            tags(pagination: $tagPagination, search: $tagSearch) {
                data {
                    ...tagScreenFields
                }
                pagination {
                    ...defaultPaginationFields
                }
            }
        }
    }
    ${AllAccountFieldsFragmentDoc}
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useAccountTagsViewQuery__
 *
 * To run a query within a React component, call `useAccountTagsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTagsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTagsViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tagPagination: // value for 'tagPagination'
 *      tagSearch: // value for 'tagSearch'
 *   },
 * });
 */
export function useAccountTagsViewQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQAccountTagsViewQuery,
        GQAccountTagsViewQueryVariables
    > &
        (
            | { variables: GQAccountTagsViewQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAccountTagsViewQuery,
        GQAccountTagsViewQueryVariables
    >(AccountTagsViewDocument, options);
}
export function useAccountTagsViewLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAccountTagsViewQuery,
        GQAccountTagsViewQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAccountTagsViewQuery,
        GQAccountTagsViewQueryVariables
    >(AccountTagsViewDocument, options);
}
// @ts-ignore
export function useAccountTagsViewSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAccountTagsViewQuery,
        GQAccountTagsViewQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountTagsViewQuery,
    GQAccountTagsViewQueryVariables
>;
export function useAccountTagsViewSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountTagsViewQuery,
              GQAccountTagsViewQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountTagsViewQuery | undefined,
    GQAccountTagsViewQueryVariables
>;
export function useAccountTagsViewSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountTagsViewQuery,
              GQAccountTagsViewQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAccountTagsViewQuery,
        GQAccountTagsViewQueryVariables
    >(AccountTagsViewDocument, options);
}
export type AccountTagsViewQueryHookResult = ReturnType<
    typeof useAccountTagsViewQuery
>;
export type AccountTagsViewLazyQueryHookResult = ReturnType<
    typeof useAccountTagsViewLazyQuery
>;
export type AccountTagsViewSuspenseQueryHookResult = ReturnType<
    typeof useAccountTagsViewSuspenseQuery
>;
export type AccountTagsViewQueryResult = ApolloReactCommon.QueryResult<
    GQAccountTagsViewQuery,
    GQAccountTagsViewQueryVariables
>;
export const AllTransactionsDocument = gql`
    query allTransactions(
        $pagination: PaginationInput
        $accountId: String
        $searching: AccountTransactionSearchInput
    ) {
        transactions(
            pagination: $pagination
            accountId: $accountId
            searching: $searching
        ) {
            data {
                ...allAccountTransactionFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllAccountTransactionFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useAllTransactionsQuery__
 *
 * To run a query within a React component, call `useAllTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTransactionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      accountId: // value for 'accountId'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useAllTransactionsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQAllTransactionsQuery,
        GQAllTransactionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAllTransactionsQuery,
        GQAllTransactionsQueryVariables
    >(AllTransactionsDocument, options);
}
export function useAllTransactionsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAllTransactionsQuery,
        GQAllTransactionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAllTransactionsQuery,
        GQAllTransactionsQueryVariables
    >(AllTransactionsDocument, options);
}
// @ts-ignore
export function useAllTransactionsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAllTransactionsQuery,
        GQAllTransactionsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAllTransactionsQuery,
    GQAllTransactionsQueryVariables
>;
export function useAllTransactionsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAllTransactionsQuery,
              GQAllTransactionsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAllTransactionsQuery | undefined,
    GQAllTransactionsQueryVariables
>;
export function useAllTransactionsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAllTransactionsQuery,
              GQAllTransactionsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAllTransactionsQuery,
        GQAllTransactionsQueryVariables
    >(AllTransactionsDocument, options);
}
export type AllTransactionsQueryHookResult = ReturnType<
    typeof useAllTransactionsQuery
>;
export type AllTransactionsLazyQueryHookResult = ReturnType<
    typeof useAllTransactionsLazyQuery
>;
export type AllTransactionsSuspenseQueryHookResult = ReturnType<
    typeof useAllTransactionsSuspenseQuery
>;
export type AllTransactionsQueryResult = ApolloReactCommon.QueryResult<
    GQAllTransactionsQuery,
    GQAllTransactionsQueryVariables
>;
export const IsAccountNameInUseDocument = gql`
    query isAccountNameInUse($name: String, $customerId: ID, $accountId: ID) {
        isAccountNameInUse(
            name: $name
            customerId: $customerId
            accountId: $accountId
        ) {
            status
        }
    }
`;

/**
 * __useIsAccountNameInUseQuery__
 *
 * To run a query within a React component, call `useIsAccountNameInUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAccountNameInUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAccountNameInUseQuery({
 *   variables: {
 *      name: // value for 'name'
 *      customerId: // value for 'customerId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useIsAccountNameInUseQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQIsAccountNameInUseQuery,
        GQIsAccountNameInUseQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQIsAccountNameInUseQuery,
        GQIsAccountNameInUseQueryVariables
    >(IsAccountNameInUseDocument, options);
}
export function useIsAccountNameInUseLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQIsAccountNameInUseQuery,
        GQIsAccountNameInUseQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQIsAccountNameInUseQuery,
        GQIsAccountNameInUseQueryVariables
    >(IsAccountNameInUseDocument, options);
}
// @ts-ignore
export function useIsAccountNameInUseSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQIsAccountNameInUseQuery,
        GQIsAccountNameInUseQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIsAccountNameInUseQuery,
    GQIsAccountNameInUseQueryVariables
>;
export function useIsAccountNameInUseSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIsAccountNameInUseQuery,
              GQIsAccountNameInUseQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIsAccountNameInUseQuery | undefined,
    GQIsAccountNameInUseQueryVariables
>;
export function useIsAccountNameInUseSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIsAccountNameInUseQuery,
              GQIsAccountNameInUseQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQIsAccountNameInUseQuery,
        GQIsAccountNameInUseQueryVariables
    >(IsAccountNameInUseDocument, options);
}
export type IsAccountNameInUseQueryHookResult = ReturnType<
    typeof useIsAccountNameInUseQuery
>;
export type IsAccountNameInUseLazyQueryHookResult = ReturnType<
    typeof useIsAccountNameInUseLazyQuery
>;
export type IsAccountNameInUseSuspenseQueryHookResult = ReturnType<
    typeof useIsAccountNameInUseSuspenseQuery
>;
export type IsAccountNameInUseQueryResult = ApolloReactCommon.QueryResult<
    GQIsAccountNameInUseQuery,
    GQIsAccountNameInUseQueryVariables
>;
export const AccountCreateDocument = gql`
    mutation accountCreate($account: AccountCreate!) {
        accountCreate(account: $account) {
            ...allAccountFields
        }
    }
    ${AllAccountFieldsFragmentDoc}
`;
export type GQAccountCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQAccountCreateMutation,
    GQAccountCreateMutationVariables
>;

/**
 * __useAccountCreateMutation__
 *
 * To run a mutation, you first call `useAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountCreateMutation, { data, loading, error }] = useAccountCreateMutation({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useAccountCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountCreateMutation,
        GQAccountCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountCreateMutation,
        GQAccountCreateMutationVariables
    >(AccountCreateDocument, options);
}
export type AccountCreateMutationHookResult = ReturnType<
    typeof useAccountCreateMutation
>;
export type AccountCreateMutationResult =
    ApolloReactCommon.MutationResult<GQAccountCreateMutation>;
export type AccountCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAccountCreateMutation,
        GQAccountCreateMutationVariables
    >;
export const AccountSaveDocument = gql`
    mutation accountSave($id: ID!, $account: AccountInput!) {
        accountSave(id: $id, account: $account) {
            ...allAccountFields
        }
    }
    ${AllAccountFieldsFragmentDoc}
`;
export type GQAccountSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQAccountSaveMutation,
    GQAccountSaveMutationVariables
>;

/**
 * __useAccountSaveMutation__
 *
 * To run a mutation, you first call `useAccountSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSaveMutation, { data, loading, error }] = useAccountSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useAccountSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountSaveMutation,
        GQAccountSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountSaveMutation,
        GQAccountSaveMutationVariables
    >(AccountSaveDocument, options);
}
export type AccountSaveMutationHookResult = ReturnType<
    typeof useAccountSaveMutation
>;
export type AccountSaveMutationResult =
    ApolloReactCommon.MutationResult<GQAccountSaveMutation>;
export type AccountSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQAccountSaveMutation,
    GQAccountSaveMutationVariables
>;
export const AccountCloseDocument = gql`
    mutation accountClose($id: ID!) {
        accountClose(id: $id) {
            status
        }
    }
`;
export type GQAccountCloseMutationFn = ApolloReactCommon.MutationFunction<
    GQAccountCloseMutation,
    GQAccountCloseMutationVariables
>;

/**
 * __useAccountCloseMutation__
 *
 * To run a mutation, you first call `useAccountCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountCloseMutation, { data, loading, error }] = useAccountCloseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountCloseMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountCloseMutation,
        GQAccountCloseMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountCloseMutation,
        GQAccountCloseMutationVariables
    >(AccountCloseDocument, options);
}
export type AccountCloseMutationHookResult = ReturnType<
    typeof useAccountCloseMutation
>;
export type AccountCloseMutationResult =
    ApolloReactCommon.MutationResult<GQAccountCloseMutation>;
export type AccountCloseMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQAccountCloseMutation,
    GQAccountCloseMutationVariables
>;
export const AccountOpenDocument = gql`
    mutation accountOpen($id: ID!) {
        accountOpen(id: $id) {
            status
        }
    }
`;
export type GQAccountOpenMutationFn = ApolloReactCommon.MutationFunction<
    GQAccountOpenMutation,
    GQAccountOpenMutationVariables
>;

/**
 * __useAccountOpenMutation__
 *
 * To run a mutation, you first call `useAccountOpenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountOpenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountOpenMutation, { data, loading, error }] = useAccountOpenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountOpenMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountOpenMutation,
        GQAccountOpenMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountOpenMutation,
        GQAccountOpenMutationVariables
    >(AccountOpenDocument, options);
}
export type AccountOpenMutationHookResult = ReturnType<
    typeof useAccountOpenMutation
>;
export type AccountOpenMutationResult =
    ApolloReactCommon.MutationResult<GQAccountOpenMutation>;
export type AccountOpenMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQAccountOpenMutation,
    GQAccountOpenMutationVariables
>;
export const AccountAssignTagsDocument = gql`
    mutation accountAssignTags($id: ID!, $tagIds: [ID!]!) {
        accountAssignTags(id: $id, tagIds: $tagIds) {
            status
        }
    }
`;
export type GQAccountAssignTagsMutationFn = ApolloReactCommon.MutationFunction<
    GQAccountAssignTagsMutation,
    GQAccountAssignTagsMutationVariables
>;

/**
 * __useAccountAssignTagsMutation__
 *
 * To run a mutation, you first call `useAccountAssignTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAssignTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAssignTagsMutation, { data, loading, error }] = useAccountAssignTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useAccountAssignTagsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountAssignTagsMutation,
        GQAccountAssignTagsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountAssignTagsMutation,
        GQAccountAssignTagsMutationVariables
    >(AccountAssignTagsDocument, options);
}
export type AccountAssignTagsMutationHookResult = ReturnType<
    typeof useAccountAssignTagsMutation
>;
export type AccountAssignTagsMutationResult =
    ApolloReactCommon.MutationResult<GQAccountAssignTagsMutation>;
export type AccountAssignTagsMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAccountAssignTagsMutation,
        GQAccountAssignTagsMutationVariables
    >;
export const AccountPayAmountDocument = gql`
    mutation accountPayAmount(
        $id: ID!
        $orderId: ID!
        $amount: Float!
        $userId: ID!
        $tagId: ID
        $tagIdentifier: String
        $printWidth: Int
    ) {
        accountPayAmount(
            id: $id
            orderId: $orderId
            amount: $amount
            userId: $userId
            tagId: $tagId
            tagIdentifier: $tagIdentifier
            printWidth: $printWidth
        ) {
            transactionId
            status
            type
            receipt
        }
    }
`;
export type GQAccountPayAmountMutationFn = ApolloReactCommon.MutationFunction<
    GQAccountPayAmountMutation,
    GQAccountPayAmountMutationVariables
>;

/**
 * __useAccountPayAmountMutation__
 *
 * To run a mutation, you first call `useAccountPayAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountPayAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountPayAmountMutation, { data, loading, error }] = useAccountPayAmountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orderId: // value for 'orderId'
 *      amount: // value for 'amount'
 *      userId: // value for 'userId'
 *      tagId: // value for 'tagId'
 *      tagIdentifier: // value for 'tagIdentifier'
 *      printWidth: // value for 'printWidth'
 *   },
 * });
 */
export function useAccountPayAmountMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountPayAmountMutation,
        GQAccountPayAmountMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountPayAmountMutation,
        GQAccountPayAmountMutationVariables
    >(AccountPayAmountDocument, options);
}
export type AccountPayAmountMutationHookResult = ReturnType<
    typeof useAccountPayAmountMutation
>;
export type AccountPayAmountMutationResult =
    ApolloReactCommon.MutationResult<GQAccountPayAmountMutation>;
export type AccountPayAmountMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAccountPayAmountMutation,
        GQAccountPayAmountMutationVariables
    >;
export const AccountRefundAmountDocument = gql`
    mutation accountRefundAmount(
        $id: ID!
        $orderId: ID!
        $amount: Float!
        $userId: ID!
        $tagId: ID
        $tagIdentifier: String
        $printWidth: Int
    ) {
        accountRefundAmount(
            id: $id
            orderId: $orderId
            amount: $amount
            userId: $userId
            tagId: $tagId
            tagIdentifier: $tagIdentifier
            printWidth: $printWidth
        ) {
            transactionId
            status
            type
            receipt
        }
    }
`;
export type GQAccountRefundAmountMutationFn =
    ApolloReactCommon.MutationFunction<
        GQAccountRefundAmountMutation,
        GQAccountRefundAmountMutationVariables
    >;

/**
 * __useAccountRefundAmountMutation__
 *
 * To run a mutation, you first call `useAccountRefundAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRefundAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRefundAmountMutation, { data, loading, error }] = useAccountRefundAmountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orderId: // value for 'orderId'
 *      amount: // value for 'amount'
 *      userId: // value for 'userId'
 *      tagId: // value for 'tagId'
 *      tagIdentifier: // value for 'tagIdentifier'
 *      printWidth: // value for 'printWidth'
 *   },
 * });
 */
export function useAccountRefundAmountMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountRefundAmountMutation,
        GQAccountRefundAmountMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountRefundAmountMutation,
        GQAccountRefundAmountMutationVariables
    >(AccountRefundAmountDocument, options);
}
export type AccountRefundAmountMutationHookResult = ReturnType<
    typeof useAccountRefundAmountMutation
>;
export type AccountRefundAmountMutationResult =
    ApolloReactCommon.MutationResult<GQAccountRefundAmountMutation>;
export type AccountRefundAmountMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAccountRefundAmountMutation,
        GQAccountRefundAmountMutationVariables
    >;
export const AccountReissueGiftcardDocument = gql`
    mutation accountReissueGiftcard($id: ID!) {
        accountReissueGiftcard(id: $id) {
            status
        }
    }
`;
export type GQAccountReissueGiftcardMutationFn =
    ApolloReactCommon.MutationFunction<
        GQAccountReissueGiftcardMutation,
        GQAccountReissueGiftcardMutationVariables
    >;

/**
 * __useAccountReissueGiftcardMutation__
 *
 * To run a mutation, you first call `useAccountReissueGiftcardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountReissueGiftcardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountReissueGiftcardMutation, { data, loading, error }] = useAccountReissueGiftcardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountReissueGiftcardMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountReissueGiftcardMutation,
        GQAccountReissueGiftcardMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountReissueGiftcardMutation,
        GQAccountReissueGiftcardMutationVariables
    >(AccountReissueGiftcardDocument, options);
}
export type AccountReissueGiftcardMutationHookResult = ReturnType<
    typeof useAccountReissueGiftcardMutation
>;
export type AccountReissueGiftcardMutationResult =
    ApolloReactCommon.MutationResult<GQAccountReissueGiftcardMutation>;
export type AccountReissueGiftcardMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAccountReissueGiftcardMutation,
        GQAccountReissueGiftcardMutationVariables
    >;
export const AccountReissueGiftcardsDocument = gql`
    mutation accountReissueGiftcards($ids: [ID!]!) {
        accountReissueGiftcards(ids: $ids) {
            status
        }
    }
`;
export type GQAccountReissueGiftcardsMutationFn =
    ApolloReactCommon.MutationFunction<
        GQAccountReissueGiftcardsMutation,
        GQAccountReissueGiftcardsMutationVariables
    >;

/**
 * __useAccountReissueGiftcardsMutation__
 *
 * To run a mutation, you first call `useAccountReissueGiftcardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountReissueGiftcardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountReissueGiftcardsMutation, { data, loading, error }] = useAccountReissueGiftcardsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAccountReissueGiftcardsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountReissueGiftcardsMutation,
        GQAccountReissueGiftcardsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountReissueGiftcardsMutation,
        GQAccountReissueGiftcardsMutationVariables
    >(AccountReissueGiftcardsDocument, options);
}
export type AccountReissueGiftcardsMutationHookResult = ReturnType<
    typeof useAccountReissueGiftcardsMutation
>;
export type AccountReissueGiftcardsMutationResult =
    ApolloReactCommon.MutationResult<GQAccountReissueGiftcardsMutation>;
export type AccountReissueGiftcardsMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAccountReissueGiftcardsMutation,
        GQAccountReissueGiftcardsMutationVariables
    >;
export const CustomersDocument = gql`
    query customers(
        $pagination: PaginationInput
        $search: SearchInput
        $searching: CustomerSearchInput
    ) {
        customers(
            pagination: $pagination
            search: $search
            searching: $searching
        ) {
            data {
                ...customerScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${CustomerScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCustomersQuery__
 *
 * To run a query within a React component, call `useCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useCustomersQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQCustomersQuery,
        GQCustomersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCustomersQuery,
        GQCustomersQueryVariables
    >(CustomersDocument, options);
}
export function useCustomersLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCustomersQuery,
        GQCustomersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCustomersQuery,
        GQCustomersQueryVariables
    >(CustomersDocument, options);
}
// @ts-ignore
export function useCustomersSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCustomersQuery,
        GQCustomersQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomersQuery,
    GQCustomersQueryVariables
>;
export function useCustomersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomersQuery,
              GQCustomersQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomersQuery | undefined,
    GQCustomersQueryVariables
>;
export function useCustomersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomersQuery,
              GQCustomersQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCustomersQuery,
        GQCustomersQueryVariables
    >(CustomersDocument, options);
}
export type CustomersQueryHookResult = ReturnType<typeof useCustomersQuery>;
export type CustomersLazyQueryHookResult = ReturnType<
    typeof useCustomersLazyQuery
>;
export type CustomersSuspenseQueryHookResult = ReturnType<
    typeof useCustomersSuspenseQuery
>;
export type CustomersQueryResult = ApolloReactCommon.QueryResult<
    GQCustomersQuery,
    GQCustomersQueryVariables
>;
export const CustomerDocument = gql`
    query customer(
        $id: ID!
        $tagPagination: PaginationInput
        $tagSearch: SearchInput
    ) {
        customer(id: $id) {
            ...customerScreenFields
            tags(pagination: $tagPagination, search: $tagSearch) {
                data {
                    ...tagScreenFields
                }
                pagination {
                    ...defaultPaginationFields
                }
            }
        }
    }
    ${CustomerScreenFieldsFragmentDoc}
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tagPagination: // value for 'tagPagination'
 *      tagSearch: // value for 'tagSearch'
 *   },
 * });
 */
export function useCustomerQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCustomerQuery,
        GQCustomerQueryVariables
    > &
        (
            | { variables: GQCustomerQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQCustomerQuery, GQCustomerQueryVariables>(
        CustomerDocument,
        options
    );
}
export function useCustomerLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCustomerQuery,
        GQCustomerQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCustomerQuery,
        GQCustomerQueryVariables
    >(CustomerDocument, options);
}
// @ts-ignore
export function useCustomerSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCustomerQuery,
        GQCustomerQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomerQuery,
    GQCustomerQueryVariables
>;
export function useCustomerSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomerQuery,
              GQCustomerQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomerQuery | undefined,
    GQCustomerQueryVariables
>;
export function useCustomerSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomerQuery,
              GQCustomerQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCustomerQuery,
        GQCustomerQueryVariables
    >(CustomerDocument, options);
}
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<
    typeof useCustomerLazyQuery
>;
export type CustomerSuspenseQueryHookResult = ReturnType<
    typeof useCustomerSuspenseQuery
>;
export type CustomerQueryResult = ApolloReactCommon.QueryResult<
    GQCustomerQuery,
    GQCustomerQueryVariables
>;
export const CustomersInGroupDocument = gql`
    query customersInGroup(
        $groupId: ID!
        $pagination: PaginationInput
        $search: SearchInput
    ) {
        customersInGroup(
            groupId: $groupId
            pagination: $pagination
            search: $search
        ) {
            data {
                ...customerScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${CustomerScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCustomersInGroupQuery__
 *
 * To run a query within a React component, call `useCustomersInGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersInGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersInGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCustomersInGroupQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCustomersInGroupQuery,
        GQCustomersInGroupQueryVariables
    > &
        (
            | { variables: GQCustomersInGroupQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCustomersInGroupQuery,
        GQCustomersInGroupQueryVariables
    >(CustomersInGroupDocument, options);
}
export function useCustomersInGroupLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCustomersInGroupQuery,
        GQCustomersInGroupQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCustomersInGroupQuery,
        GQCustomersInGroupQueryVariables
    >(CustomersInGroupDocument, options);
}
// @ts-ignore
export function useCustomersInGroupSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCustomersInGroupQuery,
        GQCustomersInGroupQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomersInGroupQuery,
    GQCustomersInGroupQueryVariables
>;
export function useCustomersInGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomersInGroupQuery,
              GQCustomersInGroupQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomersInGroupQuery | undefined,
    GQCustomersInGroupQueryVariables
>;
export function useCustomersInGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomersInGroupQuery,
              GQCustomersInGroupQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCustomersInGroupQuery,
        GQCustomersInGroupQueryVariables
    >(CustomersInGroupDocument, options);
}
export type CustomersInGroupQueryHookResult = ReturnType<
    typeof useCustomersInGroupQuery
>;
export type CustomersInGroupLazyQueryHookResult = ReturnType<
    typeof useCustomersInGroupLazyQuery
>;
export type CustomersInGroupSuspenseQueryHookResult = ReturnType<
    typeof useCustomersInGroupSuspenseQuery
>;
export type CustomersInGroupQueryResult = ApolloReactCommon.QueryResult<
    GQCustomersInGroupQuery,
    GQCustomersInGroupQueryVariables
>;
export const CustomerFormDocument = gql`
    query customerForm {
        customers(pagination: { pageSize: 99999 }) {
            data {
                id
                name
            }
        }
        customerGroups(pagination: { pageSize: 99999 }) {
            data {
                id
                name
            }
        }
    }
`;

/**
 * __useCustomerFormQuery__
 *
 * To run a query within a React component, call `useCustomerFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQCustomerFormQuery,
        GQCustomerFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCustomerFormQuery,
        GQCustomerFormQueryVariables
    >(CustomerFormDocument, options);
}
export function useCustomerFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCustomerFormQuery,
        GQCustomerFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCustomerFormQuery,
        GQCustomerFormQueryVariables
    >(CustomerFormDocument, options);
}
// @ts-ignore
export function useCustomerFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCustomerFormQuery,
        GQCustomerFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomerFormQuery,
    GQCustomerFormQueryVariables
>;
export function useCustomerFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomerFormQuery,
              GQCustomerFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomerFormQuery | undefined,
    GQCustomerFormQueryVariables
>;
export function useCustomerFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomerFormQuery,
              GQCustomerFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCustomerFormQuery,
        GQCustomerFormQueryVariables
    >(CustomerFormDocument, options);
}
export type CustomerFormQueryHookResult = ReturnType<
    typeof useCustomerFormQuery
>;
export type CustomerFormLazyQueryHookResult = ReturnType<
    typeof useCustomerFormLazyQuery
>;
export type CustomerFormSuspenseQueryHookResult = ReturnType<
    typeof useCustomerFormSuspenseQuery
>;
export type CustomerFormQueryResult = ApolloReactCommon.QueryResult<
    GQCustomerFormQuery,
    GQCustomerFormQueryVariables
>;
export const CustomerCreateDocument = gql`
    mutation customerCreate($customer: CustomerInput!) {
        customerCreate(customer: $customer) {
            ...customerScreenFields
        }
    }
    ${CustomerScreenFieldsFragmentDoc}
`;
export type GQCustomerCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQCustomerCreateMutation,
    GQCustomerCreateMutationVariables
>;

/**
 * __useCustomerCreateMutation__
 *
 * To run a mutation, you first call `useCustomerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerCreateMutation, { data, loading, error }] = useCustomerCreateMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useCustomerCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCustomerCreateMutation,
        GQCustomerCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCustomerCreateMutation,
        GQCustomerCreateMutationVariables
    >(CustomerCreateDocument, options);
}
export type CustomerCreateMutationHookResult = ReturnType<
    typeof useCustomerCreateMutation
>;
export type CustomerCreateMutationResult =
    ApolloReactCommon.MutationResult<GQCustomerCreateMutation>;
export type CustomerCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCustomerCreateMutation,
        GQCustomerCreateMutationVariables
    >;
export const CustomerSaveDocument = gql`
    mutation customerSave($id: ID!, $customer: CustomerInput!) {
        customerSave(id: $id, customer: $customer) {
            ...customerScreenFields
        }
    }
    ${CustomerScreenFieldsFragmentDoc}
`;
export type GQCustomerSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQCustomerSaveMutation,
    GQCustomerSaveMutationVariables
>;

/**
 * __useCustomerSaveMutation__
 *
 * To run a mutation, you first call `useCustomerSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerSaveMutation, { data, loading, error }] = useCustomerSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useCustomerSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCustomerSaveMutation,
        GQCustomerSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCustomerSaveMutation,
        GQCustomerSaveMutationVariables
    >(CustomerSaveDocument, options);
}
export type CustomerSaveMutationHookResult = ReturnType<
    typeof useCustomerSaveMutation
>;
export type CustomerSaveMutationResult =
    ApolloReactCommon.MutationResult<GQCustomerSaveMutation>;
export type CustomerSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQCustomerSaveMutation,
    GQCustomerSaveMutationVariables
>;
export const CustomerDeleteDocument = gql`
    mutation customerDelete($id: ID!) {
        customerDelete(id: $id) {
            status
        }
    }
`;
export type GQCustomerDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQCustomerDeleteMutation,
    GQCustomerDeleteMutationVariables
>;

/**
 * __useCustomerDeleteMutation__
 *
 * To run a mutation, you first call `useCustomerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerDeleteMutation, { data, loading, error }] = useCustomerDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCustomerDeleteMutation,
        GQCustomerDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCustomerDeleteMutation,
        GQCustomerDeleteMutationVariables
    >(CustomerDeleteDocument, options);
}
export type CustomerDeleteMutationHookResult = ReturnType<
    typeof useCustomerDeleteMutation
>;
export type CustomerDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQCustomerDeleteMutation>;
export type CustomerDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCustomerDeleteMutation,
        GQCustomerDeleteMutationVariables
    >;
export const CustomerAssignTagsDocument = gql`
    mutation customerAssignTags($id: ID!, $tagIds: [ID!]!) {
        customerAssignTags(id: $id, tagIds: $tagIds) {
            status
        }
    }
`;
export type GQCustomerAssignTagsMutationFn = ApolloReactCommon.MutationFunction<
    GQCustomerAssignTagsMutation,
    GQCustomerAssignTagsMutationVariables
>;

/**
 * __useCustomerAssignTagsMutation__
 *
 * To run a mutation, you first call `useCustomerAssignTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerAssignTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerAssignTagsMutation, { data, loading, error }] = useCustomerAssignTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useCustomerAssignTagsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCustomerAssignTagsMutation,
        GQCustomerAssignTagsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCustomerAssignTagsMutation,
        GQCustomerAssignTagsMutationVariables
    >(CustomerAssignTagsDocument, options);
}
export type CustomerAssignTagsMutationHookResult = ReturnType<
    typeof useCustomerAssignTagsMutation
>;
export type CustomerAssignTagsMutationResult =
    ApolloReactCommon.MutationResult<GQCustomerAssignTagsMutation>;
export type CustomerAssignTagsMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCustomerAssignTagsMutation,
        GQCustomerAssignTagsMutationVariables
    >;
export const CustomerGroupsDocument = gql`
    query customerGroups(
        $pagination: PaginationInput
        $search: SearchInput
        $searching: CustomerGroupSearchInput
    ) {
        customerGroups(
            pagination: $pagination
            search: $search
            searching: $searching
        ) {
            data {
                ...customerGroupScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${CustomerGroupScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCustomerGroupsQuery__
 *
 * To run a query within a React component, call `useCustomerGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useCustomerGroupsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQCustomerGroupsQuery,
        GQCustomerGroupsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCustomerGroupsQuery,
        GQCustomerGroupsQueryVariables
    >(CustomerGroupsDocument, options);
}
export function useCustomerGroupsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCustomerGroupsQuery,
        GQCustomerGroupsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCustomerGroupsQuery,
        GQCustomerGroupsQueryVariables
    >(CustomerGroupsDocument, options);
}
// @ts-ignore
export function useCustomerGroupsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCustomerGroupsQuery,
        GQCustomerGroupsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomerGroupsQuery,
    GQCustomerGroupsQueryVariables
>;
export function useCustomerGroupsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomerGroupsQuery,
              GQCustomerGroupsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomerGroupsQuery | undefined,
    GQCustomerGroupsQueryVariables
>;
export function useCustomerGroupsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomerGroupsQuery,
              GQCustomerGroupsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCustomerGroupsQuery,
        GQCustomerGroupsQueryVariables
    >(CustomerGroupsDocument, options);
}
export type CustomerGroupsQueryHookResult = ReturnType<
    typeof useCustomerGroupsQuery
>;
export type CustomerGroupsLazyQueryHookResult = ReturnType<
    typeof useCustomerGroupsLazyQuery
>;
export type CustomerGroupsSuspenseQueryHookResult = ReturnType<
    typeof useCustomerGroupsSuspenseQuery
>;
export type CustomerGroupsQueryResult = ApolloReactCommon.QueryResult<
    GQCustomerGroupsQuery,
    GQCustomerGroupsQueryVariables
>;
export const CustomerGroupDocument = gql`
    query customerGroup($id: ID!) {
        customerGroup(id: $id) {
            ...customerGroupScreenFields
        }
    }
    ${CustomerGroupScreenFieldsFragmentDoc}
`;

/**
 * __useCustomerGroupQuery__
 *
 * To run a query within a React component, call `useCustomerGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerGroupQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCustomerGroupQuery,
        GQCustomerGroupQueryVariables
    > &
        (
            | { variables: GQCustomerGroupQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCustomerGroupQuery,
        GQCustomerGroupQueryVariables
    >(CustomerGroupDocument, options);
}
export function useCustomerGroupLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCustomerGroupQuery,
        GQCustomerGroupQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCustomerGroupQuery,
        GQCustomerGroupQueryVariables
    >(CustomerGroupDocument, options);
}
// @ts-ignore
export function useCustomerGroupSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCustomerGroupQuery,
        GQCustomerGroupQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomerGroupQuery,
    GQCustomerGroupQueryVariables
>;
export function useCustomerGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomerGroupQuery,
              GQCustomerGroupQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCustomerGroupQuery | undefined,
    GQCustomerGroupQueryVariables
>;
export function useCustomerGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCustomerGroupQuery,
              GQCustomerGroupQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCustomerGroupQuery,
        GQCustomerGroupQueryVariables
    >(CustomerGroupDocument, options);
}
export type CustomerGroupQueryHookResult = ReturnType<
    typeof useCustomerGroupQuery
>;
export type CustomerGroupLazyQueryHookResult = ReturnType<
    typeof useCustomerGroupLazyQuery
>;
export type CustomerGroupSuspenseQueryHookResult = ReturnType<
    typeof useCustomerGroupSuspenseQuery
>;
export type CustomerGroupQueryResult = ApolloReactCommon.QueryResult<
    GQCustomerGroupQuery,
    GQCustomerGroupQueryVariables
>;
export const CustomerGroupCreateDocument = gql`
    mutation customerGroupCreate($customerGroup: CustomerGroupInput!) {
        customerGroupCreate(customerGroup: $customerGroup) {
            ...customerGroupScreenFields
        }
    }
    ${CustomerGroupScreenFieldsFragmentDoc}
`;
export type GQCustomerGroupCreateMutationFn =
    ApolloReactCommon.MutationFunction<
        GQCustomerGroupCreateMutation,
        GQCustomerGroupCreateMutationVariables
    >;

/**
 * __useCustomerGroupCreateMutation__
 *
 * To run a mutation, you first call `useCustomerGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerGroupCreateMutation, { data, loading, error }] = useCustomerGroupCreateMutation({
 *   variables: {
 *      customerGroup: // value for 'customerGroup'
 *   },
 * });
 */
export function useCustomerGroupCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCustomerGroupCreateMutation,
        GQCustomerGroupCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCustomerGroupCreateMutation,
        GQCustomerGroupCreateMutationVariables
    >(CustomerGroupCreateDocument, options);
}
export type CustomerGroupCreateMutationHookResult = ReturnType<
    typeof useCustomerGroupCreateMutation
>;
export type CustomerGroupCreateMutationResult =
    ApolloReactCommon.MutationResult<GQCustomerGroupCreateMutation>;
export type CustomerGroupCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCustomerGroupCreateMutation,
        GQCustomerGroupCreateMutationVariables
    >;
export const CustomerGroupSaveDocument = gql`
    mutation customerGroupSave($id: ID!, $customerGroup: CustomerGroupInput!) {
        customerGroupSave(id: $id, customerGroup: $customerGroup) {
            ...customerGroupScreenFields
        }
    }
    ${CustomerGroupScreenFieldsFragmentDoc}
`;
export type GQCustomerGroupSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQCustomerGroupSaveMutation,
    GQCustomerGroupSaveMutationVariables
>;

/**
 * __useCustomerGroupSaveMutation__
 *
 * To run a mutation, you first call `useCustomerGroupSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerGroupSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerGroupSaveMutation, { data, loading, error }] = useCustomerGroupSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customerGroup: // value for 'customerGroup'
 *   },
 * });
 */
export function useCustomerGroupSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCustomerGroupSaveMutation,
        GQCustomerGroupSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCustomerGroupSaveMutation,
        GQCustomerGroupSaveMutationVariables
    >(CustomerGroupSaveDocument, options);
}
export type CustomerGroupSaveMutationHookResult = ReturnType<
    typeof useCustomerGroupSaveMutation
>;
export type CustomerGroupSaveMutationResult =
    ApolloReactCommon.MutationResult<GQCustomerGroupSaveMutation>;
export type CustomerGroupSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCustomerGroupSaveMutation,
        GQCustomerGroupSaveMutationVariables
    >;
export const CustomerGroupDeleteDocument = gql`
    mutation customerGroupDelete($id: ID!) {
        customerGroupDelete(id: $id) {
            status
        }
    }
`;
export type GQCustomerGroupDeleteMutationFn =
    ApolloReactCommon.MutationFunction<
        GQCustomerGroupDeleteMutation,
        GQCustomerGroupDeleteMutationVariables
    >;

/**
 * __useCustomerGroupDeleteMutation__
 *
 * To run a mutation, you first call `useCustomerGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerGroupDeleteMutation, { data, loading, error }] = useCustomerGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerGroupDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCustomerGroupDeleteMutation,
        GQCustomerGroupDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCustomerGroupDeleteMutation,
        GQCustomerGroupDeleteMutationVariables
    >(CustomerGroupDeleteDocument, options);
}
export type CustomerGroupDeleteMutationHookResult = ReturnType<
    typeof useCustomerGroupDeleteMutation
>;
export type CustomerGroupDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQCustomerGroupDeleteMutation>;
export type CustomerGroupDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCustomerGroupDeleteMutation,
        GQCustomerGroupDeleteMutationVariables
    >;
export const AdyenSessionsDocument = gql`
    query adyenSessions {
        adyenSessions {
            id
            token
        }
    }
`;

/**
 * __useAdyenSessionsQuery__
 *
 * To run a query within a React component, call `useAdyenSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdyenSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdyenSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdyenSessionsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQAdyenSessionsQuery,
        GQAdyenSessionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAdyenSessionsQuery,
        GQAdyenSessionsQueryVariables
    >(AdyenSessionsDocument, options);
}
export function useAdyenSessionsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAdyenSessionsQuery,
        GQAdyenSessionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAdyenSessionsQuery,
        GQAdyenSessionsQueryVariables
    >(AdyenSessionsDocument, options);
}
// @ts-ignore
export function useAdyenSessionsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAdyenSessionsQuery,
        GQAdyenSessionsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAdyenSessionsQuery,
    GQAdyenSessionsQueryVariables
>;
export function useAdyenSessionsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAdyenSessionsQuery,
              GQAdyenSessionsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAdyenSessionsQuery | undefined,
    GQAdyenSessionsQueryVariables
>;
export function useAdyenSessionsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAdyenSessionsQuery,
              GQAdyenSessionsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAdyenSessionsQuery,
        GQAdyenSessionsQueryVariables
    >(AdyenSessionsDocument, options);
}
export type AdyenSessionsQueryHookResult = ReturnType<
    typeof useAdyenSessionsQuery
>;
export type AdyenSessionsLazyQueryHookResult = ReturnType<
    typeof useAdyenSessionsLazyQuery
>;
export type AdyenSessionsSuspenseQueryHookResult = ReturnType<
    typeof useAdyenSessionsSuspenseQuery
>;
export type AdyenSessionsQueryResult = ApolloReactCommon.QueryResult<
    GQAdyenSessionsQuery,
    GQAdyenSessionsQueryVariables
>;
export const AdyenStoresDocument = gql`
    query adyenStores($pagination: PaginationInput) {
        adyenStores(pagination: $pagination) {
            data {
                id
                description
                externalReferenceId
                merchantId
                phoneNumber
                reference
                shopperStatement
                status
                address {
                    city
                    country
                    line1
                    line2
                    line3
                    postalCode
                    stateOrProvince
                }
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useAdyenStoresQuery__
 *
 * To run a query within a React component, call `useAdyenStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdyenStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdyenStoresQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAdyenStoresQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQAdyenStoresQuery,
        GQAdyenStoresQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAdyenStoresQuery,
        GQAdyenStoresQueryVariables
    >(AdyenStoresDocument, options);
}
export function useAdyenStoresLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAdyenStoresQuery,
        GQAdyenStoresQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAdyenStoresQuery,
        GQAdyenStoresQueryVariables
    >(AdyenStoresDocument, options);
}
// @ts-ignore
export function useAdyenStoresSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAdyenStoresQuery,
        GQAdyenStoresQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAdyenStoresQuery,
    GQAdyenStoresQueryVariables
>;
export function useAdyenStoresSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAdyenStoresQuery,
              GQAdyenStoresQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAdyenStoresQuery | undefined,
    GQAdyenStoresQueryVariables
>;
export function useAdyenStoresSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAdyenStoresQuery,
              GQAdyenStoresQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAdyenStoresQuery,
        GQAdyenStoresQueryVariables
    >(AdyenStoresDocument, options);
}
export type AdyenStoresQueryHookResult = ReturnType<typeof useAdyenStoresQuery>;
export type AdyenStoresLazyQueryHookResult = ReturnType<
    typeof useAdyenStoresLazyQuery
>;
export type AdyenStoresSuspenseQueryHookResult = ReturnType<
    typeof useAdyenStoresSuspenseQuery
>;
export type AdyenStoresQueryResult = ApolloReactCommon.QueryResult<
    GQAdyenStoresQuery,
    GQAdyenStoresQueryVariables
>;
export const AdyenTerminalsDocument = gql`
    query adyenTerminals($pagination: PaginationInput) {
        adyenTerminals(pagination: $pagination) {
            data {
                id
                model
                serialNumber
                lastActivityAt
                lastTransactionAt
                firmwareVersion
                restartLocalTime
                assignment {
                    companyId
                    merchantId
                    storeId
                    status
                }
                connectivity {
                    bluetooth {
                        ipAddress
                        macAddress
                    }
                    cellular {
                        iccid
                        iccid2
                        status
                    }
                    ethernet {
                        ipAddress
                        linkNegotiation
                        macAddress
                    }
                    wifi {
                        ipAddress
                        macAddress
                        ssid
                    }
                }
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useAdyenTerminalsQuery__
 *
 * To run a query within a React component, call `useAdyenTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdyenTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdyenTerminalsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAdyenTerminalsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQAdyenTerminalsQuery,
        GQAdyenTerminalsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAdyenTerminalsQuery,
        GQAdyenTerminalsQueryVariables
    >(AdyenTerminalsDocument, options);
}
export function useAdyenTerminalsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAdyenTerminalsQuery,
        GQAdyenTerminalsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAdyenTerminalsQuery,
        GQAdyenTerminalsQueryVariables
    >(AdyenTerminalsDocument, options);
}
// @ts-ignore
export function useAdyenTerminalsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAdyenTerminalsQuery,
        GQAdyenTerminalsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAdyenTerminalsQuery,
    GQAdyenTerminalsQueryVariables
>;
export function useAdyenTerminalsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAdyenTerminalsQuery,
              GQAdyenTerminalsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAdyenTerminalsQuery | undefined,
    GQAdyenTerminalsQueryVariables
>;
export function useAdyenTerminalsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAdyenTerminalsQuery,
              GQAdyenTerminalsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAdyenTerminalsQuery,
        GQAdyenTerminalsQueryVariables
    >(AdyenTerminalsDocument, options);
}
export type AdyenTerminalsQueryHookResult = ReturnType<
    typeof useAdyenTerminalsQuery
>;
export type AdyenTerminalsLazyQueryHookResult = ReturnType<
    typeof useAdyenTerminalsLazyQuery
>;
export type AdyenTerminalsSuspenseQueryHookResult = ReturnType<
    typeof useAdyenTerminalsSuspenseQuery
>;
export type AdyenTerminalsQueryResult = ApolloReactCommon.QueryResult<
    GQAdyenTerminalsQuery,
    GQAdyenTerminalsQueryVariables
>;
export const ApprovalsDocument = gql`
    query approvals(
        $pagination: PaginationInput
        $searching: ApprovalSearchInput
    ) {
        approvals(pagination: $pagination, searching: $searching) {
            data {
                ...allApprovalFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllApprovalFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useApprovalsQuery__
 *
 * To run a query within a React component, call `useApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useApprovalsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQApprovalsQuery,
        GQApprovalsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQApprovalsQuery,
        GQApprovalsQueryVariables
    >(ApprovalsDocument, options);
}
export function useApprovalsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQApprovalsQuery,
        GQApprovalsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQApprovalsQuery,
        GQApprovalsQueryVariables
    >(ApprovalsDocument, options);
}
// @ts-ignore
export function useApprovalsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQApprovalsQuery,
        GQApprovalsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalsQuery,
    GQApprovalsQueryVariables
>;
export function useApprovalsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalsQuery,
              GQApprovalsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalsQuery | undefined,
    GQApprovalsQueryVariables
>;
export function useApprovalsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalsQuery,
              GQApprovalsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQApprovalsQuery,
        GQApprovalsQueryVariables
    >(ApprovalsDocument, options);
}
export type ApprovalsQueryHookResult = ReturnType<typeof useApprovalsQuery>;
export type ApprovalsLazyQueryHookResult = ReturnType<
    typeof useApprovalsLazyQuery
>;
export type ApprovalsSuspenseQueryHookResult = ReturnType<
    typeof useApprovalsSuspenseQuery
>;
export type ApprovalsQueryResult = ApolloReactCommon.QueryResult<
    GQApprovalsQuery,
    GQApprovalsQueryVariables
>;
export const ApprovalTokensDocument = gql`
    query approvalTokens(
        $pagination: PaginationInput
        $searching: ApprovalTokenSearchInput
    ) {
        approvalTokens(pagination: $pagination, searching: $searching) {
            data {
                ...allApprovalTokenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllApprovalTokenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useApprovalTokensQuery__
 *
 * To run a query within a React component, call `useApprovalTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalTokensQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useApprovalTokensQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQApprovalTokensQuery,
        GQApprovalTokensQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQApprovalTokensQuery,
        GQApprovalTokensQueryVariables
    >(ApprovalTokensDocument, options);
}
export function useApprovalTokensLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQApprovalTokensQuery,
        GQApprovalTokensQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQApprovalTokensQuery,
        GQApprovalTokensQueryVariables
    >(ApprovalTokensDocument, options);
}
// @ts-ignore
export function useApprovalTokensSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQApprovalTokensQuery,
        GQApprovalTokensQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokensQuery,
    GQApprovalTokensQueryVariables
>;
export function useApprovalTokensSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokensQuery,
              GQApprovalTokensQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokensQuery | undefined,
    GQApprovalTokensQueryVariables
>;
export function useApprovalTokensSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokensQuery,
              GQApprovalTokensQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQApprovalTokensQuery,
        GQApprovalTokensQueryVariables
    >(ApprovalTokensDocument, options);
}
export type ApprovalTokensQueryHookResult = ReturnType<
    typeof useApprovalTokensQuery
>;
export type ApprovalTokensLazyQueryHookResult = ReturnType<
    typeof useApprovalTokensLazyQuery
>;
export type ApprovalTokensSuspenseQueryHookResult = ReturnType<
    typeof useApprovalTokensSuspenseQuery
>;
export type ApprovalTokensQueryResult = ApolloReactCommon.QueryResult<
    GQApprovalTokensQuery,
    GQApprovalTokensQueryVariables
>;
export const ApprovalTokenGroupsDocument = gql`
    query approvalTokenGroups(
        $pagination: PaginationInput
        $searching: ApprovalTokenGroupSearchInput
    ) {
        approvalTokenGroups(pagination: $pagination, searching: $searching) {
            data {
                ...allApprovalTokenGroupFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllApprovalTokenGroupFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useApprovalTokenGroupsQuery__
 *
 * To run a query within a React component, call `useApprovalTokenGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalTokenGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useApprovalTokenGroupsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQApprovalTokenGroupsQuery,
        GQApprovalTokenGroupsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQApprovalTokenGroupsQuery,
        GQApprovalTokenGroupsQueryVariables
    >(ApprovalTokenGroupsDocument, options);
}
export function useApprovalTokenGroupsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQApprovalTokenGroupsQuery,
        GQApprovalTokenGroupsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQApprovalTokenGroupsQuery,
        GQApprovalTokenGroupsQueryVariables
    >(ApprovalTokenGroupsDocument, options);
}
// @ts-ignore
export function useApprovalTokenGroupsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQApprovalTokenGroupsQuery,
        GQApprovalTokenGroupsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokenGroupsQuery,
    GQApprovalTokenGroupsQueryVariables
>;
export function useApprovalTokenGroupsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokenGroupsQuery,
              GQApprovalTokenGroupsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokenGroupsQuery | undefined,
    GQApprovalTokenGroupsQueryVariables
>;
export function useApprovalTokenGroupsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokenGroupsQuery,
              GQApprovalTokenGroupsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQApprovalTokenGroupsQuery,
        GQApprovalTokenGroupsQueryVariables
    >(ApprovalTokenGroupsDocument, options);
}
export type ApprovalTokenGroupsQueryHookResult = ReturnType<
    typeof useApprovalTokenGroupsQuery
>;
export type ApprovalTokenGroupsLazyQueryHookResult = ReturnType<
    typeof useApprovalTokenGroupsLazyQuery
>;
export type ApprovalTokenGroupsSuspenseQueryHookResult = ReturnType<
    typeof useApprovalTokenGroupsSuspenseQuery
>;
export type ApprovalTokenGroupsQueryResult = ApolloReactCommon.QueryResult<
    GQApprovalTokenGroupsQuery,
    GQApprovalTokenGroupsQueryVariables
>;
export const ApprovalDocument = gql`
    query approval($id: ID!) {
        approval(id: $id) {
            ...allApprovalFields
        }
    }
    ${AllApprovalFieldsFragmentDoc}
`;

/**
 * __useApprovalQuery__
 *
 * To run a query within a React component, call `useApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApprovalQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQApprovalQuery,
        GQApprovalQueryVariables
    > &
        (
            | { variables: GQApprovalQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQApprovalQuery, GQApprovalQueryVariables>(
        ApprovalDocument,
        options
    );
}
export function useApprovalLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQApprovalQuery,
        GQApprovalQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQApprovalQuery,
        GQApprovalQueryVariables
    >(ApprovalDocument, options);
}
// @ts-ignore
export function useApprovalSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQApprovalQuery,
        GQApprovalQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalQuery,
    GQApprovalQueryVariables
>;
export function useApprovalSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalQuery,
              GQApprovalQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalQuery | undefined,
    GQApprovalQueryVariables
>;
export function useApprovalSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalQuery,
              GQApprovalQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQApprovalQuery,
        GQApprovalQueryVariables
    >(ApprovalDocument, options);
}
export type ApprovalQueryHookResult = ReturnType<typeof useApprovalQuery>;
export type ApprovalLazyQueryHookResult = ReturnType<
    typeof useApprovalLazyQuery
>;
export type ApprovalSuspenseQueryHookResult = ReturnType<
    typeof useApprovalSuspenseQuery
>;
export type ApprovalQueryResult = ApolloReactCommon.QueryResult<
    GQApprovalQuery,
    GQApprovalQueryVariables
>;
export const ApprovalTokenDocument = gql`
    query approvalToken($id: ID!) {
        approvalToken(id: $id) {
            ...allApprovalTokenFields
        }
    }
    ${AllApprovalTokenFieldsFragmentDoc}
`;

/**
 * __useApprovalTokenQuery__
 *
 * To run a query within a React component, call `useApprovalTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApprovalTokenQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQApprovalTokenQuery,
        GQApprovalTokenQueryVariables
    > &
        (
            | { variables: GQApprovalTokenQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQApprovalTokenQuery,
        GQApprovalTokenQueryVariables
    >(ApprovalTokenDocument, options);
}
export function useApprovalTokenLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQApprovalTokenQuery,
        GQApprovalTokenQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQApprovalTokenQuery,
        GQApprovalTokenQueryVariables
    >(ApprovalTokenDocument, options);
}
// @ts-ignore
export function useApprovalTokenSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQApprovalTokenQuery,
        GQApprovalTokenQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokenQuery,
    GQApprovalTokenQueryVariables
>;
export function useApprovalTokenSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokenQuery,
              GQApprovalTokenQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokenQuery | undefined,
    GQApprovalTokenQueryVariables
>;
export function useApprovalTokenSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokenQuery,
              GQApprovalTokenQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQApprovalTokenQuery,
        GQApprovalTokenQueryVariables
    >(ApprovalTokenDocument, options);
}
export type ApprovalTokenQueryHookResult = ReturnType<
    typeof useApprovalTokenQuery
>;
export type ApprovalTokenLazyQueryHookResult = ReturnType<
    typeof useApprovalTokenLazyQuery
>;
export type ApprovalTokenSuspenseQueryHookResult = ReturnType<
    typeof useApprovalTokenSuspenseQuery
>;
export type ApprovalTokenQueryResult = ApolloReactCommon.QueryResult<
    GQApprovalTokenQuery,
    GQApprovalTokenQueryVariables
>;
export const ApprovalTokenGroupDocument = gql`
    query approvalTokenGroup($id: ID!) {
        approvalTokenGroup(id: $id) {
            ...allApprovalTokenGroupFields
        }
    }
    ${AllApprovalTokenGroupFieldsFragmentDoc}
`;

/**
 * __useApprovalTokenGroupQuery__
 *
 * To run a query within a React component, call `useApprovalTokenGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalTokenGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApprovalTokenGroupQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQApprovalTokenGroupQuery,
        GQApprovalTokenGroupQueryVariables
    > &
        (
            | { variables: GQApprovalTokenGroupQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQApprovalTokenGroupQuery,
        GQApprovalTokenGroupQueryVariables
    >(ApprovalTokenGroupDocument, options);
}
export function useApprovalTokenGroupLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQApprovalTokenGroupQuery,
        GQApprovalTokenGroupQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQApprovalTokenGroupQuery,
        GQApprovalTokenGroupQueryVariables
    >(ApprovalTokenGroupDocument, options);
}
// @ts-ignore
export function useApprovalTokenGroupSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQApprovalTokenGroupQuery,
        GQApprovalTokenGroupQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokenGroupQuery,
    GQApprovalTokenGroupQueryVariables
>;
export function useApprovalTokenGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokenGroupQuery,
              GQApprovalTokenGroupQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokenGroupQuery | undefined,
    GQApprovalTokenGroupQueryVariables
>;
export function useApprovalTokenGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokenGroupQuery,
              GQApprovalTokenGroupQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQApprovalTokenGroupQuery,
        GQApprovalTokenGroupQueryVariables
    >(ApprovalTokenGroupDocument, options);
}
export type ApprovalTokenGroupQueryHookResult = ReturnType<
    typeof useApprovalTokenGroupQuery
>;
export type ApprovalTokenGroupLazyQueryHookResult = ReturnType<
    typeof useApprovalTokenGroupLazyQuery
>;
export type ApprovalTokenGroupSuspenseQueryHookResult = ReturnType<
    typeof useApprovalTokenGroupSuspenseQuery
>;
export type ApprovalTokenGroupQueryResult = ApolloReactCommon.QueryResult<
    GQApprovalTokenGroupQuery,
    GQApprovalTokenGroupQueryVariables
>;
export const ApprovalDeleteDocument = gql`
    mutation approvalDelete($id: ID!) {
        approvalDelete(id: $id) {
            status
        }
    }
`;
export type GQApprovalDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQApprovalDeleteMutation,
    GQApprovalDeleteMutationVariables
>;

/**
 * __useApprovalDeleteMutation__
 *
 * To run a mutation, you first call `useApprovalDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalDeleteMutation, { data, loading, error }] = useApprovalDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApprovalDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQApprovalDeleteMutation,
        GQApprovalDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQApprovalDeleteMutation,
        GQApprovalDeleteMutationVariables
    >(ApprovalDeleteDocument, options);
}
export type ApprovalDeleteMutationHookResult = ReturnType<
    typeof useApprovalDeleteMutation
>;
export type ApprovalDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQApprovalDeleteMutation>;
export type ApprovalDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQApprovalDeleteMutation,
        GQApprovalDeleteMutationVariables
    >;
export const ApprovalTokenDeleteDocument = gql`
    mutation approvalTokenDelete($id: ID!) {
        approvalTokenDelete(id: $id) {
            status
        }
    }
`;
export type GQApprovalTokenDeleteMutationFn =
    ApolloReactCommon.MutationFunction<
        GQApprovalTokenDeleteMutation,
        GQApprovalTokenDeleteMutationVariables
    >;

/**
 * __useApprovalTokenDeleteMutation__
 *
 * To run a mutation, you first call `useApprovalTokenDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalTokenDeleteMutation, { data, loading, error }] = useApprovalTokenDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApprovalTokenDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQApprovalTokenDeleteMutation,
        GQApprovalTokenDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQApprovalTokenDeleteMutation,
        GQApprovalTokenDeleteMutationVariables
    >(ApprovalTokenDeleteDocument, options);
}
export type ApprovalTokenDeleteMutationHookResult = ReturnType<
    typeof useApprovalTokenDeleteMutation
>;
export type ApprovalTokenDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQApprovalTokenDeleteMutation>;
export type ApprovalTokenDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQApprovalTokenDeleteMutation,
        GQApprovalTokenDeleteMutationVariables
    >;
export const ApprovalTokenGroupDeleteDocument = gql`
    mutation approvalTokenGroupDelete($id: ID!) {
        approvalTokenGroupDelete(id: $id) {
            status
        }
    }
`;
export type GQApprovalTokenGroupDeleteMutationFn =
    ApolloReactCommon.MutationFunction<
        GQApprovalTokenGroupDeleteMutation,
        GQApprovalTokenGroupDeleteMutationVariables
    >;

/**
 * __useApprovalTokenGroupDeleteMutation__
 *
 * To run a mutation, you first call `useApprovalTokenGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalTokenGroupDeleteMutation, { data, loading, error }] = useApprovalTokenGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApprovalTokenGroupDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQApprovalTokenGroupDeleteMutation,
        GQApprovalTokenGroupDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQApprovalTokenGroupDeleteMutation,
        GQApprovalTokenGroupDeleteMutationVariables
    >(ApprovalTokenGroupDeleteDocument, options);
}
export type ApprovalTokenGroupDeleteMutationHookResult = ReturnType<
    typeof useApprovalTokenGroupDeleteMutation
>;
export type ApprovalTokenGroupDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQApprovalTokenGroupDeleteMutation>;
export type ApprovalTokenGroupDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQApprovalTokenGroupDeleteMutation,
        GQApprovalTokenGroupDeleteMutationVariables
    >;
export const ApprovalCreateDocument = gql`
    mutation approvalCreate($approval: ApprovalInput!) {
        approvalCreate(approval: $approval) {
            type
            active
        }
    }
`;
export type GQApprovalCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQApprovalCreateMutation,
    GQApprovalCreateMutationVariables
>;

/**
 * __useApprovalCreateMutation__
 *
 * To run a mutation, you first call `useApprovalCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalCreateMutation, { data, loading, error }] = useApprovalCreateMutation({
 *   variables: {
 *      approval: // value for 'approval'
 *   },
 * });
 */
export function useApprovalCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQApprovalCreateMutation,
        GQApprovalCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQApprovalCreateMutation,
        GQApprovalCreateMutationVariables
    >(ApprovalCreateDocument, options);
}
export type ApprovalCreateMutationHookResult = ReturnType<
    typeof useApprovalCreateMutation
>;
export type ApprovalCreateMutationResult =
    ApolloReactCommon.MutationResult<GQApprovalCreateMutation>;
export type ApprovalCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQApprovalCreateMutation,
        GQApprovalCreateMutationVariables
    >;
export const ApprovalTokenCreateDocument = gql`
    mutation approvalTokenCreate($approvalToken: ApprovalTokenInput!) {
        approvalTokenCreate(approvalToken: $approvalToken) {
            name
            approvalTokenGroupId
            value
            type
            active
        }
    }
`;
export type GQApprovalTokenCreateMutationFn =
    ApolloReactCommon.MutationFunction<
        GQApprovalTokenCreateMutation,
        GQApprovalTokenCreateMutationVariables
    >;

/**
 * __useApprovalTokenCreateMutation__
 *
 * To run a mutation, you first call `useApprovalTokenCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalTokenCreateMutation, { data, loading, error }] = useApprovalTokenCreateMutation({
 *   variables: {
 *      approvalToken: // value for 'approvalToken'
 *   },
 * });
 */
export function useApprovalTokenCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQApprovalTokenCreateMutation,
        GQApprovalTokenCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQApprovalTokenCreateMutation,
        GQApprovalTokenCreateMutationVariables
    >(ApprovalTokenCreateDocument, options);
}
export type ApprovalTokenCreateMutationHookResult = ReturnType<
    typeof useApprovalTokenCreateMutation
>;
export type ApprovalTokenCreateMutationResult =
    ApolloReactCommon.MutationResult<GQApprovalTokenCreateMutation>;
export type ApprovalTokenCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQApprovalTokenCreateMutation,
        GQApprovalTokenCreateMutationVariables
    >;
export const ApprovalTokenGroupCreateDocument = gql`
    mutation approvalTokenGroupCreate(
        $approvalTokenGroup: ApprovalTokenGroupInput!
    ) {
        approvalTokenGroupCreate(approvalTokenGroup: $approvalTokenGroup) {
            name
            active
        }
    }
`;
export type GQApprovalTokenGroupCreateMutationFn =
    ApolloReactCommon.MutationFunction<
        GQApprovalTokenGroupCreateMutation,
        GQApprovalTokenGroupCreateMutationVariables
    >;

/**
 * __useApprovalTokenGroupCreateMutation__
 *
 * To run a mutation, you first call `useApprovalTokenGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalTokenGroupCreateMutation, { data, loading, error }] = useApprovalTokenGroupCreateMutation({
 *   variables: {
 *      approvalTokenGroup: // value for 'approvalTokenGroup'
 *   },
 * });
 */
export function useApprovalTokenGroupCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQApprovalTokenGroupCreateMutation,
        GQApprovalTokenGroupCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQApprovalTokenGroupCreateMutation,
        GQApprovalTokenGroupCreateMutationVariables
    >(ApprovalTokenGroupCreateDocument, options);
}
export type ApprovalTokenGroupCreateMutationHookResult = ReturnType<
    typeof useApprovalTokenGroupCreateMutation
>;
export type ApprovalTokenGroupCreateMutationResult =
    ApolloReactCommon.MutationResult<GQApprovalTokenGroupCreateMutation>;
export type ApprovalTokenGroupCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQApprovalTokenGroupCreateMutation,
        GQApprovalTokenGroupCreateMutationVariables
    >;
export const ApprovalSaveDocument = gql`
    mutation approvalSave($id: ID!, $approval: ApprovalInput!) {
        approvalSave(id: $id, approval: $approval) {
            type
            active
        }
    }
`;
export type GQApprovalSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQApprovalSaveMutation,
    GQApprovalSaveMutationVariables
>;

/**
 * __useApprovalSaveMutation__
 *
 * To run a mutation, you first call `useApprovalSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalSaveMutation, { data, loading, error }] = useApprovalSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      approval: // value for 'approval'
 *   },
 * });
 */
export function useApprovalSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQApprovalSaveMutation,
        GQApprovalSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQApprovalSaveMutation,
        GQApprovalSaveMutationVariables
    >(ApprovalSaveDocument, options);
}
export type ApprovalSaveMutationHookResult = ReturnType<
    typeof useApprovalSaveMutation
>;
export type ApprovalSaveMutationResult =
    ApolloReactCommon.MutationResult<GQApprovalSaveMutation>;
export type ApprovalSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQApprovalSaveMutation,
    GQApprovalSaveMutationVariables
>;
export const ApprovalTokenSaveDocument = gql`
    mutation approvalTokenSave($id: ID!, $approvalToken: ApprovalTokenInput!) {
        approvalTokenSave(id: $id, approvalToken: $approvalToken) {
            name
            approvalTokenGroupId
            value
            type
            active
        }
    }
`;
export type GQApprovalTokenSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQApprovalTokenSaveMutation,
    GQApprovalTokenSaveMutationVariables
>;

/**
 * __useApprovalTokenSaveMutation__
 *
 * To run a mutation, you first call `useApprovalTokenSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalTokenSaveMutation, { data, loading, error }] = useApprovalTokenSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      approvalToken: // value for 'approvalToken'
 *   },
 * });
 */
export function useApprovalTokenSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQApprovalTokenSaveMutation,
        GQApprovalTokenSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQApprovalTokenSaveMutation,
        GQApprovalTokenSaveMutationVariables
    >(ApprovalTokenSaveDocument, options);
}
export type ApprovalTokenSaveMutationHookResult = ReturnType<
    typeof useApprovalTokenSaveMutation
>;
export type ApprovalTokenSaveMutationResult =
    ApolloReactCommon.MutationResult<GQApprovalTokenSaveMutation>;
export type ApprovalTokenSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQApprovalTokenSaveMutation,
        GQApprovalTokenSaveMutationVariables
    >;
export const ApprovalTokenGroupSaveDocument = gql`
    mutation approvalTokenGroupSave(
        $id: ID!
        $approvalTokenGroup: ApprovalTokenGroupInput!
    ) {
        approvalTokenGroupSave(
            id: $id
            approvalTokenGroup: $approvalTokenGroup
        ) {
            name
            active
        }
    }
`;
export type GQApprovalTokenGroupSaveMutationFn =
    ApolloReactCommon.MutationFunction<
        GQApprovalTokenGroupSaveMutation,
        GQApprovalTokenGroupSaveMutationVariables
    >;

/**
 * __useApprovalTokenGroupSaveMutation__
 *
 * To run a mutation, you first call `useApprovalTokenGroupSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenGroupSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalTokenGroupSaveMutation, { data, loading, error }] = useApprovalTokenGroupSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      approvalTokenGroup: // value for 'approvalTokenGroup'
 *   },
 * });
 */
export function useApprovalTokenGroupSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQApprovalTokenGroupSaveMutation,
        GQApprovalTokenGroupSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQApprovalTokenGroupSaveMutation,
        GQApprovalTokenGroupSaveMutationVariables
    >(ApprovalTokenGroupSaveDocument, options);
}
export type ApprovalTokenGroupSaveMutationHookResult = ReturnType<
    typeof useApprovalTokenGroupSaveMutation
>;
export type ApprovalTokenGroupSaveMutationResult =
    ApolloReactCommon.MutationResult<GQApprovalTokenGroupSaveMutation>;
export type ApprovalTokenGroupSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQApprovalTokenGroupSaveMutation,
        GQApprovalTokenGroupSaveMutationVariables
    >;
export const ApprovalFormDocument = gql`
    query approvalForm {
        approvals(pagination: { pageSize: 99999 }) {
            data {
                type
                active
            }
        }
    }
`;

/**
 * __useApprovalFormQuery__
 *
 * To run a query within a React component, call `useApprovalFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useApprovalFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQApprovalFormQuery,
        GQApprovalFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQApprovalFormQuery,
        GQApprovalFormQueryVariables
    >(ApprovalFormDocument, options);
}
export function useApprovalFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQApprovalFormQuery,
        GQApprovalFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQApprovalFormQuery,
        GQApprovalFormQueryVariables
    >(ApprovalFormDocument, options);
}
// @ts-ignore
export function useApprovalFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQApprovalFormQuery,
        GQApprovalFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalFormQuery,
    GQApprovalFormQueryVariables
>;
export function useApprovalFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalFormQuery,
              GQApprovalFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalFormQuery | undefined,
    GQApprovalFormQueryVariables
>;
export function useApprovalFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalFormQuery,
              GQApprovalFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQApprovalFormQuery,
        GQApprovalFormQueryVariables
    >(ApprovalFormDocument, options);
}
export type ApprovalFormQueryHookResult = ReturnType<
    typeof useApprovalFormQuery
>;
export type ApprovalFormLazyQueryHookResult = ReturnType<
    typeof useApprovalFormLazyQuery
>;
export type ApprovalFormSuspenseQueryHookResult = ReturnType<
    typeof useApprovalFormSuspenseQuery
>;
export type ApprovalFormQueryResult = ApolloReactCommon.QueryResult<
    GQApprovalFormQuery,
    GQApprovalFormQueryVariables
>;
export const ApprovalTokenFormDocument = gql`
    query approvalTokenForm {
        approvalTokens(pagination: { pageSize: 99999 }) {
            data {
                name
                approvalTokenGroupId
                value
                type
                active
            }
        }
    }
`;

/**
 * __useApprovalTokenFormQuery__
 *
 * To run a query within a React component, call `useApprovalTokenFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalTokenFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useApprovalTokenFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQApprovalTokenFormQuery,
        GQApprovalTokenFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQApprovalTokenFormQuery,
        GQApprovalTokenFormQueryVariables
    >(ApprovalTokenFormDocument, options);
}
export function useApprovalTokenFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQApprovalTokenFormQuery,
        GQApprovalTokenFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQApprovalTokenFormQuery,
        GQApprovalTokenFormQueryVariables
    >(ApprovalTokenFormDocument, options);
}
// @ts-ignore
export function useApprovalTokenFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQApprovalTokenFormQuery,
        GQApprovalTokenFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokenFormQuery,
    GQApprovalTokenFormQueryVariables
>;
export function useApprovalTokenFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokenFormQuery,
              GQApprovalTokenFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokenFormQuery | undefined,
    GQApprovalTokenFormQueryVariables
>;
export function useApprovalTokenFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokenFormQuery,
              GQApprovalTokenFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQApprovalTokenFormQuery,
        GQApprovalTokenFormQueryVariables
    >(ApprovalTokenFormDocument, options);
}
export type ApprovalTokenFormQueryHookResult = ReturnType<
    typeof useApprovalTokenFormQuery
>;
export type ApprovalTokenFormLazyQueryHookResult = ReturnType<
    typeof useApprovalTokenFormLazyQuery
>;
export type ApprovalTokenFormSuspenseQueryHookResult = ReturnType<
    typeof useApprovalTokenFormSuspenseQuery
>;
export type ApprovalTokenFormQueryResult = ApolloReactCommon.QueryResult<
    GQApprovalTokenFormQuery,
    GQApprovalTokenFormQueryVariables
>;
export const ApprovalTokenGroupFormDocument = gql`
    query approvalTokenGroupForm {
        approvalTokenGroups(pagination: { pageSize: 99999 }) {
            data {
                name
                active
            }
        }
    }
`;

/**
 * __useApprovalTokenGroupFormQuery__
 *
 * To run a query within a React component, call `useApprovalTokenGroupFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalTokenGroupFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalTokenGroupFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useApprovalTokenGroupFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQApprovalTokenGroupFormQuery,
        GQApprovalTokenGroupFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQApprovalTokenGroupFormQuery,
        GQApprovalTokenGroupFormQueryVariables
    >(ApprovalTokenGroupFormDocument, options);
}
export function useApprovalTokenGroupFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQApprovalTokenGroupFormQuery,
        GQApprovalTokenGroupFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQApprovalTokenGroupFormQuery,
        GQApprovalTokenGroupFormQueryVariables
    >(ApprovalTokenGroupFormDocument, options);
}
// @ts-ignore
export function useApprovalTokenGroupFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQApprovalTokenGroupFormQuery,
        GQApprovalTokenGroupFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokenGroupFormQuery,
    GQApprovalTokenGroupFormQueryVariables
>;
export function useApprovalTokenGroupFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokenGroupFormQuery,
              GQApprovalTokenGroupFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQApprovalTokenGroupFormQuery | undefined,
    GQApprovalTokenGroupFormQueryVariables
>;
export function useApprovalTokenGroupFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQApprovalTokenGroupFormQuery,
              GQApprovalTokenGroupFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQApprovalTokenGroupFormQuery,
        GQApprovalTokenGroupFormQueryVariables
    >(ApprovalTokenGroupFormDocument, options);
}
export type ApprovalTokenGroupFormQueryHookResult = ReturnType<
    typeof useApprovalTokenGroupFormQuery
>;
export type ApprovalTokenGroupFormLazyQueryHookResult = ReturnType<
    typeof useApprovalTokenGroupFormLazyQuery
>;
export type ApprovalTokenGroupFormSuspenseQueryHookResult = ReturnType<
    typeof useApprovalTokenGroupFormSuspenseQuery
>;
export type ApprovalTokenGroupFormQueryResult = ApolloReactCommon.QueryResult<
    GQApprovalTokenGroupFormQuery,
    GQApprovalTokenGroupFormQueryVariables
>;
export const CardTransactionDocument = gql`
    query cardTransaction($id: ID!) {
        cardTransaction(id: $id) {
            ...cardTransactionScreenFields
        }
    }
    ${CardTransactionScreenFieldsFragmentDoc}
`;

/**
 * __useCardTransactionQuery__
 *
 * To run a query within a React component, call `useCardTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCardTransactionQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCardTransactionQuery,
        GQCardTransactionQueryVariables
    > &
        (
            | { variables: GQCardTransactionQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCardTransactionQuery,
        GQCardTransactionQueryVariables
    >(CardTransactionDocument, options);
}
export function useCardTransactionLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCardTransactionQuery,
        GQCardTransactionQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCardTransactionQuery,
        GQCardTransactionQueryVariables
    >(CardTransactionDocument, options);
}
// @ts-ignore
export function useCardTransactionSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCardTransactionQuery,
        GQCardTransactionQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCardTransactionQuery,
    GQCardTransactionQueryVariables
>;
export function useCardTransactionSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCardTransactionQuery,
              GQCardTransactionQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCardTransactionQuery | undefined,
    GQCardTransactionQueryVariables
>;
export function useCardTransactionSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCardTransactionQuery,
              GQCardTransactionQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCardTransactionQuery,
        GQCardTransactionQueryVariables
    >(CardTransactionDocument, options);
}
export type CardTransactionQueryHookResult = ReturnType<
    typeof useCardTransactionQuery
>;
export type CardTransactionLazyQueryHookResult = ReturnType<
    typeof useCardTransactionLazyQuery
>;
export type CardTransactionSuspenseQueryHookResult = ReturnType<
    typeof useCardTransactionSuspenseQuery
>;
export type CardTransactionQueryResult = ApolloReactCommon.QueryResult<
    GQCardTransactionQuery,
    GQCardTransactionQueryVariables
>;
export const CardTransactionsDocument = gql`
    query cardTransactions(
        $pagination: PaginationInput
        $searching: CardTransactionSearchInput
    ) {
        cardTransactions(pagination: $pagination, searching: $searching) {
            data {
                ...cardTransactionScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${CardTransactionScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCardTransactionsQuery__
 *
 * To run a query within a React component, call `useCardTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardTransactionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useCardTransactionsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQCardTransactionsQuery,
        GQCardTransactionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCardTransactionsQuery,
        GQCardTransactionsQueryVariables
    >(CardTransactionsDocument, options);
}
export function useCardTransactionsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCardTransactionsQuery,
        GQCardTransactionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCardTransactionsQuery,
        GQCardTransactionsQueryVariables
    >(CardTransactionsDocument, options);
}
// @ts-ignore
export function useCardTransactionsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCardTransactionsQuery,
        GQCardTransactionsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCardTransactionsQuery,
    GQCardTransactionsQueryVariables
>;
export function useCardTransactionsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCardTransactionsQuery,
              GQCardTransactionsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCardTransactionsQuery | undefined,
    GQCardTransactionsQueryVariables
>;
export function useCardTransactionsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCardTransactionsQuery,
              GQCardTransactionsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCardTransactionsQuery,
        GQCardTransactionsQueryVariables
    >(CardTransactionsDocument, options);
}
export type CardTransactionsQueryHookResult = ReturnType<
    typeof useCardTransactionsQuery
>;
export type CardTransactionsLazyQueryHookResult = ReturnType<
    typeof useCardTransactionsLazyQuery
>;
export type CardTransactionsSuspenseQueryHookResult = ReturnType<
    typeof useCardTransactionsSuspenseQuery
>;
export type CardTransactionsQueryResult = ApolloReactCommon.QueryResult<
    GQCardTransactionsQuery,
    GQCardTransactionsQueryVariables
>;
export const CashRegistersDocument = gql`
    query cashRegisters(
        $pagination: PaginationInput!
        $search: SearchInput
        $searching: CashRegisterSearchInput
    ) {
        cashRegisters(
            pagination: $pagination
            search: $search
            searching: $searching
        ) {
            data {
                ...cashRegister
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${CashRegisterFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCashRegistersQuery__
 *
 * To run a query within a React component, call `useCashRegistersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashRegistersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashRegistersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useCashRegistersQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCashRegistersQuery,
        GQCashRegistersQueryVariables
    > &
        (
            | { variables: GQCashRegistersQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCashRegistersQuery,
        GQCashRegistersQueryVariables
    >(CashRegistersDocument, options);
}
export function useCashRegistersLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCashRegistersQuery,
        GQCashRegistersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCashRegistersQuery,
        GQCashRegistersQueryVariables
    >(CashRegistersDocument, options);
}
// @ts-ignore
export function useCashRegistersSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCashRegistersQuery,
        GQCashRegistersQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCashRegistersQuery,
    GQCashRegistersQueryVariables
>;
export function useCashRegistersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCashRegistersQuery,
              GQCashRegistersQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCashRegistersQuery | undefined,
    GQCashRegistersQueryVariables
>;
export function useCashRegistersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCashRegistersQuery,
              GQCashRegistersQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCashRegistersQuery,
        GQCashRegistersQueryVariables
    >(CashRegistersDocument, options);
}
export type CashRegistersQueryHookResult = ReturnType<
    typeof useCashRegistersQuery
>;
export type CashRegistersLazyQueryHookResult = ReturnType<
    typeof useCashRegistersLazyQuery
>;
export type CashRegistersSuspenseQueryHookResult = ReturnType<
    typeof useCashRegistersSuspenseQuery
>;
export type CashRegistersQueryResult = ApolloReactCommon.QueryResult<
    GQCashRegistersQuery,
    GQCashRegistersQueryVariables
>;
export const CashRegistersStatusDocument = gql`
    query cashRegistersStatus(
        $pagination: PaginationInput!
        $search: SearchInput
        $searching: CashRegisterStatusSearchInput
    ) {
        cashRegistersStatus(
            pagination: $pagination
            search: $search
            searching: $searching
        ) {
            data {
                id
                name
                device {
                    id
                    lastSeen
                    appVersion
                }
                department {
                    id
                    name
                }
                merchant {
                    id
                    name
                    lastNotifySentAt
                }
                lastAppDataSentAt
                status
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCashRegistersStatusQuery__
 *
 * To run a query within a React component, call `useCashRegistersStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashRegistersStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashRegistersStatusQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useCashRegistersStatusQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCashRegistersStatusQuery,
        GQCashRegistersStatusQueryVariables
    > &
        (
            | { variables: GQCashRegistersStatusQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCashRegistersStatusQuery,
        GQCashRegistersStatusQueryVariables
    >(CashRegistersStatusDocument, options);
}
export function useCashRegistersStatusLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCashRegistersStatusQuery,
        GQCashRegistersStatusQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCashRegistersStatusQuery,
        GQCashRegistersStatusQueryVariables
    >(CashRegistersStatusDocument, options);
}
// @ts-ignore
export function useCashRegistersStatusSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCashRegistersStatusQuery,
        GQCashRegistersStatusQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCashRegistersStatusQuery,
    GQCashRegistersStatusQueryVariables
>;
export function useCashRegistersStatusSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCashRegistersStatusQuery,
              GQCashRegistersStatusQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCashRegistersStatusQuery | undefined,
    GQCashRegistersStatusQueryVariables
>;
export function useCashRegistersStatusSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCashRegistersStatusQuery,
              GQCashRegistersStatusQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCashRegistersStatusQuery,
        GQCashRegistersStatusQueryVariables
    >(CashRegistersStatusDocument, options);
}
export type CashRegistersStatusQueryHookResult = ReturnType<
    typeof useCashRegistersStatusQuery
>;
export type CashRegistersStatusLazyQueryHookResult = ReturnType<
    typeof useCashRegistersStatusLazyQuery
>;
export type CashRegistersStatusSuspenseQueryHookResult = ReturnType<
    typeof useCashRegistersStatusSuspenseQuery
>;
export type CashRegistersStatusQueryResult = ApolloReactCommon.QueryResult<
    GQCashRegistersStatusQuery,
    GQCashRegistersStatusQueryVariables
>;
export const CashRegisterEditFormDocument = gql`
    query cashRegisterEditForm($id: ID!) {
        cashRegister(id: $id) {
            ...cashRegister
        }
        departments(pagination: { pageSize: 999999 }) {
            data {
                id
                name
            }
        }
    }
    ${CashRegisterFragmentDoc}
`;

/**
 * __useCashRegisterEditFormQuery__
 *
 * To run a query within a React component, call `useCashRegisterEditFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashRegisterEditFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashRegisterEditFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCashRegisterEditFormQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCashRegisterEditFormQuery,
        GQCashRegisterEditFormQueryVariables
    > &
        (
            | {
                  variables: GQCashRegisterEditFormQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCashRegisterEditFormQuery,
        GQCashRegisterEditFormQueryVariables
    >(CashRegisterEditFormDocument, options);
}
export function useCashRegisterEditFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCashRegisterEditFormQuery,
        GQCashRegisterEditFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCashRegisterEditFormQuery,
        GQCashRegisterEditFormQueryVariables
    >(CashRegisterEditFormDocument, options);
}
// @ts-ignore
export function useCashRegisterEditFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCashRegisterEditFormQuery,
        GQCashRegisterEditFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCashRegisterEditFormQuery,
    GQCashRegisterEditFormQueryVariables
>;
export function useCashRegisterEditFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCashRegisterEditFormQuery,
              GQCashRegisterEditFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCashRegisterEditFormQuery | undefined,
    GQCashRegisterEditFormQueryVariables
>;
export function useCashRegisterEditFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCashRegisterEditFormQuery,
              GQCashRegisterEditFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCashRegisterEditFormQuery,
        GQCashRegisterEditFormQueryVariables
    >(CashRegisterEditFormDocument, options);
}
export type CashRegisterEditFormQueryHookResult = ReturnType<
    typeof useCashRegisterEditFormQuery
>;
export type CashRegisterEditFormLazyQueryHookResult = ReturnType<
    typeof useCashRegisterEditFormLazyQuery
>;
export type CashRegisterEditFormSuspenseQueryHookResult = ReturnType<
    typeof useCashRegisterEditFormSuspenseQuery
>;
export type CashRegisterEditFormQueryResult = ApolloReactCommon.QueryResult<
    GQCashRegisterEditFormQuery,
    GQCashRegisterEditFormQueryVariables
>;
export const CashRegisterCreateDocument = gql`
    mutation cashRegisterCreate($cashRegister: CashRegisterCreateInput!) {
        cashRegisterCreate(cashRegister: $cashRegister) {
            ...cashRegister
        }
    }
    ${CashRegisterFragmentDoc}
`;
export type GQCashRegisterCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQCashRegisterCreateMutation,
    GQCashRegisterCreateMutationVariables
>;

/**
 * __useCashRegisterCreateMutation__
 *
 * To run a mutation, you first call `useCashRegisterCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCashRegisterCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cashRegisterCreateMutation, { data, loading, error }] = useCashRegisterCreateMutation({
 *   variables: {
 *      cashRegister: // value for 'cashRegister'
 *   },
 * });
 */
export function useCashRegisterCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCashRegisterCreateMutation,
        GQCashRegisterCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCashRegisterCreateMutation,
        GQCashRegisterCreateMutationVariables
    >(CashRegisterCreateDocument, options);
}
export type CashRegisterCreateMutationHookResult = ReturnType<
    typeof useCashRegisterCreateMutation
>;
export type CashRegisterCreateMutationResult =
    ApolloReactCommon.MutationResult<GQCashRegisterCreateMutation>;
export type CashRegisterCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCashRegisterCreateMutation,
        GQCashRegisterCreateMutationVariables
    >;
export const CashRegisterEditDocument = gql`
    mutation cashRegisterEdit($id: ID!, $cashRegister: CashRegisterEditInput!) {
        cashRegisterEdit(id: $id, cashRegister: $cashRegister) {
            ...cashRegister
        }
    }
    ${CashRegisterFragmentDoc}
`;
export type GQCashRegisterEditMutationFn = ApolloReactCommon.MutationFunction<
    GQCashRegisterEditMutation,
    GQCashRegisterEditMutationVariables
>;

/**
 * __useCashRegisterEditMutation__
 *
 * To run a mutation, you first call `useCashRegisterEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCashRegisterEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cashRegisterEditMutation, { data, loading, error }] = useCashRegisterEditMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cashRegister: // value for 'cashRegister'
 *   },
 * });
 */
export function useCashRegisterEditMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCashRegisterEditMutation,
        GQCashRegisterEditMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCashRegisterEditMutation,
        GQCashRegisterEditMutationVariables
    >(CashRegisterEditDocument, options);
}
export type CashRegisterEditMutationHookResult = ReturnType<
    typeof useCashRegisterEditMutation
>;
export type CashRegisterEditMutationResult =
    ApolloReactCommon.MutationResult<GQCashRegisterEditMutation>;
export type CashRegisterEditMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCashRegisterEditMutation,
        GQCashRegisterEditMutationVariables
    >;
export const CashRegisterDeleteDocument = gql`
    mutation cashRegisterDelete($id: ID!) {
        cashRegisterDelete(id: $id) {
            status
        }
    }
`;
export type GQCashRegisterDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQCashRegisterDeleteMutation,
    GQCashRegisterDeleteMutationVariables
>;

/**
 * __useCashRegisterDeleteMutation__
 *
 * To run a mutation, you first call `useCashRegisterDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCashRegisterDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cashRegisterDeleteMutation, { data, loading, error }] = useCashRegisterDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCashRegisterDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCashRegisterDeleteMutation,
        GQCashRegisterDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCashRegisterDeleteMutation,
        GQCashRegisterDeleteMutationVariables
    >(CashRegisterDeleteDocument, options);
}
export type CashRegisterDeleteMutationHookResult = ReturnType<
    typeof useCashRegisterDeleteMutation
>;
export type CashRegisterDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQCashRegisterDeleteMutation>;
export type CashRegisterDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCashRegisterDeleteMutation,
        GQCashRegisterDeleteMutationVariables
    >;
export const CashRegistersDeleteDocument = gql`
    mutation cashRegistersDelete($ids: [ID!]!) {
        cashRegistersDelete(ids: $ids) {
            status
        }
    }
`;
export type GQCashRegistersDeleteMutationFn =
    ApolloReactCommon.MutationFunction<
        GQCashRegistersDeleteMutation,
        GQCashRegistersDeleteMutationVariables
    >;

/**
 * __useCashRegistersDeleteMutation__
 *
 * To run a mutation, you first call `useCashRegistersDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCashRegistersDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cashRegistersDeleteMutation, { data, loading, error }] = useCashRegistersDeleteMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCashRegistersDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCashRegistersDeleteMutation,
        GQCashRegistersDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCashRegistersDeleteMutation,
        GQCashRegistersDeleteMutationVariables
    >(CashRegistersDeleteDocument, options);
}
export type CashRegistersDeleteMutationHookResult = ReturnType<
    typeof useCashRegistersDeleteMutation
>;
export type CashRegistersDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQCashRegistersDeleteMutation>;
export type CashRegistersDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCashRegistersDeleteMutation,
        GQCashRegistersDeleteMutationVariables
    >;
export const CashRegisterClaimDocument = gql`
    mutation cashRegisterClaim($id: ID!, $devicePinCode: String!) {
        cashRegisterClaim(id: $id, devicePinCode: $devicePinCode) {
            ...cashRegister
        }
    }
    ${CashRegisterFragmentDoc}
`;
export type GQCashRegisterClaimMutationFn = ApolloReactCommon.MutationFunction<
    GQCashRegisterClaimMutation,
    GQCashRegisterClaimMutationVariables
>;

/**
 * __useCashRegisterClaimMutation__
 *
 * To run a mutation, you first call `useCashRegisterClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCashRegisterClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cashRegisterClaimMutation, { data, loading, error }] = useCashRegisterClaimMutation({
 *   variables: {
 *      id: // value for 'id'
 *      devicePinCode: // value for 'devicePinCode'
 *   },
 * });
 */
export function useCashRegisterClaimMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCashRegisterClaimMutation,
        GQCashRegisterClaimMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCashRegisterClaimMutation,
        GQCashRegisterClaimMutationVariables
    >(CashRegisterClaimDocument, options);
}
export type CashRegisterClaimMutationHookResult = ReturnType<
    typeof useCashRegisterClaimMutation
>;
export type CashRegisterClaimMutationResult =
    ApolloReactCommon.MutationResult<GQCashRegisterClaimMutation>;
export type CashRegisterClaimMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCashRegisterClaimMutation,
        GQCashRegisterClaimMutationVariables
    >;
export const DeviceByPinCodeDocument = gql`
    query deviceByPinCode($pinCode: String!) {
        deviceByPinCode(pinCode: $pinCode) {
            id
        }
    }
`;

/**
 * __useDeviceByPinCodeQuery__
 *
 * To run a query within a React component, call `useDeviceByPinCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceByPinCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceByPinCodeQuery({
 *   variables: {
 *      pinCode: // value for 'pinCode'
 *   },
 * });
 */
export function useDeviceByPinCodeQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQDeviceByPinCodeQuery,
        GQDeviceByPinCodeQueryVariables
    > &
        (
            | { variables: GQDeviceByPinCodeQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQDeviceByPinCodeQuery,
        GQDeviceByPinCodeQueryVariables
    >(DeviceByPinCodeDocument, options);
}
export function useDeviceByPinCodeLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDeviceByPinCodeQuery,
        GQDeviceByPinCodeQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDeviceByPinCodeQuery,
        GQDeviceByPinCodeQueryVariables
    >(DeviceByPinCodeDocument, options);
}
// @ts-ignore
export function useDeviceByPinCodeSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDeviceByPinCodeQuery,
        GQDeviceByPinCodeQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDeviceByPinCodeQuery,
    GQDeviceByPinCodeQueryVariables
>;
export function useDeviceByPinCodeSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDeviceByPinCodeQuery,
              GQDeviceByPinCodeQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDeviceByPinCodeQuery | undefined,
    GQDeviceByPinCodeQueryVariables
>;
export function useDeviceByPinCodeSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDeviceByPinCodeQuery,
              GQDeviceByPinCodeQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDeviceByPinCodeQuery,
        GQDeviceByPinCodeQueryVariables
    >(DeviceByPinCodeDocument, options);
}
export type DeviceByPinCodeQueryHookResult = ReturnType<
    typeof useDeviceByPinCodeQuery
>;
export type DeviceByPinCodeLazyQueryHookResult = ReturnType<
    typeof useDeviceByPinCodeLazyQuery
>;
export type DeviceByPinCodeSuspenseQueryHookResult = ReturnType<
    typeof useDeviceByPinCodeSuspenseQuery
>;
export type DeviceByPinCodeQueryResult = ApolloReactCommon.QueryResult<
    GQDeviceByPinCodeQuery,
    GQDeviceByPinCodeQueryVariables
>;
export const CmpEventsDocument = gql`
    query cmpEvents($pagination: PaginationInput) {
        cmpEvents(pagination: $pagination) {
            data {
                id
                externalId
                name
                active
                from
                to
                products {
                    id
                    name
                    amount
                    externalId
                    calendar
                }
                sequence
                createdAt
                updatedAt
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCmpEventsQuery__
 *
 * To run a query within a React component, call `useCmpEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmpEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmpEventsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCmpEventsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQCmpEventsQuery,
        GQCmpEventsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCmpEventsQuery,
        GQCmpEventsQueryVariables
    >(CmpEventsDocument, options);
}
export function useCmpEventsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCmpEventsQuery,
        GQCmpEventsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCmpEventsQuery,
        GQCmpEventsQueryVariables
    >(CmpEventsDocument, options);
}
// @ts-ignore
export function useCmpEventsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCmpEventsQuery,
        GQCmpEventsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpEventsQuery,
    GQCmpEventsQueryVariables
>;
export function useCmpEventsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpEventsQuery,
              GQCmpEventsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpEventsQuery | undefined,
    GQCmpEventsQueryVariables
>;
export function useCmpEventsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpEventsQuery,
              GQCmpEventsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCmpEventsQuery,
        GQCmpEventsQueryVariables
    >(CmpEventsDocument, options);
}
export type CmpEventsQueryHookResult = ReturnType<typeof useCmpEventsQuery>;
export type CmpEventsLazyQueryHookResult = ReturnType<
    typeof useCmpEventsLazyQuery
>;
export type CmpEventsSuspenseQueryHookResult = ReturnType<
    typeof useCmpEventsSuspenseQuery
>;
export type CmpEventsQueryResult = ApolloReactCommon.QueryResult<
    GQCmpEventsQuery,
    GQCmpEventsQueryVariables
>;
export const CmpEventDocument = gql`
    query cmpEvent($id: ID!) {
        cmpEvent(id: $id) {
            id
            externalId
            name
            active
            from
            to
            products {
                id
                externalId
                externalEventId
                name
                amount
                group {
                    vat {
                        percentage
                    }
                }
                active
                calendar
                shouldPrint
                upgradeable
                sequence
                createdAt
                updatedAt
            }
            createdAt
            updatedAt
        }
    }
`;

/**
 * __useCmpEventQuery__
 *
 * To run a query within a React component, call `useCmpEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmpEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmpEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCmpEventQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCmpEventQuery,
        GQCmpEventQueryVariables
    > &
        (
            | { variables: GQCmpEventQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQCmpEventQuery, GQCmpEventQueryVariables>(
        CmpEventDocument,
        options
    );
}
export function useCmpEventLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCmpEventQuery,
        GQCmpEventQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCmpEventQuery,
        GQCmpEventQueryVariables
    >(CmpEventDocument, options);
}
// @ts-ignore
export function useCmpEventSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCmpEventQuery,
        GQCmpEventQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpEventQuery,
    GQCmpEventQueryVariables
>;
export function useCmpEventSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpEventQuery,
              GQCmpEventQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpEventQuery | undefined,
    GQCmpEventQueryVariables
>;
export function useCmpEventSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpEventQuery,
              GQCmpEventQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCmpEventQuery,
        GQCmpEventQueryVariables
    >(CmpEventDocument, options);
}
export type CmpEventQueryHookResult = ReturnType<typeof useCmpEventQuery>;
export type CmpEventLazyQueryHookResult = ReturnType<
    typeof useCmpEventLazyQuery
>;
export type CmpEventSuspenseQueryHookResult = ReturnType<
    typeof useCmpEventSuspenseQuery
>;
export type CmpEventQueryResult = ApolloReactCommon.QueryResult<
    GQCmpEventQuery,
    GQCmpEventQueryVariables
>;
export const CmpEventByExternalIdDocument = gql`
    query cmpEventByExternalId($externalId: ID!) {
        cmpEventByExternalId(externalId: $externalId) {
            id
            externalId
            name
            active
            from
            to
            createdAt
            updatedAt
        }
    }
`;

/**
 * __useCmpEventByExternalIdQuery__
 *
 * To run a query within a React component, call `useCmpEventByExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmpEventByExternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmpEventByExternalIdQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useCmpEventByExternalIdQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCmpEventByExternalIdQuery,
        GQCmpEventByExternalIdQueryVariables
    > &
        (
            | {
                  variables: GQCmpEventByExternalIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCmpEventByExternalIdQuery,
        GQCmpEventByExternalIdQueryVariables
    >(CmpEventByExternalIdDocument, options);
}
export function useCmpEventByExternalIdLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCmpEventByExternalIdQuery,
        GQCmpEventByExternalIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCmpEventByExternalIdQuery,
        GQCmpEventByExternalIdQueryVariables
    >(CmpEventByExternalIdDocument, options);
}
// @ts-ignore
export function useCmpEventByExternalIdSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCmpEventByExternalIdQuery,
        GQCmpEventByExternalIdQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpEventByExternalIdQuery,
    GQCmpEventByExternalIdQueryVariables
>;
export function useCmpEventByExternalIdSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpEventByExternalIdQuery,
              GQCmpEventByExternalIdQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpEventByExternalIdQuery | undefined,
    GQCmpEventByExternalIdQueryVariables
>;
export function useCmpEventByExternalIdSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpEventByExternalIdQuery,
              GQCmpEventByExternalIdQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCmpEventByExternalIdQuery,
        GQCmpEventByExternalIdQueryVariables
    >(CmpEventByExternalIdDocument, options);
}
export type CmpEventByExternalIdQueryHookResult = ReturnType<
    typeof useCmpEventByExternalIdQuery
>;
export type CmpEventByExternalIdLazyQueryHookResult = ReturnType<
    typeof useCmpEventByExternalIdLazyQuery
>;
export type CmpEventByExternalIdSuspenseQueryHookResult = ReturnType<
    typeof useCmpEventByExternalIdSuspenseQuery
>;
export type CmpEventByExternalIdQueryResult = ApolloReactCommon.QueryResult<
    GQCmpEventByExternalIdQuery,
    GQCmpEventByExternalIdQueryVariables
>;
export const CmpEventProductsDocument = gql`
    query cmpEventProducts(
        $externalEventId: String!
        $pagination: PaginationInput
    ) {
        cmpEventProducts(
            externalEventId: $externalEventId
            pagination: $pagination
        ) {
            data {
                id
                externalId
                externalEventId
                name
                amount
                group {
                    vat {
                        percentage
                    }
                }
                active
                calendar
                sequence
                shouldPrint
                upgradeable
                sms
                createdAt
                updatedAt
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCmpEventProductsQuery__
 *
 * To run a query within a React component, call `useCmpEventProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmpEventProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmpEventProductsQuery({
 *   variables: {
 *      externalEventId: // value for 'externalEventId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCmpEventProductsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCmpEventProductsQuery,
        GQCmpEventProductsQueryVariables
    > &
        (
            | { variables: GQCmpEventProductsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCmpEventProductsQuery,
        GQCmpEventProductsQueryVariables
    >(CmpEventProductsDocument, options);
}
export function useCmpEventProductsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCmpEventProductsQuery,
        GQCmpEventProductsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCmpEventProductsQuery,
        GQCmpEventProductsQueryVariables
    >(CmpEventProductsDocument, options);
}
// @ts-ignore
export function useCmpEventProductsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCmpEventProductsQuery,
        GQCmpEventProductsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpEventProductsQuery,
    GQCmpEventProductsQueryVariables
>;
export function useCmpEventProductsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpEventProductsQuery,
              GQCmpEventProductsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpEventProductsQuery | undefined,
    GQCmpEventProductsQueryVariables
>;
export function useCmpEventProductsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpEventProductsQuery,
              GQCmpEventProductsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCmpEventProductsQuery,
        GQCmpEventProductsQueryVariables
    >(CmpEventProductsDocument, options);
}
export type CmpEventProductsQueryHookResult = ReturnType<
    typeof useCmpEventProductsQuery
>;
export type CmpEventProductsLazyQueryHookResult = ReturnType<
    typeof useCmpEventProductsLazyQuery
>;
export type CmpEventProductsSuspenseQueryHookResult = ReturnType<
    typeof useCmpEventProductsSuspenseQuery
>;
export type CmpEventProductsQueryResult = ApolloReactCommon.QueryResult<
    GQCmpEventProductsQuery,
    GQCmpEventProductsQueryVariables
>;
export const CmpEventProductDeleteDocument = gql`
    mutation cmpEventProductDelete($id: ID!) {
        cmpEventProductDelete(id: $id) {
            status
        }
    }
`;
export type GQCmpEventProductDeleteMutationFn =
    ApolloReactCommon.MutationFunction<
        GQCmpEventProductDeleteMutation,
        GQCmpEventProductDeleteMutationVariables
    >;

/**
 * __useCmpEventProductDeleteMutation__
 *
 * To run a mutation, you first call `useCmpEventProductDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCmpEventProductDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cmpEventProductDeleteMutation, { data, loading, error }] = useCmpEventProductDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCmpEventProductDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCmpEventProductDeleteMutation,
        GQCmpEventProductDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCmpEventProductDeleteMutation,
        GQCmpEventProductDeleteMutationVariables
    >(CmpEventProductDeleteDocument, options);
}
export type CmpEventProductDeleteMutationHookResult = ReturnType<
    typeof useCmpEventProductDeleteMutation
>;
export type CmpEventProductDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQCmpEventProductDeleteMutation>;
export type CmpEventProductDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCmpEventProductDeleteMutation,
        GQCmpEventProductDeleteMutationVariables
    >;
export const CmpEventDeleteDocument = gql`
    mutation cmpEventDelete($id: ID!) {
        cmpEventDelete(id: $id) {
            status
        }
    }
`;
export type GQCmpEventDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQCmpEventDeleteMutation,
    GQCmpEventDeleteMutationVariables
>;

/**
 * __useCmpEventDeleteMutation__
 *
 * To run a mutation, you first call `useCmpEventDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCmpEventDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cmpEventDeleteMutation, { data, loading, error }] = useCmpEventDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCmpEventDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCmpEventDeleteMutation,
        GQCmpEventDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCmpEventDeleteMutation,
        GQCmpEventDeleteMutationVariables
    >(CmpEventDeleteDocument, options);
}
export type CmpEventDeleteMutationHookResult = ReturnType<
    typeof useCmpEventDeleteMutation
>;
export type CmpEventDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQCmpEventDeleteMutation>;
export type CmpEventDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCmpEventDeleteMutation,
        GQCmpEventDeleteMutationVariables
    >;
export const CmpProductsDocument = gql`
    query cmpProducts($pagination: PaginationInput) {
        cmpProducts(pagination: $pagination) {
            data {
                id
                externalId
                name
                amount
                type
                active
                sequence
                sms
                createdAt
                updatedAt
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCmpProductsQuery__
 *
 * To run a query within a React component, call `useCmpProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmpProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmpProductsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCmpProductsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQCmpProductsQuery,
        GQCmpProductsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCmpProductsQuery,
        GQCmpProductsQueryVariables
    >(CmpProductsDocument, options);
}
export function useCmpProductsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCmpProductsQuery,
        GQCmpProductsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCmpProductsQuery,
        GQCmpProductsQueryVariables
    >(CmpProductsDocument, options);
}
// @ts-ignore
export function useCmpProductsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCmpProductsQuery,
        GQCmpProductsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpProductsQuery,
    GQCmpProductsQueryVariables
>;
export function useCmpProductsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpProductsQuery,
              GQCmpProductsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpProductsQuery | undefined,
    GQCmpProductsQueryVariables
>;
export function useCmpProductsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpProductsQuery,
              GQCmpProductsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCmpProductsQuery,
        GQCmpProductsQueryVariables
    >(CmpProductsDocument, options);
}
export type CmpProductsQueryHookResult = ReturnType<typeof useCmpProductsQuery>;
export type CmpProductsLazyQueryHookResult = ReturnType<
    typeof useCmpProductsLazyQuery
>;
export type CmpProductsSuspenseQueryHookResult = ReturnType<
    typeof useCmpProductsSuspenseQuery
>;
export type CmpProductsQueryResult = ApolloReactCommon.QueryResult<
    GQCmpProductsQuery,
    GQCmpProductsQueryVariables
>;
export const CmpProductDeleteDocument = gql`
    mutation cmpProductDelete($id: ID!) {
        cmpProductDelete(id: $id) {
            status
        }
    }
`;
export type GQCmpProductDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQCmpProductDeleteMutation,
    GQCmpProductDeleteMutationVariables
>;

/**
 * __useCmpProductDeleteMutation__
 *
 * To run a mutation, you first call `useCmpProductDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCmpProductDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cmpProductDeleteMutation, { data, loading, error }] = useCmpProductDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCmpProductDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCmpProductDeleteMutation,
        GQCmpProductDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCmpProductDeleteMutation,
        GQCmpProductDeleteMutationVariables
    >(CmpProductDeleteDocument, options);
}
export type CmpProductDeleteMutationHookResult = ReturnType<
    typeof useCmpProductDeleteMutation
>;
export type CmpProductDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQCmpProductDeleteMutation>;
export type CmpProductDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCmpProductDeleteMutation,
        GQCmpProductDeleteMutationVariables
    >;
export const CurrenciesDocument = gql`
    query currencies($pagination: PaginationInput, $search: SearchInput) {
        currencies(pagination: $pagination, search: $search) {
            data {
                ...allCurrencyFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllCurrencyFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useCurrenciesQuery__
 *
 * To run a query within a React component, call `useCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrenciesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCurrenciesQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQCurrenciesQuery,
        GQCurrenciesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCurrenciesQuery,
        GQCurrenciesQueryVariables
    >(CurrenciesDocument, options);
}
export function useCurrenciesLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCurrenciesQuery,
        GQCurrenciesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCurrenciesQuery,
        GQCurrenciesQueryVariables
    >(CurrenciesDocument, options);
}
// @ts-ignore
export function useCurrenciesSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCurrenciesQuery,
        GQCurrenciesQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCurrenciesQuery,
    GQCurrenciesQueryVariables
>;
export function useCurrenciesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCurrenciesQuery,
              GQCurrenciesQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCurrenciesQuery | undefined,
    GQCurrenciesQueryVariables
>;
export function useCurrenciesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCurrenciesQuery,
              GQCurrenciesQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCurrenciesQuery,
        GQCurrenciesQueryVariables
    >(CurrenciesDocument, options);
}
export type CurrenciesQueryHookResult = ReturnType<typeof useCurrenciesQuery>;
export type CurrenciesLazyQueryHookResult = ReturnType<
    typeof useCurrenciesLazyQuery
>;
export type CurrenciesSuspenseQueryHookResult = ReturnType<
    typeof useCurrenciesSuspenseQuery
>;
export type CurrenciesQueryResult = ApolloReactCommon.QueryResult<
    GQCurrenciesQuery,
    GQCurrenciesQueryVariables
>;
export const CurrencyDocument = gql`
    query currency($id: ID!) {
        currency(id: $id) {
            ...allCurrencyFields
        }
    }
    ${AllCurrencyFieldsFragmentDoc}
`;

/**
 * __useCurrencyQuery__
 *
 * To run a query within a React component, call `useCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCurrencyQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCurrencyQuery,
        GQCurrencyQueryVariables
    > &
        (
            | { variables: GQCurrencyQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQCurrencyQuery, GQCurrencyQueryVariables>(
        CurrencyDocument,
        options
    );
}
export function useCurrencyLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCurrencyQuery,
        GQCurrencyQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCurrencyQuery,
        GQCurrencyQueryVariables
    >(CurrencyDocument, options);
}
// @ts-ignore
export function useCurrencySuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCurrencyQuery,
        GQCurrencyQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCurrencyQuery,
    GQCurrencyQueryVariables
>;
export function useCurrencySuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCurrencyQuery,
              GQCurrencyQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCurrencyQuery | undefined,
    GQCurrencyQueryVariables
>;
export function useCurrencySuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCurrencyQuery,
              GQCurrencyQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCurrencyQuery,
        GQCurrencyQueryVariables
    >(CurrencyDocument, options);
}
export type CurrencyQueryHookResult = ReturnType<typeof useCurrencyQuery>;
export type CurrencyLazyQueryHookResult = ReturnType<
    typeof useCurrencyLazyQuery
>;
export type CurrencySuspenseQueryHookResult = ReturnType<
    typeof useCurrencySuspenseQuery
>;
export type CurrencyQueryResult = ApolloReactCommon.QueryResult<
    GQCurrencyQuery,
    GQCurrencyQueryVariables
>;
export const CurrencyCreateDocument = gql`
    mutation currencyCreate($currency: CurrencyInput!) {
        currencyCreate(currency: $currency) {
            ...allCurrencyFields
        }
    }
    ${AllCurrencyFieldsFragmentDoc}
`;
export type GQCurrencyCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQCurrencyCreateMutation,
    GQCurrencyCreateMutationVariables
>;

/**
 * __useCurrencyCreateMutation__
 *
 * To run a mutation, you first call `useCurrencyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCurrencyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [currencyCreateMutation, { data, loading, error }] = useCurrencyCreateMutation({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useCurrencyCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCurrencyCreateMutation,
        GQCurrencyCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCurrencyCreateMutation,
        GQCurrencyCreateMutationVariables
    >(CurrencyCreateDocument, options);
}
export type CurrencyCreateMutationHookResult = ReturnType<
    typeof useCurrencyCreateMutation
>;
export type CurrencyCreateMutationResult =
    ApolloReactCommon.MutationResult<GQCurrencyCreateMutation>;
export type CurrencyCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCurrencyCreateMutation,
        GQCurrencyCreateMutationVariables
    >;
export const CurrencySaveDocument = gql`
    mutation currencySave($id: ID!, $currency: CurrencyInput!) {
        currencySave(id: $id, currency: $currency) {
            ...allCurrencyFields
        }
    }
    ${AllCurrencyFieldsFragmentDoc}
`;
export type GQCurrencySaveMutationFn = ApolloReactCommon.MutationFunction<
    GQCurrencySaveMutation,
    GQCurrencySaveMutationVariables
>;

/**
 * __useCurrencySaveMutation__
 *
 * To run a mutation, you first call `useCurrencySaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCurrencySaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [currencySaveMutation, { data, loading, error }] = useCurrencySaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useCurrencySaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCurrencySaveMutation,
        GQCurrencySaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCurrencySaveMutation,
        GQCurrencySaveMutationVariables
    >(CurrencySaveDocument, options);
}
export type CurrencySaveMutationHookResult = ReturnType<
    typeof useCurrencySaveMutation
>;
export type CurrencySaveMutationResult =
    ApolloReactCommon.MutationResult<GQCurrencySaveMutation>;
export type CurrencySaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQCurrencySaveMutation,
    GQCurrencySaveMutationVariables
>;
export const CurrencyDeleteDocument = gql`
    mutation currencyDelete($id: ID!) {
        currencyDelete(id: $id) {
            status
        }
    }
`;
export type GQCurrencyDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQCurrencyDeleteMutation,
    GQCurrencyDeleteMutationVariables
>;

/**
 * __useCurrencyDeleteMutation__
 *
 * To run a mutation, you first call `useCurrencyDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCurrencyDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [currencyDeleteMutation, { data, loading, error }] = useCurrencyDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCurrencyDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCurrencyDeleteMutation,
        GQCurrencyDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCurrencyDeleteMutation,
        GQCurrencyDeleteMutationVariables
    >(CurrencyDeleteDocument, options);
}
export type CurrencyDeleteMutationHookResult = ReturnType<
    typeof useCurrencyDeleteMutation
>;
export type CurrencyDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQCurrencyDeleteMutation>;
export type CurrencyDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCurrencyDeleteMutation,
        GQCurrencyDeleteMutationVariables
    >;
export const DashboardCashRegistersDocument = gql`
    query dashboardCashRegisters(
        $pagination: PaginationInput!
        $search: SearchInput!
    ) {
        dashboardCashRegisters(pagination: $pagination, search: $search) {
            data {
                id
                name
                device {
                    id
                    osName
                    osVersion
                    appVersion
                    appBuild
                    serialNumber
                    hardwareModel
                    hardwareProducer
                    macAddress
                    language
                    lastSeen
                }
                merchant {
                    id
                    name
                }
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useDashboardCashRegistersQuery__
 *
 * To run a query within a React component, call `useDashboardCashRegistersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCashRegistersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCashRegistersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useDashboardCashRegistersQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQDashboardCashRegistersQuery,
        GQDashboardCashRegistersQueryVariables
    > &
        (
            | {
                  variables: GQDashboardCashRegistersQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQDashboardCashRegistersQuery,
        GQDashboardCashRegistersQueryVariables
    >(DashboardCashRegistersDocument, options);
}
export function useDashboardCashRegistersLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDashboardCashRegistersQuery,
        GQDashboardCashRegistersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDashboardCashRegistersQuery,
        GQDashboardCashRegistersQueryVariables
    >(DashboardCashRegistersDocument, options);
}
// @ts-ignore
export function useDashboardCashRegistersSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDashboardCashRegistersQuery,
        GQDashboardCashRegistersQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDashboardCashRegistersQuery,
    GQDashboardCashRegistersQueryVariables
>;
export function useDashboardCashRegistersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDashboardCashRegistersQuery,
              GQDashboardCashRegistersQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDashboardCashRegistersQuery | undefined,
    GQDashboardCashRegistersQueryVariables
>;
export function useDashboardCashRegistersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDashboardCashRegistersQuery,
              GQDashboardCashRegistersQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDashboardCashRegistersQuery,
        GQDashboardCashRegistersQueryVariables
    >(DashboardCashRegistersDocument, options);
}
export type DashboardCashRegistersQueryHookResult = ReturnType<
    typeof useDashboardCashRegistersQuery
>;
export type DashboardCashRegistersLazyQueryHookResult = ReturnType<
    typeof useDashboardCashRegistersLazyQuery
>;
export type DashboardCashRegistersSuspenseQueryHookResult = ReturnType<
    typeof useDashboardCashRegistersSuspenseQuery
>;
export type DashboardCashRegistersQueryResult = ApolloReactCommon.QueryResult<
    GQDashboardCashRegistersQuery,
    GQDashboardCashRegistersQueryVariables
>;
export const DashboardCashRegisterStatsDocument = gql`
    query dashboardCashRegisterStats {
        dashboardCashRegisterStats {
            label
            count
        }
    }
`;

/**
 * __useDashboardCashRegisterStatsQuery__
 *
 * To run a query within a React component, call `useDashboardCashRegisterStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCashRegisterStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCashRegisterStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardCashRegisterStatsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQDashboardCashRegisterStatsQuery,
        GQDashboardCashRegisterStatsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQDashboardCashRegisterStatsQuery,
        GQDashboardCashRegisterStatsQueryVariables
    >(DashboardCashRegisterStatsDocument, options);
}
export function useDashboardCashRegisterStatsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDashboardCashRegisterStatsQuery,
        GQDashboardCashRegisterStatsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDashboardCashRegisterStatsQuery,
        GQDashboardCashRegisterStatsQueryVariables
    >(DashboardCashRegisterStatsDocument, options);
}
// @ts-ignore
export function useDashboardCashRegisterStatsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDashboardCashRegisterStatsQuery,
        GQDashboardCashRegisterStatsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDashboardCashRegisterStatsQuery,
    GQDashboardCashRegisterStatsQueryVariables
>;
export function useDashboardCashRegisterStatsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDashboardCashRegisterStatsQuery,
              GQDashboardCashRegisterStatsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDashboardCashRegisterStatsQuery | undefined,
    GQDashboardCashRegisterStatsQueryVariables
>;
export function useDashboardCashRegisterStatsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDashboardCashRegisterStatsQuery,
              GQDashboardCashRegisterStatsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDashboardCashRegisterStatsQuery,
        GQDashboardCashRegisterStatsQueryVariables
    >(DashboardCashRegisterStatsDocument, options);
}
export type DashboardCashRegisterStatsQueryHookResult = ReturnType<
    typeof useDashboardCashRegisterStatsQuery
>;
export type DashboardCashRegisterStatsLazyQueryHookResult = ReturnType<
    typeof useDashboardCashRegisterStatsLazyQuery
>;
export type DashboardCashRegisterStatsSuspenseQueryHookResult = ReturnType<
    typeof useDashboardCashRegisterStatsSuspenseQuery
>;
export type DashboardCashRegisterStatsQueryResult =
    ApolloReactCommon.QueryResult<
        GQDashboardCashRegisterStatsQuery,
        GQDashboardCashRegisterStatsQueryVariables
    >;
export const DashboardInvoiceAmountStatsDocument = gql`
    query dashboardInvoiceAmountStats(
        $from: Date!
        $to: Date!
        $interval: String
    ) {
        dashboardInvoiceAmountStats(from: $from, to: $to, interval: $interval) {
            datetime
            sum
        }
    }
`;

/**
 * __useDashboardInvoiceAmountStatsQuery__
 *
 * To run a query within a React component, call `useDashboardInvoiceAmountStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardInvoiceAmountStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardInvoiceAmountStatsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useDashboardInvoiceAmountStatsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQDashboardInvoiceAmountStatsQuery,
        GQDashboardInvoiceAmountStatsQueryVariables
    > &
        (
            | {
                  variables: GQDashboardInvoiceAmountStatsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQDashboardInvoiceAmountStatsQuery,
        GQDashboardInvoiceAmountStatsQueryVariables
    >(DashboardInvoiceAmountStatsDocument, options);
}
export function useDashboardInvoiceAmountStatsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDashboardInvoiceAmountStatsQuery,
        GQDashboardInvoiceAmountStatsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDashboardInvoiceAmountStatsQuery,
        GQDashboardInvoiceAmountStatsQueryVariables
    >(DashboardInvoiceAmountStatsDocument, options);
}
// @ts-ignore
export function useDashboardInvoiceAmountStatsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDashboardInvoiceAmountStatsQuery,
        GQDashboardInvoiceAmountStatsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDashboardInvoiceAmountStatsQuery,
    GQDashboardInvoiceAmountStatsQueryVariables
>;
export function useDashboardInvoiceAmountStatsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDashboardInvoiceAmountStatsQuery,
              GQDashboardInvoiceAmountStatsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDashboardInvoiceAmountStatsQuery | undefined,
    GQDashboardInvoiceAmountStatsQueryVariables
>;
export function useDashboardInvoiceAmountStatsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDashboardInvoiceAmountStatsQuery,
              GQDashboardInvoiceAmountStatsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDashboardInvoiceAmountStatsQuery,
        GQDashboardInvoiceAmountStatsQueryVariables
    >(DashboardInvoiceAmountStatsDocument, options);
}
export type DashboardInvoiceAmountStatsQueryHookResult = ReturnType<
    typeof useDashboardInvoiceAmountStatsQuery
>;
export type DashboardInvoiceAmountStatsLazyQueryHookResult = ReturnType<
    typeof useDashboardInvoiceAmountStatsLazyQuery
>;
export type DashboardInvoiceAmountStatsSuspenseQueryHookResult = ReturnType<
    typeof useDashboardInvoiceAmountStatsSuspenseQuery
>;
export type DashboardInvoiceAmountStatsQueryResult =
    ApolloReactCommon.QueryResult<
        GQDashboardInvoiceAmountStatsQuery,
        GQDashboardInvoiceAmountStatsQueryVariables
    >;
export const DashboardInvoiceAmountPerMonthStatsDocument = gql`
    query dashboardInvoiceAmountPerMonthStats {
        dashboardInvoiceAmountPerMonthStats {
            year
            monthNumber
            sum
        }
    }
`;

/**
 * __useDashboardInvoiceAmountPerMonthStatsQuery__
 *
 * To run a query within a React component, call `useDashboardInvoiceAmountPerMonthStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardInvoiceAmountPerMonthStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardInvoiceAmountPerMonthStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardInvoiceAmountPerMonthStatsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQDashboardInvoiceAmountPerMonthStatsQuery,
        GQDashboardInvoiceAmountPerMonthStatsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQDashboardInvoiceAmountPerMonthStatsQuery,
        GQDashboardInvoiceAmountPerMonthStatsQueryVariables
    >(DashboardInvoiceAmountPerMonthStatsDocument, options);
}
export function useDashboardInvoiceAmountPerMonthStatsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDashboardInvoiceAmountPerMonthStatsQuery,
        GQDashboardInvoiceAmountPerMonthStatsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDashboardInvoiceAmountPerMonthStatsQuery,
        GQDashboardInvoiceAmountPerMonthStatsQueryVariables
    >(DashboardInvoiceAmountPerMonthStatsDocument, options);
}
// @ts-ignore
export function useDashboardInvoiceAmountPerMonthStatsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDashboardInvoiceAmountPerMonthStatsQuery,
        GQDashboardInvoiceAmountPerMonthStatsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDashboardInvoiceAmountPerMonthStatsQuery,
    GQDashboardInvoiceAmountPerMonthStatsQueryVariables
>;
export function useDashboardInvoiceAmountPerMonthStatsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDashboardInvoiceAmountPerMonthStatsQuery,
              GQDashboardInvoiceAmountPerMonthStatsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDashboardInvoiceAmountPerMonthStatsQuery | undefined,
    GQDashboardInvoiceAmountPerMonthStatsQueryVariables
>;
export function useDashboardInvoiceAmountPerMonthStatsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDashboardInvoiceAmountPerMonthStatsQuery,
              GQDashboardInvoiceAmountPerMonthStatsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDashboardInvoiceAmountPerMonthStatsQuery,
        GQDashboardInvoiceAmountPerMonthStatsQueryVariables
    >(DashboardInvoiceAmountPerMonthStatsDocument, options);
}
export type DashboardInvoiceAmountPerMonthStatsQueryHookResult = ReturnType<
    typeof useDashboardInvoiceAmountPerMonthStatsQuery
>;
export type DashboardInvoiceAmountPerMonthStatsLazyQueryHookResult = ReturnType<
    typeof useDashboardInvoiceAmountPerMonthStatsLazyQuery
>;
export type DashboardInvoiceAmountPerMonthStatsSuspenseQueryHookResult =
    ReturnType<typeof useDashboardInvoiceAmountPerMonthStatsSuspenseQuery>;
export type DashboardInvoiceAmountPerMonthStatsQueryResult =
    ApolloReactCommon.QueryResult<
        GQDashboardInvoiceAmountPerMonthStatsQuery,
        GQDashboardInvoiceAmountPerMonthStatsQueryVariables
    >;
export const SubscribeToDashboardDocument = gql`
    subscription subscribeToDashboard(
        $from: Date!
        $to: Date!
        $departmentIds: [String!]
    ) {
        dashboardUpdated(from: $from, to: $to, departmentIds: $departmentIds) {
            ...allDashboard
        }
    }
    ${AllDashboardFragmentDoc}
`;

/**
 * __useSubscribeToDashboardSubscription__
 *
 * To run a query within a React component, call `useSubscribeToDashboardSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToDashboardSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToDashboardSubscription({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      departmentIds: // value for 'departmentIds'
 *   },
 * });
 */
export function useSubscribeToDashboardSubscription(
    baseOptions: ApolloReactHooks.SubscriptionHookOptions<
        GQSubscribeToDashboardSubscription,
        GQSubscribeToDashboardSubscriptionVariables
    > &
        (
            | {
                  variables: GQSubscribeToDashboardSubscriptionVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSubscription<
        GQSubscribeToDashboardSubscription,
        GQSubscribeToDashboardSubscriptionVariables
    >(SubscribeToDashboardDocument, options);
}
export type SubscribeToDashboardSubscriptionHookResult = ReturnType<
    typeof useSubscribeToDashboardSubscription
>;
export type SubscribeToDashboardSubscriptionResult =
    ApolloReactCommon.SubscriptionResult<GQSubscribeToDashboardSubscription>;
export const DashboardDocument = gql`
    query dashboard($from: Date!, $to: Date!, $departmentIds: [String!]) {
        dashboard(from: $from, to: $to, departmentIds: $departmentIds) {
            ...allDashboard
        }
    }
    ${AllDashboardFragmentDoc}
`;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      departmentIds: // value for 'departmentIds'
 *   },
 * });
 */
export function useDashboardQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQDashboardQuery,
        GQDashboardQueryVariables
    > &
        (
            | { variables: GQDashboardQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQDashboardQuery,
        GQDashboardQueryVariables
    >(DashboardDocument, options);
}
export function useDashboardLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDashboardQuery,
        GQDashboardQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDashboardQuery,
        GQDashboardQueryVariables
    >(DashboardDocument, options);
}
// @ts-ignore
export function useDashboardSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDashboardQuery,
        GQDashboardQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDashboardQuery,
    GQDashboardQueryVariables
>;
export function useDashboardSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDashboardQuery,
              GQDashboardQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDashboardQuery | undefined,
    GQDashboardQueryVariables
>;
export function useDashboardSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDashboardQuery,
              GQDashboardQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDashboardQuery,
        GQDashboardQueryVariables
    >(DashboardDocument, options);
}
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardLazyQueryHookResult = ReturnType<
    typeof useDashboardLazyQuery
>;
export type DashboardSuspenseQueryHookResult = ReturnType<
    typeof useDashboardSuspenseQuery
>;
export type DashboardQueryResult = ApolloReactCommon.QueryResult<
    GQDashboardQuery,
    GQDashboardQueryVariables
>;
export const UserRoleConfigurationDocument = gql`
    query userRoleConfiguration(
        $userId: ID!
        $merchantId: ID
        $roleId: ID!
        $type: String!
    ) {
        userRoleConfiguration(
            userId: $userId
            merchantId: $merchantId
            roleId: $roleId
            type: $type
        ) {
            user {
                id
            }
            merchant {
                id
            }
            role {
                id
            }
            type
            data
        }
    }
`;

/**
 * __useUserRoleConfigurationQuery__
 *
 * To run a query within a React component, call `useUserRoleConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleConfigurationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      merchantId: // value for 'merchantId'
 *      roleId: // value for 'roleId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUserRoleConfigurationQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQUserRoleConfigurationQuery,
        GQUserRoleConfigurationQueryVariables
    > &
        (
            | {
                  variables: GQUserRoleConfigurationQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQUserRoleConfigurationQuery,
        GQUserRoleConfigurationQueryVariables
    >(UserRoleConfigurationDocument, options);
}
export function useUserRoleConfigurationLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQUserRoleConfigurationQuery,
        GQUserRoleConfigurationQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQUserRoleConfigurationQuery,
        GQUserRoleConfigurationQueryVariables
    >(UserRoleConfigurationDocument, options);
}
// @ts-ignore
export function useUserRoleConfigurationSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQUserRoleConfigurationQuery,
        GQUserRoleConfigurationQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQUserRoleConfigurationQuery,
    GQUserRoleConfigurationQueryVariables
>;
export function useUserRoleConfigurationSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUserRoleConfigurationQuery,
              GQUserRoleConfigurationQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQUserRoleConfigurationQuery | undefined,
    GQUserRoleConfigurationQueryVariables
>;
export function useUserRoleConfigurationSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUserRoleConfigurationQuery,
              GQUserRoleConfigurationQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQUserRoleConfigurationQuery,
        GQUserRoleConfigurationQueryVariables
    >(UserRoleConfigurationDocument, options);
}
export type UserRoleConfigurationQueryHookResult = ReturnType<
    typeof useUserRoleConfigurationQuery
>;
export type UserRoleConfigurationLazyQueryHookResult = ReturnType<
    typeof useUserRoleConfigurationLazyQuery
>;
export type UserRoleConfigurationSuspenseQueryHookResult = ReturnType<
    typeof useUserRoleConfigurationSuspenseQuery
>;
export type UserRoleConfigurationQueryResult = ApolloReactCommon.QueryResult<
    GQUserRoleConfigurationQuery,
    GQUserRoleConfigurationQueryVariables
>;
export const UserRoleConfigurationSaveDocument = gql`
    mutation userRoleConfigurationSave(
        $userId: ID!
        $merchantId: ID
        $roleId: ID!
        $type: String!
        $configuration: JSON!
    ) {
        userRoleConfigurationSave(
            userId: $userId
            merchantId: $merchantId
            roleId: $roleId
            type: $type
            configuration: $configuration
        ) {
            status
        }
    }
`;
export type GQUserRoleConfigurationSaveMutationFn =
    ApolloReactCommon.MutationFunction<
        GQUserRoleConfigurationSaveMutation,
        GQUserRoleConfigurationSaveMutationVariables
    >;

/**
 * __useUserRoleConfigurationSaveMutation__
 *
 * To run a mutation, you first call `useUserRoleConfigurationSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRoleConfigurationSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRoleConfigurationSaveMutation, { data, loading, error }] = useUserRoleConfigurationSaveMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      merchantId: // value for 'merchantId'
 *      roleId: // value for 'roleId'
 *      type: // value for 'type'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useUserRoleConfigurationSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQUserRoleConfigurationSaveMutation,
        GQUserRoleConfigurationSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQUserRoleConfigurationSaveMutation,
        GQUserRoleConfigurationSaveMutationVariables
    >(UserRoleConfigurationSaveDocument, options);
}
export type UserRoleConfigurationSaveMutationHookResult = ReturnType<
    typeof useUserRoleConfigurationSaveMutation
>;
export type UserRoleConfigurationSaveMutationResult =
    ApolloReactCommon.MutationResult<GQUserRoleConfigurationSaveMutation>;
export type UserRoleConfigurationSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQUserRoleConfigurationSaveMutation,
        GQUserRoleConfigurationSaveMutationVariables
    >;
export const DepartmentsDocument = gql`
    query departments(
        $pagination: PaginationInput
        $search: SearchInput
        $searching: DepartmentSearchInput
    ) {
        departments(
            pagination: $pagination
            search: $search
            searching: $searching
        ) {
            data {
                ...allDepartmentFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllDepartmentFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useDepartmentsQuery__
 *
 * To run a query within a React component, call `useDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useDepartmentsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQDepartmentsQuery,
        GQDepartmentsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQDepartmentsQuery,
        GQDepartmentsQueryVariables
    >(DepartmentsDocument, options);
}
export function useDepartmentsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDepartmentsQuery,
        GQDepartmentsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDepartmentsQuery,
        GQDepartmentsQueryVariables
    >(DepartmentsDocument, options);
}
// @ts-ignore
export function useDepartmentsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDepartmentsQuery,
        GQDepartmentsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDepartmentsQuery,
    GQDepartmentsQueryVariables
>;
export function useDepartmentsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDepartmentsQuery,
              GQDepartmentsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDepartmentsQuery | undefined,
    GQDepartmentsQueryVariables
>;
export function useDepartmentsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDepartmentsQuery,
              GQDepartmentsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDepartmentsQuery,
        GQDepartmentsQueryVariables
    >(DepartmentsDocument, options);
}
export type DepartmentsQueryHookResult = ReturnType<typeof useDepartmentsQuery>;
export type DepartmentsLazyQueryHookResult = ReturnType<
    typeof useDepartmentsLazyQuery
>;
export type DepartmentsSuspenseQueryHookResult = ReturnType<
    typeof useDepartmentsSuspenseQuery
>;
export type DepartmentsQueryResult = ApolloReactCommon.QueryResult<
    GQDepartmentsQuery,
    GQDepartmentsQueryVariables
>;
export const DepartmentDocument = gql`
    query department($id: ID!) {
        department(id: $id) {
            ...allDepartmentFields
        }
    }
    ${AllDepartmentFieldsFragmentDoc}
`;

/**
 * __useDepartmentQuery__
 *
 * To run a query within a React component, call `useDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepartmentQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQDepartmentQuery,
        GQDepartmentQueryVariables
    > &
        (
            | { variables: GQDepartmentQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQDepartmentQuery,
        GQDepartmentQueryVariables
    >(DepartmentDocument, options);
}
export function useDepartmentLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDepartmentQuery,
        GQDepartmentQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDepartmentQuery,
        GQDepartmentQueryVariables
    >(DepartmentDocument, options);
}
// @ts-ignore
export function useDepartmentSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDepartmentQuery,
        GQDepartmentQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDepartmentQuery,
    GQDepartmentQueryVariables
>;
export function useDepartmentSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDepartmentQuery,
              GQDepartmentQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDepartmentQuery | undefined,
    GQDepartmentQueryVariables
>;
export function useDepartmentSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDepartmentQuery,
              GQDepartmentQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDepartmentQuery,
        GQDepartmentQueryVariables
    >(DepartmentDocument, options);
}
export type DepartmentQueryHookResult = ReturnType<typeof useDepartmentQuery>;
export type DepartmentLazyQueryHookResult = ReturnType<
    typeof useDepartmentLazyQuery
>;
export type DepartmentSuspenseQueryHookResult = ReturnType<
    typeof useDepartmentSuspenseQuery
>;
export type DepartmentQueryResult = ApolloReactCommon.QueryResult<
    GQDepartmentQuery,
    GQDepartmentQueryVariables
>;
export const DepartmentCreateDocument = gql`
    mutation departmentCreate($department: DepartmentInput!) {
        departmentCreate(department: $department) {
            ...allDepartmentFields
        }
    }
    ${AllDepartmentFieldsFragmentDoc}
`;
export type GQDepartmentCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQDepartmentCreateMutation,
    GQDepartmentCreateMutationVariables
>;

/**
 * __useDepartmentCreateMutation__
 *
 * To run a mutation, you first call `useDepartmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepartmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [departmentCreateMutation, { data, loading, error }] = useDepartmentCreateMutation({
 *   variables: {
 *      department: // value for 'department'
 *   },
 * });
 */
export function useDepartmentCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQDepartmentCreateMutation,
        GQDepartmentCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQDepartmentCreateMutation,
        GQDepartmentCreateMutationVariables
    >(DepartmentCreateDocument, options);
}
export type DepartmentCreateMutationHookResult = ReturnType<
    typeof useDepartmentCreateMutation
>;
export type DepartmentCreateMutationResult =
    ApolloReactCommon.MutationResult<GQDepartmentCreateMutation>;
export type DepartmentCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQDepartmentCreateMutation,
        GQDepartmentCreateMutationVariables
    >;
export const DepartmentSaveDocument = gql`
    mutation departmentSave($id: ID!, $department: DepartmentInput!) {
        departmentSave(id: $id, department: $department) {
            ...allDepartmentFields
        }
    }
    ${AllDepartmentFieldsFragmentDoc}
`;
export type GQDepartmentSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQDepartmentSaveMutation,
    GQDepartmentSaveMutationVariables
>;

/**
 * __useDepartmentSaveMutation__
 *
 * To run a mutation, you first call `useDepartmentSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepartmentSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [departmentSaveMutation, { data, loading, error }] = useDepartmentSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      department: // value for 'department'
 *   },
 * });
 */
export function useDepartmentSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQDepartmentSaveMutation,
        GQDepartmentSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQDepartmentSaveMutation,
        GQDepartmentSaveMutationVariables
    >(DepartmentSaveDocument, options);
}
export type DepartmentSaveMutationHookResult = ReturnType<
    typeof useDepartmentSaveMutation
>;
export type DepartmentSaveMutationResult =
    ApolloReactCommon.MutationResult<GQDepartmentSaveMutation>;
export type DepartmentSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQDepartmentSaveMutation,
        GQDepartmentSaveMutationVariables
    >;
export const DepartmentDeleteDocument = gql`
    mutation departmentDelete($id: ID!) {
        departmentDelete(id: $id) {
            status
        }
    }
`;
export type GQDepartmentDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQDepartmentDeleteMutation,
    GQDepartmentDeleteMutationVariables
>;

/**
 * __useDepartmentDeleteMutation__
 *
 * To run a mutation, you first call `useDepartmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepartmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [departmentDeleteMutation, { data, loading, error }] = useDepartmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepartmentDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQDepartmentDeleteMutation,
        GQDepartmentDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQDepartmentDeleteMutation,
        GQDepartmentDeleteMutationVariables
    >(DepartmentDeleteDocument, options);
}
export type DepartmentDeleteMutationHookResult = ReturnType<
    typeof useDepartmentDeleteMutation
>;
export type DepartmentDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQDepartmentDeleteMutation>;
export type DepartmentDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQDepartmentDeleteMutation,
        GQDepartmentDeleteMutationVariables
    >;
export const ViWarehousesDocument = gql`
    query viWarehouses($pagination: PaginationInput) {
        viWarehouses(pagination: $pagination) {
            data {
                id
                name
            }
        }
    }
`;

/**
 * __useViWarehousesQuery__
 *
 * To run a query within a React component, call `useViWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViWarehousesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useViWarehousesQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQViWarehousesQuery,
        GQViWarehousesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQViWarehousesQuery,
        GQViWarehousesQueryVariables
    >(ViWarehousesDocument, options);
}
export function useViWarehousesLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQViWarehousesQuery,
        GQViWarehousesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQViWarehousesQuery,
        GQViWarehousesQueryVariables
    >(ViWarehousesDocument, options);
}
// @ts-ignore
export function useViWarehousesSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQViWarehousesQuery,
        GQViWarehousesQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQViWarehousesQuery,
    GQViWarehousesQueryVariables
>;
export function useViWarehousesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQViWarehousesQuery,
              GQViWarehousesQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQViWarehousesQuery | undefined,
    GQViWarehousesQueryVariables
>;
export function useViWarehousesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQViWarehousesQuery,
              GQViWarehousesQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQViWarehousesQuery,
        GQViWarehousesQueryVariables
    >(ViWarehousesDocument, options);
}
export type ViWarehousesQueryHookResult = ReturnType<
    typeof useViWarehousesQuery
>;
export type ViWarehousesLazyQueryHookResult = ReturnType<
    typeof useViWarehousesLazyQuery
>;
export type ViWarehousesSuspenseQueryHookResult = ReturnType<
    typeof useViWarehousesSuspenseQuery
>;
export type ViWarehousesQueryResult = ApolloReactCommon.QueryResult<
    GQViWarehousesQuery,
    GQViWarehousesQueryVariables
>;
export const ViWarehouseForDepartmentDocument = gql`
    query viWarehouseForDepartment($departmentId: ID!) {
        viWarehouseForDepartment(departmentId: $departmentId) {
            id
            name
        }
    }
`;

/**
 * __useViWarehouseForDepartmentQuery__
 *
 * To run a query within a React component, call `useViWarehouseForDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useViWarehouseForDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViWarehouseForDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useViWarehouseForDepartmentQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQViWarehouseForDepartmentQuery,
        GQViWarehouseForDepartmentQueryVariables
    > &
        (
            | {
                  variables: GQViWarehouseForDepartmentQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQViWarehouseForDepartmentQuery,
        GQViWarehouseForDepartmentQueryVariables
    >(ViWarehouseForDepartmentDocument, options);
}
export function useViWarehouseForDepartmentLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQViWarehouseForDepartmentQuery,
        GQViWarehouseForDepartmentQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQViWarehouseForDepartmentQuery,
        GQViWarehouseForDepartmentQueryVariables
    >(ViWarehouseForDepartmentDocument, options);
}
// @ts-ignore
export function useViWarehouseForDepartmentSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQViWarehouseForDepartmentQuery,
        GQViWarehouseForDepartmentQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQViWarehouseForDepartmentQuery,
    GQViWarehouseForDepartmentQueryVariables
>;
export function useViWarehouseForDepartmentSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQViWarehouseForDepartmentQuery,
              GQViWarehouseForDepartmentQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQViWarehouseForDepartmentQuery | undefined,
    GQViWarehouseForDepartmentQueryVariables
>;
export function useViWarehouseForDepartmentSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQViWarehouseForDepartmentQuery,
              GQViWarehouseForDepartmentQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQViWarehouseForDepartmentQuery,
        GQViWarehouseForDepartmentQueryVariables
    >(ViWarehouseForDepartmentDocument, options);
}
export type ViWarehouseForDepartmentQueryHookResult = ReturnType<
    typeof useViWarehouseForDepartmentQuery
>;
export type ViWarehouseForDepartmentLazyQueryHookResult = ReturnType<
    typeof useViWarehouseForDepartmentLazyQuery
>;
export type ViWarehouseForDepartmentSuspenseQueryHookResult = ReturnType<
    typeof useViWarehouseForDepartmentSuspenseQuery
>;
export type ViWarehouseForDepartmentQueryResult = ApolloReactCommon.QueryResult<
    GQViWarehouseForDepartmentQuery,
    GQViWarehouseForDepartmentQueryVariables
>;
export const SetDepartment2WarehouseDocument = gql`
    mutation setDepartment2Warehouse($departmentId: ID!, $warehouseId: ID) {
        setDepartment2Warehouse(
            departmentId: $departmentId
            warehouseId: $warehouseId
        ) {
            status
        }
    }
`;
export type GQSetDepartment2WarehouseMutationFn =
    ApolloReactCommon.MutationFunction<
        GQSetDepartment2WarehouseMutation,
        GQSetDepartment2WarehouseMutationVariables
    >;

/**
 * __useSetDepartment2WarehouseMutation__
 *
 * To run a mutation, you first call `useSetDepartment2WarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDepartment2WarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDepartment2WarehouseMutation, { data, loading, error }] = useSetDepartment2WarehouseMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useSetDepartment2WarehouseMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQSetDepartment2WarehouseMutation,
        GQSetDepartment2WarehouseMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQSetDepartment2WarehouseMutation,
        GQSetDepartment2WarehouseMutationVariables
    >(SetDepartment2WarehouseDocument, options);
}
export type SetDepartment2WarehouseMutationHookResult = ReturnType<
    typeof useSetDepartment2WarehouseMutation
>;
export type SetDepartment2WarehouseMutationResult =
    ApolloReactCommon.MutationResult<GQSetDepartment2WarehouseMutation>;
export type SetDepartment2WarehouseMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQSetDepartment2WarehouseMutation,
        GQSetDepartment2WarehouseMutationVariables
    >;
export const UpdateViWarehousesDocument = gql`
    mutation updateViWarehouses {
        updateViWarehouses {
            status
        }
    }
`;
export type GQUpdateViWarehousesMutationFn = ApolloReactCommon.MutationFunction<
    GQUpdateViWarehousesMutation,
    GQUpdateViWarehousesMutationVariables
>;

/**
 * __useUpdateViWarehousesMutation__
 *
 * To run a mutation, you first call `useUpdateViWarehousesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateViWarehousesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateViWarehousesMutation, { data, loading, error }] = useUpdateViWarehousesMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateViWarehousesMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQUpdateViWarehousesMutation,
        GQUpdateViWarehousesMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQUpdateViWarehousesMutation,
        GQUpdateViWarehousesMutationVariables
    >(UpdateViWarehousesDocument, options);
}
export type UpdateViWarehousesMutationHookResult = ReturnType<
    typeof useUpdateViWarehousesMutation
>;
export type UpdateViWarehousesMutationResult =
    ApolloReactCommon.MutationResult<GQUpdateViWarehousesMutation>;
export type UpdateViWarehousesMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQUpdateViWarehousesMutation,
        GQUpdateViWarehousesMutationVariables
    >;
export const DiscountsDocument = gql`
    query discounts(
        $pagination: PaginationInput
        $searching: DiscountSearchInput
    ) {
        discounts(pagination: $pagination, searching: $searching) {
            data {
                ...allDiscountFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllDiscountFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useDiscountsQuery__
 *
 * To run a query within a React component, call `useDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useDiscountsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQDiscountsQuery,
        GQDiscountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQDiscountsQuery,
        GQDiscountsQueryVariables
    >(DiscountsDocument, options);
}
export function useDiscountsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDiscountsQuery,
        GQDiscountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDiscountsQuery,
        GQDiscountsQueryVariables
    >(DiscountsDocument, options);
}
// @ts-ignore
export function useDiscountsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDiscountsQuery,
        GQDiscountsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDiscountsQuery,
    GQDiscountsQueryVariables
>;
export function useDiscountsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDiscountsQuery,
              GQDiscountsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDiscountsQuery | undefined,
    GQDiscountsQueryVariables
>;
export function useDiscountsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDiscountsQuery,
              GQDiscountsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDiscountsQuery,
        GQDiscountsQueryVariables
    >(DiscountsDocument, options);
}
export type DiscountsQueryHookResult = ReturnType<typeof useDiscountsQuery>;
export type DiscountsLazyQueryHookResult = ReturnType<
    typeof useDiscountsLazyQuery
>;
export type DiscountsSuspenseQueryHookResult = ReturnType<
    typeof useDiscountsSuspenseQuery
>;
export type DiscountsQueryResult = ApolloReactCommon.QueryResult<
    GQDiscountsQuery,
    GQDiscountsQueryVariables
>;
export const DiscountDocument = gql`
    query discount($id: ID!) {
        discount(id: $id) {
            ...allDiscountFields
        }
    }
    ${AllDiscountFieldsFragmentDoc}
`;

/**
 * __useDiscountQuery__
 *
 * To run a query within a React component, call `useDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiscountQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQDiscountQuery,
        GQDiscountQueryVariables
    > &
        (
            | { variables: GQDiscountQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQDiscountQuery, GQDiscountQueryVariables>(
        DiscountDocument,
        options
    );
}
export function useDiscountLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDiscountQuery,
        GQDiscountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDiscountQuery,
        GQDiscountQueryVariables
    >(DiscountDocument, options);
}
// @ts-ignore
export function useDiscountSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDiscountQuery,
        GQDiscountQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDiscountQuery,
    GQDiscountQueryVariables
>;
export function useDiscountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDiscountQuery,
              GQDiscountQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDiscountQuery | undefined,
    GQDiscountQueryVariables
>;
export function useDiscountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDiscountQuery,
              GQDiscountQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDiscountQuery,
        GQDiscountQueryVariables
    >(DiscountDocument, options);
}
export type DiscountQueryHookResult = ReturnType<typeof useDiscountQuery>;
export type DiscountLazyQueryHookResult = ReturnType<
    typeof useDiscountLazyQuery
>;
export type DiscountSuspenseQueryHookResult = ReturnType<
    typeof useDiscountSuspenseQuery
>;
export type DiscountQueryResult = ApolloReactCommon.QueryResult<
    GQDiscountQuery,
    GQDiscountQueryVariables
>;
export const DiscountFormDocument = gql`
    query discountForm {
        products(
            includeInactive: true
            pagination: { pageSize: 999999, sort: "name", sortDirection: "ASC" }
            includeChildren: true
        ) {
            data {
                id
                name
                active
            }
        }
        tags(
            pagination: { pageSize: 999999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                identifier
                name
            }
        }
        tagGroups(
            pagination: { pageSize: 999999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
            }
        }
        customers(
            pagination: { pageSize: 999999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
            }
        }
        customerGroups(
            pagination: { pageSize: 999999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
            }
        }
        departments(
            pagination: { pageSize: 999999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
            }
        }
    }
`;

/**
 * __useDiscountFormQuery__
 *
 * To run a query within a React component, call `useDiscountFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiscountFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQDiscountFormQuery,
        GQDiscountFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQDiscountFormQuery,
        GQDiscountFormQueryVariables
    >(DiscountFormDocument, options);
}
export function useDiscountFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQDiscountFormQuery,
        GQDiscountFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQDiscountFormQuery,
        GQDiscountFormQueryVariables
    >(DiscountFormDocument, options);
}
// @ts-ignore
export function useDiscountFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQDiscountFormQuery,
        GQDiscountFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDiscountFormQuery,
    GQDiscountFormQueryVariables
>;
export function useDiscountFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDiscountFormQuery,
              GQDiscountFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQDiscountFormQuery | undefined,
    GQDiscountFormQueryVariables
>;
export function useDiscountFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQDiscountFormQuery,
              GQDiscountFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQDiscountFormQuery,
        GQDiscountFormQueryVariables
    >(DiscountFormDocument, options);
}
export type DiscountFormQueryHookResult = ReturnType<
    typeof useDiscountFormQuery
>;
export type DiscountFormLazyQueryHookResult = ReturnType<
    typeof useDiscountFormLazyQuery
>;
export type DiscountFormSuspenseQueryHookResult = ReturnType<
    typeof useDiscountFormSuspenseQuery
>;
export type DiscountFormQueryResult = ApolloReactCommon.QueryResult<
    GQDiscountFormQuery,
    GQDiscountFormQueryVariables
>;
export const DiscountCreateDocument = gql`
    mutation discountCreate($discount: DiscountInput!) {
        discountCreate(discount: $discount) {
            ...allDiscountFields
        }
    }
    ${AllDiscountFieldsFragmentDoc}
`;
export type GQDiscountCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQDiscountCreateMutation,
    GQDiscountCreateMutationVariables
>;

/**
 * __useDiscountCreateMutation__
 *
 * To run a mutation, you first call `useDiscountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountCreateMutation, { data, loading, error }] = useDiscountCreateMutation({
 *   variables: {
 *      discount: // value for 'discount'
 *   },
 * });
 */
export function useDiscountCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQDiscountCreateMutation,
        GQDiscountCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQDiscountCreateMutation,
        GQDiscountCreateMutationVariables
    >(DiscountCreateDocument, options);
}
export type DiscountCreateMutationHookResult = ReturnType<
    typeof useDiscountCreateMutation
>;
export type DiscountCreateMutationResult =
    ApolloReactCommon.MutationResult<GQDiscountCreateMutation>;
export type DiscountCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQDiscountCreateMutation,
        GQDiscountCreateMutationVariables
    >;
export const DiscountSaveDocument = gql`
    mutation discountSave($id: ID!, $discount: DiscountInput!) {
        discountSave(id: $id, discount: $discount) {
            ...allDiscountFields
        }
    }
    ${AllDiscountFieldsFragmentDoc}
`;
export type GQDiscountSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQDiscountSaveMutation,
    GQDiscountSaveMutationVariables
>;

/**
 * __useDiscountSaveMutation__
 *
 * To run a mutation, you first call `useDiscountSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountSaveMutation, { data, loading, error }] = useDiscountSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      discount: // value for 'discount'
 *   },
 * });
 */
export function useDiscountSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQDiscountSaveMutation,
        GQDiscountSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQDiscountSaveMutation,
        GQDiscountSaveMutationVariables
    >(DiscountSaveDocument, options);
}
export type DiscountSaveMutationHookResult = ReturnType<
    typeof useDiscountSaveMutation
>;
export type DiscountSaveMutationResult =
    ApolloReactCommon.MutationResult<GQDiscountSaveMutation>;
export type DiscountSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQDiscountSaveMutation,
    GQDiscountSaveMutationVariables
>;
export const DiscountDeleteDocument = gql`
    mutation discountDelete($id: ID!) {
        discountDelete(id: $id) {
            status
        }
    }
`;
export type GQDiscountDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQDiscountDeleteMutation,
    GQDiscountDeleteMutationVariables
>;

/**
 * __useDiscountDeleteMutation__
 *
 * To run a mutation, you first call `useDiscountDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountDeleteMutation, { data, loading, error }] = useDiscountDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiscountDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQDiscountDeleteMutation,
        GQDiscountDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQDiscountDeleteMutation,
        GQDiscountDeleteMutationVariables
    >(DiscountDeleteDocument, options);
}
export type DiscountDeleteMutationHookResult = ReturnType<
    typeof useDiscountDeleteMutation
>;
export type DiscountDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQDiscountDeleteMutation>;
export type DiscountDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQDiscountDeleteMutation,
        GQDiscountDeleteMutationVariables
    >;
export const DiscountsActiveToggleDocument = gql`
    mutation discountsActiveToggle($ids: [ID!]!) {
        discountsActiveToggle(ids: $ids) {
            status
        }
    }
`;
export type GQDiscountsActiveToggleMutationFn =
    ApolloReactCommon.MutationFunction<
        GQDiscountsActiveToggleMutation,
        GQDiscountsActiveToggleMutationVariables
    >;

/**
 * __useDiscountsActiveToggleMutation__
 *
 * To run a mutation, you first call `useDiscountsActiveToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountsActiveToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountsActiveToggleMutation, { data, loading, error }] = useDiscountsActiveToggleMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDiscountsActiveToggleMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQDiscountsActiveToggleMutation,
        GQDiscountsActiveToggleMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQDiscountsActiveToggleMutation,
        GQDiscountsActiveToggleMutationVariables
    >(DiscountsActiveToggleDocument, options);
}
export type DiscountsActiveToggleMutationHookResult = ReturnType<
    typeof useDiscountsActiveToggleMutation
>;
export type DiscountsActiveToggleMutationResult =
    ApolloReactCommon.MutationResult<GQDiscountsActiveToggleMutation>;
export type DiscountsActiveToggleMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQDiscountsActiveToggleMutation,
        GQDiscountsActiveToggleMutationVariables
    >;
export const EconomicSyncJobsDocument = gql`
    query economicSyncJobs($pagination: PaginationInput) {
        economicSyncJobs(pagination: $pagination) {
            data {
                ...economicSyncJobFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${EconomicSyncJobFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useEconomicSyncJobsQuery__
 *
 * To run a query within a React component, call `useEconomicSyncJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEconomicSyncJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEconomicSyncJobsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useEconomicSyncJobsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQEconomicSyncJobsQuery,
        GQEconomicSyncJobsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQEconomicSyncJobsQuery,
        GQEconomicSyncJobsQueryVariables
    >(EconomicSyncJobsDocument, options);
}
export function useEconomicSyncJobsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQEconomicSyncJobsQuery,
        GQEconomicSyncJobsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQEconomicSyncJobsQuery,
        GQEconomicSyncJobsQueryVariables
    >(EconomicSyncJobsDocument, options);
}
// @ts-ignore
export function useEconomicSyncJobsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQEconomicSyncJobsQuery,
        GQEconomicSyncJobsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQEconomicSyncJobsQuery,
    GQEconomicSyncJobsQueryVariables
>;
export function useEconomicSyncJobsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQEconomicSyncJobsQuery,
              GQEconomicSyncJobsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQEconomicSyncJobsQuery | undefined,
    GQEconomicSyncJobsQueryVariables
>;
export function useEconomicSyncJobsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQEconomicSyncJobsQuery,
              GQEconomicSyncJobsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQEconomicSyncJobsQuery,
        GQEconomicSyncJobsQueryVariables
    >(EconomicSyncJobsDocument, options);
}
export type EconomicSyncJobsQueryHookResult = ReturnType<
    typeof useEconomicSyncJobsQuery
>;
export type EconomicSyncJobsLazyQueryHookResult = ReturnType<
    typeof useEconomicSyncJobsLazyQuery
>;
export type EconomicSyncJobsSuspenseQueryHookResult = ReturnType<
    typeof useEconomicSyncJobsSuspenseQuery
>;
export type EconomicSyncJobsQueryResult = ApolloReactCommon.QueryResult<
    GQEconomicSyncJobsQuery,
    GQEconomicSyncJobsQueryVariables
>;
export const InvoiceCountDocument = gql`
    query invoiceCount($from: Date!, $to: Date!) {
        invoiceCount(from: $from, to: $to) {
            count
            merchant {
                name
            }
        }
    }
`;

/**
 * __useInvoiceCountQuery__
 *
 * To run a query within a React component, call `useInvoiceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceCountQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useInvoiceCountQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQInvoiceCountQuery,
        GQInvoiceCountQueryVariables
    > &
        (
            | { variables: GQInvoiceCountQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQInvoiceCountQuery,
        GQInvoiceCountQueryVariables
    >(InvoiceCountDocument, options);
}
export function useInvoiceCountLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQInvoiceCountQuery,
        GQInvoiceCountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQInvoiceCountQuery,
        GQInvoiceCountQueryVariables
    >(InvoiceCountDocument, options);
}
// @ts-ignore
export function useInvoiceCountSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQInvoiceCountQuery,
        GQInvoiceCountQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInvoiceCountQuery,
    GQInvoiceCountQueryVariables
>;
export function useInvoiceCountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInvoiceCountQuery,
              GQInvoiceCountQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInvoiceCountQuery | undefined,
    GQInvoiceCountQueryVariables
>;
export function useInvoiceCountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInvoiceCountQuery,
              GQInvoiceCountQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQInvoiceCountQuery,
        GQInvoiceCountQueryVariables
    >(InvoiceCountDocument, options);
}
export type InvoiceCountQueryHookResult = ReturnType<
    typeof useInvoiceCountQuery
>;
export type InvoiceCountLazyQueryHookResult = ReturnType<
    typeof useInvoiceCountLazyQuery
>;
export type InvoiceCountSuspenseQueryHookResult = ReturnType<
    typeof useInvoiceCountSuspenseQuery
>;
export type InvoiceCountQueryResult = ApolloReactCommon.QueryResult<
    GQInvoiceCountQuery,
    GQInvoiceCountQueryVariables
>;
export const MerchantChartOfAccountsDocument = gql`
    query merchantChartOfAccounts($integrationId: ID!) {
        merchantChartOfAccounts(integrationId: $integrationId) {
            data {
                chartOfAccountsId
                merchantAccountNo
                name
            }
        }
    }
`;

/**
 * __useMerchantChartOfAccountsQuery__
 *
 * To run a query within a React component, call `useMerchantChartOfAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantChartOfAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantChartOfAccountsQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useMerchantChartOfAccountsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQMerchantChartOfAccountsQuery,
        GQMerchantChartOfAccountsQueryVariables
    > &
        (
            | {
                  variables: GQMerchantChartOfAccountsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQMerchantChartOfAccountsQuery,
        GQMerchantChartOfAccountsQueryVariables
    >(MerchantChartOfAccountsDocument, options);
}
export function useMerchantChartOfAccountsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQMerchantChartOfAccountsQuery,
        GQMerchantChartOfAccountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQMerchantChartOfAccountsQuery,
        GQMerchantChartOfAccountsQueryVariables
    >(MerchantChartOfAccountsDocument, options);
}
// @ts-ignore
export function useMerchantChartOfAccountsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQMerchantChartOfAccountsQuery,
        GQMerchantChartOfAccountsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMerchantChartOfAccountsQuery,
    GQMerchantChartOfAccountsQueryVariables
>;
export function useMerchantChartOfAccountsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMerchantChartOfAccountsQuery,
              GQMerchantChartOfAccountsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMerchantChartOfAccountsQuery | undefined,
    GQMerchantChartOfAccountsQueryVariables
>;
export function useMerchantChartOfAccountsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMerchantChartOfAccountsQuery,
              GQMerchantChartOfAccountsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQMerchantChartOfAccountsQuery,
        GQMerchantChartOfAccountsQueryVariables
    >(MerchantChartOfAccountsDocument, options);
}
export type MerchantChartOfAccountsQueryHookResult = ReturnType<
    typeof useMerchantChartOfAccountsQuery
>;
export type MerchantChartOfAccountsLazyQueryHookResult = ReturnType<
    typeof useMerchantChartOfAccountsLazyQuery
>;
export type MerchantChartOfAccountsSuspenseQueryHookResult = ReturnType<
    typeof useMerchantChartOfAccountsSuspenseQuery
>;
export type MerchantChartOfAccountsQueryResult = ApolloReactCommon.QueryResult<
    GQMerchantChartOfAccountsQuery,
    GQMerchantChartOfAccountsQueryVariables
>;
export const AccountChartByProductGroupDocument = gql`
    query accountChartByProductGroup($integrationId: ID!) {
        accountChartByProductGroup(integrationId: $integrationId) {
            data {
                accountNo
                productGroupId
                productGroup {
                    id
                    name
                    deletedAt
                }
            }
        }
    }
`;

/**
 * __useAccountChartByProductGroupQuery__
 *
 * To run a query within a React component, call `useAccountChartByProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountChartByProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountChartByProductGroupQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useAccountChartByProductGroupQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQAccountChartByProductGroupQuery,
        GQAccountChartByProductGroupQueryVariables
    > &
        (
            | {
                  variables: GQAccountChartByProductGroupQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAccountChartByProductGroupQuery,
        GQAccountChartByProductGroupQueryVariables
    >(AccountChartByProductGroupDocument, options);
}
export function useAccountChartByProductGroupLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAccountChartByProductGroupQuery,
        GQAccountChartByProductGroupQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAccountChartByProductGroupQuery,
        GQAccountChartByProductGroupQueryVariables
    >(AccountChartByProductGroupDocument, options);
}
// @ts-ignore
export function useAccountChartByProductGroupSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAccountChartByProductGroupQuery,
        GQAccountChartByProductGroupQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountChartByProductGroupQuery,
    GQAccountChartByProductGroupQueryVariables
>;
export function useAccountChartByProductGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountChartByProductGroupQuery,
              GQAccountChartByProductGroupQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountChartByProductGroupQuery | undefined,
    GQAccountChartByProductGroupQueryVariables
>;
export function useAccountChartByProductGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountChartByProductGroupQuery,
              GQAccountChartByProductGroupQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAccountChartByProductGroupQuery,
        GQAccountChartByProductGroupQueryVariables
    >(AccountChartByProductGroupDocument, options);
}
export type AccountChartByProductGroupQueryHookResult = ReturnType<
    typeof useAccountChartByProductGroupQuery
>;
export type AccountChartByProductGroupLazyQueryHookResult = ReturnType<
    typeof useAccountChartByProductGroupLazyQuery
>;
export type AccountChartByProductGroupSuspenseQueryHookResult = ReturnType<
    typeof useAccountChartByProductGroupSuspenseQuery
>;
export type AccountChartByProductGroupQueryResult =
    ApolloReactCommon.QueryResult<
        GQAccountChartByProductGroupQuery,
        GQAccountChartByProductGroupQueryVariables
    >;
export const AccountForProductGroupDocument = gql`
    query accountForProductGroup($integrationId: ID!, $productGroupId: ID!) {
        accountForProductGroup(
            integrationId: $integrationId
            productGroupId: $productGroupId
        ) {
            accountNo
            productGroupId
            productGroup {
                id
                name
            }
        }
    }
`;

/**
 * __useAccountForProductGroupQuery__
 *
 * To run a query within a React component, call `useAccountForProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountForProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountForProductGroupQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      productGroupId: // value for 'productGroupId'
 *   },
 * });
 */
export function useAccountForProductGroupQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQAccountForProductGroupQuery,
        GQAccountForProductGroupQueryVariables
    > &
        (
            | {
                  variables: GQAccountForProductGroupQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAccountForProductGroupQuery,
        GQAccountForProductGroupQueryVariables
    >(AccountForProductGroupDocument, options);
}
export function useAccountForProductGroupLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAccountForProductGroupQuery,
        GQAccountForProductGroupQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAccountForProductGroupQuery,
        GQAccountForProductGroupQueryVariables
    >(AccountForProductGroupDocument, options);
}
// @ts-ignore
export function useAccountForProductGroupSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAccountForProductGroupQuery,
        GQAccountForProductGroupQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountForProductGroupQuery,
    GQAccountForProductGroupQueryVariables
>;
export function useAccountForProductGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountForProductGroupQuery,
              GQAccountForProductGroupQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountForProductGroupQuery | undefined,
    GQAccountForProductGroupQueryVariables
>;
export function useAccountForProductGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountForProductGroupQuery,
              GQAccountForProductGroupQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAccountForProductGroupQuery,
        GQAccountForProductGroupQueryVariables
    >(AccountForProductGroupDocument, options);
}
export type AccountForProductGroupQueryHookResult = ReturnType<
    typeof useAccountForProductGroupQuery
>;
export type AccountForProductGroupLazyQueryHookResult = ReturnType<
    typeof useAccountForProductGroupLazyQuery
>;
export type AccountForProductGroupSuspenseQueryHookResult = ReturnType<
    typeof useAccountForProductGroupSuspenseQuery
>;
export type AccountForProductGroupQueryResult = ApolloReactCommon.QueryResult<
    GQAccountForProductGroupQuery,
    GQAccountForProductGroupQueryVariables
>;
export const SaveMerchantChartOfAccountsDocument = gql`
    mutation saveMerchantChartOfAccounts(
        $integrationId: ID!
        $chartOfAccounts: [MerchantChartOfAccountInput!]!
    ) {
        saveMerchantChartOfAccounts(
            integrationId: $integrationId
            chartOfAccounts: $chartOfAccounts
        ) {
            status
        }
    }
`;
export type GQSaveMerchantChartOfAccountsMutationFn =
    ApolloReactCommon.MutationFunction<
        GQSaveMerchantChartOfAccountsMutation,
        GQSaveMerchantChartOfAccountsMutationVariables
    >;

/**
 * __useSaveMerchantChartOfAccountsMutation__
 *
 * To run a mutation, you first call `useSaveMerchantChartOfAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMerchantChartOfAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMerchantChartOfAccountsMutation, { data, loading, error }] = useSaveMerchantChartOfAccountsMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      chartOfAccounts: // value for 'chartOfAccounts'
 *   },
 * });
 */
export function useSaveMerchantChartOfAccountsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQSaveMerchantChartOfAccountsMutation,
        GQSaveMerchantChartOfAccountsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQSaveMerchantChartOfAccountsMutation,
        GQSaveMerchantChartOfAccountsMutationVariables
    >(SaveMerchantChartOfAccountsDocument, options);
}
export type SaveMerchantChartOfAccountsMutationHookResult = ReturnType<
    typeof useSaveMerchantChartOfAccountsMutation
>;
export type SaveMerchantChartOfAccountsMutationResult =
    ApolloReactCommon.MutationResult<GQSaveMerchantChartOfAccountsMutation>;
export type SaveMerchantChartOfAccountsMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQSaveMerchantChartOfAccountsMutation,
        GQSaveMerchantChartOfAccountsMutationVariables
    >;
export const SaveAccountChartByProductGroupDocument = gql`
    mutation saveAccountChartByProductGroup(
        $integrationId: ID!
        $productGroupMap: [ChartAccountInput!]!
    ) {
        saveAccountChartByProductGroup(
            integrationId: $integrationId
            productGroupMap: $productGroupMap
        ) {
            status
        }
    }
`;
export type GQSaveAccountChartByProductGroupMutationFn =
    ApolloReactCommon.MutationFunction<
        GQSaveAccountChartByProductGroupMutation,
        GQSaveAccountChartByProductGroupMutationVariables
    >;

/**
 * __useSaveAccountChartByProductGroupMutation__
 *
 * To run a mutation, you first call `useSaveAccountChartByProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAccountChartByProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAccountChartByProductGroupMutation, { data, loading, error }] = useSaveAccountChartByProductGroupMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      productGroupMap: // value for 'productGroupMap'
 *   },
 * });
 */
export function useSaveAccountChartByProductGroupMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQSaveAccountChartByProductGroupMutation,
        GQSaveAccountChartByProductGroupMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQSaveAccountChartByProductGroupMutation,
        GQSaveAccountChartByProductGroupMutationVariables
    >(SaveAccountChartByProductGroupDocument, options);
}
export type SaveAccountChartByProductGroupMutationHookResult = ReturnType<
    typeof useSaveAccountChartByProductGroupMutation
>;
export type SaveAccountChartByProductGroupMutationResult =
    ApolloReactCommon.MutationResult<GQSaveAccountChartByProductGroupMutation>;
export type SaveAccountChartByProductGroupMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQSaveAccountChartByProductGroupMutation,
        GQSaveAccountChartByProductGroupMutationVariables
    >;
export const SaveAccountForProductGroupDocument = gql`
    mutation saveAccountForProductGroup(
        $integrationId: ID!
        $productGroupMap: ChartAccountInput!
    ) {
        saveAccountForProductGroup(
            integrationId: $integrationId
            productGroupMap: $productGroupMap
        ) {
            status
        }
    }
`;
export type GQSaveAccountForProductGroupMutationFn =
    ApolloReactCommon.MutationFunction<
        GQSaveAccountForProductGroupMutation,
        GQSaveAccountForProductGroupMutationVariables
    >;

/**
 * __useSaveAccountForProductGroupMutation__
 *
 * To run a mutation, you first call `useSaveAccountForProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAccountForProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAccountForProductGroupMutation, { data, loading, error }] = useSaveAccountForProductGroupMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      productGroupMap: // value for 'productGroupMap'
 *   },
 * });
 */
export function useSaveAccountForProductGroupMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQSaveAccountForProductGroupMutation,
        GQSaveAccountForProductGroupMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQSaveAccountForProductGroupMutation,
        GQSaveAccountForProductGroupMutationVariables
    >(SaveAccountForProductGroupDocument, options);
}
export type SaveAccountForProductGroupMutationHookResult = ReturnType<
    typeof useSaveAccountForProductGroupMutation
>;
export type SaveAccountForProductGroupMutationResult =
    ApolloReactCommon.MutationResult<GQSaveAccountForProductGroupMutation>;
export type SaveAccountForProductGroupMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQSaveAccountForProductGroupMutation,
        GQSaveAccountForProductGroupMutationVariables
    >;
export const FiskalyClientDocument = gql`
    query fiskalyClient($id: ID!) {
        fiskalyClient(id: $id) {
            ...fiskalyClientFields
        }
    }
    ${FiskalyClientFieldsFragmentDoc}
`;

/**
 * __useFiskalyClientQuery__
 *
 * To run a query within a React component, call `useFiskalyClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFiskalyClientQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyClientQuery,
        GQFiskalyClientQueryVariables
    > &
        (
            | { variables: GQFiskalyClientQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyClientQuery,
        GQFiskalyClientQueryVariables
    >(FiskalyClientDocument, options);
}
export function useFiskalyClientLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyClientQuery,
        GQFiskalyClientQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyClientQuery,
        GQFiskalyClientQueryVariables
    >(FiskalyClientDocument, options);
}
// @ts-ignore
export function useFiskalyClientSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyClientQuery,
        GQFiskalyClientQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyClientQuery,
    GQFiskalyClientQueryVariables
>;
export function useFiskalyClientSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyClientQuery,
              GQFiskalyClientQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyClientQuery | undefined,
    GQFiskalyClientQueryVariables
>;
export function useFiskalyClientSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyClientQuery,
              GQFiskalyClientQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyClientQuery,
        GQFiskalyClientQueryVariables
    >(FiskalyClientDocument, options);
}
export type FiskalyClientQueryHookResult = ReturnType<
    typeof useFiskalyClientQuery
>;
export type FiskalyClientLazyQueryHookResult = ReturnType<
    typeof useFiskalyClientLazyQuery
>;
export type FiskalyClientSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyClientSuspenseQuery
>;
export type FiskalyClientQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyClientQuery,
    GQFiskalyClientQueryVariables
>;
export const FiskalyClientByCashRegisterIdDocument = gql`
    query fiskalyClientByCashRegisterId($cashRegisterId: ID!) {
        fiskalyClientByCashRegisterId(cashRegisterId: $cashRegisterId) {
            ...fiskalyClientFields
        }
    }
    ${FiskalyClientFieldsFragmentDoc}
`;

/**
 * __useFiskalyClientByCashRegisterIdQuery__
 *
 * To run a query within a React component, call `useFiskalyClientByCashRegisterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyClientByCashRegisterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyClientByCashRegisterIdQuery({
 *   variables: {
 *      cashRegisterId: // value for 'cashRegisterId'
 *   },
 * });
 */
export function useFiskalyClientByCashRegisterIdQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyClientByCashRegisterIdQuery,
        GQFiskalyClientByCashRegisterIdQueryVariables
    > &
        (
            | {
                  variables: GQFiskalyClientByCashRegisterIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyClientByCashRegisterIdQuery,
        GQFiskalyClientByCashRegisterIdQueryVariables
    >(FiskalyClientByCashRegisterIdDocument, options);
}
export function useFiskalyClientByCashRegisterIdLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyClientByCashRegisterIdQuery,
        GQFiskalyClientByCashRegisterIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyClientByCashRegisterIdQuery,
        GQFiskalyClientByCashRegisterIdQueryVariables
    >(FiskalyClientByCashRegisterIdDocument, options);
}
// @ts-ignore
export function useFiskalyClientByCashRegisterIdSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyClientByCashRegisterIdQuery,
        GQFiskalyClientByCashRegisterIdQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyClientByCashRegisterIdQuery,
    GQFiskalyClientByCashRegisterIdQueryVariables
>;
export function useFiskalyClientByCashRegisterIdSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyClientByCashRegisterIdQuery,
              GQFiskalyClientByCashRegisterIdQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyClientByCashRegisterIdQuery | undefined,
    GQFiskalyClientByCashRegisterIdQueryVariables
>;
export function useFiskalyClientByCashRegisterIdSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyClientByCashRegisterIdQuery,
              GQFiskalyClientByCashRegisterIdQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyClientByCashRegisterIdQuery,
        GQFiskalyClientByCashRegisterIdQueryVariables
    >(FiskalyClientByCashRegisterIdDocument, options);
}
export type FiskalyClientByCashRegisterIdQueryHookResult = ReturnType<
    typeof useFiskalyClientByCashRegisterIdQuery
>;
export type FiskalyClientByCashRegisterIdLazyQueryHookResult = ReturnType<
    typeof useFiskalyClientByCashRegisterIdLazyQuery
>;
export type FiskalyClientByCashRegisterIdSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyClientByCashRegisterIdSuspenseQuery
>;
export type FiskalyClientByCashRegisterIdQueryResult =
    ApolloReactCommon.QueryResult<
        GQFiskalyClientByCashRegisterIdQuery,
        GQFiskalyClientByCashRegisterIdQueryVariables
    >;
export const FiskalyClientsDocument = gql`
    query fiskalyClients {
        fiskalyClients {
            data {
                ...fiskalyClientFields
            }
        }
    }
    ${FiskalyClientFieldsFragmentDoc}
`;

/**
 * __useFiskalyClientsQuery__
 *
 * To run a query within a React component, call `useFiskalyClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFiskalyClientsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQFiskalyClientsQuery,
        GQFiskalyClientsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyClientsQuery,
        GQFiskalyClientsQueryVariables
    >(FiskalyClientsDocument, options);
}
export function useFiskalyClientsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyClientsQuery,
        GQFiskalyClientsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyClientsQuery,
        GQFiskalyClientsQueryVariables
    >(FiskalyClientsDocument, options);
}
// @ts-ignore
export function useFiskalyClientsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyClientsQuery,
        GQFiskalyClientsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyClientsQuery,
    GQFiskalyClientsQueryVariables
>;
export function useFiskalyClientsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyClientsQuery,
              GQFiskalyClientsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyClientsQuery | undefined,
    GQFiskalyClientsQueryVariables
>;
export function useFiskalyClientsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyClientsQuery,
              GQFiskalyClientsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyClientsQuery,
        GQFiskalyClientsQueryVariables
    >(FiskalyClientsDocument, options);
}
export type FiskalyClientsQueryHookResult = ReturnType<
    typeof useFiskalyClientsQuery
>;
export type FiskalyClientsLazyQueryHookResult = ReturnType<
    typeof useFiskalyClientsLazyQuery
>;
export type FiskalyClientsSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyClientsSuspenseQuery
>;
export type FiskalyClientsQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyClientsQuery,
    GQFiskalyClientsQueryVariables
>;
export const FiskalyRemoteClientsDocument = gql`
    query fiskalyRemoteClients($integrationId: ID!) {
        fiskalyRemoteClients(integrationId: $integrationId) {
            data {
                ...fiskalyRemoteClientFields
            }
        }
    }
    ${FiskalyRemoteClientFieldsFragmentDoc}
`;

/**
 * __useFiskalyRemoteClientsQuery__
 *
 * To run a query within a React component, call `useFiskalyRemoteClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyRemoteClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyRemoteClientsQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useFiskalyRemoteClientsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyRemoteClientsQuery,
        GQFiskalyRemoteClientsQueryVariables
    > &
        (
            | {
                  variables: GQFiskalyRemoteClientsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyRemoteClientsQuery,
        GQFiskalyRemoteClientsQueryVariables
    >(FiskalyRemoteClientsDocument, options);
}
export function useFiskalyRemoteClientsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyRemoteClientsQuery,
        GQFiskalyRemoteClientsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyRemoteClientsQuery,
        GQFiskalyRemoteClientsQueryVariables
    >(FiskalyRemoteClientsDocument, options);
}
// @ts-ignore
export function useFiskalyRemoteClientsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyRemoteClientsQuery,
        GQFiskalyRemoteClientsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyRemoteClientsQuery,
    GQFiskalyRemoteClientsQueryVariables
>;
export function useFiskalyRemoteClientsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyRemoteClientsQuery,
              GQFiskalyRemoteClientsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyRemoteClientsQuery | undefined,
    GQFiskalyRemoteClientsQueryVariables
>;
export function useFiskalyRemoteClientsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyRemoteClientsQuery,
              GQFiskalyRemoteClientsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyRemoteClientsQuery,
        GQFiskalyRemoteClientsQueryVariables
    >(FiskalyRemoteClientsDocument, options);
}
export type FiskalyRemoteClientsQueryHookResult = ReturnType<
    typeof useFiskalyRemoteClientsQuery
>;
export type FiskalyRemoteClientsLazyQueryHookResult = ReturnType<
    typeof useFiskalyRemoteClientsLazyQuery
>;
export type FiskalyRemoteClientsSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyRemoteClientsSuspenseQuery
>;
export type FiskalyRemoteClientsQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyRemoteClientsQuery,
    GQFiskalyRemoteClientsQueryVariables
>;
export const FiskalyRemoteCashRegistersDocument = gql`
    query fiskalyRemoteCashRegisters($integrationId: ID!) {
        fiskalyRemoteCashRegisters(integrationId: $integrationId) {
            data {
                ...fiskalyRemoteCashRegisterFields
            }
        }
    }
    ${FiskalyRemoteCashRegisterFieldsFragmentDoc}
`;

/**
 * __useFiskalyRemoteCashRegistersQuery__
 *
 * To run a query within a React component, call `useFiskalyRemoteCashRegistersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyRemoteCashRegistersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyRemoteCashRegistersQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useFiskalyRemoteCashRegistersQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyRemoteCashRegistersQuery,
        GQFiskalyRemoteCashRegistersQueryVariables
    > &
        (
            | {
                  variables: GQFiskalyRemoteCashRegistersQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyRemoteCashRegistersQuery,
        GQFiskalyRemoteCashRegistersQueryVariables
    >(FiskalyRemoteCashRegistersDocument, options);
}
export function useFiskalyRemoteCashRegistersLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyRemoteCashRegistersQuery,
        GQFiskalyRemoteCashRegistersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyRemoteCashRegistersQuery,
        GQFiskalyRemoteCashRegistersQueryVariables
    >(FiskalyRemoteCashRegistersDocument, options);
}
// @ts-ignore
export function useFiskalyRemoteCashRegistersSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyRemoteCashRegistersQuery,
        GQFiskalyRemoteCashRegistersQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyRemoteCashRegistersQuery,
    GQFiskalyRemoteCashRegistersQueryVariables
>;
export function useFiskalyRemoteCashRegistersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyRemoteCashRegistersQuery,
              GQFiskalyRemoteCashRegistersQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyRemoteCashRegistersQuery | undefined,
    GQFiskalyRemoteCashRegistersQueryVariables
>;
export function useFiskalyRemoteCashRegistersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyRemoteCashRegistersQuery,
              GQFiskalyRemoteCashRegistersQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyRemoteCashRegistersQuery,
        GQFiskalyRemoteCashRegistersQueryVariables
    >(FiskalyRemoteCashRegistersDocument, options);
}
export type FiskalyRemoteCashRegistersQueryHookResult = ReturnType<
    typeof useFiskalyRemoteCashRegistersQuery
>;
export type FiskalyRemoteCashRegistersLazyQueryHookResult = ReturnType<
    typeof useFiskalyRemoteCashRegistersLazyQuery
>;
export type FiskalyRemoteCashRegistersSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyRemoteCashRegistersSuspenseQuery
>;
export type FiskalyRemoteCashRegistersQueryResult =
    ApolloReactCommon.QueryResult<
        GQFiskalyRemoteCashRegistersQuery,
        GQFiskalyRemoteCashRegistersQueryVariables
    >;
export const FiskalyOrganizationsDocument = gql`
    query fiskalyOrganizations {
        fiskalyOrganizations {
            data {
                integrationId
                merchant {
                    id
                    name
                }
                ...fiskalyOrganizationFields
            }
        }
    }
    ${FiskalyOrganizationFieldsFragmentDoc}
`;

/**
 * __useFiskalyOrganizationsQuery__
 *
 * To run a query within a React component, call `useFiskalyOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFiskalyOrganizationsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQFiskalyOrganizationsQuery,
        GQFiskalyOrganizationsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyOrganizationsQuery,
        GQFiskalyOrganizationsQueryVariables
    >(FiskalyOrganizationsDocument, options);
}
export function useFiskalyOrganizationsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyOrganizationsQuery,
        GQFiskalyOrganizationsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyOrganizationsQuery,
        GQFiskalyOrganizationsQueryVariables
    >(FiskalyOrganizationsDocument, options);
}
// @ts-ignore
export function useFiskalyOrganizationsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyOrganizationsQuery,
        GQFiskalyOrganizationsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyOrganizationsQuery,
    GQFiskalyOrganizationsQueryVariables
>;
export function useFiskalyOrganizationsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyOrganizationsQuery,
              GQFiskalyOrganizationsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyOrganizationsQuery | undefined,
    GQFiskalyOrganizationsQueryVariables
>;
export function useFiskalyOrganizationsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyOrganizationsQuery,
              GQFiskalyOrganizationsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyOrganizationsQuery,
        GQFiskalyOrganizationsQueryVariables
    >(FiskalyOrganizationsDocument, options);
}
export type FiskalyOrganizationsQueryHookResult = ReturnType<
    typeof useFiskalyOrganizationsQuery
>;
export type FiskalyOrganizationsLazyQueryHookResult = ReturnType<
    typeof useFiskalyOrganizationsLazyQuery
>;
export type FiskalyOrganizationsSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyOrganizationsSuspenseQuery
>;
export type FiskalyOrganizationsQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyOrganizationsQuery,
    GQFiskalyOrganizationsQueryVariables
>;
export const FiskalyTssListDocument = gql`
    query fiskalyTssList($integrationId: ID!) {
        fiskalyTssList(integrationId: $integrationId) {
            data {
                ...fiskalyTssFields
            }
        }
    }
    ${FiskalyTssFieldsFragmentDoc}
`;

/**
 * __useFiskalyTssListQuery__
 *
 * To run a query within a React component, call `useFiskalyTssListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyTssListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyTssListQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useFiskalyTssListQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyTssListQuery,
        GQFiskalyTssListQueryVariables
    > &
        (
            | { variables: GQFiskalyTssListQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyTssListQuery,
        GQFiskalyTssListQueryVariables
    >(FiskalyTssListDocument, options);
}
export function useFiskalyTssListLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyTssListQuery,
        GQFiskalyTssListQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyTssListQuery,
        GQFiskalyTssListQueryVariables
    >(FiskalyTssListDocument, options);
}
// @ts-ignore
export function useFiskalyTssListSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyTssListQuery,
        GQFiskalyTssListQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyTssListQuery,
    GQFiskalyTssListQueryVariables
>;
export function useFiskalyTssListSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyTssListQuery,
              GQFiskalyTssListQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyTssListQuery | undefined,
    GQFiskalyTssListQueryVariables
>;
export function useFiskalyTssListSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyTssListQuery,
              GQFiskalyTssListQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyTssListQuery,
        GQFiskalyTssListQueryVariables
    >(FiskalyTssListDocument, options);
}
export type FiskalyTssListQueryHookResult = ReturnType<
    typeof useFiskalyTssListQuery
>;
export type FiskalyTssListLazyQueryHookResult = ReturnType<
    typeof useFiskalyTssListLazyQuery
>;
export type FiskalyTssListSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyTssListSuspenseQuery
>;
export type FiskalyTssListQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyTssListQuery,
    GQFiskalyTssListQueryVariables
>;
export const FiskalyOrganizationDocument = gql`
    query fiskalyOrganization($id: ID!) {
        fiskalyOrganization(id: $id) {
            ...fiskalyOrganizationFields
        }
    }
    ${FiskalyOrganizationFieldsFragmentDoc}
`;

/**
 * __useFiskalyOrganizationQuery__
 *
 * To run a query within a React component, call `useFiskalyOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFiskalyOrganizationQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyOrganizationQuery,
        GQFiskalyOrganizationQueryVariables
    > &
        (
            | { variables: GQFiskalyOrganizationQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyOrganizationQuery,
        GQFiskalyOrganizationQueryVariables
    >(FiskalyOrganizationDocument, options);
}
export function useFiskalyOrganizationLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyOrganizationQuery,
        GQFiskalyOrganizationQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyOrganizationQuery,
        GQFiskalyOrganizationQueryVariables
    >(FiskalyOrganizationDocument, options);
}
// @ts-ignore
export function useFiskalyOrganizationSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyOrganizationQuery,
        GQFiskalyOrganizationQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyOrganizationQuery,
    GQFiskalyOrganizationQueryVariables
>;
export function useFiskalyOrganizationSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyOrganizationQuery,
              GQFiskalyOrganizationQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyOrganizationQuery | undefined,
    GQFiskalyOrganizationQueryVariables
>;
export function useFiskalyOrganizationSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyOrganizationQuery,
              GQFiskalyOrganizationQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyOrganizationQuery,
        GQFiskalyOrganizationQueryVariables
    >(FiskalyOrganizationDocument, options);
}
export type FiskalyOrganizationQueryHookResult = ReturnType<
    typeof useFiskalyOrganizationQuery
>;
export type FiskalyOrganizationLazyQueryHookResult = ReturnType<
    typeof useFiskalyOrganizationLazyQuery
>;
export type FiskalyOrganizationSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyOrganizationSuspenseQuery
>;
export type FiskalyOrganizationQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyOrganizationQuery,
    GQFiskalyOrganizationQueryVariables
>;
export const FiskalyTssDocument = gql`
    query fiskalyTss($id: ID!) {
        fiskalyTss(id: $id) {
            id
            state
        }
    }
`;

/**
 * __useFiskalyTssQuery__
 *
 * To run a query within a React component, call `useFiskalyTssQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyTssQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyTssQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFiskalyTssQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyTssQuery,
        GQFiskalyTssQueryVariables
    > &
        (
            | { variables: GQFiskalyTssQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyTssQuery,
        GQFiskalyTssQueryVariables
    >(FiskalyTssDocument, options);
}
export function useFiskalyTssLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyTssQuery,
        GQFiskalyTssQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyTssQuery,
        GQFiskalyTssQueryVariables
    >(FiskalyTssDocument, options);
}
// @ts-ignore
export function useFiskalyTssSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyTssQuery,
        GQFiskalyTssQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyTssQuery,
    GQFiskalyTssQueryVariables
>;
export function useFiskalyTssSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyTssQuery,
              GQFiskalyTssQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyTssQuery | undefined,
    GQFiskalyTssQueryVariables
>;
export function useFiskalyTssSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyTssQuery,
              GQFiskalyTssQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyTssQuery,
        GQFiskalyTssQueryVariables
    >(FiskalyTssDocument, options);
}
export type FiskalyTssQueryHookResult = ReturnType<typeof useFiskalyTssQuery>;
export type FiskalyTssLazyQueryHookResult = ReturnType<
    typeof useFiskalyTssLazyQuery
>;
export type FiskalyTssSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyTssSuspenseQuery
>;
export type FiskalyTssQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyTssQuery,
    GQFiskalyTssQueryVariables
>;
export const FiskalyEstablishmentsDocument = gql`
    query fiskalyEstablishments($integrationId: ID!) {
        fiskalyEstablishments(integrationId: $integrationId) {
            data {
                ...fiskalyEstablishmentFields
            }
        }
    }
    ${FiskalyEstablishmentFieldsFragmentDoc}
`;

/**
 * __useFiskalyEstablishmentsQuery__
 *
 * To run a query within a React component, call `useFiskalyEstablishmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyEstablishmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyEstablishmentsQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useFiskalyEstablishmentsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyEstablishmentsQuery,
        GQFiskalyEstablishmentsQueryVariables
    > &
        (
            | {
                  variables: GQFiskalyEstablishmentsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyEstablishmentsQuery,
        GQFiskalyEstablishmentsQueryVariables
    >(FiskalyEstablishmentsDocument, options);
}
export function useFiskalyEstablishmentsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyEstablishmentsQuery,
        GQFiskalyEstablishmentsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyEstablishmentsQuery,
        GQFiskalyEstablishmentsQueryVariables
    >(FiskalyEstablishmentsDocument, options);
}
// @ts-ignore
export function useFiskalyEstablishmentsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyEstablishmentsQuery,
        GQFiskalyEstablishmentsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyEstablishmentsQuery,
    GQFiskalyEstablishmentsQueryVariables
>;
export function useFiskalyEstablishmentsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyEstablishmentsQuery,
              GQFiskalyEstablishmentsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyEstablishmentsQuery | undefined,
    GQFiskalyEstablishmentsQueryVariables
>;
export function useFiskalyEstablishmentsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyEstablishmentsQuery,
              GQFiskalyEstablishmentsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyEstablishmentsQuery,
        GQFiskalyEstablishmentsQueryVariables
    >(FiskalyEstablishmentsDocument, options);
}
export type FiskalyEstablishmentsQueryHookResult = ReturnType<
    typeof useFiskalyEstablishmentsQuery
>;
export type FiskalyEstablishmentsLazyQueryHookResult = ReturnType<
    typeof useFiskalyEstablishmentsLazyQuery
>;
export type FiskalyEstablishmentsSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyEstablishmentsSuspenseQuery
>;
export type FiskalyEstablishmentsQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyEstablishmentsQuery,
    GQFiskalyEstablishmentsQueryVariables
>;
export const FiskalyEstablishmentMappingDocument = gql`
    query fiskalyEstablishmentMapping($integrationId: ID!) {
        fiskalyEstablishmentMapping(integrationId: $integrationId) {
            data {
                clientId
                cashRegisterId
                cashRegister {
                    id
                    name
                }
                establishmentId
                organizationId
            }
        }
    }
`;

/**
 * __useFiskalyEstablishmentMappingQuery__
 *
 * To run a query within a React component, call `useFiskalyEstablishmentMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyEstablishmentMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyEstablishmentMappingQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useFiskalyEstablishmentMappingQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyEstablishmentMappingQuery,
        GQFiskalyEstablishmentMappingQueryVariables
    > &
        (
            | {
                  variables: GQFiskalyEstablishmentMappingQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyEstablishmentMappingQuery,
        GQFiskalyEstablishmentMappingQueryVariables
    >(FiskalyEstablishmentMappingDocument, options);
}
export function useFiskalyEstablishmentMappingLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyEstablishmentMappingQuery,
        GQFiskalyEstablishmentMappingQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyEstablishmentMappingQuery,
        GQFiskalyEstablishmentMappingQueryVariables
    >(FiskalyEstablishmentMappingDocument, options);
}
// @ts-ignore
export function useFiskalyEstablishmentMappingSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyEstablishmentMappingQuery,
        GQFiskalyEstablishmentMappingQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyEstablishmentMappingQuery,
    GQFiskalyEstablishmentMappingQueryVariables
>;
export function useFiskalyEstablishmentMappingSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyEstablishmentMappingQuery,
              GQFiskalyEstablishmentMappingQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyEstablishmentMappingQuery | undefined,
    GQFiskalyEstablishmentMappingQueryVariables
>;
export function useFiskalyEstablishmentMappingSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyEstablishmentMappingQuery,
              GQFiskalyEstablishmentMappingQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyEstablishmentMappingQuery,
        GQFiskalyEstablishmentMappingQueryVariables
    >(FiskalyEstablishmentMappingDocument, options);
}
export type FiskalyEstablishmentMappingQueryHookResult = ReturnType<
    typeof useFiskalyEstablishmentMappingQuery
>;
export type FiskalyEstablishmentMappingLazyQueryHookResult = ReturnType<
    typeof useFiskalyEstablishmentMappingLazyQuery
>;
export type FiskalyEstablishmentMappingSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyEstablishmentMappingSuspenseQuery
>;
export type FiskalyEstablishmentMappingQueryResult =
    ApolloReactCommon.QueryResult<
        GQFiskalyEstablishmentMappingQuery,
        GQFiskalyEstablishmentMappingQueryVariables
    >;
export const FiskalyDsFinVkExportsDocument = gql`
    query fiskalyDSFinVKExports {
        fiskalyDSFinVKExports {
            data {
                ...fiskalyDSFinVKExportFields
            }
        }
    }
    ${FiskalyDsFinVkExportFieldsFragmentDoc}
`;

/**
 * __useFiskalyDsFinVkExportsQuery__
 *
 * To run a query within a React component, call `useFiskalyDsFinVkExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyDsFinVkExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyDsFinVkExportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFiskalyDsFinVkExportsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQFiskalyDsFinVkExportsQuery,
        GQFiskalyDsFinVkExportsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyDsFinVkExportsQuery,
        GQFiskalyDsFinVkExportsQueryVariables
    >(FiskalyDsFinVkExportsDocument, options);
}
export function useFiskalyDsFinVkExportsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyDsFinVkExportsQuery,
        GQFiskalyDsFinVkExportsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyDsFinVkExportsQuery,
        GQFiskalyDsFinVkExportsQueryVariables
    >(FiskalyDsFinVkExportsDocument, options);
}
// @ts-ignore
export function useFiskalyDsFinVkExportsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyDsFinVkExportsQuery,
        GQFiskalyDsFinVkExportsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyDsFinVkExportsQuery,
    GQFiskalyDsFinVkExportsQueryVariables
>;
export function useFiskalyDsFinVkExportsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyDsFinVkExportsQuery,
              GQFiskalyDsFinVkExportsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyDsFinVkExportsQuery | undefined,
    GQFiskalyDsFinVkExportsQueryVariables
>;
export function useFiskalyDsFinVkExportsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyDsFinVkExportsQuery,
              GQFiskalyDsFinVkExportsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyDsFinVkExportsQuery,
        GQFiskalyDsFinVkExportsQueryVariables
    >(FiskalyDsFinVkExportsDocument, options);
}
export type FiskalyDsFinVkExportsQueryHookResult = ReturnType<
    typeof useFiskalyDsFinVkExportsQuery
>;
export type FiskalyDsFinVkExportsLazyQueryHookResult = ReturnType<
    typeof useFiskalyDsFinVkExportsLazyQuery
>;
export type FiskalyDsFinVkExportsSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyDsFinVkExportsSuspenseQuery
>;
export type FiskalyDsFinVkExportsQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyDsFinVkExportsQuery,
    GQFiskalyDsFinVkExportsQueryVariables
>;
export const FiskalyDsFinVkExportDocument = gql`
    query fiskalyDSFinVKExport($id: ID!) {
        fiskalyDSFinVKExport(id: $id) {
            ...fiskalyDSFinVKExportFields
        }
    }
    ${FiskalyDsFinVkExportFieldsFragmentDoc}
`;

/**
 * __useFiskalyDsFinVkExportQuery__
 *
 * To run a query within a React component, call `useFiskalyDsFinVkExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyDsFinVkExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyDsFinVkExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFiskalyDsFinVkExportQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyDsFinVkExportQuery,
        GQFiskalyDsFinVkExportQueryVariables
    > &
        (
            | {
                  variables: GQFiskalyDsFinVkExportQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyDsFinVkExportQuery,
        GQFiskalyDsFinVkExportQueryVariables
    >(FiskalyDsFinVkExportDocument, options);
}
export function useFiskalyDsFinVkExportLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyDsFinVkExportQuery,
        GQFiskalyDsFinVkExportQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyDsFinVkExportQuery,
        GQFiskalyDsFinVkExportQueryVariables
    >(FiskalyDsFinVkExportDocument, options);
}
// @ts-ignore
export function useFiskalyDsFinVkExportSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyDsFinVkExportQuery,
        GQFiskalyDsFinVkExportQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyDsFinVkExportQuery,
    GQFiskalyDsFinVkExportQueryVariables
>;
export function useFiskalyDsFinVkExportSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyDsFinVkExportQuery,
              GQFiskalyDsFinVkExportQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyDsFinVkExportQuery | undefined,
    GQFiskalyDsFinVkExportQueryVariables
>;
export function useFiskalyDsFinVkExportSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyDsFinVkExportQuery,
              GQFiskalyDsFinVkExportQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyDsFinVkExportQuery,
        GQFiskalyDsFinVkExportQueryVariables
    >(FiskalyDsFinVkExportDocument, options);
}
export type FiskalyDsFinVkExportQueryHookResult = ReturnType<
    typeof useFiskalyDsFinVkExportQuery
>;
export type FiskalyDsFinVkExportLazyQueryHookResult = ReturnType<
    typeof useFiskalyDsFinVkExportLazyQuery
>;
export type FiskalyDsFinVkExportSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyDsFinVkExportSuspenseQuery
>;
export type FiskalyDsFinVkExportQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyDsFinVkExportQuery,
    GQFiskalyDsFinVkExportQueryVariables
>;
export const GetFiskalyDsFinVkExportDownloadDocument = gql`
    query getFiskalyDSFinVKExportDownload($id: ID!) {
        getFiskalyDSFinVKExportDownload(id: $id) {
            fileName
            contentType
            byteBuffer
        }
    }
`;

/**
 * __useGetFiskalyDsFinVkExportDownloadQuery__
 *
 * To run a query within a React component, call `useGetFiskalyDsFinVkExportDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiskalyDsFinVkExportDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiskalyDsFinVkExportDownloadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFiskalyDsFinVkExportDownloadQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQGetFiskalyDsFinVkExportDownloadQuery,
        GQGetFiskalyDsFinVkExportDownloadQueryVariables
    > &
        (
            | {
                  variables: GQGetFiskalyDsFinVkExportDownloadQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQGetFiskalyDsFinVkExportDownloadQuery,
        GQGetFiskalyDsFinVkExportDownloadQueryVariables
    >(GetFiskalyDsFinVkExportDownloadDocument, options);
}
export function useGetFiskalyDsFinVkExportDownloadLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQGetFiskalyDsFinVkExportDownloadQuery,
        GQGetFiskalyDsFinVkExportDownloadQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQGetFiskalyDsFinVkExportDownloadQuery,
        GQGetFiskalyDsFinVkExportDownloadQueryVariables
    >(GetFiskalyDsFinVkExportDownloadDocument, options);
}
// @ts-ignore
export function useGetFiskalyDsFinVkExportDownloadSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQGetFiskalyDsFinVkExportDownloadQuery,
        GQGetFiskalyDsFinVkExportDownloadQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQGetFiskalyDsFinVkExportDownloadQuery,
    GQGetFiskalyDsFinVkExportDownloadQueryVariables
>;
export function useGetFiskalyDsFinVkExportDownloadSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQGetFiskalyDsFinVkExportDownloadQuery,
              GQGetFiskalyDsFinVkExportDownloadQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQGetFiskalyDsFinVkExportDownloadQuery | undefined,
    GQGetFiskalyDsFinVkExportDownloadQueryVariables
>;
export function useGetFiskalyDsFinVkExportDownloadSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQGetFiskalyDsFinVkExportDownloadQuery,
              GQGetFiskalyDsFinVkExportDownloadQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQGetFiskalyDsFinVkExportDownloadQuery,
        GQGetFiskalyDsFinVkExportDownloadQueryVariables
    >(GetFiskalyDsFinVkExportDownloadDocument, options);
}
export type GetFiskalyDsFinVkExportDownloadQueryHookResult = ReturnType<
    typeof useGetFiskalyDsFinVkExportDownloadQuery
>;
export type GetFiskalyDsFinVkExportDownloadLazyQueryHookResult = ReturnType<
    typeof useGetFiskalyDsFinVkExportDownloadLazyQuery
>;
export type GetFiskalyDsFinVkExportDownloadSuspenseQueryHookResult = ReturnType<
    typeof useGetFiskalyDsFinVkExportDownloadSuspenseQuery
>;
export type GetFiskalyDsFinVkExportDownloadQueryResult =
    ApolloReactCommon.QueryResult<
        GQGetFiskalyDsFinVkExportDownloadQuery,
        GQGetFiskalyDsFinVkExportDownloadQueryVariables
    >;
export const FiskalyEstablishmentSubmissionsDocument = gql`
    query fiskalyEstablishmentSubmissions($pagination: CursorPaginationInput) {
        fiskalyEstablishmentSubmissions(pagination: $pagination) {
            pagination {
                token
                limit
                remaining
            }
            data {
                id
                establishmentId
                state
                error
                createdAt
                previewedAt
                reviewedAt
                transmittedAt
            }
        }
    }
`;

/**
 * __useFiskalyEstablishmentSubmissionsQuery__
 *
 * To run a query within a React component, call `useFiskalyEstablishmentSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyEstablishmentSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyEstablishmentSubmissionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFiskalyEstablishmentSubmissionsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQFiskalyEstablishmentSubmissionsQuery,
        GQFiskalyEstablishmentSubmissionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyEstablishmentSubmissionsQuery,
        GQFiskalyEstablishmentSubmissionsQueryVariables
    >(FiskalyEstablishmentSubmissionsDocument, options);
}
export function useFiskalyEstablishmentSubmissionsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyEstablishmentSubmissionsQuery,
        GQFiskalyEstablishmentSubmissionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyEstablishmentSubmissionsQuery,
        GQFiskalyEstablishmentSubmissionsQueryVariables
    >(FiskalyEstablishmentSubmissionsDocument, options);
}
// @ts-ignore
export function useFiskalyEstablishmentSubmissionsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyEstablishmentSubmissionsQuery,
        GQFiskalyEstablishmentSubmissionsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyEstablishmentSubmissionsQuery,
    GQFiskalyEstablishmentSubmissionsQueryVariables
>;
export function useFiskalyEstablishmentSubmissionsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyEstablishmentSubmissionsQuery,
              GQFiskalyEstablishmentSubmissionsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyEstablishmentSubmissionsQuery | undefined,
    GQFiskalyEstablishmentSubmissionsQueryVariables
>;
export function useFiskalyEstablishmentSubmissionsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyEstablishmentSubmissionsQuery,
              GQFiskalyEstablishmentSubmissionsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyEstablishmentSubmissionsQuery,
        GQFiskalyEstablishmentSubmissionsQueryVariables
    >(FiskalyEstablishmentSubmissionsDocument, options);
}
export type FiskalyEstablishmentSubmissionsQueryHookResult = ReturnType<
    typeof useFiskalyEstablishmentSubmissionsQuery
>;
export type FiskalyEstablishmentSubmissionsLazyQueryHookResult = ReturnType<
    typeof useFiskalyEstablishmentSubmissionsLazyQuery
>;
export type FiskalyEstablishmentSubmissionsSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyEstablishmentSubmissionsSuspenseQuery
>;
export type FiskalyEstablishmentSubmissionsQueryResult =
    ApolloReactCommon.QueryResult<
        GQFiskalyEstablishmentSubmissionsQuery,
        GQFiskalyEstablishmentSubmissionsQueryVariables
    >;
export const FiskalyRemoteEstablishmentSubmissionsDocument = gql`
    query fiskalyRemoteEstablishmentSubmissions($integrationId: ID!) {
        fiskalyRemoteEstablishmentSubmissions(integrationId: $integrationId) {
            data {
                id
                establishmentId
                state
                error
                createdAt
                transmittedAt
            }
        }
    }
`;

/**
 * __useFiskalyRemoteEstablishmentSubmissionsQuery__
 *
 * To run a query within a React component, call `useFiskalyRemoteEstablishmentSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyRemoteEstablishmentSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyRemoteEstablishmentSubmissionsQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useFiskalyRemoteEstablishmentSubmissionsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyRemoteEstablishmentSubmissionsQuery,
        GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
    > &
        (
            | {
                  variables: GQFiskalyRemoteEstablishmentSubmissionsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyRemoteEstablishmentSubmissionsQuery,
        GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
    >(FiskalyRemoteEstablishmentSubmissionsDocument, options);
}
export function useFiskalyRemoteEstablishmentSubmissionsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyRemoteEstablishmentSubmissionsQuery,
        GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyRemoteEstablishmentSubmissionsQuery,
        GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
    >(FiskalyRemoteEstablishmentSubmissionsDocument, options);
}
// @ts-ignore
export function useFiskalyRemoteEstablishmentSubmissionsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyRemoteEstablishmentSubmissionsQuery,
        GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyRemoteEstablishmentSubmissionsQuery,
    GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
>;
export function useFiskalyRemoteEstablishmentSubmissionsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyRemoteEstablishmentSubmissionsQuery,
              GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyRemoteEstablishmentSubmissionsQuery | undefined,
    GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
>;
export function useFiskalyRemoteEstablishmentSubmissionsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyRemoteEstablishmentSubmissionsQuery,
              GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyRemoteEstablishmentSubmissionsQuery,
        GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
    >(FiskalyRemoteEstablishmentSubmissionsDocument, options);
}
export type FiskalyRemoteEstablishmentSubmissionsQueryHookResult = ReturnType<
    typeof useFiskalyRemoteEstablishmentSubmissionsQuery
>;
export type FiskalyRemoteEstablishmentSubmissionsLazyQueryHookResult =
    ReturnType<typeof useFiskalyRemoteEstablishmentSubmissionsLazyQuery>;
export type FiskalyRemoteEstablishmentSubmissionsSuspenseQueryHookResult =
    ReturnType<typeof useFiskalyRemoteEstablishmentSubmissionsSuspenseQuery>;
export type FiskalyRemoteEstablishmentSubmissionsQueryResult =
    ApolloReactCommon.QueryResult<
        GQFiskalyRemoteEstablishmentSubmissionsQuery,
        GQFiskalyRemoteEstablishmentSubmissionsQueryVariables
    >;
export const GetFiskalyTaxPayerDocument = gql`
    query getFiskalyTaxPayer {
        getFiskalyTaxPayer {
            ... on FiskalyTaxPayerLegal {
                legalForm
                companyName
                type
                webAddress
                taxNumber
                taxOfficeNumber
                vatNumber
                street
                houseNumber
                houseNumberSuffix
                zip
                town
                country
            }
            ... on FiskalyTaxPayerNatural {
                salutation
                title
                prefix
                firstName
                lastName
                suffix
                birthDate
                identificationNumber
                type
                webAddress
                taxNumber
                taxOfficeNumber
                vatNumber
                street
                houseNumber
                houseNumberSuffix
                zip
                town
                country
            }
        }
    }
`;

/**
 * __useGetFiskalyTaxPayerQuery__
 *
 * To run a query within a React component, call `useGetFiskalyTaxPayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiskalyTaxPayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiskalyTaxPayerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFiskalyTaxPayerQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQGetFiskalyTaxPayerQuery,
        GQGetFiskalyTaxPayerQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQGetFiskalyTaxPayerQuery,
        GQGetFiskalyTaxPayerQueryVariables
    >(GetFiskalyTaxPayerDocument, options);
}
export function useGetFiskalyTaxPayerLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQGetFiskalyTaxPayerQuery,
        GQGetFiskalyTaxPayerQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQGetFiskalyTaxPayerQuery,
        GQGetFiskalyTaxPayerQueryVariables
    >(GetFiskalyTaxPayerDocument, options);
}
// @ts-ignore
export function useGetFiskalyTaxPayerSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQGetFiskalyTaxPayerQuery,
        GQGetFiskalyTaxPayerQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQGetFiskalyTaxPayerQuery,
    GQGetFiskalyTaxPayerQueryVariables
>;
export function useGetFiskalyTaxPayerSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQGetFiskalyTaxPayerQuery,
              GQGetFiskalyTaxPayerQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQGetFiskalyTaxPayerQuery | undefined,
    GQGetFiskalyTaxPayerQueryVariables
>;
export function useGetFiskalyTaxPayerSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQGetFiskalyTaxPayerQuery,
              GQGetFiskalyTaxPayerQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQGetFiskalyTaxPayerQuery,
        GQGetFiskalyTaxPayerQueryVariables
    >(GetFiskalyTaxPayerDocument, options);
}
export type GetFiskalyTaxPayerQueryHookResult = ReturnType<
    typeof useGetFiskalyTaxPayerQuery
>;
export type GetFiskalyTaxPayerLazyQueryHookResult = ReturnType<
    typeof useGetFiskalyTaxPayerLazyQuery
>;
export type GetFiskalyTaxPayerSuspenseQueryHookResult = ReturnType<
    typeof useGetFiskalyTaxPayerSuspenseQuery
>;
export type GetFiskalyTaxPayerQueryResult = ApolloReactCommon.QueryResult<
    GQGetFiskalyTaxPayerQuery,
    GQGetFiskalyTaxPayerQueryVariables
>;
export const FiskalyClientSyncDocument = gql`
    mutation fiskalyClientSync($id: ID!, $pin: String!) {
        fiskalyClientSync(id: $id, pin: $pin) {
            ...fiskalyClientFields
        }
    }
    ${FiskalyClientFieldsFragmentDoc}
`;
export type GQFiskalyClientSyncMutationFn = ApolloReactCommon.MutationFunction<
    GQFiskalyClientSyncMutation,
    GQFiskalyClientSyncMutationVariables
>;

/**
 * __useFiskalyClientSyncMutation__
 *
 * To run a mutation, you first call `useFiskalyClientSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFiskalyClientSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fiskalyClientSyncMutation, { data, loading, error }] = useFiskalyClientSyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pin: // value for 'pin'
 *   },
 * });
 */
export function useFiskalyClientSyncMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQFiskalyClientSyncMutation,
        GQFiskalyClientSyncMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQFiskalyClientSyncMutation,
        GQFiskalyClientSyncMutationVariables
    >(FiskalyClientSyncDocument, options);
}
export type FiskalyClientSyncMutationHookResult = ReturnType<
    typeof useFiskalyClientSyncMutation
>;
export type FiskalyClientSyncMutationResult =
    ApolloReactCommon.MutationResult<GQFiskalyClientSyncMutation>;
export type FiskalyClientSyncMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQFiskalyClientSyncMutation,
        GQFiskalyClientSyncMutationVariables
    >;
export const FiskalyClientDeregisterDocument = gql`
    mutation fiskalyClientDeregister(
        $id: ID!
        $integrationId: ID!
        $pin: String!
    ) {
        setFiskalyClientState(
            id: $id
            clientState: DEREGISTERED
            integrationId: $integrationId
            pin: $pin
        ) {
            ...fiskalyClientFields
        }
    }
    ${FiskalyClientFieldsFragmentDoc}
`;
export type GQFiskalyClientDeregisterMutationFn =
    ApolloReactCommon.MutationFunction<
        GQFiskalyClientDeregisterMutation,
        GQFiskalyClientDeregisterMutationVariables
    >;

/**
 * __useFiskalyClientDeregisterMutation__
 *
 * To run a mutation, you first call `useFiskalyClientDeregisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFiskalyClientDeregisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fiskalyClientDeregisterMutation, { data, loading, error }] = useFiskalyClientDeregisterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      integrationId: // value for 'integrationId'
 *      pin: // value for 'pin'
 *   },
 * });
 */
export function useFiskalyClientDeregisterMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQFiskalyClientDeregisterMutation,
        GQFiskalyClientDeregisterMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQFiskalyClientDeregisterMutation,
        GQFiskalyClientDeregisterMutationVariables
    >(FiskalyClientDeregisterDocument, options);
}
export type FiskalyClientDeregisterMutationHookResult = ReturnType<
    typeof useFiskalyClientDeregisterMutation
>;
export type FiskalyClientDeregisterMutationResult =
    ApolloReactCommon.MutationResult<GQFiskalyClientDeregisterMutation>;
export type FiskalyClientDeregisterMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQFiskalyClientDeregisterMutation,
        GQFiskalyClientDeregisterMutationVariables
    >;
export const FiskalyClientRegisterDocument = gql`
    mutation fiskalyClientRegister(
        $id: ID!
        $integrationId: ID!
        $pin: String!
    ) {
        setFiskalyClientState(
            id: $id
            clientState: REGISTERED
            integrationId: $integrationId
            pin: $pin
        ) {
            ...fiskalyClientFields
        }
    }
    ${FiskalyClientFieldsFragmentDoc}
`;
export type GQFiskalyClientRegisterMutationFn =
    ApolloReactCommon.MutationFunction<
        GQFiskalyClientRegisterMutation,
        GQFiskalyClientRegisterMutationVariables
    >;

/**
 * __useFiskalyClientRegisterMutation__
 *
 * To run a mutation, you first call `useFiskalyClientRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFiskalyClientRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fiskalyClientRegisterMutation, { data, loading, error }] = useFiskalyClientRegisterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      integrationId: // value for 'integrationId'
 *      pin: // value for 'pin'
 *   },
 * });
 */
export function useFiskalyClientRegisterMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQFiskalyClientRegisterMutation,
        GQFiskalyClientRegisterMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQFiskalyClientRegisterMutation,
        GQFiskalyClientRegisterMutationVariables
    >(FiskalyClientRegisterDocument, options);
}
export type FiskalyClientRegisterMutationHookResult = ReturnType<
    typeof useFiskalyClientRegisterMutation
>;
export type FiskalyClientRegisterMutationResult =
    ApolloReactCommon.MutationResult<GQFiskalyClientRegisterMutation>;
export type FiskalyClientRegisterMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQFiskalyClientRegisterMutation,
        GQFiskalyClientRegisterMutationVariables
    >;
export const FiskalyRegisterTssForOrganizationDocument = gql`
    mutation fiskalyRegisterTssForOrganization {
        fiskalyRegisterTssForOrganization {
            status
            adminPuk
        }
    }
`;
export type GQFiskalyRegisterTssForOrganizationMutationFn =
    ApolloReactCommon.MutationFunction<
        GQFiskalyRegisterTssForOrganizationMutation,
        GQFiskalyRegisterTssForOrganizationMutationVariables
    >;

/**
 * __useFiskalyRegisterTssForOrganizationMutation__
 *
 * To run a mutation, you first call `useFiskalyRegisterTssForOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFiskalyRegisterTssForOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fiskalyRegisterTssForOrganizationMutation, { data, loading, error }] = useFiskalyRegisterTssForOrganizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useFiskalyRegisterTssForOrganizationMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQFiskalyRegisterTssForOrganizationMutation,
        GQFiskalyRegisterTssForOrganizationMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQFiskalyRegisterTssForOrganizationMutation,
        GQFiskalyRegisterTssForOrganizationMutationVariables
    >(FiskalyRegisterTssForOrganizationDocument, options);
}
export type FiskalyRegisterTssForOrganizationMutationHookResult = ReturnType<
    typeof useFiskalyRegisterTssForOrganizationMutation
>;
export type FiskalyRegisterTssForOrganizationMutationResult =
    ApolloReactCommon.MutationResult<GQFiskalyRegisterTssForOrganizationMutation>;
export type FiskalyRegisterTssForOrganizationMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQFiskalyRegisterTssForOrganizationMutation,
        GQFiskalyRegisterTssForOrganizationMutationVariables
    >;
export const FiskalyAdvanceTssStateDocument = gql`
    mutation fiskalyAdvanceTssState(
        $tssState: TssStateEnum!
        $pinCode: String
        $adminPuk: String
    ) {
        fiskalyAdvanceTssState(
            tssState: $tssState
            pinCode: $pinCode
            adminPuk: $adminPuk
        ) {
            status
        }
    }
`;
export type GQFiskalyAdvanceTssStateMutationFn =
    ApolloReactCommon.MutationFunction<
        GQFiskalyAdvanceTssStateMutation,
        GQFiskalyAdvanceTssStateMutationVariables
    >;

/**
 * __useFiskalyAdvanceTssStateMutation__
 *
 * To run a mutation, you first call `useFiskalyAdvanceTssStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFiskalyAdvanceTssStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fiskalyAdvanceTssStateMutation, { data, loading, error }] = useFiskalyAdvanceTssStateMutation({
 *   variables: {
 *      tssState: // value for 'tssState'
 *      pinCode: // value for 'pinCode'
 *      adminPuk: // value for 'adminPuk'
 *   },
 * });
 */
export function useFiskalyAdvanceTssStateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQFiskalyAdvanceTssStateMutation,
        GQFiskalyAdvanceTssStateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQFiskalyAdvanceTssStateMutation,
        GQFiskalyAdvanceTssStateMutationVariables
    >(FiskalyAdvanceTssStateDocument, options);
}
export type FiskalyAdvanceTssStateMutationHookResult = ReturnType<
    typeof useFiskalyAdvanceTssStateMutation
>;
export type FiskalyAdvanceTssStateMutationResult =
    ApolloReactCommon.MutationResult<GQFiskalyAdvanceTssStateMutation>;
export type FiskalyAdvanceTssStateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQFiskalyAdvanceTssStateMutation,
        GQFiskalyAdvanceTssStateMutationVariables
    >;
export const FiskalyChangePinForTssDocument = gql`
    mutation fiskalyChangePinForTss(
        $pinCode: String!
        $adminPuk: String!
        $integrationId: ID!
    ) {
        fiskalyChangePinForTss(
            pinCode: $pinCode
            adminPuk: $adminPuk
            integrationId: $integrationId
        ) {
            status
        }
    }
`;
export type GQFiskalyChangePinForTssMutationFn =
    ApolloReactCommon.MutationFunction<
        GQFiskalyChangePinForTssMutation,
        GQFiskalyChangePinForTssMutationVariables
    >;

/**
 * __useFiskalyChangePinForTssMutation__
 *
 * To run a mutation, you first call `useFiskalyChangePinForTssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFiskalyChangePinForTssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fiskalyChangePinForTssMutation, { data, loading, error }] = useFiskalyChangePinForTssMutation({
 *   variables: {
 *      pinCode: // value for 'pinCode'
 *      adminPuk: // value for 'adminPuk'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useFiskalyChangePinForTssMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQFiskalyChangePinForTssMutation,
        GQFiskalyChangePinForTssMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQFiskalyChangePinForTssMutation,
        GQFiskalyChangePinForTssMutationVariables
    >(FiskalyChangePinForTssDocument, options);
}
export type FiskalyChangePinForTssMutationHookResult = ReturnType<
    typeof useFiskalyChangePinForTssMutation
>;
export type FiskalyChangePinForTssMutationResult =
    ApolloReactCommon.MutationResult<GQFiskalyChangePinForTssMutation>;
export type FiskalyChangePinForTssMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQFiskalyChangePinForTssMutation,
        GQFiskalyChangePinForTssMutationVariables
    >;
export const FiskalyOrganizationUpsertDocument = gql`
    mutation fiskalyOrganizationUpsert(
        $managedOrganization: FiskalyOrganizationInput!
    ) {
        fiskalyOrganizationUpsert(managedOrganization: $managedOrganization) {
            ...fiskalyOrganizationFields
        }
    }
    ${FiskalyOrganizationFieldsFragmentDoc}
`;
export type GQFiskalyOrganizationUpsertMutationFn =
    ApolloReactCommon.MutationFunction<
        GQFiskalyOrganizationUpsertMutation,
        GQFiskalyOrganizationUpsertMutationVariables
    >;

/**
 * __useFiskalyOrganizationUpsertMutation__
 *
 * To run a mutation, you first call `useFiskalyOrganizationUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFiskalyOrganizationUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fiskalyOrganizationUpsertMutation, { data, loading, error }] = useFiskalyOrganizationUpsertMutation({
 *   variables: {
 *      managedOrganization: // value for 'managedOrganization'
 *   },
 * });
 */
export function useFiskalyOrganizationUpsertMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQFiskalyOrganizationUpsertMutation,
        GQFiskalyOrganizationUpsertMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQFiskalyOrganizationUpsertMutation,
        GQFiskalyOrganizationUpsertMutationVariables
    >(FiskalyOrganizationUpsertDocument, options);
}
export type FiskalyOrganizationUpsertMutationHookResult = ReturnType<
    typeof useFiskalyOrganizationUpsertMutation
>;
export type FiskalyOrganizationUpsertMutationResult =
    ApolloReactCommon.MutationResult<GQFiskalyOrganizationUpsertMutation>;
export type FiskalyOrganizationUpsertMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQFiskalyOrganizationUpsertMutation,
        GQFiskalyOrganizationUpsertMutationVariables
    >;
export const FiskalyOrganizationGoLiveDocument = gql`
    mutation fiskalyOrganizationGoLive($integrationId: ID!) {
        fiskalyOrganizationGoLive(integrationId: $integrationId) {
            ...fiskalyOrganizationFields
        }
    }
    ${FiskalyOrganizationFieldsFragmentDoc}
`;
export type GQFiskalyOrganizationGoLiveMutationFn =
    ApolloReactCommon.MutationFunction<
        GQFiskalyOrganizationGoLiveMutation,
        GQFiskalyOrganizationGoLiveMutationVariables
    >;

/**
 * __useFiskalyOrganizationGoLiveMutation__
 *
 * To run a mutation, you first call `useFiskalyOrganizationGoLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFiskalyOrganizationGoLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fiskalyOrganizationGoLiveMutation, { data, loading, error }] = useFiskalyOrganizationGoLiveMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useFiskalyOrganizationGoLiveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQFiskalyOrganizationGoLiveMutation,
        GQFiskalyOrganizationGoLiveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQFiskalyOrganizationGoLiveMutation,
        GQFiskalyOrganizationGoLiveMutationVariables
    >(FiskalyOrganizationGoLiveDocument, options);
}
export type FiskalyOrganizationGoLiveMutationHookResult = ReturnType<
    typeof useFiskalyOrganizationGoLiveMutation
>;
export type FiskalyOrganizationGoLiveMutationResult =
    ApolloReactCommon.MutationResult<GQFiskalyOrganizationGoLiveMutation>;
export type FiskalyOrganizationGoLiveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQFiskalyOrganizationGoLiveMutation,
        GQFiskalyOrganizationGoLiveMutationVariables
    >;
export const SaveFiskalyEstablishmentMappingDocument = gql`
    mutation saveFiskalyEstablishmentMapping(
        $integrationId: ID!
        $establishmentMapping: [FiskalyEstablishmentMappingInput!]!
    ) {
        saveFiskalyEstablishmentMapping(
            integrationId: $integrationId
            establishmentMapping: $establishmentMapping
        ) {
            status
        }
    }
`;
export type GQSaveFiskalyEstablishmentMappingMutationFn =
    ApolloReactCommon.MutationFunction<
        GQSaveFiskalyEstablishmentMappingMutation,
        GQSaveFiskalyEstablishmentMappingMutationVariables
    >;

/**
 * __useSaveFiskalyEstablishmentMappingMutation__
 *
 * To run a mutation, you first call `useSaveFiskalyEstablishmentMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFiskalyEstablishmentMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFiskalyEstablishmentMappingMutation, { data, loading, error }] = useSaveFiskalyEstablishmentMappingMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      establishmentMapping: // value for 'establishmentMapping'
 *   },
 * });
 */
export function useSaveFiskalyEstablishmentMappingMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQSaveFiskalyEstablishmentMappingMutation,
        GQSaveFiskalyEstablishmentMappingMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQSaveFiskalyEstablishmentMappingMutation,
        GQSaveFiskalyEstablishmentMappingMutationVariables
    >(SaveFiskalyEstablishmentMappingDocument, options);
}
export type SaveFiskalyEstablishmentMappingMutationHookResult = ReturnType<
    typeof useSaveFiskalyEstablishmentMappingMutation
>;
export type SaveFiskalyEstablishmentMappingMutationResult =
    ApolloReactCommon.MutationResult<GQSaveFiskalyEstablishmentMappingMutation>;
export type SaveFiskalyEstablishmentMappingMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQSaveFiskalyEstablishmentMappingMutation,
        GQSaveFiskalyEstablishmentMappingMutationVariables
    >;
export const SaveFiskalyEstablishmentDocument = gql`
    mutation saveFiskalyEstablishment(
        $establishment: FiskalyEstablishmentInput!
        $establishmentId: ID
    ) {
        saveFiskalyEstablishment(
            establishment: $establishment
            establishmentId: $establishmentId
        ) {
            ...fiskalyEstablishmentFields
        }
    }
    ${FiskalyEstablishmentFieldsFragmentDoc}
`;
export type GQSaveFiskalyEstablishmentMutationFn =
    ApolloReactCommon.MutationFunction<
        GQSaveFiskalyEstablishmentMutation,
        GQSaveFiskalyEstablishmentMutationVariables
    >;

/**
 * __useSaveFiskalyEstablishmentMutation__
 *
 * To run a mutation, you first call `useSaveFiskalyEstablishmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFiskalyEstablishmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFiskalyEstablishmentMutation, { data, loading, error }] = useSaveFiskalyEstablishmentMutation({
 *   variables: {
 *      establishment: // value for 'establishment'
 *      establishmentId: // value for 'establishmentId'
 *   },
 * });
 */
export function useSaveFiskalyEstablishmentMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQSaveFiskalyEstablishmentMutation,
        GQSaveFiskalyEstablishmentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQSaveFiskalyEstablishmentMutation,
        GQSaveFiskalyEstablishmentMutationVariables
    >(SaveFiskalyEstablishmentDocument, options);
}
export type SaveFiskalyEstablishmentMutationHookResult = ReturnType<
    typeof useSaveFiskalyEstablishmentMutation
>;
export type SaveFiskalyEstablishmentMutationResult =
    ApolloReactCommon.MutationResult<GQSaveFiskalyEstablishmentMutation>;
export type SaveFiskalyEstablishmentMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQSaveFiskalyEstablishmentMutation,
        GQSaveFiskalyEstablishmentMutationVariables
    >;
export const DeleteEstablishmentDocument = gql`
    mutation deleteEstablishment($establishmentId: ID!) {
        deleteEstablishment(establishmentId: $establishmentId) {
            status
        }
    }
`;
export type GQDeleteEstablishmentMutationFn =
    ApolloReactCommon.MutationFunction<
        GQDeleteEstablishmentMutation,
        GQDeleteEstablishmentMutationVariables
    >;

/**
 * __useDeleteEstablishmentMutation__
 *
 * To run a mutation, you first call `useDeleteEstablishmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstablishmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstablishmentMutation, { data, loading, error }] = useDeleteEstablishmentMutation({
 *   variables: {
 *      establishmentId: // value for 'establishmentId'
 *   },
 * });
 */
export function useDeleteEstablishmentMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQDeleteEstablishmentMutation,
        GQDeleteEstablishmentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQDeleteEstablishmentMutation,
        GQDeleteEstablishmentMutationVariables
    >(DeleteEstablishmentDocument, options);
}
export type DeleteEstablishmentMutationHookResult = ReturnType<
    typeof useDeleteEstablishmentMutation
>;
export type DeleteEstablishmentMutationResult =
    ApolloReactCommon.MutationResult<GQDeleteEstablishmentMutation>;
export type DeleteEstablishmentMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQDeleteEstablishmentMutation,
        GQDeleteEstablishmentMutationVariables
    >;
export const RequestFiskalyDsFinVkExportDocument = gql`
    mutation requestFiskalyDSFinVKExport(
        $exportArguments: FiskalyDSFinVKExportInput!
    ) {
        requestFiskalyDSFinVKExport(exportInput: $exportArguments) {
            status
        }
    }
`;
export type GQRequestFiskalyDsFinVkExportMutationFn =
    ApolloReactCommon.MutationFunction<
        GQRequestFiskalyDsFinVkExportMutation,
        GQRequestFiskalyDsFinVkExportMutationVariables
    >;

/**
 * __useRequestFiskalyDsFinVkExportMutation__
 *
 * To run a mutation, you first call `useRequestFiskalyDsFinVkExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestFiskalyDsFinVkExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestFiskalyDsFinVkExportMutation, { data, loading, error }] = useRequestFiskalyDsFinVkExportMutation({
 *   variables: {
 *      exportArguments: // value for 'exportArguments'
 *   },
 * });
 */
export function useRequestFiskalyDsFinVkExportMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQRequestFiskalyDsFinVkExportMutation,
        GQRequestFiskalyDsFinVkExportMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQRequestFiskalyDsFinVkExportMutation,
        GQRequestFiskalyDsFinVkExportMutationVariables
    >(RequestFiskalyDsFinVkExportDocument, options);
}
export type RequestFiskalyDsFinVkExportMutationHookResult = ReturnType<
    typeof useRequestFiskalyDsFinVkExportMutation
>;
export type RequestFiskalyDsFinVkExportMutationResult =
    ApolloReactCommon.MutationResult<GQRequestFiskalyDsFinVkExportMutation>;
export type RequestFiskalyDsFinVkExportMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQRequestFiskalyDsFinVkExportMutation,
        GQRequestFiskalyDsFinVkExportMutationVariables
    >;
export const RequestFiskalyEstablishmentSubmissionDocument = gql`
    mutation requestFiskalyEstablishmentSubmission($establishmentId: ID!) {
        requestFiskalyEstablishmentSubmission(
            establishmentId: $establishmentId
        ) {
            status
        }
    }
`;
export type GQRequestFiskalyEstablishmentSubmissionMutationFn =
    ApolloReactCommon.MutationFunction<
        GQRequestFiskalyEstablishmentSubmissionMutation,
        GQRequestFiskalyEstablishmentSubmissionMutationVariables
    >;

/**
 * __useRequestFiskalyEstablishmentSubmissionMutation__
 *
 * To run a mutation, you first call `useRequestFiskalyEstablishmentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestFiskalyEstablishmentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestFiskalyEstablishmentSubmissionMutation, { data, loading, error }] = useRequestFiskalyEstablishmentSubmissionMutation({
 *   variables: {
 *      establishmentId: // value for 'establishmentId'
 *   },
 * });
 */
export function useRequestFiskalyEstablishmentSubmissionMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQRequestFiskalyEstablishmentSubmissionMutation,
        GQRequestFiskalyEstablishmentSubmissionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQRequestFiskalyEstablishmentSubmissionMutation,
        GQRequestFiskalyEstablishmentSubmissionMutationVariables
    >(RequestFiskalyEstablishmentSubmissionDocument, options);
}
export type RequestFiskalyEstablishmentSubmissionMutationHookResult =
    ReturnType<typeof useRequestFiskalyEstablishmentSubmissionMutation>;
export type RequestFiskalyEstablishmentSubmissionMutationResult =
    ApolloReactCommon.MutationResult<GQRequestFiskalyEstablishmentSubmissionMutation>;
export type RequestFiskalyEstablishmentSubmissionMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQRequestFiskalyEstablishmentSubmissionMutation,
        GQRequestFiskalyEstablishmentSubmissionMutationVariables
    >;
export const UpsertFiskalyTaxPayerLegalDocument = gql`
    mutation upsertFiskalyTaxPayerLegal(
        $taxPayerData: FiskalyTaxPayerLegalInput!
    ) {
        upsertFiskalyTaxPayerLegal(taxPayerData: $taxPayerData) {
            status
        }
    }
`;
export type GQUpsertFiskalyTaxPayerLegalMutationFn =
    ApolloReactCommon.MutationFunction<
        GQUpsertFiskalyTaxPayerLegalMutation,
        GQUpsertFiskalyTaxPayerLegalMutationVariables
    >;

/**
 * __useUpsertFiskalyTaxPayerLegalMutation__
 *
 * To run a mutation, you first call `useUpsertFiskalyTaxPayerLegalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFiskalyTaxPayerLegalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFiskalyTaxPayerLegalMutation, { data, loading, error }] = useUpsertFiskalyTaxPayerLegalMutation({
 *   variables: {
 *      taxPayerData: // value for 'taxPayerData'
 *   },
 * });
 */
export function useUpsertFiskalyTaxPayerLegalMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQUpsertFiskalyTaxPayerLegalMutation,
        GQUpsertFiskalyTaxPayerLegalMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQUpsertFiskalyTaxPayerLegalMutation,
        GQUpsertFiskalyTaxPayerLegalMutationVariables
    >(UpsertFiskalyTaxPayerLegalDocument, options);
}
export type UpsertFiskalyTaxPayerLegalMutationHookResult = ReturnType<
    typeof useUpsertFiskalyTaxPayerLegalMutation
>;
export type UpsertFiskalyTaxPayerLegalMutationResult =
    ApolloReactCommon.MutationResult<GQUpsertFiskalyTaxPayerLegalMutation>;
export type UpsertFiskalyTaxPayerLegalMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQUpsertFiskalyTaxPayerLegalMutation,
        GQUpsertFiskalyTaxPayerLegalMutationVariables
    >;
export const UpsertFiskalyTaxPayerNaturalDocument = gql`
    mutation upsertFiskalyTaxPayerNatural(
        $taxPayerData: FiskalyTaxPayerNaturalInput!
    ) {
        upsertFiskalyTaxPayerNatural(taxPayerData: $taxPayerData) {
            status
        }
    }
`;
export type GQUpsertFiskalyTaxPayerNaturalMutationFn =
    ApolloReactCommon.MutationFunction<
        GQUpsertFiskalyTaxPayerNaturalMutation,
        GQUpsertFiskalyTaxPayerNaturalMutationVariables
    >;

/**
 * __useUpsertFiskalyTaxPayerNaturalMutation__
 *
 * To run a mutation, you first call `useUpsertFiskalyTaxPayerNaturalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFiskalyTaxPayerNaturalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFiskalyTaxPayerNaturalMutation, { data, loading, error }] = useUpsertFiskalyTaxPayerNaturalMutation({
 *   variables: {
 *      taxPayerData: // value for 'taxPayerData'
 *   },
 * });
 */
export function useUpsertFiskalyTaxPayerNaturalMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQUpsertFiskalyTaxPayerNaturalMutation,
        GQUpsertFiskalyTaxPayerNaturalMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQUpsertFiskalyTaxPayerNaturalMutation,
        GQUpsertFiskalyTaxPayerNaturalMutationVariables
    >(UpsertFiskalyTaxPayerNaturalDocument, options);
}
export type UpsertFiskalyTaxPayerNaturalMutationHookResult = ReturnType<
    typeof useUpsertFiskalyTaxPayerNaturalMutation
>;
export type UpsertFiskalyTaxPayerNaturalMutationResult =
    ApolloReactCommon.MutationResult<GQUpsertFiskalyTaxPayerNaturalMutation>;
export type UpsertFiskalyTaxPayerNaturalMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQUpsertFiskalyTaxPayerNaturalMutation,
        GQUpsertFiskalyTaxPayerNaturalMutationVariables
    >;
export const RequestFiskalyEstablishmentSubmissionPreviewDownloadDocument = gql`
    mutation requestFiskalyEstablishmentSubmissionPreviewDownload(
        $submissionId: ID!
    ) {
        requestFiskalyEstablishmentSubmissionPreviewDownload(
            submissionId: $submissionId
        ) {
            fileContents
        }
    }
`;
export type GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutationFn =
    ApolloReactCommon.MutationFunction<
        GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation,
        GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutationVariables
    >;

/**
 * __useRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation__
 *
 * To run a mutation, you first call `useRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestFiskalyEstablishmentSubmissionPreviewDownloadMutation, { data, loading, error }] = useRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation,
        GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation,
        GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutationVariables
    >(RequestFiskalyEstablishmentSubmissionPreviewDownloadDocument, options);
}
export type RequestFiskalyEstablishmentSubmissionPreviewDownloadMutationHookResult =
    ReturnType<
        typeof useRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation
    >;
export type RequestFiskalyEstablishmentSubmissionPreviewDownloadMutationResult =
    ApolloReactCommon.MutationResult<GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation>;
export type RequestFiskalyEstablishmentSubmissionPreviewDownloadMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutation,
        GQRequestFiskalyEstablishmentSubmissionPreviewDownloadMutationVariables
    >;
export const RequestFiskalyEstablishmentSubmissionDownloadDocument = gql`
    mutation requestFiskalyEstablishmentSubmissionDownload($submissionId: ID!) {
        requestFiskalyEstablishmentSubmissionDownload(
            submissionId: $submissionId
        ) {
            fileContents
        }
    }
`;
export type GQRequestFiskalyEstablishmentSubmissionDownloadMutationFn =
    ApolloReactCommon.MutationFunction<
        GQRequestFiskalyEstablishmentSubmissionDownloadMutation,
        GQRequestFiskalyEstablishmentSubmissionDownloadMutationVariables
    >;

/**
 * __useRequestFiskalyEstablishmentSubmissionDownloadMutation__
 *
 * To run a mutation, you first call `useRequestFiskalyEstablishmentSubmissionDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestFiskalyEstablishmentSubmissionDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestFiskalyEstablishmentSubmissionDownloadMutation, { data, loading, error }] = useRequestFiskalyEstablishmentSubmissionDownloadMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useRequestFiskalyEstablishmentSubmissionDownloadMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQRequestFiskalyEstablishmentSubmissionDownloadMutation,
        GQRequestFiskalyEstablishmentSubmissionDownloadMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQRequestFiskalyEstablishmentSubmissionDownloadMutation,
        GQRequestFiskalyEstablishmentSubmissionDownloadMutationVariables
    >(RequestFiskalyEstablishmentSubmissionDownloadDocument, options);
}
export type RequestFiskalyEstablishmentSubmissionDownloadMutationHookResult =
    ReturnType<typeof useRequestFiskalyEstablishmentSubmissionDownloadMutation>;
export type RequestFiskalyEstablishmentSubmissionDownloadMutationResult =
    ApolloReactCommon.MutationResult<GQRequestFiskalyEstablishmentSubmissionDownloadMutation>;
export type RequestFiskalyEstablishmentSubmissionDownloadMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQRequestFiskalyEstablishmentSubmissionDownloadMutation,
        GQRequestFiskalyEstablishmentSubmissionDownloadMutationVariables
    >;
export const ApproveFiskalyEstablishmentSubmissionDocument = gql`
    mutation approveFiskalyEstablishmentSubmission($submissionId: ID!) {
        approveFiskalyEstablishmentSubmission(submissionId: $submissionId) {
            status
        }
    }
`;
export type GQApproveFiskalyEstablishmentSubmissionMutationFn =
    ApolloReactCommon.MutationFunction<
        GQApproveFiskalyEstablishmentSubmissionMutation,
        GQApproveFiskalyEstablishmentSubmissionMutationVariables
    >;

/**
 * __useApproveFiskalyEstablishmentSubmissionMutation__
 *
 * To run a mutation, you first call `useApproveFiskalyEstablishmentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveFiskalyEstablishmentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveFiskalyEstablishmentSubmissionMutation, { data, loading, error }] = useApproveFiskalyEstablishmentSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useApproveFiskalyEstablishmentSubmissionMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQApproveFiskalyEstablishmentSubmissionMutation,
        GQApproveFiskalyEstablishmentSubmissionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQApproveFiskalyEstablishmentSubmissionMutation,
        GQApproveFiskalyEstablishmentSubmissionMutationVariables
    >(ApproveFiskalyEstablishmentSubmissionDocument, options);
}
export type ApproveFiskalyEstablishmentSubmissionMutationHookResult =
    ReturnType<typeof useApproveFiskalyEstablishmentSubmissionMutation>;
export type ApproveFiskalyEstablishmentSubmissionMutationResult =
    ApolloReactCommon.MutationResult<GQApproveFiskalyEstablishmentSubmissionMutation>;
export type ApproveFiskalyEstablishmentSubmissionMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQApproveFiskalyEstablishmentSubmissionMutation,
        GQApproveFiskalyEstablishmentSubmissionMutationVariables
    >;
export const RequestFiskalyEstablishmentSubmissionTransmissionDocument = gql`
    mutation requestFiskalyEstablishmentSubmissionTransmission(
        $submissionId: ID!
    ) {
        requestFiskalyEstablishmentSubmissionTransmission(
            submissionId: $submissionId
        ) {
            status
        }
    }
`;
export type GQRequestFiskalyEstablishmentSubmissionTransmissionMutationFn =
    ApolloReactCommon.MutationFunction<
        GQRequestFiskalyEstablishmentSubmissionTransmissionMutation,
        GQRequestFiskalyEstablishmentSubmissionTransmissionMutationVariables
    >;

/**
 * __useRequestFiskalyEstablishmentSubmissionTransmissionMutation__
 *
 * To run a mutation, you first call `useRequestFiskalyEstablishmentSubmissionTransmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestFiskalyEstablishmentSubmissionTransmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestFiskalyEstablishmentSubmissionTransmissionMutation, { data, loading, error }] = useRequestFiskalyEstablishmentSubmissionTransmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useRequestFiskalyEstablishmentSubmissionTransmissionMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQRequestFiskalyEstablishmentSubmissionTransmissionMutation,
        GQRequestFiskalyEstablishmentSubmissionTransmissionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQRequestFiskalyEstablishmentSubmissionTransmissionMutation,
        GQRequestFiskalyEstablishmentSubmissionTransmissionMutationVariables
    >(RequestFiskalyEstablishmentSubmissionTransmissionDocument, options);
}
export type RequestFiskalyEstablishmentSubmissionTransmissionMutationHookResult =
    ReturnType<
        typeof useRequestFiskalyEstablishmentSubmissionTransmissionMutation
    >;
export type RequestFiskalyEstablishmentSubmissionTransmissionMutationResult =
    ApolloReactCommon.MutationResult<GQRequestFiskalyEstablishmentSubmissionTransmissionMutation>;
export type RequestFiskalyEstablishmentSubmissionTransmissionMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQRequestFiskalyEstablishmentSubmissionTransmissionMutation,
        GQRequestFiskalyEstablishmentSubmissionTransmissionMutationVariables
    >;
export const IntegrationSettingsDocument = gql`
    query integrationSettings($integrationId: ID!) {
        integrationSettings(integrationId: $integrationId) {
            ... on EconomicSettings {
                id
                type
                integrationId
                journalId
                enableSyncByProductGroups
                enableSyncAfterShiftClose
            }
            ... on PartnerApiSettings {
                id
                type
                integrationId
            }
            ... on VenueAccessSettings {
                id
                type
                integrationId
            }
            ... on CmpProductSettings {
                id
                type
                integrationId
                hostname
                port
                vhost
                exchangeName
                queueName
                routingKey
                username
                password
                cmpOrderUrl
            }
            ... on FiskalySettings {
                id
                type
                integrationId
                organizationId
                tssId
                apiKey
                submissionNeeded
            }
        }
    }
`;

/**
 * __useIntegrationSettingsQuery__
 *
 * To run a query within a React component, call `useIntegrationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationSettingsQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useIntegrationSettingsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQIntegrationSettingsQuery,
        GQIntegrationSettingsQueryVariables
    > &
        (
            | { variables: GQIntegrationSettingsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQIntegrationSettingsQuery,
        GQIntegrationSettingsQueryVariables
    >(IntegrationSettingsDocument, options);
}
export function useIntegrationSettingsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQIntegrationSettingsQuery,
        GQIntegrationSettingsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQIntegrationSettingsQuery,
        GQIntegrationSettingsQueryVariables
    >(IntegrationSettingsDocument, options);
}
// @ts-ignore
export function useIntegrationSettingsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQIntegrationSettingsQuery,
        GQIntegrationSettingsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIntegrationSettingsQuery,
    GQIntegrationSettingsQueryVariables
>;
export function useIntegrationSettingsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIntegrationSettingsQuery,
              GQIntegrationSettingsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIntegrationSettingsQuery | undefined,
    GQIntegrationSettingsQueryVariables
>;
export function useIntegrationSettingsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIntegrationSettingsQuery,
              GQIntegrationSettingsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQIntegrationSettingsQuery,
        GQIntegrationSettingsQueryVariables
    >(IntegrationSettingsDocument, options);
}
export type IntegrationSettingsQueryHookResult = ReturnType<
    typeof useIntegrationSettingsQuery
>;
export type IntegrationSettingsLazyQueryHookResult = ReturnType<
    typeof useIntegrationSettingsLazyQuery
>;
export type IntegrationSettingsSuspenseQueryHookResult = ReturnType<
    typeof useIntegrationSettingsSuspenseQuery
>;
export type IntegrationSettingsQueryResult = ApolloReactCommon.QueryResult<
    GQIntegrationSettingsQuery,
    GQIntegrationSettingsQueryVariables
>;
export const EconomicSettingsSaveDocument = gql`
    mutation economicSettingsSave(
        $integrationId: ID!
        $settings: EconomicSettingsInput!
    ) {
        integrationEconomicSettingsSave(
            integrationId: $integrationId
            settings: $settings
        ) {
            status
        }
    }
`;
export type GQEconomicSettingsSaveMutationFn =
    ApolloReactCommon.MutationFunction<
        GQEconomicSettingsSaveMutation,
        GQEconomicSettingsSaveMutationVariables
    >;

/**
 * __useEconomicSettingsSaveMutation__
 *
 * To run a mutation, you first call `useEconomicSettingsSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEconomicSettingsSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [economicSettingsSaveMutation, { data, loading, error }] = useEconomicSettingsSaveMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useEconomicSettingsSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQEconomicSettingsSaveMutation,
        GQEconomicSettingsSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQEconomicSettingsSaveMutation,
        GQEconomicSettingsSaveMutationVariables
    >(EconomicSettingsSaveDocument, options);
}
export type EconomicSettingsSaveMutationHookResult = ReturnType<
    typeof useEconomicSettingsSaveMutation
>;
export type EconomicSettingsSaveMutationResult =
    ApolloReactCommon.MutationResult<GQEconomicSettingsSaveMutation>;
export type EconomicSettingsSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQEconomicSettingsSaveMutation,
        GQEconomicSettingsSaveMutationVariables
    >;
export const CmpProductSettingsSaveDocument = gql`
    mutation cmpProductSettingsSave(
        $integrationId: ID!
        $settings: CmpProductSettingsInput!
    ) {
        integrationCmpProductSettingsSave(
            integrationId: $integrationId
            settings: $settings
        ) {
            status
        }
    }
`;
export type GQCmpProductSettingsSaveMutationFn =
    ApolloReactCommon.MutationFunction<
        GQCmpProductSettingsSaveMutation,
        GQCmpProductSettingsSaveMutationVariables
    >;

/**
 * __useCmpProductSettingsSaveMutation__
 *
 * To run a mutation, you first call `useCmpProductSettingsSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCmpProductSettingsSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cmpProductSettingsSaveMutation, { data, loading, error }] = useCmpProductSettingsSaveMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useCmpProductSettingsSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCmpProductSettingsSaveMutation,
        GQCmpProductSettingsSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCmpProductSettingsSaveMutation,
        GQCmpProductSettingsSaveMutationVariables
    >(CmpProductSettingsSaveDocument, options);
}
export type CmpProductSettingsSaveMutationHookResult = ReturnType<
    typeof useCmpProductSettingsSaveMutation
>;
export type CmpProductSettingsSaveMutationResult =
    ApolloReactCommon.MutationResult<GQCmpProductSettingsSaveMutation>;
export type CmpProductSettingsSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCmpProductSettingsSaveMutation,
        GQCmpProductSettingsSaveMutationVariables
    >;
export const FiskalySettingsSaveDocument = gql`
    mutation fiskalySettingsSave(
        $integrationId: ID!
        $settings: FiskalySettingsInput!
    ) {
        integrationFiskalySettingsSave(
            integrationId: $integrationId
            settings: $settings
        ) {
            status
        }
    }
`;
export type GQFiskalySettingsSaveMutationFn =
    ApolloReactCommon.MutationFunction<
        GQFiskalySettingsSaveMutation,
        GQFiskalySettingsSaveMutationVariables
    >;

/**
 * __useFiskalySettingsSaveMutation__
 *
 * To run a mutation, you first call `useFiskalySettingsSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFiskalySettingsSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fiskalySettingsSaveMutation, { data, loading, error }] = useFiskalySettingsSaveMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useFiskalySettingsSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQFiskalySettingsSaveMutation,
        GQFiskalySettingsSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQFiskalySettingsSaveMutation,
        GQFiskalySettingsSaveMutationVariables
    >(FiskalySettingsSaveDocument, options);
}
export type FiskalySettingsSaveMutationHookResult = ReturnType<
    typeof useFiskalySettingsSaveMutation
>;
export type FiskalySettingsSaveMutationResult =
    ApolloReactCommon.MutationResult<GQFiskalySettingsSaveMutation>;
export type FiskalySettingsSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQFiskalySettingsSaveMutation,
        GQFiskalySettingsSaveMutationVariables
    >;
export const IntegrationsDocument = gql`
    query integrations($pagination: PaginationInput) {
        integrations(pagination: $pagination) {
            data {
                ...allIntegrationFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllIntegrationFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useIntegrationsQuery__
 *
 * To run a query within a React component, call `useIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useIntegrationsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQIntegrationsQuery,
        GQIntegrationsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQIntegrationsQuery,
        GQIntegrationsQueryVariables
    >(IntegrationsDocument, options);
}
export function useIntegrationsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQIntegrationsQuery,
        GQIntegrationsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQIntegrationsQuery,
        GQIntegrationsQueryVariables
    >(IntegrationsDocument, options);
}
// @ts-ignore
export function useIntegrationsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQIntegrationsQuery,
        GQIntegrationsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIntegrationsQuery,
    GQIntegrationsQueryVariables
>;
export function useIntegrationsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIntegrationsQuery,
              GQIntegrationsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIntegrationsQuery | undefined,
    GQIntegrationsQueryVariables
>;
export function useIntegrationsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIntegrationsQuery,
              GQIntegrationsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQIntegrationsQuery,
        GQIntegrationsQueryVariables
    >(IntegrationsDocument, options);
}
export type IntegrationsQueryHookResult = ReturnType<
    typeof useIntegrationsQuery
>;
export type IntegrationsLazyQueryHookResult = ReturnType<
    typeof useIntegrationsLazyQuery
>;
export type IntegrationsSuspenseQueryHookResult = ReturnType<
    typeof useIntegrationsSuspenseQuery
>;
export type IntegrationsQueryResult = ApolloReactCommon.QueryResult<
    GQIntegrationsQuery,
    GQIntegrationsQueryVariables
>;
export const IntegrationsOfTypeDocument = gql`
    query integrationsOfType($type: String!) {
        integrationsOfType(type: $type) {
            data {
                ...allIntegrationFields
            }
        }
    }
    ${AllIntegrationFieldsFragmentDoc}
`;

/**
 * __useIntegrationsOfTypeQuery__
 *
 * To run a query within a React component, call `useIntegrationsOfTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsOfTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsOfTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useIntegrationsOfTypeQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQIntegrationsOfTypeQuery,
        GQIntegrationsOfTypeQueryVariables
    > &
        (
            | { variables: GQIntegrationsOfTypeQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQIntegrationsOfTypeQuery,
        GQIntegrationsOfTypeQueryVariables
    >(IntegrationsOfTypeDocument, options);
}
export function useIntegrationsOfTypeLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQIntegrationsOfTypeQuery,
        GQIntegrationsOfTypeQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQIntegrationsOfTypeQuery,
        GQIntegrationsOfTypeQueryVariables
    >(IntegrationsOfTypeDocument, options);
}
// @ts-ignore
export function useIntegrationsOfTypeSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQIntegrationsOfTypeQuery,
        GQIntegrationsOfTypeQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIntegrationsOfTypeQuery,
    GQIntegrationsOfTypeQueryVariables
>;
export function useIntegrationsOfTypeSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIntegrationsOfTypeQuery,
              GQIntegrationsOfTypeQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIntegrationsOfTypeQuery | undefined,
    GQIntegrationsOfTypeQueryVariables
>;
export function useIntegrationsOfTypeSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIntegrationsOfTypeQuery,
              GQIntegrationsOfTypeQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQIntegrationsOfTypeQuery,
        GQIntegrationsOfTypeQueryVariables
    >(IntegrationsOfTypeDocument, options);
}
export type IntegrationsOfTypeQueryHookResult = ReturnType<
    typeof useIntegrationsOfTypeQuery
>;
export type IntegrationsOfTypeLazyQueryHookResult = ReturnType<
    typeof useIntegrationsOfTypeLazyQuery
>;
export type IntegrationsOfTypeSuspenseQueryHookResult = ReturnType<
    typeof useIntegrationsOfTypeSuspenseQuery
>;
export type IntegrationsOfTypeQueryResult = ApolloReactCommon.QueryResult<
    GQIntegrationsOfTypeQuery,
    GQIntegrationsOfTypeQueryVariables
>;
export const IntegrationDocument = gql`
    query integration($id: ID!) {
        integration(id: $id) {
            ...allIntegrationFields
        }
    }
    ${AllIntegrationFieldsFragmentDoc}
`;

/**
 * __useIntegrationQuery__
 *
 * To run a query within a React component, call `useIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQIntegrationQuery,
        GQIntegrationQueryVariables
    > &
        (
            | { variables: GQIntegrationQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQIntegrationQuery,
        GQIntegrationQueryVariables
    >(IntegrationDocument, options);
}
export function useIntegrationLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQIntegrationQuery,
        GQIntegrationQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQIntegrationQuery,
        GQIntegrationQueryVariables
    >(IntegrationDocument, options);
}
// @ts-ignore
export function useIntegrationSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQIntegrationQuery,
        GQIntegrationQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIntegrationQuery,
    GQIntegrationQueryVariables
>;
export function useIntegrationSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIntegrationQuery,
              GQIntegrationQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIntegrationQuery | undefined,
    GQIntegrationQueryVariables
>;
export function useIntegrationSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIntegrationQuery,
              GQIntegrationQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQIntegrationQuery,
        GQIntegrationQueryVariables
    >(IntegrationDocument, options);
}
export type IntegrationQueryHookResult = ReturnType<typeof useIntegrationQuery>;
export type IntegrationLazyQueryHookResult = ReturnType<
    typeof useIntegrationLazyQuery
>;
export type IntegrationSuspenseQueryHookResult = ReturnType<
    typeof useIntegrationSuspenseQuery
>;
export type IntegrationQueryResult = ApolloReactCommon.QueryResult<
    GQIntegrationQuery,
    GQIntegrationQueryVariables
>;
export const IntegrationCreateDocument = gql`
    mutation integrationCreate($integration: IntegrationCreate!) {
        integrationCreate(integration: $integration) {
            ...allIntegrationFields
        }
    }
    ${AllIntegrationFieldsFragmentDoc}
`;
export type GQIntegrationCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQIntegrationCreateMutation,
    GQIntegrationCreateMutationVariables
>;

/**
 * __useIntegrationCreateMutation__
 *
 * To run a mutation, you first call `useIntegrationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationCreateMutation, { data, loading, error }] = useIntegrationCreateMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useIntegrationCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQIntegrationCreateMutation,
        GQIntegrationCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQIntegrationCreateMutation,
        GQIntegrationCreateMutationVariables
    >(IntegrationCreateDocument, options);
}
export type IntegrationCreateMutationHookResult = ReturnType<
    typeof useIntegrationCreateMutation
>;
export type IntegrationCreateMutationResult =
    ApolloReactCommon.MutationResult<GQIntegrationCreateMutation>;
export type IntegrationCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQIntegrationCreateMutation,
        GQIntegrationCreateMutationVariables
    >;
export const IntegrationSaveDocument = gql`
    mutation integrationSave($id: ID!, $integration: IntegrationInput!) {
        integrationSave(id: $id, integration: $integration) {
            ...allIntegrationFields
        }
    }
    ${AllIntegrationFieldsFragmentDoc}
`;
export type GQIntegrationSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQIntegrationSaveMutation,
    GQIntegrationSaveMutationVariables
>;

/**
 * __useIntegrationSaveMutation__
 *
 * To run a mutation, you first call `useIntegrationSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationSaveMutation, { data, loading, error }] = useIntegrationSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useIntegrationSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQIntegrationSaveMutation,
        GQIntegrationSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQIntegrationSaveMutation,
        GQIntegrationSaveMutationVariables
    >(IntegrationSaveDocument, options);
}
export type IntegrationSaveMutationHookResult = ReturnType<
    typeof useIntegrationSaveMutation
>;
export type IntegrationSaveMutationResult =
    ApolloReactCommon.MutationResult<GQIntegrationSaveMutation>;
export type IntegrationSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQIntegrationSaveMutation,
        GQIntegrationSaveMutationVariables
    >;
export const IntegrationDeleteDocument = gql`
    mutation integrationDelete($id: ID!) {
        integrationDelete(id: $id) {
            status
        }
    }
`;
export type GQIntegrationDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQIntegrationDeleteMutation,
    GQIntegrationDeleteMutationVariables
>;

/**
 * __useIntegrationDeleteMutation__
 *
 * To run a mutation, you first call `useIntegrationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationDeleteMutation, { data, loading, error }] = useIntegrationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQIntegrationDeleteMutation,
        GQIntegrationDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQIntegrationDeleteMutation,
        GQIntegrationDeleteMutationVariables
    >(IntegrationDeleteDocument, options);
}
export type IntegrationDeleteMutationHookResult = ReturnType<
    typeof useIntegrationDeleteMutation
>;
export type IntegrationDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQIntegrationDeleteMutation>;
export type IntegrationDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQIntegrationDeleteMutation,
        GQIntegrationDeleteMutationVariables
    >;
export const IntegrationFormDocument = gql`
    query integrationForm {
        integrations(pagination: { pageSize: 999999 }) {
            data {
                id
                type
                active
                name
                apiKey
            }
        }
    }
`;

/**
 * __useIntegrationFormQuery__
 *
 * To run a query within a React component, call `useIntegrationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQIntegrationFormQuery,
        GQIntegrationFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQIntegrationFormQuery,
        GQIntegrationFormQueryVariables
    >(IntegrationFormDocument, options);
}
export function useIntegrationFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQIntegrationFormQuery,
        GQIntegrationFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQIntegrationFormQuery,
        GQIntegrationFormQueryVariables
    >(IntegrationFormDocument, options);
}
// @ts-ignore
export function useIntegrationFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQIntegrationFormQuery,
        GQIntegrationFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIntegrationFormQuery,
    GQIntegrationFormQueryVariables
>;
export function useIntegrationFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIntegrationFormQuery,
              GQIntegrationFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIntegrationFormQuery | undefined,
    GQIntegrationFormQueryVariables
>;
export function useIntegrationFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIntegrationFormQuery,
              GQIntegrationFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQIntegrationFormQuery,
        GQIntegrationFormQueryVariables
    >(IntegrationFormDocument, options);
}
export type IntegrationFormQueryHookResult = ReturnType<
    typeof useIntegrationFormQuery
>;
export type IntegrationFormLazyQueryHookResult = ReturnType<
    typeof useIntegrationFormLazyQuery
>;
export type IntegrationFormSuspenseQueryHookResult = ReturnType<
    typeof useIntegrationFormSuspenseQuery
>;
export type IntegrationFormQueryResult = ApolloReactCommon.QueryResult<
    GQIntegrationFormQuery,
    GQIntegrationFormQueryVariables
>;
export const InvoicesDocument = gql`
    query invoices(
        $pagination: PaginationInput
        $search: SearchInput
        $searching: InvoiceSearchInput
    ) {
        invoices(
            pagination: $pagination
            search: $search
            searching: $searching
        ) {
            data {
                ...allInvoiceFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllInvoiceFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useInvoicesQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQInvoicesQuery,
        GQInvoicesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQInvoicesQuery, GQInvoicesQueryVariables>(
        InvoicesDocument,
        options
    );
}
export function useInvoicesLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQInvoicesQuery,
        GQInvoicesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQInvoicesQuery,
        GQInvoicesQueryVariables
    >(InvoicesDocument, options);
}
// @ts-ignore
export function useInvoicesSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQInvoicesQuery,
        GQInvoicesQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInvoicesQuery,
    GQInvoicesQueryVariables
>;
export function useInvoicesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInvoicesQuery,
              GQInvoicesQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInvoicesQuery | undefined,
    GQInvoicesQueryVariables
>;
export function useInvoicesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInvoicesQuery,
              GQInvoicesQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQInvoicesQuery,
        GQInvoicesQueryVariables
    >(InvoicesDocument, options);
}
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<
    typeof useInvoicesLazyQuery
>;
export type InvoicesSuspenseQueryHookResult = ReturnType<
    typeof useInvoicesSuspenseQuery
>;
export type InvoicesQueryResult = ApolloReactCommon.QueryResult<
    GQInvoicesQuery,
    GQInvoicesQueryVariables
>;
export const InvoiceDocument = gql`
    query invoice($id: ID!) {
        invoice(id: $id) {
            ...allInvoiceFields
        }
    }
    ${AllInvoiceFieldsFragmentDoc}
`;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQInvoiceQuery,
        GQInvoiceQueryVariables
    > &
        (
            | { variables: GQInvoiceQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQInvoiceQuery, GQInvoiceQueryVariables>(
        InvoiceDocument,
        options
    );
}
export function useInvoiceLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQInvoiceQuery,
        GQInvoiceQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQInvoiceQuery,
        GQInvoiceQueryVariables
    >(InvoiceDocument, options);
}
// @ts-ignore
export function useInvoiceSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQInvoiceQuery,
        GQInvoiceQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInvoiceQuery,
    GQInvoiceQueryVariables
>;
export function useInvoiceSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInvoiceQuery,
              GQInvoiceQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInvoiceQuery | undefined,
    GQInvoiceQueryVariables
>;
export function useInvoiceSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInvoiceQuery,
              GQInvoiceQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQInvoiceQuery,
        GQInvoiceQueryVariables
    >(InvoiceDocument, options);
}
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceSuspenseQueryHookResult = ReturnType<
    typeof useInvoiceSuspenseQuery
>;
export type InvoiceQueryResult = ApolloReactCommon.QueryResult<
    GQInvoiceQuery,
    GQInvoiceQueryVariables
>;
export const InvoicesInPeriodDocument = gql`
    query invoicesInPeriod(
        $from: Date!
        $to: Date!
        $pagination: PaginationInput
    ) {
        invoicesInPeriod(from: $from, to: $to, pagination: $pagination) {
            data {
                ...allInvoiceFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllInvoiceFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useInvoicesInPeriodQuery__
 *
 * To run a query within a React component, call `useInvoicesInPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesInPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesInPeriodQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useInvoicesInPeriodQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQInvoicesInPeriodQuery,
        GQInvoicesInPeriodQueryVariables
    > &
        (
            | { variables: GQInvoicesInPeriodQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQInvoicesInPeriodQuery,
        GQInvoicesInPeriodQueryVariables
    >(InvoicesInPeriodDocument, options);
}
export function useInvoicesInPeriodLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQInvoicesInPeriodQuery,
        GQInvoicesInPeriodQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQInvoicesInPeriodQuery,
        GQInvoicesInPeriodQueryVariables
    >(InvoicesInPeriodDocument, options);
}
// @ts-ignore
export function useInvoicesInPeriodSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQInvoicesInPeriodQuery,
        GQInvoicesInPeriodQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInvoicesInPeriodQuery,
    GQInvoicesInPeriodQueryVariables
>;
export function useInvoicesInPeriodSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInvoicesInPeriodQuery,
              GQInvoicesInPeriodQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInvoicesInPeriodQuery | undefined,
    GQInvoicesInPeriodQueryVariables
>;
export function useInvoicesInPeriodSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInvoicesInPeriodQuery,
              GQInvoicesInPeriodQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQInvoicesInPeriodQuery,
        GQInvoicesInPeriodQueryVariables
    >(InvoicesInPeriodDocument, options);
}
export type InvoicesInPeriodQueryHookResult = ReturnType<
    typeof useInvoicesInPeriodQuery
>;
export type InvoicesInPeriodLazyQueryHookResult = ReturnType<
    typeof useInvoicesInPeriodLazyQuery
>;
export type InvoicesInPeriodSuspenseQueryHookResult = ReturnType<
    typeof useInvoicesInPeriodSuspenseQuery
>;
export type InvoicesInPeriodQueryResult = ApolloReactCommon.QueryResult<
    GQInvoicesInPeriodQuery,
    GQInvoicesInPeriodQueryVariables
>;
export const LayoutEntityDocument = gql`
    query layoutEntity($id: ID!) {
        layoutEntity(id: $id) {
            ...allLayoutEntityFields
        }
    }
    ${AllLayoutEntityFieldsFragmentDoc}
`;

/**
 * __useLayoutEntityQuery__
 *
 * To run a query within a React component, call `useLayoutEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLayoutEntityQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQLayoutEntityQuery,
        GQLayoutEntityQueryVariables
    > &
        (
            | { variables: GQLayoutEntityQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQLayoutEntityQuery,
        GQLayoutEntityQueryVariables
    >(LayoutEntityDocument, options);
}
export function useLayoutEntityLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQLayoutEntityQuery,
        GQLayoutEntityQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQLayoutEntityQuery,
        GQLayoutEntityQueryVariables
    >(LayoutEntityDocument, options);
}
// @ts-ignore
export function useLayoutEntitySuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQLayoutEntityQuery,
        GQLayoutEntityQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLayoutEntityQuery,
    GQLayoutEntityQueryVariables
>;
export function useLayoutEntitySuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLayoutEntityQuery,
              GQLayoutEntityQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLayoutEntityQuery | undefined,
    GQLayoutEntityQueryVariables
>;
export function useLayoutEntitySuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLayoutEntityQuery,
              GQLayoutEntityQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQLayoutEntityQuery,
        GQLayoutEntityQueryVariables
    >(LayoutEntityDocument, options);
}
export type LayoutEntityQueryHookResult = ReturnType<
    typeof useLayoutEntityQuery
>;
export type LayoutEntityLazyQueryHookResult = ReturnType<
    typeof useLayoutEntityLazyQuery
>;
export type LayoutEntitySuspenseQueryHookResult = ReturnType<
    typeof useLayoutEntitySuspenseQuery
>;
export type LayoutEntityQueryResult = ApolloReactCommon.QueryResult<
    GQLayoutEntityQuery,
    GQLayoutEntityQueryVariables
>;
export const LayoutEntitiesDocument = gql`
    query layoutEntities(
        $pagination: PaginationInput
        $searching: LayoutEntitySearchInput
    ) {
        layoutEntities(pagination: $pagination, searching: $searching) {
            data {
                ...allLayoutEntityFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllLayoutEntityFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useLayoutEntitiesQuery__
 *
 * To run a query within a React component, call `useLayoutEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutEntitiesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useLayoutEntitiesQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQLayoutEntitiesQuery,
        GQLayoutEntitiesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQLayoutEntitiesQuery,
        GQLayoutEntitiesQueryVariables
    >(LayoutEntitiesDocument, options);
}
export function useLayoutEntitiesLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQLayoutEntitiesQuery,
        GQLayoutEntitiesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQLayoutEntitiesQuery,
        GQLayoutEntitiesQueryVariables
    >(LayoutEntitiesDocument, options);
}
// @ts-ignore
export function useLayoutEntitiesSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQLayoutEntitiesQuery,
        GQLayoutEntitiesQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLayoutEntitiesQuery,
    GQLayoutEntitiesQueryVariables
>;
export function useLayoutEntitiesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLayoutEntitiesQuery,
              GQLayoutEntitiesQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLayoutEntitiesQuery | undefined,
    GQLayoutEntitiesQueryVariables
>;
export function useLayoutEntitiesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLayoutEntitiesQuery,
              GQLayoutEntitiesQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQLayoutEntitiesQuery,
        GQLayoutEntitiesQueryVariables
    >(LayoutEntitiesDocument, options);
}
export type LayoutEntitiesQueryHookResult = ReturnType<
    typeof useLayoutEntitiesQuery
>;
export type LayoutEntitiesLazyQueryHookResult = ReturnType<
    typeof useLayoutEntitiesLazyQuery
>;
export type LayoutEntitiesSuspenseQueryHookResult = ReturnType<
    typeof useLayoutEntitiesSuspenseQuery
>;
export type LayoutEntitiesQueryResult = ApolloReactCommon.QueryResult<
    GQLayoutEntitiesQuery,
    GQLayoutEntitiesQueryVariables
>;
export const LayoutEntityFormDocument = gql`
    query layoutEntityForm {
        layoutEntities(pagination: { pageSize: 99999 }) {
            data {
                name
            }
        }
    }
`;

/**
 * __useLayoutEntityFormQuery__
 *
 * To run a query within a React component, call `useLayoutEntityFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutEntityFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutEntityFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useLayoutEntityFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQLayoutEntityFormQuery,
        GQLayoutEntityFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQLayoutEntityFormQuery,
        GQLayoutEntityFormQueryVariables
    >(LayoutEntityFormDocument, options);
}
export function useLayoutEntityFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQLayoutEntityFormQuery,
        GQLayoutEntityFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQLayoutEntityFormQuery,
        GQLayoutEntityFormQueryVariables
    >(LayoutEntityFormDocument, options);
}
// @ts-ignore
export function useLayoutEntityFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQLayoutEntityFormQuery,
        GQLayoutEntityFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLayoutEntityFormQuery,
    GQLayoutEntityFormQueryVariables
>;
export function useLayoutEntityFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLayoutEntityFormQuery,
              GQLayoutEntityFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLayoutEntityFormQuery | undefined,
    GQLayoutEntityFormQueryVariables
>;
export function useLayoutEntityFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLayoutEntityFormQuery,
              GQLayoutEntityFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQLayoutEntityFormQuery,
        GQLayoutEntityFormQueryVariables
    >(LayoutEntityFormDocument, options);
}
export type LayoutEntityFormQueryHookResult = ReturnType<
    typeof useLayoutEntityFormQuery
>;
export type LayoutEntityFormLazyQueryHookResult = ReturnType<
    typeof useLayoutEntityFormLazyQuery
>;
export type LayoutEntityFormSuspenseQueryHookResult = ReturnType<
    typeof useLayoutEntityFormSuspenseQuery
>;
export type LayoutEntityFormQueryResult = ApolloReactCommon.QueryResult<
    GQLayoutEntityFormQuery,
    GQLayoutEntityFormQueryVariables
>;
export const LayoutEntityCreateDocument = gql`
    mutation layoutEntityCreate($layoutEntity: LayoutEntityCreate!) {
        layoutEntityCreate(layoutEntity: $layoutEntity) {
            ...allLayoutEntityFields
        }
    }
    ${AllLayoutEntityFieldsFragmentDoc}
`;
export type GQLayoutEntityCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQLayoutEntityCreateMutation,
    GQLayoutEntityCreateMutationVariables
>;

/**
 * __useLayoutEntityCreateMutation__
 *
 * To run a mutation, you first call `useLayoutEntityCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutEntityCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutEntityCreateMutation, { data, loading, error }] = useLayoutEntityCreateMutation({
 *   variables: {
 *      layoutEntity: // value for 'layoutEntity'
 *   },
 * });
 */
export function useLayoutEntityCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQLayoutEntityCreateMutation,
        GQLayoutEntityCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQLayoutEntityCreateMutation,
        GQLayoutEntityCreateMutationVariables
    >(LayoutEntityCreateDocument, options);
}
export type LayoutEntityCreateMutationHookResult = ReturnType<
    typeof useLayoutEntityCreateMutation
>;
export type LayoutEntityCreateMutationResult =
    ApolloReactCommon.MutationResult<GQLayoutEntityCreateMutation>;
export type LayoutEntityCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQLayoutEntityCreateMutation,
        GQLayoutEntityCreateMutationVariables
    >;
export const LayoutEntitySaveDocument = gql`
    mutation layoutEntitySave($id: ID!, $layoutEntity: LayoutEntitySave!) {
        layoutEntitySave(id: $id, layoutEntity: $layoutEntity) {
            ...allLayoutEntityFields
        }
    }
    ${AllLayoutEntityFieldsFragmentDoc}
`;
export type GQLayoutEntitySaveMutationFn = ApolloReactCommon.MutationFunction<
    GQLayoutEntitySaveMutation,
    GQLayoutEntitySaveMutationVariables
>;

/**
 * __useLayoutEntitySaveMutation__
 *
 * To run a mutation, you first call `useLayoutEntitySaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutEntitySaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutEntitySaveMutation, { data, loading, error }] = useLayoutEntitySaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      layoutEntity: // value for 'layoutEntity'
 *   },
 * });
 */
export function useLayoutEntitySaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQLayoutEntitySaveMutation,
        GQLayoutEntitySaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQLayoutEntitySaveMutation,
        GQLayoutEntitySaveMutationVariables
    >(LayoutEntitySaveDocument, options);
}
export type LayoutEntitySaveMutationHookResult = ReturnType<
    typeof useLayoutEntitySaveMutation
>;
export type LayoutEntitySaveMutationResult =
    ApolloReactCommon.MutationResult<GQLayoutEntitySaveMutation>;
export type LayoutEntitySaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQLayoutEntitySaveMutation,
        GQLayoutEntitySaveMutationVariables
    >;
export const LayoutEntityDeleteDocument = gql`
    mutation layoutEntityDelete($id: ID!) {
        layoutEntityDelete(id: $id) {
            status
        }
    }
`;
export type GQLayoutEntityDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQLayoutEntityDeleteMutation,
    GQLayoutEntityDeleteMutationVariables
>;

/**
 * __useLayoutEntityDeleteMutation__
 *
 * To run a mutation, you first call `useLayoutEntityDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutEntityDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutEntityDeleteMutation, { data, loading, error }] = useLayoutEntityDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLayoutEntityDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQLayoutEntityDeleteMutation,
        GQLayoutEntityDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQLayoutEntityDeleteMutation,
        GQLayoutEntityDeleteMutationVariables
    >(LayoutEntityDeleteDocument, options);
}
export type LayoutEntityDeleteMutationHookResult = ReturnType<
    typeof useLayoutEntityDeleteMutation
>;
export type LayoutEntityDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQLayoutEntityDeleteMutation>;
export type LayoutEntityDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQLayoutEntityDeleteMutation,
        GQLayoutEntityDeleteMutationVariables
    >;
export const LayoutDocument = gql`
    query layout($id: ID!) {
        layout(id: $id) {
            ...allLayoutFields
        }
    }
    ${AllLayoutFieldsFragmentDoc}
`;

/**
 * __useLayoutQuery__
 *
 * To run a query within a React component, call `useLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLayoutQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQLayoutQuery,
        GQLayoutQueryVariables
    > &
        (
            | { variables: GQLayoutQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQLayoutQuery, GQLayoutQueryVariables>(
        LayoutDocument,
        options
    );
}
export function useLayoutLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQLayoutQuery,
        GQLayoutQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQLayoutQuery, GQLayoutQueryVariables>(
        LayoutDocument,
        options
    );
}
// @ts-ignore
export function useLayoutSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQLayoutQuery,
        GQLayoutQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLayoutQuery,
    GQLayoutQueryVariables
>;
export function useLayoutSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLayoutQuery,
              GQLayoutQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLayoutQuery | undefined,
    GQLayoutQueryVariables
>;
export function useLayoutSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLayoutQuery,
              GQLayoutQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQLayoutQuery,
        GQLayoutQueryVariables
    >(LayoutDocument, options);
}
export type LayoutQueryHookResult = ReturnType<typeof useLayoutQuery>;
export type LayoutLazyQueryHookResult = ReturnType<typeof useLayoutLazyQuery>;
export type LayoutSuspenseQueryHookResult = ReturnType<
    typeof useLayoutSuspenseQuery
>;
export type LayoutQueryResult = ApolloReactCommon.QueryResult<
    GQLayoutQuery,
    GQLayoutQueryVariables
>;
export const ProductLayoutsDocument = gql`
    query productLayouts(
        $pagination: PaginationInput
        $searching: LayoutSearchInput
    ) {
        productLayouts(pagination: $pagination, searching: $searching) {
            data {
                ...allLayoutFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllLayoutFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useProductLayoutsQuery__
 *
 * To run a query within a React component, call `useProductLayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductLayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductLayoutsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useProductLayoutsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQProductLayoutsQuery,
        GQProductLayoutsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQProductLayoutsQuery,
        GQProductLayoutsQueryVariables
    >(ProductLayoutsDocument, options);
}
export function useProductLayoutsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQProductLayoutsQuery,
        GQProductLayoutsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQProductLayoutsQuery,
        GQProductLayoutsQueryVariables
    >(ProductLayoutsDocument, options);
}
// @ts-ignore
export function useProductLayoutsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQProductLayoutsQuery,
        GQProductLayoutsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductLayoutsQuery,
    GQProductLayoutsQueryVariables
>;
export function useProductLayoutsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductLayoutsQuery,
              GQProductLayoutsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductLayoutsQuery | undefined,
    GQProductLayoutsQueryVariables
>;
export function useProductLayoutsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductLayoutsQuery,
              GQProductLayoutsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQProductLayoutsQuery,
        GQProductLayoutsQueryVariables
    >(ProductLayoutsDocument, options);
}
export type ProductLayoutsQueryHookResult = ReturnType<
    typeof useProductLayoutsQuery
>;
export type ProductLayoutsLazyQueryHookResult = ReturnType<
    typeof useProductLayoutsLazyQuery
>;
export type ProductLayoutsSuspenseQueryHookResult = ReturnType<
    typeof useProductLayoutsSuspenseQuery
>;
export type ProductLayoutsQueryResult = ApolloReactCommon.QueryResult<
    GQProductLayoutsQuery,
    GQProductLayoutsQueryVariables
>;
export const TableLayoutsDocument = gql`
    query tableLayouts(
        $pagination: PaginationInput
        $searching: LayoutSearchInput
    ) {
        tableLayouts(pagination: $pagination, searching: $searching) {
            data {
                ...allLayoutFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllLayoutFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useTableLayoutsQuery__
 *
 * To run a query within a React component, call `useTableLayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableLayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableLayoutsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useTableLayoutsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQTableLayoutsQuery,
        GQTableLayoutsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQTableLayoutsQuery,
        GQTableLayoutsQueryVariables
    >(TableLayoutsDocument, options);
}
export function useTableLayoutsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTableLayoutsQuery,
        GQTableLayoutsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQTableLayoutsQuery,
        GQTableLayoutsQueryVariables
    >(TableLayoutsDocument, options);
}
// @ts-ignore
export function useTableLayoutsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTableLayoutsQuery,
        GQTableLayoutsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTableLayoutsQuery,
    GQTableLayoutsQueryVariables
>;
export function useTableLayoutsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTableLayoutsQuery,
              GQTableLayoutsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTableLayoutsQuery | undefined,
    GQTableLayoutsQueryVariables
>;
export function useTableLayoutsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTableLayoutsQuery,
              GQTableLayoutsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQTableLayoutsQuery,
        GQTableLayoutsQueryVariables
    >(TableLayoutsDocument, options);
}
export type TableLayoutsQueryHookResult = ReturnType<
    typeof useTableLayoutsQuery
>;
export type TableLayoutsLazyQueryHookResult = ReturnType<
    typeof useTableLayoutsLazyQuery
>;
export type TableLayoutsSuspenseQueryHookResult = ReturnType<
    typeof useTableLayoutsSuspenseQuery
>;
export type TableLayoutsQueryResult = ApolloReactCommon.QueryResult<
    GQTableLayoutsQuery,
    GQTableLayoutsQueryVariables
>;
export const LayoutCreateDocument = gql`
    mutation layoutCreate($layout: LayoutCreate!) {
        layoutCreate(layout: $layout) {
            ...allLayoutFields
        }
    }
    ${AllLayoutFieldsFragmentDoc}
`;
export type GQLayoutCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQLayoutCreateMutation,
    GQLayoutCreateMutationVariables
>;

/**
 * __useLayoutCreateMutation__
 *
 * To run a mutation, you first call `useLayoutCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutCreateMutation, { data, loading, error }] = useLayoutCreateMutation({
 *   variables: {
 *      layout: // value for 'layout'
 *   },
 * });
 */
export function useLayoutCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQLayoutCreateMutation,
        GQLayoutCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQLayoutCreateMutation,
        GQLayoutCreateMutationVariables
    >(LayoutCreateDocument, options);
}
export type LayoutCreateMutationHookResult = ReturnType<
    typeof useLayoutCreateMutation
>;
export type LayoutCreateMutationResult =
    ApolloReactCommon.MutationResult<GQLayoutCreateMutation>;
export type LayoutCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQLayoutCreateMutation,
    GQLayoutCreateMutationVariables
>;
export const LayoutSaveDocument = gql`
    mutation layoutSave($id: ID!, $layout: LayoutSave!) {
        layoutSave(id: $id, layout: $layout) {
            ...allLayoutFields
        }
    }
    ${AllLayoutFieldsFragmentDoc}
`;
export type GQLayoutSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQLayoutSaveMutation,
    GQLayoutSaveMutationVariables
>;

/**
 * __useLayoutSaveMutation__
 *
 * To run a mutation, you first call `useLayoutSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutSaveMutation, { data, loading, error }] = useLayoutSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      layout: // value for 'layout'
 *   },
 * });
 */
export function useLayoutSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQLayoutSaveMutation,
        GQLayoutSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQLayoutSaveMutation,
        GQLayoutSaveMutationVariables
    >(LayoutSaveDocument, options);
}
export type LayoutSaveMutationHookResult = ReturnType<
    typeof useLayoutSaveMutation
>;
export type LayoutSaveMutationResult =
    ApolloReactCommon.MutationResult<GQLayoutSaveMutation>;
export type LayoutSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQLayoutSaveMutation,
    GQLayoutSaveMutationVariables
>;
export const LayoutDeleteDocument = gql`
    mutation layoutDelete($id: ID!) {
        layoutDelete(id: $id) {
            status
        }
    }
`;
export type GQLayoutDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQLayoutDeleteMutation,
    GQLayoutDeleteMutationVariables
>;

/**
 * __useLayoutDeleteMutation__
 *
 * To run a mutation, you first call `useLayoutDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutDeleteMutation, { data, loading, error }] = useLayoutDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLayoutDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQLayoutDeleteMutation,
        GQLayoutDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQLayoutDeleteMutation,
        GQLayoutDeleteMutationVariables
    >(LayoutDeleteDocument, options);
}
export type LayoutDeleteMutationHookResult = ReturnType<
    typeof useLayoutDeleteMutation
>;
export type LayoutDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQLayoutDeleteMutation>;
export type LayoutDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQLayoutDeleteMutation,
    GQLayoutDeleteMutationVariables
>;
export const LayoutCopyDocument = gql`
    mutation layoutCopy($id: ID!, $newTitle: String!) {
        layoutCopy(id: $id, newTitle: $newTitle) {
            ...allLayoutFields
        }
    }
    ${AllLayoutFieldsFragmentDoc}
`;
export type GQLayoutCopyMutationFn = ApolloReactCommon.MutationFunction<
    GQLayoutCopyMutation,
    GQLayoutCopyMutationVariables
>;

/**
 * __useLayoutCopyMutation__
 *
 * To run a mutation, you first call `useLayoutCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutCopyMutation, { data, loading, error }] = useLayoutCopyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newTitle: // value for 'newTitle'
 *   },
 * });
 */
export function useLayoutCopyMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQLayoutCopyMutation,
        GQLayoutCopyMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQLayoutCopyMutation,
        GQLayoutCopyMutationVariables
    >(LayoutCopyDocument, options);
}
export type LayoutCopyMutationHookResult = ReturnType<
    typeof useLayoutCopyMutation
>;
export type LayoutCopyMutationResult =
    ApolloReactCommon.MutationResult<GQLayoutCopyMutation>;
export type LayoutCopyMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQLayoutCopyMutation,
    GQLayoutCopyMutationVariables
>;
export const ProductLayoutFormDocument = gql`
    query productLayoutForm {
        products(
            pagination: { pageSize: 999999, sort: "name", sortDirection: "ASC" }
            includeChildren: true
        ) {
            data {
                id
                name
                buttonText
                amount
                minimumAmount
                costAmount
                group {
                    id
                    name
                    color
                }
            }
        }
        productGroups(
            pagination: { pageSize: 9999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
                color
            }
        }
        cmpEvents(
            pagination: { pageSize: 9999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
                externalId
                active
                products {
                    id
                    name
                    externalId
                    active
                    amount
                }
            }
        }
        cmpProducts(
            pagination: { pageSize: 9999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
                externalId
                active
                amount
            }
        }
        layoutEntities(
            pagination: { pageSize: 999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                ...allLayoutEntityFields
            }
        }
    }
    ${AllLayoutEntityFieldsFragmentDoc}
`;

/**
 * __useProductLayoutFormQuery__
 *
 * To run a query within a React component, call `useProductLayoutFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductLayoutFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductLayoutFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductLayoutFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQProductLayoutFormQuery,
        GQProductLayoutFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQProductLayoutFormQuery,
        GQProductLayoutFormQueryVariables
    >(ProductLayoutFormDocument, options);
}
export function useProductLayoutFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQProductLayoutFormQuery,
        GQProductLayoutFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQProductLayoutFormQuery,
        GQProductLayoutFormQueryVariables
    >(ProductLayoutFormDocument, options);
}
// @ts-ignore
export function useProductLayoutFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQProductLayoutFormQuery,
        GQProductLayoutFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductLayoutFormQuery,
    GQProductLayoutFormQueryVariables
>;
export function useProductLayoutFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductLayoutFormQuery,
              GQProductLayoutFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductLayoutFormQuery | undefined,
    GQProductLayoutFormQueryVariables
>;
export function useProductLayoutFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductLayoutFormQuery,
              GQProductLayoutFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQProductLayoutFormQuery,
        GQProductLayoutFormQueryVariables
    >(ProductLayoutFormDocument, options);
}
export type ProductLayoutFormQueryHookResult = ReturnType<
    typeof useProductLayoutFormQuery
>;
export type ProductLayoutFormLazyQueryHookResult = ReturnType<
    typeof useProductLayoutFormLazyQuery
>;
export type ProductLayoutFormSuspenseQueryHookResult = ReturnType<
    typeof useProductLayoutFormSuspenseQuery
>;
export type ProductLayoutFormQueryResult = ApolloReactCommon.QueryResult<
    GQProductLayoutFormQuery,
    GQProductLayoutFormQueryVariables
>;
export const VenueAccessTicketParametersBulkDocument = gql`
    query VenueAccessTicketParametersBulk($eventIds: [Int!]!) {
        venueAccessTicketParametersBulk(eventIds: $eventIds) {
            events {
                id
                name
                isActive
            }
            accessTypes {
                id
                name
            }
        }
    }
`;

/**
 * __useVenueAccessTicketParametersBulkQuery__
 *
 * To run a query within a React component, call `useVenueAccessTicketParametersBulkQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueAccessTicketParametersBulkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueAccessTicketParametersBulkQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useVenueAccessTicketParametersBulkQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQVenueAccessTicketParametersBulkQuery,
        GQVenueAccessTicketParametersBulkQueryVariables
    > &
        (
            | {
                  variables: GQVenueAccessTicketParametersBulkQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQVenueAccessTicketParametersBulkQuery,
        GQVenueAccessTicketParametersBulkQueryVariables
    >(VenueAccessTicketParametersBulkDocument, options);
}
export function useVenueAccessTicketParametersBulkLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQVenueAccessTicketParametersBulkQuery,
        GQVenueAccessTicketParametersBulkQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQVenueAccessTicketParametersBulkQuery,
        GQVenueAccessTicketParametersBulkQueryVariables
    >(VenueAccessTicketParametersBulkDocument, options);
}
// @ts-ignore
export function useVenueAccessTicketParametersBulkSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQVenueAccessTicketParametersBulkQuery,
        GQVenueAccessTicketParametersBulkQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVenueAccessTicketParametersBulkQuery,
    GQVenueAccessTicketParametersBulkQueryVariables
>;
export function useVenueAccessTicketParametersBulkSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVenueAccessTicketParametersBulkQuery,
              GQVenueAccessTicketParametersBulkQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVenueAccessTicketParametersBulkQuery | undefined,
    GQVenueAccessTicketParametersBulkQueryVariables
>;
export function useVenueAccessTicketParametersBulkSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVenueAccessTicketParametersBulkQuery,
              GQVenueAccessTicketParametersBulkQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQVenueAccessTicketParametersBulkQuery,
        GQVenueAccessTicketParametersBulkQueryVariables
    >(VenueAccessTicketParametersBulkDocument, options);
}
export type VenueAccessTicketParametersBulkQueryHookResult = ReturnType<
    typeof useVenueAccessTicketParametersBulkQuery
>;
export type VenueAccessTicketParametersBulkLazyQueryHookResult = ReturnType<
    typeof useVenueAccessTicketParametersBulkLazyQuery
>;
export type VenueAccessTicketParametersBulkSuspenseQueryHookResult = ReturnType<
    typeof useVenueAccessTicketParametersBulkSuspenseQuery
>;
export type VenueAccessTicketParametersBulkQueryResult =
    ApolloReactCommon.QueryResult<
        GQVenueAccessTicketParametersBulkQuery,
        GQVenueAccessTicketParametersBulkQueryVariables
    >;
export const VenueAccessTicketParametersDocument = gql`
    query venueAccessTicketParameters($eventId: Int) {
        venueAccessTicketParameters(eventId: $eventId) {
            ...allAccessTicketFields
        }
    }
    ${AllAccessTicketFieldsFragmentDoc}
`;

/**
 * __useVenueAccessTicketParametersQuery__
 *
 * To run a query within a React component, call `useVenueAccessTicketParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueAccessTicketParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueAccessTicketParametersQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useVenueAccessTicketParametersQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQVenueAccessTicketParametersQuery,
        GQVenueAccessTicketParametersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQVenueAccessTicketParametersQuery,
        GQVenueAccessTicketParametersQueryVariables
    >(VenueAccessTicketParametersDocument, options);
}
export function useVenueAccessTicketParametersLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQVenueAccessTicketParametersQuery,
        GQVenueAccessTicketParametersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQVenueAccessTicketParametersQuery,
        GQVenueAccessTicketParametersQueryVariables
    >(VenueAccessTicketParametersDocument, options);
}
// @ts-ignore
export function useVenueAccessTicketParametersSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQVenueAccessTicketParametersQuery,
        GQVenueAccessTicketParametersQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVenueAccessTicketParametersQuery,
    GQVenueAccessTicketParametersQueryVariables
>;
export function useVenueAccessTicketParametersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVenueAccessTicketParametersQuery,
              GQVenueAccessTicketParametersQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVenueAccessTicketParametersQuery | undefined,
    GQVenueAccessTicketParametersQueryVariables
>;
export function useVenueAccessTicketParametersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVenueAccessTicketParametersQuery,
              GQVenueAccessTicketParametersQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQVenueAccessTicketParametersQuery,
        GQVenueAccessTicketParametersQueryVariables
    >(VenueAccessTicketParametersDocument, options);
}
export type VenueAccessTicketParametersQueryHookResult = ReturnType<
    typeof useVenueAccessTicketParametersQuery
>;
export type VenueAccessTicketParametersLazyQueryHookResult = ReturnType<
    typeof useVenueAccessTicketParametersLazyQuery
>;
export type VenueAccessTicketParametersSuspenseQueryHookResult = ReturnType<
    typeof useVenueAccessTicketParametersSuspenseQuery
>;
export type VenueAccessTicketParametersQueryResult =
    ApolloReactCommon.QueryResult<
        GQVenueAccessTicketParametersQuery,
        GQVenueAccessTicketParametersQueryVariables
    >;
export const LogsDocument = gql`
    query logs($pagination: PaginationInput, $searching: LogSearchInput) {
        logs(pagination: $pagination, searching: $searching) {
            data {
                ...logFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${LogFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useLogsQuery__
 *
 * To run a query within a React component, call `useLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useLogsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQLogsQuery,
        GQLogsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQLogsQuery, GQLogsQueryVariables>(
        LogsDocument,
        options
    );
}
export function useLogsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQLogsQuery,
        GQLogsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQLogsQuery, GQLogsQueryVariables>(
        LogsDocument,
        options
    );
}
// @ts-ignore
export function useLogsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQLogsQuery,
        GQLogsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQLogsQuery, GQLogsQueryVariables>;
export function useLogsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLogsQuery,
              GQLogsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLogsQuery | undefined,
    GQLogsQueryVariables
>;
export function useLogsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLogsQuery,
              GQLogsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<GQLogsQuery, GQLogsQueryVariables>(
        LogsDocument,
        options
    );
}
export type LogsQueryHookResult = ReturnType<typeof useLogsQuery>;
export type LogsLazyQueryHookResult = ReturnType<typeof useLogsLazyQuery>;
export type LogsSuspenseQueryHookResult = ReturnType<
    typeof useLogsSuspenseQuery
>;
export type LogsQueryResult = ApolloReactCommon.QueryResult<
    GQLogsQuery,
    GQLogsQueryVariables
>;
export const LogoDocument = gql`
    query logo($type: LogoType!) {
        logo(type: $type) {
            ...allLogoFields
        }
    }
    ${AllLogoFieldsFragmentDoc}
`;

/**
 * __useLogoQuery__
 *
 * To run a query within a React component, call `useLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogoQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLogoQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQLogoQuery,
        GQLogoQueryVariables
    > &
        (
            | { variables: GQLogoQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQLogoQuery, GQLogoQueryVariables>(
        LogoDocument,
        options
    );
}
export function useLogoLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQLogoQuery,
        GQLogoQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQLogoQuery, GQLogoQueryVariables>(
        LogoDocument,
        options
    );
}
// @ts-ignore
export function useLogoSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQLogoQuery,
        GQLogoQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQLogoQuery, GQLogoQueryVariables>;
export function useLogoSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLogoQuery,
              GQLogoQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLogoQuery | undefined,
    GQLogoQueryVariables
>;
export function useLogoSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLogoQuery,
              GQLogoQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<GQLogoQuery, GQLogoQueryVariables>(
        LogoDocument,
        options
    );
}
export type LogoQueryHookResult = ReturnType<typeof useLogoQuery>;
export type LogoLazyQueryHookResult = ReturnType<typeof useLogoLazyQuery>;
export type LogoSuspenseQueryHookResult = ReturnType<
    typeof useLogoSuspenseQuery
>;
export type LogoQueryResult = ApolloReactCommon.QueryResult<
    GQLogoQuery,
    GQLogoQueryVariables
>;
export const LogoSaveDocument = gql`
    mutation logoSave($logo: LogoInput!) {
        logoSave(logo: $logo) {
            ...allLogoFields
        }
    }
    ${AllLogoFieldsFragmentDoc}
`;
export type GQLogoSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQLogoSaveMutation,
    GQLogoSaveMutationVariables
>;

/**
 * __useLogoSaveMutation__
 *
 * To run a mutation, you first call `useLogoSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoSaveMutation, { data, loading, error }] = useLogoSaveMutation({
 *   variables: {
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useLogoSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQLogoSaveMutation,
        GQLogoSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQLogoSaveMutation,
        GQLogoSaveMutationVariables
    >(LogoSaveDocument, options);
}
export type LogoSaveMutationHookResult = ReturnType<typeof useLogoSaveMutation>;
export type LogoSaveMutationResult =
    ApolloReactCommon.MutationResult<GQLogoSaveMutation>;
export type LogoSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQLogoSaveMutation,
    GQLogoSaveMutationVariables
>;
export const LogoDeleteDocument = gql`
    mutation logoDelete($merchantId: ID!, $type: LogoType!) {
        logoDelete(merchantId: $merchantId, type: $type) {
            status
        }
    }
`;
export type GQLogoDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQLogoDeleteMutation,
    GQLogoDeleteMutationVariables
>;

/**
 * __useLogoDeleteMutation__
 *
 * To run a mutation, you first call `useLogoDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoDeleteMutation, { data, loading, error }] = useLogoDeleteMutation({
 *   variables: {
 *      merchantId: // value for 'merchantId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLogoDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQLogoDeleteMutation,
        GQLogoDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQLogoDeleteMutation,
        GQLogoDeleteMutationVariables
    >(LogoDeleteDocument, options);
}
export type LogoDeleteMutationHookResult = ReturnType<
    typeof useLogoDeleteMutation
>;
export type LogoDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQLogoDeleteMutation>;
export type LogoDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQLogoDeleteMutation,
    GQLogoDeleteMutationVariables
>;
export const MerchantsDocument = gql`
    query merchants(
        $pagination: PaginationInput
        $search: SearchInput
        $searching: MerchantSearchInput
    ) {
        merchants(
            pagination: $pagination
            search: $search
            searching: $searching
        ) {
            data {
                ...allMerchantFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllMerchantFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useMerchantsQuery__
 *
 * To run a query within a React component, call `useMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useMerchantsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQMerchantsQuery,
        GQMerchantsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQMerchantsQuery,
        GQMerchantsQueryVariables
    >(MerchantsDocument, options);
}
export function useMerchantsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQMerchantsQuery,
        GQMerchantsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQMerchantsQuery,
        GQMerchantsQueryVariables
    >(MerchantsDocument, options);
}
// @ts-ignore
export function useMerchantsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQMerchantsQuery,
        GQMerchantsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMerchantsQuery,
    GQMerchantsQueryVariables
>;
export function useMerchantsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMerchantsQuery,
              GQMerchantsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMerchantsQuery | undefined,
    GQMerchantsQueryVariables
>;
export function useMerchantsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMerchantsQuery,
              GQMerchantsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQMerchantsQuery,
        GQMerchantsQueryVariables
    >(MerchantsDocument, options);
}
export type MerchantsQueryHookResult = ReturnType<typeof useMerchantsQuery>;
export type MerchantsLazyQueryHookResult = ReturnType<
    typeof useMerchantsLazyQuery
>;
export type MerchantsSuspenseQueryHookResult = ReturnType<
    typeof useMerchantsSuspenseQuery
>;
export type MerchantsQueryResult = ApolloReactCommon.QueryResult<
    GQMerchantsQuery,
    GQMerchantsQueryVariables
>;
export const MerchantDocument = gql`
    query merchant($id: ID!) {
        merchant(id: $id) {
            ...allMerchantFields
        }
    }
    ${AllMerchantFieldsFragmentDoc}
`;

/**
 * __useMerchantQuery__
 *
 * To run a query within a React component, call `useMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQMerchantQuery,
        GQMerchantQueryVariables
    > &
        (
            | { variables: GQMerchantQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQMerchantQuery, GQMerchantQueryVariables>(
        MerchantDocument,
        options
    );
}
export function useMerchantLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQMerchantQuery,
        GQMerchantQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQMerchantQuery,
        GQMerchantQueryVariables
    >(MerchantDocument, options);
}
// @ts-ignore
export function useMerchantSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQMerchantQuery,
        GQMerchantQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMerchantQuery,
    GQMerchantQueryVariables
>;
export function useMerchantSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMerchantQuery,
              GQMerchantQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMerchantQuery | undefined,
    GQMerchantQueryVariables
>;
export function useMerchantSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMerchantQuery,
              GQMerchantQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQMerchantQuery,
        GQMerchantQueryVariables
    >(MerchantDocument, options);
}
export type MerchantQueryHookResult = ReturnType<typeof useMerchantQuery>;
export type MerchantLazyQueryHookResult = ReturnType<
    typeof useMerchantLazyQuery
>;
export type MerchantSuspenseQueryHookResult = ReturnType<
    typeof useMerchantSuspenseQuery
>;
export type MerchantQueryResult = ApolloReactCommon.QueryResult<
    GQMerchantQuery,
    GQMerchantQueryVariables
>;
export const MerchantCreateDocument = gql`
    mutation merchantCreate($merchant: MerchantCreate!) {
        merchantCreate(merchant: $merchant) {
            ...allMerchantFields
        }
    }
    ${AllMerchantFieldsFragmentDoc}
`;
export type GQMerchantCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQMerchantCreateMutation,
    GQMerchantCreateMutationVariables
>;

/**
 * __useMerchantCreateMutation__
 *
 * To run a mutation, you first call `useMerchantCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantCreateMutation, { data, loading, error }] = useMerchantCreateMutation({
 *   variables: {
 *      merchant: // value for 'merchant'
 *   },
 * });
 */
export function useMerchantCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQMerchantCreateMutation,
        GQMerchantCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQMerchantCreateMutation,
        GQMerchantCreateMutationVariables
    >(MerchantCreateDocument, options);
}
export type MerchantCreateMutationHookResult = ReturnType<
    typeof useMerchantCreateMutation
>;
export type MerchantCreateMutationResult =
    ApolloReactCommon.MutationResult<GQMerchantCreateMutation>;
export type MerchantCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQMerchantCreateMutation,
        GQMerchantCreateMutationVariables
    >;
export const MerchantSaveDocument = gql`
    mutation merchantSave($id: ID!, $merchant: MerchantInput!) {
        merchantSave(id: $id, merchant: $merchant) {
            ...allMerchantFields
        }
    }
    ${AllMerchantFieldsFragmentDoc}
`;
export type GQMerchantSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQMerchantSaveMutation,
    GQMerchantSaveMutationVariables
>;

/**
 * __useMerchantSaveMutation__
 *
 * To run a mutation, you first call `useMerchantSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantSaveMutation, { data, loading, error }] = useMerchantSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      merchant: // value for 'merchant'
 *   },
 * });
 */
export function useMerchantSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQMerchantSaveMutation,
        GQMerchantSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQMerchantSaveMutation,
        GQMerchantSaveMutationVariables
    >(MerchantSaveDocument, options);
}
export type MerchantSaveMutationHookResult = ReturnType<
    typeof useMerchantSaveMutation
>;
export type MerchantSaveMutationResult =
    ApolloReactCommon.MutationResult<GQMerchantSaveMutation>;
export type MerchantSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQMerchantSaveMutation,
    GQMerchantSaveMutationVariables
>;
export const MerchantDeleteDocument = gql`
    mutation merchantDelete($id: ID!) {
        merchantDelete(id: $id) {
            status
        }
    }
`;
export type GQMerchantDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQMerchantDeleteMutation,
    GQMerchantDeleteMutationVariables
>;

/**
 * __useMerchantDeleteMutation__
 *
 * To run a mutation, you first call `useMerchantDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantDeleteMutation, { data, loading, error }] = useMerchantDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQMerchantDeleteMutation,
        GQMerchantDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQMerchantDeleteMutation,
        GQMerchantDeleteMutationVariables
    >(MerchantDeleteDocument, options);
}
export type MerchantDeleteMutationHookResult = ReturnType<
    typeof useMerchantDeleteMutation
>;
export type MerchantDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQMerchantDeleteMutation>;
export type MerchantDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQMerchantDeleteMutation,
        GQMerchantDeleteMutationVariables
    >;
export const MerchantFormDocument = gql`
    query merchantForm {
        merchants(pagination: { pageSize: 999999 }) {
            data {
                id
                name
            }
        }
    }
`;

/**
 * __useMerchantFormQuery__
 *
 * To run a query within a React component, call `useMerchantFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useMerchantFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQMerchantFormQuery,
        GQMerchantFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQMerchantFormQuery,
        GQMerchantFormQueryVariables
    >(MerchantFormDocument, options);
}
export function useMerchantFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQMerchantFormQuery,
        GQMerchantFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQMerchantFormQuery,
        GQMerchantFormQueryVariables
    >(MerchantFormDocument, options);
}
// @ts-ignore
export function useMerchantFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQMerchantFormQuery,
        GQMerchantFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMerchantFormQuery,
    GQMerchantFormQueryVariables
>;
export function useMerchantFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMerchantFormQuery,
              GQMerchantFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMerchantFormQuery | undefined,
    GQMerchantFormQueryVariables
>;
export function useMerchantFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMerchantFormQuery,
              GQMerchantFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQMerchantFormQuery,
        GQMerchantFormQueryVariables
    >(MerchantFormDocument, options);
}
export type MerchantFormQueryHookResult = ReturnType<
    typeof useMerchantFormQuery
>;
export type MerchantFormLazyQueryHookResult = ReturnType<
    typeof useMerchantFormLazyQuery
>;
export type MerchantFormSuspenseQueryHookResult = ReturnType<
    typeof useMerchantFormSuspenseQuery
>;
export type MerchantFormQueryResult = ApolloReactCommon.QueryResult<
    GQMerchantFormQuery,
    GQMerchantFormQueryVariables
>;
export const AvailableLoginAsRolesDocument = gql`
    query availableLoginAsRoles($merchantId: ID!) {
        roles(
            pagination: { pageSize: 999999, sort: "name", sortDirection: "ASC" }
            merchantId: $merchantId
        ) {
            data {
                id
                name
            }
        }
    }
`;

/**
 * __useAvailableLoginAsRolesQuery__
 *
 * To run a query within a React component, call `useAvailableLoginAsRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableLoginAsRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableLoginAsRolesQuery({
 *   variables: {
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useAvailableLoginAsRolesQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQAvailableLoginAsRolesQuery,
        GQAvailableLoginAsRolesQueryVariables
    > &
        (
            | {
                  variables: GQAvailableLoginAsRolesQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAvailableLoginAsRolesQuery,
        GQAvailableLoginAsRolesQueryVariables
    >(AvailableLoginAsRolesDocument, options);
}
export function useAvailableLoginAsRolesLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAvailableLoginAsRolesQuery,
        GQAvailableLoginAsRolesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAvailableLoginAsRolesQuery,
        GQAvailableLoginAsRolesQueryVariables
    >(AvailableLoginAsRolesDocument, options);
}
// @ts-ignore
export function useAvailableLoginAsRolesSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAvailableLoginAsRolesQuery,
        GQAvailableLoginAsRolesQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAvailableLoginAsRolesQuery,
    GQAvailableLoginAsRolesQueryVariables
>;
export function useAvailableLoginAsRolesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAvailableLoginAsRolesQuery,
              GQAvailableLoginAsRolesQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAvailableLoginAsRolesQuery | undefined,
    GQAvailableLoginAsRolesQueryVariables
>;
export function useAvailableLoginAsRolesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAvailableLoginAsRolesQuery,
              GQAvailableLoginAsRolesQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAvailableLoginAsRolesQuery,
        GQAvailableLoginAsRolesQueryVariables
    >(AvailableLoginAsRolesDocument, options);
}
export type AvailableLoginAsRolesQueryHookResult = ReturnType<
    typeof useAvailableLoginAsRolesQuery
>;
export type AvailableLoginAsRolesLazyQueryHookResult = ReturnType<
    typeof useAvailableLoginAsRolesLazyQuery
>;
export type AvailableLoginAsRolesSuspenseQueryHookResult = ReturnType<
    typeof useAvailableLoginAsRolesSuspenseQuery
>;
export type AvailableLoginAsRolesQueryResult = ApolloReactCommon.QueryResult<
    GQAvailableLoginAsRolesQuery,
    GQAvailableLoginAsRolesQueryVariables
>;
export const AllMiscButtonsDocument = gql`
    query allMiscButtons($pagination: PaginationInput) {
        allMiscButtons(pagination: $pagination) {
            data {
                ...screenMiscButtonFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${ScreenMiscButtonFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useAllMiscButtonsQuery__
 *
 * To run a query within a React component, call `useAllMiscButtonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMiscButtonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMiscButtonsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllMiscButtonsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQAllMiscButtonsQuery,
        GQAllMiscButtonsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAllMiscButtonsQuery,
        GQAllMiscButtonsQueryVariables
    >(AllMiscButtonsDocument, options);
}
export function useAllMiscButtonsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAllMiscButtonsQuery,
        GQAllMiscButtonsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAllMiscButtonsQuery,
        GQAllMiscButtonsQueryVariables
    >(AllMiscButtonsDocument, options);
}
// @ts-ignore
export function useAllMiscButtonsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAllMiscButtonsQuery,
        GQAllMiscButtonsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAllMiscButtonsQuery,
    GQAllMiscButtonsQueryVariables
>;
export function useAllMiscButtonsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAllMiscButtonsQuery,
              GQAllMiscButtonsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAllMiscButtonsQuery | undefined,
    GQAllMiscButtonsQueryVariables
>;
export function useAllMiscButtonsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAllMiscButtonsQuery,
              GQAllMiscButtonsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAllMiscButtonsQuery,
        GQAllMiscButtonsQueryVariables
    >(AllMiscButtonsDocument, options);
}
export type AllMiscButtonsQueryHookResult = ReturnType<
    typeof useAllMiscButtonsQuery
>;
export type AllMiscButtonsLazyQueryHookResult = ReturnType<
    typeof useAllMiscButtonsLazyQuery
>;
export type AllMiscButtonsSuspenseQueryHookResult = ReturnType<
    typeof useAllMiscButtonsSuspenseQuery
>;
export type AllMiscButtonsQueryResult = ApolloReactCommon.QueryResult<
    GQAllMiscButtonsQuery,
    GQAllMiscButtonsQueryVariables
>;
export const MiscButtonsDocument = gql`
    query miscButtons($id: ID!) {
        miscButtons(id: $id) {
            ...screenMiscButtonFields
        }
    }
    ${ScreenMiscButtonFieldsFragmentDoc}
`;

/**
 * __useMiscButtonsQuery__
 *
 * To run a query within a React component, call `useMiscButtonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMiscButtonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMiscButtonsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMiscButtonsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQMiscButtonsQuery,
        GQMiscButtonsQueryVariables
    > &
        (
            | { variables: GQMiscButtonsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQMiscButtonsQuery,
        GQMiscButtonsQueryVariables
    >(MiscButtonsDocument, options);
}
export function useMiscButtonsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQMiscButtonsQuery,
        GQMiscButtonsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQMiscButtonsQuery,
        GQMiscButtonsQueryVariables
    >(MiscButtonsDocument, options);
}
// @ts-ignore
export function useMiscButtonsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQMiscButtonsQuery,
        GQMiscButtonsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMiscButtonsQuery,
    GQMiscButtonsQueryVariables
>;
export function useMiscButtonsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMiscButtonsQuery,
              GQMiscButtonsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMiscButtonsQuery | undefined,
    GQMiscButtonsQueryVariables
>;
export function useMiscButtonsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMiscButtonsQuery,
              GQMiscButtonsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQMiscButtonsQuery,
        GQMiscButtonsQueryVariables
    >(MiscButtonsDocument, options);
}
export type MiscButtonsQueryHookResult = ReturnType<typeof useMiscButtonsQuery>;
export type MiscButtonsLazyQueryHookResult = ReturnType<
    typeof useMiscButtonsLazyQuery
>;
export type MiscButtonsSuspenseQueryHookResult = ReturnType<
    typeof useMiscButtonsSuspenseQuery
>;
export type MiscButtonsQueryResult = ApolloReactCommon.QueryResult<
    GQMiscButtonsQuery,
    GQMiscButtonsQueryVariables
>;
export const MiscButtonsCreateDocument = gql`
    mutation miscButtonsCreate($miscButtons: MiscButtonsInput!) {
        miscButtonsCreate(miscButtons: $miscButtons) {
            ...screenMiscButtonFields
        }
    }
    ${ScreenMiscButtonFieldsFragmentDoc}
`;
export type GQMiscButtonsCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQMiscButtonsCreateMutation,
    GQMiscButtonsCreateMutationVariables
>;

/**
 * __useMiscButtonsCreateMutation__
 *
 * To run a mutation, you first call `useMiscButtonsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMiscButtonsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [miscButtonsCreateMutation, { data, loading, error }] = useMiscButtonsCreateMutation({
 *   variables: {
 *      miscButtons: // value for 'miscButtons'
 *   },
 * });
 */
export function useMiscButtonsCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQMiscButtonsCreateMutation,
        GQMiscButtonsCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQMiscButtonsCreateMutation,
        GQMiscButtonsCreateMutationVariables
    >(MiscButtonsCreateDocument, options);
}
export type MiscButtonsCreateMutationHookResult = ReturnType<
    typeof useMiscButtonsCreateMutation
>;
export type MiscButtonsCreateMutationResult =
    ApolloReactCommon.MutationResult<GQMiscButtonsCreateMutation>;
export type MiscButtonsCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQMiscButtonsCreateMutation,
        GQMiscButtonsCreateMutationVariables
    >;
export const MiscButtonsSaveDocument = gql`
    mutation miscButtonsSave($id: ID!, $miscButtons: MiscButtonsInput!) {
        miscButtonsSave(id: $id, miscButtons: $miscButtons) {
            ...screenMiscButtonFields
        }
    }
    ${ScreenMiscButtonFieldsFragmentDoc}
`;
export type GQMiscButtonsSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQMiscButtonsSaveMutation,
    GQMiscButtonsSaveMutationVariables
>;

/**
 * __useMiscButtonsSaveMutation__
 *
 * To run a mutation, you first call `useMiscButtonsSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMiscButtonsSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [miscButtonsSaveMutation, { data, loading, error }] = useMiscButtonsSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      miscButtons: // value for 'miscButtons'
 *   },
 * });
 */
export function useMiscButtonsSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQMiscButtonsSaveMutation,
        GQMiscButtonsSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQMiscButtonsSaveMutation,
        GQMiscButtonsSaveMutationVariables
    >(MiscButtonsSaveDocument, options);
}
export type MiscButtonsSaveMutationHookResult = ReturnType<
    typeof useMiscButtonsSaveMutation
>;
export type MiscButtonsSaveMutationResult =
    ApolloReactCommon.MutationResult<GQMiscButtonsSaveMutation>;
export type MiscButtonsSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQMiscButtonsSaveMutation,
        GQMiscButtonsSaveMutationVariables
    >;
export const MiscButtonsDeleteDocument = gql`
    mutation miscButtonsDelete($id: ID!) {
        miscButtonsDelete(id: $id) {
            status
        }
    }
`;
export type GQMiscButtonsDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQMiscButtonsDeleteMutation,
    GQMiscButtonsDeleteMutationVariables
>;

/**
 * __useMiscButtonsDeleteMutation__
 *
 * To run a mutation, you first call `useMiscButtonsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMiscButtonsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [miscButtonsDeleteMutation, { data, loading, error }] = useMiscButtonsDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMiscButtonsDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQMiscButtonsDeleteMutation,
        GQMiscButtonsDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQMiscButtonsDeleteMutation,
        GQMiscButtonsDeleteMutationVariables
    >(MiscButtonsDeleteDocument, options);
}
export type MiscButtonsDeleteMutationHookResult = ReturnType<
    typeof useMiscButtonsDeleteMutation
>;
export type MiscButtonsDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQMiscButtonsDeleteMutation>;
export type MiscButtonsDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQMiscButtonsDeleteMutation,
        GQMiscButtonsDeleteMutationVariables
    >;
export const PasswordResetTokenRedeemDocument = gql`
    query passwordResetTokenRedeem($token: String!) {
        passwordResetTokenRedeem(token: $token) {
            status
        }
    }
`;

/**
 * __usePasswordResetTokenRedeemQuery__
 *
 * To run a query within a React component, call `usePasswordResetTokenRedeemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetTokenRedeemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePasswordResetTokenRedeemQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePasswordResetTokenRedeemQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQPasswordResetTokenRedeemQuery,
        GQPasswordResetTokenRedeemQueryVariables
    > &
        (
            | {
                  variables: GQPasswordResetTokenRedeemQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQPasswordResetTokenRedeemQuery,
        GQPasswordResetTokenRedeemQueryVariables
    >(PasswordResetTokenRedeemDocument, options);
}
export function usePasswordResetTokenRedeemLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPasswordResetTokenRedeemQuery,
        GQPasswordResetTokenRedeemQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPasswordResetTokenRedeemQuery,
        GQPasswordResetTokenRedeemQueryVariables
    >(PasswordResetTokenRedeemDocument, options);
}
// @ts-ignore
export function usePasswordResetTokenRedeemSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPasswordResetTokenRedeemQuery,
        GQPasswordResetTokenRedeemQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPasswordResetTokenRedeemQuery,
    GQPasswordResetTokenRedeemQueryVariables
>;
export function usePasswordResetTokenRedeemSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPasswordResetTokenRedeemQuery,
              GQPasswordResetTokenRedeemQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPasswordResetTokenRedeemQuery | undefined,
    GQPasswordResetTokenRedeemQueryVariables
>;
export function usePasswordResetTokenRedeemSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPasswordResetTokenRedeemQuery,
              GQPasswordResetTokenRedeemQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPasswordResetTokenRedeemQuery,
        GQPasswordResetTokenRedeemQueryVariables
    >(PasswordResetTokenRedeemDocument, options);
}
export type PasswordResetTokenRedeemQueryHookResult = ReturnType<
    typeof usePasswordResetTokenRedeemQuery
>;
export type PasswordResetTokenRedeemLazyQueryHookResult = ReturnType<
    typeof usePasswordResetTokenRedeemLazyQuery
>;
export type PasswordResetTokenRedeemSuspenseQueryHookResult = ReturnType<
    typeof usePasswordResetTokenRedeemSuspenseQuery
>;
export type PasswordResetTokenRedeemQueryResult = ApolloReactCommon.QueryResult<
    GQPasswordResetTokenRedeemQuery,
    GQPasswordResetTokenRedeemQueryVariables
>;
export const PasswordResetRequestDocument = gql`
    mutation passwordResetRequest($email: String!) {
        passwordResetRequest(email: $email) {
            status
        }
    }
`;
export type GQPasswordResetRequestMutationFn =
    ApolloReactCommon.MutationFunction<
        GQPasswordResetRequestMutation,
        GQPasswordResetRequestMutationVariables
    >;

/**
 * __usePasswordResetRequestMutation__
 *
 * To run a mutation, you first call `usePasswordResetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetRequestMutation, { data, loading, error }] = usePasswordResetRequestMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePasswordResetRequestMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPasswordResetRequestMutation,
        GQPasswordResetRequestMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPasswordResetRequestMutation,
        GQPasswordResetRequestMutationVariables
    >(PasswordResetRequestDocument, options);
}
export type PasswordResetRequestMutationHookResult = ReturnType<
    typeof usePasswordResetRequestMutation
>;
export type PasswordResetRequestMutationResult =
    ApolloReactCommon.MutationResult<GQPasswordResetRequestMutation>;
export type PasswordResetRequestMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPasswordResetRequestMutation,
        GQPasswordResetRequestMutationVariables
    >;
export const PasswordResetTokenDeleteDocument = gql`
    mutation passwordResetTokenDelete($token: String!) {
        passwordResetTokenDelete(token: $token) {
            status
        }
    }
`;
export type GQPasswordResetTokenDeleteMutationFn =
    ApolloReactCommon.MutationFunction<
        GQPasswordResetTokenDeleteMutation,
        GQPasswordResetTokenDeleteMutationVariables
    >;

/**
 * __usePasswordResetTokenDeleteMutation__
 *
 * To run a mutation, you first call `usePasswordResetTokenDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetTokenDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetTokenDeleteMutation, { data, loading, error }] = usePasswordResetTokenDeleteMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePasswordResetTokenDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPasswordResetTokenDeleteMutation,
        GQPasswordResetTokenDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPasswordResetTokenDeleteMutation,
        GQPasswordResetTokenDeleteMutationVariables
    >(PasswordResetTokenDeleteDocument, options);
}
export type PasswordResetTokenDeleteMutationHookResult = ReturnType<
    typeof usePasswordResetTokenDeleteMutation
>;
export type PasswordResetTokenDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQPasswordResetTokenDeleteMutation>;
export type PasswordResetTokenDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPasswordResetTokenDeleteMutation,
        GQPasswordResetTokenDeleteMutationVariables
    >;
export const PasswordResetTokenUpdatePasswordDocument = gql`
    mutation passwordResetTokenUpdatePassword(
        $token: String!
        $password: String!
    ) {
        passwordResetTokenUpdatePassword(token: $token, password: $password) {
            status
        }
    }
`;
export type GQPasswordResetTokenUpdatePasswordMutationFn =
    ApolloReactCommon.MutationFunction<
        GQPasswordResetTokenUpdatePasswordMutation,
        GQPasswordResetTokenUpdatePasswordMutationVariables
    >;

/**
 * __usePasswordResetTokenUpdatePasswordMutation__
 *
 * To run a mutation, you first call `usePasswordResetTokenUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetTokenUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetTokenUpdatePasswordMutation, { data, loading, error }] = usePasswordResetTokenUpdatePasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function usePasswordResetTokenUpdatePasswordMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPasswordResetTokenUpdatePasswordMutation,
        GQPasswordResetTokenUpdatePasswordMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPasswordResetTokenUpdatePasswordMutation,
        GQPasswordResetTokenUpdatePasswordMutationVariables
    >(PasswordResetTokenUpdatePasswordDocument, options);
}
export type PasswordResetTokenUpdatePasswordMutationHookResult = ReturnType<
    typeof usePasswordResetTokenUpdatePasswordMutation
>;
export type PasswordResetTokenUpdatePasswordMutationResult =
    ApolloReactCommon.MutationResult<GQPasswordResetTokenUpdatePasswordMutation>;
export type PasswordResetTokenUpdatePasswordMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPasswordResetTokenUpdatePasswordMutation,
        GQPasswordResetTokenUpdatePasswordMutationVariables
    >;
export const PaymentConfigurationsDocument = gql`
    query paymentConfigurations($pagination: PaginationInput) {
        paymentConfigurations(pagination: $pagination) {
            data {
                ...allPaymentConfigurationFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllPaymentConfigurationFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __usePaymentConfigurationsQuery__
 *
 * To run a query within a React component, call `usePaymentConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentConfigurationsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaymentConfigurationsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQPaymentConfigurationsQuery,
        GQPaymentConfigurationsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQPaymentConfigurationsQuery,
        GQPaymentConfigurationsQueryVariables
    >(PaymentConfigurationsDocument, options);
}
export function usePaymentConfigurationsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPaymentConfigurationsQuery,
        GQPaymentConfigurationsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPaymentConfigurationsQuery,
        GQPaymentConfigurationsQueryVariables
    >(PaymentConfigurationsDocument, options);
}
// @ts-ignore
export function usePaymentConfigurationsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPaymentConfigurationsQuery,
        GQPaymentConfigurationsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentConfigurationsQuery,
    GQPaymentConfigurationsQueryVariables
>;
export function usePaymentConfigurationsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentConfigurationsQuery,
              GQPaymentConfigurationsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentConfigurationsQuery | undefined,
    GQPaymentConfigurationsQueryVariables
>;
export function usePaymentConfigurationsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentConfigurationsQuery,
              GQPaymentConfigurationsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPaymentConfigurationsQuery,
        GQPaymentConfigurationsQueryVariables
    >(PaymentConfigurationsDocument, options);
}
export type PaymentConfigurationsQueryHookResult = ReturnType<
    typeof usePaymentConfigurationsQuery
>;
export type PaymentConfigurationsLazyQueryHookResult = ReturnType<
    typeof usePaymentConfigurationsLazyQuery
>;
export type PaymentConfigurationsSuspenseQueryHookResult = ReturnType<
    typeof usePaymentConfigurationsSuspenseQuery
>;
export type PaymentConfigurationsQueryResult = ApolloReactCommon.QueryResult<
    GQPaymentConfigurationsQuery,
    GQPaymentConfigurationsQueryVariables
>;
export const PaymentConfigurationDocument = gql`
    query paymentConfiguration($id: ID!) {
        paymentConfiguration(id: $id) {
            ...allPaymentConfigurationFields
        }
    }
    ${AllPaymentConfigurationFieldsFragmentDoc}
`;

/**
 * __usePaymentConfigurationQuery__
 *
 * To run a query within a React component, call `usePaymentConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentConfigurationQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQPaymentConfigurationQuery,
        GQPaymentConfigurationQueryVariables
    > &
        (
            | {
                  variables: GQPaymentConfigurationQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQPaymentConfigurationQuery,
        GQPaymentConfigurationQueryVariables
    >(PaymentConfigurationDocument, options);
}
export function usePaymentConfigurationLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPaymentConfigurationQuery,
        GQPaymentConfigurationQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPaymentConfigurationQuery,
        GQPaymentConfigurationQueryVariables
    >(PaymentConfigurationDocument, options);
}
// @ts-ignore
export function usePaymentConfigurationSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPaymentConfigurationQuery,
        GQPaymentConfigurationQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentConfigurationQuery,
    GQPaymentConfigurationQueryVariables
>;
export function usePaymentConfigurationSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentConfigurationQuery,
              GQPaymentConfigurationQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentConfigurationQuery | undefined,
    GQPaymentConfigurationQueryVariables
>;
export function usePaymentConfigurationSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentConfigurationQuery,
              GQPaymentConfigurationQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPaymentConfigurationQuery,
        GQPaymentConfigurationQueryVariables
    >(PaymentConfigurationDocument, options);
}
export type PaymentConfigurationQueryHookResult = ReturnType<
    typeof usePaymentConfigurationQuery
>;
export type PaymentConfigurationLazyQueryHookResult = ReturnType<
    typeof usePaymentConfigurationLazyQuery
>;
export type PaymentConfigurationSuspenseQueryHookResult = ReturnType<
    typeof usePaymentConfigurationSuspenseQuery
>;
export type PaymentConfigurationQueryResult = ApolloReactCommon.QueryResult<
    GQPaymentConfigurationQuery,
    GQPaymentConfigurationQueryVariables
>;
export const PaymentConfigurationCreateDocument = gql`
    mutation paymentConfigurationCreate(
        $paymentConfiguration: PaymentConfigurationInput!
    ) {
        paymentConfigurationCreate(
            paymentConfiguration: $paymentConfiguration
        ) {
            ...allPaymentConfigurationFields
        }
    }
    ${AllPaymentConfigurationFieldsFragmentDoc}
`;
export type GQPaymentConfigurationCreateMutationFn =
    ApolloReactCommon.MutationFunction<
        GQPaymentConfigurationCreateMutation,
        GQPaymentConfigurationCreateMutationVariables
    >;

/**
 * __usePaymentConfigurationCreateMutation__
 *
 * To run a mutation, you first call `usePaymentConfigurationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentConfigurationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentConfigurationCreateMutation, { data, loading, error }] = usePaymentConfigurationCreateMutation({
 *   variables: {
 *      paymentConfiguration: // value for 'paymentConfiguration'
 *   },
 * });
 */
export function usePaymentConfigurationCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPaymentConfigurationCreateMutation,
        GQPaymentConfigurationCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPaymentConfigurationCreateMutation,
        GQPaymentConfigurationCreateMutationVariables
    >(PaymentConfigurationCreateDocument, options);
}
export type PaymentConfigurationCreateMutationHookResult = ReturnType<
    typeof usePaymentConfigurationCreateMutation
>;
export type PaymentConfigurationCreateMutationResult =
    ApolloReactCommon.MutationResult<GQPaymentConfigurationCreateMutation>;
export type PaymentConfigurationCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPaymentConfigurationCreateMutation,
        GQPaymentConfigurationCreateMutationVariables
    >;
export const PaymentConfigurationSaveDocument = gql`
    mutation paymentConfigurationSave(
        $id: ID!
        $paymentConfiguration: PaymentConfigurationInput!
    ) {
        paymentConfigurationSave(
            id: $id
            paymentConfiguration: $paymentConfiguration
        ) {
            ...allPaymentConfigurationFields
        }
    }
    ${AllPaymentConfigurationFieldsFragmentDoc}
`;
export type GQPaymentConfigurationSaveMutationFn =
    ApolloReactCommon.MutationFunction<
        GQPaymentConfigurationSaveMutation,
        GQPaymentConfigurationSaveMutationVariables
    >;

/**
 * __usePaymentConfigurationSaveMutation__
 *
 * To run a mutation, you first call `usePaymentConfigurationSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentConfigurationSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentConfigurationSaveMutation, { data, loading, error }] = usePaymentConfigurationSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentConfiguration: // value for 'paymentConfiguration'
 *   },
 * });
 */
export function usePaymentConfigurationSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPaymentConfigurationSaveMutation,
        GQPaymentConfigurationSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPaymentConfigurationSaveMutation,
        GQPaymentConfigurationSaveMutationVariables
    >(PaymentConfigurationSaveDocument, options);
}
export type PaymentConfigurationSaveMutationHookResult = ReturnType<
    typeof usePaymentConfigurationSaveMutation
>;
export type PaymentConfigurationSaveMutationResult =
    ApolloReactCommon.MutationResult<GQPaymentConfigurationSaveMutation>;
export type PaymentConfigurationSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPaymentConfigurationSaveMutation,
        GQPaymentConfigurationSaveMutationVariables
    >;
export const PaymentConfigurationDeleteDocument = gql`
    mutation paymentConfigurationDelete($id: ID!) {
        paymentConfigurationDelete(id: $id) {
            status
        }
    }
`;
export type GQPaymentConfigurationDeleteMutationFn =
    ApolloReactCommon.MutationFunction<
        GQPaymentConfigurationDeleteMutation,
        GQPaymentConfigurationDeleteMutationVariables
    >;

/**
 * __usePaymentConfigurationDeleteMutation__
 *
 * To run a mutation, you first call `usePaymentConfigurationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentConfigurationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentConfigurationDeleteMutation, { data, loading, error }] = usePaymentConfigurationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentConfigurationDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPaymentConfigurationDeleteMutation,
        GQPaymentConfigurationDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPaymentConfigurationDeleteMutation,
        GQPaymentConfigurationDeleteMutationVariables
    >(PaymentConfigurationDeleteDocument, options);
}
export type PaymentConfigurationDeleteMutationHookResult = ReturnType<
    typeof usePaymentConfigurationDeleteMutation
>;
export type PaymentConfigurationDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQPaymentConfigurationDeleteMutation>;
export type PaymentConfigurationDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPaymentConfigurationDeleteMutation,
        GQPaymentConfigurationDeleteMutationVariables
    >;
export const PaymentConfigurationFormDocument = gql`
    query paymentConfigurationForm {
        paymentMethods(pagination: { pageSize: 999999, sortDirection: "ASC" }) {
            data {
                id
                name
                enabled
            }
        }
    }
`;

/**
 * __usePaymentConfigurationFormQuery__
 *
 * To run a query within a React component, call `usePaymentConfigurationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentConfigurationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentConfigurationFormQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentConfigurationFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQPaymentConfigurationFormQuery,
        GQPaymentConfigurationFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQPaymentConfigurationFormQuery,
        GQPaymentConfigurationFormQueryVariables
    >(PaymentConfigurationFormDocument, options);
}
export function usePaymentConfigurationFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPaymentConfigurationFormQuery,
        GQPaymentConfigurationFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPaymentConfigurationFormQuery,
        GQPaymentConfigurationFormQueryVariables
    >(PaymentConfigurationFormDocument, options);
}
// @ts-ignore
export function usePaymentConfigurationFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPaymentConfigurationFormQuery,
        GQPaymentConfigurationFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentConfigurationFormQuery,
    GQPaymentConfigurationFormQueryVariables
>;
export function usePaymentConfigurationFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentConfigurationFormQuery,
              GQPaymentConfigurationFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentConfigurationFormQuery | undefined,
    GQPaymentConfigurationFormQueryVariables
>;
export function usePaymentConfigurationFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentConfigurationFormQuery,
              GQPaymentConfigurationFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPaymentConfigurationFormQuery,
        GQPaymentConfigurationFormQueryVariables
    >(PaymentConfigurationFormDocument, options);
}
export type PaymentConfigurationFormQueryHookResult = ReturnType<
    typeof usePaymentConfigurationFormQuery
>;
export type PaymentConfigurationFormLazyQueryHookResult = ReturnType<
    typeof usePaymentConfigurationFormLazyQuery
>;
export type PaymentConfigurationFormSuspenseQueryHookResult = ReturnType<
    typeof usePaymentConfigurationFormSuspenseQuery
>;
export type PaymentConfigurationFormQueryResult = ApolloReactCommon.QueryResult<
    GQPaymentConfigurationFormQuery,
    GQPaymentConfigurationFormQueryVariables
>;
export const PaymentMethodsDocument = gql`
    query paymentMethods($pagination: PaginationInput) {
        paymentMethods(pagination: $pagination) {
            data {
                ...allPaymentMethodFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllPaymentMethodFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaymentMethodsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQPaymentMethodsQuery,
        GQPaymentMethodsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQPaymentMethodsQuery,
        GQPaymentMethodsQueryVariables
    >(PaymentMethodsDocument, options);
}
export function usePaymentMethodsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPaymentMethodsQuery,
        GQPaymentMethodsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPaymentMethodsQuery,
        GQPaymentMethodsQueryVariables
    >(PaymentMethodsDocument, options);
}
// @ts-ignore
export function usePaymentMethodsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPaymentMethodsQuery,
        GQPaymentMethodsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentMethodsQuery,
    GQPaymentMethodsQueryVariables
>;
export function usePaymentMethodsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentMethodsQuery,
              GQPaymentMethodsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentMethodsQuery | undefined,
    GQPaymentMethodsQueryVariables
>;
export function usePaymentMethodsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentMethodsQuery,
              GQPaymentMethodsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPaymentMethodsQuery,
        GQPaymentMethodsQueryVariables
    >(PaymentMethodsDocument, options);
}
export type PaymentMethodsQueryHookResult = ReturnType<
    typeof usePaymentMethodsQuery
>;
export type PaymentMethodsLazyQueryHookResult = ReturnType<
    typeof usePaymentMethodsLazyQuery
>;
export type PaymentMethodsSuspenseQueryHookResult = ReturnType<
    typeof usePaymentMethodsSuspenseQuery
>;
export type PaymentMethodsQueryResult = ApolloReactCommon.QueryResult<
    GQPaymentMethodsQuery,
    GQPaymentMethodsQueryVariables
>;
export const PaymentMethodDocument = gql`
    query paymentMethod($id: ID!) {
        paymentMethod(id: $id) {
            ...allPaymentMethodFields
        }
    }
    ${AllPaymentMethodFieldsFragmentDoc}
`;

/**
 * __usePaymentMethodQuery__
 *
 * To run a query within a React component, call `usePaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentMethodQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQPaymentMethodQuery,
        GQPaymentMethodQueryVariables
    > &
        (
            | { variables: GQPaymentMethodQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQPaymentMethodQuery,
        GQPaymentMethodQueryVariables
    >(PaymentMethodDocument, options);
}
export function usePaymentMethodLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPaymentMethodQuery,
        GQPaymentMethodQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPaymentMethodQuery,
        GQPaymentMethodQueryVariables
    >(PaymentMethodDocument, options);
}
// @ts-ignore
export function usePaymentMethodSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPaymentMethodQuery,
        GQPaymentMethodQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentMethodQuery,
    GQPaymentMethodQueryVariables
>;
export function usePaymentMethodSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentMethodQuery,
              GQPaymentMethodQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentMethodQuery | undefined,
    GQPaymentMethodQueryVariables
>;
export function usePaymentMethodSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentMethodQuery,
              GQPaymentMethodQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPaymentMethodQuery,
        GQPaymentMethodQueryVariables
    >(PaymentMethodDocument, options);
}
export type PaymentMethodQueryHookResult = ReturnType<
    typeof usePaymentMethodQuery
>;
export type PaymentMethodLazyQueryHookResult = ReturnType<
    typeof usePaymentMethodLazyQuery
>;
export type PaymentMethodSuspenseQueryHookResult = ReturnType<
    typeof usePaymentMethodSuspenseQuery
>;
export type PaymentMethodQueryResult = ApolloReactCommon.QueryResult<
    GQPaymentMethodQuery,
    GQPaymentMethodQueryVariables
>;
export const PaymentMethodCreateDocument = gql`
    mutation paymentMethodCreate($paymentMethod: PaymentMethodInput!) {
        paymentMethodCreate(paymentMethod: $paymentMethod) {
            ...allPaymentMethodFields
        }
    }
    ${AllPaymentMethodFieldsFragmentDoc}
`;
export type GQPaymentMethodCreateMutationFn =
    ApolloReactCommon.MutationFunction<
        GQPaymentMethodCreateMutation,
        GQPaymentMethodCreateMutationVariables
    >;

/**
 * __usePaymentMethodCreateMutation__
 *
 * To run a mutation, you first call `usePaymentMethodCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodCreateMutation, { data, loading, error }] = usePaymentMethodCreateMutation({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function usePaymentMethodCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPaymentMethodCreateMutation,
        GQPaymentMethodCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPaymentMethodCreateMutation,
        GQPaymentMethodCreateMutationVariables
    >(PaymentMethodCreateDocument, options);
}
export type PaymentMethodCreateMutationHookResult = ReturnType<
    typeof usePaymentMethodCreateMutation
>;
export type PaymentMethodCreateMutationResult =
    ApolloReactCommon.MutationResult<GQPaymentMethodCreateMutation>;
export type PaymentMethodCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPaymentMethodCreateMutation,
        GQPaymentMethodCreateMutationVariables
    >;
export const PaymentMethodSaveDocument = gql`
    mutation paymentMethodSave($id: ID!, $paymentMethod: PaymentMethodInput!) {
        paymentMethodSave(id: $id, paymentMethod: $paymentMethod) {
            ...allPaymentMethodFields
        }
    }
    ${AllPaymentMethodFieldsFragmentDoc}
`;
export type GQPaymentMethodSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQPaymentMethodSaveMutation,
    GQPaymentMethodSaveMutationVariables
>;

/**
 * __usePaymentMethodSaveMutation__
 *
 * To run a mutation, you first call `usePaymentMethodSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodSaveMutation, { data, loading, error }] = usePaymentMethodSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function usePaymentMethodSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPaymentMethodSaveMutation,
        GQPaymentMethodSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPaymentMethodSaveMutation,
        GQPaymentMethodSaveMutationVariables
    >(PaymentMethodSaveDocument, options);
}
export type PaymentMethodSaveMutationHookResult = ReturnType<
    typeof usePaymentMethodSaveMutation
>;
export type PaymentMethodSaveMutationResult =
    ApolloReactCommon.MutationResult<GQPaymentMethodSaveMutation>;
export type PaymentMethodSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPaymentMethodSaveMutation,
        GQPaymentMethodSaveMutationVariables
    >;
export const PaymentMethodDeleteDocument = gql`
    mutation paymentMethodDelete($id: ID!) {
        paymentMethodDelete(id: $id) {
            status
        }
    }
`;
export type GQPaymentMethodDeleteMutationFn =
    ApolloReactCommon.MutationFunction<
        GQPaymentMethodDeleteMutation,
        GQPaymentMethodDeleteMutationVariables
    >;

/**
 * __usePaymentMethodDeleteMutation__
 *
 * To run a mutation, you first call `usePaymentMethodDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodDeleteMutation, { data, loading, error }] = usePaymentMethodDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentMethodDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPaymentMethodDeleteMutation,
        GQPaymentMethodDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPaymentMethodDeleteMutation,
        GQPaymentMethodDeleteMutationVariables
    >(PaymentMethodDeleteDocument, options);
}
export type PaymentMethodDeleteMutationHookResult = ReturnType<
    typeof usePaymentMethodDeleteMutation
>;
export type PaymentMethodDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQPaymentMethodDeleteMutation>;
export type PaymentMethodDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPaymentMethodDeleteMutation,
        GQPaymentMethodDeleteMutationVariables
    >;
export const PaymentMethodFormDocument = gql`
    query paymentMethodForm {
        currencies(pagination: { pageSize: 999999 }) {
            data {
                id
                code
            }
        }
    }
`;

/**
 * __usePaymentMethodFormQuery__
 *
 * To run a query within a React component, call `usePaymentMethodFormQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodFormQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQPaymentMethodFormQuery,
        GQPaymentMethodFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQPaymentMethodFormQuery,
        GQPaymentMethodFormQueryVariables
    >(PaymentMethodFormDocument, options);
}
export function usePaymentMethodFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPaymentMethodFormQuery,
        GQPaymentMethodFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPaymentMethodFormQuery,
        GQPaymentMethodFormQueryVariables
    >(PaymentMethodFormDocument, options);
}
// @ts-ignore
export function usePaymentMethodFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPaymentMethodFormQuery,
        GQPaymentMethodFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentMethodFormQuery,
    GQPaymentMethodFormQueryVariables
>;
export function usePaymentMethodFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentMethodFormQuery,
              GQPaymentMethodFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPaymentMethodFormQuery | undefined,
    GQPaymentMethodFormQueryVariables
>;
export function usePaymentMethodFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPaymentMethodFormQuery,
              GQPaymentMethodFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPaymentMethodFormQuery,
        GQPaymentMethodFormQueryVariables
    >(PaymentMethodFormDocument, options);
}
export type PaymentMethodFormQueryHookResult = ReturnType<
    typeof usePaymentMethodFormQuery
>;
export type PaymentMethodFormLazyQueryHookResult = ReturnType<
    typeof usePaymentMethodFormLazyQuery
>;
export type PaymentMethodFormSuspenseQueryHookResult = ReturnType<
    typeof usePaymentMethodFormSuspenseQuery
>;
export type PaymentMethodFormQueryResult = ApolloReactCommon.QueryResult<
    GQPaymentMethodFormQuery,
    GQPaymentMethodFormQueryVariables
>;
export const PrinterDocument = gql`
    query printer($id: ID!) {
        printer(id: $id) {
            ...printerScreenFields
        }
    }
    ${PrinterScreenFieldsFragmentDoc}
`;

/**
 * __usePrinterQuery__
 *
 * To run a query within a React component, call `usePrinterQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrinterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrinterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrinterQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQPrinterQuery,
        GQPrinterQueryVariables
    > &
        (
            | { variables: GQPrinterQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQPrinterQuery, GQPrinterQueryVariables>(
        PrinterDocument,
        options
    );
}
export function usePrinterLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPrinterQuery,
        GQPrinterQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPrinterQuery,
        GQPrinterQueryVariables
    >(PrinterDocument, options);
}
// @ts-ignore
export function usePrinterSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPrinterQuery,
        GQPrinterQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPrinterQuery,
    GQPrinterQueryVariables
>;
export function usePrinterSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPrinterQuery,
              GQPrinterQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPrinterQuery | undefined,
    GQPrinterQueryVariables
>;
export function usePrinterSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPrinterQuery,
              GQPrinterQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPrinterQuery,
        GQPrinterQueryVariables
    >(PrinterDocument, options);
}
export type PrinterQueryHookResult = ReturnType<typeof usePrinterQuery>;
export type PrinterLazyQueryHookResult = ReturnType<typeof usePrinterLazyQuery>;
export type PrinterSuspenseQueryHookResult = ReturnType<
    typeof usePrinterSuspenseQuery
>;
export type PrinterQueryResult = ApolloReactCommon.QueryResult<
    GQPrinterQuery,
    GQPrinterQueryVariables
>;
export const PrinterWithRelationsDocument = gql`
    query printerWithRelations($id: ID!) {
        printer(id: $id) {
            ...printerWithRelations
        }
    }
    ${PrinterWithRelationsFragmentDoc}
`;

/**
 * __usePrinterWithRelationsQuery__
 *
 * To run a query within a React component, call `usePrinterWithRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrinterWithRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrinterWithRelationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrinterWithRelationsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQPrinterWithRelationsQuery,
        GQPrinterWithRelationsQueryVariables
    > &
        (
            | {
                  variables: GQPrinterWithRelationsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQPrinterWithRelationsQuery,
        GQPrinterWithRelationsQueryVariables
    >(PrinterWithRelationsDocument, options);
}
export function usePrinterWithRelationsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPrinterWithRelationsQuery,
        GQPrinterWithRelationsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPrinterWithRelationsQuery,
        GQPrinterWithRelationsQueryVariables
    >(PrinterWithRelationsDocument, options);
}
// @ts-ignore
export function usePrinterWithRelationsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPrinterWithRelationsQuery,
        GQPrinterWithRelationsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPrinterWithRelationsQuery,
    GQPrinterWithRelationsQueryVariables
>;
export function usePrinterWithRelationsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPrinterWithRelationsQuery,
              GQPrinterWithRelationsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPrinterWithRelationsQuery | undefined,
    GQPrinterWithRelationsQueryVariables
>;
export function usePrinterWithRelationsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPrinterWithRelationsQuery,
              GQPrinterWithRelationsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPrinterWithRelationsQuery,
        GQPrinterWithRelationsQueryVariables
    >(PrinterWithRelationsDocument, options);
}
export type PrinterWithRelationsQueryHookResult = ReturnType<
    typeof usePrinterWithRelationsQuery
>;
export type PrinterWithRelationsLazyQueryHookResult = ReturnType<
    typeof usePrinterWithRelationsLazyQuery
>;
export type PrinterWithRelationsSuspenseQueryHookResult = ReturnType<
    typeof usePrinterWithRelationsSuspenseQuery
>;
export type PrinterWithRelationsQueryResult = ApolloReactCommon.QueryResult<
    GQPrinterWithRelationsQuery,
    GQPrinterWithRelationsQueryVariables
>;
export const PrintersDocument = gql`
    query printers(
        $pagination: PaginationInput
        $searching: PrinterSearchInput
    ) {
        printers(pagination: $pagination, searching: $searching) {
            data {
                ...printerScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${PrinterScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __usePrintersQuery__
 *
 * To run a query within a React component, call `usePrintersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function usePrintersQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQPrintersQuery,
        GQPrintersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQPrintersQuery, GQPrintersQueryVariables>(
        PrintersDocument,
        options
    );
}
export function usePrintersLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPrintersQuery,
        GQPrintersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPrintersQuery,
        GQPrintersQueryVariables
    >(PrintersDocument, options);
}
// @ts-ignore
export function usePrintersSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPrintersQuery,
        GQPrintersQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPrintersQuery,
    GQPrintersQueryVariables
>;
export function usePrintersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPrintersQuery,
              GQPrintersQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPrintersQuery | undefined,
    GQPrintersQueryVariables
>;
export function usePrintersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPrintersQuery,
              GQPrintersQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPrintersQuery,
        GQPrintersQueryVariables
    >(PrintersDocument, options);
}
export type PrintersQueryHookResult = ReturnType<typeof usePrintersQuery>;
export type PrintersLazyQueryHookResult = ReturnType<
    typeof usePrintersLazyQuery
>;
export type PrintersSuspenseQueryHookResult = ReturnType<
    typeof usePrintersSuspenseQuery
>;
export type PrintersQueryResult = ApolloReactCommon.QueryResult<
    GQPrintersQuery,
    GQPrintersQueryVariables
>;
export const PrintersForCashRegisterDocument = gql`
    query printersForCashRegister(
        $pagination: PaginationInput
        $class: String
        $entityId: String
    ) {
        printersForCashRegister(
            pagination: $pagination
            class: $class
            entityId: $entityId
        ) {
            data {
                ...printerScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${PrinterScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __usePrintersForCashRegisterQuery__
 *
 * To run a query within a React component, call `usePrintersForCashRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintersForCashRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintersForCashRegisterQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      class: // value for 'class'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function usePrintersForCashRegisterQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQPrintersForCashRegisterQuery,
        GQPrintersForCashRegisterQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQPrintersForCashRegisterQuery,
        GQPrintersForCashRegisterQueryVariables
    >(PrintersForCashRegisterDocument, options);
}
export function usePrintersForCashRegisterLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQPrintersForCashRegisterQuery,
        GQPrintersForCashRegisterQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQPrintersForCashRegisterQuery,
        GQPrintersForCashRegisterQueryVariables
    >(PrintersForCashRegisterDocument, options);
}
// @ts-ignore
export function usePrintersForCashRegisterSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQPrintersForCashRegisterQuery,
        GQPrintersForCashRegisterQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPrintersForCashRegisterQuery,
    GQPrintersForCashRegisterQueryVariables
>;
export function usePrintersForCashRegisterSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPrintersForCashRegisterQuery,
              GQPrintersForCashRegisterQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQPrintersForCashRegisterQuery | undefined,
    GQPrintersForCashRegisterQueryVariables
>;
export function usePrintersForCashRegisterSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQPrintersForCashRegisterQuery,
              GQPrintersForCashRegisterQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQPrintersForCashRegisterQuery,
        GQPrintersForCashRegisterQueryVariables
    >(PrintersForCashRegisterDocument, options);
}
export type PrintersForCashRegisterQueryHookResult = ReturnType<
    typeof usePrintersForCashRegisterQuery
>;
export type PrintersForCashRegisterLazyQueryHookResult = ReturnType<
    typeof usePrintersForCashRegisterLazyQuery
>;
export type PrintersForCashRegisterSuspenseQueryHookResult = ReturnType<
    typeof usePrintersForCashRegisterSuspenseQuery
>;
export type PrintersForCashRegisterQueryResult = ApolloReactCommon.QueryResult<
    GQPrintersForCashRegisterQuery,
    GQPrintersForCashRegisterQueryVariables
>;
export const PrinterRegisterDocument = gql`
    mutation printerRegister($printer: PrinterRegister!) {
        printerRegister(printer: $printer) {
            name
            serial
            type
            manufacturer
            class
        }
    }
`;
export type GQPrinterRegisterMutationFn = ApolloReactCommon.MutationFunction<
    GQPrinterRegisterMutation,
    GQPrinterRegisterMutationVariables
>;

/**
 * __usePrinterRegisterMutation__
 *
 * To run a mutation, you first call `usePrinterRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrinterRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printerRegisterMutation, { data, loading, error }] = usePrinterRegisterMutation({
 *   variables: {
 *      printer: // value for 'printer'
 *   },
 * });
 */
export function usePrinterRegisterMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPrinterRegisterMutation,
        GQPrinterRegisterMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPrinterRegisterMutation,
        GQPrinterRegisterMutationVariables
    >(PrinterRegisterDocument, options);
}
export type PrinterRegisterMutationHookResult = ReturnType<
    typeof usePrinterRegisterMutation
>;
export type PrinterRegisterMutationResult =
    ApolloReactCommon.MutationResult<GQPrinterRegisterMutation>;
export type PrinterRegisterMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPrinterRegisterMutation,
        GQPrinterRegisterMutationVariables
    >;
export const PrinterSaveDocument = gql`
    mutation printerSave($id: ID!, $printer: PrinterSave!) {
        printerSave(id: $id, printer: $printer) {
            id
            name
        }
    }
`;
export type GQPrinterSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQPrinterSaveMutation,
    GQPrinterSaveMutationVariables
>;

/**
 * __usePrinterSaveMutation__
 *
 * To run a mutation, you first call `usePrinterSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrinterSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printerSaveMutation, { data, loading, error }] = usePrinterSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      printer: // value for 'printer'
 *   },
 * });
 */
export function usePrinterSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPrinterSaveMutation,
        GQPrinterSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPrinterSaveMutation,
        GQPrinterSaveMutationVariables
    >(PrinterSaveDocument, options);
}
export type PrinterSaveMutationHookResult = ReturnType<
    typeof usePrinterSaveMutation
>;
export type PrinterSaveMutationResult =
    ApolloReactCommon.MutationResult<GQPrinterSaveMutation>;
export type PrinterSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQPrinterSaveMutation,
    GQPrinterSaveMutationVariables
>;
export const PrinterDeleteDocument = gql`
    mutation printerDelete($id: ID!) {
        printerDelete(id: $id) {
            status
        }
    }
`;
export type GQPrinterDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQPrinterDeleteMutation,
    GQPrinterDeleteMutationVariables
>;

/**
 * __usePrinterDeleteMutation__
 *
 * To run a mutation, you first call `usePrinterDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrinterDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printerDeleteMutation, { data, loading, error }] = usePrinterDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrinterDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQPrinterDeleteMutation,
        GQPrinterDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQPrinterDeleteMutation,
        GQPrinterDeleteMutationVariables
    >(PrinterDeleteDocument, options);
}
export type PrinterDeleteMutationHookResult = ReturnType<
    typeof usePrinterDeleteMutation
>;
export type PrinterDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQPrinterDeleteMutation>;
export type PrinterDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQPrinterDeleteMutation,
        GQPrinterDeleteMutationVariables
    >;
export const ProductGroupsDocument = gql`
    query productGroups(
        $pagination: PaginationInput
        $searching: ProductGroupSearchInput
    ) {
        productGroups(pagination: $pagination, searching: $searching) {
            data {
                ...allProductGroupFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllProductGroupFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useProductGroupsQuery__
 *
 * To run a query within a React component, call `useProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useProductGroupsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQProductGroupsQuery,
        GQProductGroupsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQProductGroupsQuery,
        GQProductGroupsQueryVariables
    >(ProductGroupsDocument, options);
}
export function useProductGroupsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQProductGroupsQuery,
        GQProductGroupsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQProductGroupsQuery,
        GQProductGroupsQueryVariables
    >(ProductGroupsDocument, options);
}
// @ts-ignore
export function useProductGroupsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQProductGroupsQuery,
        GQProductGroupsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductGroupsQuery,
    GQProductGroupsQueryVariables
>;
export function useProductGroupsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductGroupsQuery,
              GQProductGroupsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductGroupsQuery | undefined,
    GQProductGroupsQueryVariables
>;
export function useProductGroupsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductGroupsQuery,
              GQProductGroupsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQProductGroupsQuery,
        GQProductGroupsQueryVariables
    >(ProductGroupsDocument, options);
}
export type ProductGroupsQueryHookResult = ReturnType<
    typeof useProductGroupsQuery
>;
export type ProductGroupsLazyQueryHookResult = ReturnType<
    typeof useProductGroupsLazyQuery
>;
export type ProductGroupsSuspenseQueryHookResult = ReturnType<
    typeof useProductGroupsSuspenseQuery
>;
export type ProductGroupsQueryResult = ApolloReactCommon.QueryResult<
    GQProductGroupsQuery,
    GQProductGroupsQueryVariables
>;
export const ProductGroupDocument = gql`
    query productGroup($id: ID!) {
        productGroup(id: $id) {
            ...allProductGroupFields
        }
    }
    ${AllProductGroupFieldsFragmentDoc}
`;

/**
 * __useProductGroupQuery__
 *
 * To run a query within a React component, call `useProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductGroupQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQProductGroupQuery,
        GQProductGroupQueryVariables
    > &
        (
            | { variables: GQProductGroupQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQProductGroupQuery,
        GQProductGroupQueryVariables
    >(ProductGroupDocument, options);
}
export function useProductGroupLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQProductGroupQuery,
        GQProductGroupQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQProductGroupQuery,
        GQProductGroupQueryVariables
    >(ProductGroupDocument, options);
}
// @ts-ignore
export function useProductGroupSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQProductGroupQuery,
        GQProductGroupQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductGroupQuery,
    GQProductGroupQueryVariables
>;
export function useProductGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductGroupQuery,
              GQProductGroupQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductGroupQuery | undefined,
    GQProductGroupQueryVariables
>;
export function useProductGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductGroupQuery,
              GQProductGroupQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQProductGroupQuery,
        GQProductGroupQueryVariables
    >(ProductGroupDocument, options);
}
export type ProductGroupQueryHookResult = ReturnType<
    typeof useProductGroupQuery
>;
export type ProductGroupLazyQueryHookResult = ReturnType<
    typeof useProductGroupLazyQuery
>;
export type ProductGroupSuspenseQueryHookResult = ReturnType<
    typeof useProductGroupSuspenseQuery
>;
export type ProductGroupQueryResult = ApolloReactCommon.QueryResult<
    GQProductGroupQuery,
    GQProductGroupQueryVariables
>;
export const ProductGroupCreateDocument = gql`
    mutation productGroupCreate($productGroup: ProductGroupInput!) {
        productGroupCreate(productGroup: $productGroup) {
            ...allProductGroupFields
        }
    }
    ${AllProductGroupFieldsFragmentDoc}
`;
export type GQProductGroupCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQProductGroupCreateMutation,
    GQProductGroupCreateMutationVariables
>;

/**
 * __useProductGroupCreateMutation__
 *
 * To run a mutation, you first call `useProductGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productGroupCreateMutation, { data, loading, error }] = useProductGroupCreateMutation({
 *   variables: {
 *      productGroup: // value for 'productGroup'
 *   },
 * });
 */
export function useProductGroupCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQProductGroupCreateMutation,
        GQProductGroupCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQProductGroupCreateMutation,
        GQProductGroupCreateMutationVariables
    >(ProductGroupCreateDocument, options);
}
export type ProductGroupCreateMutationHookResult = ReturnType<
    typeof useProductGroupCreateMutation
>;
export type ProductGroupCreateMutationResult =
    ApolloReactCommon.MutationResult<GQProductGroupCreateMutation>;
export type ProductGroupCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQProductGroupCreateMutation,
        GQProductGroupCreateMutationVariables
    >;
export const ProductGroupSaveDocument = gql`
    mutation productGroupSave($id: ID!, $productGroup: ProductGroupInput!) {
        productGroupSave(id: $id, productGroup: $productGroup) {
            ...allProductGroupFields
        }
    }
    ${AllProductGroupFieldsFragmentDoc}
`;
export type GQProductGroupSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQProductGroupSaveMutation,
    GQProductGroupSaveMutationVariables
>;

/**
 * __useProductGroupSaveMutation__
 *
 * To run a mutation, you first call `useProductGroupSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductGroupSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productGroupSaveMutation, { data, loading, error }] = useProductGroupSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productGroup: // value for 'productGroup'
 *   },
 * });
 */
export function useProductGroupSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQProductGroupSaveMutation,
        GQProductGroupSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQProductGroupSaveMutation,
        GQProductGroupSaveMutationVariables
    >(ProductGroupSaveDocument, options);
}
export type ProductGroupSaveMutationHookResult = ReturnType<
    typeof useProductGroupSaveMutation
>;
export type ProductGroupSaveMutationResult =
    ApolloReactCommon.MutationResult<GQProductGroupSaveMutation>;
export type ProductGroupSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQProductGroupSaveMutation,
        GQProductGroupSaveMutationVariables
    >;
export const ProductGroupDeleteDocument = gql`
    mutation productGroupDelete($id: ID!) {
        productGroupDelete(id: $id) {
            status
        }
    }
`;
export type GQProductGroupDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQProductGroupDeleteMutation,
    GQProductGroupDeleteMutationVariables
>;

/**
 * __useProductGroupDeleteMutation__
 *
 * To run a mutation, you first call `useProductGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productGroupDeleteMutation, { data, loading, error }] = useProductGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductGroupDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQProductGroupDeleteMutation,
        GQProductGroupDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQProductGroupDeleteMutation,
        GQProductGroupDeleteMutationVariables
    >(ProductGroupDeleteDocument, options);
}
export type ProductGroupDeleteMutationHookResult = ReturnType<
    typeof useProductGroupDeleteMutation
>;
export type ProductGroupDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQProductGroupDeleteMutation>;
export type ProductGroupDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQProductGroupDeleteMutation,
        GQProductGroupDeleteMutationVariables
    >;
export const SetInventoryProductQuantityDocument = gql`
    mutation setInventoryProductQuantity(
        $id: ID
        $productId: ID!
        $quantity: Int!
        $note: String
    ) {
        setInventoryProductQuantity(
            id: $id
            productId: $productId
            quantity: $quantity
            note: $note
        ) {
            id
            quantity
        }
    }
`;
export type GQSetInventoryProductQuantityMutationFn =
    ApolloReactCommon.MutationFunction<
        GQSetInventoryProductQuantityMutation,
        GQSetInventoryProductQuantityMutationVariables
    >;

/**
 * __useSetInventoryProductQuantityMutation__
 *
 * To run a mutation, you first call `useSetInventoryProductQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInventoryProductQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInventoryProductQuantityMutation, { data, loading, error }] = useSetInventoryProductQuantityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      quantity: // value for 'quantity'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSetInventoryProductQuantityMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQSetInventoryProductQuantityMutation,
        GQSetInventoryProductQuantityMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQSetInventoryProductQuantityMutation,
        GQSetInventoryProductQuantityMutationVariables
    >(SetInventoryProductQuantityDocument, options);
}
export type SetInventoryProductQuantityMutationHookResult = ReturnType<
    typeof useSetInventoryProductQuantityMutation
>;
export type SetInventoryProductQuantityMutationResult =
    ApolloReactCommon.MutationResult<GQSetInventoryProductQuantityMutation>;
export type SetInventoryProductQuantityMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQSetInventoryProductQuantityMutation,
        GQSetInventoryProductQuantityMutationVariables
    >;
export const InventoryProductNoteTemplatesDocument = gql`
    query inventoryProductNoteTemplates($pagination: PaginationInput) {
        inventoryProductNoteTemplates(pagination: $pagination) {
            data {
                ...allInventoryProductNoteTemplateFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllInventoryProductNoteTemplateFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useInventoryProductNoteTemplatesQuery__
 *
 * To run a query within a React component, call `useInventoryProductNoteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryProductNoteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryProductNoteTemplatesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useInventoryProductNoteTemplatesQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQInventoryProductNoteTemplatesQuery,
        GQInventoryProductNoteTemplatesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQInventoryProductNoteTemplatesQuery,
        GQInventoryProductNoteTemplatesQueryVariables
    >(InventoryProductNoteTemplatesDocument, options);
}
export function useInventoryProductNoteTemplatesLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQInventoryProductNoteTemplatesQuery,
        GQInventoryProductNoteTemplatesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQInventoryProductNoteTemplatesQuery,
        GQInventoryProductNoteTemplatesQueryVariables
    >(InventoryProductNoteTemplatesDocument, options);
}
// @ts-ignore
export function useInventoryProductNoteTemplatesSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQInventoryProductNoteTemplatesQuery,
        GQInventoryProductNoteTemplatesQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInventoryProductNoteTemplatesQuery,
    GQInventoryProductNoteTemplatesQueryVariables
>;
export function useInventoryProductNoteTemplatesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInventoryProductNoteTemplatesQuery,
              GQInventoryProductNoteTemplatesQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInventoryProductNoteTemplatesQuery | undefined,
    GQInventoryProductNoteTemplatesQueryVariables
>;
export function useInventoryProductNoteTemplatesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInventoryProductNoteTemplatesQuery,
              GQInventoryProductNoteTemplatesQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQInventoryProductNoteTemplatesQuery,
        GQInventoryProductNoteTemplatesQueryVariables
    >(InventoryProductNoteTemplatesDocument, options);
}
export type InventoryProductNoteTemplatesQueryHookResult = ReturnType<
    typeof useInventoryProductNoteTemplatesQuery
>;
export type InventoryProductNoteTemplatesLazyQueryHookResult = ReturnType<
    typeof useInventoryProductNoteTemplatesLazyQuery
>;
export type InventoryProductNoteTemplatesSuspenseQueryHookResult = ReturnType<
    typeof useInventoryProductNoteTemplatesSuspenseQuery
>;
export type InventoryProductNoteTemplatesQueryResult =
    ApolloReactCommon.QueryResult<
        GQInventoryProductNoteTemplatesQuery,
        GQInventoryProductNoteTemplatesQueryVariables
    >;
export const InventoryProductNoteTemplateDocument = gql`
    query inventoryProductNoteTemplate($id: ID!) {
        inventoryProductNoteTemplate(id: $id) {
            ...allInventoryProductNoteTemplateFields
        }
    }
    ${AllInventoryProductNoteTemplateFieldsFragmentDoc}
`;

/**
 * __useInventoryProductNoteTemplateQuery__
 *
 * To run a query within a React component, call `useInventoryProductNoteTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryProductNoteTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryProductNoteTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInventoryProductNoteTemplateQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQInventoryProductNoteTemplateQuery,
        GQInventoryProductNoteTemplateQueryVariables
    > &
        (
            | {
                  variables: GQInventoryProductNoteTemplateQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQInventoryProductNoteTemplateQuery,
        GQInventoryProductNoteTemplateQueryVariables
    >(InventoryProductNoteTemplateDocument, options);
}
export function useInventoryProductNoteTemplateLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQInventoryProductNoteTemplateQuery,
        GQInventoryProductNoteTemplateQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQInventoryProductNoteTemplateQuery,
        GQInventoryProductNoteTemplateQueryVariables
    >(InventoryProductNoteTemplateDocument, options);
}
// @ts-ignore
export function useInventoryProductNoteTemplateSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQInventoryProductNoteTemplateQuery,
        GQInventoryProductNoteTemplateQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInventoryProductNoteTemplateQuery,
    GQInventoryProductNoteTemplateQueryVariables
>;
export function useInventoryProductNoteTemplateSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInventoryProductNoteTemplateQuery,
              GQInventoryProductNoteTemplateQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInventoryProductNoteTemplateQuery | undefined,
    GQInventoryProductNoteTemplateQueryVariables
>;
export function useInventoryProductNoteTemplateSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInventoryProductNoteTemplateQuery,
              GQInventoryProductNoteTemplateQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQInventoryProductNoteTemplateQuery,
        GQInventoryProductNoteTemplateQueryVariables
    >(InventoryProductNoteTemplateDocument, options);
}
export type InventoryProductNoteTemplateQueryHookResult = ReturnType<
    typeof useInventoryProductNoteTemplateQuery
>;
export type InventoryProductNoteTemplateLazyQueryHookResult = ReturnType<
    typeof useInventoryProductNoteTemplateLazyQuery
>;
export type InventoryProductNoteTemplateSuspenseQueryHookResult = ReturnType<
    typeof useInventoryProductNoteTemplateSuspenseQuery
>;
export type InventoryProductNoteTemplateQueryResult =
    ApolloReactCommon.QueryResult<
        GQInventoryProductNoteTemplateQuery,
        GQInventoryProductNoteTemplateQueryVariables
    >;
export const InventoryProductNoteTemplateCreateDocument = gql`
    mutation inventoryProductNoteTemplateCreate(
        $inventoryProductNoteTemplate: InventoryProductNoteTemplateCreate!
    ) {
        inventoryProductNoteTemplateCreate(
            inventoryProductNoteTemplate: $inventoryProductNoteTemplate
        ) {
            ...allInventoryProductNoteTemplateFields
        }
    }
    ${AllInventoryProductNoteTemplateFieldsFragmentDoc}
`;
export type GQInventoryProductNoteTemplateCreateMutationFn =
    ApolloReactCommon.MutationFunction<
        GQInventoryProductNoteTemplateCreateMutation,
        GQInventoryProductNoteTemplateCreateMutationVariables
    >;

/**
 * __useInventoryProductNoteTemplateCreateMutation__
 *
 * To run a mutation, you first call `useInventoryProductNoteTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryProductNoteTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryProductNoteTemplateCreateMutation, { data, loading, error }] = useInventoryProductNoteTemplateCreateMutation({
 *   variables: {
 *      inventoryProductNoteTemplate: // value for 'inventoryProductNoteTemplate'
 *   },
 * });
 */
export function useInventoryProductNoteTemplateCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQInventoryProductNoteTemplateCreateMutation,
        GQInventoryProductNoteTemplateCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQInventoryProductNoteTemplateCreateMutation,
        GQInventoryProductNoteTemplateCreateMutationVariables
    >(InventoryProductNoteTemplateCreateDocument, options);
}
export type InventoryProductNoteTemplateCreateMutationHookResult = ReturnType<
    typeof useInventoryProductNoteTemplateCreateMutation
>;
export type InventoryProductNoteTemplateCreateMutationResult =
    ApolloReactCommon.MutationResult<GQInventoryProductNoteTemplateCreateMutation>;
export type InventoryProductNoteTemplateCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQInventoryProductNoteTemplateCreateMutation,
        GQInventoryProductNoteTemplateCreateMutationVariables
    >;
export const InventoryProductNoteTemplateSaveDocument = gql`
    mutation inventoryProductNoteTemplateSave(
        $id: ID!
        $inventoryProductNoteTemplate: InventoryProductNoteTemplateInput!
    ) {
        inventoryProductNoteTemplateSave(
            id: $id
            inventoryProductNoteTemplate: $inventoryProductNoteTemplate
        ) {
            ...allInventoryProductNoteTemplateFields
        }
    }
    ${AllInventoryProductNoteTemplateFieldsFragmentDoc}
`;
export type GQInventoryProductNoteTemplateSaveMutationFn =
    ApolloReactCommon.MutationFunction<
        GQInventoryProductNoteTemplateSaveMutation,
        GQInventoryProductNoteTemplateSaveMutationVariables
    >;

/**
 * __useInventoryProductNoteTemplateSaveMutation__
 *
 * To run a mutation, you first call `useInventoryProductNoteTemplateSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryProductNoteTemplateSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryProductNoteTemplateSaveMutation, { data, loading, error }] = useInventoryProductNoteTemplateSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inventoryProductNoteTemplate: // value for 'inventoryProductNoteTemplate'
 *   },
 * });
 */
export function useInventoryProductNoteTemplateSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQInventoryProductNoteTemplateSaveMutation,
        GQInventoryProductNoteTemplateSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQInventoryProductNoteTemplateSaveMutation,
        GQInventoryProductNoteTemplateSaveMutationVariables
    >(InventoryProductNoteTemplateSaveDocument, options);
}
export type InventoryProductNoteTemplateSaveMutationHookResult = ReturnType<
    typeof useInventoryProductNoteTemplateSaveMutation
>;
export type InventoryProductNoteTemplateSaveMutationResult =
    ApolloReactCommon.MutationResult<GQInventoryProductNoteTemplateSaveMutation>;
export type InventoryProductNoteTemplateSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQInventoryProductNoteTemplateSaveMutation,
        GQInventoryProductNoteTemplateSaveMutationVariables
    >;
export const InventoryProductNoteTemplateDeleteDocument = gql`
    mutation inventoryProductNoteTemplateDelete($id: ID!) {
        inventoryProductNoteTemplateDelete(id: $id) {
            status
        }
    }
`;
export type GQInventoryProductNoteTemplateDeleteMutationFn =
    ApolloReactCommon.MutationFunction<
        GQInventoryProductNoteTemplateDeleteMutation,
        GQInventoryProductNoteTemplateDeleteMutationVariables
    >;

/**
 * __useInventoryProductNoteTemplateDeleteMutation__
 *
 * To run a mutation, you first call `useInventoryProductNoteTemplateDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryProductNoteTemplateDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryProductNoteTemplateDeleteMutation, { data, loading, error }] = useInventoryProductNoteTemplateDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInventoryProductNoteTemplateDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQInventoryProductNoteTemplateDeleteMutation,
        GQInventoryProductNoteTemplateDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQInventoryProductNoteTemplateDeleteMutation,
        GQInventoryProductNoteTemplateDeleteMutationVariables
    >(InventoryProductNoteTemplateDeleteDocument, options);
}
export type InventoryProductNoteTemplateDeleteMutationHookResult = ReturnType<
    typeof useInventoryProductNoteTemplateDeleteMutation
>;
export type InventoryProductNoteTemplateDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQInventoryProductNoteTemplateDeleteMutation>;
export type InventoryProductNoteTemplateDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQInventoryProductNoteTemplateDeleteMutation,
        GQInventoryProductNoteTemplateDeleteMutationVariables
    >;
export const ProductsDocument = gql`
    query products(
        $pagination: PaginationInput
        $includeChildren: Boolean
        $includeInactive: Boolean
        $searching: ProductSearchInput
    ) {
        products(
            pagination: $pagination
            includeChildren: $includeChildren
            includeInactive: $includeInactive
            searching: $searching
        ) {
            data {
                ...allProductFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllProductFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      includeChildren: // value for 'includeChildren'
 *      includeInactive: // value for 'includeInactive'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useProductsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQProductsQuery,
        GQProductsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQProductsQuery, GQProductsQueryVariables>(
        ProductsDocument,
        options
    );
}
export function useProductsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQProductsQuery,
        GQProductsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQProductsQuery,
        GQProductsQueryVariables
    >(ProductsDocument, options);
}
// @ts-ignore
export function useProductsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQProductsQuery,
        GQProductsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductsQuery,
    GQProductsQueryVariables
>;
export function useProductsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductsQuery,
              GQProductsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductsQuery | undefined,
    GQProductsQueryVariables
>;
export function useProductsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductsQuery,
              GQProductsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQProductsQuery,
        GQProductsQueryVariables
    >(ProductsDocument, options);
}
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<
    typeof useProductsLazyQuery
>;
export type ProductsSuspenseQueryHookResult = ReturnType<
    typeof useProductsSuspenseQuery
>;
export type ProductsQueryResult = ApolloReactCommon.QueryResult<
    GQProductsQuery,
    GQProductsQueryVariables
>;
export const ProductDocument = gql`
    query product($id: ID!) {
        product(id: $id) {
            ...allProductFields
            children(
                pagination: {
                    pageSize: 999999
                    sort: "name"
                    sortDirection: "ASC"
                }
            ) {
                ...productChildrenListFields
            }
        }
    }
    ${AllProductFieldsFragmentDoc}
    ${ProductChildrenListFieldsFragmentDoc}
`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQProductQuery,
        GQProductQueryVariables
    > &
        (
            | { variables: GQProductQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQProductQuery, GQProductQueryVariables>(
        ProductDocument,
        options
    );
}
export function useProductLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQProductQuery,
        GQProductQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQProductQuery,
        GQProductQueryVariables
    >(ProductDocument, options);
}
// @ts-ignore
export function useProductSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQProductQuery,
        GQProductQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductQuery,
    GQProductQueryVariables
>;
export function useProductSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductQuery,
              GQProductQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductQuery | undefined,
    GQProductQueryVariables
>;
export function useProductSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductQuery,
              GQProductQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQProductQuery,
        GQProductQueryVariables
    >(ProductDocument, options);
}
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductSuspenseQueryHookResult = ReturnType<
    typeof useProductSuspenseQuery
>;
export type ProductQueryResult = ApolloReactCommon.QueryResult<
    GQProductQuery,
    GQProductQueryVariables
>;
export const ProductCreateDocument = gql`
    mutation productCreate($product: ProductInput!) {
        productCreate(product: $product) {
            ...allProductFields
        }
    }
    ${AllProductFieldsFragmentDoc}
`;
export type GQProductCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQProductCreateMutation,
    GQProductCreateMutationVariables
>;

/**
 * __useProductCreateMutation__
 *
 * To run a mutation, you first call `useProductCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productCreateMutation, { data, loading, error }] = useProductCreateMutation({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useProductCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQProductCreateMutation,
        GQProductCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQProductCreateMutation,
        GQProductCreateMutationVariables
    >(ProductCreateDocument, options);
}
export type ProductCreateMutationHookResult = ReturnType<
    typeof useProductCreateMutation
>;
export type ProductCreateMutationResult =
    ApolloReactCommon.MutationResult<GQProductCreateMutation>;
export type ProductCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQProductCreateMutation,
        GQProductCreateMutationVariables
    >;
export const ProductSaveDocument = gql`
    mutation productSave($id: ID!, $product: ProductInput!) {
        productSave(id: $id, product: $product) {
            ...allProductFields
        }
    }
    ${AllProductFieldsFragmentDoc}
`;
export type GQProductSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQProductSaveMutation,
    GQProductSaveMutationVariables
>;

/**
 * __useProductSaveMutation__
 *
 * To run a mutation, you first call `useProductSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productSaveMutation, { data, loading, error }] = useProductSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useProductSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQProductSaveMutation,
        GQProductSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQProductSaveMutation,
        GQProductSaveMutationVariables
    >(ProductSaveDocument, options);
}
export type ProductSaveMutationHookResult = ReturnType<
    typeof useProductSaveMutation
>;
export type ProductSaveMutationResult =
    ApolloReactCommon.MutationResult<GQProductSaveMutation>;
export type ProductSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQProductSaveMutation,
    GQProductSaveMutationVariables
>;
export const ProductDeleteDocument = gql`
    mutation productDelete($id: ID!) {
        productDelete(id: $id) {
            status
        }
    }
`;
export type GQProductDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQProductDeleteMutation,
    GQProductDeleteMutationVariables
>;

/**
 * __useProductDeleteMutation__
 *
 * To run a mutation, you first call `useProductDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productDeleteMutation, { data, loading, error }] = useProductDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQProductDeleteMutation,
        GQProductDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQProductDeleteMutation,
        GQProductDeleteMutationVariables
    >(ProductDeleteDocument, options);
}
export type ProductDeleteMutationHookResult = ReturnType<
    typeof useProductDeleteMutation
>;
export type ProductDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQProductDeleteMutation>;
export type ProductDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQProductDeleteMutation,
        GQProductDeleteMutationVariables
    >;
export const ProductsDeleteDocument = gql`
    mutation productsDelete($ids: [ID!]!) {
        productsDelete(ids: $ids) {
            status
        }
    }
`;
export type GQProductsDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQProductsDeleteMutation,
    GQProductsDeleteMutationVariables
>;

/**
 * __useProductsDeleteMutation__
 *
 * To run a mutation, you first call `useProductsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productsDeleteMutation, { data, loading, error }] = useProductsDeleteMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useProductsDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQProductsDeleteMutation,
        GQProductsDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQProductsDeleteMutation,
        GQProductsDeleteMutationVariables
    >(ProductsDeleteDocument, options);
}
export type ProductsDeleteMutationHookResult = ReturnType<
    typeof useProductsDeleteMutation
>;
export type ProductsDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQProductsDeleteMutation>;
export type ProductsDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQProductsDeleteMutation,
        GQProductsDeleteMutationVariables
    >;
export const IsProductPluInUseDocument = gql`
    query isProductPluInUse($plu: Int!, $productId: ID) {
        isProductPluInUse(plu: $plu, productId: $productId) {
            status
        }
    }
`;

/**
 * __useIsProductPluInUseQuery__
 *
 * To run a query within a React component, call `useIsProductPluInUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsProductPluInUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsProductPluInUseQuery({
 *   variables: {
 *      plu: // value for 'plu'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useIsProductPluInUseQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQIsProductPluInUseQuery,
        GQIsProductPluInUseQueryVariables
    > &
        (
            | { variables: GQIsProductPluInUseQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQIsProductPluInUseQuery,
        GQIsProductPluInUseQueryVariables
    >(IsProductPluInUseDocument, options);
}
export function useIsProductPluInUseLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQIsProductPluInUseQuery,
        GQIsProductPluInUseQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQIsProductPluInUseQuery,
        GQIsProductPluInUseQueryVariables
    >(IsProductPluInUseDocument, options);
}
// @ts-ignore
export function useIsProductPluInUseSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQIsProductPluInUseQuery,
        GQIsProductPluInUseQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIsProductPluInUseQuery,
    GQIsProductPluInUseQueryVariables
>;
export function useIsProductPluInUseSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIsProductPluInUseQuery,
              GQIsProductPluInUseQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQIsProductPluInUseQuery | undefined,
    GQIsProductPluInUseQueryVariables
>;
export function useIsProductPluInUseSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQIsProductPluInUseQuery,
              GQIsProductPluInUseQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQIsProductPluInUseQuery,
        GQIsProductPluInUseQueryVariables
    >(IsProductPluInUseDocument, options);
}
export type IsProductPluInUseQueryHookResult = ReturnType<
    typeof useIsProductPluInUseQuery
>;
export type IsProductPluInUseLazyQueryHookResult = ReturnType<
    typeof useIsProductPluInUseLazyQuery
>;
export type IsProductPluInUseSuspenseQueryHookResult = ReturnType<
    typeof useIsProductPluInUseSuspenseQuery
>;
export type IsProductPluInUseQueryResult = ApolloReactCommon.QueryResult<
    GQIsProductPluInUseQuery,
    GQIsProductPluInUseQueryVariables
>;
export const ProductFormDocument = gql`
    query productForm {
        products(
            includeChildren: true
            pagination: { pageSize: 99999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
            }
        }
        productGroups(
            pagination: { pageSize: 9999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
                vat {
                    id
                }
            }
        }
        vats(pagination: { pageSize: 99, sort: "name", sortDirection: "ASC" }) {
            data {
                id
                name
                percentage
            }
        }
        printers(
            pagination: { pageSize: 999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
                type
                class
            }
        }
        virtualPrinters(
            pagination: { pageSize: 999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
            }
        }
    }
`;

/**
 * __useProductFormQuery__
 *
 * To run a query within a React component, call `useProductFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQProductFormQuery,
        GQProductFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQProductFormQuery,
        GQProductFormQueryVariables
    >(ProductFormDocument, options);
}
export function useProductFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQProductFormQuery,
        GQProductFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQProductFormQuery,
        GQProductFormQueryVariables
    >(ProductFormDocument, options);
}
// @ts-ignore
export function useProductFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQProductFormQuery,
        GQProductFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductFormQuery,
    GQProductFormQueryVariables
>;
export function useProductFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductFormQuery,
              GQProductFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQProductFormQuery | undefined,
    GQProductFormQueryVariables
>;
export function useProductFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQProductFormQuery,
              GQProductFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQProductFormQuery,
        GQProductFormQueryVariables
    >(ProductFormDocument, options);
}
export type ProductFormQueryHookResult = ReturnType<typeof useProductFormQuery>;
export type ProductFormLazyQueryHookResult = ReturnType<
    typeof useProductFormLazyQuery
>;
export type ProductFormSuspenseQueryHookResult = ReturnType<
    typeof useProductFormSuspenseQuery
>;
export type ProductFormQueryResult = ApolloReactCommon.QueryResult<
    GQProductFormQuery,
    GQProductFormQueryVariables
>;
export const ViProductsDocument = gql`
    query viProducts($pagination: PaginationInput) {
        viProducts(pagination: $pagination) {
            data {
                ...allViProductFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllViProductFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useViProductsQuery__
 *
 * To run a query within a React component, call `useViProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViProductsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useViProductsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQViProductsQuery,
        GQViProductsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQViProductsQuery,
        GQViProductsQueryVariables
    >(ViProductsDocument, options);
}
export function useViProductsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQViProductsQuery,
        GQViProductsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQViProductsQuery,
        GQViProductsQueryVariables
    >(ViProductsDocument, options);
}
// @ts-ignore
export function useViProductsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQViProductsQuery,
        GQViProductsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQViProductsQuery,
    GQViProductsQueryVariables
>;
export function useViProductsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQViProductsQuery,
              GQViProductsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQViProductsQuery | undefined,
    GQViProductsQueryVariables
>;
export function useViProductsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQViProductsQuery,
              GQViProductsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQViProductsQuery,
        GQViProductsQueryVariables
    >(ViProductsDocument, options);
}
export type ViProductsQueryHookResult = ReturnType<typeof useViProductsQuery>;
export type ViProductsLazyQueryHookResult = ReturnType<
    typeof useViProductsLazyQuery
>;
export type ViProductsSuspenseQueryHookResult = ReturnType<
    typeof useViProductsSuspenseQuery
>;
export type ViProductsQueryResult = ApolloReactCommon.QueryResult<
    GQViProductsQuery,
    GQViProductsQueryVariables
>;
export const GetProduct2ViProduct2MeasurementUnitDocument = gql`
    query getProduct2ViProduct2MeasurementUnit($productId: ID!) {
        getProduct2ViProduct2MeasurementUnit(productId: $productId) {
            viProduct {
                id
                name
                deletedAt
            }
            value
            measurementUnit {
                id
                name
                deletedAt
            }
            deletedAt
        }
    }
`;

/**
 * __useGetProduct2ViProduct2MeasurementUnitQuery__
 *
 * To run a query within a React component, call `useGetProduct2ViProduct2MeasurementUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProduct2ViProduct2MeasurementUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProduct2ViProduct2MeasurementUnitQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProduct2ViProduct2MeasurementUnitQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQGetProduct2ViProduct2MeasurementUnitQuery,
        GQGetProduct2ViProduct2MeasurementUnitQueryVariables
    > &
        (
            | {
                  variables: GQGetProduct2ViProduct2MeasurementUnitQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQGetProduct2ViProduct2MeasurementUnitQuery,
        GQGetProduct2ViProduct2MeasurementUnitQueryVariables
    >(GetProduct2ViProduct2MeasurementUnitDocument, options);
}
export function useGetProduct2ViProduct2MeasurementUnitLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQGetProduct2ViProduct2MeasurementUnitQuery,
        GQGetProduct2ViProduct2MeasurementUnitQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQGetProduct2ViProduct2MeasurementUnitQuery,
        GQGetProduct2ViProduct2MeasurementUnitQueryVariables
    >(GetProduct2ViProduct2MeasurementUnitDocument, options);
}
// @ts-ignore
export function useGetProduct2ViProduct2MeasurementUnitSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQGetProduct2ViProduct2MeasurementUnitQuery,
        GQGetProduct2ViProduct2MeasurementUnitQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQGetProduct2ViProduct2MeasurementUnitQuery,
    GQGetProduct2ViProduct2MeasurementUnitQueryVariables
>;
export function useGetProduct2ViProduct2MeasurementUnitSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQGetProduct2ViProduct2MeasurementUnitQuery,
              GQGetProduct2ViProduct2MeasurementUnitQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQGetProduct2ViProduct2MeasurementUnitQuery | undefined,
    GQGetProduct2ViProduct2MeasurementUnitQueryVariables
>;
export function useGetProduct2ViProduct2MeasurementUnitSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQGetProduct2ViProduct2MeasurementUnitQuery,
              GQGetProduct2ViProduct2MeasurementUnitQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQGetProduct2ViProduct2MeasurementUnitQuery,
        GQGetProduct2ViProduct2MeasurementUnitQueryVariables
    >(GetProduct2ViProduct2MeasurementUnitDocument, options);
}
export type GetProduct2ViProduct2MeasurementUnitQueryHookResult = ReturnType<
    typeof useGetProduct2ViProduct2MeasurementUnitQuery
>;
export type GetProduct2ViProduct2MeasurementUnitLazyQueryHookResult =
    ReturnType<typeof useGetProduct2ViProduct2MeasurementUnitLazyQuery>;
export type GetProduct2ViProduct2MeasurementUnitSuspenseQueryHookResult =
    ReturnType<typeof useGetProduct2ViProduct2MeasurementUnitSuspenseQuery>;
export type GetProduct2ViProduct2MeasurementUnitQueryResult =
    ApolloReactCommon.QueryResult<
        GQGetProduct2ViProduct2MeasurementUnitQuery,
        GQGetProduct2ViProduct2MeasurementUnitQueryVariables
    >;
export const SetProduct2ViProduct2MeasurementUnitDocument = gql`
    mutation setProduct2ViProduct2MeasurementUnit(
        $productId: ID!
        $relations: [Product2ViProduct2MeasurementUnitInput!]!
    ) {
        setProduct2ViProduct2MeasurementUnit(
            productId: $productId
            relations: $relations
        ) {
            status
        }
    }
`;
export type GQSetProduct2ViProduct2MeasurementUnitMutationFn =
    ApolloReactCommon.MutationFunction<
        GQSetProduct2ViProduct2MeasurementUnitMutation,
        GQSetProduct2ViProduct2MeasurementUnitMutationVariables
    >;

/**
 * __useSetProduct2ViProduct2MeasurementUnitMutation__
 *
 * To run a mutation, you first call `useSetProduct2ViProduct2MeasurementUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProduct2ViProduct2MeasurementUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProduct2ViProduct2MeasurementUnitMutation, { data, loading, error }] = useSetProduct2ViProduct2MeasurementUnitMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      relations: // value for 'relations'
 *   },
 * });
 */
export function useSetProduct2ViProduct2MeasurementUnitMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQSetProduct2ViProduct2MeasurementUnitMutation,
        GQSetProduct2ViProduct2MeasurementUnitMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQSetProduct2ViProduct2MeasurementUnitMutation,
        GQSetProduct2ViProduct2MeasurementUnitMutationVariables
    >(SetProduct2ViProduct2MeasurementUnitDocument, options);
}
export type SetProduct2ViProduct2MeasurementUnitMutationHookResult = ReturnType<
    typeof useSetProduct2ViProduct2MeasurementUnitMutation
>;
export type SetProduct2ViProduct2MeasurementUnitMutationResult =
    ApolloReactCommon.MutationResult<GQSetProduct2ViProduct2MeasurementUnitMutation>;
export type SetProduct2ViProduct2MeasurementUnitMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQSetProduct2ViProduct2MeasurementUnitMutation,
        GQSetProduct2ViProduct2MeasurementUnitMutationVariables
    >;
export const UpdateViProductsDocument = gql`
    mutation updateViProducts {
        updateViProducts {
            status
        }
    }
`;
export type GQUpdateViProductsMutationFn = ApolloReactCommon.MutationFunction<
    GQUpdateViProductsMutation,
    GQUpdateViProductsMutationVariables
>;

/**
 * __useUpdateViProductsMutation__
 *
 * To run a mutation, you first call `useUpdateViProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateViProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateViProductsMutation, { data, loading, error }] = useUpdateViProductsMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateViProductsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQUpdateViProductsMutation,
        GQUpdateViProductsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQUpdateViProductsMutation,
        GQUpdateViProductsMutationVariables
    >(UpdateViProductsDocument, options);
}
export type UpdateViProductsMutationHookResult = ReturnType<
    typeof useUpdateViProductsMutation
>;
export type UpdateViProductsMutationResult =
    ApolloReactCommon.MutationResult<GQUpdateViProductsMutation>;
export type UpdateViProductsMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQUpdateViProductsMutation,
        GQUpdateViProductsMutationVariables
    >;
export const ReportFormDocument = gql`
    query reportForm {
        reportParameters {
            ...reportFields
        }
    }
    ${ReportFieldsFragmentDoc}
`;

/**
 * __useReportFormQuery__
 *
 * To run a query within a React component, call `useReportFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQReportFormQuery,
        GQReportFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQReportFormQuery,
        GQReportFormQueryVariables
    >(ReportFormDocument, options);
}
export function useReportFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQReportFormQuery,
        GQReportFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQReportFormQuery,
        GQReportFormQueryVariables
    >(ReportFormDocument, options);
}
// @ts-ignore
export function useReportFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQReportFormQuery,
        GQReportFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQReportFormQuery,
    GQReportFormQueryVariables
>;
export function useReportFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQReportFormQuery,
              GQReportFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQReportFormQuery | undefined,
    GQReportFormQueryVariables
>;
export function useReportFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQReportFormQuery,
              GQReportFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQReportFormQuery,
        GQReportFormQueryVariables
    >(ReportFormDocument, options);
}
export type ReportFormQueryHookResult = ReturnType<typeof useReportFormQuery>;
export type ReportFormLazyQueryHookResult = ReturnType<
    typeof useReportFormLazyQuery
>;
export type ReportFormSuspenseQueryHookResult = ReturnType<
    typeof useReportFormSuspenseQuery
>;
export type ReportFormQueryResult = ApolloReactCommon.QueryResult<
    GQReportFormQuery,
    GQReportFormQueryVariables
>;
export const SaftJobsDocument = gql`
    query saftJobs($pagination: PaginationInput) {
        saftJobs(pagination: $pagination) {
            data {
                ...saftJobFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${SaftJobFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useSaftJobsQuery__
 *
 * To run a query within a React component, call `useSaftJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaftJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaftJobsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSaftJobsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQSaftJobsQuery,
        GQSaftJobsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQSaftJobsQuery, GQSaftJobsQueryVariables>(
        SaftJobsDocument,
        options
    );
}
export function useSaftJobsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQSaftJobsQuery,
        GQSaftJobsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQSaftJobsQuery,
        GQSaftJobsQueryVariables
    >(SaftJobsDocument, options);
}
// @ts-ignore
export function useSaftJobsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQSaftJobsQuery,
        GQSaftJobsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSaftJobsQuery,
    GQSaftJobsQueryVariables
>;
export function useSaftJobsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSaftJobsQuery,
              GQSaftJobsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSaftJobsQuery | undefined,
    GQSaftJobsQueryVariables
>;
export function useSaftJobsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSaftJobsQuery,
              GQSaftJobsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQSaftJobsQuery,
        GQSaftJobsQueryVariables
    >(SaftJobsDocument, options);
}
export type SaftJobsQueryHookResult = ReturnType<typeof useSaftJobsQuery>;
export type SaftJobsLazyQueryHookResult = ReturnType<
    typeof useSaftJobsLazyQuery
>;
export type SaftJobsSuspenseQueryHookResult = ReturnType<
    typeof useSaftJobsSuspenseQuery
>;
export type SaftJobsQueryResult = ApolloReactCommon.QueryResult<
    GQSaftJobsQuery,
    GQSaftJobsQueryVariables
>;
export const RebuildSaftJobsDocument = gql`
    mutation rebuildSaftJobs($shiftIds: [ID!]!) {
        rebuildSaftJobs(shiftIds: $shiftIds) {
            status
        }
    }
`;
export type GQRebuildSaftJobsMutationFn = ApolloReactCommon.MutationFunction<
    GQRebuildSaftJobsMutation,
    GQRebuildSaftJobsMutationVariables
>;

/**
 * __useRebuildSaftJobsMutation__
 *
 * To run a mutation, you first call `useRebuildSaftJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRebuildSaftJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rebuildSaftJobsMutation, { data, loading, error }] = useRebuildSaftJobsMutation({
 *   variables: {
 *      shiftIds: // value for 'shiftIds'
 *   },
 * });
 */
export function useRebuildSaftJobsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQRebuildSaftJobsMutation,
        GQRebuildSaftJobsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQRebuildSaftJobsMutation,
        GQRebuildSaftJobsMutationVariables
    >(RebuildSaftJobsDocument, options);
}
export type RebuildSaftJobsMutationHookResult = ReturnType<
    typeof useRebuildSaftJobsMutation
>;
export type RebuildSaftJobsMutationResult =
    ApolloReactCommon.MutationResult<GQRebuildSaftJobsMutation>;
export type RebuildSaftJobsMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQRebuildSaftJobsMutation,
        GQRebuildSaftJobsMutationVariables
    >;
export const ShiftsDocument = gql`
    query shifts($pagination: PaginationInput, $searching: ShiftSearchInput) {
        shifts(pagination: $pagination, searching: $searching) {
            data {
                ...allShiftFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllShiftFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useShiftsQuery__
 *
 * To run a query within a React component, call `useShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useShiftsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQShiftsQuery,
        GQShiftsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQShiftsQuery, GQShiftsQueryVariables>(
        ShiftsDocument,
        options
    );
}
export function useShiftsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQShiftsQuery,
        GQShiftsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQShiftsQuery, GQShiftsQueryVariables>(
        ShiftsDocument,
        options
    );
}
// @ts-ignore
export function useShiftsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQShiftsQuery,
        GQShiftsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQShiftsQuery,
    GQShiftsQueryVariables
>;
export function useShiftsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQShiftsQuery,
              GQShiftsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQShiftsQuery | undefined,
    GQShiftsQueryVariables
>;
export function useShiftsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQShiftsQuery,
              GQShiftsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQShiftsQuery,
        GQShiftsQueryVariables
    >(ShiftsDocument, options);
}
export type ShiftsQueryHookResult = ReturnType<typeof useShiftsQuery>;
export type ShiftsLazyQueryHookResult = ReturnType<typeof useShiftsLazyQuery>;
export type ShiftsSuspenseQueryHookResult = ReturnType<
    typeof useShiftsSuspenseQuery
>;
export type ShiftsQueryResult = ApolloReactCommon.QueryResult<
    GQShiftsQuery,
    GQShiftsQueryVariables
>;
export const ShiftDocument = gql`
    query shift($id: ID!) {
        shift(id: $id) {
            ...allShiftFields
        }
    }
    ${AllShiftFieldsFragmentDoc}
`;

/**
 * __useShiftQuery__
 *
 * To run a query within a React component, call `useShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShiftQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQShiftQuery,
        GQShiftQueryVariables
    > &
        (
            | { variables: GQShiftQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQShiftQuery, GQShiftQueryVariables>(
        ShiftDocument,
        options
    );
}
export function useShiftLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQShiftQuery,
        GQShiftQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQShiftQuery, GQShiftQueryVariables>(
        ShiftDocument,
        options
    );
}
// @ts-ignore
export function useShiftSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQShiftQuery,
        GQShiftQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQShiftQuery, GQShiftQueryVariables>;
export function useShiftSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQShiftQuery,
              GQShiftQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQShiftQuery | undefined,
    GQShiftQueryVariables
>;
export function useShiftSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQShiftQuery,
              GQShiftQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQShiftQuery,
        GQShiftQueryVariables
    >(ShiftDocument, options);
}
export type ShiftQueryHookResult = ReturnType<typeof useShiftQuery>;
export type ShiftLazyQueryHookResult = ReturnType<typeof useShiftLazyQuery>;
export type ShiftSuspenseQueryHookResult = ReturnType<
    typeof useShiftSuspenseQuery
>;
export type ShiftQueryResult = ApolloReactCommon.QueryResult<
    GQShiftQuery,
    GQShiftQueryVariables
>;
export const ShiftsInPeriodDocument = gql`
    query shiftsInPeriod(
        $from: Date!
        $to: Date!
        $pagination: PaginationInput
    ) {
        shiftsInPeriod(from: $from, to: $to, pagination: $pagination) {
            data {
                ...allShiftFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllShiftFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useShiftsInPeriodQuery__
 *
 * To run a query within a React component, call `useShiftsInPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftsInPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftsInPeriodQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useShiftsInPeriodQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQShiftsInPeriodQuery,
        GQShiftsInPeriodQueryVariables
    > &
        (
            | { variables: GQShiftsInPeriodQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQShiftsInPeriodQuery,
        GQShiftsInPeriodQueryVariables
    >(ShiftsInPeriodDocument, options);
}
export function useShiftsInPeriodLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQShiftsInPeriodQuery,
        GQShiftsInPeriodQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQShiftsInPeriodQuery,
        GQShiftsInPeriodQueryVariables
    >(ShiftsInPeriodDocument, options);
}
// @ts-ignore
export function useShiftsInPeriodSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQShiftsInPeriodQuery,
        GQShiftsInPeriodQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQShiftsInPeriodQuery,
    GQShiftsInPeriodQueryVariables
>;
export function useShiftsInPeriodSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQShiftsInPeriodQuery,
              GQShiftsInPeriodQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQShiftsInPeriodQuery | undefined,
    GQShiftsInPeriodQueryVariables
>;
export function useShiftsInPeriodSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQShiftsInPeriodQuery,
              GQShiftsInPeriodQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQShiftsInPeriodQuery,
        GQShiftsInPeriodQueryVariables
    >(ShiftsInPeriodDocument, options);
}
export type ShiftsInPeriodQueryHookResult = ReturnType<
    typeof useShiftsInPeriodQuery
>;
export type ShiftsInPeriodLazyQueryHookResult = ReturnType<
    typeof useShiftsInPeriodLazyQuery
>;
export type ShiftsInPeriodSuspenseQueryHookResult = ReturnType<
    typeof useShiftsInPeriodSuspenseQuery
>;
export type ShiftsInPeriodQueryResult = ApolloReactCommon.QueryResult<
    GQShiftsInPeriodQuery,
    GQShiftsInPeriodQueryVariables
>;
export const AddEconomicSyncJobsDocument = gql`
    mutation addEconomicSyncJobs(
        $ids: [ID!]
        $integrationId: ID!
        $voucherText: String
    ) {
        addEconomicSyncJobs(
            ids: $ids
            integrationId: $integrationId
            voucherText: $voucherText
        ) {
            status
        }
    }
`;
export type GQAddEconomicSyncJobsMutationFn =
    ApolloReactCommon.MutationFunction<
        GQAddEconomicSyncJobsMutation,
        GQAddEconomicSyncJobsMutationVariables
    >;

/**
 * __useAddEconomicSyncJobsMutation__
 *
 * To run a mutation, you first call `useAddEconomicSyncJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEconomicSyncJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEconomicSyncJobsMutation, { data, loading, error }] = useAddEconomicSyncJobsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      integrationId: // value for 'integrationId'
 *      voucherText: // value for 'voucherText'
 *   },
 * });
 */
export function useAddEconomicSyncJobsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAddEconomicSyncJobsMutation,
        GQAddEconomicSyncJobsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAddEconomicSyncJobsMutation,
        GQAddEconomicSyncJobsMutationVariables
    >(AddEconomicSyncJobsDocument, options);
}
export type AddEconomicSyncJobsMutationHookResult = ReturnType<
    typeof useAddEconomicSyncJobsMutation
>;
export type AddEconomicSyncJobsMutationResult =
    ApolloReactCommon.MutationResult<GQAddEconomicSyncJobsMutation>;
export type AddEconomicSyncJobsMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAddEconomicSyncJobsMutation,
        GQAddEconomicSyncJobsMutationVariables
    >;
export const SoftpayMiaMerchantsDocument = gql`
    query softpayMiaMerchants(
        $acquirer: SoftpayAcquirer!
        $pagination: PaginationInput
    ) {
        softpayMiaMerchants(acquirer: $acquirer, pagination: $pagination) {
            data {
                merchantId
                businessRegNo
                merchantName
                primaryContactEmail
                primaryContactPhone
                countryCode
                state
                aidGroup
                localPrivileges
                remotePrivileges
                merchantReference
                stores(acquirer: $acquirer) {
                    storeId
                    businessRegNo
                    name
                    addressLine1
                    addressLine2
                    zipCode
                    city
                    phone
                    cardAcceptorCountryCode
                    cardAcceptorNameLocation
                    onlineStoreId
                    state
                    timeZone
                }
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useSoftpayMiaMerchantsQuery__
 *
 * To run a query within a React component, call `useSoftpayMiaMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftpayMiaMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftpayMiaMerchantsQuery({
 *   variables: {
 *      acquirer: // value for 'acquirer'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSoftpayMiaMerchantsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQSoftpayMiaMerchantsQuery,
        GQSoftpayMiaMerchantsQueryVariables
    > &
        (
            | { variables: GQSoftpayMiaMerchantsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQSoftpayMiaMerchantsQuery,
        GQSoftpayMiaMerchantsQueryVariables
    >(SoftpayMiaMerchantsDocument, options);
}
export function useSoftpayMiaMerchantsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQSoftpayMiaMerchantsQuery,
        GQSoftpayMiaMerchantsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQSoftpayMiaMerchantsQuery,
        GQSoftpayMiaMerchantsQueryVariables
    >(SoftpayMiaMerchantsDocument, options);
}
// @ts-ignore
export function useSoftpayMiaMerchantsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQSoftpayMiaMerchantsQuery,
        GQSoftpayMiaMerchantsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayMiaMerchantsQuery,
    GQSoftpayMiaMerchantsQueryVariables
>;
export function useSoftpayMiaMerchantsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayMiaMerchantsQuery,
              GQSoftpayMiaMerchantsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayMiaMerchantsQuery | undefined,
    GQSoftpayMiaMerchantsQueryVariables
>;
export function useSoftpayMiaMerchantsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayMiaMerchantsQuery,
              GQSoftpayMiaMerchantsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQSoftpayMiaMerchantsQuery,
        GQSoftpayMiaMerchantsQueryVariables
    >(SoftpayMiaMerchantsDocument, options);
}
export type SoftpayMiaMerchantsQueryHookResult = ReturnType<
    typeof useSoftpayMiaMerchantsQuery
>;
export type SoftpayMiaMerchantsLazyQueryHookResult = ReturnType<
    typeof useSoftpayMiaMerchantsLazyQuery
>;
export type SoftpayMiaMerchantsSuspenseQueryHookResult = ReturnType<
    typeof useSoftpayMiaMerchantsSuspenseQuery
>;
export type SoftpayMiaMerchantsQueryResult = ApolloReactCommon.QueryResult<
    GQSoftpayMiaMerchantsQuery,
    GQSoftpayMiaMerchantsQueryVariables
>;
export const SoftpayMiaMerchantDocument = gql`
    query softpayMiaMerchant(
        $acquirer: SoftpayAcquirer!
        $merchantId: String!
    ) {
        softpayMiaMerchant(acquirer: $acquirer, merchantId: $merchantId) {
            merchantId
            businessRegNo
            merchantName
            primaryContactEmail
            primaryContactPhone
            countryCode
            state
            aidGroup
            localPrivileges
            remotePrivileges
            merchantReference
            stores(acquirer: $acquirer) {
                storeId
                businessRegNo
                name
                addressLine1
                addressLine2
                zipCode
                city
                phone
                state
            }
        }
    }
`;

/**
 * __useSoftpayMiaMerchantQuery__
 *
 * To run a query within a React component, call `useSoftpayMiaMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftpayMiaMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftpayMiaMerchantQuery({
 *   variables: {
 *      acquirer: // value for 'acquirer'
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useSoftpayMiaMerchantQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQSoftpayMiaMerchantQuery,
        GQSoftpayMiaMerchantQueryVariables
    > &
        (
            | { variables: GQSoftpayMiaMerchantQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQSoftpayMiaMerchantQuery,
        GQSoftpayMiaMerchantQueryVariables
    >(SoftpayMiaMerchantDocument, options);
}
export function useSoftpayMiaMerchantLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQSoftpayMiaMerchantQuery,
        GQSoftpayMiaMerchantQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQSoftpayMiaMerchantQuery,
        GQSoftpayMiaMerchantQueryVariables
    >(SoftpayMiaMerchantDocument, options);
}
// @ts-ignore
export function useSoftpayMiaMerchantSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQSoftpayMiaMerchantQuery,
        GQSoftpayMiaMerchantQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayMiaMerchantQuery,
    GQSoftpayMiaMerchantQueryVariables
>;
export function useSoftpayMiaMerchantSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayMiaMerchantQuery,
              GQSoftpayMiaMerchantQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayMiaMerchantQuery | undefined,
    GQSoftpayMiaMerchantQueryVariables
>;
export function useSoftpayMiaMerchantSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayMiaMerchantQuery,
              GQSoftpayMiaMerchantQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQSoftpayMiaMerchantQuery,
        GQSoftpayMiaMerchantQueryVariables
    >(SoftpayMiaMerchantDocument, options);
}
export type SoftpayMiaMerchantQueryHookResult = ReturnType<
    typeof useSoftpayMiaMerchantQuery
>;
export type SoftpayMiaMerchantLazyQueryHookResult = ReturnType<
    typeof useSoftpayMiaMerchantLazyQuery
>;
export type SoftpayMiaMerchantSuspenseQueryHookResult = ReturnType<
    typeof useSoftpayMiaMerchantSuspenseQuery
>;
export type SoftpayMiaMerchantQueryResult = ApolloReactCommon.QueryResult<
    GQSoftpayMiaMerchantQuery,
    GQSoftpayMiaMerchantQueryVariables
>;
export const SoftpayMiaStoreDocument = gql`
    query softpayMiaStore(
        $acquirer: SoftpayAcquirer!
        $merchantId: String!
        $storeId: String!
    ) {
        softpayMiaStore(
            acquirer: $acquirer
            merchantId: $merchantId
            storeId: $storeId
        ) {
            storeId
            businessRegNo
            name
            addressLine1
            addressLine2
            zipCode
            city
            phone
            additionalData {
                key
                value
            }
            cardAcceptorCountryCode
            cardAcceptorNameLocation
            onlineStoreId
            state
            timeZone
            terminals(acquirer: $acquirer) {
                terminalId
                onlineTerminalId
                merchantCategoryCode
                defaultCurrencyCode
                onlineMerchantId
                state
                profileName
                installed
                takenAt
                releasedAt
                lastOnline
                appId
            }
        }
    }
`;

/**
 * __useSoftpayMiaStoreQuery__
 *
 * To run a query within a React component, call `useSoftpayMiaStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftpayMiaStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftpayMiaStoreQuery({
 *   variables: {
 *      acquirer: // value for 'acquirer'
 *      merchantId: // value for 'merchantId'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useSoftpayMiaStoreQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQSoftpayMiaStoreQuery,
        GQSoftpayMiaStoreQueryVariables
    > &
        (
            | { variables: GQSoftpayMiaStoreQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQSoftpayMiaStoreQuery,
        GQSoftpayMiaStoreQueryVariables
    >(SoftpayMiaStoreDocument, options);
}
export function useSoftpayMiaStoreLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQSoftpayMiaStoreQuery,
        GQSoftpayMiaStoreQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQSoftpayMiaStoreQuery,
        GQSoftpayMiaStoreQueryVariables
    >(SoftpayMiaStoreDocument, options);
}
// @ts-ignore
export function useSoftpayMiaStoreSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQSoftpayMiaStoreQuery,
        GQSoftpayMiaStoreQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayMiaStoreQuery,
    GQSoftpayMiaStoreQueryVariables
>;
export function useSoftpayMiaStoreSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayMiaStoreQuery,
              GQSoftpayMiaStoreQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayMiaStoreQuery | undefined,
    GQSoftpayMiaStoreQueryVariables
>;
export function useSoftpayMiaStoreSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayMiaStoreQuery,
              GQSoftpayMiaStoreQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQSoftpayMiaStoreQuery,
        GQSoftpayMiaStoreQueryVariables
    >(SoftpayMiaStoreDocument, options);
}
export type SoftpayMiaStoreQueryHookResult = ReturnType<
    typeof useSoftpayMiaStoreQuery
>;
export type SoftpayMiaStoreLazyQueryHookResult = ReturnType<
    typeof useSoftpayMiaStoreLazyQuery
>;
export type SoftpayMiaStoreSuspenseQueryHookResult = ReturnType<
    typeof useSoftpayMiaStoreSuspenseQuery
>;
export type SoftpayMiaStoreQueryResult = ApolloReactCommon.QueryResult<
    GQSoftpayMiaStoreQuery,
    GQSoftpayMiaStoreQueryVariables
>;
export const SoftpayMiaTerminalDocument = gql`
    query softpayMiaTerminal(
        $acquirer: SoftpayAcquirer!
        $merchantId: String!
        $storeId: String!
        $terminalId: String!
    ) {
        softpayMiaTerminal(
            acquirer: $acquirer
            merchantId: $merchantId
            storeId: $storeId
            terminalId: $terminalId
        ) {
            terminalId
            onlineTerminalId
            merchantCategoryCode
            defaultCurrencyCode
            onlineMerchantId
            additionalData {
                key
                value
            }
            processorData {
                cardSchema
                processorName
                processorTerminalId
                processorMerchantId
            }
            publicKeySetId
            kernelDataId
            state
            profileName
            installed
            takenAt
            releasedAt
            lastOnline
            appId
            softpayTerminalId
        }
    }
`;

/**
 * __useSoftpayMiaTerminalQuery__
 *
 * To run a query within a React component, call `useSoftpayMiaTerminalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftpayMiaTerminalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftpayMiaTerminalQuery({
 *   variables: {
 *      acquirer: // value for 'acquirer'
 *      merchantId: // value for 'merchantId'
 *      storeId: // value for 'storeId'
 *      terminalId: // value for 'terminalId'
 *   },
 * });
 */
export function useSoftpayMiaTerminalQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQSoftpayMiaTerminalQuery,
        GQSoftpayMiaTerminalQueryVariables
    > &
        (
            | { variables: GQSoftpayMiaTerminalQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQSoftpayMiaTerminalQuery,
        GQSoftpayMiaTerminalQueryVariables
    >(SoftpayMiaTerminalDocument, options);
}
export function useSoftpayMiaTerminalLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQSoftpayMiaTerminalQuery,
        GQSoftpayMiaTerminalQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQSoftpayMiaTerminalQuery,
        GQSoftpayMiaTerminalQueryVariables
    >(SoftpayMiaTerminalDocument, options);
}
// @ts-ignore
export function useSoftpayMiaTerminalSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQSoftpayMiaTerminalQuery,
        GQSoftpayMiaTerminalQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayMiaTerminalQuery,
    GQSoftpayMiaTerminalQueryVariables
>;
export function useSoftpayMiaTerminalSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayMiaTerminalQuery,
              GQSoftpayMiaTerminalQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayMiaTerminalQuery | undefined,
    GQSoftpayMiaTerminalQueryVariables
>;
export function useSoftpayMiaTerminalSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayMiaTerminalQuery,
              GQSoftpayMiaTerminalQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQSoftpayMiaTerminalQuery,
        GQSoftpayMiaTerminalQueryVariables
    >(SoftpayMiaTerminalDocument, options);
}
export type SoftpayMiaTerminalQueryHookResult = ReturnType<
    typeof useSoftpayMiaTerminalQuery
>;
export type SoftpayMiaTerminalLazyQueryHookResult = ReturnType<
    typeof useSoftpayMiaTerminalLazyQuery
>;
export type SoftpayMiaTerminalSuspenseQueryHookResult = ReturnType<
    typeof useSoftpayMiaTerminalSuspenseQuery
>;
export type SoftpayMiaTerminalQueryResult = ApolloReactCommon.QueryResult<
    GQSoftpayMiaTerminalQuery,
    GQSoftpayMiaTerminalQueryVariables
>;
export const ReleaseTerminalDocument = gql`
    mutation releaseTerminal(
        $acquirer: SoftpayAcquirer!
        $merchantId: String!
        $storeId: String!
        $terminalId: String!
    ) {
        releaseTerminal(
            acquirer: $acquirer
            merchantId: $merchantId
            storeId: $storeId
            terminalId: $terminalId
        ) {
            status
        }
    }
`;
export type GQReleaseTerminalMutationFn = ApolloReactCommon.MutationFunction<
    GQReleaseTerminalMutation,
    GQReleaseTerminalMutationVariables
>;

/**
 * __useReleaseTerminalMutation__
 *
 * To run a mutation, you first call `useReleaseTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseTerminalMutation, { data, loading, error }] = useReleaseTerminalMutation({
 *   variables: {
 *      acquirer: // value for 'acquirer'
 *      merchantId: // value for 'merchantId'
 *      storeId: // value for 'storeId'
 *      terminalId: // value for 'terminalId'
 *   },
 * });
 */
export function useReleaseTerminalMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQReleaseTerminalMutation,
        GQReleaseTerminalMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQReleaseTerminalMutation,
        GQReleaseTerminalMutationVariables
    >(ReleaseTerminalDocument, options);
}
export type ReleaseTerminalMutationHookResult = ReturnType<
    typeof useReleaseTerminalMutation
>;
export type ReleaseTerminalMutationResult =
    ApolloReactCommon.MutationResult<GQReleaseTerminalMutation>;
export type ReleaseTerminalMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQReleaseTerminalMutation,
        GQReleaseTerminalMutationVariables
    >;
export const SoftpayMerchantsDocument = gql`
    query softpayMerchants($pagination: PaginationInput) {
        softpayMerchants(pagination: $pagination) {
            data {
                ...softpayMerchantFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${SoftpayMerchantFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useSoftpayMerchantsQuery__
 *
 * To run a query within a React component, call `useSoftpayMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftpayMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftpayMerchantsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSoftpayMerchantsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQSoftpayMerchantsQuery,
        GQSoftpayMerchantsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQSoftpayMerchantsQuery,
        GQSoftpayMerchantsQueryVariables
    >(SoftpayMerchantsDocument, options);
}
export function useSoftpayMerchantsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQSoftpayMerchantsQuery,
        GQSoftpayMerchantsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQSoftpayMerchantsQuery,
        GQSoftpayMerchantsQueryVariables
    >(SoftpayMerchantsDocument, options);
}
// @ts-ignore
export function useSoftpayMerchantsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQSoftpayMerchantsQuery,
        GQSoftpayMerchantsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayMerchantsQuery,
    GQSoftpayMerchantsQueryVariables
>;
export function useSoftpayMerchantsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayMerchantsQuery,
              GQSoftpayMerchantsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayMerchantsQuery | undefined,
    GQSoftpayMerchantsQueryVariables
>;
export function useSoftpayMerchantsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayMerchantsQuery,
              GQSoftpayMerchantsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQSoftpayMerchantsQuery,
        GQSoftpayMerchantsQueryVariables
    >(SoftpayMerchantsDocument, options);
}
export type SoftpayMerchantsQueryHookResult = ReturnType<
    typeof useSoftpayMerchantsQuery
>;
export type SoftpayMerchantsLazyQueryHookResult = ReturnType<
    typeof useSoftpayMerchantsLazyQuery
>;
export type SoftpayMerchantsSuspenseQueryHookResult = ReturnType<
    typeof useSoftpayMerchantsSuspenseQuery
>;
export type SoftpayMerchantsQueryResult = ApolloReactCommon.QueryResult<
    GQSoftpayMerchantsQuery,
    GQSoftpayMerchantsQueryVariables
>;
export const TagGroupsDocument = gql`
    query tagGroups(
        $pagination: PaginationInput
        $searching: TagGroupSearchInput
    ) {
        tagGroups(pagination: $pagination, searching: $searching) {
            data {
                ...tagGroupScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${TagGroupScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useTagGroupsQuery__
 *
 * To run a query within a React component, call `useTagGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useTagGroupsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQTagGroupsQuery,
        GQTagGroupsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQTagGroupsQuery,
        GQTagGroupsQueryVariables
    >(TagGroupsDocument, options);
}
export function useTagGroupsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTagGroupsQuery,
        GQTagGroupsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQTagGroupsQuery,
        GQTagGroupsQueryVariables
    >(TagGroupsDocument, options);
}
// @ts-ignore
export function useTagGroupsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTagGroupsQuery,
        GQTagGroupsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagGroupsQuery,
    GQTagGroupsQueryVariables
>;
export function useTagGroupsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagGroupsQuery,
              GQTagGroupsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagGroupsQuery | undefined,
    GQTagGroupsQueryVariables
>;
export function useTagGroupsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagGroupsQuery,
              GQTagGroupsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQTagGroupsQuery,
        GQTagGroupsQueryVariables
    >(TagGroupsDocument, options);
}
export type TagGroupsQueryHookResult = ReturnType<typeof useTagGroupsQuery>;
export type TagGroupsLazyQueryHookResult = ReturnType<
    typeof useTagGroupsLazyQuery
>;
export type TagGroupsSuspenseQueryHookResult = ReturnType<
    typeof useTagGroupsSuspenseQuery
>;
export type TagGroupsQueryResult = ApolloReactCommon.QueryResult<
    GQTagGroupsQuery,
    GQTagGroupsQueryVariables
>;
export const TagGroupDocument = gql`
    query tagGroup($id: ID!) {
        tagGroup(id: $id) {
            ...tagGroupScreenFields
        }
    }
    ${TagGroupScreenFieldsFragmentDoc}
`;

/**
 * __useTagGroupQuery__
 *
 * To run a query within a React component, call `useTagGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagGroupQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQTagGroupQuery,
        GQTagGroupQueryVariables
    > &
        (
            | { variables: GQTagGroupQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQTagGroupQuery, GQTagGroupQueryVariables>(
        TagGroupDocument,
        options
    );
}
export function useTagGroupLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTagGroupQuery,
        GQTagGroupQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQTagGroupQuery,
        GQTagGroupQueryVariables
    >(TagGroupDocument, options);
}
// @ts-ignore
export function useTagGroupSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTagGroupQuery,
        GQTagGroupQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagGroupQuery,
    GQTagGroupQueryVariables
>;
export function useTagGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagGroupQuery,
              GQTagGroupQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagGroupQuery | undefined,
    GQTagGroupQueryVariables
>;
export function useTagGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagGroupQuery,
              GQTagGroupQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQTagGroupQuery,
        GQTagGroupQueryVariables
    >(TagGroupDocument, options);
}
export type TagGroupQueryHookResult = ReturnType<typeof useTagGroupQuery>;
export type TagGroupLazyQueryHookResult = ReturnType<
    typeof useTagGroupLazyQuery
>;
export type TagGroupSuspenseQueryHookResult = ReturnType<
    typeof useTagGroupSuspenseQuery
>;
export type TagGroupQueryResult = ApolloReactCommon.QueryResult<
    GQTagGroupQuery,
    GQTagGroupQueryVariables
>;
export const TagGroupCreateDocument = gql`
    mutation tagGroupCreate($tagGroup: TagGroupInput!) {
        tagGroupCreate(tagGroup: $tagGroup) {
            ...tagGroupScreenFields
        }
    }
    ${TagGroupScreenFieldsFragmentDoc}
`;
export type GQTagGroupCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQTagGroupCreateMutation,
    GQTagGroupCreateMutationVariables
>;

/**
 * __useTagGroupCreateMutation__
 *
 * To run a mutation, you first call `useTagGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagGroupCreateMutation, { data, loading, error }] = useTagGroupCreateMutation({
 *   variables: {
 *      tagGroup: // value for 'tagGroup'
 *   },
 * });
 */
export function useTagGroupCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQTagGroupCreateMutation,
        GQTagGroupCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQTagGroupCreateMutation,
        GQTagGroupCreateMutationVariables
    >(TagGroupCreateDocument, options);
}
export type TagGroupCreateMutationHookResult = ReturnType<
    typeof useTagGroupCreateMutation
>;
export type TagGroupCreateMutationResult =
    ApolloReactCommon.MutationResult<GQTagGroupCreateMutation>;
export type TagGroupCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQTagGroupCreateMutation,
        GQTagGroupCreateMutationVariables
    >;
export const TagGroupSaveDocument = gql`
    mutation tagGroupSave($id: ID!, $tagGroup: TagGroupInput!) {
        tagGroupSave(id: $id, tagGroup: $tagGroup) {
            ...tagGroupScreenFields
        }
    }
    ${TagGroupScreenFieldsFragmentDoc}
`;
export type GQTagGroupSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQTagGroupSaveMutation,
    GQTagGroupSaveMutationVariables
>;

/**
 * __useTagGroupSaveMutation__
 *
 * To run a mutation, you first call `useTagGroupSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagGroupSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagGroupSaveMutation, { data, loading, error }] = useTagGroupSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tagGroup: // value for 'tagGroup'
 *   },
 * });
 */
export function useTagGroupSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQTagGroupSaveMutation,
        GQTagGroupSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQTagGroupSaveMutation,
        GQTagGroupSaveMutationVariables
    >(TagGroupSaveDocument, options);
}
export type TagGroupSaveMutationHookResult = ReturnType<
    typeof useTagGroupSaveMutation
>;
export type TagGroupSaveMutationResult =
    ApolloReactCommon.MutationResult<GQTagGroupSaveMutation>;
export type TagGroupSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQTagGroupSaveMutation,
    GQTagGroupSaveMutationVariables
>;
export const TagGroupDeleteDocument = gql`
    mutation tagGroupDelete($id: ID!) {
        tagGroupDelete(id: $id) {
            status
        }
    }
`;
export type GQTagGroupDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQTagGroupDeleteMutation,
    GQTagGroupDeleteMutationVariables
>;

/**
 * __useTagGroupDeleteMutation__
 *
 * To run a mutation, you first call `useTagGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagGroupDeleteMutation, { data, loading, error }] = useTagGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagGroupDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQTagGroupDeleteMutation,
        GQTagGroupDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQTagGroupDeleteMutation,
        GQTagGroupDeleteMutationVariables
    >(TagGroupDeleteDocument, options);
}
export type TagGroupDeleteMutationHookResult = ReturnType<
    typeof useTagGroupDeleteMutation
>;
export type TagGroupDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQTagGroupDeleteMutation>;
export type TagGroupDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQTagGroupDeleteMutation,
        GQTagGroupDeleteMutationVariables
    >;
export const TagsDocument = gql`
    query tags(
        $pagination: PaginationInput
        $search: SearchInput
        $tagIds: [ID!]
        $searching: TagSearchInput
    ) {
        tags(
            pagination: $pagination
            search: $search
            tagIds: $tagIds
            searching: $searching
        ) {
            data {
                ...tagScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      tagIds: // value for 'tagIds'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useTagsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQTagsQuery,
        GQTagsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQTagsQuery, GQTagsQueryVariables>(
        TagsDocument,
        options
    );
}
export function useTagsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTagsQuery,
        GQTagsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQTagsQuery, GQTagsQueryVariables>(
        TagsDocument,
        options
    );
}
// @ts-ignore
export function useTagsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTagsQuery,
        GQTagsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQTagsQuery, GQTagsQueryVariables>;
export function useTagsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsQuery,
              GQTagsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsQuery | undefined,
    GQTagsQueryVariables
>;
export function useTagsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsQuery,
              GQTagsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<GQTagsQuery, GQTagsQueryVariables>(
        TagsDocument,
        options
    );
}
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<
    typeof useTagsSuspenseQuery
>;
export type TagsQueryResult = ApolloReactCommon.QueryResult<
    GQTagsQuery,
    GQTagsQueryVariables
>;
export const TagsWithoutAccountDocument = gql`
    query tagsWithoutAccount(
        $pagination: PaginationInput
        $search: SearchInput
    ) {
        tagsWithoutAccount(pagination: $pagination, search: $search) {
            data {
                ...tagScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useTagsWithoutAccountQuery__
 *
 * To run a query within a React component, call `useTagsWithoutAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsWithoutAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsWithoutAccountQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTagsWithoutAccountQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQTagsWithoutAccountQuery,
        GQTagsWithoutAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQTagsWithoutAccountQuery,
        GQTagsWithoutAccountQueryVariables
    >(TagsWithoutAccountDocument, options);
}
export function useTagsWithoutAccountLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTagsWithoutAccountQuery,
        GQTagsWithoutAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQTagsWithoutAccountQuery,
        GQTagsWithoutAccountQueryVariables
    >(TagsWithoutAccountDocument, options);
}
// @ts-ignore
export function useTagsWithoutAccountSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTagsWithoutAccountQuery,
        GQTagsWithoutAccountQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsWithoutAccountQuery,
    GQTagsWithoutAccountQueryVariables
>;
export function useTagsWithoutAccountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsWithoutAccountQuery,
              GQTagsWithoutAccountQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsWithoutAccountQuery | undefined,
    GQTagsWithoutAccountQueryVariables
>;
export function useTagsWithoutAccountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsWithoutAccountQuery,
              GQTagsWithoutAccountQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQTagsWithoutAccountQuery,
        GQTagsWithoutAccountQueryVariables
    >(TagsWithoutAccountDocument, options);
}
export type TagsWithoutAccountQueryHookResult = ReturnType<
    typeof useTagsWithoutAccountQuery
>;
export type TagsWithoutAccountLazyQueryHookResult = ReturnType<
    typeof useTagsWithoutAccountLazyQuery
>;
export type TagsWithoutAccountSuspenseQueryHookResult = ReturnType<
    typeof useTagsWithoutAccountSuspenseQuery
>;
export type TagsWithoutAccountQueryResult = ApolloReactCommon.QueryResult<
    GQTagsWithoutAccountQuery,
    GQTagsWithoutAccountQueryVariables
>;
export const TagsWithoutCustomerDocument = gql`
    query tagsWithoutCustomer(
        $pagination: PaginationInput
        $search: SearchInput
    ) {
        tagsWithoutCustomer(pagination: $pagination, search: $search) {
            data {
                ...tagScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useTagsWithoutCustomerQuery__
 *
 * To run a query within a React component, call `useTagsWithoutCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsWithoutCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsWithoutCustomerQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTagsWithoutCustomerQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQTagsWithoutCustomerQuery,
        GQTagsWithoutCustomerQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQTagsWithoutCustomerQuery,
        GQTagsWithoutCustomerQueryVariables
    >(TagsWithoutCustomerDocument, options);
}
export function useTagsWithoutCustomerLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTagsWithoutCustomerQuery,
        GQTagsWithoutCustomerQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQTagsWithoutCustomerQuery,
        GQTagsWithoutCustomerQueryVariables
    >(TagsWithoutCustomerDocument, options);
}
// @ts-ignore
export function useTagsWithoutCustomerSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTagsWithoutCustomerQuery,
        GQTagsWithoutCustomerQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsWithoutCustomerQuery,
    GQTagsWithoutCustomerQueryVariables
>;
export function useTagsWithoutCustomerSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsWithoutCustomerQuery,
              GQTagsWithoutCustomerQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsWithoutCustomerQuery | undefined,
    GQTagsWithoutCustomerQueryVariables
>;
export function useTagsWithoutCustomerSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsWithoutCustomerQuery,
              GQTagsWithoutCustomerQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQTagsWithoutCustomerQuery,
        GQTagsWithoutCustomerQueryVariables
    >(TagsWithoutCustomerDocument, options);
}
export type TagsWithoutCustomerQueryHookResult = ReturnType<
    typeof useTagsWithoutCustomerQuery
>;
export type TagsWithoutCustomerLazyQueryHookResult = ReturnType<
    typeof useTagsWithoutCustomerLazyQuery
>;
export type TagsWithoutCustomerSuspenseQueryHookResult = ReturnType<
    typeof useTagsWithoutCustomerSuspenseQuery
>;
export type TagsWithoutCustomerQueryResult = ApolloReactCommon.QueryResult<
    GQTagsWithoutCustomerQuery,
    GQTagsWithoutCustomerQueryVariables
>;
export const TagsByGroupDocument = gql`
    query tagsByGroup(
        $groupId: ID!
        $pagination: PaginationInput
        $search: SearchInput
    ) {
        tagsByGroup(
            groupId: $groupId
            pagination: $pagination
            search: $search
        ) {
            data {
                ...tagScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useTagsByGroupQuery__
 *
 * To run a query within a React component, call `useTagsByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsByGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTagsByGroupQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQTagsByGroupQuery,
        GQTagsByGroupQueryVariables
    > &
        (
            | { variables: GQTagsByGroupQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQTagsByGroupQuery,
        GQTagsByGroupQueryVariables
    >(TagsByGroupDocument, options);
}
export function useTagsByGroupLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTagsByGroupQuery,
        GQTagsByGroupQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQTagsByGroupQuery,
        GQTagsByGroupQueryVariables
    >(TagsByGroupDocument, options);
}
// @ts-ignore
export function useTagsByGroupSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTagsByGroupQuery,
        GQTagsByGroupQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsByGroupQuery,
    GQTagsByGroupQueryVariables
>;
export function useTagsByGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsByGroupQuery,
              GQTagsByGroupQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsByGroupQuery | undefined,
    GQTagsByGroupQueryVariables
>;
export function useTagsByGroupSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsByGroupQuery,
              GQTagsByGroupQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQTagsByGroupQuery,
        GQTagsByGroupQueryVariables
    >(TagsByGroupDocument, options);
}
export type TagsByGroupQueryHookResult = ReturnType<typeof useTagsByGroupQuery>;
export type TagsByGroupLazyQueryHookResult = ReturnType<
    typeof useTagsByGroupLazyQuery
>;
export type TagsByGroupSuspenseQueryHookResult = ReturnType<
    typeof useTagsByGroupSuspenseQuery
>;
export type TagsByGroupQueryResult = ApolloReactCommon.QueryResult<
    GQTagsByGroupQuery,
    GQTagsByGroupQueryVariables
>;
export const TagsByCustomerDocument = gql`
    query tagsByCustomer(
        $customerId: ID!
        $pagination: PaginationInput
        $search: SearchInput
    ) {
        tagsByCustomer(
            customerId: $customerId
            pagination: $pagination
            search: $search
        ) {
            data {
                ...tagScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useTagsByCustomerQuery__
 *
 * To run a query within a React component, call `useTagsByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsByCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTagsByCustomerQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQTagsByCustomerQuery,
        GQTagsByCustomerQueryVariables
    > &
        (
            | { variables: GQTagsByCustomerQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQTagsByCustomerQuery,
        GQTagsByCustomerQueryVariables
    >(TagsByCustomerDocument, options);
}
export function useTagsByCustomerLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTagsByCustomerQuery,
        GQTagsByCustomerQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQTagsByCustomerQuery,
        GQTagsByCustomerQueryVariables
    >(TagsByCustomerDocument, options);
}
// @ts-ignore
export function useTagsByCustomerSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTagsByCustomerQuery,
        GQTagsByCustomerQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsByCustomerQuery,
    GQTagsByCustomerQueryVariables
>;
export function useTagsByCustomerSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsByCustomerQuery,
              GQTagsByCustomerQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsByCustomerQuery | undefined,
    GQTagsByCustomerQueryVariables
>;
export function useTagsByCustomerSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsByCustomerQuery,
              GQTagsByCustomerQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQTagsByCustomerQuery,
        GQTagsByCustomerQueryVariables
    >(TagsByCustomerDocument, options);
}
export type TagsByCustomerQueryHookResult = ReturnType<
    typeof useTagsByCustomerQuery
>;
export type TagsByCustomerLazyQueryHookResult = ReturnType<
    typeof useTagsByCustomerLazyQuery
>;
export type TagsByCustomerSuspenseQueryHookResult = ReturnType<
    typeof useTagsByCustomerSuspenseQuery
>;
export type TagsByCustomerQueryResult = ApolloReactCommon.QueryResult<
    GQTagsByCustomerQuery,
    GQTagsByCustomerQueryVariables
>;
export const TagsByAccountDocument = gql`
    query tagsByAccount(
        $accountId: ID!
        $pagination: PaginationInput
        $search: SearchInput
    ) {
        tagsByAccount(
            accountId: $accountId
            pagination: $pagination
            search: $search
        ) {
            data {
                ...tagScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useTagsByAccountQuery__
 *
 * To run a query within a React component, call `useTagsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsByAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTagsByAccountQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQTagsByAccountQuery,
        GQTagsByAccountQueryVariables
    > &
        (
            | { variables: GQTagsByAccountQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQTagsByAccountQuery,
        GQTagsByAccountQueryVariables
    >(TagsByAccountDocument, options);
}
export function useTagsByAccountLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTagsByAccountQuery,
        GQTagsByAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQTagsByAccountQuery,
        GQTagsByAccountQueryVariables
    >(TagsByAccountDocument, options);
}
// @ts-ignore
export function useTagsByAccountSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTagsByAccountQuery,
        GQTagsByAccountQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsByAccountQuery,
    GQTagsByAccountQueryVariables
>;
export function useTagsByAccountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsByAccountQuery,
              GQTagsByAccountQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagsByAccountQuery | undefined,
    GQTagsByAccountQueryVariables
>;
export function useTagsByAccountSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagsByAccountQuery,
              GQTagsByAccountQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQTagsByAccountQuery,
        GQTagsByAccountQueryVariables
    >(TagsByAccountDocument, options);
}
export type TagsByAccountQueryHookResult = ReturnType<
    typeof useTagsByAccountQuery
>;
export type TagsByAccountLazyQueryHookResult = ReturnType<
    typeof useTagsByAccountLazyQuery
>;
export type TagsByAccountSuspenseQueryHookResult = ReturnType<
    typeof useTagsByAccountSuspenseQuery
>;
export type TagsByAccountQueryResult = ApolloReactCommon.QueryResult<
    GQTagsByAccountQuery,
    GQTagsByAccountQueryVariables
>;
export const TagDocument = gql`
    query tag($id: ID!) {
        tag(id: $id) {
            ...tagScreenFields
            actionsForTag(
                tagId: $id
                pagination: {
                    pageSize: 99999
                    sort: "createdAt"
                    sortDirection: "ASC"
                }
            ) {
                data {
                    action
                    createdAt
                    accountId
                    accountName
                    userName
                }
                pagination {
                    ...defaultPaginationFields
                }
            }
        }
    }
    ${TagScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQTagQuery,
        GQTagQueryVariables
    > &
        ({ variables: GQTagQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQTagQuery, GQTagQueryVariables>(
        TagDocument,
        options
    );
}
export function useTagLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTagQuery,
        GQTagQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQTagQuery, GQTagQueryVariables>(
        TagDocument,
        options
    );
}
// @ts-ignore
export function useTagSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTagQuery,
        GQTagQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQTagQuery, GQTagQueryVariables>;
export function useTagSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagQuery,
              GQTagQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagQuery | undefined,
    GQTagQueryVariables
>;
export function useTagSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagQuery,
              GQTagQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<GQTagQuery, GQTagQueryVariables>(
        TagDocument,
        options
    );
}
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagSuspenseQueryHookResult = ReturnType<typeof useTagSuspenseQuery>;
export type TagQueryResult = ApolloReactCommon.QueryResult<
    GQTagQuery,
    GQTagQueryVariables
>;
export const TagCreateDocument = gql`
    mutation tagCreate($tag: TagInput!) {
        tagCreate(tag: $tag) {
            ...tagScreenFields
        }
    }
    ${TagScreenFieldsFragmentDoc}
`;
export type GQTagCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQTagCreateMutation,
    GQTagCreateMutationVariables
>;

/**
 * __useTagCreateMutation__
 *
 * To run a mutation, you first call `useTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagCreateMutation, { data, loading, error }] = useTagCreateMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useTagCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQTagCreateMutation,
        GQTagCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQTagCreateMutation,
        GQTagCreateMutationVariables
    >(TagCreateDocument, options);
}
export type TagCreateMutationHookResult = ReturnType<
    typeof useTagCreateMutation
>;
export type TagCreateMutationResult =
    ApolloReactCommon.MutationResult<GQTagCreateMutation>;
export type TagCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQTagCreateMutation,
    GQTagCreateMutationVariables
>;
export const TagSaveDocument = gql`
    mutation tagSave($id: ID!, $tag: TagInput!) {
        tagSave(id: $id, tag: $tag) {
            ...tagScreenFields
        }
    }
    ${TagScreenFieldsFragmentDoc}
`;
export type GQTagSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQTagSaveMutation,
    GQTagSaveMutationVariables
>;

/**
 * __useTagSaveMutation__
 *
 * To run a mutation, you first call `useTagSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagSaveMutation, { data, loading, error }] = useTagSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useTagSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQTagSaveMutation,
        GQTagSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQTagSaveMutation,
        GQTagSaveMutationVariables
    >(TagSaveDocument, options);
}
export type TagSaveMutationHookResult = ReturnType<typeof useTagSaveMutation>;
export type TagSaveMutationResult =
    ApolloReactCommon.MutationResult<GQTagSaveMutation>;
export type TagSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQTagSaveMutation,
    GQTagSaveMutationVariables
>;
export const TagDeleteDocument = gql`
    mutation tagDelete($id: ID!) {
        tagDelete(id: $id) {
            status
        }
    }
`;
export type GQTagDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQTagDeleteMutation,
    GQTagDeleteMutationVariables
>;

/**
 * __useTagDeleteMutation__
 *
 * To run a mutation, you first call `useTagDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagDeleteMutation, { data, loading, error }] = useTagDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQTagDeleteMutation,
        GQTagDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQTagDeleteMutation,
        GQTagDeleteMutationVariables
    >(TagDeleteDocument, options);
}
export type TagDeleteMutationHookResult = ReturnType<
    typeof useTagDeleteMutation
>;
export type TagDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQTagDeleteMutation>;
export type TagDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQTagDeleteMutation,
    GQTagDeleteMutationVariables
>;
export const TagFormDocument = gql`
    query tagForm {
        tags(
            pagination: { pageSize: 99999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                ...tagNameFields
            }
        }
        tagGroups(
            pagination: { pageSize: 99999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                ...tagGroupScreenFields
            }
        }
    }
    ${TagNameFieldsFragmentDoc}
    ${TagGroupScreenFieldsFragmentDoc}
`;

/**
 * __useTagFormQuery__
 *
 * To run a query within a React component, call `useTagFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQTagFormQuery,
        GQTagFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQTagFormQuery, GQTagFormQueryVariables>(
        TagFormDocument,
        options
    );
}
export function useTagFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTagFormQuery,
        GQTagFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQTagFormQuery,
        GQTagFormQueryVariables
    >(TagFormDocument, options);
}
// @ts-ignore
export function useTagFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTagFormQuery,
        GQTagFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagFormQuery,
    GQTagFormQueryVariables
>;
export function useTagFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagFormQuery,
              GQTagFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTagFormQuery | undefined,
    GQTagFormQueryVariables
>;
export function useTagFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTagFormQuery,
              GQTagFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQTagFormQuery,
        GQTagFormQueryVariables
    >(TagFormDocument, options);
}
export type TagFormQueryHookResult = ReturnType<typeof useTagFormQuery>;
export type TagFormLazyQueryHookResult = ReturnType<typeof useTagFormLazyQuery>;
export type TagFormSuspenseQueryHookResult = ReturnType<
    typeof useTagFormSuspenseQuery
>;
export type TagFormQueryResult = ApolloReactCommon.QueryResult<
    GQTagFormQuery,
    GQTagFormQueryVariables
>;
export const TaskResultsDocument = gql`
    query taskResults($type: String!, $pagination: PaginationInput) {
        taskResults(type: $type, pagination: $pagination) {
            data {
                ...taskResultFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${TaskResultFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useTaskResultsQuery__
 *
 * To run a query within a React component, call `useTaskResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskResultsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useTaskResultsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQTaskResultsQuery,
        GQTaskResultsQueryVariables
    > &
        (
            | { variables: GQTaskResultsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQTaskResultsQuery,
        GQTaskResultsQueryVariables
    >(TaskResultsDocument, options);
}
export function useTaskResultsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQTaskResultsQuery,
        GQTaskResultsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQTaskResultsQuery,
        GQTaskResultsQueryVariables
    >(TaskResultsDocument, options);
}
// @ts-ignore
export function useTaskResultsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQTaskResultsQuery,
        GQTaskResultsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTaskResultsQuery,
    GQTaskResultsQueryVariables
>;
export function useTaskResultsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTaskResultsQuery,
              GQTaskResultsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQTaskResultsQuery | undefined,
    GQTaskResultsQueryVariables
>;
export function useTaskResultsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQTaskResultsQuery,
              GQTaskResultsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQTaskResultsQuery,
        GQTaskResultsQueryVariables
    >(TaskResultsDocument, options);
}
export type TaskResultsQueryHookResult = ReturnType<typeof useTaskResultsQuery>;
export type TaskResultsLazyQueryHookResult = ReturnType<
    typeof useTaskResultsLazyQuery
>;
export type TaskResultsSuspenseQueryHookResult = ReturnType<
    typeof useTaskResultsSuspenseQuery
>;
export type TaskResultsQueryResult = ApolloReactCommon.QueryResult<
    GQTaskResultsQuery,
    GQTaskResultsQueryVariables
>;
export const LatestTaskResultsDocument = gql`
    query latestTaskResults($pagination: PaginationInput) {
        latestTaskResults(pagination: $pagination) {
            data {
                ...taskResultFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${TaskResultFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useLatestTaskResultsQuery__
 *
 * To run a query within a React component, call `useLatestTaskResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestTaskResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestTaskResultsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useLatestTaskResultsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQLatestTaskResultsQuery,
        GQLatestTaskResultsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQLatestTaskResultsQuery,
        GQLatestTaskResultsQueryVariables
    >(LatestTaskResultsDocument, options);
}
export function useLatestTaskResultsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQLatestTaskResultsQuery,
        GQLatestTaskResultsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQLatestTaskResultsQuery,
        GQLatestTaskResultsQueryVariables
    >(LatestTaskResultsDocument, options);
}
// @ts-ignore
export function useLatestTaskResultsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQLatestTaskResultsQuery,
        GQLatestTaskResultsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLatestTaskResultsQuery,
    GQLatestTaskResultsQueryVariables
>;
export function useLatestTaskResultsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLatestTaskResultsQuery,
              GQLatestTaskResultsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQLatestTaskResultsQuery | undefined,
    GQLatestTaskResultsQueryVariables
>;
export function useLatestTaskResultsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQLatestTaskResultsQuery,
              GQLatestTaskResultsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQLatestTaskResultsQuery,
        GQLatestTaskResultsQueryVariables
    >(LatestTaskResultsDocument, options);
}
export type LatestTaskResultsQueryHookResult = ReturnType<
    typeof useLatestTaskResultsQuery
>;
export type LatestTaskResultsLazyQueryHookResult = ReturnType<
    typeof useLatestTaskResultsLazyQuery
>;
export type LatestTaskResultsSuspenseQueryHookResult = ReturnType<
    typeof useLatestTaskResultsSuspenseQuery
>;
export type LatestTaskResultsQueryResult = ApolloReactCommon.QueryResult<
    GQLatestTaskResultsQuery,
    GQLatestTaskResultsQueryVariables
>;
export const RolesDocument = gql`
    query roles($pagination: PaginationInput!) {
        roles(pagination: $pagination) {
            data {
                ...allRoleFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${AllRoleFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useRolesQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQRolesQuery,
        GQRolesQueryVariables
    > &
        (
            | { variables: GQRolesQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQRolesQuery, GQRolesQueryVariables>(
        RolesDocument,
        options
    );
}
export function useRolesLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQRolesQuery,
        GQRolesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQRolesQuery, GQRolesQueryVariables>(
        RolesDocument,
        options
    );
}
// @ts-ignore
export function useRolesSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQRolesQuery,
        GQRolesQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQRolesQuery, GQRolesQueryVariables>;
export function useRolesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQRolesQuery,
              GQRolesQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQRolesQuery | undefined,
    GQRolesQueryVariables
>;
export function useRolesSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQRolesQuery,
              GQRolesQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQRolesQuery,
        GQRolesQueryVariables
    >(RolesDocument, options);
}
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesSuspenseQueryHookResult = ReturnType<
    typeof useRolesSuspenseQuery
>;
export type RolesQueryResult = ApolloReactCommon.QueryResult<
    GQRolesQuery,
    GQRolesQueryVariables
>;
export const RoleEditFormDocument = gql`
    query roleEditForm($id: ID!) {
        role(id: $id) {
            id
            name
            type
            shared
            inUse
            merchant {
                id
                name
            }
            permissions {
                key
                value
            }
        }
    }
`;

/**
 * __useRoleEditFormQuery__
 *
 * To run a query within a React component, call `useRoleEditFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleEditFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleEditFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoleEditFormQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQRoleEditFormQuery,
        GQRoleEditFormQueryVariables
    > &
        (
            | { variables: GQRoleEditFormQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQRoleEditFormQuery,
        GQRoleEditFormQueryVariables
    >(RoleEditFormDocument, options);
}
export function useRoleEditFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQRoleEditFormQuery,
        GQRoleEditFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQRoleEditFormQuery,
        GQRoleEditFormQueryVariables
    >(RoleEditFormDocument, options);
}
// @ts-ignore
export function useRoleEditFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQRoleEditFormQuery,
        GQRoleEditFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQRoleEditFormQuery,
    GQRoleEditFormQueryVariables
>;
export function useRoleEditFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQRoleEditFormQuery,
              GQRoleEditFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQRoleEditFormQuery | undefined,
    GQRoleEditFormQueryVariables
>;
export function useRoleEditFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQRoleEditFormQuery,
              GQRoleEditFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQRoleEditFormQuery,
        GQRoleEditFormQueryVariables
    >(RoleEditFormDocument, options);
}
export type RoleEditFormQueryHookResult = ReturnType<
    typeof useRoleEditFormQuery
>;
export type RoleEditFormLazyQueryHookResult = ReturnType<
    typeof useRoleEditFormLazyQuery
>;
export type RoleEditFormSuspenseQueryHookResult = ReturnType<
    typeof useRoleEditFormSuspenseQuery
>;
export type RoleEditFormQueryResult = ApolloReactCommon.QueryResult<
    GQRoleEditFormQuery,
    GQRoleEditFormQueryVariables
>;
export const RoleCreateDocument = gql`
    mutation roleCreate($role: RoleInput!) {
        roleCreate(role: $role) {
            ...allRoleFields
        }
    }
    ${AllRoleFieldsFragmentDoc}
`;
export type GQRoleCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQRoleCreateMutation,
    GQRoleCreateMutationVariables
>;

/**
 * __useRoleCreateMutation__
 *
 * To run a mutation, you first call `useRoleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleCreateMutation, { data, loading, error }] = useRoleCreateMutation({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useRoleCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQRoleCreateMutation,
        GQRoleCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQRoleCreateMutation,
        GQRoleCreateMutationVariables
    >(RoleCreateDocument, options);
}
export type RoleCreateMutationHookResult = ReturnType<
    typeof useRoleCreateMutation
>;
export type RoleCreateMutationResult =
    ApolloReactCommon.MutationResult<GQRoleCreateMutation>;
export type RoleCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQRoleCreateMutation,
    GQRoleCreateMutationVariables
>;
export const RoleSaveDocument = gql`
    mutation roleSave($id: ID!, $role: RoleInput!) {
        roleSave(id: $id, role: $role) {
            ...allRoleFields
        }
    }
    ${AllRoleFieldsFragmentDoc}
`;
export type GQRoleSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQRoleSaveMutation,
    GQRoleSaveMutationVariables
>;

/**
 * __useRoleSaveMutation__
 *
 * To run a mutation, you first call `useRoleSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoleSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleSaveMutation, { data, loading, error }] = useRoleSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useRoleSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQRoleSaveMutation,
        GQRoleSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQRoleSaveMutation,
        GQRoleSaveMutationVariables
    >(RoleSaveDocument, options);
}
export type RoleSaveMutationHookResult = ReturnType<typeof useRoleSaveMutation>;
export type RoleSaveMutationResult =
    ApolloReactCommon.MutationResult<GQRoleSaveMutation>;
export type RoleSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQRoleSaveMutation,
    GQRoleSaveMutationVariables
>;
export const RoleDeleteDocument = gql`
    mutation roleDelete($id: ID!) {
        roleDelete(id: $id) {
            status
        }
    }
`;
export type GQRoleDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQRoleDeleteMutation,
    GQRoleDeleteMutationVariables
>;

/**
 * __useRoleDeleteMutation__
 *
 * To run a mutation, you first call `useRoleDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoleDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleDeleteMutation, { data, loading, error }] = useRoleDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoleDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQRoleDeleteMutation,
        GQRoleDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQRoleDeleteMutation,
        GQRoleDeleteMutationVariables
    >(RoleDeleteDocument, options);
}
export type RoleDeleteMutationHookResult = ReturnType<
    typeof useRoleDeleteMutation
>;
export type RoleDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQRoleDeleteMutation>;
export type RoleDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQRoleDeleteMutation,
    GQRoleDeleteMutationVariables
>;
export const UsersDocument = gql`
    query users(
        $pagination: PaginationInput!
        $search: SearchInput
        $searching: UserSearchInput
    ) {
        users(pagination: $pagination, search: $search, searching: $searching) {
            data {
                ...user
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${UserFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useUsersQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQUsersQuery,
        GQUsersQueryVariables
    > &
        (
            | { variables: GQUsersQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQUsersQuery, GQUsersQueryVariables>(
        UsersDocument,
        options
    );
}
export function useUsersLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQUsersQuery,
        GQUsersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQUsersQuery, GQUsersQueryVariables>(
        UsersDocument,
        options
    );
}
// @ts-ignore
export function useUsersSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQUsersQuery,
        GQUsersQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQUsersQuery, GQUsersQueryVariables>;
export function useUsersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUsersQuery,
              GQUsersQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQUsersQuery | undefined,
    GQUsersQueryVariables
>;
export function useUsersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUsersQuery,
              GQUsersQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQUsersQuery,
        GQUsersQueryVariables
    >(UsersDocument, options);
}
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<
    typeof useUsersSuspenseQuery
>;
export type UsersQueryResult = ApolloReactCommon.QueryResult<
    GQUsersQuery,
    GQUsersQueryVariables
>;
export const UserDocument = gql`
    query user($id: ID!) {
        user(id: $id) {
            ...user
        }
    }
    ${UserFragmentDoc}
`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQUserQuery,
        GQUserQueryVariables
    > &
        (
            | { variables: GQUserQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQUserQuery, GQUserQueryVariables>(
        UserDocument,
        options
    );
}
export function useUserLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQUserQuery,
        GQUserQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQUserQuery, GQUserQueryVariables>(
        UserDocument,
        options
    );
}
// @ts-ignore
export function useUserSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQUserQuery,
        GQUserQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQUserQuery, GQUserQueryVariables>;
export function useUserSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUserQuery,
              GQUserQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQUserQuery | undefined,
    GQUserQueryVariables
>;
export function useUserSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUserQuery,
              GQUserQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<GQUserQuery, GQUserQueryVariables>(
        UserDocument,
        options
    );
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<
    typeof useUserSuspenseQuery
>;
export type UserQueryResult = ApolloReactCommon.QueryResult<
    GQUserQuery,
    GQUserQueryVariables
>;
export const UserCreateFormDocument = gql`
    query userCreateForm {
        roles(pagination: { pageSize: 999999 }) {
            data {
                ...userFormRolesFields
            }
        }
    }
    ${UserFormRolesFieldsFragmentDoc}
`;

/**
 * __useUserCreateFormQuery__
 *
 * To run a query within a React component, call `useUserCreateFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCreateFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCreateFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCreateFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQUserCreateFormQuery,
        GQUserCreateFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQUserCreateFormQuery,
        GQUserCreateFormQueryVariables
    >(UserCreateFormDocument, options);
}
export function useUserCreateFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQUserCreateFormQuery,
        GQUserCreateFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQUserCreateFormQuery,
        GQUserCreateFormQueryVariables
    >(UserCreateFormDocument, options);
}
// @ts-ignore
export function useUserCreateFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQUserCreateFormQuery,
        GQUserCreateFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQUserCreateFormQuery,
    GQUserCreateFormQueryVariables
>;
export function useUserCreateFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUserCreateFormQuery,
              GQUserCreateFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQUserCreateFormQuery | undefined,
    GQUserCreateFormQueryVariables
>;
export function useUserCreateFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUserCreateFormQuery,
              GQUserCreateFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQUserCreateFormQuery,
        GQUserCreateFormQueryVariables
    >(UserCreateFormDocument, options);
}
export type UserCreateFormQueryHookResult = ReturnType<
    typeof useUserCreateFormQuery
>;
export type UserCreateFormLazyQueryHookResult = ReturnType<
    typeof useUserCreateFormLazyQuery
>;
export type UserCreateFormSuspenseQueryHookResult = ReturnType<
    typeof useUserCreateFormSuspenseQuery
>;
export type UserCreateFormQueryResult = ApolloReactCommon.QueryResult<
    GQUserCreateFormQuery,
    GQUserCreateFormQueryVariables
>;
export const UserEditFormDocument = gql`
    query userEditForm($userId: ID!) {
        user(id: $userId) {
            ...user
        }
        roles(pagination: { pageSize: 999999 }, userId: $userId) {
            data {
                ...userFormRolesFields
            }
        }
    }
    ${UserFragmentDoc}
    ${UserFormRolesFieldsFragmentDoc}
`;

/**
 * __useUserEditFormQuery__
 *
 * To run a query within a React component, call `useUserEditFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEditFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEditFormQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserEditFormQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQUserEditFormQuery,
        GQUserEditFormQueryVariables
    > &
        (
            | { variables: GQUserEditFormQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQUserEditFormQuery,
        GQUserEditFormQueryVariables
    >(UserEditFormDocument, options);
}
export function useUserEditFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQUserEditFormQuery,
        GQUserEditFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQUserEditFormQuery,
        GQUserEditFormQueryVariables
    >(UserEditFormDocument, options);
}
// @ts-ignore
export function useUserEditFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQUserEditFormQuery,
        GQUserEditFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQUserEditFormQuery,
    GQUserEditFormQueryVariables
>;
export function useUserEditFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUserEditFormQuery,
              GQUserEditFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQUserEditFormQuery | undefined,
    GQUserEditFormQueryVariables
>;
export function useUserEditFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUserEditFormQuery,
              GQUserEditFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQUserEditFormQuery,
        GQUserEditFormQueryVariables
    >(UserEditFormDocument, options);
}
export type UserEditFormQueryHookResult = ReturnType<
    typeof useUserEditFormQuery
>;
export type UserEditFormLazyQueryHookResult = ReturnType<
    typeof useUserEditFormLazyQuery
>;
export type UserEditFormSuspenseQueryHookResult = ReturnType<
    typeof useUserEditFormSuspenseQuery
>;
export type UserEditFormQueryResult = ApolloReactCommon.QueryResult<
    GQUserEditFormQuery,
    GQUserEditFormQueryVariables
>;
export const UsernameAvailabilityDocument = gql`
    query usernameAvailability($username: String!) {
        userAvailability(username: $username)
    }
`;

/**
 * __useUsernameAvailabilityQuery__
 *
 * To run a query within a React component, call `useUsernameAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsernameAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsernameAvailabilityQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUsernameAvailabilityQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQUsernameAvailabilityQuery,
        GQUsernameAvailabilityQueryVariables
    > &
        (
            | {
                  variables: GQUsernameAvailabilityQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQUsernameAvailabilityQuery,
        GQUsernameAvailabilityQueryVariables
    >(UsernameAvailabilityDocument, options);
}
export function useUsernameAvailabilityLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQUsernameAvailabilityQuery,
        GQUsernameAvailabilityQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQUsernameAvailabilityQuery,
        GQUsernameAvailabilityQueryVariables
    >(UsernameAvailabilityDocument, options);
}
// @ts-ignore
export function useUsernameAvailabilitySuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQUsernameAvailabilityQuery,
        GQUsernameAvailabilityQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQUsernameAvailabilityQuery,
    GQUsernameAvailabilityQueryVariables
>;
export function useUsernameAvailabilitySuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUsernameAvailabilityQuery,
              GQUsernameAvailabilityQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQUsernameAvailabilityQuery | undefined,
    GQUsernameAvailabilityQueryVariables
>;
export function useUsernameAvailabilitySuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQUsernameAvailabilityQuery,
              GQUsernameAvailabilityQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQUsernameAvailabilityQuery,
        GQUsernameAvailabilityQueryVariables
    >(UsernameAvailabilityDocument, options);
}
export type UsernameAvailabilityQueryHookResult = ReturnType<
    typeof useUsernameAvailabilityQuery
>;
export type UsernameAvailabilityLazyQueryHookResult = ReturnType<
    typeof useUsernameAvailabilityLazyQuery
>;
export type UsernameAvailabilitySuspenseQueryHookResult = ReturnType<
    typeof useUsernameAvailabilitySuspenseQuery
>;
export type UsernameAvailabilityQueryResult = ApolloReactCommon.QueryResult<
    GQUsernameAvailabilityQuery,
    GQUsernameAvailabilityQueryVariables
>;
export const UserCreateDocument = gql`
    mutation userCreate($user: UserInput!) {
        userCreate(user: $user) {
            ...user
        }
    }
    ${UserFragmentDoc}
`;
export type GQUserCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQUserCreateMutation,
    GQUserCreateMutationVariables
>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUserCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQUserCreateMutation,
        GQUserCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQUserCreateMutation,
        GQUserCreateMutationVariables
    >(UserCreateDocument, options);
}
export type UserCreateMutationHookResult = ReturnType<
    typeof useUserCreateMutation
>;
export type UserCreateMutationResult =
    ApolloReactCommon.MutationResult<GQUserCreateMutation>;
export type UserCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQUserCreateMutation,
    GQUserCreateMutationVariables
>;
export const UserSaveDocument = gql`
    mutation userSave($id: ID!, $user: UserInput!) {
        userSave(id: $id, user: $user) {
            ...user
        }
    }
    ${UserFragmentDoc}
`;
export type GQUserSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQUserSaveMutation,
    GQUserSaveMutationVariables
>;

/**
 * __useUserSaveMutation__
 *
 * To run a mutation, you first call `useUserSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSaveMutation, { data, loading, error }] = useUserSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUserSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQUserSaveMutation,
        GQUserSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQUserSaveMutation,
        GQUserSaveMutationVariables
    >(UserSaveDocument, options);
}
export type UserSaveMutationHookResult = ReturnType<typeof useUserSaveMutation>;
export type UserSaveMutationResult =
    ApolloReactCommon.MutationResult<GQUserSaveMutation>;
export type UserSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQUserSaveMutation,
    GQUserSaveMutationVariables
>;
export const UserDeleteDocument = gql`
    mutation userDelete($id: ID!) {
        userDelete(id: $id) {
            status
        }
    }
`;
export type GQUserDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQUserDeleteMutation,
    GQUserDeleteMutationVariables
>;

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQUserDeleteMutation,
        GQUserDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQUserDeleteMutation,
        GQUserDeleteMutationVariables
    >(UserDeleteDocument, options);
}
export type UserDeleteMutationHookResult = ReturnType<
    typeof useUserDeleteMutation
>;
export type UserDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQUserDeleteMutation>;
export type UserDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQUserDeleteMutation,
    GQUserDeleteMutationVariables
>;
export const UserUpdatePasswordDocument = gql`
    mutation userUpdatePassword($id: ID!, $password: String!) {
        userUpdatePassword(id: $id, password: $password) {
            status
        }
    }
`;
export type GQUserUpdatePasswordMutationFn = ApolloReactCommon.MutationFunction<
    GQUserUpdatePasswordMutation,
    GQUserUpdatePasswordMutationVariables
>;

/**
 * __useUserUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUserUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdatePasswordMutation, { data, loading, error }] = useUserUpdatePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUserUpdatePasswordMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQUserUpdatePasswordMutation,
        GQUserUpdatePasswordMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQUserUpdatePasswordMutation,
        GQUserUpdatePasswordMutationVariables
    >(UserUpdatePasswordDocument, options);
}
export type UserUpdatePasswordMutationHookResult = ReturnType<
    typeof useUserUpdatePasswordMutation
>;
export type UserUpdatePasswordMutationResult =
    ApolloReactCommon.MutationResult<GQUserUpdatePasswordMutation>;
export type UserUpdatePasswordMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQUserUpdatePasswordMutation,
        GQUserUpdatePasswordMutationVariables
    >;
export const VatDocument = gql`
    query vat($id: ID!) {
        vat(id: $id) {
            ...vatScreenFields
        }
    }
    ${VatScreenFieldsFragmentDoc}
`;

/**
 * __useVatQuery__
 *
 * To run a query within a React component, call `useVatQuery` and pass it any options that fit your needs.
 * When your component renders, `useVatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVatQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQVatQuery,
        GQVatQueryVariables
    > &
        ({ variables: GQVatQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQVatQuery, GQVatQueryVariables>(
        VatDocument,
        options
    );
}
export function useVatLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQVatQuery,
        GQVatQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQVatQuery, GQVatQueryVariables>(
        VatDocument,
        options
    );
}
// @ts-ignore
export function useVatSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQVatQuery,
        GQVatQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQVatQuery, GQVatQueryVariables>;
export function useVatSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVatQuery,
              GQVatQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVatQuery | undefined,
    GQVatQueryVariables
>;
export function useVatSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVatQuery,
              GQVatQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<GQVatQuery, GQVatQueryVariables>(
        VatDocument,
        options
    );
}
export type VatQueryHookResult = ReturnType<typeof useVatQuery>;
export type VatLazyQueryHookResult = ReturnType<typeof useVatLazyQuery>;
export type VatSuspenseQueryHookResult = ReturnType<typeof useVatSuspenseQuery>;
export type VatQueryResult = ApolloReactCommon.QueryResult<
    GQVatQuery,
    GQVatQueryVariables
>;
export const VatsDocument = gql`
    query vats($pagination: PaginationInput) {
        vats(pagination: $pagination) {
            data {
                ...vatScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${VatScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useVatsQuery__
 *
 * To run a query within a React component, call `useVatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVatsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useVatsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQVatsQuery,
        GQVatsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQVatsQuery, GQVatsQueryVariables>(
        VatsDocument,
        options
    );
}
export function useVatsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQVatsQuery,
        GQVatsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQVatsQuery, GQVatsQueryVariables>(
        VatsDocument,
        options
    );
}
// @ts-ignore
export function useVatsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQVatsQuery,
        GQVatsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQVatsQuery, GQVatsQueryVariables>;
export function useVatsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVatsQuery,
              GQVatsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVatsQuery | undefined,
    GQVatsQueryVariables
>;
export function useVatsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVatsQuery,
              GQVatsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<GQVatsQuery, GQVatsQueryVariables>(
        VatsDocument,
        options
    );
}
export type VatsQueryHookResult = ReturnType<typeof useVatsQuery>;
export type VatsLazyQueryHookResult = ReturnType<typeof useVatsLazyQuery>;
export type VatsSuspenseQueryHookResult = ReturnType<
    typeof useVatsSuspenseQuery
>;
export type VatsQueryResult = ApolloReactCommon.QueryResult<
    GQVatsQuery,
    GQVatsQueryVariables
>;
export const VatCreateDocument = gql`
    mutation vatCreate($vat: VatCreateInput!) {
        vatCreate(vat: $vat) {
            ...vatScreenFields
        }
    }
    ${VatScreenFieldsFragmentDoc}
`;
export type GQVatCreateMutationFn = ApolloReactCommon.MutationFunction<
    GQVatCreateMutation,
    GQVatCreateMutationVariables
>;

/**
 * __useVatCreateMutation__
 *
 * To run a mutation, you first call `useVatCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVatCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vatCreateMutation, { data, loading, error }] = useVatCreateMutation({
 *   variables: {
 *      vat: // value for 'vat'
 *   },
 * });
 */
export function useVatCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQVatCreateMutation,
        GQVatCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQVatCreateMutation,
        GQVatCreateMutationVariables
    >(VatCreateDocument, options);
}
export type VatCreateMutationHookResult = ReturnType<
    typeof useVatCreateMutation
>;
export type VatCreateMutationResult =
    ApolloReactCommon.MutationResult<GQVatCreateMutation>;
export type VatCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQVatCreateMutation,
    GQVatCreateMutationVariables
>;
export const VatDeleteDocument = gql`
    mutation vatDelete($id: ID!) {
        vatDelete(id: $id) {
            status
        }
    }
`;
export type GQVatDeleteMutationFn = ApolloReactCommon.MutationFunction<
    GQVatDeleteMutation,
    GQVatDeleteMutationVariables
>;

/**
 * __useVatDeleteMutation__
 *
 * To run a mutation, you first call `useVatDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVatDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vatDeleteMutation, { data, loading, error }] = useVatDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVatDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQVatDeleteMutation,
        GQVatDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQVatDeleteMutation,
        GQVatDeleteMutationVariables
    >(VatDeleteDocument, options);
}
export type VatDeleteMutationHookResult = ReturnType<
    typeof useVatDeleteMutation
>;
export type VatDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQVatDeleteMutation>;
export type VatDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQVatDeleteMutation,
    GQVatDeleteMutationVariables
>;
export const VatFormDocument = gql`
    query vatForm {
        vats(pagination: { pageSize: 99, sort: "name", sortDirection: "ASC" }) {
            data {
                id
                percentage
            }
        }
    }
`;

/**
 * __useVatFormQuery__
 *
 * To run a query within a React component, call `useVatFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useVatFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVatFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useVatFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQVatFormQuery,
        GQVatFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQVatFormQuery, GQVatFormQueryVariables>(
        VatFormDocument,
        options
    );
}
export function useVatFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQVatFormQuery,
        GQVatFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQVatFormQuery,
        GQVatFormQueryVariables
    >(VatFormDocument, options);
}
// @ts-ignore
export function useVatFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQVatFormQuery,
        GQVatFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVatFormQuery,
    GQVatFormQueryVariables
>;
export function useVatFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVatFormQuery,
              GQVatFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVatFormQuery | undefined,
    GQVatFormQueryVariables
>;
export function useVatFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVatFormQuery,
              GQVatFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQVatFormQuery,
        GQVatFormQueryVariables
    >(VatFormDocument, options);
}
export type VatFormQueryHookResult = ReturnType<typeof useVatFormQuery>;
export type VatFormLazyQueryHookResult = ReturnType<typeof useVatFormLazyQuery>;
export type VatFormSuspenseQueryHookResult = ReturnType<
    typeof useVatFormSuspenseQuery
>;
export type VatFormQueryResult = ApolloReactCommon.QueryResult<
    GQVatFormQuery,
    GQVatFormQueryVariables
>;
export const VirtualPrinterDocument = gql`
    query virtualPrinter($id: ID!) {
        virtualPrinter(id: $id) {
            ...virtualPrinterScreenFields
        }
    }
    ${VirtualPrinterScreenFieldsFragmentDoc}
`;

/**
 * __useVirtualPrinterQuery__
 *
 * To run a query within a React component, call `useVirtualPrinterQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualPrinterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualPrinterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVirtualPrinterQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQVirtualPrinterQuery,
        GQVirtualPrinterQueryVariables
    > &
        (
            | { variables: GQVirtualPrinterQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQVirtualPrinterQuery,
        GQVirtualPrinterQueryVariables
    >(VirtualPrinterDocument, options);
}
export function useVirtualPrinterLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQVirtualPrinterQuery,
        GQVirtualPrinterQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQVirtualPrinterQuery,
        GQVirtualPrinterQueryVariables
    >(VirtualPrinterDocument, options);
}
// @ts-ignore
export function useVirtualPrinterSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQVirtualPrinterQuery,
        GQVirtualPrinterQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVirtualPrinterQuery,
    GQVirtualPrinterQueryVariables
>;
export function useVirtualPrinterSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVirtualPrinterQuery,
              GQVirtualPrinterQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVirtualPrinterQuery | undefined,
    GQVirtualPrinterQueryVariables
>;
export function useVirtualPrinterSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVirtualPrinterQuery,
              GQVirtualPrinterQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQVirtualPrinterQuery,
        GQVirtualPrinterQueryVariables
    >(VirtualPrinterDocument, options);
}
export type VirtualPrinterQueryHookResult = ReturnType<
    typeof useVirtualPrinterQuery
>;
export type VirtualPrinterLazyQueryHookResult = ReturnType<
    typeof useVirtualPrinterLazyQuery
>;
export type VirtualPrinterSuspenseQueryHookResult = ReturnType<
    typeof useVirtualPrinterSuspenseQuery
>;
export type VirtualPrinterQueryResult = ApolloReactCommon.QueryResult<
    GQVirtualPrinterQuery,
    GQVirtualPrinterQueryVariables
>;
export const VirtualPrintersDocument = gql`
    query virtualPrinters(
        $pagination: PaginationInput
        $searching: PrinterSearchInput
    ) {
        virtualPrinters(pagination: $pagination, searching: $searching) {
            data {
                ...virtualPrinterScreenFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${VirtualPrinterScreenFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useVirtualPrintersQuery__
 *
 * To run a query within a React component, call `useVirtualPrintersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualPrintersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualPrintersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searching: // value for 'searching'
 *   },
 * });
 */
export function useVirtualPrintersQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQVirtualPrintersQuery,
        GQVirtualPrintersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQVirtualPrintersQuery,
        GQVirtualPrintersQueryVariables
    >(VirtualPrintersDocument, options);
}
export function useVirtualPrintersLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQVirtualPrintersQuery,
        GQVirtualPrintersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQVirtualPrintersQuery,
        GQVirtualPrintersQueryVariables
    >(VirtualPrintersDocument, options);
}
// @ts-ignore
export function useVirtualPrintersSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQVirtualPrintersQuery,
        GQVirtualPrintersQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVirtualPrintersQuery,
    GQVirtualPrintersQueryVariables
>;
export function useVirtualPrintersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVirtualPrintersQuery,
              GQVirtualPrintersQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVirtualPrintersQuery | undefined,
    GQVirtualPrintersQueryVariables
>;
export function useVirtualPrintersSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVirtualPrintersQuery,
              GQVirtualPrintersQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQVirtualPrintersQuery,
        GQVirtualPrintersQueryVariables
    >(VirtualPrintersDocument, options);
}
export type VirtualPrintersQueryHookResult = ReturnType<
    typeof useVirtualPrintersQuery
>;
export type VirtualPrintersLazyQueryHookResult = ReturnType<
    typeof useVirtualPrintersLazyQuery
>;
export type VirtualPrintersSuspenseQueryHookResult = ReturnType<
    typeof useVirtualPrintersSuspenseQuery
>;
export type VirtualPrintersQueryResult = ApolloReactCommon.QueryResult<
    GQVirtualPrintersQuery,
    GQVirtualPrintersQueryVariables
>;
export const VirtualPrinterCreateDocument = gql`
    mutation virtualPrinterCreate($virtualPrinter: VirtualPrinterCreate!) {
        virtualPrinterCreate(virtualPrinter: $virtualPrinter) {
            name
            printer {
                id
            }
        }
    }
`;
export type GQVirtualPrinterCreateMutationFn =
    ApolloReactCommon.MutationFunction<
        GQVirtualPrinterCreateMutation,
        GQVirtualPrinterCreateMutationVariables
    >;

/**
 * __useVirtualPrinterCreateMutation__
 *
 * To run a mutation, you first call `useVirtualPrinterCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVirtualPrinterCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [virtualPrinterCreateMutation, { data, loading, error }] = useVirtualPrinterCreateMutation({
 *   variables: {
 *      virtualPrinter: // value for 'virtualPrinter'
 *   },
 * });
 */
export function useVirtualPrinterCreateMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQVirtualPrinterCreateMutation,
        GQVirtualPrinterCreateMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQVirtualPrinterCreateMutation,
        GQVirtualPrinterCreateMutationVariables
    >(VirtualPrinterCreateDocument, options);
}
export type VirtualPrinterCreateMutationHookResult = ReturnType<
    typeof useVirtualPrinterCreateMutation
>;
export type VirtualPrinterCreateMutationResult =
    ApolloReactCommon.MutationResult<GQVirtualPrinterCreateMutation>;
export type VirtualPrinterCreateMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQVirtualPrinterCreateMutation,
        GQVirtualPrinterCreateMutationVariables
    >;
export const VirtualPrinterSaveDocument = gql`
    mutation virtualPrinterSave(
        $id: ID!
        $virtualPrinter: VirtualPrinterSave!
    ) {
        virtualPrinterSave(id: $id, virtualPrinter: $virtualPrinter) {
            name
            printer {
                id
            }
        }
    }
`;
export type GQVirtualPrinterSaveMutationFn = ApolloReactCommon.MutationFunction<
    GQVirtualPrinterSaveMutation,
    GQVirtualPrinterSaveMutationVariables
>;

/**
 * __useVirtualPrinterSaveMutation__
 *
 * To run a mutation, you first call `useVirtualPrinterSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVirtualPrinterSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [virtualPrinterSaveMutation, { data, loading, error }] = useVirtualPrinterSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      virtualPrinter: // value for 'virtualPrinter'
 *   },
 * });
 */
export function useVirtualPrinterSaveMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQVirtualPrinterSaveMutation,
        GQVirtualPrinterSaveMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQVirtualPrinterSaveMutation,
        GQVirtualPrinterSaveMutationVariables
    >(VirtualPrinterSaveDocument, options);
}
export type VirtualPrinterSaveMutationHookResult = ReturnType<
    typeof useVirtualPrinterSaveMutation
>;
export type VirtualPrinterSaveMutationResult =
    ApolloReactCommon.MutationResult<GQVirtualPrinterSaveMutation>;
export type VirtualPrinterSaveMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQVirtualPrinterSaveMutation,
        GQVirtualPrinterSaveMutationVariables
    >;
export const VirtualPrinterDeleteDocument = gql`
    mutation virtualPrinterDelete($id: ID!) {
        virtualPrinterDelete(id: $id) {
            status
        }
    }
`;
export type GQVirtualPrinterDeleteMutationFn =
    ApolloReactCommon.MutationFunction<
        GQVirtualPrinterDeleteMutation,
        GQVirtualPrinterDeleteMutationVariables
    >;

/**
 * __useVirtualPrinterDeleteMutation__
 *
 * To run a mutation, you first call `useVirtualPrinterDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVirtualPrinterDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [virtualPrinterDeleteMutation, { data, loading, error }] = useVirtualPrinterDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVirtualPrinterDeleteMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQVirtualPrinterDeleteMutation,
        GQVirtualPrinterDeleteMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQVirtualPrinterDeleteMutation,
        GQVirtualPrinterDeleteMutationVariables
    >(VirtualPrinterDeleteDocument, options);
}
export type VirtualPrinterDeleteMutationHookResult = ReturnType<
    typeof useVirtualPrinterDeleteMutation
>;
export type VirtualPrinterDeleteMutationResult =
    ApolloReactCommon.MutationResult<GQVirtualPrinterDeleteMutation>;
export type VirtualPrinterDeleteMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQVirtualPrinterDeleteMutation,
        GQVirtualPrinterDeleteMutationVariables
    >;
export const VirtualPrinterFormDocument = gql`
    query virtualPrinterForm {
        departments(
            pagination: { pageSize: 999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
            }
        }
        printers(
            pagination: { pageSize: 999, sort: "name", sortDirection: "ASC" }
        ) {
            data {
                id
                name
                type
                class
                manufacturer
            }
        }
    }
`;

/**
 * __useVirtualPrinterFormQuery__
 *
 * To run a query within a React component, call `useVirtualPrinterFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualPrinterFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualPrinterFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useVirtualPrinterFormQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQVirtualPrinterFormQuery,
        GQVirtualPrinterFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQVirtualPrinterFormQuery,
        GQVirtualPrinterFormQueryVariables
    >(VirtualPrinterFormDocument, options);
}
export function useVirtualPrinterFormLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQVirtualPrinterFormQuery,
        GQVirtualPrinterFormQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQVirtualPrinterFormQuery,
        GQVirtualPrinterFormQueryVariables
    >(VirtualPrinterFormDocument, options);
}
// @ts-ignore
export function useVirtualPrinterFormSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQVirtualPrinterFormQuery,
        GQVirtualPrinterFormQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVirtualPrinterFormQuery,
    GQVirtualPrinterFormQueryVariables
>;
export function useVirtualPrinterFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVirtualPrinterFormQuery,
              GQVirtualPrinterFormQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQVirtualPrinterFormQuery | undefined,
    GQVirtualPrinterFormQueryVariables
>;
export function useVirtualPrinterFormSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQVirtualPrinterFormQuery,
              GQVirtualPrinterFormQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQVirtualPrinterFormQuery,
        GQVirtualPrinterFormQueryVariables
    >(VirtualPrinterFormDocument, options);
}
export type VirtualPrinterFormQueryHookResult = ReturnType<
    typeof useVirtualPrinterFormQuery
>;
export type VirtualPrinterFormLazyQueryHookResult = ReturnType<
    typeof useVirtualPrinterFormLazyQuery
>;
export type VirtualPrinterFormSuspenseQueryHookResult = ReturnType<
    typeof useVirtualPrinterFormSuspenseQuery
>;
export type VirtualPrinterFormQueryResult = ApolloReactCommon.QueryResult<
    GQVirtualPrinterFormQuery,
    GQVirtualPrinterFormQueryVariables
>;
export const AccountBuyFundsDocument = gql`
    mutation accountBuyFunds(
        $accountId: ID!
        $amount: Float!
        $orderId: ID!
        $userId: ID!
        $tagId: ID!
        $tagIdentifier: String!
    ) {
        accountBuyFunds(
            id: $accountId
            amount: $amount
            orderId: $orderId
            userId: $userId
            tagId: $tagId
            tagIdentifier: $tagIdentifier
        ) {
            status
            transactionId
        }
    }
`;
export type GQAccountBuyFundsMutationFn = ApolloReactCommon.MutationFunction<
    GQAccountBuyFundsMutation,
    GQAccountBuyFundsMutationVariables
>;

/**
 * __useAccountBuyFundsMutation__
 *
 * To run a mutation, you first call `useAccountBuyFundsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountBuyFundsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountBuyFundsMutation, { data, loading, error }] = useAccountBuyFundsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      amount: // value for 'amount'
 *      orderId: // value for 'orderId'
 *      userId: // value for 'userId'
 *      tagId: // value for 'tagId'
 *      tagIdentifier: // value for 'tagIdentifier'
 *   },
 * });
 */
export function useAccountBuyFundsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountBuyFundsMutation,
        GQAccountBuyFundsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountBuyFundsMutation,
        GQAccountBuyFundsMutationVariables
    >(AccountBuyFundsDocument, options);
}
export type AccountBuyFundsMutationHookResult = ReturnType<
    typeof useAccountBuyFundsMutation
>;
export type AccountBuyFundsMutationResult =
    ApolloReactCommon.MutationResult<GQAccountBuyFundsMutation>;
export type AccountBuyFundsMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAccountBuyFundsMutation,
        GQAccountBuyFundsMutationVariables
    >;
export const AccountReturnFundsDocument = gql`
    mutation accountReturnFunds(
        $accountId: ID!
        $amount: Float!
        $orderId: ID!
        $userId: ID!
        $tagId: ID!
        $tagIdentifier: String!
    ) {
        accountReturnFunds(
            id: $accountId
            amount: $amount
            orderId: $orderId
            userId: $userId
            tagId: $tagId
            tagIdentifier: $tagIdentifier
        ) {
            status
            transactionId
        }
    }
`;
export type GQAccountReturnFundsMutationFn = ApolloReactCommon.MutationFunction<
    GQAccountReturnFundsMutation,
    GQAccountReturnFundsMutationVariables
>;

/**
 * __useAccountReturnFundsMutation__
 *
 * To run a mutation, you first call `useAccountReturnFundsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountReturnFundsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountReturnFundsMutation, { data, loading, error }] = useAccountReturnFundsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      amount: // value for 'amount'
 *      orderId: // value for 'orderId'
 *      userId: // value for 'userId'
 *      tagId: // value for 'tagId'
 *      tagIdentifier: // value for 'tagIdentifier'
 *   },
 * });
 */
export function useAccountReturnFundsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountReturnFundsMutation,
        GQAccountReturnFundsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountReturnFundsMutation,
        GQAccountReturnFundsMutationVariables
    >(AccountReturnFundsDocument, options);
}
export type AccountReturnFundsMutationHookResult = ReturnType<
    typeof useAccountReturnFundsMutation
>;
export type AccountReturnFundsMutationResult =
    ApolloReactCommon.MutationResult<GQAccountReturnFundsMutation>;
export type AccountReturnFundsMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAccountReturnFundsMutation,
        GQAccountReturnFundsMutationVariables
    >;
export const AccountRevertTransactionDocument = gql`
    mutation accountRevertTransaction(
        $accountId: ID!
        $transactionId: ID!
        $userId: ID!
    ) {
        accountRevertTransaction(
            id: $accountId
            transactionId: $transactionId
            userId: $userId
        ) {
            status
        }
    }
`;
export type GQAccountRevertTransactionMutationFn =
    ApolloReactCommon.MutationFunction<
        GQAccountRevertTransactionMutation,
        GQAccountRevertTransactionMutationVariables
    >;

/**
 * __useAccountRevertTransactionMutation__
 *
 * To run a mutation, you first call `useAccountRevertTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRevertTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRevertTransactionMutation, { data, loading, error }] = useAccountRevertTransactionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      transactionId: // value for 'transactionId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountRevertTransactionMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAccountRevertTransactionMutation,
        GQAccountRevertTransactionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAccountRevertTransactionMutation,
        GQAccountRevertTransactionMutationVariables
    >(AccountRevertTransactionDocument, options);
}
export type AccountRevertTransactionMutationHookResult = ReturnType<
    typeof useAccountRevertTransactionMutation
>;
export type AccountRevertTransactionMutationResult =
    ApolloReactCommon.MutationResult<GQAccountRevertTransactionMutation>;
export type AccountRevertTransactionMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAccountRevertTransactionMutation,
        GQAccountRevertTransactionMutationVariables
    >;
export const AccountBalanceDocument = gql`
    query accountBalance(
        $id: ID!
        $numberOfTransactions: Int
        $printWidth: Int
    ) {
        account(id: $id) {
            amount
            balance(
                numberOfTransactions: $numberOfTransactions
                printWidth: $printWidth
            ) {
                receipt
            }
        }
    }
`;

/**
 * __useAccountBalanceQuery__
 *
 * To run a query within a React component, call `useAccountBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBalanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      numberOfTransactions: // value for 'numberOfTransactions'
 *      printWidth: // value for 'printWidth'
 *   },
 * });
 */
export function useAccountBalanceQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQAccountBalanceQuery,
        GQAccountBalanceQueryVariables
    > &
        (
            | { variables: GQAccountBalanceQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAccountBalanceQuery,
        GQAccountBalanceQueryVariables
    >(AccountBalanceDocument, options);
}
export function useAccountBalanceLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAccountBalanceQuery,
        GQAccountBalanceQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAccountBalanceQuery,
        GQAccountBalanceQueryVariables
    >(AccountBalanceDocument, options);
}
// @ts-ignore
export function useAccountBalanceSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAccountBalanceQuery,
        GQAccountBalanceQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountBalanceQuery,
    GQAccountBalanceQueryVariables
>;
export function useAccountBalanceSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountBalanceQuery,
              GQAccountBalanceQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountBalanceQuery | undefined,
    GQAccountBalanceQueryVariables
>;
export function useAccountBalanceSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountBalanceQuery,
              GQAccountBalanceQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAccountBalanceQuery,
        GQAccountBalanceQueryVariables
    >(AccountBalanceDocument, options);
}
export type AccountBalanceQueryHookResult = ReturnType<
    typeof useAccountBalanceQuery
>;
export type AccountBalanceLazyQueryHookResult = ReturnType<
    typeof useAccountBalanceLazyQuery
>;
export type AccountBalanceSuspenseQueryHookResult = ReturnType<
    typeof useAccountBalanceSuspenseQuery
>;
export type AccountBalanceQueryResult = ApolloReactCommon.QueryResult<
    GQAccountBalanceQuery,
    GQAccountBalanceQueryVariables
>;
export const AppDataDocument = gql`
    query appData {
        me {
            cashRegister {
                appData {
                    structVersion
                    minimumStructVersion
                    cashRegister {
                        id
                        serialId
                        name
                        department {
                            id
                            name
                        }
                    }
                    merchant {
                        id
                        serialId
                        name
                        giftcardVatBookkeepingMethod
                    }
                    deviceConfig
                    productGroups {
                        id
                        name
                        vat {
                            id
                            name
                            percentage
                        }
                        color
                        excludeFromDiscounts
                        printer {
                            id
                            name
                            serial
                        }
                        createdAt
                    }
                    vats {
                        id
                        name
                        percentage
                    }
                    products {
                        id
                        name
                        externalId
                        amount
                        buttonText
                        vat {
                            id
                            name
                            percentage
                        }
                        minimumAmount
                        costAmount
                        excludeFromDiscounts
                        plu
                        barcodes {
                            barcode
                        }
                        group {
                            id
                            name
                            color
                            printer {
                                id
                                name
                                serial
                            }
                        }
                        printer {
                            id
                            name
                            serial
                        }
                        inheritPrinter
                        discountTemplate {
                            name
                            type
                            value
                            color
                        }
                        viProductRelations {
                            value
                            viProduct {
                                id
                            }
                            measurementUnit {
                                id
                            }
                        }
                    }
                    discounts {
                        lineDescription
                        type
                        valueType
                        value
                        maxPerOrder
                        itemQuery
                        conditions
                    }
                    layout {
                        ...allPosProductLayoutFields
                    }
                    layoutEntities {
                        ...allLayoutEntityFields
                    }
                    tableLayout {
                        ...allLayoutFields
                    }
                    paymentConfiguration {
                        ...allPaymentConfigurationFields
                    }
                    miscButtons {
                        ...allMiscButtonsFields
                    }
                    tags {
                        id
                        identifier
                        tagType
                        name
                        group {
                            id
                            name
                        }
                        account {
                            id
                            name
                            amount
                            status
                            type
                            vat {
                                id
                                percentage
                            }
                        }
                        customer {
                            id
                            name
                            group {
                                id
                                name
                            }
                        }
                    }
                    printers {
                        id
                        name
                        serial
                        type
                        class
                        manufacturer
                    }
                    bookkeepingAccounts {
                        id
                        name
                        systemLabel
                    }
                    cmpEvents {
                        id
                        externalId
                        name
                        active
                        from
                        to
                        products {
                            id
                            externalId
                            name
                            amount
                            group {
                                id
                            }
                            active
                            calendar
                            sms
                        }
                    }
                    cmpProducts {
                        id
                        externalId
                        type
                        name
                        active
                        amount
                        sms
                        group {
                            id
                        }
                    }
                    fiskaly {
                        ...fiskalyConfigurationFields
                    }
                    viProducts {
                        id
                        name
                        measurementUnit {
                            id
                            name
                        }
                    }
                    virtualPrinters {
                        id
                        name
                        printer {
                            id
                        }
                        departments {
                            department {
                                id
                            }
                            printer {
                                id
                            }
                        }
                    }
                    approvals {
                        id
                        type
                        approvalTokens {
                            id
                            name
                            value
                            type
                        }
                        approvalTokenGroups {
                            id
                            name
                            approvalTokens {
                                id
                                name
                                value
                                type
                            }
                        }
                    }
                }
            }
        }
    }
    ${AllPosProductLayoutFieldsFragmentDoc}
    ${AllLayoutEntityFieldsFragmentDoc}
    ${AllLayoutFieldsFragmentDoc}
    ${AllPaymentConfigurationFieldsFragmentDoc}
    ${AllMiscButtonsFieldsFragmentDoc}
    ${FiskalyConfigurationFieldsFragmentDoc}
`;

/**
 * __useAppDataQuery__
 *
 * To run a query within a React component, call `useAppDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppDataQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQAppDataQuery,
        GQAppDataQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQAppDataQuery, GQAppDataQueryVariables>(
        AppDataDocument,
        options
    );
}
export function useAppDataLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAppDataQuery,
        GQAppDataQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAppDataQuery,
        GQAppDataQueryVariables
    >(AppDataDocument, options);
}
// @ts-ignore
export function useAppDataSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAppDataQuery,
        GQAppDataQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAppDataQuery,
    GQAppDataQueryVariables
>;
export function useAppDataSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAppDataQuery,
              GQAppDataQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAppDataQuery | undefined,
    GQAppDataQueryVariables
>;
export function useAppDataSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAppDataQuery,
              GQAppDataQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAppDataQuery,
        GQAppDataQueryVariables
    >(AppDataDocument, options);
}
export type AppDataQueryHookResult = ReturnType<typeof useAppDataQuery>;
export type AppDataLazyQueryHookResult = ReturnType<typeof useAppDataLazyQuery>;
export type AppDataSuspenseQueryHookResult = ReturnType<
    typeof useAppDataSuspenseQuery
>;
export type AppDataQueryResult = ApolloReactCommon.QueryResult<
    GQAppDataQuery,
    GQAppDataQueryVariables
>;
export const CmpEventCreateOrderDocument = gql`
    mutation cmpEventCreateOrder($order: CmpEventCreateType!) {
        cmpEventCreateOrder(order: $order) {
            orderId
            receipts {
                url
                title
                description
                code
            }
            productItems {
                itemId
                value
                shouldPrint
                title
                description
            }
        }
    }
`;
export type GQCmpEventCreateOrderMutationFn =
    ApolloReactCommon.MutationFunction<
        GQCmpEventCreateOrderMutation,
        GQCmpEventCreateOrderMutationVariables
    >;

/**
 * __useCmpEventCreateOrderMutation__
 *
 * To run a mutation, you first call `useCmpEventCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCmpEventCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cmpEventCreateOrderMutation, { data, loading, error }] = useCmpEventCreateOrderMutation({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCmpEventCreateOrderMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCmpEventCreateOrderMutation,
        GQCmpEventCreateOrderMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCmpEventCreateOrderMutation,
        GQCmpEventCreateOrderMutationVariables
    >(CmpEventCreateOrderDocument, options);
}
export type CmpEventCreateOrderMutationHookResult = ReturnType<
    typeof useCmpEventCreateOrderMutation
>;
export type CmpEventCreateOrderMutationResult =
    ApolloReactCommon.MutationResult<GQCmpEventCreateOrderMutation>;
export type CmpEventCreateOrderMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCmpEventCreateOrderMutation,
        GQCmpEventCreateOrderMutationVariables
    >;
export const CmpGiftcardBalanceDocument = gql`
    query cmpGiftcardBalance($code: String!) {
        cmpGiftcardBalance(code: $code) {
            amount
            expirationDate
            status
        }
    }
`;

/**
 * __useCmpGiftcardBalanceQuery__
 *
 * To run a query within a React component, call `useCmpGiftcardBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmpGiftcardBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmpGiftcardBalanceQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCmpGiftcardBalanceQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCmpGiftcardBalanceQuery,
        GQCmpGiftcardBalanceQueryVariables
    > &
        (
            | { variables: GQCmpGiftcardBalanceQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCmpGiftcardBalanceQuery,
        GQCmpGiftcardBalanceQueryVariables
    >(CmpGiftcardBalanceDocument, options);
}
export function useCmpGiftcardBalanceLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCmpGiftcardBalanceQuery,
        GQCmpGiftcardBalanceQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCmpGiftcardBalanceQuery,
        GQCmpGiftcardBalanceQueryVariables
    >(CmpGiftcardBalanceDocument, options);
}
// @ts-ignore
export function useCmpGiftcardBalanceSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCmpGiftcardBalanceQuery,
        GQCmpGiftcardBalanceQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpGiftcardBalanceQuery,
    GQCmpGiftcardBalanceQueryVariables
>;
export function useCmpGiftcardBalanceSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpGiftcardBalanceQuery,
              GQCmpGiftcardBalanceQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpGiftcardBalanceQuery | undefined,
    GQCmpGiftcardBalanceQueryVariables
>;
export function useCmpGiftcardBalanceSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpGiftcardBalanceQuery,
              GQCmpGiftcardBalanceQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCmpGiftcardBalanceQuery,
        GQCmpGiftcardBalanceQueryVariables
    >(CmpGiftcardBalanceDocument, options);
}
export type CmpGiftcardBalanceQueryHookResult = ReturnType<
    typeof useCmpGiftcardBalanceQuery
>;
export type CmpGiftcardBalanceLazyQueryHookResult = ReturnType<
    typeof useCmpGiftcardBalanceLazyQuery
>;
export type CmpGiftcardBalanceSuspenseQueryHookResult = ReturnType<
    typeof useCmpGiftcardBalanceSuspenseQuery
>;
export type CmpGiftcardBalanceQueryResult = ApolloReactCommon.QueryResult<
    GQCmpGiftcardBalanceQuery,
    GQCmpGiftcardBalanceQueryVariables
>;
export const FiskalyAccessTokenDocument = gql`
    query fiskalyAccessToken {
        fiskalyAccessToken {
            ...accessTokenFields
        }
    }
    ${AccessTokenFieldsFragmentDoc}
`;

/**
 * __useFiskalyAccessTokenQuery__
 *
 * To run a query within a React component, call `useFiskalyAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyAccessTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useFiskalyAccessTokenQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQFiskalyAccessTokenQuery,
        GQFiskalyAccessTokenQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyAccessTokenQuery,
        GQFiskalyAccessTokenQueryVariables
    >(FiskalyAccessTokenDocument, options);
}
export function useFiskalyAccessTokenLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyAccessTokenQuery,
        GQFiskalyAccessTokenQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyAccessTokenQuery,
        GQFiskalyAccessTokenQueryVariables
    >(FiskalyAccessTokenDocument, options);
}
// @ts-ignore
export function useFiskalyAccessTokenSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyAccessTokenQuery,
        GQFiskalyAccessTokenQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyAccessTokenQuery,
    GQFiskalyAccessTokenQueryVariables
>;
export function useFiskalyAccessTokenSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyAccessTokenQuery,
              GQFiskalyAccessTokenQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyAccessTokenQuery | undefined,
    GQFiskalyAccessTokenQueryVariables
>;
export function useFiskalyAccessTokenSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyAccessTokenQuery,
              GQFiskalyAccessTokenQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyAccessTokenQuery,
        GQFiskalyAccessTokenQueryVariables
    >(FiskalyAccessTokenDocument, options);
}
export type FiskalyAccessTokenQueryHookResult = ReturnType<
    typeof useFiskalyAccessTokenQuery
>;
export type FiskalyAccessTokenLazyQueryHookResult = ReturnType<
    typeof useFiskalyAccessTokenLazyQuery
>;
export type FiskalyAccessTokenSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyAccessTokenSuspenseQuery
>;
export type FiskalyAccessTokenQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyAccessTokenQuery,
    GQFiskalyAccessTokenQueryVariables
>;
export const FiskalyRefreshTokenDocument = gql`
    query fiskalyRefreshToken($refreshToken: String!) {
        fiskalyRefreshToken(refreshToken: $refreshToken) {
            ...accessTokenFields
        }
    }
    ${AccessTokenFieldsFragmentDoc}
`;

/**
 * __useFiskalyRefreshTokenQuery__
 *
 * To run a query within a React component, call `useFiskalyRefreshTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiskalyRefreshTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiskalyRefreshTokenQuery({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useFiskalyRefreshTokenQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQFiskalyRefreshTokenQuery,
        GQFiskalyRefreshTokenQueryVariables
    > &
        (
            | { variables: GQFiskalyRefreshTokenQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQFiskalyRefreshTokenQuery,
        GQFiskalyRefreshTokenQueryVariables
    >(FiskalyRefreshTokenDocument, options);
}
export function useFiskalyRefreshTokenLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQFiskalyRefreshTokenQuery,
        GQFiskalyRefreshTokenQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQFiskalyRefreshTokenQuery,
        GQFiskalyRefreshTokenQueryVariables
    >(FiskalyRefreshTokenDocument, options);
}
// @ts-ignore
export function useFiskalyRefreshTokenSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQFiskalyRefreshTokenQuery,
        GQFiskalyRefreshTokenQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyRefreshTokenQuery,
    GQFiskalyRefreshTokenQueryVariables
>;
export function useFiskalyRefreshTokenSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyRefreshTokenQuery,
              GQFiskalyRefreshTokenQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQFiskalyRefreshTokenQuery | undefined,
    GQFiskalyRefreshTokenQueryVariables
>;
export function useFiskalyRefreshTokenSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQFiskalyRefreshTokenQuery,
              GQFiskalyRefreshTokenQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQFiskalyRefreshTokenQuery,
        GQFiskalyRefreshTokenQueryVariables
    >(FiskalyRefreshTokenDocument, options);
}
export type FiskalyRefreshTokenQueryHookResult = ReturnType<
    typeof useFiskalyRefreshTokenQuery
>;
export type FiskalyRefreshTokenLazyQueryHookResult = ReturnType<
    typeof useFiskalyRefreshTokenLazyQuery
>;
export type FiskalyRefreshTokenSuspenseQueryHookResult = ReturnType<
    typeof useFiskalyRefreshTokenSuspenseQuery
>;
export type FiskalyRefreshTokenQueryResult = ApolloReactCommon.QueryResult<
    GQFiskalyRefreshTokenQuery,
    GQFiskalyRefreshTokenQueryVariables
>;
export const AccountsByCustomerSearchDocument = gql`
    query accountsByCustomerSearch(
        $pagination: PaginationInput
        $search: SearchInput
    ) {
        accountsByCustomerSearch(pagination: $pagination, search: $search) {
            data {
                id
                name
                customer {
                    id
                    name
                    phoneNumber
                }
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useAccountsByCustomerSearchQuery__
 *
 * To run a query within a React component, call `useAccountsByCustomerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsByCustomerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsByCustomerSearchQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAccountsByCustomerSearchQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQAccountsByCustomerSearchQuery,
        GQAccountsByCustomerSearchQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAccountsByCustomerSearchQuery,
        GQAccountsByCustomerSearchQueryVariables
    >(AccountsByCustomerSearchDocument, options);
}
export function useAccountsByCustomerSearchLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAccountsByCustomerSearchQuery,
        GQAccountsByCustomerSearchQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAccountsByCustomerSearchQuery,
        GQAccountsByCustomerSearchQueryVariables
    >(AccountsByCustomerSearchDocument, options);
}
// @ts-ignore
export function useAccountsByCustomerSearchSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAccountsByCustomerSearchQuery,
        GQAccountsByCustomerSearchQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountsByCustomerSearchQuery,
    GQAccountsByCustomerSearchQueryVariables
>;
export function useAccountsByCustomerSearchSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountsByCustomerSearchQuery,
              GQAccountsByCustomerSearchQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccountsByCustomerSearchQuery | undefined,
    GQAccountsByCustomerSearchQueryVariables
>;
export function useAccountsByCustomerSearchSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccountsByCustomerSearchQuery,
              GQAccountsByCustomerSearchQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAccountsByCustomerSearchQuery,
        GQAccountsByCustomerSearchQueryVariables
    >(AccountsByCustomerSearchDocument, options);
}
export type AccountsByCustomerSearchQueryHookResult = ReturnType<
    typeof useAccountsByCustomerSearchQuery
>;
export type AccountsByCustomerSearchLazyQueryHookResult = ReturnType<
    typeof useAccountsByCustomerSearchLazyQuery
>;
export type AccountsByCustomerSearchSuspenseQueryHookResult = ReturnType<
    typeof useAccountsByCustomerSearchSuspenseQuery
>;
export type AccountsByCustomerSearchQueryResult = ApolloReactCommon.QueryResult<
    GQAccountsByCustomerSearchQuery,
    GQAccountsByCustomerSearchQueryVariables
>;
export const CmpGiftcardPayAmountDocument = gql`
    mutation cmpGiftcardPayAmount(
        $id: ID!
        $orderId: ID!
        $amount: Float!
        $userId: ID!
        $code: String
    ) {
        cmpGiftcardPayAmount(
            id: $id
            orderId: $orderId
            amount: $amount
            userId: $userId
            code: $code
        ) {
            transactionId
            status
            receipt
            amount
            balance
            createdAt
        }
    }
`;
export type GQCmpGiftcardPayAmountMutationFn =
    ApolloReactCommon.MutationFunction<
        GQCmpGiftcardPayAmountMutation,
        GQCmpGiftcardPayAmountMutationVariables
    >;

/**
 * __useCmpGiftcardPayAmountMutation__
 *
 * To run a mutation, you first call `useCmpGiftcardPayAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCmpGiftcardPayAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cmpGiftcardPayAmountMutation, { data, loading, error }] = useCmpGiftcardPayAmountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orderId: // value for 'orderId'
 *      amount: // value for 'amount'
 *      userId: // value for 'userId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCmpGiftcardPayAmountMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCmpGiftcardPayAmountMutation,
        GQCmpGiftcardPayAmountMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCmpGiftcardPayAmountMutation,
        GQCmpGiftcardPayAmountMutationVariables
    >(CmpGiftcardPayAmountDocument, options);
}
export type CmpGiftcardPayAmountMutationHookResult = ReturnType<
    typeof useCmpGiftcardPayAmountMutation
>;
export type CmpGiftcardPayAmountMutationResult =
    ApolloReactCommon.MutationResult<GQCmpGiftcardPayAmountMutation>;
export type CmpGiftcardPayAmountMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCmpGiftcardPayAmountMutation,
        GQCmpGiftcardPayAmountMutationVariables
    >;
export const CmpGiftcardRefundAmountDocument = gql`
    mutation cmpGiftcardRefundAmount(
        $id: ID!
        $orderId: ID!
        $amount: Float!
        $userId: ID!
        $code: String
    ) {
        cmpGiftcardRefundAmount(
            id: $id
            orderId: $orderId
            amount: $amount
            userId: $userId
            code: $code
        ) {
            transactionId
            status
            receipt
            amount
            balance
            createdAt
        }
    }
`;
export type GQCmpGiftcardRefundAmountMutationFn =
    ApolloReactCommon.MutationFunction<
        GQCmpGiftcardRefundAmountMutation,
        GQCmpGiftcardRefundAmountMutationVariables
    >;

/**
 * __useCmpGiftcardRefundAmountMutation__
 *
 * To run a mutation, you first call `useCmpGiftcardRefundAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCmpGiftcardRefundAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cmpGiftcardRefundAmountMutation, { data, loading, error }] = useCmpGiftcardRefundAmountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orderId: // value for 'orderId'
 *      amount: // value for 'amount'
 *      userId: // value for 'userId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCmpGiftcardRefundAmountMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQCmpGiftcardRefundAmountMutation,
        GQCmpGiftcardRefundAmountMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQCmpGiftcardRefundAmountMutation,
        GQCmpGiftcardRefundAmountMutationVariables
    >(CmpGiftcardRefundAmountDocument, options);
}
export type CmpGiftcardRefundAmountMutationHookResult = ReturnType<
    typeof useCmpGiftcardRefundAmountMutation
>;
export type CmpGiftcardRefundAmountMutationResult =
    ApolloReactCommon.MutationResult<GQCmpGiftcardRefundAmountMutation>;
export type CmpGiftcardRefundAmountMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQCmpGiftcardRefundAmountMutation,
        GQCmpGiftcardRefundAmountMutationVariables
    >;
export const CmpInvoiceCustomerSearchDocument = gql`
    query cmpInvoiceCustomerSearch($value: String!) {
        cmpInvoiceCustomerSearch(value: $value) {
            customers {
                id
                name
                email
                phone
                company
                address
                paymentMethods {
                    type
                    allowed
                    description
                }
            }
            resultsFoundCount
            status
        }
    }
`;

/**
 * __useCmpInvoiceCustomerSearchQuery__
 *
 * To run a query within a React component, call `useCmpInvoiceCustomerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmpInvoiceCustomerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmpInvoiceCustomerSearchQuery({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCmpInvoiceCustomerSearchQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCmpInvoiceCustomerSearchQuery,
        GQCmpInvoiceCustomerSearchQueryVariables
    > &
        (
            | {
                  variables: GQCmpInvoiceCustomerSearchQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCmpInvoiceCustomerSearchQuery,
        GQCmpInvoiceCustomerSearchQueryVariables
    >(CmpInvoiceCustomerSearchDocument, options);
}
export function useCmpInvoiceCustomerSearchLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCmpInvoiceCustomerSearchQuery,
        GQCmpInvoiceCustomerSearchQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCmpInvoiceCustomerSearchQuery,
        GQCmpInvoiceCustomerSearchQueryVariables
    >(CmpInvoiceCustomerSearchDocument, options);
}
// @ts-ignore
export function useCmpInvoiceCustomerSearchSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCmpInvoiceCustomerSearchQuery,
        GQCmpInvoiceCustomerSearchQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpInvoiceCustomerSearchQuery,
    GQCmpInvoiceCustomerSearchQueryVariables
>;
export function useCmpInvoiceCustomerSearchSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpInvoiceCustomerSearchQuery,
              GQCmpInvoiceCustomerSearchQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCmpInvoiceCustomerSearchQuery | undefined,
    GQCmpInvoiceCustomerSearchQueryVariables
>;
export function useCmpInvoiceCustomerSearchSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCmpInvoiceCustomerSearchQuery,
              GQCmpInvoiceCustomerSearchQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCmpInvoiceCustomerSearchQuery,
        GQCmpInvoiceCustomerSearchQueryVariables
    >(CmpInvoiceCustomerSearchDocument, options);
}
export type CmpInvoiceCustomerSearchQueryHookResult = ReturnType<
    typeof useCmpInvoiceCustomerSearchQuery
>;
export type CmpInvoiceCustomerSearchLazyQueryHookResult = ReturnType<
    typeof useCmpInvoiceCustomerSearchLazyQuery
>;
export type CmpInvoiceCustomerSearchSuspenseQueryHookResult = ReturnType<
    typeof useCmpInvoiceCustomerSearchSuspenseQuery
>;
export type CmpInvoiceCustomerSearchQueryResult = ApolloReactCommon.QueryResult<
    GQCmpInvoiceCustomerSearchQuery,
    GQCmpInvoiceCustomerSearchQueryVariables
>;
export const SoftpayAccessTokenDocument = gql`
    query softpayAccessToken {
        softpayAccessToken {
            accessToken
            expiresIn
            tokenType
        }
    }
`;

/**
 * __useSoftpayAccessTokenQuery__
 *
 * To run a query within a React component, call `useSoftpayAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftpayAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftpayAccessTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useSoftpayAccessTokenQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQSoftpayAccessTokenQuery,
        GQSoftpayAccessTokenQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQSoftpayAccessTokenQuery,
        GQSoftpayAccessTokenQueryVariables
    >(SoftpayAccessTokenDocument, options);
}
export function useSoftpayAccessTokenLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQSoftpayAccessTokenQuery,
        GQSoftpayAccessTokenQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQSoftpayAccessTokenQuery,
        GQSoftpayAccessTokenQueryVariables
    >(SoftpayAccessTokenDocument, options);
}
// @ts-ignore
export function useSoftpayAccessTokenSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQSoftpayAccessTokenQuery,
        GQSoftpayAccessTokenQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayAccessTokenQuery,
    GQSoftpayAccessTokenQueryVariables
>;
export function useSoftpayAccessTokenSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayAccessTokenQuery,
              GQSoftpayAccessTokenQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayAccessTokenQuery | undefined,
    GQSoftpayAccessTokenQueryVariables
>;
export function useSoftpayAccessTokenSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayAccessTokenQuery,
              GQSoftpayAccessTokenQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQSoftpayAccessTokenQuery,
        GQSoftpayAccessTokenQueryVariables
    >(SoftpayAccessTokenDocument, options);
}
export type SoftpayAccessTokenQueryHookResult = ReturnType<
    typeof useSoftpayAccessTokenQuery
>;
export type SoftpayAccessTokenLazyQueryHookResult = ReturnType<
    typeof useSoftpayAccessTokenLazyQuery
>;
export type SoftpayAccessTokenSuspenseQueryHookResult = ReturnType<
    typeof useSoftpayAccessTokenSuspenseQuery
>;
export type SoftpayAccessTokenQueryResult = ApolloReactCommon.QueryResult<
    GQSoftpayAccessTokenQuery,
    GQSoftpayAccessTokenQueryVariables
>;
export const SoftpayCloudTerminalsDocument = gql`
    query softpayCloudTerminals($pagination: PaginationInput) {
        softpayCloudTerminals(pagination: $pagination) {
            data {
                ...softpayCloudTerminalFields
            }
            pagination {
                ...defaultPaginationFields
            }
        }
    }
    ${SoftpayCloudTerminalFieldsFragmentDoc}
    ${DefaultPaginationFieldsFragmentDoc}
`;

/**
 * __useSoftpayCloudTerminalsQuery__
 *
 * To run a query within a React component, call `useSoftpayCloudTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftpayCloudTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftpayCloudTerminalsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSoftpayCloudTerminalsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQSoftpayCloudTerminalsQuery,
        GQSoftpayCloudTerminalsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQSoftpayCloudTerminalsQuery,
        GQSoftpayCloudTerminalsQueryVariables
    >(SoftpayCloudTerminalsDocument, options);
}
export function useSoftpayCloudTerminalsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQSoftpayCloudTerminalsQuery,
        GQSoftpayCloudTerminalsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQSoftpayCloudTerminalsQuery,
        GQSoftpayCloudTerminalsQueryVariables
    >(SoftpayCloudTerminalsDocument, options);
}
// @ts-ignore
export function useSoftpayCloudTerminalsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQSoftpayCloudTerminalsQuery,
        GQSoftpayCloudTerminalsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayCloudTerminalsQuery,
    GQSoftpayCloudTerminalsQueryVariables
>;
export function useSoftpayCloudTerminalsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayCloudTerminalsQuery,
              GQSoftpayCloudTerminalsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSoftpayCloudTerminalsQuery | undefined,
    GQSoftpayCloudTerminalsQueryVariables
>;
export function useSoftpayCloudTerminalsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSoftpayCloudTerminalsQuery,
              GQSoftpayCloudTerminalsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQSoftpayCloudTerminalsQuery,
        GQSoftpayCloudTerminalsQueryVariables
    >(SoftpayCloudTerminalsDocument, options);
}
export type SoftpayCloudTerminalsQueryHookResult = ReturnType<
    typeof useSoftpayCloudTerminalsQuery
>;
export type SoftpayCloudTerminalsLazyQueryHookResult = ReturnType<
    typeof useSoftpayCloudTerminalsLazyQuery
>;
export type SoftpayCloudTerminalsSuspenseQueryHookResult = ReturnType<
    typeof useSoftpayCloudTerminalsSuspenseQuery
>;
export type SoftpayCloudTerminalsQueryResult = ApolloReactCommon.QueryResult<
    GQSoftpayCloudTerminalsQuery,
    GQSoftpayCloudTerminalsQueryVariables
>;
export const AccessTokenDocument = gql`
    query accessToken {
        accessToken {
            accessToken
        }
    }
`;

/**
 * __useAccessTokenQuery__
 *
 * To run a query within a React component, call `useAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessTokenQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQAccessTokenQuery,
        GQAccessTokenQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAccessTokenQuery,
        GQAccessTokenQueryVariables
    >(AccessTokenDocument, options);
}
export function useAccessTokenLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAccessTokenQuery,
        GQAccessTokenQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAccessTokenQuery,
        GQAccessTokenQueryVariables
    >(AccessTokenDocument, options);
}
// @ts-ignore
export function useAccessTokenSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAccessTokenQuery,
        GQAccessTokenQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccessTokenQuery,
    GQAccessTokenQueryVariables
>;
export function useAccessTokenSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccessTokenQuery,
              GQAccessTokenQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAccessTokenQuery | undefined,
    GQAccessTokenQueryVariables
>;
export function useAccessTokenSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAccessTokenQuery,
              GQAccessTokenQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAccessTokenQuery,
        GQAccessTokenQueryVariables
    >(AccessTokenDocument, options);
}
export type AccessTokenQueryHookResult = ReturnType<typeof useAccessTokenQuery>;
export type AccessTokenLazyQueryHookResult = ReturnType<
    typeof useAccessTokenLazyQuery
>;
export type AccessTokenSuspenseQueryHookResult = ReturnType<
    typeof useAccessTokenSuspenseQuery
>;
export type AccessTokenQueryResult = ApolloReactCommon.QueryResult<
    GQAccessTokenQuery,
    GQAccessTokenQueryVariables
>;
export const VenueAccessCheckoutTicketDocument = gql`
    mutation venueAccessCheckoutTicket(
        $eventId: Int!
        $accessTypes: [Int!]!
        $validFrom: Date!
        $validTo: Date!
    ) {
        venueAccessCreateAccessTicket(
            eventId: $eventId
            accessTypes: $accessTypes
            validFrom: $validFrom
            validTo: $validTo
        ) {
            tokenValue
            ticketId
        }
    }
`;
export type GQVenueAccessCheckoutTicketMutationFn =
    ApolloReactCommon.MutationFunction<
        GQVenueAccessCheckoutTicketMutation,
        GQVenueAccessCheckoutTicketMutationVariables
    >;

/**
 * __useVenueAccessCheckoutTicketMutation__
 *
 * To run a mutation, you first call `useVenueAccessCheckoutTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVenueAccessCheckoutTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [venueAccessCheckoutTicketMutation, { data, loading, error }] = useVenueAccessCheckoutTicketMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      accessTypes: // value for 'accessTypes'
 *      validFrom: // value for 'validFrom'
 *      validTo: // value for 'validTo'
 *   },
 * });
 */
export function useVenueAccessCheckoutTicketMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQVenueAccessCheckoutTicketMutation,
        GQVenueAccessCheckoutTicketMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQVenueAccessCheckoutTicketMutation,
        GQVenueAccessCheckoutTicketMutationVariables
    >(VenueAccessCheckoutTicketDocument, options);
}
export type VenueAccessCheckoutTicketMutationHookResult = ReturnType<
    typeof useVenueAccessCheckoutTicketMutation
>;
export type VenueAccessCheckoutTicketMutationResult =
    ApolloReactCommon.MutationResult<GQVenueAccessCheckoutTicketMutation>;
export type VenueAccessCheckoutTicketMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQVenueAccessCheckoutTicketMutation,
        GQVenueAccessCheckoutTicketMutationVariables
    >;
export const VenueAccessCheckoutTicketsDocument = gql`
    mutation venueAccessCheckoutTickets($tickets: [VenueAccessCreateType!]) {
        venueAccessCreateAccessTickets(tickets: $tickets) {
            tokenValue
            ticketId
        }
    }
`;
export type GQVenueAccessCheckoutTicketsMutationFn =
    ApolloReactCommon.MutationFunction<
        GQVenueAccessCheckoutTicketsMutation,
        GQVenueAccessCheckoutTicketsMutationVariables
    >;

/**
 * __useVenueAccessCheckoutTicketsMutation__
 *
 * To run a mutation, you first call `useVenueAccessCheckoutTicketsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVenueAccessCheckoutTicketsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [venueAccessCheckoutTicketsMutation, { data, loading, error }] = useVenueAccessCheckoutTicketsMutation({
 *   variables: {
 *      tickets: // value for 'tickets'
 *   },
 * });
 */
export function useVenueAccessCheckoutTicketsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQVenueAccessCheckoutTicketsMutation,
        GQVenueAccessCheckoutTicketsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQVenueAccessCheckoutTicketsMutation,
        GQVenueAccessCheckoutTicketsMutationVariables
    >(VenueAccessCheckoutTicketsDocument, options);
}
export type VenueAccessCheckoutTicketsMutationHookResult = ReturnType<
    typeof useVenueAccessCheckoutTicketsMutation
>;
export type VenueAccessCheckoutTicketsMutationResult =
    ApolloReactCommon.MutationResult<GQVenueAccessCheckoutTicketsMutation>;
export type VenueAccessCheckoutTicketsMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQVenueAccessCheckoutTicketsMutation,
        GQVenueAccessCheckoutTicketsMutationVariables
    >;
export const VenueAccessCancelTicketDocument = gql`
    mutation venueAccessCancelTicket($ticketId: Int!) {
        venueAccessCancelAccessTicket(ticketId: $ticketId) {
            status
        }
    }
`;
export type GQVenueAccessCancelTicketMutationFn =
    ApolloReactCommon.MutationFunction<
        GQVenueAccessCancelTicketMutation,
        GQVenueAccessCancelTicketMutationVariables
    >;

/**
 * __useVenueAccessCancelTicketMutation__
 *
 * To run a mutation, you first call `useVenueAccessCancelTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVenueAccessCancelTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [venueAccessCancelTicketMutation, { data, loading, error }] = useVenueAccessCancelTicketMutation({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useVenueAccessCancelTicketMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQVenueAccessCancelTicketMutation,
        GQVenueAccessCancelTicketMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQVenueAccessCancelTicketMutation,
        GQVenueAccessCancelTicketMutationVariables
    >(VenueAccessCancelTicketDocument, options);
}
export type VenueAccessCancelTicketMutationHookResult = ReturnType<
    typeof useVenueAccessCancelTicketMutation
>;
export type VenueAccessCancelTicketMutationResult =
    ApolloReactCommon.MutationResult<GQVenueAccessCancelTicketMutation>;
export type VenueAccessCancelTicketMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQVenueAccessCancelTicketMutation,
        GQVenueAccessCancelTicketMutationVariables
    >;
export const CanPeriodCardBeRenewedDocument = gql`
    query canPeriodCardBeRenewed(
        $productId: String!
        $cardToken: String
        $cardId: String
    ) {
        canPeriodCardBeRenewed(
            productId: $productId
            cardToken: $cardToken
            cardId: $cardId
        ) {
            status
            message
            cardToken
            cardId
        }
    }
`;

/**
 * __useCanPeriodCardBeRenewedQuery__
 *
 * To run a query within a React component, call `useCanPeriodCardBeRenewedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanPeriodCardBeRenewedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanPeriodCardBeRenewedQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      cardToken: // value for 'cardToken'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useCanPeriodCardBeRenewedQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCanPeriodCardBeRenewedQuery,
        GQCanPeriodCardBeRenewedQueryVariables
    > &
        (
            | {
                  variables: GQCanPeriodCardBeRenewedQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCanPeriodCardBeRenewedQuery,
        GQCanPeriodCardBeRenewedQueryVariables
    >(CanPeriodCardBeRenewedDocument, options);
}
export function useCanPeriodCardBeRenewedLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCanPeriodCardBeRenewedQuery,
        GQCanPeriodCardBeRenewedQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCanPeriodCardBeRenewedQuery,
        GQCanPeriodCardBeRenewedQueryVariables
    >(CanPeriodCardBeRenewedDocument, options);
}
// @ts-ignore
export function useCanPeriodCardBeRenewedSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCanPeriodCardBeRenewedQuery,
        GQCanPeriodCardBeRenewedQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCanPeriodCardBeRenewedQuery,
    GQCanPeriodCardBeRenewedQueryVariables
>;
export function useCanPeriodCardBeRenewedSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCanPeriodCardBeRenewedQuery,
              GQCanPeriodCardBeRenewedQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCanPeriodCardBeRenewedQuery | undefined,
    GQCanPeriodCardBeRenewedQueryVariables
>;
export function useCanPeriodCardBeRenewedSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCanPeriodCardBeRenewedQuery,
              GQCanPeriodCardBeRenewedQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCanPeriodCardBeRenewedQuery,
        GQCanPeriodCardBeRenewedQueryVariables
    >(CanPeriodCardBeRenewedDocument, options);
}
export type CanPeriodCardBeRenewedQueryHookResult = ReturnType<
    typeof useCanPeriodCardBeRenewedQuery
>;
export type CanPeriodCardBeRenewedLazyQueryHookResult = ReturnType<
    typeof useCanPeriodCardBeRenewedLazyQuery
>;
export type CanPeriodCardBeRenewedSuspenseQueryHookResult = ReturnType<
    typeof useCanPeriodCardBeRenewedSuspenseQuery
>;
export type CanPeriodCardBeRenewedQueryResult = ApolloReactCommon.QueryResult<
    GQCanPeriodCardBeRenewedQuery,
    GQCanPeriodCardBeRenewedQueryVariables
>;
export const CanPeriodCardBeUpgradedDocument = gql`
    query canPeriodCardBeUpgraded(
        $productId: String!
        $cardToken: String
        $cardId: String
    ) {
        canPeriodCardBeUpgraded(
            productId: $productId
            cardToken: $cardToken
            cardId: $cardId
        ) {
            status
            message
            cardToken
            cardId
        }
    }
`;

/**
 * __useCanPeriodCardBeUpgradedQuery__
 *
 * To run a query within a React component, call `useCanPeriodCardBeUpgradedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanPeriodCardBeUpgradedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanPeriodCardBeUpgradedQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      cardToken: // value for 'cardToken'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useCanPeriodCardBeUpgradedQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQCanPeriodCardBeUpgradedQuery,
        GQCanPeriodCardBeUpgradedQueryVariables
    > &
        (
            | {
                  variables: GQCanPeriodCardBeUpgradedQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQCanPeriodCardBeUpgradedQuery,
        GQCanPeriodCardBeUpgradedQueryVariables
    >(CanPeriodCardBeUpgradedDocument, options);
}
export function useCanPeriodCardBeUpgradedLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQCanPeriodCardBeUpgradedQuery,
        GQCanPeriodCardBeUpgradedQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQCanPeriodCardBeUpgradedQuery,
        GQCanPeriodCardBeUpgradedQueryVariables
    >(CanPeriodCardBeUpgradedDocument, options);
}
// @ts-ignore
export function useCanPeriodCardBeUpgradedSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQCanPeriodCardBeUpgradedQuery,
        GQCanPeriodCardBeUpgradedQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCanPeriodCardBeUpgradedQuery,
    GQCanPeriodCardBeUpgradedQueryVariables
>;
export function useCanPeriodCardBeUpgradedSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCanPeriodCardBeUpgradedQuery,
              GQCanPeriodCardBeUpgradedQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQCanPeriodCardBeUpgradedQuery | undefined,
    GQCanPeriodCardBeUpgradedQueryVariables
>;
export function useCanPeriodCardBeUpgradedSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQCanPeriodCardBeUpgradedQuery,
              GQCanPeriodCardBeUpgradedQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQCanPeriodCardBeUpgradedQuery,
        GQCanPeriodCardBeUpgradedQueryVariables
    >(CanPeriodCardBeUpgradedDocument, options);
}
export type CanPeriodCardBeUpgradedQueryHookResult = ReturnType<
    typeof useCanPeriodCardBeUpgradedQuery
>;
export type CanPeriodCardBeUpgradedLazyQueryHookResult = ReturnType<
    typeof useCanPeriodCardBeUpgradedLazyQuery
>;
export type CanPeriodCardBeUpgradedSuspenseQueryHookResult = ReturnType<
    typeof useCanPeriodCardBeUpgradedSuspenseQuery
>;
export type CanPeriodCardBeUpgradedQueryResult = ApolloReactCommon.QueryResult<
    GQCanPeriodCardBeUpgradedQuery,
    GQCanPeriodCardBeUpgradedQueryVariables
>;
export const MerchantDataUpdatedDocument = gql`
    subscription merchantDataUpdated {
        merchantDataUpdated
    }
`;

/**
 * __useMerchantDataUpdatedSubscription__
 *
 * To run a query within a React component, call `useMerchantDataUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMerchantDataUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantDataUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMerchantDataUpdatedSubscription(
    baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
        GQMerchantDataUpdatedSubscription,
        GQMerchantDataUpdatedSubscriptionVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSubscription<
        GQMerchantDataUpdatedSubscription,
        GQMerchantDataUpdatedSubscriptionVariables
    >(MerchantDataUpdatedDocument, options);
}
export type MerchantDataUpdatedSubscriptionHookResult = ReturnType<
    typeof useMerchantDataUpdatedSubscription
>;
export type MerchantDataUpdatedSubscriptionResult =
    ApolloReactCommon.SubscriptionResult<GQMerchantDataUpdatedSubscription>;
export const LogoDataUpdatedDocument = gql`
    subscription logoDataUpdated {
        logoDataUpdated
    }
`;

/**
 * __useLogoDataUpdatedSubscription__
 *
 * To run a query within a React component, call `useLogoDataUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLogoDataUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogoDataUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useLogoDataUpdatedSubscription(
    baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
        GQLogoDataUpdatedSubscription,
        GQLogoDataUpdatedSubscriptionVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSubscription<
        GQLogoDataUpdatedSubscription,
        GQLogoDataUpdatedSubscriptionVariables
    >(LogoDataUpdatedDocument, options);
}
export type LogoDataUpdatedSubscriptionHookResult = ReturnType<
    typeof useLogoDataUpdatedSubscription
>;
export type LogoDataUpdatedSubscriptionResult =
    ApolloReactCommon.SubscriptionResult<GQLogoDataUpdatedSubscription>;
export const InventoryForIdsDocument = gql`
    query inventoryForIds($ids: [ID!]!) {
        inventoryForIds(ids: $ids) {
            id
            quantity
            products {
                id
            }
        }
    }
`;

/**
 * __useInventoryForIdsQuery__
 *
 * To run a query within a React component, call `useInventoryForIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryForIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryForIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useInventoryForIdsQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQInventoryForIdsQuery,
        GQInventoryForIdsQueryVariables
    > &
        (
            | { variables: GQInventoryForIdsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQInventoryForIdsQuery,
        GQInventoryForIdsQueryVariables
    >(InventoryForIdsDocument, options);
}
export function useInventoryForIdsLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQInventoryForIdsQuery,
        GQInventoryForIdsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQInventoryForIdsQuery,
        GQInventoryForIdsQueryVariables
    >(InventoryForIdsDocument, options);
}
// @ts-ignore
export function useInventoryForIdsSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQInventoryForIdsQuery,
        GQInventoryForIdsQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInventoryForIdsQuery,
    GQInventoryForIdsQueryVariables
>;
export function useInventoryForIdsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInventoryForIdsQuery,
              GQInventoryForIdsQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQInventoryForIdsQuery | undefined,
    GQInventoryForIdsQueryVariables
>;
export function useInventoryForIdsSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQInventoryForIdsQuery,
              GQInventoryForIdsQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQInventoryForIdsQuery,
        GQInventoryForIdsQueryVariables
    >(InventoryForIdsDocument, options);
}
export type InventoryForIdsQueryHookResult = ReturnType<
    typeof useInventoryForIdsQuery
>;
export type InventoryForIdsLazyQueryHookResult = ReturnType<
    typeof useInventoryForIdsLazyQuery
>;
export type InventoryForIdsSuspenseQueryHookResult = ReturnType<
    typeof useInventoryForIdsSuspenseQuery
>;
export type InventoryForIdsQueryResult = ApolloReactCommon.QueryResult<
    GQInventoryForIdsQuery,
    GQInventoryForIdsQueryVariables
>;
export const SelectMerchantPosUserDocument = gql`
    query selectMerchantPosUser {
        me {
            cashRegister {
                name
                department {
                    name
                }
                merchant {
                    name
                }
            }
            merchant {
                id
                users {
                    ...allAuthUserFields
                }
            }
        }
    }
    ${AllAuthUserFieldsFragmentDoc}
`;

/**
 * __useSelectMerchantPosUserQuery__
 *
 * To run a query within a React component, call `useSelectMerchantPosUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectMerchantPosUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectMerchantPosUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectMerchantPosUserQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQSelectMerchantPosUserQuery,
        GQSelectMerchantPosUserQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQSelectMerchantPosUserQuery,
        GQSelectMerchantPosUserQueryVariables
    >(SelectMerchantPosUserDocument, options);
}
export function useSelectMerchantPosUserLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQSelectMerchantPosUserQuery,
        GQSelectMerchantPosUserQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQSelectMerchantPosUserQuery,
        GQSelectMerchantPosUserQueryVariables
    >(SelectMerchantPosUserDocument, options);
}
// @ts-ignore
export function useSelectMerchantPosUserSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQSelectMerchantPosUserQuery,
        GQSelectMerchantPosUserQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSelectMerchantPosUserQuery,
    GQSelectMerchantPosUserQueryVariables
>;
export function useSelectMerchantPosUserSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSelectMerchantPosUserQuery,
              GQSelectMerchantPosUserQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQSelectMerchantPosUserQuery | undefined,
    GQSelectMerchantPosUserQueryVariables
>;
export function useSelectMerchantPosUserSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQSelectMerchantPosUserQuery,
              GQSelectMerchantPosUserQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQSelectMerchantPosUserQuery,
        GQSelectMerchantPosUserQueryVariables
    >(SelectMerchantPosUserDocument, options);
}
export type SelectMerchantPosUserQueryHookResult = ReturnType<
    typeof useSelectMerchantPosUserQuery
>;
export type SelectMerchantPosUserLazyQueryHookResult = ReturnType<
    typeof useSelectMerchantPosUserLazyQuery
>;
export type SelectMerchantPosUserSuspenseQueryHookResult = ReturnType<
    typeof useSelectMerchantPosUserSuspenseQuery
>;
export type SelectMerchantPosUserQueryResult = ApolloReactCommon.QueryResult<
    GQSelectMerchantPosUserQuery,
    GQSelectMerchantPosUserQueryVariables
>;
export const AuthDevicePollDocument = gql`
    query authDevicePoll($deviceId: ID!, $devicePinCode: String!) {
        authDevicePoll(deviceId: $deviceId, devicePinCode: $devicePinCode) {
            ...allAuthTokenFields
        }
    }
    ${AllAuthTokenFieldsFragmentDoc}
`;

/**
 * __useAuthDevicePollQuery__
 *
 * To run a query within a React component, call `useAuthDevicePollQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthDevicePollQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthDevicePollQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      devicePinCode: // value for 'devicePinCode'
 *   },
 * });
 */
export function useAuthDevicePollQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQAuthDevicePollQuery,
        GQAuthDevicePollQueryVariables
    > &
        (
            | { variables: GQAuthDevicePollQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAuthDevicePollQuery,
        GQAuthDevicePollQueryVariables
    >(AuthDevicePollDocument, options);
}
export function useAuthDevicePollLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAuthDevicePollQuery,
        GQAuthDevicePollQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAuthDevicePollQuery,
        GQAuthDevicePollQueryVariables
    >(AuthDevicePollDocument, options);
}
// @ts-ignore
export function useAuthDevicePollSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAuthDevicePollQuery,
        GQAuthDevicePollQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAuthDevicePollQuery,
    GQAuthDevicePollQueryVariables
>;
export function useAuthDevicePollSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAuthDevicePollQuery,
              GQAuthDevicePollQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAuthDevicePollQuery | undefined,
    GQAuthDevicePollQueryVariables
>;
export function useAuthDevicePollSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAuthDevicePollQuery,
              GQAuthDevicePollQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAuthDevicePollQuery,
        GQAuthDevicePollQueryVariables
    >(AuthDevicePollDocument, options);
}
export type AuthDevicePollQueryHookResult = ReturnType<
    typeof useAuthDevicePollQuery
>;
export type AuthDevicePollLazyQueryHookResult = ReturnType<
    typeof useAuthDevicePollLazyQuery
>;
export type AuthDevicePollSuspenseQueryHookResult = ReturnType<
    typeof useAuthDevicePollSuspenseQuery
>;
export type AuthDevicePollQueryResult = ApolloReactCommon.QueryResult<
    GQAuthDevicePollQuery,
    GQAuthDevicePollQueryVariables
>;
export const AuthRefreshDocument = gql`
    query authRefresh($refreshToken: String!) {
        authRefresh(refreshToken: $refreshToken) {
            ...allAuthTokenFields
        }
    }
    ${AllAuthTokenFieldsFragmentDoc}
`;

/**
 * __useAuthRefreshQuery__
 *
 * To run a query within a React component, call `useAuthRefreshQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthRefreshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthRefreshQuery({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAuthRefreshQuery(
    baseOptions: ApolloReactHooks.QueryHookOptions<
        GQAuthRefreshQuery,
        GQAuthRefreshQueryVariables
    > &
        (
            | { variables: GQAuthRefreshQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<
        GQAuthRefreshQuery,
        GQAuthRefreshQueryVariables
    >(AuthRefreshDocument, options);
}
export function useAuthRefreshLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQAuthRefreshQuery,
        GQAuthRefreshQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<
        GQAuthRefreshQuery,
        GQAuthRefreshQueryVariables
    >(AuthRefreshDocument, options);
}
// @ts-ignore
export function useAuthRefreshSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQAuthRefreshQuery,
        GQAuthRefreshQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAuthRefreshQuery,
    GQAuthRefreshQueryVariables
>;
export function useAuthRefreshSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAuthRefreshQuery,
              GQAuthRefreshQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQAuthRefreshQuery | undefined,
    GQAuthRefreshQueryVariables
>;
export function useAuthRefreshSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQAuthRefreshQuery,
              GQAuthRefreshQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<
        GQAuthRefreshQuery,
        GQAuthRefreshQueryVariables
    >(AuthRefreshDocument, options);
}
export type AuthRefreshQueryHookResult = ReturnType<typeof useAuthRefreshQuery>;
export type AuthRefreshLazyQueryHookResult = ReturnType<
    typeof useAuthRefreshLazyQuery
>;
export type AuthRefreshSuspenseQueryHookResult = ReturnType<
    typeof useAuthRefreshSuspenseQuery
>;
export type AuthRefreshQueryResult = ApolloReactCommon.QueryResult<
    GQAuthRefreshQuery,
    GQAuthRefreshQueryVariables
>;
export const AuthLoginDocument = gql`
    mutation authLogin($username: String!, $password: String!) {
        authLogin(username: $username, password: $password) {
            successful
            token {
                ...allAuthTokenFields
            }
        }
    }
    ${AllAuthTokenFieldsFragmentDoc}
`;
export type GQAuthLoginMutationFn = ApolloReactCommon.MutationFunction<
    GQAuthLoginMutation,
    GQAuthLoginMutationVariables
>;

/**
 * __useAuthLoginMutation__
 *
 * To run a mutation, you first call `useAuthLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLoginMutation, { data, loading, error }] = useAuthLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthLoginMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAuthLoginMutation,
        GQAuthLoginMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAuthLoginMutation,
        GQAuthLoginMutationVariables
    >(AuthLoginDocument, options);
}
export type AuthLoginMutationHookResult = ReturnType<
    typeof useAuthLoginMutation
>;
export type AuthLoginMutationResult =
    ApolloReactCommon.MutationResult<GQAuthLoginMutation>;
export type AuthLoginMutationOptions = ApolloReactCommon.BaseMutationOptions<
    GQAuthLoginMutation,
    GQAuthLoginMutationVariables
>;
export const AuthUpdateLoginDocument = gql`
    mutation authUpdateLogin {
        authUpdateLogin {
            successful
            token {
                ...allAuthTokenFields
            }
        }
    }
    ${AllAuthTokenFieldsFragmentDoc}
`;
export type GQAuthUpdateLoginMutationFn = ApolloReactCommon.MutationFunction<
    GQAuthUpdateLoginMutation,
    GQAuthUpdateLoginMutationVariables
>;

/**
 * __useAuthUpdateLoginMutation__
 *
 * To run a mutation, you first call `useAuthUpdateLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthUpdateLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authUpdateLoginMutation, { data, loading, error }] = useAuthUpdateLoginMutation({
 *   variables: {
 *   },
 * });
 */
export function useAuthUpdateLoginMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAuthUpdateLoginMutation,
        GQAuthUpdateLoginMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAuthUpdateLoginMutation,
        GQAuthUpdateLoginMutationVariables
    >(AuthUpdateLoginDocument, options);
}
export type AuthUpdateLoginMutationHookResult = ReturnType<
    typeof useAuthUpdateLoginMutation
>;
export type AuthUpdateLoginMutationResult =
    ApolloReactCommon.MutationResult<GQAuthUpdateLoginMutation>;
export type AuthUpdateLoginMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAuthUpdateLoginMutation,
        GQAuthUpdateLoginMutationVariables
    >;
export const AuthSelectUserRoleDocument = gql`
    mutation authSelectUserRole($roleId: ID!, $merchantId: ID) {
        authSelectUserRole(roleId: $roleId, merchantId: $merchantId) {
            token {
                ...allAuthTokenFields
            }
        }
    }
    ${AllAuthTokenFieldsFragmentDoc}
`;
export type GQAuthSelectUserRoleMutationFn = ApolloReactCommon.MutationFunction<
    GQAuthSelectUserRoleMutation,
    GQAuthSelectUserRoleMutationVariables
>;

/**
 * __useAuthSelectUserRoleMutation__
 *
 * To run a mutation, you first call `useAuthSelectUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSelectUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSelectUserRoleMutation, { data, loading, error }] = useAuthSelectUserRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useAuthSelectUserRoleMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQAuthSelectUserRoleMutation,
        GQAuthSelectUserRoleMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQAuthSelectUserRoleMutation,
        GQAuthSelectUserRoleMutationVariables
    >(AuthSelectUserRoleDocument, options);
}
export type AuthSelectUserRoleMutationHookResult = ReturnType<
    typeof useAuthSelectUserRoleMutation
>;
export type AuthSelectUserRoleMutationResult =
    ApolloReactCommon.MutationResult<GQAuthSelectUserRoleMutation>;
export type AuthSelectUserRoleMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQAuthSelectUserRoleMutation,
        GQAuthSelectUserRoleMutationVariables
    >;
export const MeDocument = gql`
    query me {
        me {
            cashRegister {
                id
                serialId
                name
            }
            user {
                ...allAuthUserFields
            }
            department {
                ...allDepartmentFields
            }
            merchant {
                ...allAuthMerchantFields
            }
            role {
                ...allAuthRoleFields
            }
        }
    }
    ${AllAuthUserFieldsFragmentDoc}
    ${AllDepartmentFieldsFragmentDoc}
    ${AllAuthMerchantFieldsFragmentDoc}
    ${AllAuthRoleFieldsFragmentDoc}
`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<
        GQMeQuery,
        GQMeQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GQMeQuery, GQMeQueryVariables>(
        MeDocument,
        options
    );
}
export function useMeLazyQuery(
    baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
        GQMeQuery,
        GQMeQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GQMeQuery, GQMeQueryVariables>(
        MeDocument,
        options
    );
}
// @ts-ignore
export function useMeSuspenseQuery(
    baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
        GQMeQuery,
        GQMeQueryVariables
    >
): ApolloReactHooks.UseSuspenseQueryResult<GQMeQuery, GQMeQueryVariables>;
export function useMeSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMeQuery,
              GQMeQueryVariables
          >
): ApolloReactHooks.UseSuspenseQueryResult<
    GQMeQuery | undefined,
    GQMeQueryVariables
>;
export function useMeSuspenseQuery(
    baseOptions?:
        | ApolloReactHooks.SkipToken
        | ApolloReactHooks.SuspenseQueryHookOptions<
              GQMeQuery,
              GQMeQueryVariables
          >
) {
    const options =
        baseOptions === ApolloReactHooks.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSuspenseQuery<GQMeQuery, GQMeQueryVariables>(
        MeDocument,
        options
    );
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = ApolloReactCommon.QueryResult<
    GQMeQuery,
    GQMeQueryVariables
>;
export const RegisterDeviceDocument = gql`
    mutation registerDevice(
        $deviceInfo: DeviceInfoInput!
        $newPinCode: Boolean
    ) {
        deviceRegister(deviceInfo: $deviceInfo, newPinCode: $newPinCode) {
            id
            pinCode
        }
    }
`;
export type GQRegisterDeviceMutationFn = ApolloReactCommon.MutationFunction<
    GQRegisterDeviceMutation,
    GQRegisterDeviceMutationVariables
>;

/**
 * __useRegisterDeviceMutation__
 *
 * To run a mutation, you first call `useRegisterDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerDeviceMutation, { data, loading, error }] = useRegisterDeviceMutation({
 *   variables: {
 *      deviceInfo: // value for 'deviceInfo'
 *      newPinCode: // value for 'newPinCode'
 *   },
 * });
 */
export function useRegisterDeviceMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQRegisterDeviceMutation,
        GQRegisterDeviceMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQRegisterDeviceMutation,
        GQRegisterDeviceMutationVariables
    >(RegisterDeviceDocument, options);
}
export type RegisterDeviceMutationHookResult = ReturnType<
    typeof useRegisterDeviceMutation
>;
export type RegisterDeviceMutationResult =
    ApolloReactCommon.MutationResult<GQRegisterDeviceMutation>;
export type RegisterDeviceMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQRegisterDeviceMutation,
        GQRegisterDeviceMutationVariables
    >;
export const DeviceHeartbeatDocument = gql`
    mutation deviceHeartbeat($deviceInfo: DeviceInfoInput!) {
        deviceHeartbeat(deviceInfo: $deviceInfo)
    }
`;
export type GQDeviceHeartbeatMutationFn = ApolloReactCommon.MutationFunction<
    GQDeviceHeartbeatMutation,
    GQDeviceHeartbeatMutationVariables
>;

/**
 * __useDeviceHeartbeatMutation__
 *
 * To run a mutation, you first call `useDeviceHeartbeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeviceHeartbeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deviceHeartbeatMutation, { data, loading, error }] = useDeviceHeartbeatMutation({
 *   variables: {
 *      deviceInfo: // value for 'deviceInfo'
 *   },
 * });
 */
export function useDeviceHeartbeatMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        GQDeviceHeartbeatMutation,
        GQDeviceHeartbeatMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<
        GQDeviceHeartbeatMutation,
        GQDeviceHeartbeatMutationVariables
    >(DeviceHeartbeatDocument, options);
}
export type DeviceHeartbeatMutationHookResult = ReturnType<
    typeof useDeviceHeartbeatMutation
>;
export type DeviceHeartbeatMutationResult =
    ApolloReactCommon.MutationResult<GQDeviceHeartbeatMutation>;
export type DeviceHeartbeatMutationOptions =
    ApolloReactCommon.BaseMutationOptions<
        GQDeviceHeartbeatMutation,
        GQDeviceHeartbeatMutationVariables
    >;
